module.exports={
"label_emailtocloudcc_department":`Departamento`,
"label.wei.weiresearch":`Micro Voto`,
"message.error.appsecret.null":`La contraseña de la clave secreta no puede estar vacía`,
"label.file.orderbylastmodifydate":`Ordenado por la última fecha modificada`,
"label.minus":`#NAME?`,
"label.horizontalbar":`Líneas horizontal`,
"label.emailobject.emailsentfailed":`?Envío fallido!`,
"assignedresource.check":`Este recurso de servicio ya ha sido asignado a una cita de servicio. Por favor, no lo añada de nuevo`,
"label.finish":`Completar`,
"label.document.history":`Descargar el historial`,
"label.customfields.number.numberLengthHelpText":`1. Ingrese longitud de número y lugares decimale. Por ejemplo, un número con longtitud de 8, lugar decimal de 2, entonces el valor máximo aceptable será "12345678.90".`,
"label.standard.buttonandlink.info":`Cambiar los botones y enlaces estándar cambiará URL y definiciones de todas las llamadas de URL(Por ejemplo la página CloudCC, acceso directo del navegador o sistema externo). Puede reemplazar botón estándar o URL de CloudCC utilizando la página personalizada de CloudCC.com.`,
"front-epwechat-module-v1-contacts-desc":`Cuando se habilita, el objeto de Contactos de WeCom se añadirá en el sistema CloudCC, la información del cliente de WeCom se sincronizará con este objeto.`,
"label.mr.caption.contact.result":`Encontrar los duplicados y fusionados: Resultado de la búsqueda de los datos duplicados de contacto`,
"label.ems.selectaccount":`Seleccione cuenta`,
"label.group.no.activity":`No hay grupos de actividad para coincidir.`,
"label.call.for":`Invitado por`,
"label.newreportguide":`Crear Guía de Informe`,
"component.telerecord.label.name":`Nombre`,
"vue.add.dashboard.component":`Añadir el componente {titleName}`,
"label.chatter.sendEmailToGroupMember.check.V":`Ver votos`,
"UG.ST.002":`Confirmar`,
"label.setting.intergrationmanage":`Gestión de la integración`,
"label.field.apiname.validate":`Ingrese un número entre 0 y 6`,
"label.emailmerge.list.deletefolder":`Cancelar carpeta`,
"vue_label_pool_received":`Reclamado`,
"label_emailtocloudcc_step1_case1":`Correo al Caso`,
"message.sumlength":`La suma de la longitud y número de decimales no puede exceder 18 dígitos`,
"vue_label_approve_reassignapproval":`{name} reasignó esta aprobación a {people}`,
"label.specify.time":`Fecha: 13:00 del 21 de junio de 2016`,
"vue_label_report_sortdown":`Ordenar de forma descendente`,
"chatter.login.now":`Cargando...`,
"label.import.page2.notsuited":`Sin asignar`,
"label.please.fill.out":`Complete`,
"label.recordtype.edit.description":`Seleccione un valor de ¨Valores disponibles¨, luego agréguelo a ¨Valores seleccionados¨ y conviértalo en un valor de la lista de opciones para este tipo de registro. Atención, cancelar un valor de la lista de opciones no eliminará este valor de cualquier registro existente. Al final, seleccione valor pedeterminado de la lista de opciones para este tipo de registro.`,
"label.customer.tab.new":`Crear el menú personalizado`,
"label.sameas":`Igual que`,
"front-filter-module-v1-filter-a-week-ago":`Hace una semana`,
"label.processsetting.disable.process.failed":`No se ha podido desactivar el proceso`,
"label.summaryreport.2018.step4":`Paso 4: Seleccione los criterios de informe`,
"label.secrecyinfo":`Información confidencial-No disperse`,
"label.custom.page.component.general.settings":`Configuración general de componente`,
"label.ccpeak.folder":`Carpetas con la clasificación indefinida`,
"vue_label_homepage_select_button_operation":`Opción de operación del botón de selección`,
"message.pleaseinputrightdistance":`Ingrese los intervalo de días correcto`,
"label.mobile.phone.required.short":`Obligatorio`,
"vue_label_account_equityseructure":`Estructura del accionariado`,
"label.file.library.error1":`El fichero ya está en la base de documentos.`,
"fliter.nextmonth":`El próximo mes`,
"label.mr.descreption.oneGroupNote2":`Información del conjunto de empresas, total`,
"label.allfolderdashboard":`Carpeta de todos los paneles`,
"lable.opppdt.selPdt.bykeywords":`Por palabra clave`,
"setup_layout_label_selectedfield":`Seleccionar campos`,
"label.file.preview.convert.firstpage.failure":`Error al previsualizar, haga clic en los detalles o descargue para ver`,
"vue_label_systemSettings_companie":`Creación de la empresa`,
"label.loginhis.recently":`Historial de recién inicio de sesión`,
"label.permission.visualpagepermission.edit":`Asignación de la página personalizada`,
"label.ccservice.validate.email":`?El formato del valor correspondiente {2} del campo {1} bajo el objeto de API {0} es incorrecto. Ingrese el correo correcto!`,
"label.sms.companyname.gm":`Configuración SMS-2`,
"lable.opppdt.addpdt.table.discount":`Descuento(% de descuento)`,
"Lead.Scoring.Setting.LevelSetting":`Configuración de la popularidad del cliente potencial`,
"message.duplication.label.duplicationremark":`Es la operación de buscar datos repetidos al guardar los registros nuevos o editados`,
"label.file.preview.error":`Un error se ocurrió al previsualizar, descargue para revisar`,
"label.imgfield.type.input":`Insertar imagen`,
"label.file.share.email.content1":`Nombre de archivo: #filename`,
"vue_label_notice_batchedit_fail":`Actualización de datos con id {0} fallida debido a {1}`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.four":`Cuarta semana`,
"label.view.sortview.printview":`Imprimir`,
"label.projectManagement.Addposttask":`Añadir una tarea posterior`,
"vue_label_commonobjects_view_fail":`Fallo en la configuración de vista por defecto`,
"label.dayinweek":`De semana`,
"label.layout.notexist":`El dise?o no existe`,
"label.brief.total":`Registro {total}`,
"label.dashboardSetup.tz.bb":`Saltar a informes`,
"label_emailtocloudcc_select3":`Seleccione el propietario del registro`,
"label.input.least.string":`Ingrese al menos {0} caracteres`,
"label.app.step2":`Paso 2. Ingrese los detalles`,
"lable.account.LastWeek":`Semana pasada`,
"label.notifications":`Notificaciones`,
"label.tabpage.viewname":`Nombre de la vista`,
"label.knowledge.language.italian":`Italiano`,
"label.sendmail.step2.introduce":`Por favor seleccione una plantilla de correo`,
"label_enable_or_no":`¿Desea activar?`,
"pagecreator_button_save":`Guardar`,
"template.chart.cplb":`Categoría de productos`,
"label.knowledge.publish":`No se puede publicar por no cumplir los requisitos`,
"label.name.required":`El campo del nombre es obligatorio`,
"component.chatter.label.myfans":`Mis seguidores`,
"label.rejectoperate":`Operación de rechazo`,
"label.report.action.addtodashboard3":`Seleccione panel`,
"label.icon.101":`Libro De Texto`,
"label.data.exp.su.ok":`Exportando`,
"label.appupload.component.type.layout":`Dise?o de página`,
"template.chart.yscb":`Coste presupuestado`,
"label.tabularreport.selectorder":`Determine el orden mostrado de las columnas de los informes`,
"email.title.one":`Recuperar contrase?a`,
"label.case.copy.link":`Copiar enlace web`,
"label.mr.descreption.oneGroupReData4":`Grupo, queda`,
"label.newprocess5.error.des":`Solo se puede ingresar números`,
"label.partnerCloud.loginButton":`Botón de inicio de sesión`,
"label.interfaceconstraint.adminonly":`Solo los administradores pueden utilizar esta interfaz.`,
"label.campaign.channel.input.date":`2. Configure un período de validez para su canal de marketing:`,
"label.clientwebsiteentranceprofile":`Portal del sitio web de cliente Perfil`,
"UG.opportunity.011":`Importar transacción`,
"label.page.copy.value.paste.template":`Copie y pegue los valores del campo de combinación en su plantilla siguiente.`,
"label.notselect":`No seleccionado`,
"label.weixin.input.password":`Ingrese contrase?a`,
"label.email.select.template":`Seleccione plantilla`,
"label_chatter_ok":`Confirmar`,
"permissionService.error":`La asignación del conjunto de permisos ha fallado, por favor compruebe si la licencia de la aplicación ha caducado o la asignación ha alcanzado el máximo permitido`,
"label.webtocloudcc.sorry":`?Lo sentimos, hay error de página, intente de nuevo o contacte con el administrador!`,
"UG.opportunity.007":`Rol del contacto`,
"label.manageAll.forapproval":`?tems por aprobar`,
"label.imgfield.type.ref":`Imagen de fórmula`,
"label.profile.setcustomtab":`Configuración del menú personalizado`,
"label.tabpage.datatyoez":`Tipo de datos`,
"label.partnerCloud.basicSetting.editPersonal":`Permitir a los usuarios de la nube asociada editar la información personal`,
"label.mr.caption.account":`Encontrar duplicados y fusionarse: consultar los criterios de datos duplicados de cliente`,
"message.serviceterritoryMe.time.violation":`Violación del tiempo de envío: el período de envío no está dentro del rango de tiempo de los miembros regionales`,
"pagecreator_page_message_publish_success":`La publicación exitosa de la página`,
"label.field.formula.timezonetip":`Tenga en cuenta el soporte de múltiples zonas horarias para operar funciones de tipo fecha y hora. Al utilizar el sistema de función como SYSDATE en una fórmula para obtener la hora actual, debe reemplazar por las múltiples funciones de zonas horarias correspondientes, por ejemplo CURRENT_DATE.`,
"label.marketseamemset.specialuser":`Miembro especial`,
"label.staticresource.message":`Detalles de recursos estáticos`,
"label.workflow.rulecondition":`Regla de Criterios`,
"component_salesperformance_label_nodata":`A?adir su oportunidad y ingrese aquí para ver los gráficos de rendimiento.`,
"label.customfields.textarea.tip":`Permite a los usuarios ingresar múltiples líneas de textos, hasta 4000 caracteres.`,
"font-evaluate-module-v1-template":`Plantilla personalizada`,
"label.step3.total5":`Paso 3 de 5`,
"label.customfields.formula.percent.tip":`Calcular el porcentaje y añadir automáticamente el signo de porcentaje al núero`,
"label.sortdesc":`Descendente`,
"lable.PowerProcess.edit":`Editar el proceso de asignación de derechos`,
"label.dongshifang.description":`Configure información de Dongshifang para alcanzar los requisitos del servicio de enviar y recibir SMS en su organización.`,
"label.chatter.addressee":`Destinatario`,
"vue_label_systemSettings_obj2":`Consola de Gestión de Objetos`,
"label.selectreporttype.tip":`Seleccione el tipo de datos que quiere incluir en este informe`,
"label.version.enterprise":`Versión de Empresas`,
"label.area.add":`Añadir territorio`,
"label.h5.bookmarked":`Marcadores`,
"label.step5.total7":`Paso 5 de 7`,
"front-lightning-module-v1-title-quotation":`Cita previa`,
"label.search.onlymyrecords":`Limitar a los ítems obtenidos`,
"vue_label_commonobjects_noduplication":`Duplicado con el {字段} de {记录}`,
"label.customerpage.edit":`Editar el menú de la página personalizada`,
"message.please.choose.user":`Seleccione usuario`,
"label.approval.his.currentactor":`Aprobador actual`,
"label.field.duplicate.error.msg3":`Se puede crear hasta 3 campos de propiedad única`,
"label.page_url":`URL de la página`,
"label.permission.goback":`Regrese al Conjunto de Permisos`,
"vue_label_commonobjects_view_kanban_notice2":`Para ver todos los registros, utilice la vista de lista o la vista de pantalla dividida`,
"label.group.no.recent.searchs":`No hay coincidencia en los grupos vistos recientemente`,
"label.event.fiducial.point":`Puntual`,
"label.integrations.mailchimp.addtolist":`Añadir a los candidatos y contactos de CloudCC a su lista de Mailchimp`,
"label.workflow.configrule.introduce":`Ingrese nombre de regla, notas y criterios para activar su regla de flujo de trabajo. En el paso siguiente, asocie las operaciones del flujo de trabajo con esta regla de flujo de trabajo.`,
"label.icon.161":`Maleta`,
"label.recordtype.enable":`Activar`,
"label_mailboxes_limit":`El número de correos supera el límite permitido`,
"label.notification.time3":`Hace {0} horas`,
"label.setsharerule.step2":`Paso 2: Seleccione los criterios para compartir`,
"vue_label_homepage_somecomponents":`¡Precaución! Después de añadir el componente, la altura excede del límite por lo que causa una visualización incompleta. Por favor, elimine algunos componentes`,
"label.icon.63":`Pozo Subterráneo`,
"label.use.standard.sharerules":`Utilizar las reglas estándares de compartir`,
"label.button.step2.select.required.field":`Paso 2: Seleccione los campos obligatorios`,
"lable.Confirm.collect.potential.customers":`Confirmar la recogida del cliente {name}`,
"label.version.sum.custompage":`Página personalizada`,
"label.file.ccchat.changefile":`Modificar archivo`,
"label.mobile.phone.phone.call":`Llamar`,
"label.appupload.managed.img":`Controlado`,
"vue_label_chatter_comment":`Comentario`,
"label.central.european.time":`Hora de Europa Central`,
"label.three.quarter":`Tercer trimestre`,
"label.service.newBuildDialog.filter.editor":`Editor de filtros`,
"pagecreator_systemstyle_funcpath":`/ constructor / branded style library`,
"label_chatter_collect":`Marcadores`,
"label.custom.page.component.window.settings":`Configuración de ventana de componentes`,
"component_chatter_file_label_title":`Subir archivo`,
"label.marketsea.button.discard":`Descartar`,
"label.Batch.input":`Entrada de lotes`,
"vue_label_campaign_market_members":`Miembros actuales de la campaña`,
"label.salescloud.salesdashboard":`Panel de ventas`,
"message.summaryconditionrepeated":`?Lo sentimos, las condiciones de resumen se duplican, seleccione de nuevo!`,
"label.tianyancha.h5.companycode":`Código de empresa`,
"label.quickbooks.description":`Configure la información de cuenta QuickBooks para seguir el pago de su factura en línea`,
"label.colombia.time":`Hora de Columbia`,
"label.usermanage.unknown.license":`Con la licencia inválida no se puede crear usuario, por favor contacte con el administrador.`,
"label.operatedata.selectoperateandobject":`Seleccione operación(Importar o Exportar) y los objetos`,
"message.setup.field.picklist.valuerepeated":`La lista de valores no se puede repetir, ingrese de nuevo.`,
"label.editerror.list":`Lista de datos no editados`,
"pagecreator_page_message_save_success":`La página se ha guardado con éxito`,
"label.icon.154":`Computadora`,
"label.emailsync.setting":`Configuración del correo electrónico personal`,
"label.startuploadfile.step2":`Paso 3. Haga clic en ¨Empezar a subir¨ para subir los archivos`,
"label.dashboard.notmeet.conditions":`?No hay información que alcance los requisitos,  y el panel no se configura!`,
"label.temp.del.conf":`?Está seguro de que quiere cancelar?`,
"label.sms.authkey":`Contrase?a de autenticación`,
"lable.oppt.jieduan.choosejieduan":`Seleccione las etapas cerradas`,
"label.tabpage.viewNamez":`Introduzca el nombre de la vista`,
"label.totalQuotation":`Total de la oferta`,
"label.tabpage.hoursagoz":`horas antes`,
"label.receiveadminnews":`Recibir las noticias del administrador`,
"label.field.is.lookup":`?Si el campo está relacionado con el campo de búsqueda?`,
"label.any_changes":`Cualquier cambio realizado aquí también actualizará su pie de página en`,
"lable.products.to.assets":`¿Confirmar la transferencia del producto al activo?`,
"label.dashboard.compare":`Comparación`,
"vue_label_chatter_notice1":`Se borrará toda la información del grupo tras eliminar el grupo, pero no se eliminarán los archivos del grupo`,
"label_tabpage_exitz":`Cierre de sesión`,
"label.potentialcustomerflow":`Proceso de candidatos`,
"label.longtext":`Área de texto (Largo)`,
"october":`Octubre`,
"label.customer.email":`Correo`,
"label.partnerCloud.productSet.addChildren":`Añadir subnivel`,
"label.defaultline.cannot.greater":`El número de líneas predeterminado no se puede exceder 30`,
"front-detail-module-v1-view-report":`Ver informe`,
"label.knowledge.setting.hint.sixteen":`Guardar el conocimiento y seguir transmitiendo`,
"label.page.use.merged.field":`Utilice campo fusionado`,
"label.salescloud.salescloud.continuerecover":`Si continua, se cancelará y no se puede recuperar:`,
"front-project-module-v1-from-template-create":`Crear a partir de una plantilla`,
"label.exportall":`Exportar todos los registros`,
"label.weixin.recalculate.shared.results":`Recalcular los resultados de reglas de compartido`,
"label.components.isTemplate":`Datos de la plantilla`,
"label_emailsync_status":`Estado del correo de usuario`,
"label.file.library.delete":`?Está seguro de que desea cancelar {librayrname}?`,
"label.integrations.username":`Nombre de usuario`,
"front-lightningset-module-v1-detail-page-report-chart":`Informe de gráficos en la página de detalles`,
"label_tabular":`Lista`,
"label.approverecords":`Registro de aprobación`,
"vue_label_helpcenter_topic":`Uso y ayuda de la versión Lightning`,
"label.h5.date.none":`Nadie`,
"lable.outlook.mcto.allrecord":`Todos los registros`,
"label.readandwrite":`Leer/Escribir`,
"label.allfold":`Colapso de todo`,
"AD":`Dirección`,
"message.custom.field.donotdelete.reporttype":`El campo es referenciado por origen de datos de informe`,
"label.escalation.setup.newaction.title":`Editar operación de escalamiento`,
"label.dashboard.snapshot.settings":`Configuración de instantáneas del panel`,
"label.attendance.inner":`Trabajador de la oficina`,
"chatter.ns":`Mensaje nuevo`,
"label.validate.nowork":`Error: Campo inválido, seleccione de nuevo la posición del error`,
"label.custom.EmptyCanvas":`Lienzo claro`,
"label.service.miniProgram.fillImageOrder":`Introduzca el orden de carrusel`,
"label.icon.16":`Servicio`,
"label.selected":`Seleccionado`,
"component_chatter_link_label_name":`Nombre de enlace`,
"label.reportsSubscriptionPage.schedulereport.starttime":`Tiempo de inicio`,
"label.file.uploadNewVersion":`Subir la nueva versión`,
"chatter.group.theMembership":`Membresía`,
"label.knowledge.recommended.articles":`Artículos sugeridos`,
"label.appupload.install.parentobj":`Objeto propietario`,
"label.file.recent":`Reciente`,
"vue_label_helpcenter_quote":`La oferta representa el precio sugerido de los productos y servicios de su empresa. Puede crear ofertas a partir de las oportunidades y sus productos.<br>En la esquina superior derecha de la información detallada, puede utilizar el botón para sincronizar la oferta desde la oportunidad de negocio, o sincronizar la oferta con la oportunidad de negocio. Cuando la oferta se sincroniza con la oportunidad, cualquier cambio en la oferta se sincronizará con el producto de la oportunidad, y viceversa. Cada oportunidad de negocio puede tener varias ofertas asociadas, todas pueden ser sincronizadas con la oportunidad de negocio.<br>En la esquina superior derecha de la información detallada, puede generar el pdf y previsualizar la oferta, también puede imprimir, descargar o guardar directamente.`,
"message.error.field.default":`El valor predeterminado debe ser un número entero`,
"label.campaignmember.main.importmember.contacts.desc":`Importe los contactos de compa?a de los archivos`,
"vue_label_calendar_show_only_this_calendar":`Mostrar solo este calendario`,
"vue_label_quot_syncfrom":`Sincronizar a partir de las oportunidades de negocio`,
"label.data.expnode.e_desc2":`2. Se exporta de acuerdo con la plantilla: los usuarios pueden seleccionar plantilla para exportar los datos.`,
"label.login.verification.mfa.desc1":`Debe instalar una aplicación de MFA en su dispositivo inteligente para continuar. Las aplicaciones comunes se permiten en MFA son: Onions, Autenticador de Google.`,
"label.jiandangfenpei.desc":`Asignar el acceso de la página personalizada actual al perfil. Los administradores pueden acceder a todas las páginas personalizadas.`,
"label_tabpage_thisrecord":`Este registro`,
"lable.SalesCommitmentKanBan.totalPaymentAmount":`Monto acumulado de recibo`,
"message.error.object.notvalidcurrency":`Moneda inválida`,
"label.edit.discount":`Editar el descuento`,
"label.setup.mobile.offlinecache.setenable":`Activar función fuera de línea del dispositivo móvil`,
"UG.ST.005":`Entendido, no volver a mostrarme esta página y entrar directamente la próxima vez.`,
"label.assignedapprover":`Aprobador asignado`,
"template.chart.htlx":`Estadísticas del tipo de contrato`,
"scope":`Dentro del rango`,
"label.workmate.search":`Buscar colegas`,
"message.validation.isnotdigits":`Por favor introduzca el número correcto`,
"label.ccpeak.use.class.time.page":`Si la clasificación sea recordada por un página personalizada, necesita recordar el método de invoker() en la clasificación de PageClsInvoker`,
"setup_mainpage_label_welcome27":`La plataforma de nube CloudCC proporciona la función de la importación y exportación de datos de todos los objetos, cancelación masiva de los datos, transferencia masiva y etc.`,
"front-epwechat-module-v1-epwechat-integrate":`Integración de WeCom`,
"label.file.publiclink":`Enlace público`,
"front-epwechat-module-v1-input-name":`Por favor, introduzca el nombre de la empresa`,
"lable.Number.of.columns":`Columnas`,
"message.error.dev.service.duplicateparameter":`?Los parámetros del servidor se repiten!`,
"label.projectManagement.percent.complete":`Porcentaje de completitud`,
"label.chatter.nextSevenday":`Los próximos 7 días`,
"chatter.feed.myfollowers":`Mis seguidores`,
"label.bacchtransfer.pleaseselecttouser":`Transferir a`,
"label_partner_workspace_member_memo":`Todos los usuarios con los perfiles seleccionados y conjunto de permisos pueden acceder a la nube de socios`,
"label.marketsea.chosen.member":`Miembros seleccionados`,
"label.marketsea.assignment.setup":`Configuración de la asignación`,
"label.myaccount":`Mis clientes`,
"label.schedulejob.setup.schedule.executedate":`Tiempo de ejecución`,
"label.uploadaccessory":`Subir adjunto`,
"Homepage.News.004":`No hay noticias`,
"label.marketsea.name":`Nombre del grupo público`,
"label.pending.task":`Tareas pendientes`,
"label.report.details":`Detalles`,
"UG.homepage.008":`Comprender el estado actual del negocio (informes de ventas, tablas de clasificación, embudos de ventas, etc.), consultar las oportunidades de negocio que pueden ser problemáticas, predecir el rendimiento futuro, procesar y asignar a tiempo los asuntos importantes y tomar decisiones adecuadas.`,
"label.h5.similar.opportunity.clear.all":`Limpiar todo`,
"label.tabpage.noz":`No`,
"label.report.recent.all.reports":`Todos los informes`,
"vue_label_lead_to_score":`Haga clic en Puntuar para puntuar a los clientes potenciales de la vista actual.`,
"vue_label_normal_receivable_sf":`Plan de Cobro`,
"label.layout.edittabdistribute":`Editar el dise?o de menú`,
"label.validate.function.funcFormat.PRIORVALUE":`PRIORVALUE(campo)`,
"label.salescloud.field.editoptionlist":`Editar lista de opciones`,
"APPIntegration.Dropbox.01":`Seleccionar archivos de Dropbox`,
"label.campaign.channel.step2":`Paso 2: Configure el campo de valor de los candidatos predeterminados de la canal de marketing`,
"label_partner_new_function":`Descripción de función`,
"vue_label_chat_no_search_results":`No hay resultados de búsqueda`,
"vue_label_commonobjects_detail_visitstate":`Estado de visita`,
"label.sendemail.send.testemail":`Este es un correo de prueba, si puede recibir este correo, puede utilizar el correo normalmente.`,
"label.attendance.clear.position":`Vaciar el punto de referencia`,
"chatter.write.n":`Comentario sobre las publicaciones`,
"label_chatter_sendmail":`Enviar correo`,
"label.remindertime":`Hora de recordatorio`,
"label.app.elegantgray":`Gris elegante`,
"label.tabpage.ownedz":`En total posee`,
"label.select.approval":`Seleccione el aprobador`,
"UG.Lead.007":`Sincronizar con Google`,
"chatter.emailSetUp":`Configuración de recordatorio de mi CCChatter`,
"label.default.censor":`Examinador por defecto`,
"vue_label_notice_uploadavatar_success":`Icono cargado con éxito`,
"label.sms.title":`Información de Interfaz SMS`,
"front-console-choose-contact":`Elija el contacto`,
"label.field.edit.des":`El punto más alto controla los íconos de estrella para mostrar, el punto máximo será 100`,
"label.pw.big.letter":`Mayúsculas`,
"label.select.time.dimension":`Elija la dimensión temporal`,
"UG_Campaign_004":`Importar campa?a`,
"label.dashboard.summary":`Medida`,
"label.ems.yahoo":`Yahoo`,
"label.leadscore.rule.name":`Nombre de regla de puntuación`,
"vue_label_calendar_object_name":`Nombre del objeto`,
"label.icon.69":`Máquina`,
"label.reporttotal":`Total`,
"lable.SalesCommitmentKanBan.theActualContract":`Monto de contrato actual`,
"label.project.member.data":`Este usuario ya es miembro del proyecto actual.`,
"label.cloudccclass.list.viewremark":`Instrucciones`,
"label.deleteObject.isNotAdministrator":`No es un administrador, no puede cancelar objetos.`,
"lable.edit.queue.nameandemail":`Nombre de cola y Dirección de correo`,
"label.recordtype.tabname":`Tipo de registro`,
"label.file.is.ok":`?Está seguro?`,
"label.knowledge.language.german":`Alemán`,
"label.layout.realityapprover":`Aprobador actual`,
"label.ems.with7day":`Dentro de 7 días`,
"label.autoRegister.changepwd.setpwd.setpwd.button":`Configurar`,
"label.weixin.edit.polls":`Cambiar votación`,
"label.layout.mobile.default.tab":`Seleccione el menú predeterminado abierto en aplicación móvil`,
"vue_label_report_deletegroupcolumn":`Borrar columna de grupo`,
"label.group.archived.success":`Archivar con éxito`,
"label.customfields.formula.returntype":`Tipo de Retorno de la Fórmula`,
"label.file.followers":`Seguidores`,
"label.textmessage.new.templates.message1":`El nombre de la plantilla no puede estar vacío！`,
"label.selected.field.length":`Los campos seleccionados no puede exceder a 100`,
"ObjectDetailed_ViewKeyInformation_Layout":`Editar información clave`,
"label.paging.totalofpage":`Un total de {0} páginas`,
"label.ccchat.message.new.error41":`Para chatear con más personas, intente utilizar grupos`,
"message.recordtype.detail.noselectlist":`No hay lista de opciones para mostrar`,
"label.conditiontag.lookup.title":`Seleccione valores de la lista de opciones al siguiente para añadir`,
"label_partner_setup":`Configuración de Nube de Socios`,
"front-epwechat-module-v1-android-packname":`Nombre del paquete Android:`,
"lable.custom.Current.CY":`Año personalizado actual`,
"label.newprocess2.desc":`Si el descuento es mayor que 0.3%, se evaluará como verdadero.`,
"label.operatedata.selectobjectfields":`Seleccione los campos para exportar objetos`,
"report_reportdatasource_label":`Origen de datos del informe`,
"label.chosesubject.others":`Otros eventos`,
"label.list.desc2":`La página de web to CloudCC se divide en dos tipos: Versión PC y Versión Móvil. PC se puede acceder con la computadora y la versión móvil es accesible con el dispositivo móvil, por ejemplo Wechat.`,
"vue_group_several_groups":`{totalSize} grupos`,
"label.page.button.linkurl":`Botón o URL de enlace`,
"show.week":`Mostrar fin de semana`,
"label.gotocalendar.new":`Crear eventos en el calendario`,
"button.reset.advancedsearch":`Borrar las condiciones de búsqueda avanzada`,
"label.h5.chatter.feedandcomnum":`Publicar y Comentar`,
"lable.opppdt.addpdt.table.unitprice":`Precio de Venta`,
"label.dataimport.validate":`Seleccione verificación por ejecutar`,
"label.lead.score":`Puntaje de Candidato`,
"vue_label_help_product":`Producto y lista de precios`,
"label.role.select":`Roles seleccionados`,
"lable.opppdt.selPdt.searchproduct":`Encontrar productos`,
"component_event_label_newevent":`Nuevos eventos`,
"front-invoice-online-payment-setup-configure-button":`Configurar ahora`,
"label.stdashbord.xsld.business.img2":`Monto total de la etapa de oportunidad con probabilidad  1%-99%`,
"label.event.moveup.2week":`2 semanas con anticipación`,
"label.partnerCloud.priceOfManual.allCustomer":`Todas las cuentas`,
"lable.account.dep":`Haga clic en ¨Crear¨ para definir un a?o fiscal nuevo.`,
"label.dataimport.insertdata.error.null.update":`El valor de $schemefield_name$ en este registro está vacío y no se puede actualizar, este registro se ha ignorado.`,
"label_component_helper_businesschange_0activity":`30 días sin actividad`,
"lable.account.NextbbDays":`Próximos 60 días`,
"label_scope_length":`Rango-Longitud`,
"label.customfields.operation":`Correr la operación de exportar datos.`,
"serviceappointment.save.workorder":`Seleccione una orden de trabajo asociada a la partida de la orden de trabajo.`,
"label.field.update.hide.editor":`Ocultar el editor de fórmulas`,
"button.partner.new":`Nueva la nube de socios`,
"label.stdashbord.xsld.business.oppdetails":`Detalles de oportunidad`,
"message.pleasewaitingnextversion":`?Esta función será disponible en la próxia versión!`,
"label_tabpage_potentialcustomersz":`Candidatos`,
"label_emailtocloudcc_step2":`Paso 2`,
"label.weixin.username":`Nombre`,
"label.quickbooks.viewlist.type":`TIPO`,
"front-kefu-moudle-v1-Select-seats":`Elegir agente`,
"label.customsetting.manage":`Gestionar`,
"label.tabpage.field":`Campo`,
"label.custom.page.button.icon.URL":`URL del ícono de botón`,
"font-evaluate-module-v1-evaluation-link":`Añadir enlace de evaluación:`,
"vue_label_salesfunnel_notice3":`Número de oportunidades de negocio con una probabilidad del 1% al 99%`,
"front-email-payment-describe":`Gracias por su apoyo a nuestra empresa. Puede pagar en línea a través del siguiente enlace, y ver, imprimir y descargar las facturas en formato PDF.`,
"label.productsales.today.noevttskaddevt":`?Hoy no hay eventos abierto o tareas vencidas, puede hacer clic en  “ ” en la parte superior derecha para añadir nuevo evento!`,
"component.setup.iframe.label.memo":`Haga clic en el icono de configuración e introduzca la dirección URL incrustada.`,
"front-email-payment-select-country":`Por favor, introduzca el país`,
"label.ems.starred":`Correo estrella`,
"component_setup_label_object":`Objetos`,
"label.query.detail.viewpartneruser":`Ver socios`,
"this.year":`Esta a?o`,
"serviceresource.isactive.notactive":`Este servicio de recursos no está habilitado`,
"label.marketing.message.recipientisnull":`El destinatario no puede estar vacío`,
"label.unfold":`Expandir`,
"label.service.assetBOM.view.tip":`No tiene permiso para ver la lista de materiales de los activos. Por favor, póngase en contacto con el administrador.`,
"label.validate.function.funcExplain.ISCHANGED":`Revise si el campo de valor es diferente del valor anterior. Si no, regresará TRUE, de lo contrario regresará FALSE`,
"label.validate.function.funcExplain.NOW":`Regrese a la fecha y hora que representan el momento actual`,
"label.phoenix.islands.time":`Hora de Islas Fénix`,
"vue_label_checkduplicate_complete_filter_rules":`Por favor, complete las condiciones del filtro`,
"vue_label_report_rowcount":`Recuento de filas`,
"chatter.p":`Persona`,
"label.umeng.activity.distributetask":`Le asignaron una tarea`,
"UG_quota_05":`Sync bidireccional con oportunidades`,
"june":`junio`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.tuesday":`Martes`,
"vue_label_commonobjects_view_chart_upto5":`Muestra hasta 5 grupos`,
"vue_label_opportunity_contactrole_searchallcontacts":`Buscar en todos los contactos`,
"label.custom.field.task.notice":`Notificación de tareas`,
"label.weixin.insert.address":`Insertar localidad`,
"label.attachementNew.desc":`Archivar el adjunto al documento, y el adjunto no se puede cancelar.`,
"setup_mainpage_label_welcome18":`Configuración de permiso del nivel empresarial CloudCC le permite controlar los derechos de uso de los usuarios individuales al proceder los datos y módulos. La configuración basada en los roles también incluye posición de cliente, grupos, roles, regla de compartido de datos, control de seguridad del nivel de campo para realizar el compartido de datos entre diferentes personas y departamentos.`,
"front-kefu-instance-noarea":`No se ha creado ninguna instancia para esta zona, por favor, vuelva a seleccionarla`,
"label.please.ChooseMax":`Por favor, elija hasta {a} opciones de productos.`,
"label.businesschance":`Oportunidades`,
"label.verticalline-group":`Agrupación de columna vertical`,
"label.ordering.platform":``,
"label.product.pricebooks.ples":`Seleccione el libro de precios`,
"vue_label_norm_addcomponent":`Añadir componente`,
"label.ServiceCloud.Installation.address":`Dirección de instalación`,
"vue_label_report_groupcolumn":`Columna de grupo`,
"label.ccchat.person.invite.notallsucc":`{0} correos han sido guardados pero no han sido enviado. Para enviar una invitación, corrija el error siguiente y haga clic en enviar.`,
"label.customfields.optionlist.tip":`Permite a los usuarios seleccione un valor de la lista personalizada.`,
"UG.activity.07":`Crear una tarea`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.last":`Última semana`,
"label.permission.accessname":`Nombre de acceso`,
"lable.custom.year.stadate":`Fecha de inicio del año personalizado`,
"label.ems.inputmails":`Servidor para recibir correos(I)`,
"label.cpq.quote.transfer.order.already":`Este presupuesto se transfiere al pedido. Por favor, elimine el pedido original y vuelva a crear un pedido.`,
"label.sendletter.status":`Status de los miembros de campa?a`,
"vue_label_commonobjects_view_save_as_view":`Guardar como vista`,
"message.mobilechooseatmostfive":`Seleccione hasta 5 campos`,
"label.errormessage.batchedit.nopermission":`No hay registro de datos que tiene permiso para editar`,
"label.dataoperate.tip":`Seleccione la operación y los objetos`,
"label.enableoperate":`Operación disponible`,
"label.ems.usernamepassword.error":`Error de la dirección de correo o contrase?a.`,
"label.campaignmember.selectmember.deletemember":`Remover miembros de`,
"label.Tab":`Menú`,
"label.emailobject.template.message1":`Seleccione un campo y haga clic en "Insertar". Con el ">" significa hacer clic para ver más campos disponibles.`,
"label.approvalstep3.tip":`Especifique usuario para entrar este paso. Es opcionable que seleccione si permiten a los agentes aprobar las solicitudes`,
"label.inusing":`Activado`,
"label.edit.select.tre":`Lista de casilla de verificación`,
"label.appointmentconfirmail.wizard.title1":`Hola {0}`,
"label.partnerCloud.financeSetting.setAlipay":`Configurar Alipay`,
"lable.edit.queue.avobj":`Objetos disponibles`,
"vue_label_checkduplicate_verify_all_characters":`Verificar todos los caracteres`,
"label.huntingzone":`Rango de búsqueda`,
"label.request.approved":`La solicitud ha sido aprobada, no repita`,
"label.sharerule.msgerror":`Error del servidor interno`,
"front-epwechat-module-v1-tick-unbound":`Por favor, marque la casilla de acuerdo y acepte la información no vinculante anterior`,
"label.console.step6":`Paso 6: Seleccione cómo se muestran las listas`,
"label.multilang.micropost.vote":`{0} boleto(s)`,
"message.error.appid.null":`La clave secreta no puede estar vacía`,
"lable.product.delq":`Cancelar preguntas`,
"label.h5.approval.leixing":`Tipo de aprobación`,
"label.edit.field.select.style1":`Mostrar`,
"label.passwordPolicy.setup.alpandnum":`Debe mezclar caracteres alfabéticos y numéricos`,
"label.ems.close2":`Cerrado`,
"label.report.reporttypetitle":`Nombre de fuente de informe`,
"label.umeng.approval.approvalsuccess":`Se ha entregado la aprobación`,
"label.page.showamount":`Total de registro de cada página:`,
"label.copy.asset.successfully":`Copiar lista de materiales de activos con éxito.`,
"vue_label_homepage_bigscreen_dark":`Oscuro`,
"vue_label_email_selected_members":`Miembros seleccionados`,
"label.file.preview":`Previsualizar`,
"label.partner.new.step3.name":`Nombre`,
"label.forecast.settings.periods.ago":`Hace ciclo(s)`,
"label.evaluation.praise":`Buena`,
"label.cloudccsite.edit":`Editar sitio`,
"label.knowledgebase.advanced.filtering":`Filtro avanzado`,
"label.knowledgebase.framework":`Marco`,
"vue_label_pool_ownedpool":`Piscina principal`,
"label.exchange.sync.setting.license":`Al iniciar esta función, una parte de los datos de su organización serán guardados en el servidor de Microsoft Exchange en implementación interna o de forma de nube, y se procesan via el servidor de Microsoft Exchange. Miscrosoft está libre de las responsabilidades de la privacidad y seguridad practical de las aplicaciones de tercer parte o del sistema, tal como Exchange u Office 365.`,
"front-console-conversation-btn2":`Respuesta por correo electrónico`,
"label.projectManagement.thelastone":`Este es el último`,
"message.duplication.confirmscript.mergeoperation":`Estos registros se fusionan en un registro a través de los valores seleccionados. Atención: la acción de fusión no se puede cancelar, ?Está seguro de que quiere fusionar los registros?`,
"lable.outlook.detail.nosyn":`No sync`,
"label.iscopy":`Si permite copiar`,
"message.matrixReportSetupStage.row":`Seleccione base del subtotal de【Título de fila específica】, seleccione por lo menos un subtotal entre los dos.`,
"label.forecast.forehistory.possibility":`Posibilidad`,
"label.timetrigger.validate":`El valor ingresado debe ser un entero positivo, y el sistema ejecutará automáticamente operación del flujo de trabajo una vez alcance el tiempo activado de la dependencia del flujo de trabajo`,
"member.name.choice.field":`El nombre del miembro es un campo obligatorio`,
"label.undone_external page":`Esto es irreversible, así que por favor confirme. Este formulario no se utiliza en ninguna página de inicio de sesión, pero puede utilizarse en otros lugares. Por ejemplo, puede haber utilizado el código de incrustación para insertarlo en una página externa.`,
"UG_Lead_012":`Importar pistas`,
"component_chatter_label_fans":`Seguidores`,
"label.systeminfo":`Información de sistema`,
"label.mr.descreption.oneGroupNote1":`Seleccione por lo menos dos datos, haga clic en [Cargar Información Cargada] para entrar a la página de fusión de datos. Esta es el   `,
"label.wtd.changefields.selfields":`Seleccione los campos para incluir en su página de CloudCC`,
"message.error.fileinfoid.null":`¡fileinfoid no puede estar vacío! Id de información del archivo`,
"label_tabpage_cownerz":`Cambiar Propietario`,
"setup_layout_button_save":`Guardar`,
"Dashboard.View.Createdbyme":`Creados por mí`,
"label.escalation.setup.detail.order":`Número de orden`,
"button.partner.start":`Empezar el uso`,
"label.htyj.remark1":`La versión actual no permite el objeto de contrato`,
"component.event.label.person":`Persona asignada`,
"label.appointmentconfirmail.wizard.subtitle3":`Ubicación`,
"label.emailtocloudcc.filed.username":`Cuenta de correo electrónico`,
"label.vlidaterule.remark":`Defina la regla de verificación especificando las condiciones de un error y los mensajes de error correspondientes; los usuarios pueden corregir los errores e intentar de nuevo`,
"message.duplication.label.insertoption":`Operar al crear`,
"front-web-module-v1-detail-comment-toast":`Por favor, complete todas las evaluaciones`,
"label.import.page2.notsuitedfiledwillbenotimport":`Aviso: El sistema no importará los campos no mapeados`,
"label.h5.similar.opportunity.enable":`Activar las oportunidades similares`,
"label.allunfold":`Extender todo`,
"component_setup_iframe_label_inputurl":`Ingrese dirección de la URL`,
"label.manage.all":`Gestionar todos`,
"label.mobile.side.tab.cs":`Funciones comunes`,
"label.datamanage.contact.information":`Información de contacto`,
"lable.outlook.edit.sel":`Seleccione un valor...`,
"label.imgfield.type.url.tip2":`Por ejemplo\uff1ahttp://www.CloudCC.com/images/logo.png&cimgSize=50,50`,
"setup.layout.label.areasetup":`Configurar propiedades del área`,
"label.date":`Fecha`,
"vue_label_commonobjects_detail_openfilter":`Abrir filtro`,
"label.loginip.pagecue":`Introduzca el rango de direcciones IP válidas , con las cuales los usuarios pueden ingresar. `,
"vue_label_email_not_valid":`El correo electrónico que has introducido no es una dirección de correo electrónico válida`,
"label.page.step5.add.application":`Paso 5: Añadir a las aplicaciones personalizadas`,
"label.dashboard.donot.delete":`?No puede cancelar esta carpeta porque algunos paneles están adentro!`,
"label.visitAPPexchange":`Acceder a Appexchange(Nueva pesta?a)`,
"label.generate.location":`Generar los datos de latitud y longitud de los clientes`,
"lable.quote.syncing.syncingbutton":`Sync`,
"label.pw.error.text":`Las dos contraseñas que has escrito no coinciden.`,
"label_partner_setup_Enable":`Verificar`,
"label.file.preview.unav":`Vista previa no disponible`,
"label.sms.tip":`Del Internet`,
"setup.mainpage.label.welcome21":`La plataforma de nube CloudCC ofrece la función de personalizar plantillas de correo electrónico que facilita el uso de un formato uniforme a los usuarios y mejora la eficiencia del trabajo.`,
"label.trigger.for.example":`Por ejemplo: Actualice oportunidad en update de trigger del cliente, al actualizar el cliente en update de trigger de oportunidad, va a activar update de trigger de cliente, si no a?ade control condicional en el trigger, el sistema permite ejecutar hasta 3 ciclos de llamadas.`,
"setup.layout.button.layoutprop":`Propiedades del diseño`,
"component.chatter.label.fans":`Seguidores`,
"lable.PowerProcess.event.edit":`Editar evento clave`,
"label.detailintro":`Descripción de los detalles`,
"vue_label_report_nosearchresults":`No hay resultados de búsqueda`,
"error.name.repeat":`No se puede repetir nombre`,
"label.emailEncoding":`Código del correo`,
"label.partnerCloud.financeSetting.enableAccount":`Activar la cuenta de reembolso`,
"label_emailtocloudcc_clear":`Limpiar`,
"setup_mainpage_label_welcome12":`El usuario puede completar la definición del informe via hacer clic en el ratón sin hacer programación y siguiendo los pasos indicados por el sistema. El sistema contiene una lista de informe, un informe de resumen y un informe matricial para seleccionar. La vista de opciones para todos los campos también está disponible. Remover las informaciones no requeridas. Al  mismo tiempo, proporciona una variedad de gráfico, tales como tiras, pliegues, anillos, embudos y pasteles, que serán más claros para los usuarios.`,
"lable.SalesCommitmentKanBan.contractStartDate":`Fecha del comienzo de contrato`,
"front-starter-v1-potential-customer-tips-success":`Activar con éxito el Lead Pool`,
"UG_Forcast_02":`Previsones son estimaciones de las ventas expectadas de un período determinado, y el modo de previsiones le ayudará a determinar la demanda e ingresos de venta en un período determinado. El administrador puede utilizar previsiones para configurar objetivo y mesurar el proceso del grupo. Las previsiones generales de la organización se puede reflejar el resumen de todas ventas via los representantes de ventas (Sin considerar la etapa de finalización de ventas desde la etapa pipeline a etapa cerrada).`,
"label.escalation.setup.detail.ruleentries":`?tems de regla`,
"lable.SalesCommitmentKanBan.allComplete":`Cantidad Total de Finalización`,
"label.appupload.install.apicanuse":`El nombre de API es disponible`,
"label.organiza.field":`Campo de organización`,
"button.partner.workspace.manage":`Gestión`,
"lable.PowerProcess.setevent":`Establecer eventos clave`,
"label.emailobject.groupemail.msg2":`Falta dirección de correo, lo que causará que el correo no se puede enviar al destinatario.`,
"label.h5.orderbyname":`Ordenado por nombre`,
"vue_label_salesadvance_opportunities":`Cantidad de oportunidad`,
"label.appointment.disable.cancel":`Desactivar la cancelación`,
"label.trigger.folder.edit":`Página de Trigger: Editar carpeta`,
"label.customfields.new.step2.opration.unique.info.v2":`Tratar ¨ABC¨ y ¨abc¨ como valores diferentes (Distinguir entre Mayúsculas y Minúsculas)`,
"label.icon.40":`Posicionamiento`,
"label.eventmenuandlink":`Botón de eventos y enlaces`,
"label.service.gantt.candidate":`Candidato`,
"label.top.userphoto":`Foto del usuario`,
"label.appointmentconfirmail.wizard.btn2":`Cancelar la reunión`,
"label.print":`Imprimir`,
"saveandreturn":`Guardar y Regresar`,
"lable.account.CurrentandNextCY":`A?o calendario actual y siguiente`,
"label.group.no.recent1":`No revisa ningún grupo activado.`,
"lable.Asset.conversion":`Generar el activo según la "Transición de activos" del producto de la orden cuando se transfieren los activos.`,
"label.emailtocloudcc.button.sure":`Confirmar`,
"label.Path.List":`Lista de rutas`,
"label.please.rule.name":`Introduzca el nombre de las normas.`,
"label.knowledge.category.hint.six":`Categorías disponibles`,
"setup_mainpage_label_welcome28":`Instrucciones: Haga clic en el menú ubicado a la izquierda de la página →Configuración de gestión → Gestión de datos→ Importación y Exportación de datos, Transferencia Masiva, Cancelación Masiva.`,
"vue_label_commonobjects_view_chart_editchart":`Editar gráfico`,
"label.permission.detail.app.object":`Configuración del objeto`,
"label.multilang.totalpage":`Total`,
"label.marketsea.button.return":`Devolver`,
"Click.to.load.more":`Haga clic en cargar más`,
"label.validate.globalvariable":`Variable global`,
"label.marketsea.iseditseabymanager":`Permitir que los administradores cambiar el grupo público al que pertenecen`,
"label.price.yuan":`Precio (yuanes)`,
"label.service.resource.uesr.tip":`Seleccione el usuario para crear el recurso de servicio, el tipo de recurso no puede ser seleccionado como equipo`,
"vue_label_help_viewusageguide":`Ver la guía del usuario de la versión Lightning`,
"label.autoRegister.changepwd.setpwd.too.long":`Demasiado largo`,
"label.campagin.roi.fwsl":`Número de visitas`,
"label.campaign.mobile":`Aplicación Móvil`,
"UG.Lead.012":`Importar pistas`,
"link.recordtype.detail.backtoobject":`Regrese a los objetos personalizados`,
"front-kefu-moudle-callcentrt-hasclose":`El centro de llamadas ha cerrado`,
"label.category.5":`TI de alta tecnología`,
"label.import.page1.selectwayofdealdata":`Seleccione el modo de procesamiento de datos`,
"chatter.emailReceiveEmail":`Recibe recordatorio de CCChatter`,
"vue_label_file_manage_lib_members":`Gestionar miembros de la biblioteca de archivos`,
"label.appupload.upload.overview":`Recapitulación`,
"label.service.miniProgram.inputNumber":`Introduzca un número entre 0-999`,
"label.emailtemplate.finishdetailinfo":`Complete los detalles de la plantilla de correo`,
"label.weixin.fmu.before.day":`{0} días antes`,
"label.integrations.login":`Iniciar sesión`,
"label.dashboard.setUpHomePage":`La página oficial ha sido configurado`,
"label_partner_common_webSit":`Dominio`,
"front-epwechat-module-v1-unbound-user":`Usuarios no vinculados`,
"label.partnerCloud.basicSetting.offline":`Activar el pago sin conexión`,
"label.start.loginip":`Dirección de inicio de IP`,
"label.projectManagement.delete.subtasks":`Toda la información relacionada con esta subtarea también se borrará si eliminas esta subtarea, y los datos no se podrán recuperar. ¿Está seguro de confirmar la eliminación?`,
"label.message.batchapp":`Aprobación Masiva`,
"message.duplication.label.ruletitle":`Reglas de filtro de duplicados`,
"label.all_networks":`Toda la red`,
"label.select_columns":`Seleccione las columnas que desea ver para los envíos de formularios`,
"vue_label_notice_uploadavatar_exceed":`El tamaño de la imagen de icono cargada no puede superar los 2 MB`,
"message.error.get.failed":`No se ha podido conseguir la información`,
"label.quickbooks.viewlist.duedate":`FECHA DE VENCIMIENTO`,
"label.ccchat.topic.search":`Buscar Tema`,
"label.forecast.shre.manager":`Gerente de asignación`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.thursday":`Jueves`,
"lable.product.pricebooks.copy":`Copiar del catálogo de precios existente`,
"label.instrumentPanel.minLabelname":`Este valor debe ser positivo y menor que el valor del punto de ruptura 1`,
"front-market-form-createdsecond":`Campo de autorrellenado en la página de registro`,
"label.submission_detail":`Detalle de la presentación`,
"label.customfields.checkbox.tip":`Permite a los usuarios seleccionar un Verdadero(Seleccionado) o valor Falso(No seleccionado)`,
"label.escalation.setup.list.description":`Puede determinar automáticamente operaciones cuando los casos alcancen los criterios y no se procesan en tiempo específico. Al actualizar un caso, puede seleccionar notificación automática a los usuarios y reasignar el caso a un usuario nuevo.`,
"UG.Forcast.05":`Ajustes de previsión: paso {0}/{1}`,
"label.data.import":`Importar los datos`,
"label.upload.error.cause":`Carga fallada por`,
"label.search.change.remark":`Aplicar a configuraciones de objeto mostradas en la barra de búsqueda ubicada en la izquierda de la página oficial`,
"serviceappointment.edit.status.limitwithstatus":`No se puede cambiar el estado de la cita de servicio de {0} a {1}`,
"label.department.operation":`Operación`,
"label.textmessage.vonage.message3":`Para buscar la clave y el secreto de la API, puedes ingresar a tu cuenta de la API de Vonage e ir a "Configuración" debajo de tu nombre de cuenta. Para buscar los números de teléfono que tienes en tu cuenta de API de Vonage, puedes ir a "Números" en "Productos" y hacer clic en "Tus números" para ver todos los números de teléfono que tienes.`,
"label.privacystatement.dialog":`Declaración de Privacidad(Nueva Pesta?a)`,
"label.datamanage.import.leadfield":`En la lista siguiente, seleccione los campos del fichero de importación que deben importar a cada candidato. Haga el paso siguiente al terminar la operación:`,
"label.appupload.upload.install.failar":`Se frascasó en instalar`,
"label.viewall":`Ver todo`,
"label.sendemail.chat.addComentsfavoritesubject":`CloudCC CCChatter responde a las micro-publicaciones a favoritos`,
"lable.custom.dp":`Esta página le permite definir los años personalizados.`,
"label.mobile.more.share":`Compartir con los colegas o grupos`,
"lable.name.cannot.be.empty":`El nombre no puede estar vacío`,
"label.autoRegister.changepwd.setpwd.password":`Su contrase?a`,
"label.multipleactivity.aevents":`Evento(s)`,
"label.many.dayline.lastday":`Día anterior`,
"lable.Please.bind.the.QuickBooks.record.first":`Vincule primero los registros de quickbooks`,
"vue_no_related_dashboards":`No hay cuadros de mando relevantes.`,
"label.newdashboardpage.name":`Nombre de panel`,
"vue_label_commonobjects_detail_network":`Red de relaciones`,
"label.tianyancha.reginstitute":`Autoridad de Registro`,
"label.the.lower.bound.of.each.level.must.be.equal.to.the.upper.bound.of.the.upper.level.":`El límite inferior de cada nivel deberá ser igual al límite superior del nivel superior cuando se fije el precio por bloques.`,
"label.chat.file.upload.info":`Ficheros subidos`,
"label.appexchange.vlidaterule":`Regla de Verificación`,
"label.salescloud.salesdashboard.current.business":`Oportunidades actuales`,
"label.app.step4.homeisfrist":`?La página oficial debe ser el primer menú y no se puede remover!`,
"label.weixin.micro.research.optionname":`Nombre de opción de micro encuesta`,
"label.paging.totalofnbsp":`Un total de {0}`,
"label.opportunity.perm.title":`Acceso de solicitud`,
"front-kefu-moudle-v1-zhyzcw-reinput":`Error de verificación del arrendatario. Por favor, vuelva a introducir`,
"label.unsaved_changes":`Si continúa la operación, los cambios no guardados se perderán.`,
"label_partner_all_description":`Descripción`,
"lable.account.Next.CQ":`El trimestre siguiente`,
"chatter.feed.menutype.feed.me":`Actualización relacionada conmigo`,
"label.sourcetranstemp":`Plantilla de traducción de origen: plantilla de traducción vacía, puede crear un nuevo archivo de idioma`,
"label.apply.newuser.validate":`Registro de nuevo usuario de CloudCC, el código de verificación es:`,
"label.user.password.error":`?Error del nombre o contrase?a, o usuario inválido!`,
"label.there.is.no.quotation.line.item.in.this.quotation.line.group.at.present.":`No se encuentra ninguna línea de cotización en este grupo de líneas de cotización. Por favor, haga clic en "Añadir producto" para añadirlo.`,
"lable.PowerProcess.time.filed":`Basado en el campo de fecha y hora de {detailInterestType}`,
"label.file.default.value.is.integer":`Solo se permite introducir número entero`,
"label.processsetting.please.select.field":`Seleccione el campo`,
"label.app.step3.introduce":`El tama?o de fichero de un logo de aplicaciones personalizadas deber ser menor que 20KB, la imagen máxima será 300 píxeles de ancho y 55 píxeles de altura para los mejores resultados. Imagentes más grandes serán ajustadas por el sistema y se mostrarán deformadas. Además, al guardarse , la nueva imagen entrará en vigor.`,
"button_partner_save":`Guardar`,
"label.marketingmanagement":`Marketing`,
"label.isEnableVisualpage_new.leftlist":`Páginas Personalizadas Disponibles`,
"label.salescloud.teamrole.optionlist.choose.correct":`Los mismos ítems existen en la lista, por favor modifique`,
"System_ChangeUser_Info_001":`Cambio de propietario exitoso, no tiene permiso para ver este registro, clic para regresar a la página anterior.`,
"front-console-no-contact":`Sin contacto`,
"component.assistant.label.overduetask":`La oportunidad de negocio contiene tareas atrasadas`,
"label.roleofpartner":`Rol de socio`,
"label.appointmentconfirmpage.wizard.subtitle4-1":`Usted y {0}`,
"front-template-V1-Please-select-a-picture":`Elija una imagen`,
"lable.SalesCommitmentKanBan.allsignedCommitmentRate":`Tasa de compromiso de contrato total`,
"label.h5.similar.opportunity.step2.conment":`Seleccione campos entre 3 y 10 o listas relativas para que coincidan entre sí al encontrar las oportunidades similares`,
"label.projectManagement.alert.frequency.will.not.work":`Si selecciona "No", no se habilitará la frecuencia del recordatorio`,
"vue_label_fllscreen":`Visualización en pantalla completa`,
"label.customfields.selectcontainfieldlayout":`Seleccone el dise?o de página que debe incluirse en este campo`,
"label.appointment.wizard.subtitle1-4":`45 minutos`,
"label.tianyancha.businessverify.unagree":`Desacuerdo`,
"label.unique":`?nico`,
"setup_mainpage_label_welcome10":`Instrucciones: Haga clic en el menú a la izquierda de la página → Configuración de Aplicación → Crear → Objetos → Nombre de Objeto→ Dise?o Personalizado.`,
"vue_label_account_subsidiary":`Filial`,
"label.dataimport.format.error":`Error del formato, utilice el formato MM/DD/YYYY o YYYY-MM-DD.`,
"label.email.new":`Nuevo correo`,
"label.log.descri":`Descripción de operación`,
"vue_label_dashboard_componentname":`Introduzca el nombre del componente`,
"label.weixin.quick.reply":`Respuesta rápida`,
"label.productsales.payment.badversion":`Su versión actual no permite ver el objeto de contrato, por eso no puede ver la lista de pago`,
"label.position":`Localidad`,
"label.Annex.Conditions":`Añadir filtros lógicos para condiciones adicionales (p.ej：1 And 2 Or 3)`,
"label_tabpage_endz":`Finalizar`,
"label.setup.mobile.bottombutton.prompt":`Aviso: Guardar estos ajustes cambiará la configuración original del usuario del primer nivel de la aplicación móvil.`,
"lable.Edit.template":`Editar plantilla de informe de servicio`,
"vue_label_report_onlydisplay2000":`Mostrar solo 2000 datos`,
"label.salescloud.salesdashboard.sign.account.top5":`5 Mejores en firmar Clientes VIP`,
"label.weixin.ontime":`Puntual`,
"font-evaluate-module-v1-disappoint":`Lamento decepcionarte.`,
"chatter.sel.addre":`?Puede elegir hasta 5 destinatarios!`,
"label.mobile.phone.month.summary":`Resumen Mensual`,
"label.partnerCloud.priceOfManual.selected":`Cuenta seleccionada`,
"label.south.georgia.time":`Hora Estándar de Georgia del Sur`,
"label.create.ccdocument":`Añadir adjuntos`,
"label.chatter.to":`a`,
"label.ems.minute":`Minutos`,
"label.mobile.phone.submit.tome":`Informe enviado a mí`,
"label.approvalstep1":`Paso 1: Ingrese nombre y descripción`,
"label.h5.similar.opportunity.last.months9":`En los últimos 6-9 meses`,
"Opportunity_Detailed_Phase_Label_003":`Cambiar etapa`,
"lable.PowerProcess.time.input":`Introduzca la hora`,
"label.stdashbord.xsld.business.yqzsr":`Monto toal estimado`,
"label.icon.64":`Reflector`,
"label.data.choses.i_desc":`De acuerdo con su demanda, seleccione datos de un objeto individual.`,
"label.integrations.mainlandchinaleads":`Candidatos de China Continenal`,
"vue_label_notice_savemenu_success":`Menú guardado con éxito`,
"front-kefu-moudle-v1-xzhxzxkf-online":`Elija el servicio en línea de Easemob`,
"label_chatter_name":`Nombre`,
"label.Viewon_Linkedin":`Vista desde LinkedIn`,
"lable.PowerProcess.chioce.event":`Seleccione el evento clave`,
"component.chatter.file.label.maxsize":`El tamaño máximo del archivo es de 20 mb.`,
"label.validate.function.funcExplain.SECOND":`Devuelve el segundo del campo de fecha/tiempo`,
"label.data.downpage.i.title.num4":`4. Si tiene un campo de búsqueda o un campo principal-detalle en el objeto que desea importar, el valor de ese campo debe ser ID, de lo contrario no será válido.`,
"label.icon.139":`Moneda`,
"label.app.step4.atleastone":`?El menú de la página oficial no se puede remover!`,
"label.weixin.input.telephone":`Ingrese número de móvil`,
"label.setup.mobile.bottombutton.remark":`Una organización podría configurar los ajustes iniciales de la página de primer nivel en función del proceso empresarial.`,
"label.file.searchs":`Buscar archivo`,
"vue_label_email_there_is_no_draft_yet":`De momento no hay borrador`,
"front-kefu-moudle-v1-bind-seats":`Vincular al agente`,
"label.customfields.lookupmuti.tip":`Cree una relación que vincule este objeto con el otro. El campo de relación permite a los usuarios hacer clic en un ícono de búsqueda para seleccionar valores múltiples de la lista emergente. Otro objeto es el origen de los valores en la lista.`,
"label.integrations.password":`Contrase?a`,
"label.data.newtemplate.t_conditions":`Condiciones de plantilla`,
"message.error.repeatsubmit":`El envío es repetido o múltiples ventanas de modificación están abiertas en la misma página, si es la última, envíe en la ventana recién abierta.`,
"label.umeng.approval.approvalreassign":`Solicitud de aprobación de #obj se ha reasignado. #objname`,
"lable.edit.queue.selobj":`Error: En la cola debe tener por lo menos un objeto seleccionado`,
"label.compact.layout.frame":`Marco de dise?o de página`,
"label.sms.companyname.dsf.infor":`Este servicio solo está disponible en China continental`,
"template.report.individual.case.source":`Fuente del caso`,
"pagecreator.button.pcpage":`PC`,
"vue_label_commonobject_selectdatatime":`Seleccionar fecha y hora`,
"label.icon.181":`Archivo`,
"label.loginip.setup.please":`Especifique el rango de IP`,
"vue_label_dashboard_?secondarygroup":`Seleccione un grupo secundario`,
"lable.outlook.mcto.pleasedes":`Ingrese los dominios de correo que no quiere asociar con una coma.`,
"DetailedInfo_Activity_EmailMessage_01":`{0} ha enviado un correo a {1}`,
"label.sendmail.step4":`Paso 4: Los correos enviados han sido procesados`,
"label.monitorsys.delete.source":`Descripción`,
"label.monitorsys.log.datetime":`Descargar el log de auditoría de operación clave en el rango de búqueda(Excel.xls)`,
"component_chatter_label_myfans":`Mis seguidores`,
"label.tianyancha.h5.registereddate":`Fecha de registro`,
"label.multilang.feedtrack.operatecreate":`Se ha creado {0} registros`,
"label.console.step6.no":`Seleccione como se muestran las listas`,
"four":`Cuatro`,
"message.confirmsetpwdforuser":`?Si resetea contrase?a para usuarios nuevos?`,
"label.cape.verde.time":`Hora de Cabo Verde`,
"label.queue.new":`Nueva cola`,
"label.cloudccsite.start":`Activar la página oficial`,
"label.data.exp.way":`Método de exportación`,
"label.lock.record.donot.delete":`No se puede cancelar los registros cerrados`,
"label_emailtocloudcc_filed_type":`Tipo`,
"frame_personinfo_label_minipic":`Imagen de Miniatura`,
"label.checkfield.choosetab":`Seleccione los campos para encontrar los duplicados`,
"component.setup.tabs.label.default":`Página predeterminada`,
"page.404.button.toknowmore":`Más información`,
"vue_label_SMS_message_sent_cannot_be_empty":`El contenido del mensaje a enviar no puede estar vacío`,
"label.lookupreplaceselectvalue":`Encontrar y reemplazar lista de opciones`,
"pagecreator_layout_button_new":`Nuevo dise?o`,
"label.mobile.more.upload":`Subir Versión Nueva`,
"front-kefu-moudle-v1-Connection-failure":`Fallo de conexión`,
"label.version.support.unlimited":`Soporte ilimitado`,
"message.error.notmarketseamember":`No es miembro de este grupo público`,
"label.taskandincident":`Tareas y eventos`,
"label.report.export.print.title":`Imprimir vistas de informes`,
"label.file.publicview.error2":`El enlace público es incorrecto, utilice un nuevo`,
"label_chatter_cancel":`Cancelar`,
"front-web-module-v1-detail-comment-satisfied":`Nivel de satisfacción`,
"label.knowledge.delete.topic":`Error al borrar el tema utilizado en este artículo de conocimiento`,
"label.forecast.forehistory.all":`Todo`,
"label.displaybutton":`Botones mostrados`,
"label.icon.148":`Robot`,
"label_tabpage_ok":`Confirmar`,
"label.checkfield.merge.mainrecord":`Registro maestro`,
"label.notification.arketsea.restored":`{5} ha restaurado {2}{0}: {1}`,
"setup.mainpage.label.welcome31":`Instrucciones: Haga clic en el menú de la izquierda de esta página → Gestionar configuración → Crear → Aplicación`,
"front-kefu-moudle-v1-jtrrt-connect":`Asociar los usuarios de CloudCC con las extensiones de TRRT`,
"vue_label_calendar_please_select":`Seleccione los campos a mostrar`,
"setup.layout.label.pagename":`Nombre del diseño de la página`,
"template.chart.schdywjhz":`Valor de la oportunidad de la campaña`,
"label.access_report":`¿Quién puede acceder a este informe?`,
"label.assignment.layout.section.optional":`Disponible`,
"label_chatter_recently":`Recientemente`,
"lable.chat.advanced.setting":`Configuración avanzada`,
"label.knowledge.category.hint.eight":`Grupo de categorías`,
"message.error.facebookuid.null":`El ID de usuario de Facebook no puede estar vacío.`,
"label.step5.total6":`Paso 5 de 6`,
"label.is.cancel.delete":`?Está seguro de cancelar?`,
"setup_mainpage_label_welcome11":`Informe personalizado`,
"label.answers":`Respuestas`,
"label.approvalstep1.tip":`Ingrese nombre, instrucciones y número de paso para el nuevo proceso de aprobación.`,
"template.chart.htjeph":`Importe del contrato Clasificación`,
"label.campaigns.onsiteregistration":`Registro escenario`,
"front-epwechat-module-v1-input-agentid":`Por favor, introduzca el ID del agente`,
"label.emailobject.wizard.desc2":`Seguir si los correos han sido abiertos y las veces de abierto`,
"label.multilang.chatterdetial.vote":`{0} voto(s)`,
"label.customsetting.manage.value":`Datos personalizados`,
"front-electronic-export-listCount":`{totalView} datos en total en la vista actual, seleccione los datos importados`,
"label.dashboard.create.prompt":`No se puede crear cuadros de mando con informes de listas`,
"label_tabpage_askz":`Qué quiere preguntar`,
"label.ems.sentmail":`Bandeja de salida`,
"label.reportlist.untop":`No fijado`,
"label.owner.h5.plzchose":`Al seleccionar el propietario, haga clic en guardar`,
"label.callcenter.addup.10.pieces":`Añadir 10 datos una vez como máximo`,
"label.ccdocument.save":`Guardar documento`,
"label.productcannotnull":`El producto no se puede estar vacío`,
"label_tabpage_enabletomobile":`Si activa la aplicación móvil`,
"lable.account.CYAgo":`Hace dos a?o calendario`,
"lable.Select.the.returned.high.seas.pool":`Seleccione el grupo a devolver`,
"tuesday":`martes`,
"label.partnerCloud.basicSetting.partnerPayment":`Activar el Fondo de Socios`,
"label.validate.function.funcExplain.WEEKDAY":`Devuelve un día específico de la semana. El 1 representa el domingo y 7 el sábado`,
"label.query.detail.manageexuser":`Gestionar las cuentas externas`,
"vue_label_systemSettings_environment":`Medio ambiente`,
"component_setup_tabs_label_delete":`Eliminar`,
"label.weixin.delete.ccchat":`?Está seguro de que quiere cancelar esta publicación?`,
"label.lanxin.title":`Lanxin-H5Micro App`,
"label.layout.editcondition.morethanten":`Puede seleccionar hasta 10 campos como sus criterios de búsqueda`,
"label.project.hit.fourteen":`Aviso de actualización de hitos`,
"label.createby":`Creado por`,
"label.moreoperation":`Más operación`,
"label.lock.tip":`Bloquear los registros para evitar ser editado`,
"label.check.input.condition.three":`El tipo de campo de la fórmula y el resumen desplegable no son compatibles con la inserción`,
"label.quote.dingjia":`Fijar el precio`,
"label.currentuseremail":`Correo del usuario actual`,
"UG_homepage_004":`Automatización`,
"chatter.link":`Enlace`,
"label.new.zealand.standard.time":`Hora de Verano de Nueva Zelanda`,
"APPIntegration.Dropbox.setting.02":`Deshabilitar`,
"label.version.searchandmerge":`Comprobar la duplicación y la fusión`,
"label.allmenus.showmsg.nomenu":`?No han encontrado el menú que está buscando!`,
"front-template-V1-Enable-disable":`Activar | Desactivar`,
"label.marketing.setting4":`Registro exitoso regresará a la URL predeterminada`,
"UG.Forcast.07":`Permitir la previsión`,
"vue_label_systemSettings_correlation":`Modo de visualización de la lista relacionada`,
"label.cloudccsite.remark.length":`Permite a los usuarios ingresar hasta 255 caracteres`,
"label.favorite":`Marcar esta página`,
"template.report.converted.leads":`Clientes potenciales convertidos`,
"label.campaignmember.main.description":`Utilizar esta página para gestionar los miembros de la campa?a. Puede añadir nuevos miembros o actualizar el status de los miembros actuales de campa?a.`,
"label.salescloud.teamrole.account.organization":`Los miembros del equipo pueden tener un nivel de acceso a este cliente superior al establecido por su organización`,
"label.permission.modifyAppPermission.canselectapp":`Aplicaciones disponibles`,
"front-epwechat-module-v1-self":`Configuración de la aplicación de creación propia`,
"message.duplication.label.matchexactletters":`Combinación precisa`,
"label.appointmentdetail.wizard.title18":`Plan de viernes`,
"label.area":`Regiones`,
"label.sso.saml.sp.username":`Nombre de usuario`,
"lable.outlook.new":`Nueva configuración del Exchange Sync`,
"label.custom.field.close.conversion":`Cerrado-Convertido`,
"lable.outlook.detail.tmaping":`Mapear el campo de tareas`,
"label.emailobject.emaildetail.nextactivity.event":`Agregar un evento`,
"vue_label_commonobjects_detail_date":`La fecha de finalización no puede ser inferior a la fecha de inicio`,
"vue_label_email_mark?as":`Marcar como`,
"label.guestgroup":`Grupos de clientes`,
"label_emailtocloudcc_filed_server":`Servidor`,
"label.icon.186":`Consultivo`,
"label.department.user.edit":`Editar`,
"label.custom.page.component.button.settings":`Configuración del botón de componentes`,
"label.partnerCloud.orderingPlatform.nextProduct":`¿Desea guardar la configuración actual del producto y configurar el siguiente?`,
"vue_label_appstore_cloud_platform":`Plataforma oficial de cloud`,
"label.page.previous":`Página anterior`,
"label.direct.dashboard.week.report":`Crear reporte semanal`,
"label.ServiceCloud.prompt.warning":`No hay estadísticas de distribución de recursos por dirección.`,
"label.emailtocloudcc.position":`Cargo`,
"vue_label_email_please_enter_the_message_content":`Introduzca el contenido del correo`,
"labal_About_to_jump":`Pronto se redirigirá`,
"label_profile_mobile_setup_stand":`Página oficial estándar`,
"label.visualpage.component.n3":`3. Parámetros. El parámetro se escribe en las propiedades args, args="name:'zhang', age:26" Presta atención a las comillas simples y dobles.`,
"vue_label_report_operationmode":`Modo de funcionamiento del informe`,
"label.reportsSubscription.select.attached.file":`Seleccione el tipo de archivo adjunto.`,
"label.afghanistan.time":`Hora de Afganistán`,
"label.vlidaterule.formulatrue":`Si el resultado de la fórmula es verdad, muestre los textos definidos en el área de ¨Información de error¨`,
"label.ccchat.person.invite.erroremail":`El formato del correo is incorrecto`,
"label.viewDashboard":`Ir a la lista de paneles`,
"label.at":`en`,
"label.notification.arketsea.beforeretrieve":`Su {0}：{1}  va a ser reciclado a {2}， tiempo restante: {6} días`,
"label.field.update.show.editor":`Mostrar el editor de fórmulas`,
"label.weixin.polls.time":`Fecha de votación`,
"vue_label_commonobjects_detail_activity_nostarttime":`No hay tiempo de inicio`,
"label.direct.dashboard.me.not.approval70":`?tems de aprobación pendiente enviado por mí`,
"label.data.setok.t_desc3":`, Operación.`,
"label.view.edit.search.describe":`Buscar después de ingresar las palabras clave`,
"label.importsourcefiletip":`Antes de importar, asegúrese de que satisface las condiciones siguientes: <span><ul><li>1. Cree documento que contiene nombre y traducción para idioma por importar. </li><li>2. En la parte superior de cada archivo debe incluir propiedades de idioma(No se permite la importación de chino). Las propiedades de idioma como: Language=en_US。</li><li>3.Asegúrese de que el documento importado sea formato correcto de código,  si no define, el sistema utilizará el código de UTF-8. </li><li>4. Asegúrese de que tener tecla enter para saltar de línea al final del archivo.</li></ul></span>`,
"UG.Case.01":`Caso`,
"label.weixin.report.filters":`Filtros`,
"vue_label_homepage_profilehomepageassignment":`Asignación de la página de inicio del perfil`,
"label_tabpage_editview":`Editar vista`,
"label.tabpage.allpotentialcustomers":`Todos los clientes potenciales`,
"label.sendemail.send.standbyemail":`(Bandeja de salida de reserva)`,
"errormessage.email.atleastonereceiver.z":`Debe al menos seleccionar o introducir una dirección de recepción.`,
"workflow.action.tasks.assignortype.ownertype":`Tipo de propietario`,
"label.list.userinterface.new.page.setup":`Nueva página`,
"chatter.seladress":`Por favor introduzca al menos un destinario`,
"Pagelayout_Setup_004":`Puede configurar hasta 4 campos`,
"label.mobile.home.page.tenbig.opp":`Los 10 mejores oportunidades en los próximos 30 días`,
"label.wtd.changefields.newpc":`Generar Página PC`,
"label.opportunity.perm.remark":`Esta es oportunidad exclusiva, contacte con el propietario de "owneridccname" <br>  para obtener el acceso.`,
"label.data.exp.tempdes":`Descripción de plantilla`,
"label.appointment.wizard.subtitle2-1":`De`,
"lable.currencyManage.button.manageexchangeRate":`Gestionar la tasa de cambio caducada`,
"label.file.viewinfo":`Ver detalles de fichero`,
"label.integrations.mailchimp.export.failed":`La exportación de datos se frascasó, revise la conexión de red y intente de nuevo`,
"pagecreator_page_button_edit":`Editar`,
"label.icon.86":`Maletín`,
"label.exchange.sync.reset":`Restablecer Sync`,
"label.customfields.lookupfilter":`Puede crear un filtro para limitar los registros que están disponibles en el campo de búsqueda`,
"label.component.hotdeal.nopermission":`Para ver los datos relacionados con sus oportunidades de negocio, póngase en contacto con su administrador de CloudCC.`,
"label.address.province":`Provincia/Distrito`,
"lable.PowerProcess.3digit.input":`No puede haber más de 3 dígitos`,
"label.asset":`Activos`,
"label.passwordPolicy.setup.nopwdremember":`No recordado`,
"front-electronic-signature-setting-intro2":`Antes de iniciar un contrato, predefina la plantilla en la plataforma DocuSign. Al iniciar la firma, puede seleccionar la plantilla de contrato preestablecida.`,
"pagecreator.page.button.new":`Nueva página`,
"label.tabpage.step2":`Paso 2: Especificar las condiciones del filtro`,
"label_switch_two_column_or_responsive_layout":`Cambiar a dos columnas o a un diseño adaptable`,
"label.batchDelete":`Cancelación Masiva`,
"chatter.edit.ct":`Editar su información de contacto`,
"UG_ST_003":`No tiene permiso para crear {0}, contacte con el administrador, haga clic en confirmar para ir directamente a la interfaz {0}.`,
"label.timzone.tip.info2":`Al utilizar simpledateformat para formatear una fecha, debe establecer la zona horaria para la instancia de clase simpledateformat, tal como SimpleDateFormat myDateFormat=new SimpleDateFormat("yyyy-MM-dd");myDateFormat.setTimeZone(TimeUtil.getUserTimeZone(userInfo));o utilice el método de herramienta proporcionado por TimeUtil para obtener la instancia, SimpleDateFormat myDateFormat=TimeUtil.getSimpleDateFormat("yyyy-MM-dd",userInfo);`,
"label.ems.firstsynchistory":`La primera vez sincroniza los correos desde hace cuánto tiempo`,
"label.currency.invalid":`Monedas inválidas`,
"label.mask.custom":`Personalizar`,
"lable.opppdt.addpdt.title":`Seleccionar Producto`,
"label.appointment.wizard.subtitle3-3":`Miércoles`,
"label.weixin.report.criteria":`Criterios de agrupación`,
"label.appupload.upload.install.uninstall":`No se puede instalar`,
"label.compact.layout.frame.split":`Mostrar en plantalla separada`,
"label.email.attach.complete.info":`Una vez completada la carga, el archivo se mostraráen la lista de los adjuntos siguientes`,
"label.Receivables":`Plan de Cobro`,
"label.linkedin.title.setting":`Información integrada de LinkedIn`,
"label.companynotice":`Anuncio de empresa`,
"label.emailobject.discard":`Cancelar`,
"label.selected.searchfield":`Campo de búsqueda de resultado seleccionado`,
"front-electronic-signature-explainDocusign":`Descripción de la firma electrónica de DocuSign:`,
"chatter.link.name":`Nombre del enlace`,
"label.low":`Bajo`,
"label.verticalline":`Columnas Verticales`,
"label.approval.isallowed.reject.label":`¿Permitir rechazar al aprobar datos individuales?`,
"label.emailtocloudcc.button.enable":`Activado`,
"label.dashboardSetup.showdw.d5":`Unidad de número entero`,
"label.usermanage.not.authority":`No tiene permiso suficiente para hacer la operación`,
"label.customobjects.track.introduce0":`Esta página le permite seleccionar los campos para seguir en la lista relacionada con {0} "Seguimiento del campo". Cada vez que un usuario modifique cualquier de los campos seleccionados siguientes, el valor del campo viejo y del nuevo, así como la fecha, hora, características cambiadas y los usuarios que hacen cambios se agregarán a la lista relacionada con  "Seguimiento del campo".`,
"canlendarmonth":`Mes de calendario`,
"vue_label_dashboard_minimum":`Introduzca el valor mínimo`,
"label.salescloud.optionlist.inputname.linealone":`Ingrese uno o más valores de la lista de opción al siguiente, cada valor deber estar en una línea separada.`,
"message.error.organuzation.information.null":`La información de la organización no existe`,
"label.tabpage.maxfilez":`El tamaño máximo del archivo es`,
"message.validation.apiname":`Debe comenzar por letra, solo puede contener letras mayúsculas y minúsculas, números, guiones bajos, la longitud máxima es 50 caracteres, mínimo 20.`,
"report.type.label.contractPayment":`Contratos y cobros`,
"label.limiting.choose.three.files":`Puede seleccionar hasta 3 archivos, ha seleccionado`,
"label.reportTypeFocus":`El foco del origen de datos de informe`,
"Report_Delete_Confirm_Title":`Por favor confirme`,
"front-gantt-module-reorder-milestones":`Reordenar los hitos`,
"front-starter-v1-customer-tips-success":`Activar el Pool de Cuentas con éxito`,
"label.tabpage.isdeleteview":`¿Está seguro de que quiere eliminar esta vista?`,
"label.favorite.title":`Plataforma de CloudCC`,
"page.layout.sysinfo":`Información de sistema`,
"label.tabpage.pleaseSelectz":`Por favor, seleccione`,
"label.smsnotice":`Notificación por SMS`,
"label.forecast.customforecast.foretype.Pipeline":`Pipeline`,
"label.rejectbehaviour":`Rechazar el comportamiento`,
"label.searchlayout.view.example.new":`Ver ejemplo (Nueva ventana)`,
"vue_label_homepage_notice2":`Puede distribuir manualmente el diseño de la página de inicio, facilitando a los empleados la realización de sus tareas diarias de forma eficaz`,
"label.import.index.chooseidorother":`3. Puede elegir entre utilizar el ID o el nombre para hacer coincidir el registro y rellenar el campo de búsqueda. Si necesita adquirir el ID del registro correspondiente u otra información, puede crear un informe y establecer el nombre del registro y el ID del registro como columnas de grupo y luego exportar el informe.`,
"label.westem.european.summer.time":`Hora de Europa del Oeste`,
"label.brackets":`Paréntesis`,
"asset.serialnumber.unique":`El número de serie del activo ya existe, no lo añada de nuevo`,
"label.callcenter.access.keyID":`Clave secreta de acceso ID`,
"label.calendar.month.view":`Vista mensual`,
"label.realdelete":`Cancelar completamente`,
"label.partnerCloud.orderingPlatform.amountPaid:":`A pagar:`,
"label.reportTypName":`Nombre del origen de los datos en el informe`,
"lable.newtabpage.opensearchresult":`Extender los resultado de búsqueda`,
"front-kefu-moudle-v1-Session-duration":`Duración de la sesión:`,
"label.import.index.ignore":`Ignorar`,
"label.customfields.url.tip":`Permite a los usuarios ingresar cualquier sitio web válido. Si los usuarios hacen clic en este campo, la URL se abrirá en una pesta?a nueva o la pesta?a actual de acuerdo con los modos seleccionados por los usuarios. Y por defecto se abrirá la URL en una pesta?a nueva.`,
"label.projectManagement.editMilestone":`Editar hito`,
"front-gantt-module-v1-project-gantt-list":`Lista de proyectos`,
"label.validate.remark":`Las reglas de validación ayudará en mejorar la calidad de los datos por prevenir a los usuarios guardar datos erróneos. Puede definir una o más reglas de validación que incluyen condiciones de error y los menasajes de error correspondientes. Las reglas se ejecutarán al guardar registro. Si satisface las condiciones de error, dejará de guardar y mostrará los mensajes de error.`,
"front-kefu-moudle-v1-sjgsbzq-reinput":`El formato del número de teléfono es incorrecto. Por favor, vuelva a introducirlo`,
"label.channel.name":`Nombre del canal`,
"label.weixin.cloudcc.user.message":`Información de Usuarios de CloudCC`,
"label.icon.59":`Taller`,
"label.ccpeak.function":`Método`,
"lable.opppdt.selPdt.leastten.fields":`Seleccione hasta 5 campos`,
"label.deadline":`Fecha de vencimiento`,
"label.product.sel":`Selección del catálogo de precios`,
"vue_label_helpcenter_detail2":`Todos las actividades: Muestra todas las actividades a las que tienes acceso, aunque no esté participando <br>    También puede filtrar los registros de actividad que quiere ver en función del rango de fechas y el tipo de actividad.<br>   4. Novedades<br>    Todas las personas que pueden ver este registro pueden dejar un mensaje y publicar en la columna "Novedades" del registro, y también puede ver todos los cambios de información, las últimas actividades y los comentarios y publicaciones de otras personas sobre este registro. Esta columna facilita la comunicación laboral en línea y la colaboración entre usted y sus colegas, lo que ayuda a mejorar el trabajo en equipo y la eficiencia.<br> Publicar post<br>   Paso 1: Haga clic en la barra de publicación e introduzca el contenido de la publicación<br>   Paso 2: Haga clic en el botón Archivo/Enlace para añadir un archivo/enlace según sea necesario<br>  Paso 3: Haga clic en Compartir para completar la publicación. <br> Ver post<br>    Puede ver el micropost que acaba de publicar en la zona de abajo. El micro-post consta de las siguientes partes: icono, nombre del usuario, contenido del micro-post y métodos de interacción (Me gusta/Comentar/Editar/Borrar post). <br> Ordenar y buscar posts<br>    Haga clic en la lista desplegable a la derecha de "Ordenar" para cambiar la ordenación de los posts. <br>     Ordenar por la “actividad más reciente”: ordenar por la hora de la última interacción de los microposts;<br>     Ordenar por la “última publicación”: ordenar por la hora de publicación de los micro-posts;<br>    Ver diferentes tipos de micro-posts<br>    Micro-posts de texto: Se puede ver todo el contenido directamente en el área de publicación de microposts;<br>    Microposts que contienen archivos: haga clic en el botón de descarga del archivo para descargarlo localmente y verlo;<br>   Microposts que contienen enlaces: haga clic en el enlace del microposts para abrirlo;<br>  Comentar y dar “Me gusta” a los micro-posts<br>   Comentar<br>  Paso 1: Haga clic en Comentar debajo de cada micro-post<br>   Paso 2: Introduzca el comentario en el cuadro de texto que se abre<br>  Paso 3: Añada el archivo/enlace al comentario según sea necesario Paso 4: Haga clic en Comentario debajo del cuadro de texto para completar la operación<br>    Borrar comentario<br>   El editor del comentario puede eliminar el contenido del mismo. Haga clic en el botón situado a la derecha del comentario y seleccione "Borrar" en el cuadro desplegable.`,
"pagecreator_layout_button_mergecell":`Combinar casillas`,
"Lead_Scoring_Setting_Rule_Setup_Active":`Si activa`,
"label.query.detail.loginbypartneruser":`Ingrese a la red de nube de socios como usuario`,
"label.view.selectrenderfields":`Seleccione campos para demostrar`,
"label.code.add":`Añadir información del enlace del código QR`,
"label.appointmentconfirmpage.wizard.title1":`LA REUNI?N RESERVADA`,
"label.timzone.tip.title":`Apoyo de múltiples zonas horarias para el tipo de datos Fecha/horas. Al manejar las fechas utilizando new date() o calendar, se debe tratar los problemas de zona horaria múltiple correspondientes. Además, la clase de herramienta TimeUtil proporciona muchos métodos de herramienta que soportan múltiples zonas horarias.`,
"label.tag.addtags.visibility":`Visibilidad`,
"label.appointmentconfirmpage.wizard.title3":`?Está seguro de que desea cancelar la reserva existente y hacer una reserva nuevo?`,
"lable.outlook.detail.oldest":`Más antiguo`,
"label.account.custom.quarter.timeerror":`La fecha de inicio y la fecha de finalización del trimestre personalizado se encuentran entre el período de tiempo de los trimestres personalizados históricos, por favor, compruébelas y reconfigúrelas.`,
"label.sendsms.idea":`Estimado`,
"label.manageAll.pagenum2":`Esta es la última página`,
"serviceterritory.isactive.notactive":`Este territorio de servicio no está habilitado`,
"label.userinfo.newpwd.notnull":`?La contrase?a nueva no puede estar vacía!`,
"vue_label_dashboard_nolinkagedashboard":`No hay cuadro de mandos de enlace de momento`,
"message.cannotdeleteapproval":`No puede cancelar el proceso de aprobación`,
"label.wtd.detail.m":`Móvil`,
"label.app.step4.introduce":`Seleccione el menú para incluir las aplicaciones personalizadas`,
"label.ccchat.error.permission":`No tiene acceso`,
"UG_opportunity_009":`O`,
"label.Receivables.TheActualAmountOfMoney":`Cobro real`,
"label.callcenter.no.search":`No hay consulta relevante a la información`,
"label.user.introduce":`Usuarios`,
"message.datalocked.addpdt":`Este registro de oportunidad está cerrada, no puede a?adir producto.`,
"label.sendsms.step1":`Paso 1: Especifique los destinatarios`,
"label.brief.contracts":`Contratos`,
"label.setup.mini.swap":`Ajuste del carrusel`,
"label.emailobject.wizard.desc1":`Vincule con su correo personal, envíe correo aquí y sincronice automáticamente con el registro`,
"label.login.verification.mfa.desc2":`Si no puede verificar por algún motivo (Pérdida de móvil o eliminación errónea de MFA), contacte con el administrador para que desbloquee MFA`,
"label.notification.receiveSms.message":`Ha recibido un SMS de {!fromaddress}, haga clic para verlo`,
"label.emailmerge.mergeFolder.publicfolder":`Plantilla fusionada de correo público no archivado`,
"label.password.update.false":`No se ha podido cambiar la contraseña, póngase en contacto con el administrador.`,
"label_tabpage_systemz":`Sistema(s)`,
"label.dataimport.objectid.null":`El objeto ID está vacío y no se puede importar`,
"label.currency.type":`Tipo de moneda`,
"component_setup_button_appurl":`URL del sistema`,
"label.appointmentconfirmail.wizard.title2":`Ha reservado con éxito {0}`,
"lable.product.please.enter":`Ingrese`,
"label.escalation.setup.title":`Regla de Escalamiento de Casos`,
"label.create_failure":`Fallo al crear el formulario`,
"label.weixin.brand.model":`Modelo de Marca`,
"label.layout.nameoftestobj2":`Probar objeto dos Nombre`,
"vue_label_filters_number":`Máximo 10 filtros por cada informe`,
"label.file.following":`Siguiente`,
"vue_label_account_all_contracts":`Transferir todos los contratos del propietario del cliente`,
"label.service.please.select.cycle.type":`Seleccione el tipo de ciclo`,
"label.weixin.weipoll.optionname":`Nombre de opción de Micro Voto`,
"label.data.newtemplate.null":`No`,
"message.passwordPolicy.validate.complexReq1":`Error: La contrase?a debe ser alfanumérica`,
"label.forecast.shre.editmanager":`Gerente de Redacción`,
"label.emailtemplate.tip":`Al siguiente es una lista de todas las plantillas de correo en la carpeta seleccionada. Haga clic en el botón ¨Nuevo¨ para crear los textos nuevos o plantilla de correo HTML. Puede utilizar las plantillas de correo al enviar correo. Haga clic en el enlace de rol por más información detallada.`,
"label.tag.manage.button":`Gestionar etiqueta`,
"label.changepw":`Cambiar contrase?a`,
"label.sso.saml.sp.idsource.nameid":`Identidad está en el elemento de NameIdentifier de la declaración de Sujeto`,
"label.salescloud.teamrole.addmember":`Añadir miembros del grupo de oportunidades CloudCC`,
"label.h5.similar.opportunity.last.months6":`Últimos 3 a 6 meses`,
"message.save.opportunity.role.save.failed":`Se frascasó en guardar rol de contactos`,
"vue_label_report_formulainformation":`Información sobre la fórmula`,
"label.area.assignuser.remark":`Asignar los usuarios a la área`,
"label.multilang.viewlist.total":`{0}  Seleccionado`,
"label.newprocessstep4":`Paso 4 Seleccione plantilla para la notificación de correo`,
"label.permission.objectpermission.open":`Abierto`,
"label.service.gantt.close.list":`Cerrar Lista`,
"label.standarduserfield":`Campos estándar de usuario`,
"vue_label_commonobjects_detail_the_administrator":`El registro ha sido bloqueado, por favor, póngase en contacto con el administrador.`,
"label.exchange.sync.account":`Credenciales de cuenta de servicio Exchange`,
"label.mr.title.button.back":`Regrese, y resetee los criterios de búsqueda`,
"label.notsetup.operation":`?Error de condición de línea, el operador no se ha configurado!`,
"label.notifications_center":`Centro de notificaciones`,
"label.event.moveup.5hour":`5 horas con antelación`,
"report_label_pleaseinput":`Ingrese los contenidos de búsqueda`,
"label.batchadd.newbatchpage.errorlist":`Agregación de datos fallada`,
"label.quickbooks.invoices":`Factura`,
"chatter.feed.usingchatter":`Al iniciar el CCChatter, puede seguir a los miembros o registros y hacer las publicaciones.`,
"label.all.marketing.activities":`Propietario de la campaña`,
"label.lookup.finish":`Terminar automáticamente la búsqueda`,
"label.weixin.unbind":`Desvincular`,
"front-console-closeTime":`Tiempo de cierre`,
"label.service.rest.time":`Tiempo restante`,
"label.mr.descreption.condition1":`Ingrese el rango y reglas para encontrar los registros de duplicados. Haga clic en  [Encontrar duplicados] para conseguir los registros duplicados que alcancen los criterios.`,
"label.group.new":`Nuevo Grupo`,
"vue_label_SMS_sending_please_wait":`Enviando, por favor espere`,
"label.Standardobj.tab":`Menú del objeto estándar`,
"label_chatter_pastEvents":`Actividades pasadas`,
"label.chatter.priority":`Prioridad`,
"select.nullvalue":`--Ninguna--`,
"setup_layout_group_pagecomponent":`Componentes de página`,
"label.dataimport.dataerror.check":`Error de datos, revise este dato`,
"label.permission.detail.app.pagesetting.tip":`Ejecutar configuración de permisos de la página personalizada`,
"label.knowledge.language.polish":`Polaco`,
"label.project.hit.two":`Recordatorio de expiración de subtarea`,
"label.customerapp":`Aplicaciones personalizadas`,
"label.reportsSubscriptionPage.condition.value":`Valor`,
"label.tabpage.no2z":`No2`,
"lable.system.administrator":`Lo sentimos, no tiene acceso para operar. Por favor, póngase en contacto con el administrador.`,
"homepage.layout.buttion":`Asignación del dese?o de la página`,
"label.notification.event.overlapEvent":`Ya se le ha asignado a este usuario el evento {subject} de {begintime}-{endtime}, ¿quieres crear este evento de todos modos?`,
"label.customfields":`Campos personalizados`,
"label.data.downpage.e.title":`Pasos para la exportación de datos:`,
"label.notification.serviceappointment.remove":`Su orden de trabajo enviada {0} ha sido cancelada, por favor organice su trabajo razonablemente.`,
"label.campagin.roi.zhuangtai":`Status de campa?a`,
"label.applt.updown":`Descargar el miniprograma Código QR`,
"label.customfields.new.step1.tip":`Especifique el tipo de información que el campo personalizado deber contener`,
"label.staticresource.upload.limit":`Sólo los archivos de los formatos siguientes se pueden subir: png, jpg, gif, js, css, zip.`,
"chatter.edit.user.p":`Cambiar perfil de usuario`,
"label.icon.32":`Computadora`,
"vue_label_homepage_notice_cantset":`La página de inicio del perfil no está configurada para este perfil, la página de inicio por defecto del perfil no puede ser modificada`,
"front-epwechat-module-v1-agree-unbound":`Acepta la información no vinculante anterior`,
"label.version.chatter.cooperation":`CCChatter`,
"label.customer.tab.step1.selectstyle":`Seleccione el estilo del menú`,
"label.select.an.asset":`Por favor, seleccione un activo.`,
"label.search.sizer.field":`Buscar campo de filtros`,
"label.emailmerge.mergeFolder.lastone":`Seleccione por lo menos una plantilla.`,
"label_tabpage_step2":`Paso 2: Especifique los criterios de filtro`,
"label.version.lead.automatic.allocation":`Asignatura automática de candidatos`,
"label.projectManagement.update.succeeded":`Actualizado con éxito`,
"label_tabpage_bar":`Barra`,
"label.appupload.component.type.tab":`Menú`,
"label.pigeonhole.sel.f":`Elija la carpeta a archivar`,
"homepage.components.status":`Estado de los componentes`,
"label.currency.edit.new":`Editar Moneda: Nueva Moneda`,
"label.input.new.password":`Por favor, introduzca la nueva contraseña correcta`,
"chatter.group.membersName":`Nombre de miembro`,
"label.myinfo.modify":`Editar información personal`,
"label_tabpage_next":`Siguiente`,
"vue_label_homepage_card_closedopportunities":`Oportunidades atrasadas`,
"label.permission.edit":`Editar propiedades`,
"message.error.searchfield.objid.null":`El ID del objeto requerido por el campo de consulta no puede estar vacío`,
"label.partnerCloud.productSet":`Configuración del producto`,
"label.emailtocloudcc.filed.emailto":`Enviar un correo a`,
"label.service.miniProgram.uploadingImage":`Suba la imagen del carrusel`,
"label.sso.saml.idp.description1":`Aplicaciones conectadas`,
"label.event.moveup.10minutes":`10 minutos con antelación`,
"label.quote.createby":`Preparador`,
"label.workflow.baseontimeoparate":`Operación del flujo de trabajo depende del tiempo`,
"label.searchall.r":`Buscar de nuevo`,
"vue_label_homepage_differentprofiles":`Asignar diferentes páginas de inicio a diferentes perfiles`,
"label.campaign.channel.step1":`Paso 1: Información`,
"label.event.moveup.2hour":`Dos horas con antelación`,
"font-evaluate-module-v1-cancle-reply":`Cancelar la respuesta automática`,
"message.datalocked.delete":`Registro cerrado: El regisro que intente cancelar ya está cerrado. Si quiere hacerlo, contacte con el administrador.`,
"label.sso.listOfKey":`Lista de clave`,
"label_chatter_newtask":`Nueva tarea`,
"label_emailsync_form_seversetting":`Configurar`,
"label.partner.new.function":`Descripción de función`,
"vue_label_notice_homepage_pleaceentername":`Introduzca el nombre de la página de inicio`,
"message.please.choose.opportunity":`Seleccione oportunidad`,
"label_file_use_most_user":`Los usuarios co más espacio utilizado`,
"label.htyj.remark2":`No puede ver rendimiento de contrato`,
"label.formula.message":`Cuando la fórmula se evalua como falso, se mostrará el aviso de error`,
"UG_Case_04":`Asignación de casos`,
"label.displaycolumn":`Mostrar columnas`,
"vue_label_campaign_selected_member_status":`Actualizar a estado de miembro seleccionado`,
"label.workflow.operate":`Operación del flujo de trabajo`,
"label_chatter_mail":`Correo`,
"label.setup.mini.setting":`Configuración backend del miniprograma`,
"vue_label_chat_invitetojoin":`Has invitado a "{invite}" a unirse al chat de grupo`,
"setup.object.field.dependency.label.linkedfieldvalue":`Valor de campo dependiente`,
"vue_label_email_update_template":`Actualizar plantilla`,
"label.email.template.private.mail":`Carpeta exclusiva de plantillas de correo electrónico`,
"lable.Confirm .potential.customers":`Confirmar reciclar el cliente potencial {name}`,
"vue_label_leadpool":`Grupo público de clientes potenciales`,
"label.ems.hostorpost.error":`Error de configuración del servidor o puerto, revise.`,
"label.search.saveok":`Guardar con éxito`,
"label.custom.field.cannot.maping":`No puede mapear a este campo múltiples veces`,
"label.projectManagement.dispatched":`Enviado`,
"time":`Hora`,
"label.choose_socialnetwork":`Elige una red social para empezar`,
"label.vlidaterule.checkedtrue":`Si la fórmula es una casilla de verificación, no necesita comillas dobles`,
"label.appointmentconfirmail.wizard.btn1":`Reservar de nuevo`,
"front-kefu-moudle-v1-maxchars-input":`Se pueden introducir hasta {0} caracteres`,
"setup.mainpage.label.welcome10":`Instrucciones: Haga clic en el menú de la izquierda de la página → Configuración de la aplicación → Crear → Objeto → Nombre del objeto → Diseño personalizado.`,
"label.ems.company.setup.title":`Configuración de la bandeja de salida de la empresa`,
"label.channel":`Canal de marketing`,
"label.textmessage.groupsms":`SMS de grupo`,
"label.asset.deleted.successfully":`Eliminar la lista de materiales de los activos con éxito.`,
"label.knowledgebase.new.workspace":`Nuevo espacio de trabajo`,
"label.ServiceCloud.diliweizhi":`Ubicación`,
"label.private_me":`Privado para el propietario (yo)`,
"label.service.miniProgram.imageLink":`Enlace al carrusel`,
"label.area.assigned":`Usuarios asignados`,
"label.weixin..xsld.name":`Nombre de oportunidad`,
"label.campaign.matchway.select.name":`Nombre`,
"label.installedsoft":`Paquetes instalados`,
"label.projectManagement.spare.time":`Tiempo disponible`,
"label.user.select.custom.text.sendemail":`Seleccione el formato de textos personalizados para enviar directamente via correo`,
"label_chatter_chatter":`CCChatter`,
"label.approveorrefuse":`Aprobar/Rechazar`,
"startdate.enddate.time.illegal":`La fecha de inicio debe ser menor o igual a la fecha de finalización.`,
"label.project.hit.eight":`Recordatorio de tareas diarias`,
"message.duplication.label.uncheck":`No verifica`,
"label.allocation.role":`Asignar usuarios`,
"label.sendemail.lead.scoreinfo":`Estimado #username:\r\n    el sistema ha puntuado a todos los candidatos de la vista de candidatos seleccionados “#viewlabel” basándose en la regla de puntuación para los candidatos, lleva #timestr.\r\n Ingrese y abra la vista para revisar.\r\n atención:\r\n si no puede ver los puntos de los candidatos, edite la vista y agregue ¨Puntuación de candidatos¨al campo mostrado para ver el resultado de puntos\r\n ?Gracias por su uso!\r\n                                                          #orgname\r\n`,
"lable.oppt.jieduan.closejieduan":`Cerrar esta oportunidad`,
"label.ems.verify":`Verificar`,
"message.error.startdate":`Fecha de inicio debe ser más temprano que la fecha de finalización`,
"label.campaignmember.main.deletelead":`Cancelar miembros-Candidatos existentes`,
"label.partnerCloud.financeSetting.account":`Una vez activado el fondo de socios, se añadirán los objetos del fondo de socios y el extracto de fondos. Los usuarios asociados pueden utilizar la cuenta en CloudCC para pagar los pedidos.`,
"message.datalocked":`Registro cerrado: <br>????El registro que quiere editar está cerrado. Si quiere hacerlo, contacte con el administrador.`,
"lable.opppdt.selPbk.pricebook":`Lista de Precios`,
"label.knowledgebase.restore.article":`¿Restaurar el artículo?`,
"label.object.batchadd":`Añadir por lotes {objName}`,
"label.what_happen":`Página después del envío del formulario`,
"label.roleandunderling":`Roles y subordinados`,
"label.knowledge.language.russian":`Ruso`,
"front-electronic-signature-explain-first":`Antes de vincular la firma electrónica, se recomienda registrarse y certificarse en la plataforma Fadada.`,
"component.sendmail.label.subject":`Asunto`,
"month":`Mes`,
"label_chatter_save":`Guardar`,
"label.view.sortview.sectiontitle":`La vista se mostrará por el orden de selección`,
"label.mobile.home.page.major.project":`Proyectos Clave`,
"label.weixin.input.filename":`Por favor ingrese el nombre del archivo`,
"label.pagelayout.remark":`Esta página le permite crear los dise?os de página diferentes para mostrar`,
"label.service.miniProgram.store":`Historia de la marca`,
"label.recordtype.edit.selected":`Valor seleccionado`,
"message.selectgroupcondition":`Seleccione los criterios para la agrupación`,
"label.y.axis.cannot.empty":`El eje Y no puede ser nulo`,
"label.textmessage.vonage.connected.count":`Contabilizar como contactado`,
"setup.layout.label.readonly":`Solo lectura`,
"front-kefu-moudle-service-agent":`Servicio de atención al cliente`,
"message.login.mfaverification.page.invalid":`La página es inválida, refresque`,
"label.central.standard.time":`Hora estándar central`,
"label.processnoticepic":`Tenga en cuenta en la imagen en el proceso de aprobación`,
"vue_label_helpcenter_calendar1.2":`Reglas de visualización de las entradas del calendario: las entradas del calendario se mostrarán en la cuadrícula del calendario, y el área de la cuadrícula donde se encuentra la entrada del calendario representa el rango de tiempo del registro. Las entradas del calendario que abarcan más de 24 horas se mostrarán en la parte superior de la escala de tiempo en las vistas de día, semana y disponibilidad. Si hay varias entradas de calendario en una cuadrícula en la vista del mes, puede hacer clic en "Más" para verlas. Si en el lado izquierdo o derecho de la entrada del calendario hay un semicírculo, significa que no existe ese registro en el día anterior o siguiente de la cuadrícula. Si es un ángulo recto, indica que existe ese registro en el día anterior o siguiente de la cuadrícula. <br>Localizar rápidamente la fecha en la vista de calendario: Puede localizar el intervalo de fechas que aparece en la vista de calendario de la izquierda seleccionando la hora en el pequeño calendario de la parte derecha de la página de calendario. También puedes hacer clic en los iconos "<" y ">" de la parte superior derecha de la página de calendario para cambiar rápidamente de fecha. Si la hora de la vista del calendario no es la actual, puedes hacer clic en el icono "Hoy" situado en la parte superior derecha de la página del calendario para cambiar rápidamente a hoy. <br>Vista de lista<br> Cambiar de la vista de calendario a la vista de lista: Haga clic en el icono "calendario" en la parte superior derecha de la vista de calendario y seleccione "tabla" para cambiar a la vista de lista de eventos. <br> Uso de la vista de lista: Para ver eventos específicos o múltiples eventos al mismo tiempo, abra la vista de tabla. Hay vistas de lista preestablecidas en la vista de lista. Haga clic en el icono "botón desplegable" en la esquina superior izquierda de la vista de lista para mostrar todas las vistas de lista a las que tiene acceso. También puede personalizar la vista de lista de eventos para satisfacer sus necesidades. <br> 2. Mi calendario y otros calendarios<br> Mi calendario<br> Mi calendario contiene mi calendario de eventos y mi calendario de objetos. <br> Mi calendario de eventos: Muestra todos los registros de eventos donde la persona asignada es la suya en la vista del calendario. Mi calendario de eventos no se puede eliminar, editar o cambiar de color. Puede compartir "Mi calendario de eventos" con sus compañeros.`,
"label.approval.end":`Finalizar`,
"vue_label_report_notice_cannotdelete":`No se puede eliminar la carpeta porque contiene informes`,
"label.sso.saml.idp.loginurl":`idP ingresa URL`,
"label.emailtocloudcc.filed.port":`Puerto`,
"label.directdashboard.righttitle":`Panel de análisis de ventas`,
"label.knowledge.case.suggest.article":`Artículos sugeridos en los casos`,
"label.version.maxcount":`, ?ha superado al límite!`,
"label.weixin..xsld.yjqyrq":`Fecha cerrada`,
"front-project-module-v1-unmarket-is-template":`Desmarcar la plantilla`,
"label.mobile.quickcreate.default.map":`Login`,
"chatter.click.p":`Haga clic para previsualizar`,
"label.chat.topic.all.topic":`Todos los temas`,
"label.channel.head":`Supervisor del canal`,
"lable.edit.queue.emaildes":`Ingrese el nombre de la cola y el correo al que enviar las notificaciones (por ejemplo, cuando se pone un caso en la cola). El correo puede ser individual o de una lista de distribución. Cuando un objeto es asignado a una cola, se notificará solo a los miembros de la cola.`,
"label.tag.filter":`Filtro de etiquetas`,
"label_chatter_filterTimeLine":`Filtrar la línea de tiempo`,
"label.dashboard.show.value":`Mostrar valores`,
"vue_label_normal_solution_sf":`Solución`,
"label.customfields.location.tip":`Permite a los usuarios definir la ubicación. Incluye longitud y componentes de dimensión que puede utilizar para calcular distancia.`,
"label.weixin.copyright":`Copyright\u00a9 2008-2022 CloudCC.com,inc. Todos los derechos serán reservados por CloudCC.com`,
"label.icon.33":`Computadora`,
"label.mr.title.opportunityName":`Nombre de oportunidad`,
"template.report.sales.month":`Ventas de este mes`,
"chatter.group.lookingForPeople":`Buscando miembros`,
"label_tabpage_userz":`Usuarios`,
"label.reportsSubscriptionPage.email.formatselection":`Seleccione el formato del informe que desea enviar por correo`,
"lable.product.plist":`Lista de precios`,
"label.multilang.activity.monthline":`Semana {0}`,
"label.ccchat.whose.name.contains2":`Miembros de cualquier grupo de campa?a`,
"label.mobile.phone.day.report":`Reporte diario`,
"label.processsetting.set.files":`Configurar campos`,
"label.systemlog.s":`?xito`,
"label.tabpage.uploadsz":`Cargar`,
"serviceterritory.member.time.conflict":`En este rango de tiempo, los recursos de servicio se han convertido en miembros de otro territorio de servicio.`,
"label_chatter_startDate":`Fecha de inicio`,
"label.search.at.least.two":`Las palabras de búsqueda no debe ser menos que 2 caracteres`,
"label.approval.ressign.project":`Items por asignar`,
"lable.custom.Previous.CY":`Año contable personalizado anterior`,
"label_chatter_link":`Enlace de la página de detalles`,
"label.weixin.group.name":`Nombre`,
"label.partnerCloud.basicSetting.domainName":`La operación es irreversible y el nombre del dominio no puede ser cambiado después de la inicialización. Está seguro de confirmar la operación?`,
"lable.SalesCommitmentKanBan.targetContract":`Monto objetivo del contrato`,
"label.currency.new":`Moneda de Empresa Nueva`,
"message.passwordPolicy.validate.complexReq3":`Error: Su contrase?a debe ser mayúsculas y minúsculas alfanuméricas y signos`,
"label.icon.127":`Doctores`,
"label.customfields.fieldname.tip":`El nombre del campo es una referencia interna y es utilizado para integración como API`,
"chatter.feed.menutype.feed":`Extracto`,
"label.home.standard.dashboard.role":`No tiene información del rol, no puede ver el panel de compromiso de ventas `,
"label.customfields.fielddependency.button":`Haga clic en el botón para incluir o excluir los valores seleccionados de la lista de opciones dependiente`,
"label.recentprojects":`?tems recientes`,
"label.appupload.logo.introduce":`El ícono del AppExchange deber ser menos de 20KB. El tama?o de la imagen debe ser de un máximo de 60 píxeles de ancho, 60 píxeles de alto para obtener mejores resultados. Las imágenes más grandes cambiarán de tam?o  y puede aparecer distorsionadas. Además, la nueva imagen no tendrá efecto hasta que se guarde.`,
"label.integrations.northamericanleads":`Candidatos norteamericanos`,
"label.sms.balance":`Saldo(yuan)`,
"label.ccchat.message.num":`Noticias`,
"label.embed_website":`Para incrustar este formulario, simplemente copie y pegue el siguiente código en el código HTML de su sitio web.`,
"label.trigger.check.error":`Reviso de la sintaxis de trigger se frascasó`,
"label.bmap.baidu.maps":`Mapa de Baidu`,
"label.nextapproverauto":`Próximo Aprobador Automatizado determinado por`,
"label.customfields.date.tip":`Permite a los usuarios ingresar una fecha o seleccione la fecha del calendario.`,
"button.partner.back":`Regresar`,
"label.layout.editcondition.tip":`Seleccione los campos que quiere usar como criterios de búsqueda. Nota: Puede seleccionar 10 campos al máximo`,
"label.stacked.area":`Gráfico apilado-?rea`,
"font-evaluate-module-v1-case-closed":`Sólo cuando el caso está cerrado`,
"label_emailsync_status_log":`Historial de vinculación`,
"label.version.area.and.sales":`Gestión Regional y Grupo de Ventas`,
"label.service.booking.sessions":`Hora de la cita de servicio`,
"label.untransfile":`Documento no traducido`,
"label.textmessage.sentfail":`Fallo en el envío`,
"label.emailtemplate.detailinfo":`Detalles de la Plantilla`,
"setup_mainpage_label_welcome13":`Instrucciones: Haga clic en el menú de la parte superior→ Reportes → Nuevo`,
"label.ccchat.error.nullid":`El ID no puede estar vacío`,
"label.partnerCloud.partnerAccount.rebate":`Rebaja Revenu`,
"label.appupload.component.type.scheme":`Campo`,
"front-kefu-moudle-phonein":`Llamada entrante`,
"label.emailmerge.list.description":`Las plantilla de fusionar correo son documentos Miscrosoft Word con los campos fusionados que referencia a campos CloudCC.com. Haga clic en ¨Crear plantilla¨ para subir nueva plantilla de fusión de correos`,
"vue_label_commonobjects_detail_select_first":`Seleccione primero los elementos relacionados`,
"label_emailsync_form_action":`Operación`,
"label.customfieldrelation":`Campo personalizado y relación`,
"label.ems.other.msg":`Contacte con el administrador de CloudCC(<a href='mailto:admin@cloudcc.com' style='text-decoration: underline;'>admin@cloudcc.com</a>), abra el servicio de sincronización de correo.`,
"label.appointment.wizard.subtitle4-3-4":`1h`,
"label.service.miniProgram.isOpen":``,
"equal":`Igual a`,
"label.partnerCloud.financeSetting.merchantInformation":`Ruta de acceso: Plataforma para Comerciantes  Centro de Cuentas  Información para Comerciantes`,
"vue_label_calendar_displayed_field_name":`Nombre del campo mostrado`,
"UG_opportunity_002":`Defina su ciclo de ventas, configure la etapa`,
"label.tag.addtags.button1":`Confirmar`,
"label.explain":`Instrucciones`,
"label.icon.166":`Pabellón`,
"label.exchange.sync.setting.use":`Iniciar Exchange Sync`,
"label.chatter.assignPerson":`Persona asignada`,
"lable.PowerProcess.event.condition":`Condiciones de eventos clave`,
"label.addattachment.step1":`Paso 1: Seleccione archivo`,
"label.account.fiscal.quarter.timeerror":`La fecha de inicio y la fecha de finalización del trimestre contable se encuentran entre el período de tiempo de los trimestres personalizados históricos, por favor, compruébelas y reconfigúrelas.`,
"label.URL":`Ruta URL`,
"label.icon.134":`Datos`,
"label.forecast.customforecast.foredis.sq":`Miles`,
"label.custom.field.number.decimal":`Dígitos de número incorrectos`,
"label.version.history.track.error":`Su versión solo admite seleccionar <=5 campos, no puede seleccionar más campos.`,
"label.log.os":`Sistema de operación`,
"label.partner.workspace.tab.option":`Pesta?as disponibles`,
"label.partnerCloud.partnerAccount.accountWater":`Declaración de fondos`,
"setup_layout_label_norelatedlist":`No hay listas relativas`,
"label.import.page1.nextstep":`Siguiente paso`,
"label.emailobject.view.attached":`Correo con anexos`,
"label.SalesCommitmentKanBan.allTask":`Monto total de tarea`,
"label.eastem.daylight.time":`Hora de Verano del Este`,
"label.create_engaging":`Crea un puesto atractivo para conectar con el mundo.`,
"label.area.adduser":`Añadir o Cancelar Usuario`,
"label.timezone.importtimezone.user":`Utilizar zona horaria del usuario actual`,
"label.passwordPolicy.setup.pwdremember1":`Recordar una contrase?a`,
"label.query.detail.openpartneruser":`Activar usuario de socios`,
"label.senduser":`Enviado de`,
"Pagelayout_Setup_001":`Seleccione las listas relativas que se mostrarán en la página de dese?o`,
"label.mobile.parameter.setup":`Configuración de parámetros del dispositivo móvil`,
"message.device.not.bound.mfa":`Dispositivo MFA no vinculado`,
"setup.layout.label.buttonarea":`Área de botones`,
"chatter.email.reply.like":`Al comentar sobre las publicaciones que me gusta`,
"label.chatter.day":`Día`,
"label.sendemail.chat.addComentspraisesubject":`CloudCC CCChatter ha respondido que le gusta su publicación`,
"label.field.remark2":`Campos mostrados en la página`,
"label.ggReleaseRange.release":`Publicar gama`,
"lebel.alreadyback":`Llamada devuelta`,
"label.appupload.install.appname":`Nombre de aplicación`,
"label.selectnewadeckertag":`Seleccione etiqueta para el nuevo campo de jerarquía`,
"label.cliententrancewebsiteadmin":`Administrador del portal del cliente`,
"label.checkbox.checked":`Seleccionado`,
"UG.Case.03":`Actualización automática del caso`,
"vue_label_dashboard_group":`Seleccione un grupo`,
"label.import.index.preparedata":`Prepare los datos que desea importar`,
"vue_label_member_notice1":`Puede subir archivos tipo JPG, GIF o PNG, el tamaño máximo del archivo es de 2MB`,
"message.modify.success":`Modificación exitosa`,
"label.userquotas":`Cuotas`,
"label.appointmentpage.wizard.subtitle3-1":`Nombre`,
"label.import.index.maxdata2":`2. Antes de importar, por favor asegúrese de importar primero todos los registros relacionados. Por ejemplo, si hay una relación de búsqueda entre el objeto que está importando y los contactos, por favor, importe esos contactos primero, y luego importe sus datos. Si necesita obtener el ID del registro correspondiente y otras informaciones, puede crear un informe y establecer el nombre del registro y el ID del registro como columna de grupo, y luego exportar el informe.`,
"label.pc.sectionpart":`PC`,
"template.chart.wcldqzkh":`Contactos no procesados`,
"label.save.the.block.pricing.information.of.the.current.price.manual":`¿Desea guardar la información de precios en bloque del libro de precios actual?`,
"label.partnerCloud.financeSetting.payments":`Permitir el pago en línea`,
"lable.account.ThisWeek":`Esta semana`,
"label.validate.function.funcFormat.RIGHT":`RIGHT(text, num_chars)`,
"label.app.select.bgcolor":`Seleccione el color de fondo`,
"label.planned.work":`Trabajos Planeados`,
"label.passwordPolicy.setup.nolimit":`Ilimitado`,
"label.vlidaterule.s":`Si desactive la moneda utilizada por los usuarios, la moneda de los usuarios será configurada como moneda de empresa.`,
"label.paging.totalofrecords":`Un total de {0} registros`,
"label.customobjects.behaviour":`Comportamientos`,
"vue_label_ccchat_notice_deletecommentsuccess":`Comentario borrado con éxito`,
"label.lock.record.dele":`?El registro actual está bloqueado, y no se puede cancelar!`,
"label.data.expnode.e.desc3":`3. Crear plantillas: el usuario puede crear plantillas basándose los campos y las condiciones exportados según sus necesidades, lo que es conveniente utilizarla la próxima vez.`,
"label.button.step3.create.page":`Paso 3: Generar Páginas`,
"label.sharer":`Compartir con`,
"label.service.cycle.type":`Tipo de ciclo`,
"lable.SalesCommitmentKanBan.allreceivingCommitmentRate":`Tasa de compromiso del recibo total`,
"label.formuladate":`Formato de fecha: yyyy-MM-DD hh:mm:ss o MM/DD/YYYYhh:mm:ss, por ejemplo: 2007-12-25 12:25:30 o 12/25/2007 12:25:30, también puede utilizar today() O now();`,
"front-template-V1-addImg":`Añadir imagen`,
"label.basecontrol":`Acceso básico`,
"label.forecast.settings.lable1":`Agrupación de datos pronosticados`,
"message.error.file.null":`El archivo de carga no puede estar vacío`,
"label.multiply":`*Múltiplicar`,
"message.duplication.label.targetobject":`Objeto`,
"label.addattachment":`Añadir adjunto`,
"vue_label_dashboard_notice_editcertification":`¿Estás seguro de que quieres editar el componente {name}?`,
"label.notification.tip2":`No hay notificaciones`,
"lable.quote.syncingfrom.firstsync":`Sync inicial: Oportunidad sincroniza con la cotización`,
"label.createtasktip":`Cree una tarea para asociar con una o más regla del flujo de trabajo, proceso de aprobación o de derecho. Si cambia una tarea, cualquiera modificación se aplicará a las reglas, aprobaciones o proceso de derecho asociado con ellas.`,
"label.leave":`Deja`,
"front-invoice-online-payment-setup-china":`Aplicar a las cuentas chinas`,
"label.appointment.wizard.subtitle4-1-2":`30 minutos`,
"label.projectManagement.the.person.not.be.informed":`Si selecciona "No", no podrá notificar al responsable`,
"label.campagin.roi.name":`Nombre de compa?a`,
"label.import.page1.newcreate":`Crear`,
"label.data.downpage.i.title.num2":`2. Antes de empezar a importar, asegúrese de que el nombre del campo en el archivo que quiere importar coincide con el nombre del campo del objeto en CloudCC.`,
"label.callcenter.call.in":`Llamar`,
"label.weixin.activity.phone":`Actividad: Llamadas`,
"label.forecast.customforecast.type.role":`Por rol`,
"label.moscow.standard.time":`Hora Estándar de Moscú`,
"label.profile.setcustomobjectrecordtype":`Configuración del tipo de registro personalizado`,
"lable.edit.queue.new":`Nueva cola`,
"label.newAPPexchange":`Nueva aplicación...`,
"message.custom.field.donotdelete.fieldupdate":`Este campo es referido por la actualización del campo bajo el proceso del flujo de trabajo o de aprobación`,
"label.chatter.state":`Estado`,
"label.subject_line":``,
"template.report.folder.active":`Análisis de campañas y acciones`,
"label.icon.114":`Casa`,
"label.assignment.setup.newentries.step3":`Paso 3: Seleccione los usuarios para asignar`,
"label.salescloud.salesdashboard.sales.behavior.rankings":`Vista General de Personal-Comportamiento`,
"label.weixin.optiontwo":`Opción 2`,
"label.sso.saml.idp.config.sp":`Proveedor de servidor`,
"System_TimeField_Description":`Permite a los usuarios ingresar la hora local. Por ejemplo, "2:40 PM", "14:40" y "14:40:00" son todas las horas válidas de este campo.`,
"label.knowledgebase.draft":`Borrador`,
"label.chat.topic.no.more.suggestions":`No hay otras sugerencias`,
"label.quote.product":`Producto`,
"label.cryptographictext":`Texto cifrado`,
"label.custom.unlock":`Desbloquear`,
"label.assignment.setup.newentries.step2":`Paso 2: Seleccionar los criterios de esta regla`,
"label.tabularreport.selectline":`Seleccione las columnas que quiere incluir en el informe`,
"label.exchange.sync.state.contact.m2":`Registros sincronizados en los últimos 60 minutos:`,
"label.codeType":`Tipo de código`,
"saturday":`Sábado`,
"label.mask.type":`Tipo de máscaras`,
"label.schedulejob.setup.schedule.Monthly":`Mensual`,
"label.import.page2.totalfiled{{20}}，{{4}}notsuited":`Hay en total {{20}} campos en el archivo , quedan {{20}} sin asignar`,
"label.projectManagement.delete.item":`Toda la información relacionada con este proyecto se borrará si elimina el proyecto, y los datos no se podrán recuperar. ¿Está seguro de querer eliminarlo?`,
"label.page.general.us.and.western.europe":`Idiomas generales US y Europa occidental`,
"label.reportsSubscription.status":`Suscrito`,
"label.discount.baifenbi":`Descuento (%)`,
"font-evaluate-module-v1-web-page-evaluation-settings":`Configuración de la evaluación web`,
"message.error.searchwork":`Palabra ingresada debe ser 2 o más caracteres.`,
"label.weixin.option.setting":`Configuración de opciones (10 opciones al máximo)`,
"label.lead.score.prompt1":`Puntuación automática al crear o editar un candidato individual, pero se procesa puntuación masiva manual con respecto a los candidatos de importación masiva o creados por interfaz.`,
"label.exception.must.try.throw":`?Las excepciones deben lanzarse en el bloque de declaración!`,
"label.activity.plan":`Plan`,
"label.partnerCloud.productSet.editor":`Opción de edición`,
"label.mobile.quickcreate.default.signinnew":`Iniciar sesión`,
"label.summaryreport.2018.step6.new":`Paso 6: Seleccione el tipo de gráfico e ítems destacados`,
"vue_label_homepage_owner":`Página de inicio de`,
"vue_label_dashboard_editfoldersuccessfully":`Carpeta editada con éxito`,
"label.quickbooks.view.overdueinvoices":`Invoices vencidos`,
"label.emailtocloudcc.redmessage4":`Introduzca los datos del puerto`,
"label.tabpage.equalz":`Igual a`,
"lable.quote.syncing.firstsync":`Sync inicial: la cotización sincroniza con las oportunidades`,
"label.download.CloudCCAPP":`Descargar la aplicación CloudCC`,
"label.icon.6":`Moneda`,
"label.list.serial.number":`Número de serie`,
"label.profile.setstandardobjectrecordtype":`Configuración del tipo de registro estándar`,
"label.customize.memory.function.sorting.error":`El tiempo de respuesta de la consulta es demasiado largo y provoca el cierre de la página. Puede deberse a que la memoria de ordenación de cabeceras está activada. Por favor, vaya a la configuración personal y desactive esta función.`,
"message.view.addtoallusers":`Visible a usuarios relacionados`,
"label.globaloperation.operationtype.record.phone":`Registrar llamada`,
"lable.opppdt.selPdt.searchresult":`Resultados de búsqueda`,
"label.import":`Importar`,
"label.service.gantt.work.based.resources":`Recursos basado en las horas de trabajo`,
"label_partner_template_detailimage":`Imagen`,
"label.cpq.product.feature.option.count":`El mínimo de opciones de producto no puede ser mayor que el máximo de opciones de producto`,
"label.chatter.newtask":`Nueva tarea`,
"font-trade-module-v1-invoice-total-price":`Pagos totales previstos`,
"setup_mainpage_label_welcome29":`Integración API estándar con los productos de los terceros`,
"label.data.exportall.all.btn":`Exportar todos los datos`,
"front-epwechat-module-v1-unbound-WeChat":`Desenlazar WeCom`,
"label.salescloud.salesdashboard.performance.rankings":`General-Ranking de monto del contrato de ventas`,
"label.import.page1.newcreateandupdate":`Actualizar y crear`,
"component.chatter.post.button.file":`Añadir adjunto`,
"label.partnerCloud.orderingPlatform.createOrder":`Nuevo orden`,
"label.lookup.multiple.data":`Múltiples datos han sido encontrados, seleccione manualmente`,
"button.partner.save":`Guardar`,
"label.service.add.timeslot":`Añadir franja horaria`,
"label.campaign.matchway.select.email":`Correo`,
"front-sales-button-fromQB":`Actualización de QuickBooks`,
"label.icon.108":`Flecha`,
"lable.outlook.edit.efmapping":`Editar campos de mapeo`,
"label_tabpage_refreshz":`Refrescar`,
"chatter.follow.cancel":`Cancelar el seguimiento`,
"label.totals.sum":`Total`,
"label.noRequest":`No requisitos`,
"vue_label_homepage_fixedcomponent":`Seleccione el componente estándar`,
"label.knowledge.delete.case":`Error al borrar el artículo del caso.`,
"label.weixin..xsld.yjwc":`Ingresos expectativos`,
"label.customcomponent.page.index.console.btn":`Consola de programador`,
"label.sendsms.batch":`SMS masivo`,
"vue_label_chat_onlychosechat":`Solo puede chatear con los usuarios del Plan de Equipo`,
"label.tabpage.page":`Página`,
"label.cyen.note":`Moneda activada. Atención, la activación de la moneda es irreversible.`,
"label.weixin.againsend":`Reenviar`,
"label.processnumber":`Paso No.`,
"label.emailobject.to":`A:`,
"label.event.today":`Hoy`,
"label.dashboard.dispalyPosition":`Mostrar Posición`,
"message.error.recalculate.dupoperate":`?Recalculando, no opere con frecuencia!`,
"vue_label_email_linkrecordsuccess":`Registro asociado con éxito`,
"label.updateoutboundnews":`Actualizar mensajes salientes`,
"label_emailtocloudcc_exists2":`El correo ha sido configurado Email to Case, no repita la configuración`,
"label.tag.addtags.button2":`Cancelar`,
"label.stdashbord.xsld.business.role":`Este rol proviene de los roles activados en la jerarquía de previsiones`,
"label.commonnew":`Creación normal`,
"label.validate.remark2":`Muestra de uso:`,
"label.reportsSubscriptionPage.condition.checkbox":`Añadir condiciones en el informe`,
"label.globalselect":`Conjunto de valores de la lista de opciones global`,
"label.partnerCloud.partnerAccount.available":`Cantidad disponible`,
"label_tabpage_nothingz":`Nada`,
"label.version.webtolead":`We to Lead`,
"label.projectManagement.heat.map":`Mapa de calor`,
"message.error.pleasecorrectdata":`Revise todos los mensajes de error siguientes para corregir los datos.`,
"label.hight.tip":`Cuando no activen el filtro avanzado, la relación entre las condiciones de filtro diferentes será "and", es decir, un registro que satisface a las características comunes de 1 y 2`,
"label.workflow.estimatecondition3":`Cada vez cree o edite registro`,
"AssetRelationship.time.limit.error":`La fecha de inicio deberá ser anterior o igual a la fecha de vencimiento.`,
"label.multilang.workflow.dayinmonth":`El {1} de cada  {0}mes(es)`,
"label.reportsSubscriptionPage.schedulereport.daily":`Diario`,
"label.emailtocloudcc.step1.name":`Elija la función`,
"label.follow_up":`Correo electrónico de seguimiento`,
"label.price.list.price.cannot.be.empty":`El precio de lista no puede estar vacío.`,
"label.chatter.link":`Enlace`,
"label.ccpeak.condition.return.record":`Regrese los registros de acuerdo con las condiciones y admite condiciones comunes de where.`,
"pagecreator.layout.message.canntdelete":`No se puede borrar en el diseño actual`,
"label.compact.layout.main":`Dise?o de la información principal y clave`,
"label.testandupdate":`Revisar la actualización`,
"button_partner_cancel":`Cancelar`,
"label.activity":`Actividades`,
"label.knowledge.setting.hint.fourteen":`¡Prepárate para escribir!`,
"vue_label_commonobjects_view_open_from_list":`Abrir en la lista para usar`,
"front-electronic-export-intro":`Se pueden exportar 2000 registros a Mailchimp por una vez`,
"label.chosen.all":`Todos los campos`,
"label.file.extension":`Extensión del fichero`,
"vue_label_systemSettings_server_miniprogram":`Miniprograma de servicios`,
"label.weixin.no.pending.wdgz.qin.today":`No hay trabajo hoy`,
"label_tabpage_issuez":`Problema`,
"label.staticresource.tip":`Utilice los recursos estáticos para subir los contenidos que quiere hacer referencia en sus páginas personalizadas, incluye .zip, imágenes, hoja de estilo, JavaScript y otros archivos.`,
"label.approvalstep":`Paso de aprobación`,
"label.china.standard.time":`Hora Estándar China`,
"label.appexchange.download.tiaoguo":`Ignorar`,
"label.callcenter.link.Amazon.connect":`Conectar con Amazon`,
"vue.dashboard.notRequired.notConformToTheRules":`Hay campos obligatorios sin rellenar o que no cumplen con las reglas, no se ha podido enviar.`,
"label.appointment.wizard.title1":`Definir su tiempo libre`,
"label.chat.remove.bookmark":`Remover los marcadores`,
"label.tabpage.advancedsearch":`Búsqueda avanzada`,
"batch.ranf.f":`Error de transferencia masiva`,
"label.appointment.wizard.subtitle4-1-4":`1h`,
"label.brief.account":`Clientes`,
"component.chatter.link.label.url":`Enlace URL`,
"label_emailtocloudcc_redmessage8":`Error del parámetro, contacte con el administrador`,
"label.object.create.two.number.field":`Cada objeto se puede crear hasta 2 campos personalizados de Número Automático.`,
"label.salecommit.not.roleinformation":`No tiene información de rol, no puede ver los paneles del compromiso de ventas.`,
"label.defautline.cannot.less":`Líneas predeterminadas no puede ser menos que 1`,
"label.selectedproducts":`Número de productos seleccionado`,
"label.productsales.today.notskadd":`?Hoy no hay tareas vencidas, puede hacer clic en “ ” en la parte superior derecha para añadir tarea nueva!`,
"lable.account.year.stadate":`Fecha de inicio del a?o fiscal`,
"label.mobile.phone.month.plan2":`Tareas de este mes`,
"label.ccpeakfolder":`Carpeta de clasificación`,
"setup_mainpage_label_welcome21":`La plataforma de nube CloudCC proporciona la función de plantilla de correo definida por los usuarios, que es conveniente para utilizar y mejoar la eficiencia del trabajo.`,
"label.modify.layout":`Editar el dise?o`,
"report.label.folder":`Carpeta`,
"label.tianyancha.businessverify.rewritename":`Rellene los nombres de usuarios`,
"lable.currencyAdv.dao":`A`,
"label.mobilelayout":`Dise?o en la aplicación móvil`,
"label.the.current.model.is.enabled.and.cannot.be.edited.":`El modelo actual está habilitado, no se puede editar`,
"label_partner_all_disable":`Prohibir`,
"label.ownerapproverfield":`Campos del aprobador de propietario`,
"label.emailobject.template.message4":`Algunos de los campos insertados en el mensaje son nulos, por favor edite y reenvíe.`,
"label.productsales.today.notsk":`?Hoy no hay tareas expiradas!`,
"label.multilang.document.upload.success":`{0}ficheros han sido subidos con éxito y {1}ficheros se frascasaron`,
"label.manageAll.sta3":`Rechazado`,
"vue_label_calendar_week_view":`Calendario-Vista por semana`,
"setup_layout_label_nocustompage":`No hay página personalizada`,
"label.weixin.wdyj.jxdcl":`Tasa de finalización Personal- Rendimiento`,
"label.donot.update":`?No tiene permiso para modificar!`,
"setup.mainpage.label.welcome14":`Establecer el flujo de trabajo y gestionar el proceso de aprobación`,
"UG_Campaign_002":`Planifique, ejecute y monitoree el efecto de las actividades de marketing`,
"label.layout2":`Dise?o Dos`,
"label.app.looup":`Encontrar las aplicaciones`,
"label.projectManagement.selectitem":`Seleccione el proyecto`,
"label.field.relating.rule":`Buscar las Reglas de Asociación de Campos`,
"vue_label_commonobjects_detail_selectname":`Seleccione primero el nombre`,
"front-email-payment-Invoice-select-pay":`Seleccione Pagar con:`,
"label.customfields.formula.numberexample":`Grado Fahrenheit = 1.8 * Celsius__c   32`,
"component_event_label_enddate":`*Tiempo de finalización`,
"label.partnerCloud.partnerAccount.lineOfCredit":`Límite de crédito`,
"label.chatter.newpost":`El post más reciente`,
"label.report_dashboard":`Este informe se guardará en sus informes. También puede añadirlo a un panel de control.`,
"label.assigned":`Asignar a`,
"Homepage_News_002":`Por la presente el componente de noticias no está disponible`,
"label.approval.select.relatedobj":`Para seleccionar ítem relativo, debe seleccionar un tipo`,
"label.service.miniProgram.isTop":`¿Fijar?`,
"message.error.object.datatoolang":`La longitud de los datos es demasiado larga, máximo {!length} caracteres.`,
"label.importsourcetip":`La importación se utiliza para modificar el archivo exportado antes de importarlo al sistema. Si aún no ha exportado, vaya a la página de exportación para exportar.`,
"label.select.deadlineplease.deadline":`Seleccione la fecha de vencimiento`,
"vue_label_account_equityrelationship":`Vinculación accionarial`,
"label.account.Calendar.month":`Mes del calendario`,
"label.appointment.wizard.subtitle3-4":`Jueves`,
"font-evaluate-module-v1-smaller-500":`El archivo debe ser inferior a 500KB`,
"label.reportsSubscriptionPage.email.tome":`Enviar solo a mí`,
"label.ccchat.person.invite.existpers":`Ya está siguiendo:`,
"label.appointment.wizard.subtitle1-3":`30 minutos`,
"front-kefu-moudle-connected":`Conectado`,
"label.campaignmember.main.duplicatelist.tip":`El sistema encontrará los duplicados de los candidatos y miembros de campa?a basándose en la configuración aquí.`,
"label.visualpage.such.tags.double":`Estas etiquetas aparecen en pares`,
"label.sendsms.batch.step2.introduce":`Seleccione una plantilla de SMS.`,
"Account_News_Setting_002":`Utilice la configuración del cliente siguiente para especificar el comportamiento de cliente predeterminado para su organización.`,
"message.encryptchange.alert":`Va a convertir {{!fieldapi}} de un campo cifrado(Almacenamiento cifrado) a un campo de texto cifrado(Se muestra cifrado), después de convertir con éxito, este campo se guardará en texto claro en la base de los datos, que se puede mostrar en texto claro o texto cifrado de acuerdo con la configuración de perfil, los campos son seleccionables. \\r ?Esta operación es irreversible, quiere continuar?`,
"label.mainpageset.description":`Configure su página de nivel de organización basada en sus requisitos comerciales reales. <br>Puede desactivar o cerrar los componentes que no tienen relación con su comercio de la configuración predeterminada.<br>Activar: Los componentes activados han sido mostrados en la página oficial de todos los miembros.<br>Desactivar: Los componentes desactivados no muestran en la página oficial de todos los miembros, ni mostrarán en la lista de ¨Configuración de mi página oficial¨ de la aplicación móvil. <br>Cerrado: No mostrarán en la página oficial de todos los miembros por defecto, y los usuarios pueden activarlo a través de ¨Configuración¨ en la aplicación móvil.`,
"label_tabpage_linknamez":`Nombre de enlace`,
"label.companyname":`CloudCC.com Co.,Ltd`,
"label.currency.current":`Moneda actual de la empresa`,
"label.campaignmember.main.duplicatelist.html.title":`Configuración de remover los duplicados por escanear código`,
"label.sendsms.batch.step3.plan":`Plan de fecha de entrega`,
"label.profile":`Perfil`,
"label.canceluploadfile.step":`Haga clic en el botón ¨Cancelar¨ para cancelar todos los archivos mostrados en la parte superior`,
"message.newreport":`Informe nuevo`,
"label.service.newBuildDialog.date.selection":`Seleccionar fecha`,
"label.lookup":`Buscar`,
"label.file.editinfo":`Editar detalles del fichero`,
"component_assistant_label_nodata":`No hay evento hoy, revise más tarde.`,
"label.tianyancha.businessverify.msg4":`Esta función utiliza los servicios proporcionados por terceros y actualmente es gratis, pero CloudCC no garantiza si la tercera parte continuará siendo gratuito. Si los terceros cobren, CloudCC reservará el derecho de cobrar al usuario o el usuario deja de utilizar esta función. `,
"label.noequal":`!=No equivale`,
"vue_label_metric_column":`La tabla debe tener al menos una columna de evaluación`,
"label_reportType_chose_and_form":`Seleccione origen de datos de informe y un formato de informe`,
"vue_label_pool_reasondescription":`{0} descripción del motivo`,
"label.isusing":`Si activa`,
"label.passwordPolicy.setup.pwdremember5":`5 contrase?as recordadas`,
"label.cancel":`Cancelar`,
"vue_label_helpcenter_detail1.1":`En la página de detalles de los datos de la versión Lightning, puede consultar la información básica, los eventos relacionados y el estado de cada registro. Puede plegar o desplegar la información correspondiente en la esquina superior derecha del módulo. También puede ver y gestionar los datos asociados al registro a través del listado relacionado.<br> 1. Ver y gestionar un solo dato<br> Puede editar, copiar, eliminar o compartir datos a otro usuario a través de los botones de la esquina superior derecha.<br> Ver la información detallada del usuario, puede editar directamente algunos campos de la página, cambiar el propietario o el tipo de registro de los datos.<br> Ver y gestionar los datos asociados al registro a través de la lista relacionada. En la lista de archivos relacionados, cargue el archivo registrado, o haga clic en el nombre del archivo para descargar y ver el archivo correspondiente.<br> 2. Listas relacionadas <br>  Conéctese rápidamente a través de la lista relacionada, y utilice la ventana flotante para ver hasta 10 registros relacionados. Haga clic para entrar en la vista de lista, ver todos los registros relacionados y editarlos en línea.<br> Utilice abajo la búsqueda modo tarjeta para ver y gestionar los registros relacionados.<br> 3. Actividades<br> En la página de detalles registrados, la versión Lightning no muestra las listas relacionadas de "Actividades no procesadas" e "Historial de actividades". En su lugar, se muestra la línea de tiempo de la actividad.<br>Línea de tiempo de la actividad muestra el contenido<br> La línea de tiempo de la actividad puede mostrar todas las actividades próximas y pasadas en el registro actual. Las tareas atrasadas y las próximas tareas y eventos se muestran en el módulo "Atrasados y próximos" de la línea de tiempo de actividades. Las tareas pasadas o actualmente completadas, los eventos, las llamadas registradas, los correos electrónicos y los mensajes de texto se mostrarán en el mes correspondiente.<br>`,
"registration.page.preview":`Vista previa de la página de registro`,
"label.quickbooks.search":`Buscar`,
"label.setup.mobile.bottombutton.tab.show":`Visualización de pestañas en la parte inferior`,
"lable.want.to.delete.tem":`¿Está seguro de que desea eliminar la plantilla de informe de servicio {currentTelmplateName}?`,
"label.multilang.fielddtrack.dealkey":`Modificar {0} de {1} a {2}`,
"vue_label_pool_return":`Devolver`,
"vue_label_calendar_failed_to_share_calendar":`Error al compartir calendario`,
"label.less":`< menos que`,
"label.email.form.html":`HTML`,
"label.tag.nodata":`Registros sin etiqueta`,
"label.setarticlecon":`Especificar los criterios`,
"label.searchlayout.displayrow":`Columnas para demostrar`,
"label.change.task":`Cambiar a la vista de tareas`,
"lable.quote.editqtpdt.title":`Editar detalles de la lista de precio`,
"label.appointment.wizard.subtitle4-4":`El tiempo más largo de la reserva con anticipación`,
"label.custom.page.button.css":`Botón CSS`,
"label.input.documentmessage":`Ingrese detalles`,
"vue_label_commonobjects_detail_email_address":`Dirección del destinatario`,
"label.chatter.filterTimeLine":`Filtrar línea de tiempo`,
"label.must.select.twoorthree.records":`Debe seleccionar dos o tres registros para fusionarse`,
"label.mobile.setup":`Configuración de aplicaciones de móvil`,
"vue_label_commonobjects_detail_key_field":`Campos clave`,
"label.chatter.relateitem":`Elementos relacionados`,
"label.customobjects.tip":`Una vez cree un objeto personalizado, puede crear menú personalizado, listas relativas personalizadas, informes y paneles para que los usuarios interactúe con los datos del objeto personalizado. Puede acceder a los datos del objeto personalizado via API. `,
"label.sso.saml.idp.config":`Configuración de proveedor de identidad`,
"label.knowledgebase.affect.article.version":`¿Afectará la modificación a la traducción existente? Si es así, puede marcar la preciosa traducción como "Caducada" y generar una lista de pendientes de traducción para los proveedores de la misma.`,
"message.error.record":`No se ha encontrado el registro correspondiente.`,
"message.duplication.label.fieldname":`Campo de objetivo`,
"setup.layout.button.cancel":`Cancelar`,
"label_radar_map_function":`Utilice gráficos de radar con múltiples parámetros para medir el papel de los contactos en la cadena de decisión de ventas`,
"label.campagin.roi.fss":`Número enviado`,
"label.emailobject.template.giveup":`Cancelar`,
"label.apiname.exists":`El nombre de API ya existe`,
"message.failtoreaddata":`Error de leer los datos`,
"label.file.versionedit":`Modificador de los contenidos`,
"template.report.lost.business.opportunity":`Oportunidades perdidas`,
"label.ccchat.group.allowgd":`Permite los grupos para archivarse`,
"label.fieldaccesslimit":`Accesibilidad del campo`,
"label_target_model":`Modelo objetivo`,
"message.validation.isnoturl":`URL inválida`,
"servicecrew.member.time.conflict":`Dentro de esta franja de tiempo, los recursos de servicio se han convertido en miembros de otros equipos de servicio.`,
"label.knowledgebase.delete.details":`Se borrará cualquier información de la asignación.`,
"vue_label_normal_bottom":`Fijar abajo`,
"label.custombutton.editerror":`Se frascasó en editar`,
"label.dashboardSetup.showdw.d6":`Automático`,
"message.error.field.decimalPlaces":`Error del formato de entrada decimal`,
"label.tabpage.busoppnamez":`Oportunidad`,
"label.insertfield.intro":`Seleccione un campo, y haga clic en ¨insertar¨. Con etiqueta de ">" significa que hay más campos disponibles.`,
"setup.layout.label.nocustompage":`No hay páginas personalizadas`,
"front-gantt-module-project-has-only":`Este proyecto sólo tiene {n} hitos`,
"label.weixin.fmu.am":`{0} AM`,
"label.emailsync.status.connectaccounts":`Asociar cuenta de correo`,
"label.customcomponent.check.name.same":`El nombre ya existe`,
"label.validate.function.funcFormat.HOUR":`HOUR(date)`,
"label.approvepagelayout4":`Copiar el diseño de la página anterior`,
"label.knowledge.category.hint.nine":`Activar grupo de categorías`,
"label.report.sorting.column":`Columna ordenada`,
"label.hours":`Hora`,
"label.email.clearAllemail":`¿Quiere borrar todos los correos electrónicos sincronizados en el buzón?`,
"font-evaluate-module-v1-satisfaction":`Evaluación satisfecha`,
"label.service.hide.more.info":`Ocultar más información`,
"label.area.list.intro":`Puede editar la área de información en esta página`,
"label.sendemail.chat.addPostat":`Estimado  #name:\n\n ?hola! #userName le ha mencionado en una micropublicación.`,
"label.data.newtemplate.e_seltype.desc":`Hay dos tipo para importar los datos: </li><li class="titledesc1">1.uno es formato CSV(por defecto)</li><li class="titledesc1">2. otro es formato de compresión. El modo de formato de compresión se divide en dos tipos</li><li class="titledesc1">2.1.una manera es generar automáticamente la contrase?a de los archivos comprimidos, que se enviará al correo de usuario una vez exporte exitosamente los datos</li><li class="titledesc1">2.2. otra manera es introducir manualmente la contrase?a de los archivos comprimidos, que no se enviará al correo de los usuarios, por eso es necesario recordar la contrase?a ingresada, si no ingrese, no tendrá constrase?a por defecto`,
"message.passwordPolicy.validate.minlengths":`Error: la longitud de contrase?a debe ser al menos`,
"message.save":`?Está seguro de que quiere guardar?`,
"label.marketsea.notfollowdays1":`después de obtener`,
"label.app.step1":`Paso 1. Seleccione tipo`,
"message.error.pageid.null":`El identificador de redes sociales de Facebook no puede estar vacío.`,
"label.weixin.input.lookupfield":`Ingrese palabras clave para encontrar micro voto coincidente`,
"label.whChatAccount":`Cuenta de WeChat`,
"label.tabpage.groupingitem":`Proyecto de grupo`,
"label.callboard.introduce":`Al siguiente se ha alistado todos los anuncios de su empresa.`,
"label.financial.services.seminar":`Seminario de planificación financiera`,
"label.data.file.i_title.num1":`1. El archivo importado debe ser un archivo en formato CSV, que debe contener un título, no se puede importar sin título.`,
"label.visualpage.filename.exist":`El nombre de fichero ya existe`,
"front-kefu-moudle-v1-new-chats":`Nuevo agente`,
"label.console.step5.tab":`Abrir el menú`,
"vue_label_opportunity_contactrole_edit":`Gestionar el rol de los contactos`,
"label.projectManagement.delete.return":`Este es el último dato, regresará a la página anterior al borrarlo`,
"registration.page.designs":`Ajustes de la apariencia de la página de registro`,
"label.console.step6.heigth":`Altura`,
"label.objectRelationshipAtLeast":`Hay un registro al menos relacionado con`,
"label.knowledge.delete.viewstat":`Error al borrar los datos de navegación del artículo de conocimiento`,
"label.direct.dashboard.month.report":`Crear informe mensual de trabajo`,
"label_tabpage_lookatmorez":`Ver Más`,
"label.setup.rights.management":`Gestión de derechos`,
"label.campaign.channel.clear.img":`Remover imagen`,
"label.calendar":`Calendario`,
"label.biaoqingfaxian.username":`Cuenta`,
"label.weixin.wdyj.jxht":`Personal-Rendimiento de Ventas-Contratos`,
"label.emailtocloudcc.exists1":`Este correo ha sido configurado como Email to Lead. No repita la configuración.`,
"label.emailtocloudcc.filed.password":`Contraseña del correo`,
"label.what_create":`¿Qué tipo de formulario quiere crear?`,
"vue_label_report_onlydisplaypart":`Muestra 50 datos como máximo, se mostrarán todos los datos después de la ejecución`,
"label.up":`Arriba`,
"label.addattachment.edit":`Editar adjuntos`,
"label.ccchat.message.search.desc5":`Las palabras de búsqueda no puede ser menos de 2 caracteres`,
"label.chose.nonotice":`Seleccione primero los registros que ya no se recordará`,
"UG_activity_06":`Quiere seguir los clientes`,
"label.set_contactsmarketing":`Establecer como contacto de la campaña`,
"pagecreator.layout.button.horizontal":`Descomposición horizontal`,
"label.brief.opportunity2":`Oportunidades que se espera cerrar`,
"label.ems.nomsg":`No configurado`,
"label.fieldupdate.tip":`La actualización de campos le permite cambiar automáticamente el valor de algún campo a uno determinado. La actualización de campo es operaciones relacionadas con las reglas de flujo de trabajo y proceso de aprobación.`,
"label.sso.saml.sp.federationid":`Federación ID`,
"label.import.page2.suited":`Asignado`,
"message.error.appexchange.integrity":`?Asegúrese de la integridad de los componentes del paquete subido!`,
"label.fielddatatype":`Tipo de los datos del campo`,
"message.approval.cannotsubmit.detail2":`El registro actual debe satisfacer uno de los criterios siguientes o evaluar con fórmula como verdadero, o no se puede enviar para aprobar, modifique para reenviar. `,
"vue_label_commonobjects_detail_cloud_as_a_user":`Iniciar sesión en Nube de Socios como usuario`,
"label.summaryreport.selectlinetogroup":`Seleccione las columnas por las cuales se agrupa el informe`,
"label.tabpage.norecordtypez":`Tipo de registro no utilizable`,
"label.icon.141":`Moneda`,
"label.addattachment.step3.intruduce":`Si está cargando, esto cancelará la carga en progreso `,
"label.trigger.recursive.call.three":`Las activaciones se pueden llamar de forma interactiva, el número de ciclo se limita a 3 veces, si supere a 3 veces, el sistema se ocurrirá un mensaje de error.`,
"maintenanceplan.workorder.type.asset.workorder":`Elija "Una orden de trabajo por cada activo" como tipo de generación de orden de trabajo`,
"label.emailtocloudcc.select1":`Seleccione`,
"label.system.log":`Configuración del log de auditoría`,
"vue_homepage_dashboard_not_support_fullscreen":`Lo sentimos, su navegador no admite el uso de la pantalla completa`,
"label.projectManagement.nodata.resource":`No está participando en ningún proyecto. Añade la información de mis proyectos a los miembros para ver la asignación de tiempo de los miembros del equipo.`,
"label.exchange.sync.state.contact":`Contactos`,
"label.field.type":`Tipo del campo`,
"label.selected.object":`Objeto Seleccionado`,
"label.customfields.new.step2":`Paso 2: Ingrese los detalles`,
"label.monitorsys.delete.style":`Tipos de operación`,
"label.projectcondition":`Criterios`,
"potential.customers.field.default":`Ajustes por defecto del campo de clientes potenciales`,
"message.password.nosame":`Las contrase?as no coinciden, por favor intente de nuevo.`,
"label.validate.function.funcExplain.MONTH":`Regrese al mes, que es un número entre 1(enero) y 12(diciembre)`,
"label.project.user.project.count":`Número de proyectos en los que han participado los usuarios`,
"chatter.to":`A`,
"vue_label_commonobjects_detail_activity_owntask":`Tareas en propiedad`,
"label.generate.mobile.page":`Se ha generado la página móvil`,
"label.escalation.setup.newentries.step1":`Paso 1: Configure el orden para procesar los ítems de esta regla`,
"label.email_footer":`Pie de página del correo electrónico`,
"label_partner_workspace_member_profile":`Perfiles disponibles`,
"label.loginhis.between":`El intervalo entre la fecha de comienzo y la de finalización no excede 2 meses`,
"label.user.verficationcode.error":`El código de verificación es incorrecto`,
"label.email_notifications":`Enviar una notificación por correo electrónico de la presentación`,
"APPIntegration_Dropbox_01":`Seleccione archivos de Dropbox`,
"label.projectManagement.Selectweek":`Seleccione la semana`,
"wednesday":`miércoles`,
"message.atleastonereceiver":`Seleccione por lo menos un destinatario`,
"label.applt.link.text":`Hemos vinculado su empresa al mini programa del portal. Copie la dirección del portal del miniprograma dedicado a su empresa, coloque la dirección del miniprograma en el enlace de salto al menú de la cuenta oficial de su empresa, entonces los clientes pueden hacer clic en el menú para utilizar el miniprograma. (Menú personalizado de la cuenta oficial < Saltar al mini programa< Ruta del mini programa)`,
"label.wait.for.a.moment":`Por favor, espere un momento mientras ajusta el idioma...`,
"vue_label_chatter_only_group_members_look":`Sólo los miembros del grupo tienen acceso, puede tratar de solicitar para unirse al equipo`,
"label.knowledgebase.last.release":`Última publicación`,
"component.setup.label.pagesize":`Artículos por página`,
"label.paging.totalofpages":`Un total de {0} páginas`,
"label.globaloperation.successmessage":`Mensaje de éxito`,
"label.logout":`Cerrar sesión`,
"label.partner.common.enable":`Activar nube de socios`,
"label.permission.objectpermission.goback":`Regrese a la lista del conjunto de permiso`,
"label.approvalstep5.required":`Obligatorio`,
"component_chatter_label_to":`A`,
"message.please.choose.role":`Seleccione rol`,
"maintenanceasset.servicecontract.contractlineitem.illegal":`Debe seleccionar la partida del contrato de servicio asociada al plan de mantenimiento`,
"label.projectManagement.Resource.usage.view":`Vista de uso de recursos`,
"label.smsmainbody":`Texto del SMS`,
"label.ccchat.error.nullname":`El nombre no puede estar vacío`,
"label.appupload.upload.version":`Número de versión`,
"label.data.setok.t_desc2":`Regrese a la página de plantilla de datos`,
"vue_label_pool_allocationstatus":`Estado de la asignación`,
"label.tianyancha.orgapprovedinstitute":`Organización de aprobación`,
"label.quickbooks.searchlist.startdate":`Fecha de comienzo`,
"label.setapp":`Configuración de aplicaciones`,
"chatter.about":`Acerca de mí`,
"label.layoutname":`Nombre del dise?o de página`,
"label.icon.160":`Tierra`,
"label.tabpage.Rolesz":`Rol y subordinados`,
"label.console.step5.introduce":`Opte por cómo mostrar`,
"label.customfields.totalsummary.gettogetherfield":`Campo para agregar`,
"message.appexchange.addtopackage.profile":`?Solo se permite un componente de perfil en un paquete!`,
"vue_label_file_user_header_pic":`Icono`,
"font-trade-module-v1-invoice-detail-price":`Pagos detallados`,
"homepage.components.three":`Paso 3: Ingrese los contenidos mostrados de los componentes personalizados`,
"nine":`Nueve`,
"label.marketsea.button.restore":`Restaurar`,
"label.forecast.editshrepage.desc2":`Compartido individual sólo se puede utilizar para autorizar los permisos mayores a los datos, no para restringir el acceso`,
"label.cloudccsite.list":`Sitios`,
"label.icon.35":`Nube`,
"vue_label_pricebook_price":`Añadir precio estándar`,
"label.version.sum.addressfield":`Campo(s) de dirección`,
"label.projectManagement.Gotomilestone":`Ir a hitos`,
"label.dataimport.name.length":`Error: La longitud del nombre es demasiado larga.`,
"label_alculation_method":`Método de cálculo`,
"label.uploadfile":`Subir Archivo`,
"label.ems.otheraccount":`Otras cuentas`,
"vue_label_commonobjects_detail_group_opportunitystrategy":`¿Estás seguro de unirse a este Plan de Equipo?`,
"message.error.chatter.img.nodata":`?Error: el archivo de imagen no existe y no puede capturarse!`,
"component.chatter.file.button.files":`Seleccionar documento`,
"label.salescloud.teamrole.optionlist.choose.null":`El nombre de rol no puede estar vacío`,
"label.yourexportsuc":`Su solicitud de exportación ha sido procesado, revise su correo.`,
"pagecreator_systemstyle_label_modifycolor":`Editar color`,
"label_partner_setup_title":`Configuraciones`,
"label.chat.topic.topic":`Tema`,
"file.error.nottype":`?Error: Tipo inválido, los tipos que se pueden subir es txt, doc, excel, ppt, pdf, jpg, jpeg!`,
"label.all_time":`Todos los tiempos`,
"homepage_componet_approval_label":`Centro de aprobación`,
"label.partnerCloud.financeSetting.merchantNumber":`Número de comerciante de WeChat Pay`,
"label.user.resetpw":`Resetear contrase?a`,
"label.exchange.sync1":`Está?Microsoft??Exchange?Después de crear cuenta de servicio con permisos de simulación para los usuarios, introduzca el recibo de la cuenta de servico para permitir?CloudCC?Y?Exchange?Comunicación de servidor.`,
"label.import.index.editfield":`Editar la asignación de campos`,
"and":`Y`,
"label.partnerCloud.cloudInfrastructure":`Configuración básica de Partner Cloud`,
"label.escalation.setup.newentries.createdate":`De acuerdo con el tiempo creado del caso`,
"Pagelayout.Setup.002":`Ya ha seleccionado 3 listas relacionadas, si añade más listas puede afectar al diseño de la página`,
"label.customfields.file.tip":`Permiter al usuario subir fichero entre 1 y N`,
"label.tianyancha.businessverify.accname":`Búsqueda en tiempo real del nombre de cliente`,
"label.Additional.Conditions":`Filtrar citas de servicio según las condiciones adicionales`,
"label.emailtocloudcc.filed.type":`Tipo`,
"vue_label_homepage_fixedcomponents":`Componente estándar`,
"label.visualpage.delerror":`Cancelación fallada, intente de nuevo`,
"label.tabpage.filetypez":`Tipo de archivo`,
"label.emailobject.search.input":`Buscar`,
"label.createprocessstep2":`Paso 2 Especificar criterios de filtro`,
"label.weixin.inhead":`Procesando`,
"component.recdetail.label.title":`Información detallada`,
"label.weixin.telephone":`Número de móvil`,
"label.web.link":`Enlace web`,
"label.partnerCloud.paySuccess":`Pagado con éxito`,
"label.case.adress.link":`Portal de Atención al Cliente`,
"label.emailobject.view.connectopp":`Correos electrónicos relacionados con las oportunidades abiertas`,
"front-kefu-moudle-think-again":`Déjeme pensar de nuevo`,
"label.Button":`Botón`,
"chatter.pt.most":`El tama?o máximo del fichero es 20 MB.`,
"label.service.newBuildDialog.numberdays.horizontal":`Días antes de la fecha horizontal`,
"label.ems.relatedobj":`Vincular al objeto`,
"label.notification.insert.approval":`[提交人] presenta [对象] para su aprobación`,
"label.setting.codeSet":`Conjunto de códigos`,
"vue_label_report_rowlevelformula":`Fórmula a nivel de fila`,
"label.validate.function.funcFormat.TIMENOW":`TIMENOW()`,
"label.copyright":`?Los derchos de autor? 2008-2022 CloudCC Inc. Todos los derechos reservados. Contacto al Servicio: 400-642-2008`,
"component.setup.button.save":`Guardar`,
"label.emailsync.button.sure":`Confirmar`,
"label.multilang.dupicatecheck.getdatalist":`Los datos del grupo{0}se duplican, hay un total de {0}registros`,
"label.ccchat.person.invite.tochat":`Invite a los colegas a CCChatter`,
"label_partner_all_maxNum":`Dato máximo de Nube de socios`,
"label.checkfield":`Campos de configuración de encontrar duplicados`,
"label.sales.dashboard.income":`Objetivo de ingreso`,
"label.setup":`Configurar`,
"label.dashboardSetup.center":`Medio`,
"lable.quote.syncing.finished":`Sync completada`,
"vue_label_helpcenter_dashboard1":`Con el fin de ayudarle a mostrar los datos de manera más intuitiva, el cuadro de mandos de CloudCC Sales Cloud Lightning le proporciona potentes herramientas de elaboración de gráficos.<br> El cuadro de mandos del CloudCC Sales Cloud versión Lightning tiene las siguientes características<br>Puede utilizar diferentes fuentes de datos: puede seleccionar los datos originales en una vista bajo el objeto como fuente de datos, o puede seleccionar los datos procesados del informe como fuente de datos<br>Hasta 13 tipos de plantillas de gráficos a su elección: embudo de ventas, medidores, gráfico circular, histograma agrupado secundario, etc. <br> Arrastre libremente para cambiar el tamaño y la posición del gráfico: el cuadro de mandos puede distinguir los datos importantes y los datos auxiliares mediante la disposición y el tamaño de los diferentes gráficos establecidos a su gusto. <br> <br>Filtro general del cuadro de mandos: El cuadro de mandos admite el filtrado de los datos del gráfico incorporado mediante campos de filtro establecidos por rango de tiempo y usuario<br>Almacenamiento de datos en caché: los datos del gráfico del cuadro de mandos se pueden almacenar en caché cuando se crean por primera vez, lo que reduce el tiempo de carga secundaria. <br>Penetración de componentes: Se puede saltar a los detalles del informe correspondiente o a la lista de registros en la vista correspondiente del objeto haciendo clic en el componente<br>Vinculación de componentes: En el mismo cuadro de mando, un componente puede configurar otros componentes de la misma fuente de datos para que interactúen consigo mismo. Haciendo clic en el área de datos del componente, se pueden configurar otros componentes para que vuelvan contabilizar los datos según las condiciones de filtrado de esta área de datos<br> 1. Crear un nuevo cuadro de mando<br> Como representante de ventas o gerente del departamento de ventas, puede mostrar sus datos de ventas haciendo cuadros de mando. La versión Lightning de CloudCC Sales Cloud proporciona amplios recursos para crear cuadros de mando<br>Nota: Los datos de la versión Lightning del cuadro de mando y la versión antigua del cuadro de mando no son interoperables. <br> Haga clic en la pestaña "Cuadro de mando", haga clic en "Nuevo cuadro de mando", rellene el nombre del cuadro de mando y seleccione la carpeta en la que desea guardar este cuadro de mando y podrá introducir un nuevo cuadro de mando.`,
"label.layout.availabletab.trackrecord":`Seguir registros`,
"label.campaignmember.main.deletecontact":`Cancelar Miembros-Contactos existentes`,
"lable.outlook.mcto.emaltoc":`Cuando los correos fueron enviados a CloudCC.com`,
"label.setup.mobile.offlinecache.savesuccess":`Configuración de caché fuera de línea ha sido guardada con éxito.`,
"label.timezone.default":`Zona horaria predeterminada`,
"label.noRules.have.been.enabled":`No hay reglas habilitadas.`,
"label.ccchat.person.invite.existsend":`Algunas direcciones de correo coinciden con los usuarios existentes.`,
"label.work":`Trabajo`,
"actualstarttime.actualendtime.time.illegal":`La hora real de inicio de la cita de servicio debe ser menor o igual a la hora real de finalización.`,
"lable.product.stsp":`Configurar precio estándar`,
"vue_label_normal_account_sf":`Cliente`,
"label.finishpic":`Gráfico generado`,
"label.h5.similar.opportunity.step3":`Paso 3. Seleccione los campos mostrados para las oportunidades similares`,
"label.relateobjDefault":`Registro por defecto`,
"label.customcomponent.check.tag.endwith":`Los componentes deben acabar con la etiqueta &lt;/cc:componente&gt;.`,
"label.related.organization":`Oportunidad relacionada`,
"label.recordtype.edit.selectvalue.orderby":`Orden del valor de lista de opciones`,
"vue_label_homepage_enter_name":`Introduzca el nombre`,
"label.permission.group":`Grupo de permisos`,
"label.emailobject.send":`Enviar`,
"label.ralateuser":`Usuarios relacionados`,
"label.validate.function.funcFormat.ADDMONTHS":`ADDMONTHS(date,num)`,
"label.tablayoutedit.remark2":`Seleccione los campos que se van a mostrar en la página oficial`,
"setup_mainpage_label_welcome3":`La creación de formulario en la plataforma de nube CloudCC depende de la base de datos personalizada (Objeto), los objetos definidos por usuario son formularios de la base de datos que se utiliza para guardar los datos específicos para su organización. La relación entre los formularios se puede establecer sin desarrollo de programación.`,
"label.user.notallowed.login.scope":`No le permiten ingresar fuera del plazo establecido o su IP está restringida.`,
"label.tel.ten.case":`Ingrese hasta 10 números de móvil para recibir notificaciones, cada número se separa por coma`,
"front-kefu-moudle-v1-user-info":`Información del usuario`,
"label.aboutme":`Acerca de mí`,
"label.setfieldediting.tip":`Al definir los pasos de aprobación, puede asignar solicitud a usuarios diferentes. Una de las opciones es para asignar automáticamente solicitud utilizando los campos de usuario. Si usa esta opción en cualquier paso del proceso de aprobación, seleccione un campo de la lista de opciones siguiente. Además, durante el proceso de aprobación, siempre está bloqueado--Solo los administradores pueden editar. Pero, puede dar permiso al aprobador actualmente asignado para editar este registro`,
"label.existing_dashboard":`Añadir al cuadro de mandos existente`,
"label.sendemail.spotsign":`Estimado #name: el miembro de campa?a#customer ha invitado a  #activity llegó y firmó, que se entere.`,
"UG_solution_01":`Proporcionar la solución`,
"label.tianyancha.estiblishtime":`Hora de establecimiento`,
"label.pc.lightningpage":`Aplicación ligera (Beta)`,
"label.saveAndSync":`Guardar y sincronizar`,
"label.state.end":`Completado`,
"label.sendemail.queue.assigninfo":`Cola: [#queueName] ha asignado #objectName: #recordName`,
"label.approvalprocessname":`Nombre del proceso de aprobación`,
"label.view.conditions.message":`Filtrado por {!conditions}`,
"label.partnerCloud.financeSetting.alipayCorporate":`Cuenta comercial de Alipay`,
"label.forecast.detailforecast.de":`De`,
"label.savepayset.failure.nopay":`Configure al menos una cuenta de pago en línea`,
"label.step1.total6":`Paso 1 de 6`,
"label.appointment.wizard.subtitle4-1-3":`45 minutos`,
"label.emailobject.markasread":`Marcar como leído`,
"message.error.orgid.null":`orgid no puede estar vacío`,
"label.emailtemplate.mergefield":`Valor de campo combinado`,
"label.weixin.recent.list":`Listas recientemente vistas`,
"label.emailsync.form.email":`Correo electrónico`,
"label.funnel":`Embudo`,
"label.logintime.clear":`Limpiar el tiempo`,
"label.chatter.followed":`Seguidos`,
"label.ccpeak.function.field.spack":`Campos de la función debe tener espacio en ambos lados.`,
"label.setup.mobile.offlinecache.remark":`Al activar esta función, los miembros dentro de la organización pueden crear, ver, editar y cancelar los registros sin internet con la aplicación móvil`,
"label.product.function":`Categorías de paquetes`,
"label.icon.14":`Martillo`,
"message.report.nodata":`No hay datos para regresar`,
"label.please.ChooseMin":`Por favor, elija al menos {a} opciones de productos`,
"label.tabpage.releaseTourz":`Publicar guía`,
"vue_label_chat_opportunity":`Plan de equipo de oportunidades`,
"vue_label_chatter_refucecertification":`¿Está seguro de rechazar la solicitud de entrada al equipo de "{name}"?`,
"label.version.unlimited":`Ilimitado`,
"label.processsetting.enable.prompt":`Una vez habilitada, la ruta de acceso a los ajustes estará en la página de detalles correspondiente a la versión Lightning. También puede guardar los ajustes primero y habilitarlos más tarde.`,
"label.page.display.property":`Mostrar las propiedades`,
"label.service.appointmentList.thisOption":`No marcado`,
"label.register.date":`Fecha de registro`,
"label.brief.contract.amount":`Importe del Contrato`,
"setup.object.field.dependency.label.actionfieldnotnull":`Seleccione primero un valor del campo de control para configurarlo`,
"UG_homepage_009":`Acceso a CRM`,
"label.icon.98":`Carpeta`,
"label.weixin.datacount":`Total`,
"label.mobile.hasbind":`Este número de móvil ha sido utilizado. La última vinculación se liberará si se sigue vinculando.`,
"label.emailtemplate.choosemorecontacts":`Seleccione más destinatarios`,
"setup_layout_button_deleteitem":`Remover ítems seleccionados`,
"vue_label_account_collection_plan":`Plan de cobro sin procesar`,
"label_chatter_maturiyDate":`Fecha de vencimiento`,
"label.emailtocloudcc.license":`Licencia`,
"vue_label_checkduplicate_complete_check_rules":`Complete las reglas de comprobación de duplicados`,
"chatter.up.type":`Puede subir documento en formato jpg, gif, o png.`,
"label.attendance.nocheckout":`No check-out`,
"label.setup.mobile.offlinecache.remark2":`Los menús seleccionados serán activados en el dispositivo móvil de todos los usuarios en su organización como el menú predeterminado de caché fuera de línea. Cada usuario puede cerrar la configuración de organización del menú de caché fuera de línea, o activar otros menús como el menú de caché fuera de línea dependiendo sus necesidades`,
"template.report.count.marketing.activities":`Campaña total`,
"label.multilingual.tip4":`Si se desactiva el multilingüismo, el idioma por defecto de la empresa se establecerá en chino o en inglés en función de la dirección de la empresa, y el idioma de todos los usuarios se establece en el idioma por defecto de la empresa.`,
"label.settings_area":`Área de configuración`,
"label_assessment_content":`Contenido de la evaluación`,
"label.top":`Cima`,
"UG.Account.06":`Crear un cliente`,
"label.emailtocloudcc.step1.case2":`Una vez configurado, se generarán los casos de los correos recibidos en este correo. De acuerdo con el remitente, se emparejarán los contactos y los clientes, y se asignarán los casos a los clientes y contactos correspondiente para facilitar la aceptación y el seguimiento de los casos.`,
"label.forecast.forehistory.best.remark":`Mejor nota del caso`,
"label.project.problem.date":`La fecha del problema debe estar dentro del rango de fechas del hito o proyecto al que pertenece`,
"label.forecast.customforecast.foredis.wzs":`Números completados`,
"message.setup.field.name.value.notexists":`?El valor de lista del rol de grupo que ha ingresado no existe, introduzca de nuevo!`,
"label.salescloud.teamrole.opportunity.organization":`Los miembros del grupo tendrán un mayor nivel de acceso a esta oportunidad que la configuración del acceso a la oportunidad predeterminada de parte de su organización`,
"label.sms.message.input":`Ingrese el mensaje`,
"label.document.type.not.allow":`Este tipo de documento no se puede cargar.`,
"label.customfields.totalsummary.tip":`Un campo de solo lectura que muestra la suma, el valor mínimo o máximo de un campo en una lista relacionada o todos los registros enumerados en una lista relacionada.`,
"label.tabpage.filesizez":`Tamaño del archivo`,
"label.import.page2.filedname":`Nombre del archivo`,
"label.same.analyze":`Mi análisis de oportunidad similar`,
"label.service.gantt.refreshData":`Actualizar los datos después de refrescar la página.`,
"label.sendsms.batch.step2.sendbycontext":`Enviar según los contenidos personalizado de SMS`,
"UG_Account_05":`Gráfico de estructura de contactos`,
"label_emailtocloudcc_step1total3":`Paso 1 de 3`,
"label.weixin.no.history":`No hay registros de historial`,
"label.datamanage.queryfield.error":`Error de la búsqueda del campo`,
"label.emailmerge.mergeFolder.emailmerge":`Fusión de plantilla de correo`,
"label.workflow.estimatecondition":`Criterios de Evaluación`,
"label.autonumberfield.wrong":`Por favor, introduzca un número entre 0-{0}`,
"label.data.setok.t.desc1":`Haga clic si desea exportar los datos según esta plantilla`,
"label.data.downpage.i.title":`Instrucciones para la importación de datos:`,
"label.data.downpage.i_list.desc2":`Al importar los datos, recibirá un correo para recordarle si ha importado con éxito.`,
"label.opportunity.jieduan":`Etapa actual`,
"vue_label_commonobjects_view_sumby":`Modo de resumen`,
"label.knowledge.setting.hint.three":`Podemos prepararte para la operación. Esto es lo que necesitas para la instalación:`,
"page.activity.history":`Historial de eventos`,
"label.cancelQuoteLineGroup":`Anular el grupo de líneas de oferta`,
"label.addattachment.batch.step3":`Paso 3: Haga clic en el botón ¨Completar¨ y regrese a la página anterior`,
"label.chat.topic.follow":`Seguir`,
"label.import.page1.uploadcsvfiled":`Arrastre o haga clic para cargar el archivo CSV`,
"label.batchtransfer.datetype.tip":`En cuanto al campo de fecha, ingrese el valor con el formato siguiente:`,
"vue_label_systemSettings_application_util":`Consola de gestión de aplicaciones`,
"label.partner.workspace.member.selectedpermission":`Conjunto de permiso seleccionado`,
"label.service.appointmentList.plansToEnd":`Fin de plan`,
"label.industrialandcommercialverification.contactinformation":`Compra o consulta, contacte a 400-642-2008`,
"chatter.del.p":`Cancelar esta publicación`,
"label.forecast.customforecast.replacefirst":`Mi prioridad`,
"Lead.Scoring.Setting.Rule.Setup.RuleName":`Nombre de la regla de puntuación`,
"label.weixin.appr.applicant":`Iniciado por`,
"component_event_label_calendar":`Ver calendario`,
"step":`Paso`,
"label.attendance.setting.position.alert":`El trabajador de oficina debe configurar ubicación del punto de referencia`,
"label.end":`Completado`,
"label.mobile.change.owner.success":`Se ha cambiado al propietario nuevo`,
"label.chinese":`Chino`,
"label.textmessage.vonage.account":`Información de la cuenta`,
"front-console-no-related-contact":`Por favor, asociarse con el contacto primero`,
"label.dashboardSetup.seltype":`Tipo de componente seleccionable`,
"chatter.follow.user":`Seguir a este usuario`,
"label.textmessage.sentsuccess":`Enviado con éxito`,
"label.australian.gentral.standard.time":`Horario de Verano Central (Australia del Sur)`,
"label.validate.function.funcFormat.AND":`AND(logical1,logical2,...)`,
"lable.SalesCommitmentKanBan.contract":`Firmado`,
"label.processsetting.basic.settings":`Configuración básica`,
"label.escalation.setup.newentries.ifcondtions":`Correrá esta regla si`,
"label.lookup.nofound.data":`El valor no existe o no coincide con los criterios de filtro.`,
"vue_label_commonobjects_view_chart_chartname":`Nombre del gráfico`,
"label.dashboard.show.percent":`Mostrar %`,
"label.sso.saml.sp.userid":`Usuario ID`,
"label_tabpage_minutesagoz":`minutos`,
"vue_label_chatter_comment_content":`Introduzca el contenido del comentario`,
"label.campaign.channel.step6.mobilepc":`Generar Página PC y Página Móvil`,
"vue_label_homepage_editprofilepage":`Editar nombre`,
"label.tabpage.crecordtypez":`Cambiar el tipo de registro`,
"label.social.posts.type.null":`El tipo de puesto no puede estar vacío`,
"label.projectManagement.groupbyuser":`Agrupar por usuarios`,
"vue_label_email_new_template":`Guardar como nueva plantilla`,
"label.ems.close":`Cancelar`,
"label.ccdocument.noauthority.folder":`?No tiene permiso para operar esta carpeta!`,
"message.filterconditionerror":`<strong>Error: </strong> Su filtro ha referenciado a las condiciones de filtro incorrecta:`,
"label.User.Interface":`Interfaz de usuario`,
"label_tabpage_greaterz":`Mayor que`,
"vue_label_CCChat_unfollow":`Dejar de seguir`,
"label.selectandcontinue":`Seleccione y continue`,
"vue_label_commonobjects_detail_influence":`Influencia`,
"label.total.have.priority":`Es prioridad`,
"label.manageAll.sta4":`Recordar`,
"label.setup.mobile.offlinecache.setup":`Configuración de caché sin conexión de móvil`,
"vue_label_chatter_cancel_adding":`Cancelar añadir`,
"vue_label_lead_select_existing":`Seleccione los existentes`,
"front-epwechat-module-v1-contacts-sync":`Sincronizar contactos de WeCom`,
"label.appupload.component.type.recordtype":`Tipos de registro`,
"label.layout.hint":`Esta página no está disponible para la vista previa. Por favor, guarde y vea la página en primer plano.`,
"label.change":`Cambiar`,
"setup_layout_label_detailpage":`Página detallada`,
"label.imgfield.use.tip":`img(docid,width,height), esta función es utilizada para exportar imagen, "docid" es documento ID, "width" configura ancho de la imagen(El tipo de Integer puede ser nulo), "height" configura altura de imagen (El tipo de Integer puede ser nulo).`,
"pagecreator.systemstyle.button.edit":`Editar diseño`,
"label.delete_externalpage":`El ' ' que desea eliminar no puede ser retirado, por favor confirme de nuevo. El formulario no se utiliza en ninguna página de inicio de sesión, pero puede utilizarse en otros lugares. Por ejemplo, puede haber utilizado el código de inserción para insertarlo en una página externa.`,
"font-evaluate-module-v1-open-case":`Reabrir el caso:`,
"label_not_adjust":`Sin ajustes`,
"vue_label_title_ordernow":`Pedir ahora`,
"label.notification.serviceappointment.allocation":`Se le ha enviado una nueva orden de trabajo {0}, por favor revísela.`,
"label.objectRelationshipDescription2":`. Puede definir qué registros relacionados de otros objetos regresarán al resultado de informe a través de seleccionar un objeto que tiene relación con el otro.`,
"vue_label_calendar_notice_createfail":`Error al crear calendario`,
"label.ems.step1":`Paso 1`,
"label.ems.password":`Contrase?a`,
"label.icon.143":`Hucha`,
"label.select.year":`Seleccione el año`,
"label.termsforusage.dialog":`?tems de uso(Nueva pesta?a)`,
"label.tag.addtags.create":`Crear`,
"label.emailobject.groupemail.msg4":`Sin la dirección del correo, no se puede enviar al destinatarios`,
"label.version.sum.autonumberfield":`Campo de auto número`,
"label.projectManagement.unallocated.time":`Tiempo no asignado`,
"PageLayout.Search.MultiSearch.002":`Mostrar el campo de búsqueda (búsqueda de un solo campo)`,
"label.icon.150":`VR`,
"label.SMS.edit":`Notificación de Editar via SMS`,
"Opportunity.Detailed.Phase.Label.003":`Cambiar fase`,
"vue_label_helpcenter_all":`1. Búsqueda general<br> La búsqueda general es una herramienta que le ayuda a encontrar rápidamente lo que necesita. <br> <br>Introduzca palabras clave en el cuadro de entrada de búsqueda en la barra de navegación en la parte superior de la página. Cuando escribe el contenido, el sistema le recomendará contenido relevante en tiempo real de acuerdo con el contenido introducido; <br>Haga clic en "Buscar" o pulse directamente la tecla Enter del teclado para abrir la página de resultados de la búsqueda; <br>En la página de resultados, puede filtrar el objeto de la izquierda para ver la lista de resultados de la búsqueda bajo ese objeto. En la lista de resultados se le recomendarán hasta 10 registros. Puede hacer clic en "Ver más" para entrar en la página de la lista de este objeto para ver más resultados de búsqueda; <br>Nota: El sistema busca por defecto en "oferta", "cliente", "cliente potencial", "oportunidad de negocio", "campaña", "contrato", "producto", "solicitud de servicio", "tarea" y "evento". <br> 2. Crear rápidamente<br> Haga clic en " " en la barra de navegación, y podrá seleccionar el objeto que desee crear en la ventana desplegable. <br> 3. Centro personal<br> Haga clic en el icono en el lado derecho de la barra de navegación para abrir la ventana del Centro personal. Se ofrecen las siguientes funciones: <br> Entrada rápida en la página de configuración personal, importación por lotes y entrada a la papelera; <br> <br>Si se encuentra en el periodo de prueba, haga clic en "Pedir ahora" para entrar rápidamente en la página de pedidos de Cloud CC; <br> Haga clic en una versión para cambiar rápidamente; <br> Cerrar sesión. <br> 4. Menú<br> En la barra de menús se le proponen una serie de objetos de menú, y puede hacer clic en un menú para ir rápidamente a la página correspondiente. También puede ver todos los menús y configurar los menús más utilizados para que aparezcan en la barra de menús. <br> Todos los menús: haga clic en "Más" y en "Todos los menús" en la parte inferior del cuadro desplegable; <br>Personalizar mi menú: Haga clic en el botón de la derecha del menú para abrir la ventana del menú personalizado, y establezca el menú común que quiera mostrar en la barra de menú en “Todos los menús”. <br>5. Centro de activación de aplicaciones<br> Haga clic en el icono de la derecha de la barra de menús para cambiar rápidamente a otros servicios de aplicaciones configurados para usted por el administrador del sistema. <br>Nota: Las aplicaciones son un conjunto de módulos funcionales (como la gestión de clientes potenciales, las oportunidades de negocio, la gestión de contratos, etc.) que pueden utilizarse para satisfacer necesidades empresariales específicas.`,
"label.summaryreport.2018.step5.new":`Paso 5: Seleccione criterios de informe`,
"label.weixin.id":`Número`,
"chatter.pu.mess":`Publicación(es) y comentario(s)`,
"label.weixin.lookup.record":`Encontrar registros`,
"label.ServiceCloud.statistics.by.address":`Estadísticas por dirección`,
"label.jixiaoswitchoff":`Colapso`,
"label.savealipay.failure":`No se ha podido guardar la información de la cuenta de pago de Alipay`,
"template.chart.khdqfb":`Cuentas Distribución regional`,
"front-email-payment-immediate-payment":`Pagar ahora`,
"label.dashboard.unit5":`Unidad: 100 millones`,
"label.tabpage.greaterz":`Mayor que`,
"vue_label_calendar_stop_sharing_calendar":`Dejar de compartir calendario`,
"label.projectManagement.allhours":`Todo (horas)`,
"label.currency":`Moneda`,
"label_vue_create_edit_obj_create_event_dialog_title":`Recordatorio de horarios repetitivos`,
"front-template-V1-templateSetting":`Configuración de la plantilla`,
"label.dashboard.away.condition":`Condición de colapso`,
"label.replacelayout":`Reemplazar el dise?o de página`,
"label.permission.detail.system.setting.tip":`Ejecutar aplicación a las apps. Por ejemplo: modificar permiso de todos los datos`,
"label.customfield.delete.prompt":`Etiqueta del campo personalizada`,
"label.add":`Añadir`,
"label.deputationalsoapprove":`Los agentes delegados también pueden aprobar esta solicitud`,
"label.leave_nosave":`Después de salir, los datos actuales no se guardarán.`,
"label.tianyancha.title":`Tian Yancha`,
"vue_label_pool_restore":`Restaurar`,
"chatter.feed.menutype.feed.markcom":`Miscro-publicaciones a favoritos`,
"label.query.data.error":`Se ocurrió error al consultar las listas relacionadas`,
"label.pc.ui.2018.unpin":`Desanclar`,
"label.partner.template.memo":`Descripción breve`,
"label.weixin.cannot.gain.userinformation":`No puede obtener información de usuario`,
"label.stdashbord.xsld.department":`Departamento`,
"label.service.ganttBaiduMap.scheduled.starttime":`Hora de inicio prevista`,
"label.documentforms":`Documentos`,
"label.operator.insert":`Insertar operador`,
"label.processsetting.select.five.fields":`Se pueden seleccionar hasta 5 campos`,
"label.weixin.password":`Contrase?a`,
"vue_label_chatter_share_followers":`Compartir con los seguidores`,
"label.brief.baifang":`Visitas`,
"label.emailobject.track.unopen":`No abierto`,
"label.sendmail.immediately":`Enviar ahora`,
"label.partnerCloud.payTheAmount":`Importe del pago`,
"label.integrations.mailchimp.connect":`Conecta CloudCC con su cuenta`,
"label.datamove.record.sucessfully":`?registro(s) ha(n) sido transferido con éxito!`,
"lable.outlook.edit.allocation":`Asignar usuarios y perfiles`,
"label.chosesubject.talk":`Programar una charla`,
"label.escalation.setup.entrydetail.escalation.time":`Tiempo de actualización`,
"label.projectManagement.must.be.less.than.24.hours":`Debe ser menor de 24 horas`,
"setup_mainpage_label_welcome15":`Las reglas del flujo de trabajo de CloudCC realizan el proceso automático de su venta, marketing y más. De acuerdo con el conjunto de reglas previamente definidas, los registros pueden ser asignados automáticamente a los usuarios o convertir de un usuario a otro. La ventaja principal de la gestión del flujo de trabajo consiste en mejorar la eficiencia del trabajo eliminando muchas operaciones innecesarias al renovar los registros, elevar el nivel de procedimiento comercial y optimizar el proceso de control via Método de trabajo estandarizado y reducción del costo de operación. Permite las aprobaciones libres de nivel para cualquier objeto y al mismo tiempo activar el recordatorio del correo, SMS, recordatorio de SMS, tarea, actualización del campo y otras funciones.`,
"label.mobile.phone.week.plan2":`Plan de esta semana`,
"label.add.newAsset":`Activo nuevo`,
"vue_label_salesadvance_losts":`Número de pérdidas`,
"vue_label_report_editcolumn":`Editar Columna`,
"vue_label_homepage_assignedtasks":`Tareas asignadas`,
"label.posting_from":`Publicado por`,
"year":`A?o`,
"label.autoRegister.changepwd.setpwd.tip.letter":`Hay por lo menos una letra`,
"label.version.nonsupport.feature.staticresource":`?Esta función no está disponible. Espere la actualización antes del uso!`,
"label.toleadmyclientandlinkman":`Importar mis clientes y contactos`,
"label.appupload.install.processcrash":`Tratar los conflictos`,
"label.profile.setstandardtab":`Configuración de menú estándar`,
"template.chart.khhyfx":`Análisis del sector de las cuentas`,
"label.reportTypcrtC":`Objeto asociado(C) Haga clic en seleccionar objeto relacionado`,
"vue_label_report_mayormaynothave":`El objeto superior puede o no tener registros relacionados con este objeto`,
"label.service.gantt.plan.recommendation":`Plan recomendado`,
"label.version.sum.lookupfield":`Campos de búsqueda`,
"label.builder":`Constructor de páginas`,
"label.sharerule.remark":`Especifique el compartido de este registro. Puede compartir los registros y dato relacionado con usuarios, roles, roles y subordinados, usuarios en un territorio, usuarios en un territorio y sub territorio. Compartido individual solo se puede utilizar para otorgar un acceso más amplio a los datos, no para restringir el acceso.`,
"vue_label_email_benn_added":`Se ha añadido este correo`,
"label.version.allow.sum":`, ha alcanzado al límite. Si necesita, actualice CloudCC a la última versión.`,
"label.icon.130":`Moneda`,
"label.custom.new":`Nuevo`,
"label.see_allfields":`Ver todos los campos`,
"front-marketing-module-v1-share-poster":`Compartir cartel`,
"label.service.one":`Su filtro hace referencia a un filtro indefinido:`,
"lable.outlook.edit.alprec":`Siempre preferido CloudCC.com`,
"Account_News_Setting_001":`Configuración de cliente`,
"label.mr.caption.opportunity.result":`Encontrar duplicados y fusionar: Resultados para encontrar duplicados de oportunidad`,
"label.forbidden":`Prohibir`,
"label.query.detail.openpartner":`Activar como socio`,
"label.session_date":`Fecha de la sesión`,
"label.forecast.customforecast.submit.deyuce":`Previsiones de`,
"label.emailtocloudcc.filed.server":`Servidor`,
"label.emailtocloudcc.tip2":`Después de eliminar, no podrá utilizar la función Email to CloudCC, ¿está seguro de que quiere eliminar?`,
"pagecreator_layout_message_delete_fail":`Cancelación fallada del dise?o`,
"front-lightning-module-v1-dashborad-export-PDF":`Exportar PDF`,
"lable.quote.syncing.syncingto":`Los detalles de cotización han sido sincronizados con los productos de oportunidad.`,
"message.error.view.lastview.update":`No se puede cancelar la úlitma vista de lista pública </br> No puede cambiar la visibilidad de la última vista de lista pública de ¨Visible para todos los usuarios¨ a ¨Visible sólo para mí¨</br></br>`,
"label.weixin.select.one":`Seleccionar uno al menos`,
"label.projectManagement.Pleaseenterprojectname":`Por favor, introduzca el nombre del proyecto...`,
"label.data.downpage.e_list.desc1":`Está página muestra los datos exportados con éxito, descargue los archivos exportados a tiempo de acuerdo con el enlace de descarga en su correo.`,
"label_tabpage_notexceed25":`El registro seleccionado no puede exceder 25`,
"label.campaign.channel.step5.remark":`Ha finalizado la configuración de la página de registro`,
"label.setup.mobile.bottombutton.profile.prompt":`Consejos: el menú inferior personalizado del perfil anulará los ajustes unificados del menú inferior de la empresa`,
"label.stdashbord.xsld.business.knx":`Probabilidad`,
"label.setemailtip":`Cree un aviso de correo para asociarlo con uno o más reglas del flujo de trabajo o proceso de permiso. Si cambie el aviso del correo, cualquier modificación se aplicará a todas las reglas o permisos asociados con el.`,
"report.button.go":`Ir`,
"lable.the.united.arab.emirates":`Los registros han sido reclamados`,
"label.writer. name.file":`Por favor, introduzca el nombre del archivo de cotización`,
"label.validate.function.funcExplain.ADDMONTHS":`Devuelve una nueva fecha según el date (campo de fecha) introducido sumándole el num (meses). Devuelve el número de días de un mes como la nueva fecha del último día del mes actual si el número de días del mes original es igual al último día del mes actual o el número de días del mes de la nueva fecha es menor que el del mes original.`,
"vue_label_chatter_enter_shared_content":`Introduzca el contenido compartido`,
"message.lookup.condition":`Los criterios de búsqueda debe introducir más de un carácter`,
"vue_label_commonobjects_detail_customers":`Desactivar permanentemente los clientes de usuarios externos desactivarán a todos los usuarios externos asociados al cliente y los eliminarán de todas las comunidades, grupos, equipos, conjuntos de permisos y reglas de compartición asociados a ellos. Al mismo tiempo, los roles y grupos asociados a la cuenta se eliminarán de forma permanente y no aparecerán en la papelera. ¿Está usted seguro de querer seguir?`,
"label.emailobject.view.all":`Todos los correos`,
"vue_label_file_size_limit_new":`Carga fallida, el archivo adjunto supera los {size}MB`,
"front-gantt-module-please-reorder-milestones":`Por favor, introduzca un número válido para reordenar los hitos`,
"label.escalation.setup.entrydetail.escalation.assingTemplate":`Correo`,
"label.namespaceprefix":`Prefijo del espacio de nombre`,
"label.ems.delete.success":`Se ha cancelado con éxito`,
"label.partnerCloud.financeSetting.setWechatPay":`Configurar WeChat Pay`,
"front-epwechat-module-v1-input-token":`Por favor, introduzca la ficha`,
"setup_object_field_dependency_button_setdependency":`Configurar la dependencia de campo`,
"chatter.group.request01":`Solicitud(es)`,
"message.error.field.number.length":`El formato de longitud es incorrecto`,
"label.tabpage.lessz":`Menos de`,
"vue_label_notice_uploadavatar_format":`Solo se admiten imágenes en formato JPG/PNG/GIF como icono`,
"label.project.hit.thirteen":`Recordatorio de hitos diarios`,
"frame_personinfo_label_usethisimage":`Utilizaremos variaciones de esta imagen en miniatura alrededor de la aplicación.`,
"label.startuploadfile.step":`O los mensajes no subidos con éxito se mostrarán en la área superior, si necesita removerla, seleccione un nuevo fichero`,
"component_assistant_label_overduetask":`Oportunidades con tareas atrasadas`,
"label.partnerCloud.financeSetting.information":`¿Cómo configurar la información de suscripción de Alipay?`,
"label.appupload.install.package.component":`Componentes de paquete`,
"label.emailobject.emaildetail.nextactivity.task":`Añadir tarea`,
"vue_label_chatter_edit_post":`Editar el puesto`,
"label.appupload.upload.logo":`?cono`,
"label.role.selecteduser":`Usuarios seleccionados`,
"label.letter.assign":`Especifique los contenidos de invitación`,
"label.forecast.shrepage.title":`Información detallada del compartido de previsiones`,
"lable.Generate.service.appointment":`Citas de servicio generadas por la partida de la orden de trabajo`,
"label.productsales.nodata":`No hay datos`,
"vue_label_email_Please_select_at_least_one_email":`Seleccione al menos un correo electrónico`,
"label.data.downpage.i_title.num4":`4. Si tiene un campo de búsqueda o de relación máster-detalle en el objeto que quiere importar, el valor de este campo deber ser ID, de lo contrario, no es inválido.`,
"label.new.exchagecurrency":`Tasa de cambio nueva`,
"label.layout.listtip":`La tabla siguiente muestra la asignación del dise?o de página para perfiles diferentes`,
"label.icon.2":`Billetera`,
"label.chat.topic.delete.prompt3":`?Está seguro de que quiere cancelar el tema?`,
"UG_Lead_008":`Código de escaneo de la tarjeta de negocio`,
"label.multilang.databatchadd.fail":`Agregación de {0} datos fallada`,
"front-kefu-moudle-v1-chzx-confirm":`¿Está seguro de que quiere eliminar el agente?`,
"label.import.page1.matchlabel":`Coincidir con {{$store.state.labelName}}`,
"label.dashboardSetup.showdw.d3":`Millón`,
"label.version.ifnecessary":`Si es necesario, actulice a la versión CloudCC.`,
"label.confirm.delete.default.tab":`?Está seguro de que quiere cancelar el inicio de sesión predeterminado`,
"label.emailtemplate.mergefields.tip":`Cuando los usuarios editan los contenidos del correo, pueden añadir los campos combinados para reemplazar los textos en el correo. Una vez enviado el correo, el sistema los reemplazará con los textos. Por ejemplo, {!Contact.name} en su correo convertirá en el nombre del contrato.`,
"vue_label_chatter_decline_members_join":`Rechazar solicitud de entrada`,
"label.role.no":`No roles`,
"label.service.gantt.resources":`recursos`,
"label.knowledge.language.simplified":`Chino simplificado`,
"label.eidt.queue.length.cannot.than":`La longitud del nombre no puede exceder 50 caracteres`,
"label.mobile.quickcreate.default.tasks":`Tareas`,
"label.discount.yuan":`Descuento (yuanes)`,
"message.error.delete.pending":`El registro está en el proceso de permiso, no se puede cancelar <br>Haga clic en <a href='javascript:history.back();'>Aquí</a> para regresar`,
"chatter.show.mostnews":`Mostrar más informaciones`,
"label.optionlist":`Lista de opciones`,
"template.chart.cpdj":`Precios de los productos`,
"label.user.usernamepassword.error":`Revise su nombre de usuario y contrase?a`,
"label.file.sharetype.check":`Visitante`,
"label.completed.generated.page":`Se ha generado la página web de ordenador`,
"label.martrixcross":`Cruz de matriz`,
"label_tabpage_entercusnamez":`Ingrese el nombre de cliente`,
"lable.account.NextwDays":`Próximo 30 días`,
"label.list.userinterface.dashboard.hint":`Las gráficos nuevos de paneles admiten mostrar rápidamente en móvil, tableta, etc...`,
"message.fieldtrack.operatecreate":`Creado`,
"label.service.gantt.available.plan":`Escalas de tiempo disponibles:`,
"label.activity.setting":`Configuración los eventos`,
"label.tag.manage.record":`Cantidad de registros`,
"label.customcomponent.page.edit.title":`Editar los componentes personalizados`,
"label.import.index.creationrecord":`Crear registro`,
"label.tabpage.printz":`Imprimir`,
"label.appointment.wizard.subtitle4-1-5":`1.5h`,
"label.partnerCloud.orderingPlatform.discountUnit":`Unidad de descuento:`,
"label.weixin.micro.message.profile.associated":`Relación entre la cuenta oficial WeChat y el perfil de empresa`,
"label.cpq.opportunity.pricebook.change":`Esta oportunidad ha sido vinculada a una cotización primaria y el libro de precios no puede ser modificado`,
"vue_label_opportunity_business_opportunity":`Los resultados de las oportunidades de negocio cerradas y ganadas de clientes contienen registros con uno o más campos iguales que la oportunidad de negocio actual.`,
"message.standardreport":`Reportes estándar`,
"vue_label_account_outstanding_business":`Transferir todas las oportunidades de negocio no procesadas de otros`,
"vue_label_commonobjects_detail_field":`Seleccionar el campo del filtro`,
"pagecreator_page_button_delete":`Eliminar`,
"label.leadconvers.permisson":`?No tiene permiso de {!operator}para {!objectname}, contacte con el administrador!`,
"vue_label_systemSettings_customcode":`Código personalizado`,
"button.partner.cancel":`Cancelar`,
"label.whChatBindingState":`Status de vincular WeChat`,
"label.appointmentconfirmail.wizard.subtitle6":`Teléfono`,
"label.recycle.dis.tip2":`Haga clic en vaciar su papelera de reciclaje o vaciar todo para limpiar la papelera de reciclaje de los usuarios o de su organización, que llevará unos minutos, el sistema le enviará correo una vez termine la operación.`,
"batch.transfer.succ":`Número de transferencia masiva de datos exitosa es:`,
"label.chat.add.bookmark":`Marcador`,
"label.mr.object.contact":`Contactos`,
"component_setup_label_parentobject":`Objeto superior`,
"label.reportsSubscriptionPage.schedulereport.weekly.tuesday":`Martes`,
"vue_label_report_list":`Seleccione el campo que debe aparecer en el título de la lista`,
"label.checkbox.false":`No`,
"label.chatter.followers":`Ser seguido`,
"label.mr.loadReDate":`Cargar información seleccionada`,
"label.versiontype.Essential":`Esencial`,
"front-project-module-v1-input-actual_working_hours":`Por favor, introduzca las horas de trabajo`,
"label.visualpage.staticresource.p2":`2. Notas: Se permiten los formatos de archivos de los recursos estáticos png, jpg, gif, js and css`,
"label.query.clone.detail.choose":`Seleccione los ítems detallados para copiar`,
"component.assistant.label.30daysnoact":`Sin actividad en 30 días`,
"label.tianyancha.businessverify.relation":`Mapeado`,
"vue_label_email_havent_received_the_email_yet":`No ha recibido ningún correo de momento`,
"label.isEnableVisualpage_new.title":`Activar el acceso de página personalizada`,
"lable.SalesCommitmentKanBan.allContractAmount":`Monto toal de contrato`,
"label.searchall":`Buscar Todo`,
"label.h5.similar.opportunity.select.all":`Seleccione todo`,
"label.area.tree.intro":`Puede ver directamente las áreas y la relación entre las áreas`,
"label.select.up.three.fields":`Atención: Se puede seleccionar un máximo de tres campos.`,
"label.leadscore.doing":`La puntuación ha comenzado, no la repita`,
"message.choosereportobj":`Seleccione objetos del informe`,
"button_partner_start":`Empezar a utilizar`,
"label.quote.print":`Imprimir presupuestos`,
"label.workflowoperateselect":`Paso 3: Especifique la operación del flujo de trabajo`,
"label.greate":`> Más que`,
"lable.setting.qrcodeOrbarcode.rule":`Configuración de las reglas de generación de códigos QR/códigos de barras`,
"label.partnerCloud.orderingPlatform.discounts":`Programa de descuentos`,
"label.ems.save2draft":`Guardar como borrador`,
"vue_label_homepage_editname":`Editar el nombre de la página de inicio`,
"label.ccdocument.save.error":`Se frascasó en guardar y el código de error es`,
"label.samoa.standard.time":`Hora Estándar de Samoa`,
"label.tianyancha.businessverify.msg7":`3. Rango de servicio:`,
"vue_label_commonobjects_view_up_to_data":`La operación admite hasta 200 datos`,
"label.manage":`Gestionar`,
"label.tooltip":`?El origen de datos de informe ha sido utilizado, no puede editar la relación de objeto!`,
"vue_label_calendar_edit_calendar":`Editar calendario`,
"label.attendance.keywords":`Por favor introduzca palabra clave`,
"label.otherinfo":`Otras informaciones`,
"System_TAB_SeeViewAmount":`Ver la cantidad total`,
"label.recordtype.remark":`Descripción`,
"label.object.cannot.delete":`No se puede eliminar el objeto, porque está asociado con las relaciones siguientes de otros objetos`,
"label.setup.mobile.bottombutton.saveprompt":`Seleccione 4 páginas de primer nivel`,
"label.department.lastpage":`Es la última página`,
"label.emailtemplate.mergefield.use":`Copiar y pegar los valores del campo combinado en el cuerpo del correo`,
"vue_label_salesfunnel_notice8":`Porcentaje de conversión con éxito desde la fase actual hasta la siguiente`,
"lable.opppdt.addpdt.table.product":`Productos`,
"vue_label_helpcenter_report2.2":`Paso 2: Seleccione cómo quiere resumir las columnas: Total, Media, Máximo, Mínimo. <br>•Ordenar los datos del informe en orden ascendente o descendente<br> Haga clic en el símbolo ↑ o ↓ junto a cualquier campo de la cabecera del informe de vista previa. Los datos del informe se clasificarán en orden ascendente y descendente según este campo. <br>Mostrar u ocultar las filas de detalle<br> Después de la agrupación, puede mostrar u ocultar las filas de detalle mediante la vista previa del interruptor "Fila de detalle" en la parte superior derecha del informe. La "Fila de detalle" está desactivada por defecto. <br>• Activar o desactivar la vista previa de actualización automática<br> La "Vista previa de actualización automática" en la parte superior derecha del informe de vista previa le permite activar o desactivar la vista previa de actualización automática. Cuando está activada, el impacto de cada paso que se da en los datos se muestra automáticamente en el informe de vista previa. •Para filtrar los registros del informe, haga clic en los filtros<br>Los filtros se dividen en filtros estándar y filtros de campo. <br>Los filtros estándar incluyen el filtro "Rol", el filtro "Mostrar a mí" y el filtro "Fecha". <br> A. El filtro "Rol" divide los datos por rol actual y roles subordinados inmediatos, y puede cambiar entre roles haciendo clic en el nombre del rol. <br> B. El filtro "Mostrar a mí" divide los datos por "Mostrar a mí" y "Mostrar a todos", con "Mostrar a mí" muestra los datos donde el propietario es el usuario actual, y "Mostrar a todos" muestra todos los datos donde el usuario actual tiene permiso de visualización. <br> C. El filtro "Rango de fechas" divide los datos por fecha en un rango de tiempo, como "Fecha de creación", "Fecha de finalización". <br> El filtro "Campo" incluye tanto un filtro de campo como un filtro avanzado. <br>`,
"label.validate.function.funcFormat.YEAR":`A?O(Fecha)`,
"label.service.gantt.timeScale":`Elegir la escala de tiempo en Gantt`,
"label.data.dataexptemplate.desc1":`1. Hay dos formatos de la exportación de los datos de archivos: Formato CSV y formato compresionado. Por defecto es formato CSV.`,
"template.chart.btjbkhqk":`Diferentes niveles de clientes`,
"label.role.assign.select":`Remover un usuario de<b>Usuarios Seleccionados</b>lista y asignar al usuario a los roles seleccionados arriba mencionado.`,
"label.event.lookupmulti.assigner":`Asignar a`,
"label.appexchange.fieldupdata":`Actualización del campo del flujo de trabajo`,
"label.lookup.page.notexists":`La página no existe`,
"label.appupload.install.error.choice3":`Fusionar los componentes en conflicto en un componente`,
"vue_label_commonobjects_detail_team":`Gestionar grupo`,
"label.approvereqiest":`Aprobar la solicitud`,
"message.error.id.replace":`No se ha encontrado la información del calendario correspondiente a {0}`,
"font-evaluate-module-v1-general":`El tipo de evaluación es Neutral`,
"vue_label_report_whatweek":`Día de la semana`,
"vue_label_chatter_img_upload":`Puede subir archivos JPG, GIF o PNG, el tamaño máximo permitido es de 2MB`,
"label.checkbox":`Casilla de verificación`,
"label.visualpage.component.n5":`5.Ejemplo. Call: &lt:component:c1 args="name:sqlName,age=18, sex='man'" /&gt; Utiliza: &lt;cc:component>&lt;cc>String myName = name; int myAge = age; String sex = sex;&lt;/cc>&lt;/cc:component>`,
"chatter.updat":`Actualizar`,
"label.ems.emailaccount":`Cuenta del correo`,
"label.autoRegister.changepwd.setpwd.tip1":`Configure contrase?a para la cuenta de CCloudCC`,
"label.import.step1.matchway":`Forma de coincidir {labelNameshow}`,
"label.manageAll.sel.one4":`Los ítems he rechazado`,
"label.tabpage.lookatmorez":`Ver más`,
"label_tabpage_addadvancedoptions":`Añadir opciones avanzadas`,
"message.validation.accept":`Formato inválido`,
"label.handlingnooperate":`Los datos están procesando, no haga otras operaciones , o el proceso se frascasará.`,
"label.mobile.buttom.homepage":`Página de inicio`,
"lable.account.LastaDays":`Los 7 días pasados`,
"label.user.notexists":`El usuario no existe`,
"front-electronic-signature-isclose":`Inactivo`,
"label.optional.groups":`Grupos de líneas de cotización opcionales`,
"pagecreator.layout.label.layoutname":`Nombre del diseño`,
"label.error404":`La página quiere visitar no existe, intente de nuevo más tarde...`,
"label.eventtrigger":`Triggers de eventos`,
"label.projectManagement.next.page":`Página siguiente`,
"vue_label_SMS_chosen":`Seleccionado`,
"label.part.cannot.empty":`?El campo no puede estar vacío!`,
"label.call.center.jilu":`Historial de llamada`,
"front-kefu-moudle-v1-tenant-reinput":`Por favor, introduzca el ID del arrendatario`,
"label.projectManagement.you.want.to.delete.this.data":`¿Está seguro de que quiere eliminar este registro?`,
"label.projectManagement.nocharge":`Sin cargo`,
"System_TAB_SeeViewPageAmount":`Ver páginas`,
"label.password.query.error":`Consulta de usuario se ocurrío un error`,
"message.chooseatleastone":`Seleccione por lo menos un valor`,
"label.sortasc":`Orden ascendente`,
"label.stdashbord.xsld.business.jinezhb":`Proporción de Cantidad`,
"label.attendance.add":`Añadir asistencia`,
"vue_label_account_invoices":`Transferir todas las facturas del propietario del cliente`,
"label_delete _model":`Al eliminar un modelo también se eliminarán los datos de destino asociados de forma irreversible. ¿Está seguro de continuar?`,
"label.folder.sort。discreption":`Las carpetas se muestran por el orden seleccionado`,
"label.partnerCloud.financeSetting.merchantPlatform":`Ruta de acceso: Plataforma comercial  Centro de cuentas  Seguridad de la API  Secreto de la APIＫey`,
"label.equal":`#NAME?`,
"lable.PowerProcess.Workorder":`Orden de trabajo`,
"front-docusign-setting-error-tips":`Por favor, elija el campo personalizado`,
"template.report.lead.status":`Estado de las pistas`,
"label.create.remark":`Añadir notas`,
"font-evaluate-module-v1-one-points":`Nota negativa: 1 punto`,
"label.validate.function.funcExplain.DATETIMEVALUE":`Devuelve el año, mes, día y hora GMT (campo de fecha/tiempo)`,
"label.report.select.group.mode":`Seleccione modo de agrupación`,
"label.h5.editmydetails":`Editar información personal`,
"front-epwechat-module-v1-authorize":`Dominio de devolución de llamada autorizado`,
"label.tabpage.kanban":`Configuración del Kanban`,
"label.emailobject.emaildetail.button.addtocontact":`Añadir a contactos`,
"lable.opppdt.selPbk.description":`Seleccione el libro de precios para esta oportunidad. Sólo puede añadir producto de un libro de precios individual, y cambiar el libro de precios seleccionado va a cancelar todos los productos existentes de la oportunidad`,
"component.event.button.save":`Guardar`,
"vue_label_homepage_homepage_assigned_success":`Página de inicio asignada con éxito`,
"message.duplication.label.blankmatch":`?Si combina el campo vacío?`,
"label.icon.24":`Kit De Primeros Auxilios`,
"label.mobile.same":`El nuevo número de teléfono es el mismo que el anterior`,
"label.file.library.managemembers.addmember":`Añadir miembros`,
"chatter.sp":`Mostrar Miscro-publicación`,
"label.user.notlogin.range":`?Está fuera del período de login`,
"label.step3.total7":`Paso 3 de 7`,
"label.user.fullname":`Nombre completo`,
"label.button.menubar":`Barra del menú`,
"#label.importfilestep3":`Paso 3: Seleccione y suba sus archivos#`,
"label.appointment.wizard.subtitle6":`Descripción`,
"message.lostnextapprover":`Si quiere entregar la solicitud de aprobación, complete el campo ¨Usuraio relevante¨para definir el próximo aprobador. El campo de ¨Usuario relevante¨ no puede estar vacío. Contacte con el administrador por más detalles.`,
"label.sso.saml.sp.logoutUrl":`Cerrar sesión URL de proveedor de identidad único`,
"label.weixin.isgoon":`La información de su miembro ya existe, si continúa, el WeChat ID anteriormente vinculado a este número de móvil no se puede utilizar AidMax WeChat Oficial. ?Está seguro de continuar?`,
"vue_label_notice_homepage1":`Introduzca el valor objetivo correcto con un máximo de 12 dígitos`,
"label.umeng.activity.event.will":`En`,
"label.insertURL":`Insertar URL`,
"label.partnerCloud.orderingPlatform.administrator":`No hay libro de precios disponible. Por favor, póngase en contacto con el administrador.`,
"vue_label_systemSettings_emailtemplate":`Correo electrónico Tamplate`,
"template.dashboard.market.analysis":`Análisis de la campaña`,
"message.deleteapproval.tip":`Solo puede cancelar el proceso de aprobación que no tiene relación con los datos o registros.`,
"pagecreator_page_message_delete":`?Si elimina la página seleccionada actualmente?`,
"component.telerecord.label.message":`Comentario`,
"front-email-payment-Invoice-preview-opening":`Póngase en contacto con el administrador del sistema para activar la función de pago en línea y configurar los parámetros correspondientes del método de pago.`,
"noless":`Mayor o igual`,
"label_emailtocloudcc_button_back":`Cancelar`,
"lable.Please.select.a.template":`Por favor, elija una plantilla existente.`,
"front-lightning-module-v1-details-page-chart-relevant":` Cuando los objetos asociados del informe seleccionado contengan el objeto actual, podrá seguir filtrando los datos del informe según el registro actual; Configure si permite a los usuarios actualizar manualmente los datos de la caja.`,
"label.object.page.head":`Encabezco de página`,
"label.notification.time1":`hace unos minutos`,
"label.weixin.optionnine":`Opción 9`,
"label.approval.content.tolang":`?Los contenidos ingresados son demasiado largos, intente de nuevo!`,
"label.leadconvers":`Conversión de candidatos`,
"label.compact.layout.frame.tabseq":`Mostrar orden de la página TAB:`,
"label.permission":`Conjunto de permisos`,
"vue_label_notice_new_success":`Creado con éxito`,
"label.money":`Moneda`,
"label.ccchat.person.invite.unsuppem":`El correo que ha ingresado no admite {0}`,
"message.profile.del":`?Este perfil es un perfil de administrador y no se puede cancelar!`,
"vue_label_report_savelocation":`Guardar ubicación`,
"label.knowledgebase.select.lighting.target":`Por favor, elija el objetivo de Lightning`,
"label.visualpage.labelname":`Nombre de la etiqueta de página`,
"label.notification.ccchat2":`A【点赞用户名】le gusta sus publicaciones.`,
"label.htyj.wanchenglv":`Porcentaje`,
"label.weixin.report.generatedchart":`Gráfico generado`,
"label.customer.tab.please.label":`Ingrese la etiqueta del menú`,
"label.template.lookup":`Ver plantilla`,
"label.attendance.setting.wucha":`Desviación dentro de 200 metros`,
"vue_label_opportunity_product_addproduct":`Añadir producto`,
"label.data.setok.t.desc3":`, ejecutar operación.`,
"label.emailobject.template.public":`Público`,
"label.setsubmit":`Configuración de envío`,
"chatter.feed.menutype.feed.companycom":`Todas las publicaciones`,
"label.Generate.Document":`Generar documentos`,
"label.knowledge.setting.hint.six":`Organizar los artículos por clasificación de datos.`,
"label.dashboard.show.total":`Mostrar total`,
"attachment.select.warning.001":`Archivo adjunto seleccionado, el botón Archivar no está disponible, por favor, vuelva a seleccionar un archivo adjunto.`,
"message.schedulejob.error.delete":`Un error se ocurrió al cancelar la base de Job`,
"setup.layout.group.pagecomponent":`Elementos de la página`,
"label_partner_new_step3_meno":`?No está seguro de lo que tiene que ingresar? No se preocupe, puede cambiarlo más tarde cuandoquiera.`,
"label.partnerCloud.orderingPlatform.mutex":`Mutex`,
"label.subtotalrely":`Base de subtotal`,
"label.file.library.selectFile2Lib":`Añadir los ficheros`,
"label.lock.record":`Recordatario bloqueado (`,
"label.multilang.addcustomreporttypestage2.description":`Este origen de datos generará un informe relacionado con {0}. A través de seleccionar un objeto relacionado con él, puede definir qué registros relacionados de otros objetos regresará a los resultados de origen de datos.`,
"message.duplication.errorinscript.greaterthan10":`?Puede seleccionar hasta 10 registros para fusionarse`,
"label.encd":`Mostrar encriptado`,
"UG.Account.03":`Comprobar y fusionar los clientes duplicados`,
"label.salescloud.teamrole.main2":`Principal`,
"label.email.to":`Destinatario`,
"label.members.sign.notify":`Notificar al supervisor`,
"template.report.individual.case.priority":`Caso prioritario`,
"vue_label_report_selectfolder":`Seleccione carpeta`,
"label_partner_all":`Todas las nubes de socio`,
"lable.custom.year":`Año personalizado`,
"label.ispigeonhole":`Archivar`,
"label.campaignmember.selectmember.steptotal":`Paso 2 de 2`,
"label.userphoto.save":`Guardar`,
"label.knowledgebase.published.version.online":`Las versiones publicadas siguen en línea hasta que se publique este borrador.`,
"template.report.customer.level.statistics":`Estadísticas a nivel de cuenta`,
"label.mobile.phone.day.plan":`Plan de ma?ana`,
"label.icon.95":`Enseñando`,
"label.recordphone":`Registrar llamada`,
"lable.currencyManage.unEnabledadvcurrency.discripation":`Si prohibe la gestión de moneda avanzada, no se pueden utilizar la tasa de cambio vencida. Las monedas de oportunidades, productos de oportunidad y los informes relacionados con los dos objetos no mapearán a la tasa de cambio de un rango de fecha específico. Todos los campos de moneda utilizarán la tasa de cambio fija.`,
"label.service.gantt.is.candidate":`Candidato de`,
"label.ruleofchecktask":`Reglas de verificación de tareas`,
"label.whole.page.show":`Pantalla completa`,
"label.validate.function.funcFormat.ISNULL":`ISNULL(expresión)`,
"label.ccdocument.template.set":`Función del conjunto de plantilla`,
"label.icon.103":`Calendario`,
"lable.no.products.to.assets":`Ningún producto puede ser transferido al activo.`,
"label.fristname":`Nombre`,
"label.appointmentconfirmail.wizard.subtitle5":`Organizador`,
"label.partner.workspace.myspace":`Mi espacio de trabajo`,
"label.tabpage.optionsz":`Opciones`,
"component_chatter_link_button_save":`Publicar`,
"label.validate.function.funcFormat.NOW":`NOW()`,
"label.discountPlanEditor":`Editor de planes de descuento`,
"label.weixin.fmu.pm":`{0} PM`,
"front-gantt-module-milestone-sorting":`Clasificación de hitos`,
"label.partnerCloud.maximumNumber":`El máximo de sitios asociados:`,
"label.mobile.place.record.interval.setup":`Intervalo para compartir la ubicación`,
"label.visiblelinenumber":`Líneas visibles`,
"front-kefu-moudle-nopower-calluser":`No hay permiso, por favor, póngase en contacto con el administrador`,
"label.field":`Campos`,
"label.projectManagement.groupbydate":`Agrupar por fecha`,
"label_vue_create_edit_obj_create_event_dialog_desc_deal_field":`programado`,
"label.operation.monitoring.history":`Historial de monitoreo del trabajo`,
"label.data.dataexpalltype.all_desc1":`1. contrase?a de todos los ficheros compresionados exportados, o ingrese manualmente. La contrase?a automáticamente generada se enviará al correo de usuario una vez haya sido exportados con éxito. Los contrase?as manualmente ingresadas no se enviarán al correo de usuario, por eso los usuarios necesitan recordar la contrase?a, si no ingrese, no habrá contrase?a por defecto.`,
"front-web-module-v1-detail-comment-proposal":`Espero sus valiosas sugerencias`,
"label_partner_workspace_member_selectedpermission":`Conjunto de permiso seleccionado`,
"vue_label_helpcenter_view1":`En la vista de la versión Lighting, puede ver y gestionar de forma intuitiva y flexible los datos a los que tiene acceso. A través de la vista, puede realizar funciones básicas como la vista de clasificación de datos, la visualización de datos de múltiples maneras, la adición, la modificación y la eliminación de datos, y también puede ver cómodamente informes y gráficos para el análisis posterior de los datos.<br> 1. Gestionar vista<br> En el menú desplegable de la esquina superior izquierda de la vista, seleccione la vista que desea ver, y seleccione la vista predeterminada a través de los ajustes fijos. <br> Utilice el menú de control de la vista de la lista para crear, editar, eliminar u ordenar las vistas. Al mismo tiempo, utilice la función de filtro en la parte superior derecha para editar rápidamente y crear nuevas vistas. <br> 2. Ver los datos a través de múltiples vistas<br> Puede ver los datos de diferentes maneras. En la esquina superior derecha, puede cambiar la lista, el Kanban y la pantalla dividida para ver los datos. <br>En la vista de lista, se puede modificar datos de algunos campos. Haga doble clic en la celda a editar o haga clic en el botón de edición para editar directamente los datos en la ventana emergente. Para editar varios datos, solo tiene que seleccionar primero los datos y, a continuación, seleccionar "Aplicar a los datos seleccionados" en la ventana emergente de edición. <br> En la vista de lista, puede editar directamente la columna que se mostrará en la esquina superior izquierda, hacer clic en el encabezado en la cabecera de la tabla para ordenar, o seleccionar la columna que desee a través de la ventana flotante desplegable. <br> Después de configurar la vista Kanban, puede ver los datos en grupos, y ver el valor de resumen de cada grupo. En la configuración de la vista Kanban, puede editar el criterio de agrupación, de resumen y el método de resumen de la vista Kanban, y también puede seleccionar hasta cuatro campos para la visualización. Puede cambiar rápidamente la agrupación de los datos mediante el arrastre. <br>`,
"component.task.label.priority":`Prioridad`,
"label.datamanage.field.error":`Error del objeto de búsqueda`,
"label.console.step3":`Paso 3. Seleccione el origen de imagen para consola`,
"label.ems.emailsyncsetup":`Configuración de la sincronización de correo`,
"label_tabpage_placeenterz":`?Por favor ingrese?`,
"label.getontocolumn":`Saltar a columna:`,
"label.file.down.e":`El tipo de archivo actual no puede ser descargado`,
"vue_label_notificationcenter_unreadonly":`Mostrar solo los no leídos`,
"label.login.access.change":`Cambiar`,
"label.globaloperation.operationtype.send_e-mail":`Enviar correo`,
"label.dashboard.refresh.hint":`Haga clic en resfrescar el panel para cargar de nuevo los informes originales, este proceso llevará unos minutos, ?está seguro de continuar?`,
"front-kefu-moudle-open-free":`Habilitar (prueba)`,
"label.lanxin.setting.appsecret":`AppSecret`,
"label.payment.manage.order":`Gestionar su suscripción`,
"label.chatter.maturiyDate":`Fecha de validez`,
"message.mobilechooseatmostthree":`El menú de la App Móvil se puede seleccionar hasta 3 campos.`,
"label.customfields.formula.tip":`Un campo de solo lectura que deriva su valor de la fórmula definida. El campo de fórmula se actualiza cuando cambia cualquiera de los campos de origen.`,
"lable.PowerProcess.start.time":`Seleccione la hora de inicio`,
"label.mr.title.button.group2":`Conjunto(s) de registros duplicados, un total de `,
"label.atlantic.standard.time":`Hora estándar de Atlántico`,
"label.account.LengthofTime":`Duración`,
"label.ccchat.message.search.desc2":`Mensaje`,
"label.pigeonhole.desc":`Los adjuntos archivados solo son válidos para los ficheros no archivados. <br/>Una vez el adjunto sea archivado, no se puede cancelar. `,
"label.partnerCloud.orderingPlatform.sure":`Cambiar {alias} vaciará el carro. Está seguro de confirmar la operación?`,
"label.default.value.is.positive.integer":`El valor predeterminado debe ser un entero positivo`,
"label.partnerCloud.selectOne":`Seleccione al menos un menú`,
"label.dashboard.more.condition":`Más condiciones`,
"component.event.label.enddate":`*Fecha de finalización`,
"label.forecast.settings.type":`Tipo de previsiones`,
"com.cloudcc.login.error.message.licensenotstart":`La licencia no se ha iniciado`,
"lable.list.queue":`Fila`,
"label.mobile.app.isdisablum":`? Está prohibido seleccionar fotos del álbum del móvil al registrarse?`,
"label.service.gantt.filter":`Al filtrar por habilidades, solo se mostrarán en el diagrama de Gantt los recursos con la habilidad seleccionada`,
"label.potentialcustomeronline":`Candidatos en línea`,
"label.campaignmember.main.deletecontactdesc":`Remover todos los contactos de la campa?a`,
"label.list.desc1":`Con Web to funciones CloudCC, puede capturar información de contacto y perfil de los usuarios y generar automáticamente nuevos candidatos en CloudCC.com.`,
"label.generatepage.title.desc3":`El nombre debe ser único, comienza con letra, sólo contiene letras alfanuméricas, guión bajo y debe contener al menos 30 caracteres`,
"label.emailtocloudcc.step2total3":`Paso 2 de 3`,
"label.movablemenu":`Botón de actividad`,
"label.partnerCloud.partnerAccount.topUp":`Recarga`,
"label.data.standobject":`Objetos estándar`,
"label.frequency":`Frecuencia`,
"label.schedulejob.setup.schedule.end":`Terminar`,
"label.chat.topic.following":`Siguiendo`,
"label.martrixreport.2018.step2":`Paso 2: seleccione las informaciones por resumir:`,
"label.event.moveup.11hour":`11 horas con anticipación`,
"label.forecast.customforecast.directorcommit":`Compromiso de subordinados directos`,
"vue_label_homepage_card_view":`Vista de la tarjeta`,
"vue_labenl_applauncher_notice_closecertification":`Los datos se perderán después de apagarlo. ¿Está seguro de hacerlo?`,
"component_setup_button_weburl":`URL externa`,
"label_emailtocloudcc_button_addemailaddress":`Agregue su correo de empresa`,
"vue_label_campaign_added_campaign_members":`Miembro añadido con éxito a la campaña`,
"label_tabpage_rtemptyz":`El tipo de registro no puede estar vacío`,
"label.martrixreport.2018.step5":`Paso 5: seleccione el tipo de gráfico y ítems destacados`,
"label.moverecord":`Transferir registro`,
"pagecreator_layout_label_layoutdesc":`Descripción del dise?o`,
"label.knowledge.setting.data.nine":`Sí, quiero eliminar este grupo de categorías y las categorías bajo este grupo.`,
"label.icon.90":`Personas`,
"label.weixin.micro.research.name":`Nombre de Micro Encuesta`,
"label.ccchat.micropost.allowedit":`Permite a los usuarios editar publicaciones y comentarios`,
"vue_label_homepage_fixed_components":`Componente estándar`,
"label.version.document":`Biblioteca de documento`,
"label_assessment":`Evaluación (Oportunidad - Cantidad)`,
"label.appupload.component.type.lookuplayout":`Dise?o de búsqueda`,
"label_chatter_loadmore":`Cargar más`,
"component_setup_tabs_label_memo":`Configurar el nombre de etiqueta de Tab`,
"label.icon.167":`Brújula`,
"vue_label_chatter_enter_content_sharing":`Introduzca el contenido y el grupo al que quiera compartir`,
"vue_label_notice_modify_success":`Modificado con éxito`,
"label.sharerules":`Regla de compartido`,
"label.field.api.exists":`El campo del nombre API ya existe`,
"label.icon.83":`Pintar`,
"label.file":`Archivo`,
"vue_label_report_foldernameisrequired":`El nombre de la carpeta es obligatorio`,
"label.emailobject.wizard.btn2":`Vinculado, ir a enviar correo`,
"label.data.downpage.i_title.num3":`3. Antes de importar, asegúrese de que importar todos los registros relacionados. Por ejemplo: si existe una relación de búsqueda entre los objetos actualmente importados y los contactos, importe esos contactos antes de importar sus datos.`,
"label.email.original.content":`Contenido de referencia`,
"vue_label_campaign_add_to_campaign":`Añadir a la campaña`,
"label.dashboard.new":`Nuevo panel`,
"label.console.detail":`Ver consola`,
"label.view.desc":`El campo de fecha puede ser igual a "ayer", "hoy", "ma?ana", "el mes pasado", "este mes", "próximo mes", "semana pasada", "esta semana", "próxima semana" o "YYYY-MM-DD、MM/DD/YYYY".`,
"label.emailobject.template.insert.continue":`Continuar`,
"label.notification.appointment.overlapEvent":`La hora seleccionada ya fue reservada, por favor seleccione otra hora.`,
"label.console.step6.top":`Fijar a la cima y las listas siempre son visibles.`,
"label.data.file.the_trigger":`Ejecutar Trigger`,
"message.report.error.operation":`?Operación fallada, resetee el informe!`,
"vue_label_helpcenter_detail3":`<br> "Me gusta" y "No me gusta"<br> Puede darle un "Me gusta" a un micropost o al comentario de un micropost. Después de dar un "Me gusta", puedes ver el número de "Me gusta" del post, y también puedes cancelar "Me gusta". <br> Editar y eliminar post<br> El autor del post puede reeditar o eliminarlo. <br>   Paso 1: Haga clic en el botón a la derecha del post y seleccione Editar o Eliminar en el cuadro desplegable.<br>  Paso 2: Abra la ventana emergente de Editar/Aceptar eliminar.<br>   Paso 3: Haga clic en Guardar/Aceptar para completar la operación.<br> 5. Historial de aprobación.<br> Enviar para aprobación<br> El botón "Enviar para aprobación" aparece cuando se crea un nuevo registro, se devuelve una solicitud de aprobación o se deniega finalmente una aprobación. <br> Paso 1: Haga clic en "Enviar para aprobación". El sistema determina si el registro y el remitente cumplen con las condiciones del proyecto y del remitente inicial establecidas por el proceso de aprobación, y si todas estas condiciones se cumplen, se completará el envío. <br> Si el siguiente paso de aprobación en la configuración del proceso de aprobación requiere la selección manual del aprobador, el paso 2 se ejecuta después de "Enviar para aprobación".<br>Paso 2: Seleccione el siguiente aprobador y complete la operación de envío. <br>Historial de aprobación<br> A. Antes de enviar:<br> Haga clic en "Vista previa del proceso de aprobación", el sistema determinará si el registro y el usuario que lo envía cumplen los elementos establecidos en el proceso de aprobación. Si se cumplen todas estas condiciones, se mostrará el proceso de aprobación. <br> B. Después del envío:<br> En el historial de aprobación no solo puede ver los pasos del historial de aprobación y el estado actual de aprobación del registro, sino que también puede previsualizar los siguientes pasos del proceso de aprobación. <br> Retirar solicitud de aprobación<br> Si este proceso de aprobación está configurado de tal forma que permite la retirada de solicitudes de aprobación, estas pueden ser retiradas en cualquier momento después de haberlas enviado. <br> Paso 1: Haga clic en "Retirar solicitud de aprobación" en la página de detalles del registro <br> Paso 2: Abra la página de "Retirar solicitud de aprobación" a y haga clic en "Retirar solicitud de aprobación" para completar la operación.`,
"Opportunity_Detailed_Phase_Label_004":`día(s)`,
"PageLayout_Search_MultiSearch_001":`Seleccione hasta 3 campos`,
"vue_label_systemSettings_set_business":`Configure la disposición y los campos de los objetos para que se adapten a su negocio.`,
"label.compact.layout.frame.select":`Seleccione la estructura del dise?o de página`,
"label.tabpage.rolez":`Rol`,
"label.weixin.appr.currentauditor":`Asignado por`,
"label.knowledgebase.verification.status":`Estado de la verificación`,
"UG_Case_05":`Crear un caso`,
"label.service.marking.completed":`Marcar como completado`,
"label.notification.ccchat1":`【发出@的用户名】le ha mencionado`,
"label.knowledgebase.no.action.available":`No hay acción disponible`,
"label.tabpage.newlybuildz":`Nueva fuente de datos de informes personalizados`,
"label.appupload.install.error.choice2":`Renombre los componentes locales que tienen conflictos con el paquete`,
"label_tabpage_as":`Como`,
"Opportunity.Detailed.Phase.Label.Popup.001":`Fecha de entrada`,
"vue_label_homepage_singlepage":`Solo se puede añadir hasta 10 componentes en una página`,
"font-evaluate-module-v1-fair-and-bad":`Cuando el tipo de evaluación es neutra y negativa`,
"label.partnerCloud.orderingPlatform.orderInformation":`Confirmación del pedido`,
"label.custom.lead.conversion.notice":`Notificación de conversión de los candidatos`,
"label.re.upload":`Subir de nuevo`,
"label.knowledgebase.top.window":`Ventana superior`,
"label.h5.allmarkedasread":`Todos marcados como leídos`,
"vue_label_SMS_open_record_from_start_activation":`Abra el registro de la lista para activarlo.`,
"label.customer.tab.step2":`Paso 2: Añadir a los perfiles`,
"label.campaign.channel.input.owner.select2":`Invitación de este canal de marketing`,
"component.task.button.save":`Guardar`,
"front-kefu-moudle-v1-phone-type":`Tipo de teléfono`,
"label.wedge-shapearrows":`Flecha de cola en forma de cu?a`,
"vue_label_homepage_todaysevent":`Eventos de hoy`,
"label.data.exp.way.sel":`Seleccione método de exportación`,
"label.setting.intergrationlist.status1":`Esta integración no se instala ahora`,
"button_partner_workspace_disable":`Cancelar la activación`,
"label.customfields.reference":`Pueden ser referenciado por otros campos como fórmulas, lista de opciones, campos de búsqueda y etc. `,
"label.publicgroups.new":`Crear Grupo Público`,
"label.data.setok.e_desc3":`, descargar los datos exportados`,
"vue_label_commonobjects_view_chart_countmode":`Modo de recuento`,
"label.service.appointmentList.earliest.allowedStart":`Fecha de inicio más temprana`,
"label.data.choses.e.desc":`Puede exportar todos los datos o exportar datos de un solo objeto según sus necesidades.`,
"label.multilang.common.fieldlist.fieldremark":`Se aplica a los campos mostrados en la página de {0}.`,
"label.umeng.activity.event":`Evento`,
"label.project.hit.ten":`Recordatorio de actualización de la edición`,
"label.c_d_least":`Cada regsitro de ¨C¨ debe tener por lo menos un registro de ¨D¨ correspondiente.`,
"label.emailobject.wizard.btn1":`Vincular con el correo personal`,
"lable.product.pricebooks.info":`Detalles del catálogo de precios`,
"component_telerecord_label_message":`Comentario`,
"lable.total.of.estimates":`0 estimaciones en total`,
"label.stdashbord.xsld.business.oppcounts":`Cantidad de oportunidades`,
"vue_label_commonobject_duplicatewith":`Duplicar con {1} de {0}`,
"label.setpicandreport":`Configuración de gráfico`,
"label.category.2":`General`,
"label.emailtocloudcc.reauthorization":`Reautorizar`,
"label.chatter.vote":`Votar`,
"label_emailtocloudcc_edit":`Editar`,
"label.pleaseinput":`Importar`,
"vue_label_homepage_user_particular_application":`La página de inicio cuando el usuario utiliza una aplicación concreta se sobrescribirá la página de inicio estándar`,
"label.allianceID":`Alianza ID`,
"label.h5.homepage.cannot.applied.mobile.terminal":`La página de inicio del perfil no está configurada para este perfil. No está disponible para la aplicación móvil`,
"label.appointmentpage.wizard.notif2":`Rellene el nombre`,
"label_emailsync_status_email":`Correo de operación`,
"label.icon.179":`Personas`,
"UG_Contract_03":`Crear contrato`,
"label.cy.new":`Nueva moneda`,
"label.version.setup.controllist":`La plataforma configura la lista de control`,
"label.vlidaterule":`Reglas de verificación`,
"label.customer.tab.name":`Nombre del menú`,
"label.recentview.seloption1":`Visto Recientemente`,
"vue_label_report_notice_nameisrequired":`El nombre del informe es obligatorio`,
"label.createapproveprocessstep":`<li>1.Lea el tema de ayuda </li><li>2.Cree plantilla de correo</li><li>3.Cree plantilla de SMS</li><li>4.Cree un proceso de aprobación utilizando Jump Start o Wizard Estándar</li><li>5.Agregue "Historial de aprobación" Lista relativa a todos los dise?os de página</li><li>6.Active el proceso para implementar a los usuarios</li>`,
"label.gotocalendar":`Ir al calendario`,
"label.import.page1.pleaseselectobj":`Por favor, seleccione primero el objeto`,
"label_tabpage_messagez":`Por favor ingrese los comentarios`,
"vue_label_homepage_profilepage":`Página de inicio del perfil`,
"label.tabpage.choose":`Seleccionar`,
"label.campaignmember.setup.lead.field":`Campo de candidatos`,
"label.setalipay.null":`La información requerida para configurar Alipay está vacía.`,
"label.custom.Current.and.NextCQ":`Trimestre personalizado actual y el siguiente`,
"label.knowledgebase.needto.publish.articles":`Resotre el artículo archivado creará una versión preliminar. Quieres publicar el artículo?`,
"pagecreator.layout.message.save.success":`Diseño guardado con éxito`,
"homepage.componet.approval.label":`Centro de aprobación`,
"label.last_submission":`Última hora de presentación`,
"lable.outlook.detail.prefo":`Primera opción Exchange`,
"label.projectManagement.new.subtask":`Nueva subtarea`,
"label.service.appointmentList.checkThe":`Marcado`,
"message.error.searchlayoutselectdefields":`No se puede cancelar y debe ser el primer campo en la búsqueda`,
"label.ems.normal":`Normal`,
"vue_label_notice_pleaseselectobject":`Seleccione objeto`,
"component.sendmail.button.send":`Enviar`,
"label.relevant.records":`Registros relacionados`,
"label.weixin.login.CloudCC":`Ingresar a CloudCC`,
"label.tag.addtags.private":`Privado`,
"label.appointment.disable.remark":`Lo sentimos, la función está actualmente desactivada. Si desea reprogramar o cancelar la reunión, póngase en contacto con el responsable en el {邮箱地址}.`,
"label.campaignmember.main.addMember1":`Añadir miembros`,
"message.error.objectnofound":`Objeto indefinido;`,
"label.employeenum":`Número de empleado`,
"label.search.applyfilter":`Aplicar filtros`,
"label.version.history.track.nonsupport":`Sólo la versión infinita tiene la función del seguimiento de historial.`,
"label.ccpeak.direction.for.use.time":`Instrucción de clasificación programada para CloudCC[Versión 2.0]`,
"label.ems.settings":`Configuración`,
"label_tabpage_arecordtypez":`Tipo de registro disponbile`,
"vue_label_pool_assign1":`{1}{2}`,
"label.customcomponent.direction.for.use":`Instrucciones para el uso de los componentes personalizados[Versión 2.0]`,
"label.appupload.appname":`Nombre de paquete`,
"label.cpq.order.status.no.active":`Sólo los pedidos con estado activo pueden generar contratos`,
"label.dashboard.maxlength":`Ingrese hasta 255 caracteres`,
"label.customize.memory.function.sorting.title2":`Memoria de ordenación de cabeceras`,
"label.report.chose.obj":`Seleccione la relación de objetos y la fuente de datos del informe`,
"label.partner.step3":`Paso3: Información básica`,
"message.report.type.error.fail":`Origen de datos del informe es incorrecto.`,
"pagecreator.page.message.publish.fail":`No se ha podido publicar página`,
"label.minimun":`Mínimo`,
"label.state":`Status`,
"label.customcomponent.referencetype":`Tipo de referencia`,
"label.nameandemailtemplate":`Introduzca un nombre del proceso en el cuadro siguiente y luego seleccione una plantilla de correo para notificar el aprobador(opcional).`,
"label.customobjects.track.introduce":`Esta página le permite seleccionar los campos que quiere seguir`,
"label.campaign.matchway.label":`Método de combinación:`,
"label.redistribution":`Reasignar`,
"label.groupmanage":`Gestión de organización`,
"label.icon.157":`Cámara`,
"label.quickbooks.viewlist.total":`Total`,
"label.file.copy.file.fail":`Se frascasó en copiar, copie manualmente`,
"label.outline.selectfield":`Resumen de campos seleccionados`,
"label.datetime.maxsize":`El ciclo de consulta no puede ser más de 3 meses`,
"label.dashboard.CustomDashboardMyHomePage":`Personalice mis paneles de la página oficial`,
"label.data.customobject":`Objetos personalizados`,
"vue_label_SMS_noselected":`No se ha seleccionado ningún registro`,
"label_tabpage_value":`Valor`,
"label.quote.qianming":`Firma`,
"label.view.source":`Ver origen de código`,
"label_popup_infoz":`Indicación`,
"label.emailtocloudcc.redmessage8":`Error en los parámetros, póngase en contacto con el administrador`,
"label.tianyancha.Search.business":`Buscar información del registro comercial`,
"vue_label_systemSettings_server":`Servicio`,
"vue_label_homepage_dashboard_components":`Componente del cuadro de mando`,
"label.search.listview":`Vista de lista`,
"label.service.gantt.distribution.success":`Asignado con éxito`,
"label.icon.4":`Billetera`,
"label.partnerCloud.orderingPlatform.calculate":`Calcular el precio`,
"label.forecast.edittotal.ycyx":`Previsiones primero`,
"vue_label_commonobjects_detail_to_precise_search":`Ir a la búsqueda precisa`,
"label.order.number":`Número de serie`,
"setup.mainpage.label.welcome7":`Instrucciones: Haga clic en el menú de la izquierda de la página → Configuración de aplicación → Crear → Nombre del objeto → Campo personalizado.`,
"label.weixin.user.binding":`Vinculación de usuario`,
"label.custom.canvas.size":`Tamaño del lienzo`,
"label.projectManagement.recent.projects":`Proyectos recientes`,
"vue_label_helpcenter_lead":`Haga un seguimiento y gestione sus clientes potenciales a través de Cloud CC. Utilice las reglas configuradas para puntuar y asignar clientes potenciales y convertirlos en clientes, contactos y oportunidades de negocio correspondientes en el momento adecuado.<br>Puntuación<br> En la esquina superior derecha de la vista, utilice el botón de puntuación por lotes para puntuar los clientes potenciales de la vista actual.<br>Asignación<br> Al crear o editar un cliente potencial, pulse Asignar en la parte inferior de la página para asignar el cliente potencial al personal correspondiente para que lo procese según las reglas existentes.<br>Conversión<br> En el momento adecuado, puede convertir los clientes potenciales en clientes y contactos haciendo clic en el botón de conversión en la esquina superior derecha de la página de detalles. Al mismo tiempo, puede crear las correspondientes oportunidades de negocio y tareas para facilitar el seguimiento continuo de las oportunidades de negocio.`,
"label.enabledprocess":`Proceso de aprobación activado`,
"label.emailobject.noemail":`?No hay ningún correo, vaya a enviar uno!`,
"label.validate.remark3":`Determina si un campo es obligatorio basado en el valor de otro campo`,
"vue_label_salesadvance_retention":`Retención`,
"label.product.managep":`Gestionar el libro de precios`,
"font-evaluate-module-v1-not-report":`No reabrir`,
"label.emailmerge.mergepage.step1":`1. Seleccione los registros para fusionarse:`,
"front-epwechat-module-v1-epwechat-describe":`CloudCC proporciona la integración con WeCom, combinando las potentes características de WeCom con la versión ligera H5 del sistema CloudCC,<br /> ayudándole a gestionar convenientemente las relaciones con los clientes, operar el tráfico de dominio privado y mejorar los ingresos de la empresa.`,
"label.partner.template.detailimage":`Imagen`,
"label.recycle.clearall":`Limpiar la papelera de reciclaje de su organización`,
"chatter.error.nottype":`Error: Tipo inválido del fichero, puede subir archivo en formato JPG, GIF o PNG.`,
"pagecreator.button.cancel":`Cancelar`,
"front-market-form-quired-ziduan":`Campos obligatorios en la página de registro`,
"vue_label_report_columnname":`Nombre de la columna`,
"message.notdelete.type":`No puede cancelar este tipo de registro porque los perfiles siguientes utilizan este tipo de registro como el valor predeterminado.`,
"label.ccpeak.folder.all.time":`Todas las carpetas del tipo programado`,
"label.quickbooks.searchlist.total3":`Hay {0} estimaciones desvinculadas para un valor total de {1}`,
"label.forecast.detailforecast.quantity":`Cantidad de previsiones`,
"label.knowledge.language.british":`Inglés británico`,
"label.vlidaterule.example.messagelocation":`Este mensaje de error se puede aparecer en la cima de página o está abajo de un campo específico en la página`,
"front-kefu-moudle-chf-success":`Dividir con éxito`,
"vue_label_jihui_yi":`Oportunidad 1`,
"label.import.step1.null":`No hay opciones disponibles`,
"label.console.step5.tab.subtab":`Como menú secundario`,
"batch.edit.permission":`No hay permisos para editar`,
"label.weixin.fmu.before.min":`{0} minutos con antelación`,
"chatter.up.file":`Subir un fichero llevará tiempo, que depende del tama?o del documento. Espere a que se cargue el archivo. `,
"setup.layout.group.field":`Campo`,
"label.chat.unlike":`No me gusta`,
"vue_label_dashboard_updatefrequency":`Frecuencia de actualización`,
"label.trigger.folder.new":`Página de Trigger: Nueva Carpeta`,
"label.process.des.app":`Haga clic en el enlace a la derecha para ver los detalles del registro actual.`,
"vue_label_pool_assignselect":`Elegir la asignación de miembros`,
"label.lookup.user":`Buscar colegas`,
"label.mobilescreentablayoutedit.remark2":`Seleccione los campos de filtro mostrados en el menú de la página oficial de Aplicación Móvil`,
"label.data.exp.objtemp":`Creará la plantilla y exportará los datos de este objeto de acuerdo con los criterios siguientes`,
"label.weixin.moreselect.error":`Solo puede seleccionar 10 registros`,
"label.icon.25":`Vendaje`,
"lable.sample.text":`Texto de muestra`,
"label.most.setup.obj":`Puede configurar hasta 10 objetos`,
"label.weixin.coming":`Futuro`,
"label.editdescription":`Editar notas`,
"label.multipleactivity.multiple":`Múltiples usuarios`,
"label.sso.saml.idp.entityid":`ID de Entidad`,
"label.SMS.pho.filed":`Campo de teléfono`,
"message.serviceabsence.violation":`Violación del tiempo de asignación: está en conflicto con el registro de ausencia.`,
"label.forecast.settings.type.clist":`Utilizar serie de productos`,
"label.state.noend":`Incompletado`,
"label.sourcetemp":`Plantilla de traducción original`,
"vue_label_chatter_name_link":`Rellene el nombre y el enlace`,
"label.emailobject.attach":`Agregar adjunto`,
"label.everyother":`Cada`,
"label.title":`CloudCC.com`,
"vue_label_chat_haventactivate":`Aún no ha activado una cuenta de chat. ¿Quiere activarla ahora?`,
"pagecreator_layout_button_delete":`Cancelar el dise?o`,
"label.transfer.temporarily":`Llamar`,
"label.service.dispatchingUnits.search.services":`Buscar cita de servicio`,
"customer.message.fail.chat":`No se han podido obtener los registros de mensajes, por favor, póngase en contacto con el administrador para obtener ayuda`,
"label.apiname.toolong":`El nombre de API es demasiado largo`,
"label.empty.filter":`Limpiar filtros`,
"label_tabpage_personalCenterz":`Centro personal`,
"label.minutes":`Minuto`,
"label.multipleactivity.atasks":`Tarea(s)`,
"label_tabpage_deleteview":`Cancelar la vista`,
"pagecreator_layout_message_save_success":`El dise?o ha sido guardado con éxito`,
"label.reportlineorder":`Orden de columna de informe`,
"label.total.forecast.have.priority":`Cualquiera previsión tiene prioridad, también acpetan la prioridad de otros subordinados`,
"label.custom.quarter.subtitle":`Trimestre personalizado`,
"label.icon.79":`Impresión`,
"label.hiddenoperate":`Ocultar operación`,
"label.project.hit.six":`Aviso de asignación de tareas`,
"label.visualpageaction.errordesc":`No tiene permiso suficiente para ejecutar la operación. Contacte con el propietario del registro o su administrador.`,
"label.chat.unmute":`Cancelar ¨No moleste¨`,
"label.zhaiyao":`Abstrato`,
"vue_label_commonobjects_detail_bcc":`CCO`,
"label.customcomponent.page.index.table.version":`Versión API`,
"UG.quota.06":`Crear oferta`,
"label.icon.152":`Robot`,
"label.partnerCloud.partnerAccount.account":`Nombre de usuario`,
"label.file.sharewith":`Compatidor`,
"label.data.dataexptemplate.desc2":`2. El formato de compresión se divide en dos tipos: una manera es generar automáticamente la contrase?a de los archivos comprimidos, que se enviará al correo de usuario una vez exporte exitosamente los datos; otra manera es introducir manualmente la contrase?a de los archivos comprimidos, que no se enviará al correo de los usuarios, por eso es necesario recordar la contrase?a ingresada, si no ingrese, no tendrá constrase?a por defecto.`,
"vue_label_dashboard_newfoldersuccessfully":`Carpeta creada con éxito`,
"label.campaignmember.main.importmember":`Importación masiva de los miembros de campa?a`,
"label.htyj.completed":`Completado`,
"label.reportTypeLabel":`Etiqueta de informe`,
"label.customer.tab.label":`Etiqueta del menú`,
"label.dashboard.component":`Componentes`,
"label.safetystatement.dialog":`Declaración de seguridad (Nueva ventanilla)`,
"label.forecast.settings.data":`Fecha de previsiones`,
"label.knowledgebase.modifiedby":`Modificado por`,
"label.batchadd.remark":`Añadir Múltiples Registros`,
"button.partner.delete":`Eliminar`,
"Pagelayout_Setup_005":`Hay que poner el nombre en primer lugar`,
"label.forecast.edit.wcpxl":`No hay serie de productos`,
"lable.PowerProcess.seq.input":`Introduzca el orden`,
"pagecreator.layout.message.delete.fail":`No se ha podido eliminar el diseño`,
"label.emailobject.edit":`EDITAR`,
"label.weixin.million":`Diez mil yuanes`,
"setup.mainpage.button.manageobject":`Gestión de objetos`,
"label.weixin.participants.perfect.information":`Participantes se requieren para mejorar información`,
"vue_label_campaign_campaign_members":`Añadir miembro de campaña`,
"label.ccchat.person.invite.emplaceholder":`Ingrese direcciones de correo, se separa por punto y coma`,
"label.mobile.phone.new":`Nuevo`,
"font-evaluate-module-v1-small-program-evaluation-settings":`Configuración de la evaluación del miniprograma`,
"UG.opportunity.005":`Proceso de venta múltiple`,
"vue_label_report_polymerization":`Polimerización`,
"label.multilang.lookfiltercondition.fieldtypenotmate":`?La condición de línea{0}es incorrecta, el tipo de campo no coincide!`,
"label.knowledgebase.delete.draft":`¿Borrar el borrador?`,
"label.mr.descreption.condition3":`Regla-si combina completamente: revise este ítem y encuentre los registros duplicados de acuerdo con los mismos datos del campo. Si marca este ítem, los carácteres ingresados de acuerdo con la regla anterior se volverán inválidos.`,
"Lead.Auto.Scoring.Setting":`Ajuste de puntuación de los clientes potenciales`,
"label.marketing.channel.default":`Canal de comercialización (activado por defecto)`,
"front-project-module-v1-select-projecttemplate":`Seleccione la plantilla del proyecto`,
"front-email-payment-select-area":`Por favor, introduzca el distrito`,
"lable.PowerProcess.message":`Información de proceso de asignación`,
"label.weixin.free.get.captcha":`Conseguir el código de verificación gratis`,
"label.projectManagement.please.select.task.or.question":`Seleccione la Tarea/Asunto`,
"label.pacific.daylight.time":`Hora de Verano Pacífico`,
"label.sendsms.batch.step1.introduce":`Seleccione una de las vistas siguientes(Que contiene los destinatarios de esta SMS).`,
"label.same.analyze.account.name":`Cliente`,
"Homepage.Contract.FieldMissed.DoesntSupport":`No hay campos "qdrq" y "htje" en el objeto de contrato, por lo que no se pueden mostrar los datos.`,
"label.partnerCloud.orderingPlatform.noProduct":`No se requiere la configuración de la opción de producto bajo este producto.`,
"label.totalsummary":`Resumen acumulado`,
"label.partner.workspace.tab":`Menú`,
"label.entitlement.process.name.unique":`Este nombre ya existe, vuelve a introducirlo`,
"report.label.norole":`No tiene el permiso necesario, por favor, póngase en contacto con su administrador.`,
"label.password.old.error":`Las contrase?as antiguas son incorrectas, intente de nuevo`,
"lable.account.quarter.stadate":`Día de inicio del trimestre fiscal`,
"label.salescloud.contactrole.choose.correct":`Contactos duplicados seleccionados, por favor corrija`,
"label.schedulejob.setup.schedule.day":`Día`,
"label.communalusergroup":`Grupos públicos`,
"label.Display.Fields":`Campos que aparecen en la lista de citas de servicio`,
"label.marketsea":`Grupo público`,
"label_partner_setup_address":`Dirección de la nube de socios`,
"label.industrialandcommercialverification.label.url":`URL`,
"lable.data.exp.newtemp":`La exportación de datos y Elaboración de Plantilla`,
"label.pc.ui.2018":`Menú Vertical`,
"label.version.free":`Edición gratis`,
"label.dataimport.contact.length":`Error: la longitud del nombre de contacto es demasiado larga`,
"label.cy.vlidate":`La activación de moneda es irreversible. ?Está seguro de que quiere activar la gestión de moneda?`,
"label.recycle.all":`Todas las papeleras de reciclaje`,
"label.message.changeaccount.isnot":`El contacto ha activado el usuario de socios, no se puede cambiar la información del cliente`,
"label.searchlayout.exactsearch":`Notas: Marque la casilla de verificación detrás del campo de búsqueda para proceder la búsqueda precisa de este campo`,
"label.file.size.limit":`Nota: El tamaño máximo permitido es de 10MB`,
"label.mobileapp.modelsetting1":`Configuración de módulo de recomendación en la aplicación móvil`,
"template.report.overall.sales.opportunities":`Período global de ventas (por tipo de oportunidad)`,
"label.password.update.success":`?Cambio de contrase?a exitoso!`,
"label.import.page3.gobackhome":`Volver al inicio`,
"label.phone":`Móvil`,
"label.detail.vlidaterule":`Ver regla de validación`,
"label.weixin.input.usernames":`Por favor introduzca el nombre de usuario`,
"label.icon.85":`Transformador`,
"vue_label_systemSettings_partner":`Socio`,
"label.processsetting.new.process":`Nuevo proceso`,
"Lead_Scoring_Setting_Rule_Setup_01":`Lista de reglas de puntuación de los candidatos`,
"setup.layout.component.area":`Área`,
"label.createnewpwdinformuser":`Genere nueva contrase?a y notifique inmediatamente a los usuarios`,
"label.pwinfo":`Detalles de contrase?a`,
"label.imgfield.type.url":`Imagen de referencia`,
"label.attendance.sxccheckincy":`Registro de miembros de campa?a`,
"lable.PowerProcess.condition.input":`Seleccione condición`,
"label.partnerCloud.partnerAccount.topUpFailure":`Recarga fialada`,
"label.document.size.too.long":`El tama?o del documento excede`,
"label.link":`Enlace de acceso`,
"label.partnerproduct.sort.repeat":`Se toma el nombre de la familia de productos.`,
"label.data.setok.e_desc2":`Página de lista de exportación de datos`,
"front-project-module-v1-plase-input-project-name":`Por favor, introduzca el nombre del proyecto`,
"label.export":`Exportar`,
"label.icon.45":`Caldera`,
"label.autoRegister.changepwd.title":`Configure la contrase?a del inicio de sesión`,
"label_clear_adjust":`Eliminar ajustes`,
"front-kefu-moudle-return-visit":`Revise`,
"label.ems.compose":`Componer`,
"Pagelayout_Setup_002":`Ha seleccionado 3 listas relativas, si quiere añadir más, afectará el dise?o de la página`,
"label.service.gantt.skill.screening":`Utilizar el filtro de habilidades`,
"label.partnerCloud.basicSetting.enable":`La Nube de Socios será desactivada. Las acciones de inicio de sesión y de edición en su organización serán desactivadas automáticamente por el sistema.`,
"label.workbanch.setup.description":`Puede configurar las vistas siguientes para que se muestren en la mesa de trabajo.`,
"label.category.1":`Todo`,
"label.foldername":`Nombre de carpeta`,
"label.forecast.settings.shuliang":`Cantidad de previsiones`,
"label.emailmerge.newtemplate.word":`Por favor sube los documenos word`,
"message.error.type":`El type puede estar vacío, tiene que pasar el tipo public o personal private.`,
"label.manualallocation":`Asignar manualmente`,
"label.addattachment.step2":`Paso 3. Haga clic en ¨Subir archivo¨`,
"label.company":`Compa?ía`,
"label_emailsync_status_export":`Exportar el fichero en formato Excel_csv`,
"label.eventreminder":`Recordatorio de evento`,
"label.emailtemplate.lookup":`Ver plantillas de correo`,
"label.customsetting.touse.getCustomSetting":`Consultar el tipo de "jerarquía" de las configuraciones personalizadas, devolver el apiName correspondiente y los permisos (el ID es el ID del perfil o el ID del usuario), Map map = cs.getCustomSetting(String apiName, String id);`,
"label.projectManagement.Resourceuse":`Uso de recursos`,
"label.appointment.wizard.subtitle4":`Ajustes del buffer y del tiempo`,
"label.donot.close.your.browser":`Durante el proceso, no haga clic en otro enlace o cierre el navegador Web`,
"label.multilang.customforcast.target":`Objetivo de {0}`,
"setup_layout_label_newarea":`Nueva Area`,
"component.timeline.button.more":`Más pasos`,
"label.appointmentdetail.wizard.title3":`Duración`,
"label.help.new.features.pc":`Guía de operación de las nuevas funciones en PC`,
"label.mr.record":`Registro`,
"label.trigger.wgd":`Triggers no archivados`,
"label.icon.72":`Caja De Herramientas`,
"setup.layout.label.detailpage":`Página de detalles`,
"frame.personinfo.label.usethisimage":`Utilizaremos la imagen deformada de esta miniatura en el entorno de la aplicación.`,
"label.multilingual.confirm.open":`¿Está seguro de que lo ha habilitado? Se puede utilizar el multilenguaje después de habilitarlo.`,
"label.recordcreater":`Creado por`,
"label.afterfinish":`Al finalizar, haga clic en ¨Guardar y Crear¨ para crear más campos personalizados; una vez termine la operación de crear , haga clic en ¨Guardar¨`,
"label.companyinformation":`Información de Empresa`,
"step1":`Paso 1`,
"label.sales.page.dashboard.add":`Añadir al Tablero de la Pagina de inicio`,
"label.processsetting.process.enabled.failed":`No se ha podido eliminar el proceso.`,
"label.document.history.date":`Fecha`,
"label.linkedin.title":`LinkedIn-H5MiniApp`,
"label.foldervisitlimit1":`Todos los usuarios pueden acceder a esta carpeta`,
"april":`Abril`,
"label_emailsync_form_disconnect":`Cancelar la vinculación`,
"label.appointment.wizard.subtitle4-2-6":`2 Días`,
"vue_label_notice_follow_success":`Suscrito`,
"label.startuploadfile.success":`Al hacer clic en ¨Empezar a subir¨, si la barra de progreso alcance a 100%, el archivo ha sido subido con éxito y desaparecerá en la área superior`,
"message.accesstoken.acquisition.failed":`No se ha podido obtener el token de acceso.`,
"label.quickbooks.fieldlabel.fistname":`Nombre`,
"label.appointment.wizard.subtitle1-5":`1h`,
"2018UI.Homepage.DataNoAccess.Info":`No tiene permiso para ver este registro, por favor haga clic para volver al paso anterior.`,
"label.batchaddattachments":`Añadir adjunto masivo`,
"label.ems.next":`Siguiente`,
"label.quote.zhekou":`Descuento`,
"lable.product.notdel":`Porque está asociado con el registro de otro catálogo de precios, el registro relativo es lo siguiente.`,
"label.ems.action":`Operación`,
"message.error.chart.type":`?El tipo de gráfico no puede estar vacío!`,
"label.conditiontag.lookup.value":`Valor`,
"label.chatter.allactivity":`Todas las actividades`,
"label.summaryreport":`Informes de resumen`,
"label.textmessage.vonage.action":`Acción`,
"label.ccpeak.must.result":`Debe utilizarse como as de alias para obtener el resultado`,
"label.data.newtemplate.savetemp.desc":`Rellene atentamente el nombre de plantilla y descripción para facilitar su uso.`,
"label.projectManagement.search.for.users":`Buscar usuario`,
"component.milestones.label.title":`Hito`,
"vue_label_applauncher_description_accountpool":`Utilice el grupo público de clientes para gestionar cómodamente el estado de seguimiento dentro de la organización y motivar al personal a completar la transacción.`,
"label.import.index.startimport":`Iniciar Importación`,
"page.field.masterinput2":`Importar Maestro-Detalle`,
"label.mobile.change.owner.permission":`El nuevo propietario debe tener el permiso de lectura sobre este tipo de registro`,
"label_partner_common_enable":`Activar la nube de socios`,
"label.log.browser":`Navegador`,
"label.app.step4":`Paso 4. Seleccione el menú`,
"lable.quote.syncing.opportunity":`Oportunidades`,
"label.forecast.customforecast.foredis.jqz":`Valor preciso`,
"label.forecast.forecastroleuserpage.title":`Asignación de gerente de previsiones`,
"label.starting.quarter":`Cuarto de partida`,
"label-combination-record":`Registro {índice}`,
"label.here":`Aquí`,
"label.weixin.underfind.error":`Error desconocido`,
"label.cloudccclass.list.tip.time":`Permitir a los técnicos desarrollar la clasificación programada  en CloudCC.com, que pueden utilizar para los programas previstos`,
"label.data.setok.t_desc1":`Si necesita utilizar esta plantilla para exportar los datos, haga clic en `,
"label.service.gantt.break.rules":`Incumplimiento de las normas`,
"label.weixin.no.pending.ywjh.qin":`No hay oportunidades en los proximos 30 días`,
"label.view.atleastone":`La lista no se puede estar vacío`,
"label.attendance.sxccheckin":`Asistencia de Compa?a`,
"label.custom.split":`Dividir`,
"front-kefu-moudle-v1-yesorno-delete-templete":`¿Está seguro de que quiere eliminar esta plantilla?`,
"label_chatter_theme":`Tema`,
"label.partner.new.step1":`Paso1: Seleccione las plantilla que quiere`,
"vue_label_commonobjects_view_settings":`Configuración de la vista Kanban`,
"UG_Contract_02":`El contrato es un acuerdo escrito entre todas las partes. Muchas empresas utilizan contactos para definir ítems de negocios con otras empresas. Utilizar CloudCC para establecer los contratos existentes con sus clientes y oportunidades. Siga el contrato via el proceso de aprobación. Utilizar los recordatorios del flujo de trabajo para recordarle sobre la renovación de contrato.`,
"label.setup.mobilesetup.isenableh5newandedit":`¿Ha habilitado Editar/Nuevo de H5 en el dispositivo móvil?`,
"label.attendance.edit":`Editar Asistencia`,
"label.service.miniProgram.fillImageLink":`Introduzca el enlace del carrusel`,
"label.b.c.without":`Los registros "B" pueden contener o no registros "C" relacionados.`,
"label.sso.key":`Código de Autorización`,
"label.star_click":`Haga clic en limpiar`,
"vue_label_SMS_name_or_phone_number_lookup":`Búsqueda de nombres de registros`,
"label.case.copre.text":`También puede descargarse un código QR del portal web dedicado a su empresa y colocarlo en su sitio web o dispositivo, de modo que los clientes puedan escanear el código QR para utilizar la versión web del portal de clientes.`,
"label.salescloud.forbidden.confirm":`?Está seguro de que quiere prohibir ventas del grupo?`,
"vue_label_chat_conformactivation":`Confirmar activación`,
"label.emailtocloudcc.redmessage9":`Error en la base de datos, por favor, póngase en contacto con el administrador`,
"label.sahreto":`Compartir con`,
"label.recordtype.sort":`Los tipos de registro se muestran de acuerdo con el orden de guardarse`,
"label.allreport":`Todos los informes`,
"front-gantt-module-drag-and-drop-subtask":`Arrastre (póngalo en una tarea) para convertirlo en una subtarea.`,
"label.permission.objlist.nopermission":`No hay permiso para acceder`,
"label_file_num":`Cantidad`,
"chatter.mostword":`Los comentarios máximo serán 500 caracteres, cancele antes de publicar`,
"label.h5.chatter.comment":`Comentar sobre el cuerpo`,
"vue_label_calendar_notice_havecreated":`Has creado un calendario`,
"label.tabpage.loadz":`La página se está cargando, por favor espere...`,
"chatter.w.p":`Teléfono de trabajo`,
"label.chat.topic.name.desc":`Sólo puede cambiar el caso e intervalo del nombre de tema`,
"label_partner_template_name":`Nombre de Plantilla`,
"label.mobile.phone.required.examines.people":`El revisor es obligatorio`,
"message.error.view.notexists":`La vista no existe </br> o la vista se ha modificado por los demás, haga clic en <a href='javascript:history.back();'> aquí </a> para regresar a la página anterior`,
"label.custom_time":`Tiempo personalizado`,
"label_partner_workspace_member_all":`Todo`,
"lable.custom.year.name":`Nombre del año personalizado`,
"label.account.previous.M":`Último mes`,
"vue_label_commonobjects_detail_locking":`Bloquear`,
"label.brief.lead":`Candidatos`,
"label.linkedin.setting.appsecret":`Contraseña de la clave secreta`,
"label.query.detail.closepartner":`Desactivar los socios`,
"label.isEnableVisualpage_new.rightlist":`Página personalizada activada`,
"front-epwechat-module-v1-unbound-item3":` datos de la información autorizada`,
"label.exchange.sync.setting.info":`Al crear una cuenta de servicio con permiso virtual para los usuarios en Microsoft Exchage, ingrese credenciales de la cuenta de servicio para permitir la comunicación entre CloudCC y Exchange. Si los usuarios no pueden sincronizar los registros al guardar los credenciales de la cuenta de servico, verifiquen si configuran correctamente Exchange Sync.`,
"label.emailobject.groupemail.fail.title":`Dirección de correo de los correos masivos enviados por CloudCC`,
"label.the.upper.bound.of.each.level.of.edit.discount.must.be.greater.than.the.lower.bound.":`El límite superior para editar cada nivel de descuento será mayor que el límite inferior.`,
"label.visualpage.list.vpname":`Nombre de la página personalizada`,
"label.mask.length.error.message":`La longitud de los campos de textos cifrados no puede exceder a 255 caracteres`,
"label.h5.approval.actorname":`Lanzado por`,
"label.knowledgebase.view.translation":`Ver traducción`,
"label.ems.edit":`Editar`,
"vue_label_commonobjects_view_reset_width":`Restablecer el ancho de la columna`,
"label.version.feature.controllist":`Lista del control de funciones`,
"label.setuppagelayout":`Dise?o de página`,
"vue_label_commonobjects_view_new_view":`Nueva vista`,
"label_tabpage_queuez":`Cola`,
"label.direct.dashboard.wait.me.approval":`?tems por aprobar`,
"message.report.error.noRelatedField":`No se encuentra campo relacionado en el informe, es posible se haya cancelado, por favor contacte con el administrador.`,
"label.ccchat.person.invite.notme":`No puede enviar invitaciones a su correo propio.`,
"label.weixin.jieduan.finish":`Marque la etapa actual como completada`,
"vue_label_commonobjects_detail_?enter_subject":`Introduzca el asunto`,
"label_starting_month":`Mes de inicio`,
"label.address_linetwo":`Dirección Línea 2`,
"message.error.select.contiguous.item":`Selección de ítems relacionados con`,
"vue_label_pricebook_enterbookname":`Introduzca el nombre de la lista de precios`,
"label.cycleworkflowoperate":`Operación de flujo de trabajo periódico`,
"label.ems.withoneday":`Hoy`,
"component.todaytask.label.notask":`No hay tareas pendientes hoy, aprovecha para tomar un café.`,
"label.tianyancha.id":`ID de Compa?ía`,
"label.user.illegal.login":`?Login ilegal!`,
"label.withgathercondition":`Por los criterios de resumen`,
"label.foldervisitlimit":`Permiso de acceso`,
"label.ccchat.search.conversation":`Buscar esta conversación`,
"lable.annual.project.report":`Informe de la cuenta del proyecto en este año`,
"template.chart.qzkhzhfx":`Análisis de conversión de clientes potenciales`,
"label.my":`Mi`,
"label.sendsms.batch.chosetemplate":`SMS Masivos: Seleccionar una plantilla o editar los contenidos`,
"label.callcenter.enterprise.number":`Nº de empresa`,
"label_last_modified_by_time":`Último modificador y hora`,
"message.fieldtrack.operaterecord":`Cambiar <b>operatefield</b>de<b>operateold</b>to<b>operatenew</b>`,
"label.mobile.more.openin":`Abierto de forma`,
"label.multilingual.tip2":`Puede activar o desactivar el multilingüismo.`,
"label.datamanage.lead.novalue":`?Notas: El campo del nombre de candidatos está vacío, los registros de contacto no será importados!`,
"label.custom.revoke":`Deshacer`,
"label_chatter_leaveword":`Comentario`,
"vue_label_ccchat_group_deletedgroup":`El grupo ha sido eliminado`,
"label.tabpage.operationz":`Campo, la operación no puede estar vacía`,
"label.user.organization.permit.overdue":`?La licencia de su organización se ha caducado, contacte con el administrador!`,
"label.log.datetimeoruser.value":`?Ingrese la hora y el nombre de usuario!`,
"lable.product.stsp.noavailable":`No hay precio estándar disponible`,
"label.appservice.cannot.delete.app":`No puede cancelar la aplicación personalizada, porque algunos perfiles están utilizando esta aplicación personalizada como aplicación predeterminada.`,
"component.event.label.newevent":`Nuevo evento`,
"label.view.sortview.exportview":`Exportar la vista`,
"label.uploadfilemaxsize":`?El valor máximo permitido para subir los archivos es?`,
"label.event.weekview":`Vista semanal`,
"label.conversion_rate":`Tasa de conversión`,
"label.partnerCloud.partnerAccount.useWechat":`Utiliza el escaneo de WeChat para pagar.`,
"UG_Forcast_05":`Configuración de previsiones: Paso {0}/{1}`,
"label.service.gantt.jobresour":`Mostrar sólo los recursos de trabajo`,
"vue_label_campaign_fromopprotunities":`Oportunidades de negocio de {dsrjine}`,
"label.app.skyblue":`Azul del cielo`,
"label.chinacloudcc":`Computación de nube China`,
"label.connectOtherFinalNumber":`Límite de objetos alcanzado<br/>Puede asociar hasta 4 objetos con el origen de datos de informe personalizado.`,
"label.redistributionrequest":`Asignar de nuevo las solicitudes de aprobación`,
"label.knowledge.category.button.one":`Añadir subcategoría`,
"label.campagin.pcandmo":`PC y Móvil`,
"label.project.milestone.date":`La fecha del hito debe estar dentro del rango de fechas del proyecto al que pertenece.`,
"assetbom.transfer.notpermission":`No tiene permiso para migrar la lista de materiales de los activos. Póngase en contacto con el administrador`,
"label.marketing.setting1":`Canal de marketing`,
"label.select.file":`Seleccione el archivo`,
"message.error.object.contactadministrators":`El sistema es anormal, por favor, póngase en contacto con el administrador del sistema para obtener ayuda.`,
"label.custom.quarter.title":`Trimestre personalizado`,
"label.knowledge.case.settings":`Ajuste de casos`,
"front-service-cloud-transfer-title":`Transferencia de activos BOM Propietario`,
"label.group.search.searchthisfeed":`Introduzca el contenido de búsqueda`,
"label.report.action.addtodashboard5":`Agregue a panel nuevo`,
"label.mobile.side.tab.remark2":`Al configurar la barra lateral, puede poner los ítems más utilizados en la posición delante; historial de llamadas y el menú sólo son disponibles para la versión Android de CloudCC móvil`,
"contain":`Incluya`,
"label.select.template":`Seleccione plantilla`,
"label.addattachment.step3.weixin":`Paso 3 Haga clic en ¨Completar¨ y regrese a la página anterior`,
"lable.Order.successfully":`Transferir la orden al activo con éxito.`,
"label.user.title":`Título`,
"label.weixin.check.agreement":`Marque los acuerdos relativos`,
"label.SMS.pfi":`Campo de número de teléfono`,
"label.weixin.micro.research":`Miscro encuesta`,
"label.projectManagement.assigned.work":`Trabajo asignado`,
"label.document.login.error":`Error al iniciar sesión, intente de nuevo.`,
"label.mobile.phone.examines.people":`Revisado por`,
"label.safetyset":`Configuraciones de seguridad`,
"label_function_tip":`Esta función no es compatible actualmente con los usuarios de China continental. Le agradecemos por su comprensión.`,
"label.app.sort":`Ordena aplicaciones`,
"component.sendmail.label.cc":`CC`,
"label.titlename":`Título`,
"label.event.moveup.3day":`3 días con antelación`,
"label.condition":`Condiciones`,
"label.description.message":`Los caracteres de notas no exceden 500`,
"label.ems.detailedsettings":`Configuración de detalles`,
"label.repeat.condition.field.prompt":`?Rellene un número en el campo de ¨De acuerdo con la longitud de caracteres¨`,
"label.validate.function.funcExplain.OR":`Revise que cualquier parámetro sea verdadero, y regresa TRUE o FALSE. Regresará FALSE solo cuando todos los parámetros sean falsos.`,
"label.salecommit.allow.prediction.query":`No puede ver los paneles de compromiso de ventas porque no ha marcado la opción de permitir previsiones en Configurar-Mi Información Personal-Configuración personal.`,
"front-kefu-moudle-soft-phone":`Softphone`,
"label.view":`Vista`,
"front-gantt-module-quick-create-task":`Crear una tarea rápidamente`,
"label.all_forms":`Todos los formularios`,
"front-lightning-module-v1-dashborad-statistical-dimension":`Dimensión estadística`,
"label.forecast.settings.data.chanpin":`Fecha de producto`,
"label.appointment.wizard.subtitle4-2-7":`3 días`,
"front-web-module-v1-detail-comment-please":`Por favor, introduzca los comentarios`,
"label_chatter_nextSevenday":`Próximos 7 días`,
"homepage.components.desctiption":`Esta página le permite crear o editar los componentes mostrados en el dise?o de la página oficial.`,
"label.customcomponent.page.index.table.namespace":`Prefijo del espacio de nombre`,
"label_emailtocloudcc_exists":`El correo electrónico ya existe.`,
"label_tabpage_save":`Guardar`,
"label.mergeRechecking":`Comprobar la duplicación y la fusión`,
"vue_label_helpcenter_view2":`En la vista de pantalla dividida, puedes ver rápidamente la información detallada de cada dato. <br> 3. Analizar rápidamente los datos de ventas<br> En la esquina superior derecha de la vista, puedes abrir el gráfico de la vista para realizar un análisis visual simple de los datos de la vista. Al mismo tiempo, puedes ver el tablero y la lista de informes relacionados con los datos de la vista para un análisis más profundo. <br>Haga clic en el botón de gráfico en la esquina superior derecha, puedes ver, crear, editar gráficos simples creados con los datos de la vista, o ver cuadros de mando relacionados con la vista actual. <br> Paso 1: Haz clic en el botón de gráfico en la esquina superior derecha para expandir el gráfico en la página. Puedes ver y gestionar los gráficos existentes según los permisos, y ver la lista de cuadros de mando relacionados con los datos de la vista. <br> Paso 2: Haz clic en el botón Configuración, puede crear, editar y eliminar gráficos según los permisos. Puedes crear cuatro estilos de gráficos, gráfico de columnas verticales, gráfico de columnas horizontales, gráfico circular y gráfico de embudo. <br> <br> Haga clic en el botón de informe para ver los informes relacionados con la vista actual. <br> 4. Gestionar los datos en la vista<br>En la vista, según el permiso que tienes, puedes añadir, editar, eliminar y cambiar el propietario de los datos a través de los botones en la parte superior derecha de la vista o al lado de cada dato. <br> <br> Utilizar las etiquetas para ayudar a la gestión de tus datos. Utiliza el botón de la derecha para ampliar la lista de gestión de etiquetas, y podrás filtrar los datos de la vista en función de las etiquetas. Después de hacer clic en Gestionar Etiquetas, también puede mantener y gestionar su biblioteca de etiquetas. Después de seleccionar los datos, utiliza el botón Añadir Etiqueta en la esquina superior derecha para añadir etiquetas a los datos por lotes.`,
"label.app.ismobile":`Mostrar en la aplicación móvil`,
"chatter.group.changeTheGroupPicture":`Cambiar foto del grupo`,
"label.mr.descreption.reDataList2":`Registros de repeticiones`,
"vue_label_chatter_agree_join":`Aceptar`,
"label.planned.nextrun":`Ejecutar en el siguiente programa`,
"Homepage.News.003":`No se pueden mostrar las noticias por no disponer de datos de clientes, se mostrarán las noticias del cliente cuando cree un nuevo cliente`,
"label.summaryreport.selectpictype":`Seleccione el tipo de gráfico y otras opciones de gráfico`,
"label.app":`Aplicaciones`,
"label.trigger.name":`Nombre de Trigger`,
"vue_label_email_private_template":`Plantilla privada`,
"label.appointmentpage.wizard.subtitle1":`Seleccione fecha y hora La zona horaria del invitador es {0}`,
"label.partnerCloud.orderingPlatform.payment":`Pedir el pago`,
"label.stdashbord.xsld.title":`Embudo de ventas`,
"vue_label_pool_poolname":`Nombre del grupo público`,
"label.ServiceCloud.fuwuyuyue.distributionMap":`Mapa de distribución de citas de servicio`,
"front-lightning-module-v1-dashborad-target-value":`Valor objetivo`,
"label.reportsSubscriptionPage.email.keywords":`Introduzca las palabras clave para la búsqueda`,
"label.appointmentconfirmail.wizard.subtitle1":`Nombre de evento`,
"label.limited_scanning":`El billete de entrada es sólo para escanear para registrarse en el sitio`,
"label.weixin.nomore":`No más`,
"february":`Febrero`,
"label.view.filterbyowner":`Filtrar por propietario`,
"label.contentType":`Extensión de Documento`,
"label.customobjdel.master.hsiang":`El campo de relación Maestro-Detalle ha sido creado en este objeto, por eso no puede cancelarlo.`,
"lable.Removal.succeeded":`Eliminado con éxito.`,
"label.weixin.end.incorrect":`El formato de la fecha finalizada es inválido`,
"label.email.cc.recipients":`Cc`,
"label.taskevent.list":`Lista de actividades`,
"label.formula":`Fórmula`,
"label.h5.new.errorheader":`Revisar los errores en esta página`,
"label.emailobject.template.private":`Privado`,
"label.visualpage.component.n4":`4. Variable. Puede utilizar los variables directamente, y tenga en cuenta de que no haya comillas simples`,
"label.newemailnotice.step1":`Paso 1: Seleccione objeto`,
"label.chatter.file":`Archivo`,
"vue_label_checkduplicate_rules":`Establecer reglas de comprobación de duplicados`,
"label.appointment.wizard.subtitle1-6":`1.5h`,
"label.customReportType":`Origen de datos del informe`,
"vue_label_email_with_accessories":`Correos electrónicos con archivos adjuntos`,
"label_efine_assessment_cycle":`Fijar el período de evaluación`,
"label_emailtocloudcc_button_sure":`Confirmar`,
"label.forecast.userenablepage.isusing":`Usuarios activados`,
"lable.goal.description":`Descripción del objetivo`,
"message.error.serviceresource.relatedrecordid":`Cada usuario solo puede ser añadido como un recurso de servicio de tipo {0}`,
"label.weixin.addbus.information":`Añadir información de vehículo`,
"label.emailtocloudcc.button.view":`Ver`,
"label.detail.workflow":`Ver flujo de trabajo`,
"label.standardfilter":`Filtros estándar`,
"label.mobile.phone.results":`Rendimiento`,
"chatter.feed.unavailabled":`No activado`,
"label.view.sortview":`Ordenado por vista`,
"label.availabilityobject.wizard.title":`Tiempo libre`,
"Main_Menu_Mobiledownload":`Se puede utilizar`,
"chatter.sticker":`Seguido`,
"label.workflow.intruduce":`Configure el flujo de trabajo de la organización a través de crear reglas del flujo de trabajo. La regla consiste en:`,
"label.customfields.richtext.tip":`Permite a los usuarios ingresar texto formateado, a?adir imagenes y enlaces. Hasta 32,768 caracteres en líneas separadas.`,
"label.new.cy.select":`Seleccione una nueva moneda de la lista disponible`,
"template.chart.schdzqzkhzhqk":`Conversión de clientes potenciales en las campañas`,
"label.forecast.customforecast.cpxl":`Serie de producto`,
"front-electronic-signature-open-service":`Habilitar la firma electrónica`,
"label.datamanage.import.field":`Importar Campos`,
"chatter.email.sendMessageToMe":`Al enviarme un mensaje`,
"message.cannotusebefore":`Recuerde que no puede utilizar este proceso de aprobación hasta que sea activado.`,
"label.textmessage.vonage.api.secret":`Secreto de la API`,
"label_chatter_newEvent":`Nuevo evento`,
"label.ji.year":`{un} año`,
"label.sendmail.step2":`Paso 2: Seleccione una plantilla de correo`,
"label.console.step5.record":`Abrir registros`,
"label.customfields.totalsummary.gettogetherfield.isnull":`Seleccione los campos para fusionarse`,
"vue_label_commonobjects_detail_current_recorder":`El nuevo propietario también se convertirá en el propietario de los registros relacionados con este proyecto, y estos registros son propiedad del actual registrador`,
"label.SMS":`Notificación de SMS`,
"label.reconfigure.bundle":`Reconfigurar el paquete`,
"front-kefu-select-region":`Seleccione la zona donde se encuentra la instancia`,
"chatter.feed.deletefeeds":`?Está seguro de que quiere cancelar esta publicación y sus notas?`,
"label.customsetting.manage.introduce.h":`Si la configuración personalizada es una jerarquía, puede añadir datos para usuario o perfil. Por ejemplo, puede mostrar los valores diferentes de acuerdo con si es un usuario específico, un perfil específico o solo un usuario general.`,
"label.product.name":`Nombre de producto`,
"vue_label_commonobjects_view_saveas":`Guardar como`,
"label.group.my.archived":`Mis grupos archivados`,
"vue_label_pool_coflictmethods":`Reacio al modo de venta actual`,
"label.appupload.upload":`Subir`,
"lable.SalesCommitmentKanBan.signedTaskRate":`Tasa de finalización de tareas asignadas`,
"label.dashboardStandard":`Paneles estándar`,
"label.niboer.time":`Hora de Nepal`,
"label.emailtocloudcc.filed.email":`Correo electrónico`,
"market.name.social.post":`Mensajes sociales`,
"evaluation.detail.notfound":`No se encuentra el detalle del comentario`,
"label.layoutoftestobj":`Probar objetos Dise?o`,
"label.example":`Ejemplos`,
"label.campaign.channel.step6.remark6":`Visite aquí`,
"chatter.emailLike":`Me gusta`,
"label.knowledge.category.button.two":`Editar categoría`,
"label.alluser":`Todos los usuarios`,
"addadvancedconditions":`Añadir Opciones Avanzadas`,
"message.selectgsummarycondition":`Por favor seleccione por los criterios`,
"message.duplication.label.sectionremar2":`Atención: Todos los registros relacionados, incluye las notas, los adjuntos y las actividades, se asociarán con el nuevo registro combinado.`,
"vue_label_helpcenter_product&pricebook":`Los Productos son su catálogo básico de todos los artículos y servicios que vende y de sus precios estándares. La lista de precios le permite crear una colección personalizada de productos y precios de lista asociados para usuarios específicos.`,
"message.duplication.label.isprofile":`Por permiso`,
"component_setup_label_milestonesfield":`Campo de hito`,
"setup_layout_label_required":`Requerido`,
"component_chatter_label_title":`?litma publicación`,
"label.assignment.setup.detail.order":`Número de orden`,
"vue_label_pool_unassigned":`No asignado`,
"UG_Lead_007":`Sync de Google`,
"label.knowledge.record":`No existen datos relevantes.`,
"label_tabpage_filetypez":`Tipo de archivos`,
"label.ccpeak.if.error.message":`Si regresa un error: utilizar`,
"label.intialsubmitter":`Remitentes iniciales`,
"label.wei.icon":`?cono`,
"label.mask.show.last.4":`Mostrar solo los últimos 4 dígitos`,
"lable.PowerProcess.time.trigger":`Disparador de tiempo (min)`,
"july":`Julio`,
"label.usestandardwizard":`Utilizar Configuración Estándar Wizard`,
"label.two.quarter":`Segundo trimestre`,
"label.size":`Tama?o`,
"label.integrations.mailchimp.massage4":`No se instala Mailchimp. Configure el Mailchimpen ¨Integraciones¨`,
"label_emailtocloudcc_step2total3":`Paso 2 de 3`,
"vue_label_chat_customer_group_strategy":`Plan de equipo de clientes`,
"label.searchvalue":`Buscar valores`,
"label.sendemail.birthday.title":`Recordatorio de cumpleaños`,
"label.projectManagement.planned.days":`Número de días planeados (días)`,
"label.service.gantt.workhours":`Basado en la hora de trabajo`,
"label.notification.approval5":`Aprobación Delegada：【提交人】está solicitando la aprobación de 【对象】`,
"label.service.miniProgram.bindAddressDesc":`Portal del miniprograma de atención al cliente de CloudCC:`,
"chatter.error.wt":`Error: Tipo de archivo inválido.`,
"vue_label_calendar_my_calendar":`Mi calendario`,
"label.customername":`Cliente`,
"label.salescloud.salesdashboard.huikuan.rankings":`Ranking de Grupo-Pago`,
"message.query.opportunity.contactrole.error":`La búsqueda del rol predeterminado del contacto de oportunidad se frascasó, contacte con el administrador`,
"noequal":`no igual a`,
"label.document.searchcustominfo":`Ingrese palabras clave para encontrar los documentos coincidentes`,
"label.account.PreviousFQ":`Trimestre fiscal anterior`,
"label.file.f":`Archivos`,
"label.dashboard":`Paneles`,
"label.report.folder":`Carpetas`,
"batch.edit.permission.list":`No hay permiso para editar la lista de datos`,
"label.file.orderbyowner":`Ordenado por propietario`,
"label.exchange.sync.account.password":`Contrase?a de la cuenta de servicio`,
"pagecreator.button.publish":`Publicar`,
"label.modify":`Editar`,
"label.exchange.sync4":`Estado`,
"label.remark.information":`Información de notas`,
"label.service.without.major.event":`No hay eventos clave importantes que mostrar`,
"label.knowledgebase.release.status":`Publicar estado`,
"label.tabpage.ok":`Aceptar`,
"label_screening_assessment_content":`Filtrar el contenido de evaluación`,
"label_partner":`Nube de socios`,
"label.user.detail":`Ver usuarios`,
"front-kefu-moudle-or-this":`o, ¿así?`,
"label.unselect.object":`Objeto Seleccionable`,
"label.quote.contactfax":`Fax`,
"label.weixin.appmanage.alert":`Presione {0} para remover las aplicacioens de mis a Apps, Presione {1} para añadir aplicaciones a mis Apps`,
"vue_label_dashboard_thisfolder":`Añadir el cuadro de mandos público a esta carpeta`,
"label.delete":`Eliminar`,
"label.appexchange.installedpage.message1":`Puede ver y descargar aplicaciones directamente en CloudCC App Store y instalarlas en su CloudCC.com`,
"label.mobile.phone.required.summary":`El resumen es obligatorio`,
"label.batchadd.newbatchpage.addtr":`Un máximo de 30 registros se puede añadir`,
"label.partnerCloud.partnerAccount.lockLine":`Importe bloqueado`,
"label.emailsync.status.connectstatus":`Estado de asociación`,
"label.campaignmember.main.importmember.lead":`Importar miembros-Candidatos actuales`,
"message.username.isnull":`?El nombre de usuario no puede estar vacío!`,
"label.forecast.tree.enableuser":`Activar usuarios`,
"label.multilang.view.viewmessage":`Esta vista se ha aplicado al dispositivo móvil, puede seleccionar hasta 10 campos, ahora hay {0}:`,
"friday":`Viernes`,
"label.sendemail.activity.neweventtitle":`Notificación de eventos nuevos`,
"label.page.addtabto.user":`Adjuntar el menú a la configuración personalizada existente`,
"front-kefu-moudle-v1-connect-phone":`Número de teléfono del asociado`,
"label.wei.pollis":`Votar por`,
"lable.opppdt.editPdt.title":`Editar productos de oportunidad`,
"label.permission.objectpermission.recordfenpei":`Asignación del tipo de registro`,
"pagecreator.layout.message.delete.success":`Diseño borrado con éxito`,
"label.dataimport.isdupecatcher":`Ejecutar filtro de duplicados`,
"label.deletelayout.tip":`Para cancelar el dise?o de una página, debe seleccionar otra página para reemplazarla.`,
"label.projectManagement.No.matching.data":`No hay datos de coincidencia`,
"pagecreator_page_message_delete_success":`La página se ha cancelado con éxito`,
"label_tabpage_equalz":`Equivale a`,
"label.ems.emailsetup":`Configuración de correo`,
"label.decimaldigits":`Decimales`,
"component.chatter.button.delete":`Eliminar`,
"label.isallowreport":`Permite los informes`,
"label.view.appliedMobile.message":`Marque este ítem, Paso 3. Seleccione hasta 6 campos para mostrarse`,
"label.must.positive.integer":`El número deber ser un entero`,
"label.preview.print.template":`Vista previa de la plantilla de impresión`,
"label.schedulejob.setup.schedule.start":`Empezar`,
"UG.Case.04":`Asignación de casos`,
"vue_label_pool_move1":`{1}{2}`,
"label.list.userinterface.enableHoverDetails":`Activar flotante para mostrar los detalles`,
"vue_label_email_alltemplates":`Todas las plantillas`,
"label_report_chose_obj":`Seleccione la relación de objeto y origen de informe de datos`,
"label.partnerCloud.productSet.del":`Borrar elemento`,
"label.quote.shrdz":`Dirección del destinatario`,
"page.approval.history":`Historial de aprobación`,
"lable.outlook.detail.prefc":`Siempre Preferido CloudCC.com`,
"label.translation.unable.display.view":`No se puede mostrar la vista`,
"label.encrypt.change":`Conversión de campo encriptado`,
"button.partner.workspace.login.logo.upload":`Subir imagen`,
"label.batchadd.mustinput2":`Es obligatorio, el registro no se guardará si la información obligatoria está vacía`,
"label.dataimport.update.error.check":`Un error se ocurrió al actualizar los datos, revise este dato atentamente. `,
"label.staticresource.name.already.exists":`?El nombre único de recurso estático ya existe!`,
"label.appupload.upload.install.success":`Se ha instalado con éxito`,
"label.conditiontag.lookup.true":`CIERTO`,
"label.quickbooks.viewlist.customer":`Cliente`,
"label.field.edit.change2":`La evaluación máxima es 1 al menos`,
"label.fianalrejectoperate":`Operación de rechazo final`,
"label.ccpeak.wgd":`Clasificación no archivada`,
"label.reportsSubscriptionPage.condition.emailreport":`Resumen   Informe`,
"label.detailinf":`Detalles`,
"label.eastem.standard.time":`Hora estándar de Este`,
"chatter.group.manager":`Administrador`,
"label.manage_columns":`Gestionar la cabecera`,
"label.daylight.time":`Horario de Verano`,
"label.weixin.mycar.information":`Mis vehículos`,
"label.ccpeak.help":`Ayuda para clasificaciones`,
"lable.outlook.detail.match":`Coincide con los criterios`,
"label.version.nonsupport.approval":`?El proceso de aprobación no está disponible temporalmente!`,
"label.custom-tailor":`Personalizar`,
"label.showoperate":`Mostrar operaciones`,
"label.view_edit":`Ver y editar`,
"label.lead.score.prompt2":`Seleccione el rango de puntuación, haga lien en el botón de [Lead Scoring], cel sistema hará la puntuación para los candidatos seleccionados de acuerdo con la regla de puntuación activada.`,
"label.datamanage.savetemplate.error":`?Error al guardar la plantilla!`,
"label.source":`Origen`,
"label.multilang.customfieldsetup.reference":`Este campo fue referido por {0}:`,
"chatter.poll.option7":`Opción 7`,
"label.login.access.day":`día(s)`,
"label.icon.66":`Equipo`,
"label.tabpage.kanbansetup":`Configuración del panel de control`,
"label_emailtocloudcc_step1_lead2":`Una vez configure, los correos recibidos en este correo serán marcados como registro de candidatos de CloudCC. Aségurese de que no pierda ninguna oportunidad comercial.`,
"label.partnerCloud.partnerAccount.numericValue":`El importe de la recarga será un valor numérico.`,
"label.permission.detail.app.object.tip":`Configuración de objetos, campos y acceso de menú`,
"label.emailobject.template.subject":`Asunto`,
"template.report.month.customer":`Cuentas de este mes`,
"label.weixin.formerly":`Pasado`,
"label.contract":`Contrato`,
"label.help":`Ayuda`,
"vue_label_homepage_setdefault":`Establecer como página de inicio por defecto`,
"label.icon.52":`Generación De Energía`,
"label.customfields.file.count":`Cantidad de ficheros`,
"UG_Account_07":`Importar clientes`,
"label.addattachment.ntko":`Editar en línea`,
"label.service.ganttBaiduMap.assign.service":`Asignar cita de servicio a esta persona`,
"vue_label_file_my_file":`Mi archivo`,
"label.custom.page.hide":`Ocultar`,
"label.addexistoperate":`Añadir la operación existente`,
"label.already.startdate":`Hora de comienzo`,
"label.partnerCloud.financeSetting.alipay":`Necesita abrir una cuenta comercial de Alipay. Sólo se admite la cuenta comercial como cuenta de recibo. Alipay cobrará los gastos de transacción al beneficiario.`,
"label.dashboard.summary.editPageFooter":`Editar pie de página`,
"label.category.8":`Bienes De Consumo`,
"label.forecast.customforecast.foretype.best":`Mejor caso`,
"message.validation.isnull":`Ingrese un valor`,
"label.savewxpay.failure":`No se ha podido guardar la información de la cuenta de pago de WeChat`,
"label.file.stop.sharing.desc1":`Terminar con`,
"label.opportunity.setting.showstage。read.info":`Las etapas de oportunidad no pueden ser modificadas manualmente después de marcar`,
"UG_Campaign_003":`Crear una campa?a`,
"label.edit.field.select.showoptions":`Mostrar todas opciones`,
"message.inputplatformpwd":`Introduzca la contrase?a del administrador`,
"vue_label_systemSettings_mobel_set":`Configuración de la aplicación móvil`,
"label.projectManagement.thefirstone":`Este es el primer registro`,
"label.data.newtemplate":`Crear plantilla de exportación de datos`,
"label.monitorsys.delete.log":`Historial de Auditoría sobre operaciones clave`,
"label.template":`Plantilla`,
"Lead.Auto.Scoring.Setting.001":`Puntuación automáticamente al editar o guardar el cliente potencial. (Excepto los casos de importación por lotes y crear por interfaz)`,
"label.operatesuccess":`Operación exitosa`,
"label.send":`Enviar`,
"chatter.yp":`Ocultar Feed`,
"label.overall_responses":`Respuesta global`,
"vue_label_systemSettings_server_report":`Informe de servicio`,
"label.icon.113":`Casa`,
"label.partnerCloud.basicSetting.domainSet":`Configurar el nombre de dominio`,
"label.login.access.text":`Para facilitar el apoyo, puede conceder al administrador el acceso para iniciar sesión y visitar sus datos.`,
"vue_label_report_addrowlevelformula":`Añadir fórmula a nivel de fila`,
"message.duplication.label.mergeTitle":`Fusionar mi`,
"label.event.add":`Añadir eventos`,
"vue_label_homepage_bigscreen_light":`Claro`,
"setup.chatter.enabled":`No disponible, por favor contacte con el administrador para habilitar micropost.`,
"label.inputreceiver":`Puede ingresar hasta 5 correos electrónicos para enviar las notificaciones. Cada una se separa por ";".`,
"label.custom.page.custom.page":`Página personalizada`,
"label.data.exp.csv":`Formato CSV`,
"label.searchlayout.view.example":`Ver ejemplo`,
"label_tabpage_fullscreenz":`Pantalla completa`,
"label.tabpage.last":`Paso anterior`,
"lable.outlook.mcto.accepemail":`Mis direcciones de correo disponibles`,
"front-electronic-signature-isopen":`Activo`,
"vue_label_commonobjects_detail_earlier":`Ver más fechas anteriores`,
"label.name.cannot.greater.str":`El nombre puede ingresar hasta 255 caracteres`,
"label.weixin.activity.email":`Actividad : Correo`,
"label.tabpage.unequalz":`No es igual a`,
"label_calendar_year":`Año natural`,
"label.appupload.upload.installor":`Instalado por`,
"label.jixiaoswitchon":`Extender`,
"label.user.congratulations.send.finish":`Felicidades, ha completado envío masivo de correo.`,
"label.customsetting.touse.getListCustomSetting2":`Buscar "list" tipo de datos personalizados, regrese al dato individual correspondiente a nombrede API.  Map map = cs.getListCustomSetting(String apiName, String Name);`,
"label.recordtype.masterrecordtype.selectedTip":`El tipo de registro maestro no puede asignarse al perfil que ya tiene asignado un tipo de registro.`,
"label.tippage.li3":`Cualquier componente basado en el informe cancelado se volverá inválido`,
"label.weixin.no.name":`No hay subjeto`,
"label.tabpage.viewz":`Imprimir la vista actual`,
"label.create_contacts":`Crear una lista de contactos`,
"vue_label_homepage_operationitem":`Seleccione la operación del botón`,
"label.pc.ui.2018.switch.version":`Cambiar versión`,
"label.salescloud.teamrole.main":`Contacto principal`,
"label.reportsSubscription.format.report":`Informe con formato (formato Excel .xlsx)`,
"label.forecast.customforecast.total":`Total`,
"label.quickbooks.fieldlabel.lastname":`Apellido`,
"label.appointment.wizard.title2":`Detalles de la reunión`,
"label.project.template.one":`La creación de un proyecto a partir de una plantilla de proyecto requiere 2~3 minutos. Gracias por su paciente espera.`,
"label.timetrigger.workflow":`Cuando el flujo de trabajo active`,
"label.projectManagement.creator":`Creador`,
"label.customfields.formula.selectreturnfieldtype":`Seleccione el tipo regresado de fórmula`,
"label.list.userinterface.dashboard.enable":`Activar nuevos componentes del panel`,
"label.email.delete.html.format":`Todos los formatos HTML serán cancelados. ?Está seguro de cancelarlos?`,
"label.appupload.install.modifyapi":`Modificar el nombre pugnante de api:`,
"label.chat.add.topics":`Añadir un tema`,
"label.savepartner.fail":`Error al guardar la configuración de la Nube de Socios`,
"label.pc.query.new":`Ver los recientes`,
"message.duplication.label.editfiltertitle":`Editar el filtro de duplicados`,
"label.task":`Tareas`,
"label.emailobject.emaildetail.title.toaddress":`A:`,
"label.setup.mobile.bottombutton.select":`Seleccione las 4 páginas de primer nivel que desea mostrar en la aplicación móvil`,
"label.loginip.pagecue.invalido":`Dirección de internet inválido`,
"label_tabpage_listshow":`La lista muestra`,
"component.newrecords.label.10records":`10 registros`,
"label_chatter_file":`Archivo`,
"pagecreator.systemstyle.label.detailcolor":`Color del texto de detalles`,
"label.forecast.userenablepage.title":`Usuarios de previsiones`,
"front-project-module-v1-actual_working_hours":`Horashombre declaradas`,
"vue_label_systemSettings_Security":`Contención de la seguridad`,
"label.processsetting.two.select.key.fields":`Paso 2: Seleccionar los campos clave para cada paso del proceso y proporcionar indicaciones`,
"label.page.display1":`Registro de cada página`,
"label.appointmentpage.wizard.subtitle1.2":`La zona horaria del invitador es {0}`,
"label.ggReleaseRange.searchTeam":`Buscar en un grupo público`,
"chatter.group.searchGroup":`Buscar grupo`,
"label_card_type":`Tarjeta`,
"label.appupload.managed.tip":`Ser controlado significa que solo puede editar algunas propiedades.`,
"label.changemyshow":`Cambiar mi visualización`,
"label.custom.CustomQuarter":`Trimestre personalizado`,
"label.tobedelete":`Será cancelado`,
"label.newPage.unuse":`La página se perdió`,
"label.product.pricebooks":`Lista de Precios`,
"label.mobile.layout":`Dise?o de la página del dispositivo de móvil`,
"label.multilang.file.items":`{0} ítems:`,
"label.app.step4.tabused":`Menú seleccionado`,
"label_ccchat_create_account":`Crear una cuenta`,
"message.startusingprocess":`Al activar este proceso de aprobación, no puede añadirlo o cancelarlo. Algunas propiedades del proceso no se puede editar. ?Estás seguro de continuar?`,
"vue_label_email_please_add_a_theme":`Por favor, añada un tema antes de guardar como plantilla`,
"label.please.create.a.target.record.first.":`Por favor, cree primero un registro de indicadores`,
"label.processsetting.set.objandfile":`Paso 1: Seleccione los objetos y los campos que desea establecer el proceso`,
"label.newreport.group.data":`Grupo(s)`,
"label.notcreatenew":`No cree nueva oportunidad durante la conversión.`,
"lable.custom.CurrentandPreviousCY":`Año personalizado previo y actual`,
"front-epwechat-module-v1-input-androidschema":`Por favor, introduzca el esquema de Android`,
"label.projectManagement.unfinished.quantity":`Cantidad no completada`,
"label.visualpage.idandname":`La página id y name se nombran:`,
"label.approvingprojects":`?tems por aprobar`,
"label.partnerCloud.financeSetting.weChat":`Es necesario abrir el servicio WeChat y el acuerdo de servicio de cobro con Tencent. Tencent cobrará una comisión por la transacción al beneficiario.`,
"label.quickbooks.viewlist.view":`Ver`,
"label.knowledge.category.hint.ten":`Grupo de categorías desactivadas`,
"report_type_label_productPricebooks":`Los productos y libro de precios`,
"label.fenbeitong.description":`Marcar y habilitar el formulario de solicitud de viaje de FenBeiTong para ayudar a los empleados a solicitar viajes de negocios y el reembolso de los gastos del viaje`,
"label.ccchat.upload.change":`?Qué ha cambiado? (Opcional)`,
"label.emailsync.status.log":`Registro de asociaciones`,
"label.addnew":`Añadir nuevo`,
"UG_contact_05":`Crear un contacto`,
"label.appupload.componet.queryerror":`Un error se ocurrió al buscar los componentes, ccontacte con el administrador`,
"label.salescloud.setting":`Configuración del grupo de ventas`,
"label.recurrencetimetriggeroperate":`Operación del trigger de tiempo periódico`,
"label.event.moveup.4day":`4 días con antelación`,
"No.Hisitory.Activity":`No hay historial de actividades`,
"label.validate.function.funcFormat.MINUTE":`MINUTE(date)`,
"label.recentview.seloption3":`Modifiqué recientemente`,
"label.login.access.nopermission":`--No acceso--`,
"label.taskmenuandlink":`Botón de tareas y enlaces`,
"label.forecast.customforecast.foredis.sbw":`Milliones`,
"lable.PowerProcess.created.event":`Crear evento clave`,
"label.stdashbord.xsld.funnelchat":`Gráfico del embudo de ventas`,
"label.step1.total7":`Paso 1 de 7`,
"label.sendsms.batch.chosepersion":`SMS masivo: Seleccione destinatarios de SMS`,
"Lead.Scoring.Setting.Rule.Setup.Value":`Valor`,
"label.ccdocument.isdel.folder":`?Estás seguro de que desea cancelar la carpeta?`,
"label.discard_change":`Sí, descarta los cambios`,
"label.knowledgebase.assign":`Asignar`,
"PersonalInfo_LoginHistory_001":`Enlace de registro para el correo de validación del navegador`,
"label.globalselect.deletedvlaue":`El conjunto del valor global se ha cancelado`,
"label.ems.lookup2":`Buscar`,
"label.dataimport.system.unable.determine":`, el sistema no se puede determinar la pérdida`,
"label.weixin.invitation.consultant":`Asesor invitado`,
"label.salescloud.salesdashboard.phone.rankings":`Ranking de llamadas`,
"label.knowledgebase.plan.release":`Plan para publicar`,
"label.integrations.first.half":`La vista actual en total`,
"label.icon.123":`Kit De Primeros Auxilios`,
"label.leadscore.isactivity":`Si activa`,
"front-epwechat-module-v1-corpid":`WeCom ID (Corpld)`,
"label.createnewcustomer":`Crear nuevo cliente`,
"front-lightning-module-v1-details-page-chart-tittle":`Puede insertar módulos de gráficos y diagramas en la página de detalles, y se pueden insertar hasta 10 gráficos de informes. Por ejemplo, puede añadir un módulo de diagrama de informe para un registro con tipo de registro como Agente en el objeto Cuentas, añadir gráficos de importe de ventas del pedido del agente e informe de ventas trimestrales del agente al módulo, y filtrar por el nombre de la cuenta para ver los datos relacionados directamente en la página de detalles de la cuenta del agente.`,
"label.customobjects.fieldsrelation":`Campos personalizados y relaciones`,
"label.dashboardSetup.left":`Izquierda`,
"label.mobile.app.sectionpart":`Sesión de la Aplicación Móvil`,
"setup.mainpage.label.welcome25":`Instrucciones: Haga clic en el menú de la izquierda de esta página → Configuración de gestión → Control de seguridad → Ajustes compartidos.`,
"label.custombutton.edit.error":`Error: El nombre está utilizando o se ha utilizado anteriormente, seleccione otro nombre.`,
"label.icon.48":`Extractor De Aire`,
"label.tabularreport.step2":`Paso 2: Seleccione columna del informe`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.two":`Segunda semana`,
"UG_quota_01":`Gestionar cotización del cliente`,
"label.customcomponent.btn.usewhere":`?Para qué sirve?`,
"label.quickbooks.searchresault.email":`Correo`,
"label.emailobject.appointment.urltext2":`Seleccione un tiempo adecuado`,
"label.tianyancha.field.relation.error":`Por favor configure la relación de mapeo entre el campo tianyancha y el campo del cliente primero`,
"APPIntegration_Social_facebookerror":`Debe ingresar una URL válida para entrar a facebook.com`,
"label.notification.arketsea.transfer":`{5} ha transferido {0}：{1} de {2} a {3}`,
"lable.SalesCommitmentKanBan.allreceivingTaskRate":`Tasa de finalización de tareas de recibos totales`,
"UG.Account.04":`Filtro pasivo de clientes`,
"this.week":`Esta semana`,
"label.email.track.attachment.num.control1":`El número de ficheros que están subiendo excede a 10, no se puede subir.`,
"label.exchange.sync.state.event":`Eventos`,
"vue_label_systemSettings_websitesetting":`Configuración de la web`,
"vue_label_file_replace_reason":`Motivo de reemplazo`,
"label.version.feature":`Funciones`,
"E":`Correo`,
"label.escalation.setup.entrydetail.escalation.notifyTemplate":`Plantilla de notificación`,
"label.chosesubject.meet":`Reunión`,
"UG.ST.003":`No tiene permiso para crear {0}, por favor, póngase en contacto con el administrador, haga clic en confirmar para ir directamente a la interfaz de {0}.`,
"label.authorization.failure":`Error en la autorización. Vuelva a autorizarlo.`,
"label.newprocessstep3":`Paso 3 Especifique el campo de aprobador y registre las propiedades de editabilidad`,
"lable.outlook.mcto.mostrecord":`Registro con más eventos`,
"vue_label_normal_select":`Seleccionar`,
"label.partner.workspace.login.buttontext":`Textos de botón`,
"template.chart.ydschdtj":`Estadísticas mensuales de la campaña`,
"label.ServiceCloud.zichanmingcheng":`Nombre del activo`,
"label.productsales.oppor.nooverdue":`Excelente, no hay oportunidades vencidas`,
"label.appointment.wizard.subtitle3-5":`Viernes`,
"label.payment.the.current.version":`Versión actual`,
"label.reportlist.top":`Fijo a la cima`,
"label.emailobject.emaildetail.prompt":`Indicación`,
"label.weixin.endst":`Hora de finalización no puede ser anterior a la hora de inicio`,
"report_label_knowcreatehighlevelreport":`?Cómo crear un informe avanzado?`,
"label.quickbooks.view.openestimates":`Estimaciones abiertas`,
"label.url.cannot.empty":`? El URL no puede ser nulo!`,
"label.emailnoticetemplate":`Plantilla de notificación de correo`,
"calendar.tips.task":`Hoy no hay tarea`,
"label_partner_all_operate":`Operación`,
"message.duplication.label.cancelbutton":`Cancelar`,
"vue_label_SMS_addcontact":`Añadir contacto`,
"label.martrixreport.setsumfield2":`Seleccione los campos que se utilizarán como columna de resumen en su informe matricial`,
"approval_request_email_body":`Los ítems siguientes se requieren su aprobación: \n      Haga clic en el enlace siguiente para aprobar: \n`,
"label.emailobject.emaildetail.field.record":`Registro`,
"label.tab.page":`Página`,
"label_tabpage_prepagez":`Mostrar en cada página`,
"label.iran.daylight.time":`Hora Estándar de Irán`,
"label.event.nextweek":`Próxima semana`,
"fliter.lastmonth":`El último mes`,
"label.group.no.recent.search":`No hay grupos recién revisados que coinciden`,
"label.h5.act.confirm":`Confirmar`,
"label_tabpage_mypotentialcustomers":`Mis candidatos`,
"label.tabpage.queuez":`Cola`,
"label.batch.edit.description":`Seleccione los campos para editar, por lo menos un campo, y 5 al máximo `,
"label.batchadd.newbatchpage.deltr":`Mantenga por lo menos una línea`,
"label.industrialandcommercialverification.instructions2":`La versión actual es gratis, la consulta máxima del día será de 10,000. Si necesita ampliar las veces de consulta, es recomendado comprar el servico. Despúes de comprarlo, recibirá el token del vendedor y lo configure en la página actual, el vendedor le ofrece los servicios pagados correspondientes.`,
"label.rejectrequestbehaviour":`Realice todo el rechazo <strong> y </ strong> todo el rechazo final para este paso. (Rechazo final)`,
"label.batchCopy":`Clonación por lotes`,
"label.service.two":`Algunas condiciones de filtro se han definido, pero no está referenciadas en los filtros avanzados`,
"label.data.import.setup.detail.remark":`Si marque las opciones siguientes, se ejecutará al importar los datos`,
"vue_label_file_delete_lib":`Eliminar biblioteca de archivos`,
"label.integerdigit":`El número de dígitos ubicado en la izquierda del punto decimal`,
"label.profile.standardobjcontrol":`Permisos de objeto estándar`,
"label.reportrecords":`Registros`,
"label.noplan":`No tiene programa de evento en los próximo 7 días`,
"label.visualpage.ytype":`Paneles`,
"label.branch":`;`,
"label.knowledgebase.new.article":`Artículo nuevo`,
"label.Addressbook":`Contactos`,
"label.delete.reward.groups":`Eliminar grupo de filas de oferta`,
"label.appexchange.uninstallpage.message1":`Cancelar permanentemente todos los componentes en este paquete (Lista siguiente)`,
"chatter.group.everyone":`Todos los usuarios`,
"label.cooperation":`Cooperación`,
"label.uploadfail":`Carga fallida`,
"to":`a`,
"button_partner_delete":`Eliminar`,
"attachment_select_warning_001":`El adjunto archivado está marcado, el botón archivado no está disponible, seleccione de nuevo un adjunto.`,
"label.step4.total4":`Paso 4 de 4`,
"label.login.access.avalid":`Expira hoy`,
"label.defaultview2":`Vista predeterminada`,
"vue_label_commonobjects_detail_style":`Estilo de compra`,
"label.selectfield":`Seleccione los campos`,
"label.report.select.column.collect":`Seleccione las columnas para resumir`,
"lable.currencyAdv.newdaterate.existeddate":`La fecha ha sido utilizada para HKC, especifique una fecha de inicio diferente`,
"pagecreator_systemstyle_button_new":`Nuevo estilo`,
"label.ccchat.person.invite":`Invitación de colegas`,
"label.sendemail.recycle.clear":`Limpiar la papelera de reciclaje`,
"label.usermanage.view.notexist":`La vista no existe`,
"setup_chatter_enabled":`No activado, contacte con el administrador para activar el CCChatter.`,
"UG.Contract.01":`Gestionar contratos`,
"label.martrixreport.2018.step4":`Paso 4: Seleccione los criterios de informe`,
"message.errorinscript":`?Se ocurrió error al ejecutar guiones!`,
"label.knowledgebase.modification.date":`Fecha modificada`,
"label.projectManagement.the.maximum.number.of.fees.is.10":`Máximo 10 dígitos en costes`,
"label.list.isActiveNewApproval":`Si activa la nueva página de aprobación`,
"label.mobile.main.page.icon.setup":`Configuración de íconos del dispositivo móvil`,
"label.select.customer":`Seleccione cliente`,
"label.sharerule":`Configuración de compartir`,
"label.fiscal.FY":`Año contable`,
"label.appupload.component.type.customfield":`Campo personalizado`,
"label.emailobject.emailsend.sendindividually":`Enviar individualmente`,
"label.new_formname":`Nuevo nombre del formulario`,
"label.appointment.wizard.notif1":`La hora de finalización no debe ser más temprano que la hora de comienzo`,
"front-console-conversation-evaluate-desc":`Respuesta de evaluación de {evaluateInfoName}`,
"homepage.components.lasttime":`Fecha de la Última Modificación`,
"vue_label_commonobjects_view_chart_deletechart":`Borrar gráfico`,
"label.multilang.document.upload.fail":`{0} archivos se han subido con éxito y {0} archivos fallaron`,
"UG_contact_03":`Seguir los contactos en un mismo sitio, siganos de ventas`,
"label.marketsea.istoseafromother":`Permitir la transferencia desde otros grupos públicos`,
"label.datamanage":`Administración de datos`,
"label.globaloperation.operationtype.create.data":`Crear registro`,
"label.customer.tab.step2.see":`Visibilidad del menú`,
"label.wtd.changefields.desc":`Después de que los usuarios envíen el formulario, verán URL específica regresada en su sitio web, como una página de "agradecimiento".
`,
"label.ems.eamilinfo":`Información de correo`,
"label.recordtypeselect.new":`Nuevo tipo de registro`,
"vue_label_report_output":`Tipo de salida de la fórmula`,
"label.emailnotice":`Notificación del correo`,
"label.icon.196":`Papel Higiénico`,
"label.emailsync.status.disabel":`Inactivo`,
"label.tabpage.isdeleterecord":`¿Quiere eliminar los registros seleccionados?`,
"message.selectoneoftypes":`Seleccione uno de los tipos siguientes`,
"label.import.index.createid":`Crear ID`,
"vue_label_systemSettings_social2":`Configuración de la cuenta en las redes sociales`,
"label.ccpeak.sel.time":`Clasificación programada en esta carpeta`,
"label.data.downpage.i_list.desc1":`Durante el proceso de importación, los datos no han sido importado con éxito debido al formato incorrecto de los datos, o porque la regla de trigger o validación se frascasó, generará fichero en formato CSV para mostrar en la página actual. Los datos importados con éxito no se mostrarán en la página actual.`,
"label_adjust_forecast":`Ajustar previsión`,
"vue_label_normal_lead_sf":`Cliente potencial`,
"vue_label_report_notice1":`El informe contiene cambios no guardados. Si cierra el informe, estos cambios se perderán. Haga clic en el botón "Guardar y cerrar" para guardar los cambios.`,
"label.notfiledpublicreport":`Informes públicos no archivados`,
"one":`Uno`,
"UG.Lead.008":`Escaneo del código de la tarjeta de visita`,
"label.archived":`Archivado`,
"label.standardabstractfield":`Campo de abstracto estándar`,
"vue_label_notice_add_fail":`Error al añadir`,
"label.sendemail.registIMUser.addresserror":`Correo del destinatario es incorrecto`,
"label.ccdocument.toolbar.switch":`Cambiar de herramientas`,
"first":`El primero`,
"label.icon.147":`Ratón`,
"vue_label_jihui_er":`Oportunidad 2`,
"label.ccchat.micropost.isedit":`Modificación de publicación y comentario`,
"label.department.next":`Página siguiente`,
"front-kefu-moudle-confirm-disable-phone-user":`¿Está seguro de desactivar el dialout para el usuario {0}?`,
"label.reportsSubscription.time.meets.subscription.frequency":`La fecha de inicio y finalización no coincide con la frecuencia de suscripción`,
"lable.account.NextpDays":`Los próximos 120 días`,
"UG_opportunity_007":`Rol de contacto`,
"label.encrypt":`Encriptado`,
"label.knowledge.category.hint.three":`Eliminar o reemplazar el grupo de categoría existente elimina todas las categorías asociadas al artículo.`,
"label.customcomponent.usewhere.info":`Las siguientes son todas las referencias de este componente. Haga clic en la etiqueta de referencia para ver la definición.`,
"vue_label_import_addandupdate":`Añadir y actualizar`,
"label.email.all.members":`Enviar a todos los miembros del grupo por correo electrónico`,
"component_task_button_save":`Guardar`,
"label.file.deleted.unavailable.desc":`El archivo se ha cancelado, no existe o no se puede previsualizar`,
"label.emailsync.status.viewlog":`Ver registro`,
"label.marketsea.othersetup":`Otros ajustes`,
"label.data.exp.newtemppage":`Página para elaborar plantilla`,
"vue_label_lead_score_successsful":`Puntuado con éxito`,
"label.sendemail.activity.newtask":`Estimado #belongtoidccname, hola:\r\n su colega #createbyidccname le ha asignado una tarea nueva en #createdate, los contenidos son:\r\n subject:#subjecto\r\n fecha de vencimiento:#expireDate\ r\n ítems relativos: #relatedstr\r\n contenido: #remark\r\npor más detalles,visite a este enlace:\r\n #path\r\n #orgNameSistema CRM`,
"component.event.label.soon":`Inmediatamente`,
"label.forecast.shrepage.getlist":`Regrese a la jerarquía de previsiones`,
"UG.solution.02":`La solución es una solución interna de la institución a los problemas que encuentran los clientes.`,
"label.weixin.data.approval":`El registro está en el proceso de aprobación`,
"label.build.pagelist":`Lista de contructor de página`,
"label.customsetting.type.hiberarchy":`Jerarquía`,
"label.forecast.ccfh":`Supera a`,
"label.Current.Window":`Mostrar las pesta?as actuales`,
"label.appointmentdetail.wizard.title20":`Plan de Domingo`,
"label.emailaddress":`Correo`,
"label.qetting_notifications":`¿No recibe nuestros correos electrónicos? Asegúrese de que ha añadido las direcciones de correo electrónico de CloudCC a su lista de permitidos y de que ha activado las notificaciones de exportación.`,
"Homepage.News.001":`Noticias`,
"label.runreport":`Ejecutar Informe`,
"label.customer.tab.step3":`Paso 3 Añadir a las aplicaciones personalizadas`,
"label.dashboard.snapshot.refresh":`Resfrescar`,
"label.approvepagelayout3":`Aprobar el diseño de la página`,
"vue_label_SMS_send_messages":`Enviar SMS`,
"label.executestate.old":`Ejecutado`,
"label.approvalstep3":`Paso 3 Seleccione aprobador asignado`,
"label.step3.total6":`Paso 3 de 6`,
"front-kefu-moudle-v1-delete-templete":`Borrar plantilla`,
"label.data.downpage.e.title.num3":`3. Los usuarios pueden crear plantillas de exportación de acuerdo con sus necesidades y seleccionar "Exportar según plantilla" para que la exportación sea más cómoda.`,
"label.attendance.outer":`Trabajador de móvil`,
"setup_layout_button_selectall":`Seleccione todo`,
"chatter.photo.img":`El tama?o máximo del archivo es de 2 MB`,
"front-dynamiclayout-module-v1-required":`El campo de {required} se establece como obligatorio.`,
"label.mytask":`Mis tareas`,
"label.edit.customerinfo":`Actualice los perfiles de la empresa`,
"label.processsetting.process.explain":`La configuración y el uso del proceso permiten a los usuarios centrarse en los elementos más importantes y les muestran palabras clave y consejos en el momento adecuado para ayudarles a completar el proceso.`,
"label.emailobject.subject":`Asunto`,
"label.mobileapp.scansetting.message":`Seleccione si guarda las tarjetas escaneadas en formato de imagen a la lista relativa de ¨Notas y Anexos¨ de acuerdo con el uso de escenario actual.<br> Activar: La tarjeta escaneada se guardará automáticamente al adjunto cuando el registro sea guardados.<br>Desactivar, solo guarda el registro.`,
"front-epwechat-module-v1-android-autograph":`Firma de aplicaciones Android`,
"label_component_helper_potentialcustom":`Los candidatos asignados a tí hoy`,
"label.projectManagement.nodata.week.work":`Añada tareas para organizar mejor el trabajo de esta semana`,
"label_tabpage_rolez":`Rol`,
"label.importsourcestep4":`Paso 3: Importar sus ficheros`,
"label.icon.50":`Brújula`,
"lable.service.prompt":`No se puede crear campo nuevo, el número de campo ha alcanzado al límite`,
"label.campaign.channel.input.page":`Especifique una página web, generalmente se puede configurar la página de campa?a como la página de agradecimiento.`,
"UG.homepage.001":`Consiga más transacciones en menos tiempo`,
"label.step4.total6":`Paso 4 de 6`,
"label.partner.required":`Error: el dominio no se puede estar vacío`,
"label.tag.manage.title":`Gestionar etiqueta- {0}`,
"label.data.downpage.i_title.num1":`1. El sistema solo admite el formato general de CSV.`,
"label.custom.quarter.end":`Fecha de fin del trimestre personalizado`,
"label.layout.distribute":`Asignación del dise?o de página`,
"label.version.allsms":`SMS masivo`,
"label.tolead":`Importar`,
"label.texttemplate.usemergefields":`Utilizar campos incorporados en la plantilla de SMS.`,
"label.emailobject.sure":`Seguro`,
"lable_setup_mobilesetup_isenbaleh5newandedit":`Si activa H5 en su dispositivo móvil y edita`,
"label.tabpage.messagez":`Introduzca el comentario`,
"label.mobile.phone.write.day.report":`Escribir reporte diario`,
"label.data.setok.e.desc2":`Página de exportación de lista de datos`,
"label.emailsync.message":`Nota`,
"label.sales.page.mubiao":`Objetivo finalizado`,
"label.ccdocument.list":`Ver los documentos recientes`,
"label.tabpage.userGuidez":`Guía de usuario`,
"label.report.fields":`Campos disponibles para informes`,
"vue_label_checkduplicate_at_same_time":`Satisfacer todos al mismo tiempo`,
"label.sms.phone":`Teléfono del servicio`,
"UG_ST_004":`No tiene permiso para la gestión y importación de datos, contacte con el administrador, haga clic en confirmar para ingresar directamente a la interfaz {0}. `,
"label.mobile.nobindmobile":`Este número de móvil no existe ahora. Por favor, vincule el número de móvil desde la información del usuario`,
"label.partnerCloud.basicSetting.intro":`CloudCC permite configurar múltiples sitios para socios de diferentes tipos y configurar la página de acceso, los menús y los permisos por separado. Por ejemplo, los minoristas pueden crear varios sitios para agentes locales y socios publicitarios.`,
"label.trigger.targetobject":`Objetivo`,
"label.ems.emailsyncperiod":`Intervalo de sync de correo`,
"lable.Transformation.mode":`Modo de transformación`,
"label.emailobject.new.template":`Añadir nueva plantilla`,
"label.System.Setting":`Configuración del sistema`,
"label.emailtocloudcc.button.addemailaddress":`Añadir correo empresarial`,
"lable.a.total.of.invoices":`0 facturas en total`,
"label.multilang.customforcast.forecasthistory":`Pronosticar historia de {0}：`,
"label.role":`Roles`,
"advancedconditions":`Filtro de condiciones avanzadas`,
"label.tabpage.beginz":`Comenzar`,
"label.campagin.roi.khzhsl":`Cantidad de conversión de clientes`,
"chatter.poll.option5":`Opción  5`,
"label.weixin.horse.club.registered":`Usuarios de registro de Aid-Max`,
"frame_personinfo_label_resizeimage":`Para ajustar su imagen abreviado, arrastre y ajustar la línea punteada en la parte superior de la foto de su perfil.`,
"label.file.share.select.warning":`?Han configurado el compartido!`,
"label.event.this.week":`Evento de esta semana`,
"label.data.import.object.label":`Etiquetas de objeto`,
"label.visualpage.folder":`Carpetas de página no archivadas`,
"vue_label_report_saveandclose":`Guardar y cerrar`,
"label.newdashboardpage.saveto":`Guardar en`,
"label.partnerCloud.financeSetting.developerIDTwo":`ID de desarrollador`,
"lable.PowerProcess.created.ago.please":`Antes de crear un proceso, por favor`,
"label.chatter.myfollowers":`Mis seguidores`,
"label.campaignmember.main.duplicatelist.title":`Miembros de campa?a: Escanee el código para encontrar configuración de duplicado`,
"label.group.no.recent2":`Encontrar grupos para entrar`,
"label.icon.110":`Libro`,
"label.merge.my.account":`Fusionar mis clientes`,
"setup.layout.button.quicksave":`Guardado rápido`,
"pagecreator.page.message.canntdelete":`La página actual no se puede borrar`,
"label.report.printable.view":`Vista imprimible`,
"ccchat_fieldtrack_fieldchange":`Cambiar de {0} a {1}`,
"label.email.bcc":`Cco`,
"label.sso.saml.sp.idpcert":`Certificado del proveedor de identidad`,
"label.step2.total2":`Paso 2 de 2`,
"lable.product.pricebooks.isn":`Libro de precios activado`,
"labal.emailtemplate.namemassage":`El nombre único de la plantilla de correo ya existe, ingrese de nuevo`,
"only.one.field":`Solo se puede seleccionar un campo`,
"label.weixin.appr.audittime":`Fecha de aprobación`,
"pagecreator.page.button.delete":`Eliminar`,
"front-kefu-moudle-v1-Session-start-time":`La sesión comienza en:`,
"label_chatter_state":`Status`,
"vue_label_systemSettings_lightningcustom":`Interfaz de usuario personalizada en Lightning`,
"label.searchs":`Buscar`,
"label.mobile.phone.not.read":`No revisado`,
"label_chatter_allweather":`Todo el tiempo`,
"label.enter.number":`Por favor ingrese un número entero entre 0 y 6`,
"front-epwechat-module-v1-addressbook-desc":`Si se activa, los contactos y departamentos de WeCom se sincronizarán con los usuarios y funciones de CloudCC`,
"label.emailfield":`Campos de correo`,
"pagecreator_button_next":`Siguiente`,
"label.more.select.merge.records":`Solo puede seleccionar 3 registros para fusionarse`,
"lable.edit.queue.selobjct":`Objetos seleccionados`,
"label.reportsSubscription.editsubscribe":`Editar suscripción`,
"label.selectfieldtoautotransmit":`Seleccione el campo utilizado para enviar automáticamente`,
"label.ccpeak.need.topass":`Necesita pasar`,
"label.checkfield.merge":`Fusionar`,
"front-lighting-module-v1-detail-file-downlaodInfo":`El registro está bloqueado y no está disponible para descargar archivos. Por favor, póngase en contacto con el administrador para desbloquearlo.`,
"vue.please.enter.a.chart.name":`Introduzca el nombre del gráfico`,
"label.data.dataexptemplate.desc3":`3. El modo de exportación sólo es válido para los datos exportados y es inválido para la plantilla de exportación. El formato de la plantilla de exportación es CSV.`,
"label.setup.mobile.homepageshortcuts.setting":`Configuración de la función rápida en la página oficial de la aplicación móvil`,
"label.ems.connect.success":`Prueba de correo exitosa`,
"label.applet.text":``,
"label.knowledgebase.parent.window":`Ventana de los padres`,
"label_file_size":`Espacio ocupado`,
"label.allocation.department":`Asignar usuarios`,
"label.browser":`Navegador`,
"label.reportsSubscriptionPage.schedulereport.weekly.wednesday":`Miércoles`,
"label.integrations.description1":`Exportar todos los datos de la vista actual`,
"label.project360":`Proyecto 360`,
"label.choose_formtype":`Elija el tipo de formulario`,
"label_emailsync_status_connectstatus":`Estado de vinculación`,
"label.bmap.beijing.city":`Beijing`,
"label.mask.encryption.scheme":`Formato cifrado`,
"label.imgfield.type":`Tipo de imagen`,
"label.person.target.responsible":`Seleccionar supervisor del objetivo`,
"label.appexchange.installedpage.installdate":`Fecha de instalación`,
"label.partnerCloud.orderingPlatform.partnerUsers":`Esta función sólo está disponible para los usuarios asociados.`,
"label.profile.customfieldsafety":`Seguridad del nivel de campo personalizado`,
"label.no.target.models.available.":`No hay modelos de indicadores disponibles. Por favor, cree un modelo de indicador o póngase en contacto con el administrador.`,
"label.process.execute.tip":`Su solicitud ha sido procesada y llevará unos minutos para vaciar la papelera de reciclaje, le informarán por correo una vez lo termine.`,
"label.app.step2.introduce":`Ingrese los campos siguientes para definir las aplicaciones personalizadas`,
"label.loginip.cue":`No rango IP fue especificado. Permite a los usuarios de cualquier IP ingresar.`,
"label.step1.select.tablayout":`Paso 1: Seleccione el dise?o de menú`,
"mainpage.setup.chosecomponent.leastone":`Debe haber al menos un componente en la página de inicio.`,
"label.custom.quarter.name":`Nombre del trimestre personalizado`,
"chatter.ptup.link":`Publica un enlace`,
"label.compact.layout.frame.error2":`La información detallada y la lista relacionada deben estar en la pantalla izquierda`,
"vue_label_salesfunnel_notice7":`Número total de oportunidades de negocio con 100% de probabilidad/Número total de oportunidades de negocio con probabilidad del 0% o del 100%`,
"label.multilang.datamanage.dataimport.lostmsg":`La longitud del título es &nbsp;{0}&nbsp;, pero la longitud de datos es &nbsp;{1}&nbsp;, el sistema no puede determinar cuál&nbsp;{2}&nbsp; campos son redundantes.`,
"label.owner.notnull":`El propietario no puede estar vacío`,
"label.logintime.pagecue.invalidt":`Hora de comienzo no puede ser mayor que hora de finalización`,
"vue_label_file_checked_num_limit":`El número de archivos seleccionados supera el límite establecido`,
"front-email-payment-repayments":`Pagar de nuevo`,
"template.report.today.prospects":`Líderes de hoy`,
"label.weixin.appr.status":`Status`,
"label.knowledge.language.japanese":`Japonés`,
"label.event.reminder.lead.time":`Recordatorio`,
"lable.custom.dep":`Haga clic en el botón Nuevo para definir un nuevo año personalizado`,
"Dashboard_View_Createdbyme":`Creados por mí`,
"label.file.upload.fail":`Se frascasó en subir los archivos`,
"label.manager":`Gerente`,
"label.stdashbord.xsld.business.jine":`Monto`,
"label.tag.manage.tag":`Etiqueta`,
"chatter.nlk":`No me gusta`,
"label.file.search.people":`Busar personal`,
"message.error.domain.format":`Los dominios solo pueden contener letras y números`,
"label.firstisdefault":`Utilice el primer valor como el valor predeterminado`,
"label.discount":`Descuento`,
"label.mobile.phone.have.read":`Revisado`,
"label.field_selected":`Este campo ha sido seleccionado`,
"label.payment.renew.now":`Renovar ahora`,
"label.multilang.lookfiltercondition.notsetup":`?La condición de {0}línea es incorrecta, no se ha configurado ningún operador!`,
"label.projectManagement.Selectionday":`Seleccione el día`,
"label.user.organization.permit.licensenotstart":`La licencia de su organización no se ha activado, por favor intente de nuevo una vez se active la licencia`,
"label.download.save.attachment":`Descargar y guardar en el archivo adjunto`,
"lable.outlook.mcto.must":`Deber ser formato de correo`,
"vue_label_notice_unfollow_success":`Seguimiento cancelado`,
"label.taskinfo":`Paso 2 Configurar tarea`,
"label.other.SMS":`Otros números de móvil`,
"label_partner_workspace_login_logo":`Logo encabezado`,
"label.weixin.data.lock":`El registro está cerrado`,
"label.Yaxis":`Eje Y`,
"lable.edit.queue.selobjdes":`Seleccione los objetos que quiere asignar a esta cola. Los registros individuales de estos objetos se pueden obtener por esta cola.`,
"label.campagin.roi.dcfezb":`Tasa de asistencia`,
"label.marketseamemset.maximum":`Cantidad máxima`,
"label.owner":`Propietario`,
"label.reportsubscribe.error.noview":`Por favor, elija la vista en la que quiere ejecutar el informe en "Ejecutar informe en las siguientes vistas del usuario"`,
"label.icon.133":`Carpeta`,
"vue_label_file_share_files":`Documento compartido`,
"label.searchlayoutfilterfields.remark":`Seleccione el campos de criterios de filtro para mostrar en la búsqueda de menú o la columna frontal izquierda`,
"vue_label_help_contract":`Contrato y plan de cobro`,
"component.chatter.button.message":`Comentario`,
"label.marketsea.recyclereminddays2":`Recordatorio del día (debe ser inferior al número de días sin seguimiento después de la obtención)`,
"label.webtocloudcc.input.information":`?La información es obligatoria!`,
"vue_label_chatter_exit_group":`Salir del grupo`,
"vue_label_lead_notcreatetask":`No crear tarea`,
"front-lightning-module-v1-dashborad-date-dimension":`Fecha Dimensión`,
"setup.layout.label.fieldlist":`Campos disponibles`,
"label.leadscore.charname":`Nombre de campo`,
"label.forecast.customforecast.mybest":`Mi mejor caso`,
"setup_mainpage_label_welcome24":`La plataforma CloudCC proporciona configuración de acceso de seguridad para todos los datos de objeto en el sistema. El compartido de datos y permisos de acceso pueden ser controlados por configurar varias reglas y condiciones.`,
"label.queue":`Colas`,
"label.icon.159":`Chip`,
"label.path":`Trayectoria de referencia`,
"label.app.message.failtoget":`No se ha podido obtener la lista de aplicaciones`,
"label.returntoprocess":`Regrese a la lista de proceso de aprobación`,
"vue_label_commonobjects_detail_more_data":`No hay más datos`,
"label.number":`Número`,
"label.product.find":`Encontrar catálogo de precios`,
"label.legend":`Gráfico`,
"label.partner.workspace.member.profile":`Perfiles seleccionables`,
"label.service.gantt.sum.appointments":`Citas de servicio completadas/Todas las citas de servicio`,
"label.partnerCloud.financeSetting.paymentAllowed":`Permitir la recarga en línea`,
"label.integrations.upgrate":`Actualizar`,
"label.timzone.tip.info3":`Al procesar fechas utilizando clase de Calendar, debe configurar zona horaria para el calendario, y puede selecionar cualquiera de los dos métodos para conseguir los objetos del calendario: Calendario cal=Calendar.getInstance(TimeUtil.getUserTimeZone(userInfo)) y Calendar cal=TimeUtil.getCalendar(userInfo)`,
"label.ems.addaccount2":`Añadir cuenta de correo`,
"label.partneruser":`Usuarios de socio`,
"label.validate.globalvariable.user.roleId":`Rol ID`,
"pagecreator.layout.button.mergecell":`Fusionar celdas`,
"label.evacuantvalue":`Valor excluido`,
"label.setup.mini.msg":`Ajustes de la Historia de la marca/Mensajes`,
"label.icon.178":`Personas`,
"vue_label_pricebook_notice_cantbedeleted":`Las entradas de la lista de precios no pueden ser borrados porque ya hay registros aplicados a la lista de precios. En cambio, puede marcar las entradas de la lista de precios como inactivas.`,
"vue_label_appstore_application_recommendation":`Recomendación de aplicaciones destacadas`,
"label.version.createlimit":`La versión actual de su CloudCC es {0}, y puede crear {1}{2} para cada objeto. Ahora la cantidad de {2} ha superado al límite, actualice a la última versión. `,
"message.duplication.label.sectionremar1":`Selecciones los valores que quiere mantener después de fusionarse. Las filas resaltadas significan campos que contienen datos en conflicto. El registro maestro seleccionado conservará valores de campo de solo lectura y ocultos`,
"label.icon.1":`Nube`,
"label.salescloud.salesdashboard.sales.performance":`General-Rendimiento del contrato de venta`,
"System_AddressFieldType_Post":`Código postal`,
"setup_object_field_dependency_label_mustone":`Debe seleccionar al menos un valor del campo dependiente`,
"label.appointmentdetail.wizard.title6":`Ubicación`,
"label.layout.testobj2":`Prueba objeto 2`,
"label.searchlayout.dupcacher.field":`Haga clic en encontrar duplicados y fusionar el enlace para ver los campos duplicados.`,
"label.attendance.persons.title":`Seleccione persona adecuada para la asistencia`,
"template.report.product.sales":`Venta de productos`,
"label.editCustomReportType":`Editar el origen de datos de informe personalizado`,
"label.multilang.ui.setup.profile.alltime":`Todas las horas son {0}`,
"label.service.dispatchingUnits.noservice.booking":`No hay cita de servicio`,
"label.validate.remark4":`Asegúrese de que el número está dentro de un rango específico, por ejempo el descuento debe ser menos de 30%`,
"front-kefu-moudle-v1-Waiting-time":`Tiempo de espera:`,
"label.weipagelayout.remark":`Se aplica a la aplicación móvil o página WeChat`,
"vue_label_wang_er":`Michael`,
"label.pw.text":`Por favor, introduzca la contraseña de {usuario}, y asegúrese de que contiene al menos`,
"message.error.user.data.null":`La información del usuario no puede estar vacía.`,
"chatter.like.p":`Me gusta`,
"label.page.double.column.style.cloudcc":`El estilo de 2 columnas proporciona funciones útiles de CloudCC.com, como ¨Buscar¨y ¨?tems recientes¨.
`,
"label.h5.iscloseaccount":`?Está seguro de que quiere salir?`,
"label.dataimport.insertdata.id.error":`Error de formato, utilice letras alfanuméricas`,
"label_tabpage_sum":`Total`,
"front-epwechat-module-v1-addressbook-sync":`Sincronizar la agenda de contactos`,
"label.setup.mobile.offlinecache.mostsave":`La plataforma puede configurar hasta 10 menú offline del dispositivo móvil predeterminadamente activado`,
"label.weixin.quickcreate":`Creación rápida`,
"label.forecast.edittotal.de.mubiao":`Objetivo`,
"label.icon.144":`Garantizar`,
"label.icon.155":`Imagen`,
"label.In.the.search":`Buscando`,
"message.validation.isnotdateISO":`Ingrese fecha válida(ISO)`,
"label.service.appointmentList.send.successfully":`Enviado con éxito`,
"label.dynamicpage.error.exist":`No existen datos del diseño de la página dinámica`,
"vue_label_SMS_otherpeople":`y {0} personas más`,
"label.cloudccsite.url":`URL del sitio`,
"label.tabpage.contactsz":`Contactos`,
"vue_label_commonobject_notice_clickthename":`Si necesita descargar el archivo cargado, haga clic en el nombre del archivo`,
"vue_label_file_new_lib":`Nueva biblioteca de archivos`,
"label.chatter.card":`Tarjeta`,
"chatter.feed.menutype.user.allusercom":`Todos los Colegas`,
"label.exchange.sync2":`Configuración`,
"template.report.year.income":`Ingresos de este año`,
"label.partner.template.detail":`Descripción de función`,
"label.setup.service.template":`Plantilla de informe de servicio`,
"label.dataimport.insertdata.id.length":`Error del formato, la longitud es inferior a 20 caracteres, revise atentamente este registro y modifíquelo.`,
"label.partnerCloud.financeSetting.collaborator":`Identificación del cooperador`,
"label.processskipwizard":`Proceso de aprobación de Jump Start Wizard`,
"label.weixin.inputbusnumber":`Ingrese el número de placa`,
"label.dashboardSetup.d1":`Punto de Interrupción 1`,
"template.report.conversions.number.industry":`Número de conversiones de clientes potenciales (por sector)`,
"vue_label_chat_group_chat":`Chat grupal`,
"label.file.publicview.error":`El fichero ha sido cancelado, no existe o no se puede previsualizar`,
"label.customfields.location.locationHelpText":`Ingrese el nombre de ubicación, como ¨Sede oficial¨, sea descriptivo y específico, y tenga en cuenta que un registro puede tener múltiples ubicaciones como "oficina de ventas de la costa oeste" y "oficina de ventas de la costa este".`,
"message.duplication.label.blankmatchtip":`Configure si el espacio blanco participe a la combinación, el predeterminado es False`,
"message.appexchange.addtopackage":`?Seleccione uno o más componentes para añadir a este paquete!`,
"label.ems.return2query":`Regrese a la página de consulta para añadir cuentas de correo`,
"label_model_name":`Nombre del modelo`,
"label.apiname.retainapi":`?Name es un nombre reservado por sistema, utilice un nombre API de otro campo!`,
"lable.Cancel.the.search":`Cancelar la búsqueda`,
"label.custom.viewport":`Punto de vista`,
"label.weixin.polls.type":`Tipo de votación`,
"label.opportunity.setting.showstage.label":`Promover automáticamente`,
"label_component_helper_businesschange_expiredtask":`Oportunidades con tareas atrasadas`,
"label.operator":`Operador`,
"label.ccpeak.use.class.time.listmap":`Acceder por pasar la lista<Map> recolección`,
"component_timeline_label_past":`Actividades pasadas`,
"label.mobile.phone.submit":`El informe que he enviado`,
"message.recordtype.new.subtip":`Ingrese nombre y nota para el nuevo tipo de registro. El nuevo tipo de registro incluye todos los valores de la lista de opción de los tipos de registros existentes seleccionados al siguiente. Al guardar el nuevo tipo de registro, puede personalizar los valores de la lista de opción.`,
"UG_product_05":`Importar productos`,
"label.validate.globalvariable.user.id":`Usuario ID`,
"label.umeng.activity.distribute":`Asigna a`,
"label.weixin.avote":`Votar`,
"label.weixin.already.sign":`Ha iniciado la sesión`,
"label.emailmerge.mergepage.generator":`Generar`,
"label.batchtransfer.transferto":`Transferir a`,
"label.tianyancha.industry":`Industria`,
"label.addattachment.name":`Nombre del fichero`,
"label.customfields.formula.date.tip":`Calcular fecha, por ejemplo, sume o reste ciertos días de otras fechas`,
"label.partnerCloud.orderingPlatform.noPayment":`No pagar`,
"label.emailobject.failedtosend":`Envío fallido`,
"label.knowledge.setting.data.three":`Se puede seleccionar un máximo de {contar} datos de grupos de categorías.`,
"label.weixin.input.maxlength.langtext":`Ingrese aquí hasta 32,000 caracteres`,
"vue_label_calendar_delete_calendar":`Borrar calendario`,
"vue_label_commonobjects_detail_filter":`Filtro de colapso`,
"setup.layout.group.custompage":`Personalizar página`,
"component_sendmail_label_subject":`Tema`,
"label_tabpage_maxfilez":`El tama?o máximo del archivo es`,
"label.logintime.pagecue":`Seleccione la fecha y hora que los usuarios con este perfil pueden ingresar. Tenga en cuenta de que debe utilizar la hora precisa de la zona horaria específica para todas las horas. Aunque los usuarios están en diferentes zonas horarias, la hora de login se utiliza esta hora precisa. `,
"label.salescloud.salesdashboard.datetime":`Fecha cerrada`,
"label.format":`Formato`,
"label.newfoundland.daylight.time":`Hora de Verano de Terranova`,
"front-kefu-moudle-v1-messagetemplate.finishdetailinfo":`Copiar y pegar el valor del campo de fusión en el contenido del SMS`,
"message.chooseatleastoneforshare":`Seleccione por lo menos un usuario para compartir`,
"label.multilang.datamanage.importobjfield":`Columna {0}`,
"label.denglu":`Login`,
"label.popup.infoz":`Nota`,
"label.schedulejob.setup.schedule.onday":`Cada mes`,
"label.appointmentdetail.wizard.title16":`Plan del miércoles`,
"label.userphoto.dragtoadjust":`Arrastre y ajuste el tama?o de la miniatura`,
"label.product.series":`Serie de productos`,
"message.view.kanban.not.set.group.summary.field":`El panel de vista no configura el campo del resumen de agrupación`,
"page.un.activities":`Actividades no empezadas`,
"label.exchange.sync3":`Configuración`,
"label.login.activityExpired":`El período activo del cliente ha caducado, contacte con el administrador.`,
"component_chatter_file_button_files":`Seleccione un documento`,
"message.onlydelete.type":`Sólo puede cancelar los tipos de registro inactivados. Bloquear los tipos de registro primero si quiere cancelarlos.`,
"message.recordtype.selectlayouttouse":`Seleccione el dise?o que utilizar`,
"label.knowledgebase.unable.restore.draft":`No puedes recuperar los borradores borrados.`,
"label.shangqing.name":`Información comercial`,
"label.weixin.target.payment":`Pago del objetivo`,
"label.chatter.sendEmailToGroupMember.check":`Ver los mensajes`,
"front-kefu-moudle-v1-input-single-login-area":`Introduzca el nombre de dominio de inicio de sesión único`,
"vue_label_zhang_yi":`Alice`,
"label.icon.190":`Secador De Pelo`,
"label.quickbooks.fieldlabel.company":`Cliente`,
"vue_label_email_are_you_sure_to_delete":`¿Está seguro de querer borrar el correo?`,
"Pagelayout.Setup.005":`El nombre debe estar en primer lugar.`,
"label.object.name.two":`Nombre del objeto 2`,
"label.tabpage.completez":`Marcar los seleccionados como completado`,
"label.setup.mobile.bottombutton.saveerror":`No se ha podido guardar la configuración de la página de primer nivel`,
"label.report.action.addtodashboard8":`Seleccione la carpeta del panel`,
"label.data.downpage.i_list.desc3":`Los usuarios pueden ver las razones del fallo de importación en la última columna del fichero después de la descarga.`,
"label.layout":`Dise?o`,
"label.marketsea.button.assign":`Asignar`,
"UG.solution.03":`Crear solución`,
"label.ccchat.person.invited":`Invitar colegas`,
"label.ccchat.person.invite.address":`Destinatario`,
"label.displaytype1":`Enlace de la página de detalles`,
"label.tianyancha.h5.ziranrengudong":`Accionista de persona natural`,
"lable.SalesCommitmentKanBan.targetReceipts":`Recibo de objetivo`,
"message.error.getitems.type":`getItems:type no puede estar vacío`,
"label.addattachment.list":`Los archivos siguientes han sido subidos`,
"label.datamanage.export.false":`Un error se ocurrió al exportar`,
"pagecreator.systemstyle.label.buttonfontcolor":`Texto del botón`,
"label.emailtocloudcc.redmessage1":`Introduzca un correo electrónico válido`,
"label.weixin.polls.closed":`La votación ha finalizado, fecha límite es `,
"label.icon.165":`Sombrero`,
"vue_label_report_detailsonly":`Solo detalles`,
"component.salesperformance.label.100finish":`Finalizado`,
"november":`Noviembre`,
"label.data.file.generatejwd":`Generar el servicio de latitud y longitud de acuerdo con las direcciones`,
"label.salescloud.opportunity.access":`Acceso a Oportunidades`,
"label.isremider.remider":`Recordatorio`,
"vue_label_total":`Total`,
"label.email.prompt.using.lightning.link":`Configurar el enlace de correo electrónico en las notificaciones del sistema para que sea coherente con los enlaces Lightning.`,
"label.knowledgebase.cancel.attached.articles":`Cancle Artículo adjunto`,
"label.version.custom.xslc":`Proceso de ventas que se puede personalizar`,
"component_setup_button_save":`Guardar`,
"label.ems.cc":`Cc`,
"label.edit.user":`Actualizar los usuarios`,
"label.emailtocloudcc.select2":`Por favor, seleccione tipo`,
"label.industrialandcommercialverification.fieldnumber":`Número de campo de mapeo: 4`,
"label.ccchat.havenot.joined.group":`No está en cualquier grupo de eventos`,
"pagecreator_page_label_pagename":`Nombre de página`,
"setup.layout.button.save":`Guardar`,
"label.campaignmember.main.updatestatus":`Actualización masiva del status de los miembros de campa?a`,
"label.tab.web.edit":`Editar el menú de Web`,
"label.ring_chart":`Tabla de donuts`,
"label.usermanage.resetpwd.error":`El reseteo de la contrase?a se frascasó, el usuario no existe`,
"label.Xaxisscope":`Rango del eje X`,
"label.app.new":`Nueva aplicación personalizada`,
"message.modifythereport":`El tablero utiliza este informe. Las modificaciones pueden invalidar el panel que hace referencia a este informe.`,
"label.component.helper.businesschange.0activity":`30 días sin actividad`,
"label.weixin.fmu.noon":`{0} PM`,
"label.enter.rule.name":`Introduzca el nombre de las reglas`,
"lable.Confirm.recovery.potential.customers":`Confirmar recuperar el cliente {name}`,
"lable.PowerProcess.type.created":`¿Qué tipo de proceso de asignación quiere crear?`,
"front-lightning-module-v1-dashbord-rectangle-size":`Tamaño del ortogono`,
"label.projectManagement.new.service.appointment":`Nueva cita de servicio`,
"label.multilang.totalpage2":`Un total de`,
"pagecreator.systemstyle.label.styledesc":`Descripción del estilo`,
"chatter.up":`Cargando`,
"2018UI_Homepage_DataDeleted_Info":`Los datos han sido cancelados, haga clic en regresar al paso anterior.`,
"label.knowledge.draft.recordid":`El ID del borrador no puede estar vacío`,
"vue_label_pool_recyclecertification":`{0}{1}{2}{3}？`,
"label.setting.intergrationlist.viewall":`Ver todas las integraciones`,
"vue_label_file_num_limit_tip":`El número de archivos supera el límite preestablecido. Si necesita reemplazar los archivos, por favor, elimine primero los archivos cargados`,
"vue_label_commonobjects_view_refreshat":`Actualizado hace {timeInterval}`,
"laebe.data.exp.save.success":`Si necesita utilizar esta plantilla para exportar los datos, regrese a ¨Exportar via plantilla¨ para operar.`,
"label.mr.caption.contact":`Buscar duplicados y fusionados: buscar las condiciones para los datos duplicados de contactos`,
"label.webtocloudcc.submit.error":`La entrega se frascasó`,
"label.multilang.datadelete.delmessage":`Los registros cerrados ({0}) no se permiten cancelar:`,
"label.quickbooks.searchlist.total2":`Hay{0}pagos no vinculados con un valor total de {1}`,
"label.createnew":`Crear..`,
"component.milestones.label.choicestate":`Confirmar este estado`,
"lable.outlook.edit.exist":`El nombre de campo ya existe, ingrese el nombre de campo único.`,
"vue_label_dashboard_eachother":`Sólo se pueden vincular vistas del mismo informe o del mismo objeto`,
"label.new.role":`Rol nuevo`,
"message.error.operationType":`La operación se encontró indefinido al llamar al servicio`,
"label.fenbeitong.name":`FenBeiTong`,
"label.choose.person":`Por favor seleccione los destinarios para enviar`,
"label.attendance.thanks":`?Agradecemos por su participación!`,
"label.invoice.message.statusupdatefailed":`La actualización del status Invoice se frascasó, intente de nuevo`,
"template.chart.yzhqzkhlyfx":`Análisis del origen de los clientes potenciales convertidos`,
"chatter.feed.menutype.user.alluser":`Todos los colegas`,
"UG_Forcast_04":`Empezar la prueba`,
"label.appupload.upload.tips.profile":`Notas: se ha añadido componentes de ¨perfil¨ a este paquete, no puede añadir más(En un paquete se puede añadir un componente de perfil al máximo).`,
"lable.PowerProcess.leave.the.process":`{describeName} abandona el proceso`,
"template.report.sales.cycle.opportunities":`Duración del ciclo de ventas (por tipo de oportunidad)`,
"vue_label_calendar_please_fill_in_the_calendar":`Introduzca el nombre del calendario`,
"label.salescloud.unit.wanyuan":`Unidad(Yuan)`,
"label.fileAPI":`Nombre único del documento`,
"label.weixin.link":`Asociar con`,
"label.service.seconds":`segundos`,
"label.encd.visible":`El campo cifrado visible`,
"label.tianyancha.regstatus":`Status de operación`,
"label.event.moveup.18hour":`18 hora con anticipación`,
"label.upper.bound":`Límite superior`,
"label.please.insertURL":`Por favor, introduzca la URL a insertar.`,
"label.approval.notallowed.reject":`Rechazo no permitido`,
"label.permission.fieldpermission":`Configuración del campo de permiso`,
"label.customcomponent.page.index.title":`Componentes personalizados`,
"label.quickbooks.viewlist.number":`No.`,
"lable.list.queue.sendemail":`Enviar correos a los miembros`,
"label.productsales.today.noevtadd":`Hoy no hay eventos abierto, haga clic en “ ” en la parte superior derecho para a?adir nuevo evento. `,
"label.report.line.daixuan":`Columna de informes pendientes`,
"label.reportsSubscription.select.start.endtime":`Seleccione la fecha de inicio y de finalización`,
"template.chart.schdyscb":`Coste presupuestado de las campañas`,
"label.sendemail.chat.addPostatsubject":`Le han mencionado en la micro-publicación de CloudCC CCChatter`,
"label.RelatedList":`Listas relacionadas`,
"label.knowledgebase.delete.translation.associated.with.draft":`Los borradores de traducción existentes se vincularán a la última versión publicada del artículo de la lengua principal. Si no existe ninguna versión publicada, se eliminarán todas las traducciones.`,
"vue_label_chatter_submitted_review":`Ha enviado una solicitud de entrada, por favor, espere la respuesta del administrador`,
"label.layout.list2":`Lista 2`,
"label.manage.area":`Gestionar territorios`,
"label.manageapproveprocess":`Gestionar el proceso de aprobación`,
"workflow.action.tasks.assignortype.created":`Creado por`,
"label.custombutton.nonsupport.operation":`La versión actual no permite la operación de botones estándar y enlaces`,
"label.ip":`Dirección IP`,
"label.chat.topic.desc.error.info":`La descripción del tema no puede exceder 1000 caracteres. Intente utilizar una descripción del tema más corta.`,
"label_tabpage_cue":`Información`,
"label.integrations.mailchimp1":`Los usuarios de su organización pueden importar a los candidatos y contactos a Mailchimp al terminar la integración`,
"label.email.track.required":`Obligatorio`,
"label.set.case":`Por favor, establezca primero el propietario del caso.`,
"label.weixin.newspaper.coverage.number":`Número de Tabla de Riesgo`,
"vue_label_approve_submitreason":`Motivo de la presentación`,
"message.oppdt.noenabledpricebook":`No have catálogo de precios activado`,
"label.partner.workspace.setup":`Configuración`,
"label.version.nonsupport.feature":`?Esta función no está disponible temporalmente! Si la necesite, actualice la versión CloudCC!`,
"com.cloudcc.login.error.message.licenseexpired":`La licencia caducada`,
"label.emailsync.form.signin":`Iniciar sesión`,
"label.campaign.channel.input.to.chooselanguage":`Seleccione un idioma`,
"label.tabpage.gotit":`Entendido`,
"front-console-no-contact-tip":`No hay datos. Por favor, póngase en contacto con la persona pertinente y vea.`,
"label.approval.apiname":`El nombre único utilizado por API y Paquete gestionado debe comenzar con letra, solo se puede utilizar caracteres alfanuméricos y guiones. Los nombres no pueden finalizar con un guión o con dos guiones consecutivos.`,
"label_emailtocloudcc_filed_ssl":`Conexión segura`,
"component_sendmail_label_fromuser":`Remitente`,
"front-kefu-moudle-v1-new-online-chats":`Nuevo agente en línea`,
"label.searchlayout.merge.duplicated.results":`Si activa buscar duplicados y fusionarse`,
"label.weixin.input.maxlength.remark":`Por favor introduzca al máximo 500 caracteres`,
"component.telerecord.label.related":`Elementos relacionados`,
"label.note":`Notas`,
"message.duplication.label.nletters":`caracteres`,
"label.productsales.payment.phb":`Lista de pago`,
"label.forecast.editshrepage.desc":`Pronóstico: Especifique el compartido de este registro. Puede compartir este registro y datos relacionados con un solo usuario, usuarios en un rol específico o todos los usuarios en un rol bajo un rol específico. `,
"vue.dashboard.setPenetrationSuccessful":`Penetración configurada con éxito`,
"label.tabpage.noOperationz":`¡Este contenido es un elemento fijo y no puede ser modificado!`,
"label.email.jump":`Redirigiendo a un sitio web de terceros...`,
"label.appointmentpage.wizard.btn1":`Confirmar la reserva`,
"label.umeng.approval.pass":`#approver ha aprobado la solicitud de #obj.`,
"label.project.hit.twelve":`Recordatorio de vencimiento de hitos`,
"two":`Dos`,
"label.approvedinfo":`Información de aprobación`,
"label.import.step1.choosecsv":`Seleccione el archivo csv`,
"vue.please.select.the.expansion.method":`Seleccione el método de expansión`,
"UG.homepage.005":`Inteligencia de ventas`,
"Account.News.Setting.003":`Configuración general`,
"label.quickbooks.button.actions":`Operaciones`,
"lable.list.queue.email":`Correo de la Cola`,
"label.name.lastname":`Apellido`,
"message.confirm":`?Está seguro?`,
"Opportunity.Detailed.Phase.Label.Popup.002":`Fecha de partida`,
"label.knowledge.setting.title":`Ajustes del Conocimiento`,
"label.helptocreateprocess":`Para crear un proceso de aprobación nuevo, haga clic en ¨Nuevo¨, y seleccione ¨Utilizar Jump Start Wizard¨ para configurar el proceso con unos pasos. O, seleccione ¨Utilizar Wizard Estándar¨ para configurar todas las opciones de aprobación.`,
"label.batcheditor.remark":`Múlptiples registros se pueden editar`,
"label.page":`Página`,
"label.newfolder":`Crear nueva carpeta`,
"label.version.interceptor.api":`Interfaz API`,
"label.sms.toaddress":`recibió un SMS`,
"front-kefu-moudle-noopen-callcenter":`La organización no ha activado la función de centro de llamadas, por favor, póngase en contacto con el administrador`,
"label.data.exp.zip":`Formato de compresión`,
"lable.account.LastcDays":`Últimos 60 días`,
"label.import.index.starttime":`Tiempo de inicio`,
"label.dashboardall":`Todos los paneles`,
"label.create_socialpost":`Nuevo puesto`,
"label.searchlayoutedit.remark":`Seleccione los campos y botones mostrados cuando haga clic en búsqueda de la barra lateral en la página oficial o el menú`,
"message.servicecrew.violation":`Violación de la asignación de recursos: los recursos del servicio son miembros del equipo en este periodo`,
"label.email.attrach.file":`Adjunto`,
"report.label.folderandreport":`Informes y carpetas`,
"label.list.userinterface.sales.setup":`Configuración de la página oficial de Ventas`,
"label.martrixreport.2018.step1":`Paso 1: Seleccione forma de agrupación para calcular las informaciones resumidas`,
"label.campaignmember.selectmember.memberstatus":`Status de los miembros de campa?a`,
"label.textmessage.vonage.api.key":`Clave API`,
"label.tabpage.next":`Siguiente`,
"UG_Lead_006":`Visitante de sitio web`,
"label.salescloud.salesdashboard.visit.rankings":`Ranking de visita`,
"label.myevent":`Mis eventos`,
"label.activity.history":`Historial`,
"label_tabpage_kanban":`Configuración del panel`,
"label.weixin.allapp":`Todas las aplicaciones`,
"label.query.clone.detail.choose.choosed":`?tems detallados seleccionados`,
"message.error.view.errvalid":`Error: El campo de nombre único de vista sólo se puede contener guión bajo y letras alfanuméricas. Debe ser único, comenzar por letra, no hay espacio, no se termina por guión bajo y no contiene guiones bajo consecutivos`,
"label.customfields.searchrelation.dependobject.tip":`Seleccione otro objeto asociado con este objeto`,
"label.appointment.wizard.subtitle4-4-3":`3 semanas`,
"label.setup.mobile.offlinecache.saveerror":`Error al guardar la configuración del caché offline de la aplicación móvil`,
"label.planned.started":`Iniciado`,
"label.page.step4.of.step5":`Paso 4 de 5`,
"label.tabpage.value":`Valor`,
"label.reportlist.allfolder":`Todas las carpetas`,
"label.callcenter.sure.disable.center":`¿Está seguro de desactivar el centro de llamadas actual?`,
"vue_label_commonobjects_detail_activity_tocalendar":`Ir al calendario`,
"label.setup.mobile.bottombutton.recovery.default":`Restablecer valores por defecto`,
"label.appointmentdetail.wizard.title15":`Plan de martes`,
"label.icon.15":`Orden De Reparación`,
"component_sendmail_label_touser":`Destinatario`,
"template.report.all.owner":`Propietario de los leads`,
"front-Partner-email-tips":`Por favor, introduzca el correo electrónico para el nombre de usuario`,
"vue_label_systemSettings_mobelhomepagesetting":`Configuración de la página de inicio de la aplicación móvil`,
"label.service.newBuildDialog.aswellas":`y`,
"label.name":`Nombre`,
"label.tag.search.taglist":`Lista de etiqueta`,
"label.partnerCloud.priceOfManual.theOnly":`Se recomienda configurar el único libro de precios para cada usuario asociado. O bien, se puede elegir uno de entre varios libros de precios al realizar el pedido. El libro de precios estándar se aplica si no se establece un libro de precios específico.`,
"label.knowledge.field.update":`{1} se cambia de {2} a {3}`,
"label.emailobject.save":`Guardar`,
"label.top.changeVersion":`Horizontal`,
"label.recordtype.edit.unselected":`Valores existentes`,
"label.knowledgebase.additional.articles":`Adjuntar artículo`,
"label.lead.score.confirm":`Seleccione el rango de puntuación, haga clic en el botón de [Puntuación de candidatos], y el sistema puntuará para los candidatos seleccionados de acuerdo con la regla activada de puntuación de candidatos<br><br>Lleva unos minutos. Recibirá un correo de confirmación una vez termine<br><br>`,
"label.projectManagement.pleaseselectadate":`Seleccione la fecha`,
"label.appointment.wizard.subtitle5":`Nombre de reunión`,
"label_setup_failed":`Fallo en la configuración`,
"label.chatter.collect":`Favorito`,
"label.appointment.cancelappointment":`Cancelar`,
"front-console-response":`Tiempo de respuesta`,
"message.delete":`?Está seguro de que quiere cancelar?`,
"label.dataimport.type.selected":`Seleccione el tipo de importación`,
"label.new.target":`Nuevo indicador`,
"vue_label_report_autoupdatepreview":`Vista previa de la actualización automática`,
"label.knowledgebase.guidance":`Orientación`,
"label.chatter.mail":`Correo`,
"label.login.verification.scan.code.acquisition":`Conseguir por escanear el código:`,
"label.customsetting.changefieldtype":`Cambiar el tipo de campo`,
"label.data.dataexpalltype.all_desc2":`2. Necesita tiempo para exportar todos los datos. Al terminar la exportación, recibirá un correo.`,
"label.opportunity.contactisnull":`Información del usuario está vacía, no se puede mostrar.`,
"pagecreator_layout_button_upload":`Subir el dise?o`,
"label.dashboard.noRecord":`No hay registros`,
"label.SMS.template":`Nombre de Plantilla de SMS`,
"label.c.d.without":`Los registros "C" pueden tener o no registros "D" relacionados.`,
"UG.Case.05":`Crear caso`,
"front-epwechat-module-v1-edit-selfapp":`Editar la aplicación creada por Sefl`,
"label.role.createrole.tip":`Puede establecer sobre la jerarquía de roles actual que se muestra en esta página. Si quiere insertar un nuevo rol, haga clic en <b> para a?adir rol </b>.`,
"label.grouping":`Agrupar`,
"vue_label_email_upload_new_file":`Cargar un nuevo archivo`,
"label.notification.event3":`Su evento【事件名】empezará en【开始时间】`,
"labe_benchmark_objects":`Objeto de referencia`,
"component.chatter.button.collect":`Favorito`,
"front-QBtoCC-sinchronies":`Sincronización...`,
"message.submitpage.sms":`?Felicidades! Envio exitoso de SMS.`,
"label.imgfield.width":`Ancho`,
"label.send_email":`Enviar notificaciones de envío por correo electrónico a`,
"label.queue.list":`Lista de Cola`,
"label.tabpage.fieldoptions":`Campo de tipo registro, campo de lista de opciones y campo de lista de opciones (elección múltiple), se recomienda introducir como máximo 10 palabras clave separadas por comas para separar la realidad de relación, por ejemplo: "Nueva York, Toronto, Tokio".`,
"component.chatter.post.button.save":`Publicar`,
"chatter.group.groupDescriptionInformation":`Descripción del Grupo`,
"label_setup_mobilesetup_isenableh5newandedit":`Si active H5 para crear y editar en el dispositivo móvil`,
"lable.Confirm.recallpotential.customers":`Confirmar reciclar {num} clientes potenciales`,
"label.knowledge.setting.hint.seven":`Seleccione un nombre de los siguientes y conceda acceso de escritura para contribuir con sus esfuerzos.`,
"label.emailtocloudcc.redmessage2":`Introduzca la contraseña correcta del correo electrónico`,
"message.validation.equalTo":`Ingrese los mismos valores`,
"vue_label_help_golbal":`Navegación global`,
"vue_label_chatter_delete_group_title":`Borrar grupo`,
"label.user.login.success":`Inicio de sesión con éxito.`,
"label.chatham.standard.time":`Hora de Verano de Chatham`,
"label.vlidaterule.example.percent":`El porcentaje del descuento no se puede exceder el 30%`,
"label.group.field":`Campo de grupo asignado`,
"label.trigger.operation.sharetab":`Formulario compartido de operación de activación`,
"label.mobile.phone.write.month.report":`Escribir reporte mensual`,
"label.statusofconvers":`Status convertido`,
"label.version.emailtemplate.track":`Plantilla de correo`,
"label.customobjects.onlytrackforupdate":`Solo seguir los cambios`,
"label_tabpage_enterviewname":`Paso 1: Ingrese el nombre de vista`,
"label.processsetting.three.enable":`Paso 3: Activar`,
"label.service.show.more.info":`Mostrar más información`,
"front-epwechat-module-v1-input-iosschema":`Por favor, introduzca el esquema de iOS`,
"label.dataimport.datatype.error":`Error del tipo de datos, revise atentamente si los datos y título coinciden`,
"label.staticresource":`Recursos estáticos`,
"label.weixin.customize":`Personalizar`,
"label.product.edit.sel":`Editar los seleccionados`,
"label.appointmentpage.wizard.notif5":`Formato de móvil inválido`,
"label.marketsea.basicsetup":`Configuración básica`,
"label.workflow.supplyintruduce":`1. Los criterios que causan el funcionamiento del flujo de trabajo.<br/>2. Operación inmediata realizada cuando un registro alcance los requisitos. Por ejemplo, CloudCC puede enviar automáticamente un correo de notificación al grupo de clientes una vez creada una nueva oportunidad<br/>3. Las operaciones dependientes del tiempo se ponen en cola, y se ejecutarán de acuerdo con el trigger de tiempo `,
"label_report_line_tuozhuai":`Arrastre o haga doble clic para seleccionar las columnas del informe y ajustar el orden de las columnas`,
"label.add.new.rule":`Añadir nuevas reglas de generación`,
"label.marketing.setting2":`Configuración de canal`,
"vue_label_chatter_delete_some_group":`¿Está seguro de que quiere eliminar el grupo "{groupInfoList}"`,
"label.appupload.uploading.wait":`En espera`,
"label.linecondition.error":`?Error de condición de línea, no coincide con el formato del campo!`,
"chatter.group.request":`Solicitud`,
"label.recordtype.tabname.remark":`Utilice esta página para crear y mantener los tipos de registro de su organización. Se puede mostrar des?o diferente y valor de lista de opciones según los tipos de registro. Para utilizar los tipos de registro, a?ade ¨Tipo de registro¨ al dese?o`,
"setup_mainpage_label_welcome4":`Instrucciones: Haga clic en el menú a la izquierda de la página → Configuración de Aplicación → Crear → Objetos.`,
"vue_label_salesadvance":`Avanzar etapa de venta`,
"vue_label_campaign_of_existing_campaign_members":`Establezca el estado de los miembros de la campaña existente`,
"label.report.object.detail.no.permission":`El tipo de informe ha cambiado o se ha desplazado. Póngase en contacto con el administrador para obtener ayuda.`,
"label.weixin.untreated":`Abierto`,
"label.service.miniProgram.bindSetOwnerDesc":``,
"label.autoassigntoapprover":`Asignar automáticamente a los aprobadores.`,
"label.marketseamemset.containself":`Contiene registros auto-creados`,
"vue_label_report_drill":`Exploración en profundidad`,
"label.order.products.to.assets":`Convertir el producto de la orden en un activo`,
"label.recordtype.list":`Tipos de registro existentes`,
"lable.outlook.detail.conflict":`Comportamiento de conflicto`,
"pagecreator.page.label.layoutpreview":`Vista previa del diseño`,
"front-kefu-moudle-v1-zxltyhxzc-buyuser":`El chat del agente es apoyado por Easemob. Por favor, compre una cuenta Easemob primero.`,
"label.convers":`Convertir`,
"serviceappointment.worktype.isnot.father.worktype":`Para esta cita de servicio debe seleccionarse el tipo de trabajo asociado a su registro principal`,
"lable.tianyancha.h5.relatedcom":`Empresas relevantes`,
"label.reportsSubscriptionPage.schedulereport":`Establecer el tiempo de informe`,
"label.workbanch.setup.showinworkbanch":`Si muestra en mi mesa de trabajo`,
"label_emailsync_connectaccount":`Vincular cuenta de correo`,
"label.usermanage.license.not.qualified":`El sistema ha detectado que se trata de una licencia no conforme, por favor, póngase en contacto con el proveedor para obtener la licencia de nuevo.`,
"component_setup_label_displayfield":`Mostrar campo`,
"setup_layout_label_buttonarea":`?rea de botón`,
"label.weixin.input.content":`Ingrese los contenidos`,
"label.operatedata.importsuc":`Importación exitosa, puede revisar el resultado de importación haciendo clic en el menú del objeto`,
"label_tabpage_yes1z":`Sí 1`,
"front-electronic-signature-describe":`Acceda a la firma electrónica, firme un contrato en cualquier momento y lugar. Firme con un solo clic, de forma segura y eficaz.`,
"label.event.this.month":`Eventos de este mes`,
"label.document.replaces":`Reemplazar`,
"label.email.cc":`Cc`,
"chatter.feed.sticker":`Seguimiento de micro-publicación`,
"vue_label_commonobjects_view_chart_notice_pleaseaddchart":`Añada un gráfico`,
"label.cpq.main.quote.transfer.order":`Sólo la cotización primaria puede generar órdenes.`,
"label.partnerCloud.partnerAccount.topUpSuccess":`Recarga con éxito`,
"label.appexchange.uninstallpage.uninstall":`Desinstalar`,
"label.campagin.roi.channel":`Canal`,
"label.multilang.versioncontrol.checkversion":`?Su versión actual de CloudCC es {0} que permite crear {1} {2} que alcanzó al límite!? Si es necesario, actualice la úlitma versión!`,
"label.emailobject.my.template":`Sólo mis plantillas`,
"label.edittimetrigger":`Editar hora de Trigger`,
"label.setup.mobile.homepageshortcuts.saveerror":`Error al guardar la configuración de la función rápida en la página ofical del móvil`,
"label.address.street":`Calle`,
"label.workflow.estimatecondition2":`Creado`,
"label.wei.expiresdate":`Fecha de vencimiento`,
"label.quickbooks.viewlist.date":`Fecha`,
"label.page.select.field.type":`Seleccione tipo de campo`,
"label.tabpage.mypotentialcustomers":`Mis clientes potenciales`,
"label.file.library.editlib":`Editar detalles de la base de documentos`,
"label.weixin.message.operateexception":`Indicación`,
"label.visualpage.staticresource.p1":`1. Método de llamada. Referencie los recursos estáticos seleccionados por referenciar al botón de recurso estático`,
"label.icon.175":`Boletos De Avión`,
"chatter.edit.r":`Escribir un comentario...`,
"label.examinationandapproval.flow":`Proceso de aprobación`,
"label.mr.descreption.reDataList5":`Conjunto de datos`,
"label.edit.field.select.showstyle":`Estilo Demostrado`,
"label.reportsSubscriptionPage.condition.and":`Y`,
"label.please.associations":`Por favor, elija el objeto asociado.`,
"label.service.dispatchingUnits.displays.service.appointments":`Mostrar las citas de servicio que no están asociadas a una región`,
"label.addcurrent":`Añadir los existentes`,
"label.search.change":`Configuración del objeto de búsqueda`,
"message.schedulejob.error.modify":`Según el programa configurado, el trabajo dado nunca se activará, revise los datos y vuelva a enviarlos. `,
"label.chatter.sendEmailToGroupMember.subject.L":`{0} enlaces publicados para todos en {1}`,
"label.weixin.micro.oldid":`ID Orginal de Cuenta Oficial de WeChat`,
"label.employees.only.invitation.code":`El sistema generará un código de invitación único para el empleado, que puede ser utilizado para realizar invitaciones y puede ser contabilizado como KPI individual. Por favor, tenga en cuenta que el propietario de los clientes principales será el propietario de la campaña actual o el anfitrión del canal de marketing. Puede reasignar los clientes potenciales a través de las reglas de asignación. Sobre las reglas de asignación`,
"lable.PowerProcess.event.msg":`Puede añadir acciones de flujo de trabajo dependientes del tiempo que se produzcan en cada paso (evento clave) del proceso de asignación. Por ejemplo, puede configurar acciones para enviar un correo electrónico al propietario del caso una hora antes de que expire un evento clave, o para actualizar automáticamente campos específicos del caso cuando se complete la primera respuesta de un evento clave.`,
"label.file.share.email.content2":`Información compartida: Comparte permiso #sharerole con su archivo actual`,
"label.querydetailservice.datalayout.notexist":`El dise?o correspondiente del registro no existe`,
"label.group.items":`?tem de agrupación`,
"label.istouse":`Disponible`,
"front-electronic-signature-explain":`Descripción de la firma electrónica de Fadada:`,
"label.partner.template.thumbnail":`Imagen en miniatura`,
"registration.page.selected.fields":`Campos obligatorios de la página de registro`,
"label.reportTypeCategoryLabel":`Fuente de datos`,
"vue_label_email_You_have_not_activated_the_mailbox":`No ha activado el correo`,
"lable.SalesCommitmentKanBan.taskCompletionRate":`Ratio de finalización de tareas`,
"label.forecast.detailforecast.program":`?tems de previsiones`,
"label.page.display":`Mostrar`,
"label.passwordPolicy.setup.minute":`Minutos`,
"label.emailtocloudcc.step1total3":`Paso 1 de 3`,
"label.file.title":`Título`,
"label.callcenter.private.key":`Clave secreta de acceso privado`,
"com.cloudcc.login.error.message.loginerror":`Nombre del usuario o contraseña incorrecta`,
"UG_Lead_004":`Formulario de red`,
"label_tabpage_recordsz":`Registro`,
"label.shangqing.discovery":`Encuentro de información comercial`,
"vue_label_notice_change_success":`Modificado con éxito`,
"label.ems.other":`Otros`,
"loading":`Cargando...`,
"label.committedtoapprove":`Las solicitudes entregadas`,
"label.category.4":`Financiero`,
"template.report.folder.customer.situation":`Análisis de la situación contable`,
"label.quickbooks.searchresault.phone":`Teléfono`,
"label.ccpeak.ccobj.save":`Para guardar CCObjeto en la base de datos, el método de llamada es`,
"label.knowledge.delete.linked":`Error al borrar el artículo asociado`,
"label.forecast.settings.future2":`Dos ciclos del futuro`,
"message.error.displaytype.detail":`El tipo de visualización no puede estar vacío, Día: day, Mes: month, Semana: week, Disponibilidad: availability`,
"front-template-V1-search-template-name":`Introduzca el nombre del objeto y busque`,
"label.sendsms.batch.step3.introduce":`Guardar los eventos de cada SMS`,
"UG.Forcast.08":`Paso anterior`,
"label.inputnameandintro":`Ingrese el nombre y descripción`,
"label.redistributioned":`Reasignado`,
"label.service.dispatchingUnits.left.right.total":`{left}-{right} registros actuales, {totalCount} registros en total`,
"label.projectManagement.Pleaseentertheactualworkinghours":`Introduzca las horas de trabajo reales`,
"label.exporttemplate":`Exportar la plantilla`,
"label.data.downpage":`Página de descarga de datos`,
"message.please.choose.contact":`Seleccione un contacto`,
"message.error.dataformat.error":`Error de formato de datos`,
"label.customsetting.changefieldtype.losevalue":`Cambiar al tipo de datos seleccionado causará la pérdida de todos los datos existentes en el campo.`,
"label.sendemail.chat.chattype":`Tipo de la publicación principal`,
"label.ccdocument.upload.error":`?Se ocurrió error al subir documento!`,
"label.quickbooks.view.all":`Todos`,
"label.data.downpage.e_title":`Paso para exportar datos:`,
"lable.data.lock":`Los datos están cerrados, desbloquéenlos primero antes de editar.`,
"label.locked":`Bloqueado`,
"label.customfields.beforedeletedata":`Antes de cancelar este campo personalizado, se recomienda que configure haciendo clic en  | Gestión de Datos |`,
"label.productsales.oppor.noapproach":`No hay oportunidades con una fecha del contrato expectado menos de 30 días`,
"label.input.notmore.than.number":`Ingrese un número menor o igual que {0}`,
"label.list.userinterface.isenable":`Activar edición en línea`,
"label.listofshare":`Lista de información sobre las acciones`,
"label.emailsync.status.role":`Rol`,
"label.staticresource.useful.realtion":`Utilizar la posición de los recursos estáticos`,
"label.sharerule.tip":`Esta página muestra configuración compartida de su organización. Las configuraciones especifican el nivel de acceso que tiene cada usuario para entrar a los datos de los demás.`,
"label.qrcodelogin.message.expired":`El código QR ha expirado`,
"label.marketing.setting3":`Configuración del canal de marketing`,
"vue_label_statistical_field":`Campo estadístico`,
"message.view.addtomyhomepage":`Añadir a la mesa de trabajo de la página oficial`,
"label.customfields.percent.tip":`Permite a los usuarios ingresar número de porcentaje (por ejemplo ¨10¨) y a?ade automáticamente el signo de porcentaje al número.`,
"component_newrecords_label_10records":`10 registros`,
"Lead_Scoring_Warning_001":`Puntuación automática al crear o editar un candidato individual, pero se procesa puntuación masiva manual con respecto a los candidatos de importación masiva o creados por interfaz.`,
"label.project.planing":`Horashombre de despacho VS horashombre declaradas en este año`,
"label.data.exp.pwdverif":`Las contrase?as sólo pueden ser letras y números`,
"coderules.notEnable":`Póngase en contacto con el administrador para activar las reglas de generación de códigos QR y de barras`,
"label.weixin.wdyj.jxhk":`Personal-Rendimiento de ventas-Pago`,
"label.data.expnode.e_desc3":`3. Crear plantilla: Los usuarios pueden hacer plantilla para los campos y criterios que necesiten exportar de acuerdo con los requisitos, que es conveniente para el próximo uso.`,
"chatter.group.join":`Participar`,
"vue_label_systemSettings_monitoring":`Monitor`,
"front-kefu-moudle-v1-yesorno-delete-folder":`¿Está seguro de que debe eliminar esta carpeta?`,
"label.exchange.sync.state.info":`Revise el status del sistema para asegurarse de que los registros sincronicen entre Exchange y CloudCC.`,
"lable.outlook.mcto.emaildes":`Introduzca todas las direcciones de correo de clientes y candidatos que utilice para enviar correos, y los separa por coma. Solo el correo enviado desde el correo siguiente se puede añadir a la lista de actividad del registro relacionado.`,
"label.ems.save":`Guardar`,
"vue_label_dashboard_maximumvalue":`Introduzca el valor máximo`,
"label.passwordPolicy.setup.norestriction":`No restricción`,
"label.multilang.customforcast.total":`Acumulación de {0}：`,
"label_partner_all_memo":`La lista muestra todas las nubes de socio en su organización. Haga clic en URL para saltar directamente al inicio de sesión.`,
"Account.News.Setting.002":`Utilice la configuración de cliente de a continuación para especificar el comportamiento del cliente por defecto para su organización.`,
"label.essential":`Obligatorio`,
"label.nonotice":`No más recordatorios`,
"vue_label_calendar_calendar_deleted_successfully":`Calendario borrado con éxito`,
"message.huanxinagent.disable":`Agente inactivo`,
"label.goto":`Saltar a`,
"label.chat.topic.add.favorite":`Agregar a los marcadores`,
"label.trigger.targetobj":`Objeto de objetivo`,
"label.form_fields":`Campos del formulario`,
"this.month":`Este mes`,
"vue_label_homepage_select_view":`Seleccionar vista`,
"label.weixin.input.subject":`Rellene el subjeto`,
"label.ems.emailType":`Tipo del correo`,
"vue_label_file_safe_type_file":`Por favor, asegúrese de que el archivo no contenga información sensible. Considere la posibilidad de compartir archivos con usuarios o registros específicos`,
"label.version.case.automatic.upgrade":`Escalamiento y Asignación automática del Case`,
"label.input.invalid.credit.card.number":`Ingrese el número de tarjeta de crédito válido`,
"component_timeline_label_future":`Siguiente paso`,
"label.emailtemplate.cannotsupporthtml":`Por la presente el tipo HTML no está disponible`,
"label.appupload.install.error.info2":`{1} '{0}' tienen conflictos con los componentes existentes.`,
"label.custom.field.maping":`Mapear a este campo`,
"encd":`Texto Cifrado (Mostrar Cifrado)`,
"label.service.newBuildDialog.filter.logic":`Lógica del filtro`,
"label.customerinfo":`Perfil de empresa`,
"vue_label_applauncher_notice_activepoolsuccess":`Se ha activado con éxito el grupo público`,
"label.partner.workspace.member.choicepermission":`Seleccione conjunto de permisos`,
"front-gantt-module-this-task-of-other-tasks":`Esta tarea existe como una subtarea y no puede ser una subtarea de otra tarea.`,
"label_chatter_publish":`Publicar`,
"label.forecast.settings.mrfw":`Empezando de`,
"label.Named.Filter":`Nombre del filtro`,
"label.department.email":`Correo electrónico`,
"label.updatingfield":`Campo por actualizar`,
"label_partner_template_detail":`Descripción de función`,
"front-epwechat-module-v1-unbound-item":` vinculación de todas las empresas`,
"vue_label_file_lib_name":`Nombre de la biblioteca de archivos`,
"label.notification.arketsea.distribution":`{5} le ha asignado {2}{0}：{1} a usted`,
"vue_label_norm_removecomponent":`Eliminar componente`,
"component.event.label.begindate":`*Tiempo de inicio`,
"chatter.note":`Comentario(s) recibido(s)`,
"label.forecast.settings.type.all":`Utilizar previsiones generales`,
"label.compact.layout.frame.full":`Pantalla completa`,
"label.approvalstep3intro":`Utilice las opciones siguientes, especifique los usuarios a los cuales asignan la solicitud de aprobación`,
"label.notification.approval6":`【被委派人名称】le ayuda a aprobar la solicitud de 【对象】【对象名称】 de parte de【申请人】.`,
"setup.object.field.dependency.label.actionfieldvalue":`Valor de campo de control`,
"label.multilang.page2":`Página`,
"vue_label_email_submitted":`Enviado`,
"label.Standard.button":`Botones estándar`,
"vue_label_report_emailchoose":`Opción de correo electrónico`,
"page.field.masterinput.list":`Lista de importación de datos Máster-Detalle`,
"label.martrixdown":`Matriz abajo`,
"vue_label_helpcenter_opportunity":`En la esquina superior derecha de la vista, haga clic en el icono del embudo de ventas para visualizarlo.<br> A través de la barra de progreso, siga el progreso de cada oportunidad de negocio de manera intuitiva y haga clic en el botón para marcar la finalización de la etapa actual o ajustar la etapa actual. Si se encuentra con obstáculos en el avance de las oportunidades de negocio, también puede expandir la barra de progreso para ver la información y algunos consejos sobre lo que debe prestar más atención en la etapa actual.<br>A través de la lista relacionada del grupo de oportunidades de negocio, los datos de las oportunidades de negocio se pueden compartir con otras personas que no tienen acceso a verlos, para facilitar el trabajo en equipo.<br>En la lista relacionada del rol de contacto bajo la oportunidad de negocio, se puede añadir rápidamente el rol en la oportunidad al contacto en el cliente correspondiente, y luego ver la relación superior y subordinada del contacto relacionado a través de la red de relaciones, y utilizar el gráfico de radar para evaluar el valor del contacto en la oportunidad actual, el estado del seguimiento, la localización de las personas clave y comprobar los contactos. Rol, estado de la visita, grado de relación, estilo de compra y número de visita<br>A través de la lista de productos relacionados de la oportunidad de negocio, puede añadir productos en la misma lista de precios para la oportunidad de negocio, y editar el precio y la cantidad de los productos.`,
"label.sso.ssoKeyMan":`Gestión de clave de inicio de sesión individual`,
"label.forecast.edit.desc":`Configurar cuota de algún usuario en el período siguiente`,
"label.weixin.newspaper.coverage.time":`Fecha de Riesgo`,
"label.pleaseselectpro":`Seleccione productos`,
"label.bottonandlink":`Botones y enlaces`,
"label.donot.know.error":`Un error desconocido se ocurrió, contacte con el administrador`,
"label.account_noordab":`Su cuenta tiene 0 informes personalizados y 2 cuadros de mando.`,
"label.partnerCloud.orderingPlatform.toPay":`Pago por fondo asociado`,
"label.many.dayline.nextday":`Al día siguiente`,
"lable.showmorerecords":`Mostrar más`,
"front-lightning-module-v1-details-page-chart-record-type":`Seleccione el tipo de registro`,
"label.ccpeak.query.record":`Registros de búsqueda:`,
"pagecreator.systemstyle.message.save.fail":`Error al guardar diseño`,
"label.weixin.share.file":`Compartir archivo`,
"errormessage.email.relatedorreceivermusthaveone.z":`Debe seleccionar al menos un destinatario o un elemento relacionado`,
"chatter.save.f":`Se frascasó en guardar`,
"button.partner.create":`Crear`,
"label.marketseamemset.lead.title2":`Por favor, establezca un límite máximo en el número de clientes potenciales que afectan a todos los miembros. El límite no se aplica al grupo público.`,
"label.service.major.event.new":`Nuevo evento clave`,
"label.version.custom.site":`Sitio personalizado`,
"label.permission.visualpagepermission":`Página personalizada asignada`,
"lable.product.zongjia":`Precio total`,
"label.viewchart":`Ver gráficos`,
"label.alaska.daylight.time":`Hora de verano de Alaska`,
"front-kefu-moudle-v1-rgdyhcwzx-reply":`Permita que más usuarios se conviertan en agentes y atiendan a los visitantes, mejorando el servicio al cliente.`,
"component_assistant_label_todaylead":`Los candidatos que le asignaron hoy`,
"label.sendemail.chat.addComentsfavorite":`Estimado #name:\n\n ; ?Hola! #userName responde su micro-publicación a favoritos.`,
"label.smstemplate.tip":`Se muestran a continuación todas las plantillas SMS de la carpeta seleccionada. Haga clic en el botón "Nuevo" para crear una nueva plantilla SMS de texto o HTML. Puede utilizar estas plantillas SMS para enviar mensajes. Haga clic en el enlace de la función para ver información más detallada`,
"label.documentname":`Nombre de documento`,
"label.icon.162":`Paisaje`,
"label.salescloud.wanyuan":`Yuan`,
"label.view.desc1":`Recordar el tipo de campo, el campo de lista de opciones, lista de opciones (Múltiples selecciones), se recomienda que ingrese hasta 10 palabras clave, separada por comas, como ¨Beijing, Shanghai, Guangzhou¨`,
"label.searchlayout.lookup.newfield":`El campo mostrado al hacer clic en el botón de ¨Nuevo¨ en el cuadro de diálogo de búsqueda.`,
"label.emailobject.bcc":`Cco:`,
"label.manageAll.pagenum1":`Esta es la primera página`,
"vue_label_appstore_crm_used_companies":`El CRM utilizado por las empresas cotizadas`,
"label.document.replace":`Reemplazar`,
"label.assignment.setup.newrule.title":`Crear regla de asignación del caso`,
"component.chatter.label.mygroup":`Mi grupo`,
"lable.currencyAdv.exchangedate":`Rango de fecha`,
"label.quickbooks.button.viewinqb":`Ver en QuickBooks`,
"UG.homepage.004":`Automatización`,
"label.currencyName":`Nombre de Moneda`,
"Homepage_News_001":`Noticias`,
"front-lightning-module-v1-details-page-chart-refresh-button":`Mostrar el botón de actualización`,
"label.list.projectSetting.isenable":`Habilitar el temporizador del proyecto: (incluye: hito, tarea, subtarea, problema)`,
"setup.layout.message.relatedlistbutton":`Seleccionar los botones estándares que se mostrarán en la lista relacionada.`,
"vue_label_homepage_homepageassignment":`Asignación de la página de inicio de la aplicación`,
"label.pending":`Pendiente`,
"component.timeline.label.today":`Hoy`,
"front-kefu-moudle-free-hasexpire":`Su prueba gratuita ha expirado`,
"homepage.layout.customlayout":`Dise?o de página personalizada`,
"label.service.miniProgram.content":`Rellene el contenido`,
"label.defaultline.must.int":`El número de líneas predeterminado sólo puede ser entero positivo`,
"label.mirror_issues":`Si el formulario no refleja lo que ves en tu lado, lee nuestro artículo sobre cómo solucionar los problemas de visualización más comunes.`,
"label.edit.select.two":`Lista de selección única`,
"label.emailmerge.mergeFolder.tip":`?Combinar las plantillas necesita tiempo, durantes la combinación, no haga clic en otros enlaces, cierre navegador de web o refresque página!`,
"label.ServiceCloud.zichan.distributionMap":`Mapa de distribución de activos`,
"label.selectfile":`Seleccione ficheros`,
"vue_label_account_equitymanage":`Gestionar la vinculación accionarial`,
"label.email.clearAll":`Borrar todo`,
"label.selecting.parent.assets":`Elija el activo principal`,
"component.setup.tabs.label.delete":`Eliminar`,
"label.visualpage.top.must.is":`La primera línea del encabezado de la página debe ser:`,
"label.SalesCommitmentDashboard":`Tableros de Ventas`,
"chatter.group.changeTheRole":`Cambiar rol`,
"label.dataimport.insertdata.error":`Un error se ocurrió al insertar nuevos datos, por favor revise este dato atentamente.`,
"label.partner":`Nube de socios`,
"label.process.async.execute.tip":`Su solicitud está en proceso. La aprobación lleva cierto tiempo y el resultado se mostrará en la página de detalles. Por favor, espere.`,
"label.service.newBuildDialog.additional.conditions":`Condiciones adicionales`,
"label.name_copy":`Está a punto de clonar este formulario existente. Por favor, introduzca un nombre para la copia.`,
"label.integrations.install":`Autorizar`,
"label.edit.ccpeakfolder.time":`Clasificación programada: Editar carpeta`,
"label.knowledgebase.filing.time":`Tiempo archivado`,
"vue_label_chatter_success_exit_group":`Se ha salido con éxito del grupo`,
"font.market.module.v1.save.name":`Por favor, rellene el nombre de la reunión`,
"label.a.b.without":`Los registros A pueden tener o no registros relacionados con B.`,
"label.chat.topic.desc":`Descripción`,
"label.field.editoptionlist.introduce":`Ingrese el nombre del valor de la lista de opción,   seleccione esta casilla de verificación y utilice este valor como valor predeterminado`,
"label.versiontype.Enterprise":`Versión empresarial`,
"message.selectrulecondition":`?Especifique los criterios de regla!`,
"label.custombutton.unknown.operation":`Operación inválida`,
"label.pricecannotnull":`El precio no se puede estar vacío`,
"component_salesperformance_label_target":`Objetivo`,
"pagecreator.page.message.delete.success":`Página eliminada con éxito`,
"label.help.new.features":`Guía de nuevas funciones de CloudCC`,
"label.weixin.vehicle.owner.information":`Detalles del propietario del vehículo`,
"label.exchange.sync.state.user.info":`Revise el status de sync de un usuario para asegurarse de que los registros sincronicen entre Exchange y CloudCC. Si el usuario encuentre problema sincronizando entre Exchange y CloudCC, puede resetear el proceso de sincronización. Resetee información sólo usada por CloudCC for Exchange y no cancele datos del servidor de Microsoft Exchange o CloudCC.`,
"label.batcheditor":`Edición Masiva`,
"report.label.knowcreatehighlevelreport":`¿Cómo crear un informe avanzado?`,
"label.dataimport.title.length":`La longitud del título es`,
"label_model_description":`Descripción del modelo`,
"label.tabpage.ctbtsftcz":`Haga clic en la parte posterior para buscar el contenido`,
"label.channel.activity.member.owner":`Propietario de los miembros del evento del canal`,
"label.ems.serverinfo":`Información de servidor`,
"tjinvilid":`Condiciones ilegales`,
"label.nameofreport":`Nombre de informe`,
"label.ifapproverreject":`?Qué se pasará si el aprobador rechace esta solicitud?`,
"label.wtd.changefields.title.desc2":`Si necesite un registro en la aplicación móvil ¨Web to CloudCC¨ para asociar un candidato, necesite crear un campo basado en el objeto actual para buscar el candidato, y el campo de nombre API es  " lead_wtd".`,
"label_emailsync_form_connecttime":`Tiempo relacionado`,
"label.visualpage":`Página personalizada`,
"label.customlink":`Enlaces personalizados`,
"label.lead.score.doing.remark":`Su solicitud ha sido procesada y se requiere tiempo determinado para la puntuación de los candidatos, el sistema le enviará el correo para avisarle una vez lo termine.`,
"label.h5.act.details":`Detalles de eventos`,
"label.profile.setrecordtype":`Configuración del tipo de registro`,
"label.processsetting.process.enabled.successfully":`Proceso habilitado con éxito`,
"label.campaign.url.overtime":`El enlace ha expirado`,
"label.structureChart.notFiled":`Sin rellenar`,
"label.h5.chatter.something":`Quiere decir algo`,
"label.pm":`PM`,
"template.chart.rwlx":`Tipo de tarea`,
"label.icon.42":`Nube`,
"label.project.hit.one":`Aviso de asignación de subtareas`,
"label.martrixreport.2018.step3":`Paso 3: Seleccione columnas de informe`,
"label.wtd.changefields.newmo":`Generar la página móvil`,
"label.downloadTheTemplate":`Descargar Plantilla`,
"label_chatter_assignPerson":`Asignado`,
"label_emailtocloudcc_license":`Licencia`,
"label.willdeletedlayout":`Dise?o de página que desea cancelar`,
"label.projectManagement.delete.question":`Toda la información relacionada con esta cuestión también se borrará si elimina esta cuestión, y los datos no se pueden recuperar. Está seguro de confirmar la eliminación?`,
"lable_setup_mobilesetup_isEnableValidationRulesForScan":`Si activa las reglas de verificación al escanear la tarjeta`,
"label.salescloud.opportunity.addandedit.contactrole.note":`Nota: Haga doble clic en los contactos en blanco, se puede añadir un nuevo registro en blanco`,
"label.step6.total6":`Paso 6 de 6`,
"label.knowledge.setting.hint.one":`El conocimiento permite al cliente y al personal de servicio hacer un uso completo de los artículos de conocimiento.`,
"label.usefieldautoassign":`Asigne automáticamente un aprobador utilizando un estándar o campo de jerarquía personalizado:`,
"label.partnerCloud.orderingPlatform.orderAmount":`Cantidad del pedido:`,
"chatter.fieldtrack.operateupdate":`Ha cambiado a`,
"chatter.del.com":`Cancelar este comentario`,
"report.reportdatasource.label":`Fuente de datos del informe`,
"label.text":`Texto`,
"label.marketsea.select.member":`Miembros elegibles`,
"label.typeofreceivers":`Tipo de destinatario`,
"label.knowledgebase.affect.existing.translations":`Sí, mis modificaciones afectarán a la traducción existente. Marcar como "Caducado"`,
"label.marketing.invitationmail":`Bienvenido a nuestro evento, el enlace de su invitación es:`,
"label.version.quotation.management":`Gestión de presupuestos`,
"label.dataimport.insertdata.error.unique":`$fieldName$ viola la restricción única al insertar datos nuevos`,
"label.emailmerge.list.newtemplate":`Nueva plantilla`,
"label.salescloud.salescloud.allteam":`Todas las oportunidades basadas en grupos`,
"vue_label_commonobjects_detail_record_changes":`Cambios en los registros de campo`,
"label.file.delete.info":`Cancelar archivos`,
"vue_label_calendar_name":`Nombre del calendario`,
"label.version.support":`Soporte`,
"label.event":`Eventos`,
"label.searchlayout.lookup.searchdialog":`Haga clic en el enlace de ¨búsqueda¨ en el campo ¨búsqueda¨ para abrir el cuadro de diálogo.`,
"label.data.downpage.e_list.desc2":`Después de exportar los datos, recibirá un correo para recordarle el éxito de la exportación.`,
"label.partnerCloud.productSet.delIsTrue":`¿Desea eliminar este producto?`,
"label.tianyancha.businessverify.msg2":`Este acuerdo es uno entre usted (Por lo siguiente¨Usuario¨) y CloudCC con respecto al uso de la función de verificación de datos comerciales. Este acuerdo describe los derechos y obligaciones del uso de la función de verificación de datos comerciales y servicios relacionados entre CloudCC y el usuario. CloudCC puede actualizar este acuerdo en cualquier momento. Los términos acualizados del acuerdo, una vez publicados, reemplazarán los términos originales del acuerdo sin previo aviso.`,
"label.customobjects.cancleselectallfield":`Cancelar todos los campos seleccionados`,
"image.up.maxsize":`El archivo subido es demasiado grande, no supere los 2M.`,
"label.icon.8":`Archivo`,
"label.donot.delete":`?No tiene permiso para cancelar!`,
"label.version.profile.and.layoutpage":`Perfiles y dise?o de página`,
"chatter.coll.s":`Cancelar el marcador`,
"label.icon.163":`Tierra`,
"label_chatter_myfollowers":`Mis seguidores`,
"label.multilang.customforecast.refuse":`Se rechaza cualquiera prioridad de previsiones de {0}, pero se acepta prioridad de otros subordinados`,
"label.tabpage.findz":`Buscar`,
"label.smstemplate.detailinfo":`Detalles de la plantilla de SMS`,
"label.knowledge.setting.hint.nineteen":`Comencemos`,
"label.mr.tip":`Complete las reglas en línea{0}.`,
"label.icon.132":`Garantizar`,
"label.customobjects.track.introduce2":`Los campos de seguimiento en la lista relativa de ¨campo de seguimiento¨. Cada vez que un usuario cambie cualquier campo selecionado siguiente, los valores nuevos y antiguos, fecha, tiempo, propiedades y usuarios modificados serán a?adidos a la lista relativa de ¨Campo de seguimiento¨`,
"label_emailtocloudcc_redmessage5":`Estado desconocido, contacte con el administrador`,
"label.must.select.field":`Error de condición de línea, debe seleccionar por lo menos un campo.`,
"label.tag.manage.modifiedby":`Última Modificación Por`,
"label.translation.start1":`Seleccione un idioma(Si es un traductor)`,
"label.ccchat.topic.searchs":`Buscar tema`,
"label.mask.custom.example":`{AAAA}{****}{AAAA}representa la visualización encriptada de quinto carácter al octavo carácter`,
"setup_object_field_dependency_label_addtolist":`Añadir valores seleccionados`,
"label.view.total.record":`Un total de 0 registros seleccionados`,
"label.service.without.right":`No hay derecho asociado`,
"template.chart.wxqzkhyy":`Motivos de los clientes potenciales no válidos`,
"vue_label_dashboard_pleaseenterabreakpoint1value":`Introduzca un valor de punto de ruptura 1`,
"message.pleaseinputmouthdistance":`Ingrese el intervalo del mes válido`,
"label.forgetPsd.tip":`Se ha olvidado la contrase?a, contacte con el administrador.`,
"label.projectManagement.planned":`Programado`,
"lable.Product.conversion.asset.operation":`Transferir el producto al activo`,
"label.search_forms":`Búsqueda de formularios`,
"label.sendemail.chat.addPostmainPagesubject":`Comentario de la página oficial de CloudCC CCChatter`,
"label_tabpage_viewNamez":`Por favor ingrese el nombre de la vista`,
"label_chatter_addresser":`Remitente`,
"Opportunity_Detailed_Phase_Change_Text_001":`Cambiar etapa de oportunidad`,
"label.what":`Página`,
"vue_label_systemSettings_set_android":`Configurar los menús y las funciones para Android e IOS con el fin de adaptarlo a los usuarios de la empresa.`,
"label.sell":`Venta`,
"template.report.folder.case":`Análisis de casos`,
"label.customfields.profilefieldsafety":`Perfil de seguridad del nivel de campo`,
"label.industrialandcommercialverification.label.token":`Token`,
"label.finished":`Completado`,
"label.sendmail.step3.introduce1":`Actualemente seleccionado`,
"vue_label_calendar_other_calendars":`Otros calendarios`,
"label.donot.know.validate.field":`Campo de validación inválido`,
"label.exportdetail":`Exportar detalles`,
"label.step.filter":`Especifique las condiciones de filtro`,
"label.campaignmember.main.hasMember":`Miembros existentes`,
"label.updown.suess":`Descargar con éxito`,
"label.ems.browse":`Buscar`,
"front-email-payment-Invoice-login-account-describe":`Haga clic en "Continuar" para completar el pago de la factura escaneando el código QR de Alipay o iniciando sesión en Alipay.`,
"label.copyCustomReportType":`Copiar origen de datos del informe personalizado`,
"label.visualpage.write.class":`Editar código de Class, la sintaxis del código es igual que el de Java`,
"label.setsharerule.tip":`<br>Comparte los datos que alcanza las condiciones configuradas a algún rol de acuerdo con las reglas de compartido<br>Nota: Los roles y subordinados incluyen todos los usuarios en un rol determinado y los roles por debajo de este rol.`,
"label.report.action.addtodashboard9":`Página de la lista de tableros`,
"label.cloudccsite.remark":`Descripción del Sitio`,
"label_tabpage_noz":`No`,
"chatter.up.limit":`El archivo subido es demasiado grande, no exceda a `,
"label.leadmarketsea.grouplist.title":`Configuración de grupos del grupo público de clientes potenciales`,
"label.pc.user.help":`Guía de usuario`,
"label.partnerCloud.orderingPlatform.relyOn":`Dependencia`,
"label.appointmentpage.wizard.subtitle2":`Seleccione tiempo`,
"label.deleteoneormore":`?Cancelar uno o más?`,
"january":`Enero`,
"label.delete.profile":`Cancelar perfil`,
"label.appointment.wizard.subtitle1-7":`2h`,
"label.icon.188":`Cosmético`,
"vue_label_file_already_in_lib":`Ya existe en esta biblioteca de archivos`,
"label.icon.151":`VR`,
"label.withvalue":`Por Valor`,
"label.tianyancha.businseeverify.opererror":`?Se frascasaron en abrir los datos comerciales, intente de nuevo o contacte con el administrador!`,
"label.tabpage.individual":`Selección única`,
"label.layout.editdistribute":`Editar asignación`,
"label.smstemplate.lookup":`Ver plantilla de SMS`,
"pagecreator.systemstyle.button.delete":`Borrar estilo`,
"label.customer.tab.step2.same.option1":`Abierto por defecto`,
"label.knowledgebase.no.results.knowledge":`Ningún resultado en Conocimiento`,
"label.data.exp.newtemporexp":`Seleccione el método de exportación de datos o cree una nueva plantilla`,
"vue_label_chatter_refuse_join":`Rechazar`,
"Homepage.News.002":`El componente de noticias no está disponible actualmente.`,
"label.log.requesttype":`Método de solicitud`,
"vue_label_dashboard_generatefromreport":`Generar a Partir de Informe`,
"label.knowledge.create.version":`Crear versión`,
"label.emailtocloudcc.description2":`Asocie su correo empresarial`,
"label.partnerCloud.partnerAccount.recharge":`El importe de la recarga debe estar entre 0,1 y {límite superior}.`,
"label.customobjects":`Objeto personalizado`,
"label.schedulableprg.endtime":`La fecha finalizada debe ser más tarde que la fecha actual del sistema`,
"message.error.viewreport.confirmdelete":`Hay gráficos que utilizan la vista/informe actual como fuente de datos. ¿Quiere eliminar también el gráfico?`,
"label.marketing.social.seting":`Configuración de las redes sociales`,
"chatter.follow.stop":`Dejar de seguir a este usuario`,
"label.notification.arketsea.return":`{5} ha devuelto {0}：{1} a {2}`,
"label.conditionsofnextapprover":`Hay uno o más próximo aprobador específico en la solicitud de aprobación seleccionada. Utilice los casillas de búsqueda siguiente para determinar al aprobador siguiente.`,
"label.partner.all.state":`Status`,
"mobel_web_closed":`Cerrado`,
"label.icon.65":`Equipo`,
"label.stdashbord.xsld.business.jinehj":`Total`,
"label.selectobject":`Seleccione objeto`,
"label.account.CurrentFQ":`Trimestre fiscal actual`,
"label.workflow.estimaterule":`Regla de evaluación`,
"label.list.userinterface.shownewrecordssetup":`Configuración de los últimos registros`,
"label.tianyancha.businessverify.msg3":`1. Costos`,
"label.weixin..xsld.jieduan":`Etapa`,
"label.first.quarter":`Primer trimestre`,
"Opportunity.Detailed.Phase.Label.002":`Lleva {0} día(s) en el estado actual`,
"label_tabpage_page":`Página`,
"label_emailsync_status_time":`Tiempo`,
"label.pleaseselectaapprover":`Seleccione un aprobador`,
"label.emailtocloudcc.redmessage5":`Estado desconocido, por favor contacte con el administrador.`,
"label.four.quarter":`Cuarto trimestre`,
"label_chatter_relateList":`Lista relativa`,
"label.customfields.new.step2.opration.exid.info":`Configure este campo como único identificador para el sistema external`,
"label.projectManagement.nodata.overdue.tasks":`Genial. No tiene ninguna tarea atrasada`,
"label.sendemail.activity.task.statuscompleted":`Estimado #createbyidccname ¡Hola! \r\nLa tarea que le asignaste a #belongtoidccname en #createdate es la siguiente: \N  Asunto: #subject\r\nTiempo de vencimiento: #expireDate\r\n Artículos relacionados: #relacionados\nContenido: #remark\r\n Por favor, visite el enlace para más detalles: #réditos: #réditos #réditos #réditos #réditos #réditos #réditos #réditos #réditos #réditos #perteneceralnombredelaidc está marcado como completado. \N  #nombredelorganismoSistemaCRM`,
"label.sso.saml.idp.config.issuer":`Emisor`,
"label.cannot.delete":`ítems) no se permiten cancelar`,
"label.pigeonhole.sel_f":`Seleccione la carpeta por archivar`,
"label.customfields.text.tip":`Permite a los usuarios introducir cualquier combinación de letras y números.`,
"message.error.user.service.common":`?La operación se frascasó, contacte con el administrador para conseguir ayuda!`,
"label.datamanage.account.information":`Información de cliente`,
"vue_label_homepage_deleteprofilepage":`Eliminar la página de inicio del perfil`,
"label.sendmail.step3.introduce3":`destinatario(s) seleccionado(s) para recibir SMS.`,
"label.pc.ui.2018.recentitem":`?tems recientes`,
"label.report.loading":`Cargando`,
"vue_label_globalsearch_adjustment":`Método de ajuste`,
"label_report_line_yixuan":`Columna del informe seleccionada`,
"label.h5.similar.opportunity.only.view":`Sólo muestra`,
"label.marketactivitymember":`Miembros de campa?a`,
"label.recycle.execute.tip":`Su solicitud ha sido procesada y llevará unos minutos para vaciar la papelera de reciclaje, le informarán por correo una vez lo termine.`,
"label.permission.detail.system.setting":`Configuración del permiso de sistema`,
"label.RecordType":`Tipo de Registro`,
"label.custom.error.between":`La fecha de inicio y la fecha de finalización del año personalizado se encuentran entre el período de tiempo de los años personalizados históricos, por favor, compruébelas y reconfigúrelas.`,
"vue_label_dashboard_selectview":`Seleccionar vista`,
"label.tianyancha.businessverify.cancel":`Cancela la verificación de los datos comerciales`,
"label.partnerCloud.financeSetting.MD5":`Clave secreta MD5`,
"label.multilang.messagedetail.new.error":`No pudimos encontrar ningún usuario de Chat cuyo nombre contiene {0}:`,
"label.callcenter.pleaseenter.private.key":`Por favor, introduzca la clave secreta de acceso privado`,
"label.umeng.activity.youdistribute":`Ha asignado a`,
"label.weixin.nickname":`Apodo`,
"label.customerinfo.mailusername":`Nombre de usuario del correo`,
"label.partnerCloud.orderingPlatform.discountPlan":`Nombre del programa de descuentos:`,
"lable.account.year":`A?o fiscal`,
"T":`Tiempo`,
"System.Email.Template.Title":`Bienvenido a la plataforma CRM de CloudCC`,
"label.login.type":`Tipo de login`,
"label.notification.evaluation":`{0} comentario izquierdo de {2} para el caso {1}`,
"label.turntolist":`Saltar a las listas`,
"label.sort":`Ordenar`,
"vue_label_commonobject_notice_clickcross":`Si necesita reemplazar el archivo cargado, haga clic en el botón [X] y vuelva a cargarlo`,
"label.Select.maximumecords.operate":`Se pueden seleccionar hasta 200 registros para procesar`,
"label.submission_rate":`Tasa de presentación`,
"label.datadelete.record.sucessfully":`Registro ha sido cancelado con éxito!`,
"label.version.standard.dashboard":`Paneles`,
"label.task.postunsolve":`Tareas vencidas`,
"label.Receivables.name":`Nombre del plan de recibo`,
"label_tabpage_noOperationz":`?Los contenidso son fijos, no se puede operar!`,
"label.attendance.onrecord":`Seleccione por lo menos un registro`,
"label.partner.error2":`Error: El nombre de dominio sólo puede contener números o letras.`,
"label.account.map":`Mapa del cliente`,
"label.dashboardSetup.reference.legend":`Diagrama de referencia`,
"label.Yaxisscope":`Rango del eje Y`,
"label.hierarchy.tree.tip":`Seleccione un registro en el campo de búsqueda de cada menú para crear una jerarquía. La jerarquía se muestra a continuación:`,
"label.permission.objlist.columnsize":`Total de campos`,
"label.setup.mobile.bottombutton.savesuccess":`Se guarda la configuración de la página de primer nivel`,
"label.mobile.side.tab.selected":`Seleccionado`,
"label.partner.donotdel.cause":`Porque tiene relación con la nube de socio siguiente`,
"label.ccchat.message.new.error4":`Recordatorio`,
"vue_label_systemSettings_setorganization":`Configure aplicaciones para su organización, personalice diferentes menús para varias divisiones funcionales.`,
"label.umeng.approval.approvalmes4obj1":`Por favor, revise la aprobación a tiempo`,
"UG_opportunity_010":`Crear una transacción`,
"label.tag.addtags.public":`Público`,
"System.TAB.SeeViewPageAmount":`Ver número de páginas`,
"label.filterconditions":`Filtro`,
"front-personalEmailBox-module-v12-clear-not-associated":`Cancelar la conexión borrará todos los correos electrónicos no asociados, ¿está seguro de cancelar la conexión?`,
"label.assign":`Asignar`,
"label.layout.clone.tip":`Puede seleccionar un dise?o existente para copiar`,
"label.choose.relatedlist":`Seleccione las listas relativas que quiere transferir`,
"label_chatter_recordcall":`Llamadas registradas`,
"label.product.proofOne":`En {0}, elija hasta {1} opciones de productos.`,
"label.layout.availablefield.relatedlist":`Campos disponibles / listas relativas`,
"label.campaignmember.main.updateleadstatus":`Actualizar estado-Candidatos existentes`,
"label.custom.buttonandlink":`Botones personalizados o enlace`,
"label.view.manage":`Gestión de vista`,
"label.search.exp":`Seleccione los objetos para los cuales quiere activar los funciones siguientes y hacer clic en ¨Guardar¨:`,
"vue_label_appstore_apply_to":`Apto para`,
"label.dashboard.message.refreshfail":`Fallo en la actualización del cuadro de mandos`,
"UG_Case_02":`Los caso le permite responder y resolver los problemas de los usuarios. Los casos son un registro poderoso en CloudCC que no solo rastrea los problemas de cliente, sino que también muestra una vista completa del cliente.`,
"label.project.hit.three":`Recordatorio diario de subtareas`,
"label.tianyancha.businessverify.tip":`Iniciar la verificación de los datos comerciales ayudará a los usuarios ingresar informaciones correctas del registro empresarial al introducir datos de los clientes de la empresa.`,
"label_emailsync_status_disconnect":`Cancelar la vinculación`,
"label.rule.disabled.successfully":`Desactivar las reglas con éxito`,
"label.custombutton.queryerror":`Consulta fallida, intente de nuevo`,
"label.customfields.deletecannotresume":`Los datos correspondientes se cancelarán permanentemente y no se pueden recuperar.`,
"label.account.current.M":`Este mes`,
"label.under.approve.data":`El registro se está revisando(`,
"vue_label_title_remainingdays":`Días restantes`,
"label.partnerCloud.orderingPlatform.refundable":`Rebaja disponible`,
"label.lookup.iscover":`Se permite sync al editar`,
"label.recordtype.detail.selectlist":`La lista de opciones disponible para editar`,
"label.sso.isActiveYes":`Sí`,
"label.service.appointmentList.canceltheSuccess":`Cancelado con éxito`,
"label.escalation.setup.newentries.createfirst":`Según la hora de la creación del caso, y prohibir el uso después de que el caso se modifique por primera vez`,
"label.new.ccpeakfolder":`Clasificación: Carpeta Nueva`,
"lable.currencyAdv.exchagecurrency.after":`y después`,
"label.majoranddetailrelation":`Relación de Maestro-Detalles`,
"label.appointment.wizard.subtitle4-2-1":`1h`,
"label.projectManagement.working.hours":`Horario de trabajo`,
"label.forecast.customforecast.button.forehistory":`Predecir la historia`,
"label.mymasterplate":`Mis plantillas`,
"component.setup.tabs.label.memo":`Establecer el nombre de la etiqueta de la pestaña`,
"label.customfields.longtextarea.tip":`Permite a los usuarios ingresar hasta 32,000 caracteres en líneas separadas. Puede crear hasta 10 campos de texto cada objeto.`,
"label.service.miniProgram.fillJumpLink":`Introduzca el enlace del salto`,
"label.british.summer.time":`Hora de Greenwich`,
"label.nogreate":`<=Menor que o igual`,
"label.assignment.setup.detail.sameuser":`Mismo usuario`,
"mesage.error.profile.delate.user":`No se puede cancelar este perfil porque los usuarios han sido asignados a este perfil.`,
"label.tabpage.cownerz":`Cambiar Propietario`,
"label.multilang.dupicatecheck.processedcount":`Datos duplicados, {1} grupos han sido procesados, los datos de {1} grupos no han sido procesados.`,
"vue_label_report_notice_leavecertification":`¿Está seguro de abandonar esta página? Los datos introducidos podrían perderse`,
"label.master.required":`Campo obligatorio no rellenado de los registros secundarios`,
"label.chatter.follow":`Seguir`,
"label.dataimport.insertdata.error.repeat":`Este registro se ha duplicado en la base de los datos, se ha ignorado la importación`,
"label.sms.cgid":`Número de galería`,
"label.knowledge.article.rator":``,
"label.datamanage.object.field":`Campos de objetos`,
"label.forecast.editshrepage.quanxian":`Nivel de acceso del permiso compartido`,
"label.weixin.interactive.log":`Log de Interacción`,
"label.batchedit.remark":`Editar múltiples registros`,
"label.user.permissions.message":`No tiene permiso para configurar información de usuario.`,
"label.mobile.phone.month":`Mes`,
"chatter.sel.u":`Seleccione los usuarios que quiere @, o ingrese directamente el nombre que quiere @`,
"label.service.gantt.assigned.work":`Trabajo asignado`,
"UG_ST_001":`Indicación`,
"label.edit.select.one":`Lista desplegable`,
"label.forecast.shrepage.desc0":`Esta página alistará los usuarios, roles y territorios que tienen acceso compartido a {0}.`,
"label.multilingual.confirm.close":`¿Está seguro de desactivar? El multiidioma no se puede utilizar después de la desactivación y el idioma del usuario se cambiará al idioma por defecto.`,
"label.setting.intergrationlist.integration":`Integración`,
"label.leadscore.rule.list":`Lista de regla de puntuación para los candidatos`,
"component_telerecord_button_save":`Guardar`,
"label.weixin.save.log":`Log guardado`,
"label.validate.function.funcExplain.DAY":`Regresar a algún día del mes, debe ser un número entre 1 y 31`,
"label.appointmentdetail.wizard.title1":`Nombre de reunión`,
"label.multilang.feedtrack.dealkey":`Modificar {0} de {1} a {2}`,
"label.optional.features":`Funciones opcionales`,
"vue_label_email_no_email":`No hay correo electrónico`,
"label.sendemail.chat.messagecontent":`Los contenidos del mensaje`,
"label.tabpage.lessequalz":`Menor o igual que`,
"setup.layout.label.setupfield":`Configurar propiedades del campo`,
"label.approved.receiveApprovalEmail.option1":`Si soy un aprobador o un aprobador delegado`,
"label.chatter.relateList":`Lista relacionada`,
"component.sendmail.label.fromuser":`Remitente`,
"label.projectManagement.problem.status":`Estado del problema`,
"label.weixin.fmu.before.hour":`{0} hora(s) con anticipación`,
"chatter.feed.menutype.feed.mark":`Mis publicaciones a favoritos`,
"label.addQuoteLineGroup":`Añadir grupo de líneas de oferta`,
"label.report.action.addtodashboard6":`Añadir`,
"label.url":`URL`,
"lable.account.CurrentandPreviousCQ":`Trimestre calendario actual y anterior`,
"label.tabpage.emptyz":`Vaciar`,
"less":`Menos que`,
"label.h5.selectmostphotos":`Se puede seleccionar hasta 9 fotos`,
"UG.activity.04":`Correo de Outlook/Gmail  Registrar correo`,
"template.chart.qbhtje":`Todo el importe del contrato`,
"label.tabpage.endz":`Finalizar`,
"label.partner.workspace.member":`Miembro`,
"label.filter.error.filedvaluetoolong":`Error: El valor del campo ha superado al límite.`,
"label.months":`Mes`,
"button.partner.workspace.disable":`Cancelar la activación`,
"label.visualpage.checkpinyin.grammar":`Revise ortografía y gramática`,
"label.dashboardSetup.geshihua":`Formatear`,
"label.belongto":`Pertenece a`,
"label.upload.cannot.empty":`?El fichero subido no puede estar vacío!`,
"label.number.MaxCheck":`El máximo de {0} es {1}. Por favor, modifique la cantidad y guarde los cambios.`,
"pagecreator.page.message.save.fail":`No se ha podido guardar página`,
"label.edit.SMS":`Editar la notificación de SMS`,
"UG_Lead_002":`Hay muchos métodos para identificar ¨Candidatos¨ de su producto o servicio.`,
"label.quickcreate.active.quickcreate":`Activar Creación Rápida`,
"label.recordtypeselect.tip":`Para saltar esta paso en el futuro, configure los tipos de registro predeterminados.`,
"label.form_content":`Formulario`,
"workflow.action.tasks.assignortype.related":`Usuario relativo`,
"vue_label_allsearch_set_more_items":`Puede establecer más elementos de búsqueda en el cuadro desplegable de la izquierda del cuadro de búsqueda para seguir buscando`,
"label.tianyancha.businessverify.title":`Verificación Industrial y Comercial`,
"label.errormessage.batchedit.norecord":`No hay datos.`,
"label.permission.appname":`Nombre de aplicación`,
"label.report.action.addtodashboard7":`Cancelar`,
"label.generated.transfer.product":`Generar activos según la forma de Conversión de Activos.`,
"vue_label_commonobjects_detail_you":`Usted`,
"label.user.captcha":`Verificar`,
"label.notification.event4":`El evento【事件名】que ha asignado a【被分配人】empezará en 【开始时间】`,
"label.version.setup":`Configurar`,
"setup.object.layout.message.selectedlayoutandrecordtype":`Seleccione el diseño y el tipo de registro`,
"label.role.add":`Añadir adir rol`,
"label.versiontype.Unlimited":`Versión ilimitada`,
"label.partnerCloud.financeSetting.developerID":`Por favor, introduzca el ID del desarrollador.`,
"front-invoice-online-payment-setup-global":`Aplicar a las cuentas globales`,
"vue_label_commonobjects_view_basis":`Criterio de clasificación`,
"label.decimaldigits.tip":`El número de dígitos a la derecha del punto decimal`,
"vue_label_commonobjects_detail_selected":`Marcar como fase seleccionada`,
"label.data.export.page":`Ir a la página de exportación`,
"message.error.serviceresource.servicecrewid":`Cada equipo de servicio solo puede añadirse como un registro de recursos de servicio del tipo equipo`,
"label.loginttime.alltime":`Todo el tiempo es`,
"label.requiredinfo":`Información obligatoria`,
"label.forecast.edit.di":`El`,
"vue_label_calendar_failed_to_remove_calendar":`Eliminar calendario fallido`,
"pagecreator_systemstyle_button_delete":`Cancelar el estilo`,
"label.import.page3.continueimport":`Seguir importando`,
"label.page.width":`Ancho de Página Completa`,
"label.campaignmember.selectmember.addmember":`Añadir miembros de`,
"label.finalreject":`Rechazo final`,
"label.isend":`Si finaliza`,
"front-console-conversation":`Diálogo`,
"label.mr.theLastGroupOfThisPage":`Este es el último conjunto de datos de esta página. Haga clic en [Regrese a la lista de datos duplicados] para ver más datos repetidos.`,
"label.data.dataexpalltype.all_desc":`Exportar datos de todos los objetos que los usuarios actuales tengan acceso a ver.`,
"label_emailtocloudcc_redmessage7":`Error de configuración, contacte con el administrador`,
"label.forecast.shrepage.classdes.all":`Acesso completo-Los usuarios pueden ver y descubrir los datos de previsiones y extender el acceso a otros usuarios via compartir.`,
"market.contacts":`Contacto de mercado`,
"label.weixin.polls.voter":`Lista de los participantes de voto`,
"template.report.industry.distribution.customers":`Distribución de las cuentas por sectores`,
"front-electronic-signature-setup":`Configuración del Autocompletado y el Backfill de Infor`,
"vue_label_chatter_removecertification":`¿Está seguro de que quiere expulsar a "{name}" del equipo?`,
"label.appointment.wizard.subtitle1-2":`15 minutos`,
"label.sso.saml.idp.config.custattr":`Propiedad personalizada`,
"label_tabpage_totalTeamz":`Grupos totales`,
"lable.outlook.detail.assigned":`Usuarios y perfiles asignados`,
"label.department.user.delete":`Eliminar`,
"label.customcomponent.check.label.same":`La etiqueta ya existe`,
"label.partner.error1":`Error: La longitud del dominio es demasiado larga`,
"label.escalation.setup.entrydetail.escalation.notify":`Notificar`,
"component_todaytask_label_choicestate":`Seleccione status`,
"label.customfields.fielddependency.new.step1":`<b>Paso1: </b> Seleccione un campo de control y un campo de dependencia. Haga clic en ¨Continuar¨ al terminar.`,
"chatter.group.anyoneCanSeeTheUpdateAndJoin":`Todos pueden ver y solicitar para unirse a este grupo.`,
"label.custom.pixel":`pixel`,
"label.quicksave":`Guarda rápida`,
"label.approved.persion":`Aprobador delegado`,
"lable.info.queue.member":`Miembros de cola`,
"label.addattachment.step2.weixin":`Paso 2. Haga clic en ¨Subir¨ para subir los ficheros`,
"label.forecast.customforecast.title":`Previsiones`,
"mainpage_setup_chosecomponent_leastone":`Debe seleccionar por lo menos un componente para poner en la página oficial.`,
"label.appointmentconfirmpage.wizard.title2":`El calendario detallado de la reserva ha sido enviado a su correo`,
"label.useallselectedapprover":`Se requiere que todos los aprobadores <strong> Unanimidad </strong>Aprobado`,
"label.ccpeak.current.line.return":`Ingrese de la línea actual y no se ejecuta hacia abajo.`,
"label_new_target_model":`Nuevo modelo de objetivo`,
"label.saving":`Guardando...`,
"label.mobile.phone.write":`Escribir`,
"label.applt.updown.text":`También puede descargar el código QR de un miniprograma del portal dedicado a su empresa y colocar el código QR dentro de una página web o un artículo público, y los clientes pueden escanear el código QR para utilizar el miniprograma.`,
"label.partner.common.manageSetup":`Configuración de gestión de nube de socios`,
"label.quickbooks.new":`Nuevo cliente`,
"message.error.color":`¡El color no puede estar vacío!`,
"label.project.template.two":`Sólo puede haber un conjunto de configuraciones bajo cada tipo de registro por objeto.`,
"label.approval.input.des1":`Aprobar o rechazar nivel por nivel, y el nivel máximo de la jerarquía es:`,
"label.x.axis.cannot.empty":`?El eje X no puede estar vacío!`,
"label.solomon.isiands.time":`Hora de Islas de Salomón`,
"label.login.access.duedate":`Duración del acceso`,
"label.service.dispatch.booking.order":`Asignar cita de servicio`,
"label_shareme_forecast":`Previsiones compartidos conmigo`,
"label.custom.page.cuspage.height":`Altura(Píxeles)`,
"label.quote.line.group.":`¿Está seguro de que desea eliminar el grupo de líneas de cotización de {groupName}? Las líneas de cotización de este grupo también se eliminarán después de la operación.`,
"label.data.downpage.i_title.num6":`Se recomienda que importe un fichero de prueba que contiene 5 registros antes de importar los datos para asegurarse de que los datos quiere importar sean correctos.`,
"label.\u2019s":`de`,
"label.version.contact.management":`Gestión de contratos`,
"label.document.history.user":`Usuarios`,
"vue_labenl_commonobjects_opportunity_product_edit_notice1":`Introduzca el importe correcto con dos decimales como máximo.`,
"label.weixin.target.contract.jine":`Monto objetivo del contrato`,
"lable.common":`Total 0 ￥`,
"front-kefu-moudle-sendemail-success":`El correo electrónico ha sido enviado y el personal de ventas se pondrá en contacto con usted lo antes posible`,
"label.service.no.operation.time":`El registro actual no tiene tiempo de operación asociado`,
"label.info":`Información`,
"label.ccchat.zw":`Mediodía`,
"label.assignment.setup.newentries.title":`Editar los ítems de criterios`,
"label.weixin.report.timeline":`Campo de fecha`,
"UG.quota.04":`Imprimir oferta`,
"label.social.user.exception":`Anomalía en la información de usuario social`,
"label.import.index.failed":`Fallido`,
"label.common.settings":`Configuración general`,
"label.nullvalue":`Valor nulo`,
"PageLayout_Search_MultiSearch_002":`Habilitar búsqueda personalizada (Búsqueda de Campo ?nico)`,
"message.myselfreport":`Mi informe personalizado`,
"label.productsales.today.noevttskaddtsk":`Hoy no hay eventos o tareas vencidas, puede hacer clic en “ ” en la parte superior derecha para a?adir tarea nueva.`,
"lable.oppdt.noconditionrecrods":`No hay registros para mostrar.`,
"label.campaignmember.selectmember.deletelead":`Campa?a: Remover miembros de los candidatos`,
"label.marketingactivity":`Campa?as`,
"vue_label_pool_self-built":`Autoconstruir`,
"message.textareamaxlength":`La longitud no puede exceder 4,000 caracteres`,
"label.valadate.must.value":`Debe introducir un valor`,
"label.tabpage.groupsVisiblez":`Visible para algunos usuarios`,
"component.button.cancel":`Cancelar`,
"label.emailobject.list.inbox":`Bandeja de entrada`,
"label.app.step1.error.labelexist":`Error: La etiqueta ya existe`,
"front-calendar-V1-Unable-to-display":`El registro no puede mostrarse en el calendario porque el campo final de uno o más registros es anterior al campo inicial.`,
"label.forecast.settings.prompt1":`Debe seleccionar al menos una opción de previsiones: Ingresos o cantidad.`,
"front-kefu-moudle-callout-missphone":`Llamadas perdidas`,
"label.tabpage.editz":`Editar`,
"vue_label_chatter_label_new_team":`Nuevo grupo`,
"label.version.formulafield":`Campo de Fórmula`,
"label.partner.step1":`Paso 1: Seleccione plantilla`,
"label.weixin.perfect.url":`Ingrese los detalles de URL`,
"label.appointmentconfirmail.wizard.subtitle4":`Descripción`,
"label.step7.total7":`Paso 7 de 7`,
"setup.object.layout.label.selectedprofile":`Perfiles seleccionados`,
"label.payments.paytip5":`Ingrese la cantidad correcta`,
"label.visualpage.open.type":`Tipo de página personalizada abierto`,
"lable.Sort.field.tips":`Personalice el orden de registro en la lista relacionada seleccionando los campos a ordenar. Puede ordenar en base a cualquier campo numérico o de fecha de los objetos.`,
"label.nosharerules":`Regla de compartido no especificada`,
"label.service.miniProgram.bindSetOwner":`Establecer propietario del caso`,
"report_label_highlevelreport":`Los informes avanzados le permite crear hasta 4 relaciones de objetos`,
"S":`Texto`,
"label.lastmodifyby":`Última Modificación Por`,
"label.customerinfo.mailaddress":`Dirección de correo`,
"vue_label_pool_converted":`Convertido`,
"UG.ST.004":`No tiene el permiso de Gestión de datos -》 Importación de datos, por favor, póngase en contacto con el administrador, haga clic en confirmar y vaya directamente a la interfaz {0}.`,
"label.view.application.mobile.terminal.filed":`La vista se ha aplicado a la aplicación móvil, puede seleccionar hasta 10 campos, ahora hay`,
"chatter.feed.limitentity500":`Puede seguir hasta 500 colegas y registros`,
"label.starttime":`Empezar`,
"chatter.emailToMe":`Recuérdeme por CCChatter bajo situaciones siguientes`,
"label.custom.Current.and.PreviousCQ":`Trimestre personalizado previo y actual`,
"label.my.logout":`Mi`,
"label.quickbooks.searchlist.enddate":`Fecha de finalización`,
"label.ccservice.validate.length":`?La longitud del valor correspondiente {2} del campo{1} bajo la API de objeto {0} ha superado al límite. Configure de nuevo!`,
"label.integrations.installed":`Autorizado`,
"label.integrations.mailchimplist":`Lista de Mailchimp`,
"label.checkfield.matchothers":`Coincidir con otros registros`,
"label.umeng.activity.event.distributewillbegin":`El evento #el evento asignado a #name empezará después de #time.`,
"pool.notice.gotolightning":`Diríjase a la versión Lightning si quiere utilizar esta función.`,
"label.batchtransfer.pleaseselecttransferreddata":`Seleccione los datos que quiere transferir`,
"label.mr.title.mailingAddress":`Dirección`,
"vue_label_approve_no_response":`No hay respuesta`,
"component.event.label.title":`Próximos eventos`,
"label.mobile.setup.confirm":`Está cambiando la localidad del ícono del menú predeterminado en la aplicación móvil. Después de cambiarla con éxito, todas las configuraciones previas se eliminarán a menos que resetee el ícono en el móvil, o el sistema seleccionará aleatoriamente en el catálogo de su configuración.`,
"label.tianyancha.approvaltime":`Fecha de aprobación`,
"label.download_merge_file":`Descargar el archivo fusionado`,
"label_display_quota":`Mostrar cuota`,
"label.publishreadonly":`Solo lectura pública`,
"label.campagin.roi.query.roi":`Campa?a ROI`,
"label.dashboardSetup.lookup":`Encontrar paneles`,
"vue_label_notificationcenter_nomessages":`No hay mensajes sin leer`,
"label.create.object":`Crear objeto`,
"label.social.campaign.null":`La información del campamento no puede estar vacía`,
"label.console.step6.left":`Fijar a la izquierda, las listas siempre son visibles.`,
"label.line":`Columna`,
"label.bottonandlink.introduce":`Aquí está una lista de botones y enlaces. Para añadir botones o enlaces, por favor edite el dise?o de la página.<br/>Los botones y enlaces se pueden añadir en la página de información, listas relativas y lista de vista: <br/>      1.Edite el dise?o para a?adir botones o enlaces en la página de información. <br/>      2.Edite las propiedades de la lista relativa para a?adir botones y enlaces a la lista relativa.<br/>      3.Edite el dise?o de búsqueda para a?adir botones y enlaces a la lista de vista.<br/>`,
"label.layout.list1":`Lista 1`,
"label.mr.title.customerName":`Cliente`,
"label.user.text":`Texto`,
"label.nolastestrecord":`No hay último registro`,
"label.emailobject.appointment.urltext1":`Aquí está mi programa, revise`,
"label.chat.topic.my.favorites":`Mis marcadores`,
"label.select.dashboar.cd0":`El campo de agrupación no puede estar vacío`,
"label.data.downpage.e_title.num2":`2. Si seleccione por exportar datos del objeto individual, se requiere optar por el modo de exportación. El modo de exportación de datos: exportación personalizada, exportar por plantilla y exportar plantilla.`,
"message.error.user.service.login.unconn":`Error del servidor, intente de nuevo más tarde`,
"label.escalation.setup.newentries.title":`Editar ítems de regla`,
"label.import.step1.above2000":`Cuando se ejecuta el disparador, se puede importar un máximo de 2000 registros a la vez. Por favor, divida en varios archivos e impórtelos por lotes.`,
"label.ccchat.person.allowinvite":`Permite la invitación de los colegas`,
"label.input.number.between":`Ingrese un número entre {0} y {1}`,
"label.forecast.shrepage.wpfmanager":`Gerente de previsiones delegado`,
"label_server_is_time_out":`El servidor está fuera de servicio. Por favor, inténtelo de nuevo más tarde.`,
"label.indochina.standard.time":`Hora Estándar de India`,
"label.cpq.quote.sync.opportunity.failure":`Sólo se puede sincronizar la oferta principal con la oportunidad. Por favor, marque la casilla de la oferta principal, y luego comience a sincronizar.`,
"label.emailobject.send100emails":`?Lo sentimos, solo puede enviar 100 correos al día, seleccione de nuevo!`,
"label.dashboard.snapshot.end":`Terminar en`,
"label.jiandangfenpei.rightlist":`Perfiles asignados`,
"label.input.string.length.between":`Ingrese una cadena de caracteres cuya longitud entre {0} y {1}`,
"label.multilang.lookfiltercondition.select":`?La condición de línea {0} es incorrecta, ?Debe seleccionar un campo!`,
"label.datamanage.lead.namenull":`?Atención: Si el nombre de candidato es nulo, el registro no se importará!`,
"label.forecast.detailforecast.button.saveandfresh":`Guardar y Resfrescar`,
"label.venezuela.time":`Hora de Venezuela`,
"label.same.analyze.miaoshu1":`Si necesita más reglas, por favor utilice¨`,
"label.twomb":`Sólo se permite subir archivos jpg/png con un tamaño máximo de 2MB.`,
"label.event.moveup.7hour":`7 horas con anticipación`,
"label.weixin.forgot.password":`?Se ha olvidado su contrase?a?`,
"label.import.page1.diledsizelimited":`2. El tamaño máximo permitido del archivo es de 100M`,
"label.file.foldername":`Nombre de Carpeta`,
"label.multilingual.open":`La gestión multilingüe está activada.`,
"label.dashboard.snapshot.refresh.failed":`La actualización de instantánea del panel se frascasó`,
"label.marketsea.memberfieldselectone":`Seleccione entre Ver campo y Campos visibles para miembros`,
"label.trigger.createdate":`Fecha de creación`,
"label.ccpeak.operation.sharetab":`Operar el formulario compartido:`,
"label.partner.message.admin.access":`Sólo los administradores pueden iniciar sesión`,
"label.emailsync.status.email":`Operación de correo`,
"chatter.error":`Error: ? Seleccione primero un archivo!`,
"label.role.viewinlist":`Mostrar en vista de lista`,
"label.tag.addtags.title":`Etiqueta`,
"setup.mainpage.label.welcome6":`Los usuarios pueden crear varios tipos de campos en todos los objetos del sistema CloudCC sin necesidad de conocimientos de programación o desarrollo de código. Los tipos de campo incluyen: búsqueda de contactos, campo de selección única, selección doble, fórmula, numeración automática, URL, teléfono, fax, correo electrónico, casilla de confirmación, fecha, hora, número, texto, área de texto, lista de opciones (selección única/múltiple), moneda, etc.`,
"label.delete.rule.successfully":`Borrar las reglas con éxito`,
"label.field.duplicate.error.msg6":`Valor del campo duplicado. El valor ya existe en el registro:`,
"label.stdashbord.xsld.business.jhzsl":`Oportunidades totales`,
"label.compact.layout":`Dise?o de información clave`,
"label.checkfield.merge.introduce":`Seleccione el valor que quiere mantener en el registro combinado.`,
"earlieststarttime.duedate.time.illegal":`La hora real de inicio de la cita de servicio debe ser menor o igual a la hora real de finalización.`,
"label.dataimport.validate.prompt":`Indicación de regla de validación`,
"message.setuptip":`Puede cancelar después de crear`,
"template.report.customer.collection.statistics":`Estadísticas de pago de cuentas`,
"vue_label_homepage_dashboardcomponents":`Editar Panel`,
"setup.mainpage.label.welcome30":`La plataforma CloudCC es una verdadera plataforma de computación en nube. Las propiedades abiertas de la plataforma, los métodos de integración estándar y la personalización flexible son aplicables a todos los sectores, integrando software de terceros, realizando la unificación en tiempo real de los datos de gestión de la empresa y maximizando las necesidades de gestión integral y profunda de nuestros clientes. La plataforma CloudCC puede integrarse con cualquier aplicación o sistema empresarial, incluyendo software de terceros como SAP, Kingdee y Yonyou. El método de servicio web estándar en el marco de la arquitectura SOA flexible no tiene ningún tipo de dependencia técnica o destructiva ni de bloqueo de proveedores.`,
"label.SMS.new.det":`Cree una notificación de SMS para asociar con uno o más regla de flujo de trabajo y el proceso de aprobación. Si cambia la notificación de SMS, cualquiera modificación se aplicará a las reglas y aprobaciones asociadas con ella.`,
"lable.product.page.previous":`Regrese a  la página anterior`,
"label.recordtype.labelname":`Tipo de etiqueta de registro`,
"message.error.system.service.failure":`?La ejecución del servicio se frascasó, contacte con el administrador!`,
"label.visualpagefolder":`Carpeta de página`,
"label.username":`Nombre de usuario`,
"label.data.downpage.i.title.num5":`5. Compruebe la exactitud de los datos.`,
"label.permission.manage":`Gestión de asignación`,
"label_emailsync_status_user":`Usuarios`,
"label.weixin.voting.least.two":`La opción de votación tiene por lo menos dos`,
"label.tabpage.thisrecord":`Este registro`,
"label.icon.119":`Pizarra`,
"label.partner.common.webSit":`Dominio`,
"label.email.form.html2":`[Cambiar a solo texto]`,
"label.appupload.upload.noversion":`No hay versión subida`,
"label.appointmentpage.wizard.subtitle1_2":`Zona horaria del invitador es {0}`,
"MR":`Buscar Multi Opciones`,
"label.partnerCloud.orderingPlatform.availableBalance":`Saldo disponible`,
"label.schedulejob.setup.schedule.st3":`El tercero`,
"label.reportsSubscriptionPage.email.general":`General`,
"label.setsharerule.step4":`Paso 4: Seleccione el nivel de acceso para los usuarios`,
"front-epwechat-module-v1-info-desc":`Por favor, obtenga información del backend de WeCom y rellene aquí`,
"message.duplication.label.isactive":`Activar`,
"pagecreator_systemstyle_label_linkcolor":`Color del enlace`,
"label.import.page1.alertfiledsize":`Los archivos cargados no deben superar los 100 MB.`,
"tomorrow":`Ma?ana`,
"label.publicdashboard":`Panel Público sin Archivar`,
"label.knowledgebase.same.taborworkspace":`La misma pestaña o espacio de trabajo`,
"homepage.layout":`Dise?o de la página oficial`,
"label.emailobject.trackemailopening":`Seguimiento de correo`,
"label.unlock.tip":`Desbloquee los registros para editar`,
"lable.account.NextzDays":`Próximos 90 días`,
"vue_label_report_throw":`Descartar`,
"label.icon.102":`Calendario`,
"label.payments.paytip2":`Ha actualizado a la versión pagada, haga clic en confirmar para cerrar la ventana actual y refrescar su sistema CRM.`,
"label.customfields.email.tip":`Permite a los usuarios ingresar a la dirección del correo para verificar y garantizar el formato correcto. Si este campo es especificado para algún contacto o candidato, los usuarios pueden seleccionar la dirección al dar clic en ¨Enviar Correo¨. Tenga en cuenta que el correo personalizado no se puede utilizar para correos masivos.`,
"label.test_visitors":`Pruebe el aspecto de su formulario cuando lo vean los visitantes.`,
"label.workflow.immediatelyoperate":`Flujo de trabajo inmediato`,
"label.approvalstep4.tip":`La página de aprobación es donde los aprobadores permiten o rechazan la solicitud. Utiliza las opciones siguientes para seleccionar los campos van a mostrar en esta página.`,
"label.ccchat.person.invite.failsend":`La invitación siguiente no se puede enviar, por favor contacte con el administrador.`,
"label.import.index.obj":`Objeto`,
"label.multilang.leadscore.countnum":`{0} veces:`,
"label.report.error.typefind":`No se ha encontrado ningún tipo de informe al agrupar la información`,
"label.validate.function.funcFormat.SUBSTITUTE":`SUBSTITUTE(text, old_text, new_text)`,
"label_tabpage_unpacketz":`?No datos agrupados disponibles!`,
"lable.Create.new.template":`Plantilla del nuevo informe de servicio`,
"label.knowledgebase.display.error":`Mostrar {a} errores`,
"label.emailobject.template.message2":`El campo insertado en el correo electrónico actual no coincide con el registro asociado, lo que puede provocar valores nulos.`,
"label.productsales.today.taskcomplete":`Configurar como completado`,
"label.emailobject.selectone":`Seleccione por lo menos un registro como el destinatario`,
"button_partner_workspace_saveas_memo":`Guardar la nube de socios actual como ¨Plantilla¨`,
"vue_label_help_detail":`Detalles del registro`,
"label.tabpage.minutesagoz":`minutos antes`,
"label_tabpage_characterz":`Carácter de inicio`,
"message.error.accesstoken.null":`La ficha no puede estar vacía.`,
"label.textMessageObject.send100":`Lo sentimos, sólo puede enviar 100 mensajes de texto al día, por favor, vuelva a seleccionar.`,
"vue_label_commonobjects_detail_record_call":`Nuevo Registro de Llamada`,
"label.campaignmember.main.addlead":`Añadir miembros-candidatos actuales`,
"setup_mainpage_label_welcome30":`CloudCC es una verdadera plataforma de computación de nube, la propiedad abierta de la plataforma, los métodos estándar de integración y la personalización flexible son aplicables a todas las industrias, integrando software de terceros, realizando unificación en tiempo real de los datos de gestión empresarial y satisfaciendo al máximo las necesidades de los clientes. CloudCC se puede integrar con cualquier aplicación o sistema, incluye SAP, Kingdee y UF. El método estándar de Web Service bajo la arquitectura flexible de SOA no tiene ninguna destrucción, dependencia técnica o bloqueo de proveedores.`,
"label.file.library.deleteprompt":`Eliminar {0} de la biblioteca de activos ?`,
"label.wtd.changefields.title":`Configuración del Web to CloudCC`,
"label.sendmail.step1":`Paso 1: Especifique los destinatarios para incluirse`,
"label.cpq.newquote.createorder.checkbox.selected":`La casilla de crear un pedido no puede ser seleccionada al crear un nuevo presupuesto.`,
"label.emailtocloudcc.name":`Nombre`,
"message.error.object.nullbinding":`binding está vacío`,
"B":`Casilla de verificación`,
"label.pc.endtime":`Su licencia caducará en 30 días, la renueve a tiempo para el uso continuo.`,
"label.visualpage.section.start":`Utilice etiqueta en el comienzo`,
"label.partnerCloud.basicSetting.available":`El nombre de dominio está disponible.`,
"label.data.exportall.all_desc":`Exportar todos los datos de los objetos que los usuarios actuales tienen permiso para ver.`,
"label.editor.layout":`Editar el dese?o de búsqueda`,
"label.send.chatter":`Enviar micro-pulicación`,
"label.h5.chatter.reply":`Respuesta rápida`,
"component_chatter_post_button_file":`Añadir adjuntos`,
"label.emailobject.emaildetail.button.reply":`Responder`,
"label.eidt.queue.title.desc":`El nombre debe ser único, y el nombre debe comenzar con una letra, sólo contiene mayúsculas, minúsculas, número, guión bajo y la longitud no puede exceder 40.`,
"label.campaign.channel.input.url":`5. Configure información que los usuarios pueda ver después de registrarse, que puede ser una página de agradecimiento, un folleto o un boleto:`,
"label.compact.layout.assign.tip":`Esta tabla muestra las asignaciones del dise?o de información clave para tipos de registros diferentes`,
"vue_label_fall":`Descender`,
"label.trigger.save.failed":`Se frascasó en guardar, los datos no pueden ser vacíos`,
"label.appupload.upload.tips.report":`NOTA: Los informes y los informes antiguos de Mis informes personalizados" y "Informes públicos no archivados" no pueden añadirse a los paquetes y no se mostrarán en esta carpeta."`,
"label.tianyancha.businessverify.rewriteall":`Regrese a rellenar todos los datos`,
"label.campaign.channel.step6.remark4":`Nota que el propietario del candidato puede sesr propietario de la campa?a actual o el invitador de la canal de marketing`,
"front-kefu-moudle-called-num":`Número marcado`,
"label.approvalstep4":`Paso 4: Seleccione los campos para mostrar en el dise?o de la página de aprobación`,
"label.login.verification.please.scan":`Escanee el código utilizando la aplicación MFA de su móvil inteligente`,
"label.invoice.message.statusupdated":`El status de Invoice ha actualizado`,
"label.pc.ui.2018.subject":`Tema`,
"label.area.notexist.userinfo":`El grupo de usuario no existe`,
"label.newuser":`Nuevo usuario`,
"label.chat.micropost.share":`Compartir la publicación`,
"label.locatedupcurrentvalue":`El valor está arriba del valor actual`,
"vue_label_systemSettings_course":`Configuración del camino del rayo`,
"chatter.group.public":`Público`,
"label.reportsSubscription.entrance":`Suscribir`,
"front-kefu-moudle-v1-online-at":`Agente en línea`,
"label.rejectbehaviourselect":`Realice <strong>sólo</strong> ejecute el rechazo de este paso y envíe la solicitud de aprobación al aprobador más reciente. (Regrese al paso anterior)`,
"vue_label_commonobjects_view_currentviewset":`Para cancelar la configuración de la vista por defecto actual, puede establecer otras vistas como vista por defecto`,
"lable.currencyAdv.and":`Y`,
"label.appexchange.installedpage.publish":`Publicado por`,
"label.tab.profile.ismobile":`Aplicar a App móvil`,
"label.data.setok.t.desc2":`Volver a la página de plantillas de datos`,
"label.email_required":`El correo electrónico es obligatorio.`,
"label.tabpage.fullscreenz":`Pantalla completa`,
"chatter.sticker.set":`Seguimento de micro-publicación`,
"label.mobile.phone.year":`A?o`,
"label.projectManagement.next.page.before":`Página anterior`,
"pagecreator_button_pcpage":`PC`,
"label.dashboard.xsld.percent":`Porcentaje`,
"label.ccpeak.service.checkerror":`El reviso de sintaxis se frascasó`,
"label.icon.26":`Carpeta`,
"label_partner_common_webSit_memo":`Dominio predeterminado de la nube de socios de su organización:`,
"label.unselectfile":`No hay archivos seleccionados`,
"label.take.notice":`Atención`,
"message.error.filename.null":`¡fileName no puede estar vacío!`,
"vue_label_SMS_nophone":`No hay número de teléfono`,
"label.area.assignuser":`Asignar usuarios`,
"label.icon.176":`Rápido`,
"label.icon.21":`Moneda`,
"message.error.system.service.deletedeny":`?Los datos están asociados y no se pueden cancelar!`,
"label.compact.layout.main.tip":`Seleccione el dise?o de la información clave por utilizar cuando este registro aparezca como un ítem de lista en CloudCC.`,
"label.emailtocloudcc.delete":`Eliminar`,
"label.dashboardSetup.showdw.d2":`10 Milliones`,
"front-kefu-moudle-hqyyjlsb-admin":`No se ha podido obtener la grabación de voz, por favor, póngase en contacto con el administrador para obtener ayuda`,
"label.partnerCloud.basicSetting.userCounts":`Funciones totales del socio`,
"front-kefu-moudle-calling-num":`Número de llamada`,
"label.alldocument":`Todos los documentos`,
"coderules.nullvalue1":`No se ha podido generar. Introduzca el valor de 【{0}】 utilizado en las reglas de generación.`,
"lable.automatically.shared":`Compartir automáticamente`,
"label.batchadd.newbatchpage.save.emptyselect":`Revise si hay opciones obligatorias no seleccionadas`,
"vue_label_homepage_card_30dayswithout":`Oportunidades de negocio no contactadas en los últimos 30 días`,
"label.multilang.dupicatecheck.onegroupnote":`Marque por lo menos dos datos, haga clic en el botón [Carga información seleccionada] para entrar en la página de combinación de datos. Actualmente son información empresarial del {0}grupo, hay totalmente {1}registros.`,
"UG.activity.03":`Reservar horario`,
"label.pc.oldpage":`Página antigua`,
"label.exchange.sync.state.task.m2":`Los registros sincronizados en los últimos 60 minutos:`,
"label.setmovable":`Configuración de eventos`,
"label.sendemail.send.loginfail":`Login fallado al correo, resetee las informaciones de su correo`,
"label.copy.quote.lines":`Clonar la línea de cotización`,
"label.copying.reward.to.groups":`Copiar en grupos de líneas de cotización`,
"label.ems.connect.error":`Conexión de servidor fallida, revise.`,
"lable.account.Tomorrow":`Ma?ana`,
"label.manageAll.sta2":`Aprobado`,
"label.create_form":`Nuevo formulario`,
"label.ems.saveDetail.error.msg":`Se frascasó en guardar, revise la cuenta y contrase?a del correo.`,
"label.service.gantt.distribution.recommendation":`Asignación Sugerida`,
"label.email.track.attachment.size.control2":`El tama?o del fichero subido excede 10M, no se puede subir.`,
"lable.product.pricebooks.add":`Añadir al catálogo de precios`,
"label.login.time":`Hora de login`,
"label.tabpage.yes1z":`Sí1`,
"label.SalesCommitmentKanBan":`Panel de compromiso de ventas`,
"label_partner_workspace_myspace":`Mi zona de trabajo`,
"chatter.like":`Favorito(s) recibidos`,
"lable.PowerProcess.number.input":`Introduzca un número entero`,
"chatter.coll":`Marcadores`,
"label.campaign.channel.img.remark":`Notas: El tama?o de imagen no debe exceder 2M`,
"label.field.duplicate.error.msg7":`Datos repetidos`,
"vue_label_pool_discard":`Descartar`,
"label.service.gantt.total.planned.duration":`Tiempo total de las citas de servicio planeadas`,
"label.weixin.click.loadmore":`Haga clic para cargar más`,
"label.help.new.features.yd":`Guía de operación de nueva interfaz de la aplicación móvil`,
"label":`Etiqueta`,
"label.quickbooks.viewlist.total1":`Hay {0} invoices con el valor total de  {1}`,
"front-kefu-moudle-v1-input-publicKey":`Por favor, introduzca la clave compartida`,
"label.approval.allowed.reject":`Rechazo permitido`,
"label.visualpage.folder.notdel":`No puede cancelar esta carpeta, porque contiene algunos ficheros`,
"label.projectManagement.charging":`Con cargo`,
"label.ccservice.validate":`?El formato del valor correspondiente {2} del campo {1} bajo la API de objeto {0} es incorrecto. Ingrese el número correcto!`,
"message.unbind.mfadevice.no.permission":`No tiene permiso para desvincular el dispositivo de MFA, contacte con el administrador`,
"label.partner.new.step3.meno":`?No está seguro de qué ingresar? No se preocupe, puede cambiarlo más tarde en cualquier momento.`,
"label.import.page3.importsucceedtip":`Importación iniciado con éxito. Después de la importación, se enviará un correo electrónico a su buzón vinculado`,
"label.customsetting.visible.protect":`Protegido`,
"label.publishreadandwrite":`Lectura/Escritura Pública`,
"vue_label_file_add_most_once":`Se puede añadir como máximo de una sola vez`,
"label.salescloud.teamrole.optionlist.group":`Asignar roles a los miembros del grupo de oportunidad y los miembros del grupo de cliente`,
"label.appointment.wizard.subtitle7":`Ubicación`,
"label.task.dateminus":`Menos`,
"label.data.exp.zippwd":`Ingrese manualmente la contrase?a de archivo compresionado`,
"UG_Forcast_09":`Siguiente`,
"message.duplication.label.allselectlink":`[Seleccionar todo]`,
"label.file.ccchat.selectfromcloudcc":`Seleccione un fichero de CloudCC`,
"label.ems.addaccount3":`A?dir cuenta`,
"front-epwechat-module-v1-schedule-sync":`Sincronización de horarios`,
"label.h5.manage":`Gestionar las aplicaciones`,
"setup.layout.label.nobutton":`No hay botones disponibles`,
"label_component_hotdeal":`Transacciones calientes`,
"template.dashboard.contract.analysis":`Análisis de contratos y cuentas por cobrar`,
"vue_label_dashboard_editcomponent":`Editar componente`,
"label.quotationInformation":`Información de la oferta`,
"label.data.file.validation_rules":`Ejecutar las reglas de verificación`,
"label.ccpeak.construction.shareobj":`Para establecer un formulario compartido de un objeto, debe ingresar el nombre de API y el logo compartido:`,
"label.wei.pollinformation":`Detalles de Micro Voto`,
"label.quickbooks.viewlist.total3":`Hay {0} pagos con un valor total de{1}`,
"label.paging.totalofpagesnoid":`Un total de {0}páginas`,
"label.unlock":`desbloqueado`,
"front-invoice-online-payment-information":`Información de la factura`,
"label.permission.systempermission":`Permisos asignados del sistema`,
"message.error.object":`Al recordar un servicio, han encontrado que el objeto no está definido;`,
"font-trade-module-v1-invoice-intro":`Por favor, introduzca el número o el nombre de la factura`,
"label.userinfo.pwdexpired":`La contrase?a actual se ha caducado. Debe cambiar la contrase?a por razones de seguridad.`,
"label.userphoto.photo":`Foto del perfil`,
"label.tabularreport.filterrecord":`Seleccione los criterios para determinar que registros para mostrar`,
"label.partnerCloud.orderingPlatform.rechargeIt":`El saldo de su cuenta no es suficiente, por favor, recárguelo.`,
"label.icon.120":`Computadora`,
"label.projectManagement.select.new.type":`Seleccione el tipo de creación`,
"vue_label_commonobjects_detail_customer_details":`Cargando detalles del cliente`,
"label.ems.status":`Status`,
"label.validate.function.description":`Cualquier función que se ajuste a la sintaxis de java puede ser utilizada en la regla de validación, y la expresión necesita devolver un valor booleano.<br> También puede utilizar una función específica proporcionada por CloudCC.
Por ejemplo, isNew(),isChanged(FieldAPIName__c),priorValue(FieldAPIName__c),priorValue() devuelve un objeto, es necesario convertirlo al tipo de campo correspondiente.`,
"label.escalation.setup.newaction.step2":`Paso 2: Seleccione los usuarios para asignarles los casos automáticamente`,
"label.forecast.customforecast.searchforecast":`Buscar previsiones`,
"label.the.upper.bound.of.each.level.of.block.pricing.must.be.greater.than.the.lower.bound.":`El límite superior de cada nivel deberá ser mayor que el límite inferior cuando se fije el precio por bloques.`,
"vue_label_commonobjects_view_notice_deletefailreason":`No se ha podido eliminar el dato con id {0} debido a {1};`,
"page.field.masterinput.remark":`Importación de Maestro-Detalle activada ha sido utilizada para crear lista relativa de registros en la página de menú.`,
"lable.SalesCommitmentKanBan.contractName":`Nombre de contrato`,
"front-gantt-module-add-milestone":`Añadir hito`,
"label.callcenter.save.error":`Por favor no guarde repetidamente`,
"label.workflow.selectobj":`Paso 1: Seleccionar objeto`,
"label.validate.function.category.all":`--Clasificación de todas las funciones--`,
"label.multilang.uploadifupage.select":`Ha seleccionado totalmente {0} ficheros:`,
"label.weixin.dragsort":`Arrastre los íconos en mis aplicaciones para ordenarlos de nuevo`,
"N":`Número`,
"label.knowledge.article.translation.completed":`Traducción del artículo completada`,
"label.weixin.myapp":`Mis Apps`,
"label.icon.138":`Moneda`,
"vue_label_chat_create_discussion_now":`Crear discusión ahora`,
"label.knowledge.recover.article":`Restaurar el artículo`,
"label.ccpeak.use.class.time.map":`Acceder por transmitir colección de Map`,
"front-email-payment-error-tips":`Error de interfaz`,
"label.service.gantt.ziyuan":`Solo para`,
"label.upload.error":`Frascasado`,
"label.staticresource.upload.error":`?Se ocurrió un error al subir los recursos estáticos!`,
"com.cloudcc.login.error.message.loginfail":`Operación fallida, por favor contacte con el administrador`,
"pagecreator_button_back":`Paso anterior`,
"label_tabpage_skip":`Saltar a`,
"label.pw.old":`Por favor, introduzca la antigua contraseña`,
"pagecreator.layout.label.modifylayout":`Editor de diseño`,
"vue_label_chatter_share_group":`Compartir con el grupo`,
"label.app.edit":`Editar las aplicaciones`,
"label.user.Email.repeat":`Correo electrónico duplicado. Este usuario no es compatible con la vinculación con el agente`,
"label.field.quilt":`Este campo es`,
"label.projectManagement.Groupuser":`Agrupar por usuarios`,
"label.deleteall":`Cancelar todo`,
"label.appexchange.download.tiaoguo.mes":`Omita la instalación de los siguientes componentes en conflicto:`,
"label.sendemail.recycle.operatehello":`#username Hola:\r\n`,
"label.emailmerge.mergeFolder.max20templates":`?Seleccione hasta 20 plantillas!`,
"label.campaignmember.main.deleteleaddesc":`Cancelación masiva de todos los candidatos de esta campa?a`,
"Opportunity_Detailed_Phase_Label_Popup_003":`Días en la etapa actual`,
"vue_label_file_no_title":`Sin título`,
"label.data.dataexpalltype.all.desc":`Exportar los datos de todos los objetos que el usuario actual tiene acceso.`,
"label.dashboard.unit2":`Unidad: Millon`,
"label.list.userinterface.isrelatedlist":`Activar el desplazamiento de lista relacionada`,
"label.role.tree":`La estructura de los roles de su organización es lo siguiente:`,
"label.campagin.roi.zcsl":`Inscripción`,
"message.error.forecast.setupchange":`No se encontraron los datos a los que intentaba acceder, es posible que otros usuarios cancelaron los datos o los cambiaron.`,
"label.sendemail.changeowner.dataname":`El nombre de documento es archivo de #dataname`,
"label.salescloud.opportunity.contactrole.optionlist":`Valores de la lista de opciones de roles para los contactos de oportunidad`,
"setup_mainpage_label_welcome1":`Necesita permisos correspondientes`,
"UG_activity_02":`Asignar tareas`,
"label.tabpage.erraddressz":`Formato de correo electrónico incorrecto, por favor, introduzca el correo electrónico correctamente.`,
"label.weixin.nicheng":`Nombre de WeChat`,
"label.forecast.settings.mrsz":`Pronóstico de número por defecto`,
"label.campaign.channel.download.size3":`Tama?o peque?o: 300*300 píxeles`,
"label.icon.73":`Herramienta De Máquina`,
"label.ServiceCloud.suoxuchanpin":`Productos necesarios`,
"label.escalation.setup.newrule.description":`Ingrese el nombre de regla y acívelo. Activar esta regla bloqueará la regla de actualización del caso actual. Para evitar la actualización automática del caso, se prohibe la regla acutal.`,
"label.data.import.setup.whichfield.cloudccid":`ID de CloudCC`,
"label.validate.function.funcExplain.PRIORVALUE":`Regrese al tipo object, se requiere convertir al tipo de campo correspondiente`,
"Lead.Scoring.Warning.001":`La puntuación de un solo cliente potencial es automática cuando se crea o edita. Pero es necesario puntuar manualmente múltiples clientes potenciales cuando se importan por lotes o se crean por interfaz.`,
"label.tianyancha.businessverify.msg9":`CloudCC. Co.,Ltd Beijing reserva el derecho de la interpretación de este acuerdo.`,
"label.compact.layout.tip":`El dise?o de información clave se utiliza para mostrar los campos clave de los detalles de registro en la página de información.`,
"label.visualpage.btype":`Informe`,
"label.textmessage.vonage.settings":`Ajustes`,
"label.field.not.exites":`?No existe!`,
"label.payment.switch.version":`Transferiendo a la versión`,
"label.ems.hour":`Hora`,
"label.weixin.cannot.edit":`?El formato del fichero no se puede editar!`,
"chatter.pt.limit":`El tama?o máximo del archivo es`,
"label.quote.detailinfo.add":`Añadir detalles de cotización`,
"component.setup.label.displayfield":`Mostrar campo`,
"vue_label_report_reportfolder":`Ubicación del informe`,
"label.gbkencoding":`Chino(GBK)`,
"front-kefu-moudle-v1-Transfer-to":`Transferencia a {TransferName}`,
"label.file.stop.sharing.desc2":`Compartir`,
"label.textmessage.messageCannoutuse":`No es posible, por favor, póngase en contacto con el administrador para activar los mensajes de texto.`,
"component_newrecords_label_type":`Tipo de almacenamiento`,
"label.validate.function.funcFormat.ISNEW":`ISNEW()`,
"lable.product.pricebooks.new":`Crear nuevo catálogo de precios`,
"vue_label_newfile":`Nuevo archivo`,
"label.reportTypcrtB":`Asociar objeto (B) haga clic en seleccionar el objeto relacionado`,
"label.knowledgebase.type":`Categoría`,
"label.report.select.format":`Seleccione el formato del informe`,
"component.todaytask.label.title":`Tareas de hoy`,
"message.undelete":`?Está seguro de que quiere anular la cancelación?`,
"label.ccdocument.trace.retention":`Función de rentención de seguimientos`,
"label.publicgroup.tip":`El grupo público es un conjunto de usuarios. Puede contener usuarios individuales, otros grupos, roles específicos o usuarios dentro del rango.`,
"label.forecast.settings.lable2":`Vista predeterminada de abstracto de previsión`,
"label.projectManagement.positive.integer":`Introduzca un número entero positivo entre 0-24`,
"label.projectManagement.one.work.list":`Rellene al menos una lista de trabajo`,
"label.or":`||O`,
"label.projectManagement.no.person.in.charge":`No hay supervisor`,
"vue_label_commonobjects_detail_an_email":`Enviar un correo electrónico`,
"front-electronic-signature-field-mapping":`Añadir mapeo de campos`,
"label.marketsea.name.error":`El nombre del grupo público no puede estar vacío`,
"component.setup.button.appurl":`URL del sistema`,
"label.mr.title.button.group1":`El`,
"chatter.contact":`Contacto`,
"vue_label_pool_hasfixed":`Posee canales fijos de cooperación`,
"lable.list.queue.des":`Las colas permiten a los grupos de usuarios gestionar el trabajo compartido eficientemente. Una cola es un lugar donde los registros pueden ser enrutados para esperar el procesamiento por parte de un miembro del grupo. Los registros están en la cola hasta que un usuario los acepte para procesar o se transfieran a otra cola. Puede especificar el conjunto de objetos admitidos por cada cola, así como el conjunto de usuarios que pueden recuperar registros de la cola.`,
"label.reportsSubscriptionPage.condition":`Configurar condiciones`,
"label.transwork":`Traducción de la mesa de trabajo`,
"label.batch.batchopration.resel":`Seleccione de nuevo los datos que quiere transferir, y haga clic en ¨OK¨ para saltar a la página de la lista de vista.`,
"label.cloudccsite.new":`Nuevo sitio`,
"label.button.select.page.required.field":`Seleccione los campos obligatorios en la página`,
"label.pagelayout":`Dise?o de página`,
"label.weixin.trace.record":`Seguir registros`,
"label.emailtocloudcc.clear":`Borrar todo`,
"label.checkfield.find":`Encontrar duplicados`,
"message.view.count.title0":`Resumen de la página actual`,
"label.reportsSubscriptionPage.schedulereport.frequency":`Frecuencia`,
"setup.mainpage.label.welcome5":`Campo personalizado`,
"label.implementation.details":`Executar detalles`,
"label.attendance.history":`Historial de Asistencia`,
"label.is.pigeonhole":`¿Guardar archivo?`,
"lable.account.CurrentandPreviousFYt":`A?o fiscal actual y anterior`,
"label.forecast.customforecast.tab.opportunity":`Oportunidades`,
"label.version.business.track":`Seguir oportunidades`,
"label.profilelayoutedit.selectrecordtype.tip":`Seleccione el tipo de registro para el perfil de usuario. Necesite a?adir este tipo de registro al dise?o de página asociada con este perfil, así se puede mostrar en la página detallada y la página editada. `,
"label.campagin.roi.zclzb":`Proporción de registro`,
"label.validate.function.funcFormat.WEEKDAY":`WEEKDAY(date)`,
"label.view.sort.message":`Ordenado por {!sort}`,
"page.field.masterinput.sort":`Importación de Máster-Detalle se muestra de acuerdo con la orden de guarda`,
"label.selected.field":`Campos de búsqueda seleccionados`,
"label.product.proofTwo":`En {0}, elija al menos {1} opciones de productos.`,
"vue_label_report_filtercondition":`Condiciones del filtro`,
"label.forecast.shrepage.desc1":`Esta página alistará los usuarios, roles y territorios que tienen acceso compartido a `,
"label.file.copy.link":`Copiar el enlace`,
"vue_label_chat_movedto":`{name} ha modificado {label} a {newField}`,
"label.layout.new.built":`Nueva sección`,
"label_tabpage_crecordtypez":`Cambiar el tipo de registro`,
"label.report.searchcustominfo":`Ingrese palabras clave para encontrar los reportes personalizado a juego`,
"chatter.feed.menutype.user":`Colegas`,
"label.recordtypeselect":`Seleccione tipo de registro`,
"label.partner.new.step3":`Paso 3: Ingrese el nombre y la URL`,
"label.newCustomReportType":`Fuente de datos de nuevos informes personalizados`,
"label.service.gantt.day.timescale":`Escala de tiempo en la vista de día:`,
"label.displaytype3":`Botón de lista`,
"label.weixin.discharge.rate":`Volumen de Escape`,
"label.weixin.menu.message":`Menú`,
"label.mask.show.all.characters":`Muestra con máscara todos los caracteres`,
"label.quickbooks.fieldlabel.billingaddress":`Dirección de facturación`,
"Dashboard.View.All":`Todos los cuadros de mando`,
"setup_mainpage_label_welcome22":`Instrucciones: Haga clic en el menú a la izquierda de la página → Configuración de Gestión → Plantilla de Contactos → Plantilla de Correo.`,
"chatter.group.groupInformation":`Información de Grupo`,
"front-epwechat-module-v1-input-secret":`Por favor, introduzca el secreto`,
"lable.Set.value.prompt":`O bien, filtrar los registros mostrados en la lista relacionada. Elija la casilla de verificación o los campos de la lista de selección y los valores que desea filtrar. Si introduce los valores manualmente, sepárelos con comas.`,
"label.appupload.upload.from":`Por`,
"label.weixin.postunsolve":`Atrasado`,
"label.cooperation.all":`Cooperación de todos`,
"lable.PowerProcess.close.time":`Basado en la hora de cierre de {detailInterestType}`,
"lable.opppdt.selPdt.leastone.fields":`Seleccione por lo menos un campo`,
"label.emailtocloudcc.help":`Introduzca la contraseña de correo electrónico correcta o el código de autorización. Si su servidor de correo electrónico necesita activar el servicio IMAP/SMTP para iniciar la sesión mediante una cuenta de terceros, debe acceder a la configuración de la cuenta de correo electrónico para activar el servicio en primer lugar, y copiar el código de autorización correspondiente en la casilla de de la contraseña.`,
"label.attendance.offwork.time":`Tiempo libre`,
"front-gantt-module-v1-project-gantt":`Diagrama de Gantt del proyecto`,
"label.chuangming.description":`Configure información de Chuangming para satisfacer los requisitos del servico de enviar y recibir SMS en su organización.`,
"label.custom.lead.notice.account.name":`?Hola! Hay candidatos que le asignen como propietario de clientes, contactos y propiedades a través de la conversión, nombre del cliente:`,
"label.emailobject.failedtosend1":`?Envío fallido: La verificación del correo es inválido, vincule con su correo personal de nuevo!`,
"vue_label_ccchat_notice_updaterecordsuccess":`Se ha actualizado el registro`,
"label.dayinmonth":`De meses`,
"label.sendemail.chat.follow":`Estimado #name:\n\n hola! #userName le sigue.`,
"label.emailsync.form.emialpassword":`Contraseña`,
"component_task_label_subject":`Tema`,
"label.projectManagement.please.enter.a.positive.integer":`Introduzca un número entero positivo`,
"lable.account.NexteDays":`En los proximos 7 días`,
"label.appupload.upload.managed":`?Se puede crear un paquete controlado al máximo!`,
"label.data.dataexpalltype.all.desc1":`1. Puede elegir entre generar automáticamente o introducir manualmente la contraseña del archivo comprimido exportado. La contraseña generada automáticamente se enviará al correo del usuario cuando los datos se exporten con éxito. La contraseña introducida manualmente no se enviará al correo, por lo que los usuarios deben recordar la contraseña introducida. Si no se introduce, se entenderá que no hay contraseña.`,
"label.step1.total3":`Paso 1 de 3`,
"label.escalation.setup.detail.section":`Detalles de regla`,
"front-gantt-module-drag-task-sorting":`Arrastrar las tareas para ordenarlas`,
"label.isEnableVisualpage.new.title":`Habilitar el acceso a páginas personalizadas`,
"label_tabpage_yesz":`Sí`,
"label.emailobject.emaildetail.button.replyall":`Mostrar todo`,
"label.knowledge.setting.data.one":`Esto no puede añadir más subcategorías.`,
"label.manageAll.sel.one3":`Los ítems que he aprobado`,
"UG_contact_01":`?Cómo utilizar suficientemente sus contactos?`,
"font-trade-module-v1-invoice-name":`Nombre de la factura`,
"label.central.daylight.time":`Hora de Verano Central`,
"label.chatter.pastThirtyday":`Los últimos 30 días`,
"vue_label_commonobjects_detail_activity_ownevent":`Evento en propiedad`,
"label.user.modify":`Editar usuarios`,
"label.uploadTemplate":`Subir plantilla`,
"setup_mainpage_label_welcome14":`Personalización del flujo de trabajo, gestión del proceso de aprobación`,
"label.workmate":`Colegas`,
"label.displaycolumns":`Mostrar columnas`,
"label.emailnoticeintro":`El aviso de correo es el correo que se envia al activar la regla del flujo de trabajo.`,
"label.knowledge.category.button.five":`Borrar categoría`,
"template.report.business.opportunities.type":`Oportunidades por tipos`,
"vue_labenl_applauncher_moreapp":`Más aplicaciones`,
"label.captcha.expired":`El código de verificación ha caducado, por favor verifíquelo de nuevo.`,
"template.chart.bnqzkhslmb":`Objetivo de número de clientes potenciales para el año`,
"chatter.up.user.pic":`Subir foto del perfil`,
"label.timezone.importtimezone.gmt":`Hora de Greenwich`,
"label.step.type":`Seleccione el tipo de miembros que quiere buscar`,
"Dashboard.View.RecentlyView":`Visto Recientemente`,
"label.reportinthisfolder":`Informes en esta carpeta`,
"label.product.vies":`Vista del producto`,
"pagecreator_systemstyle_message_delete_fail":`La cancelación del estilo se frascasó`,
"label.multipleactivity.singleUser":`Usuario individual`,
"vue_label_email_enter_subject":`Introducir asunto`,
"label_tabpage_alltabs":`Todos los menús`,
"label.publicgroup.groupname":`Nombre del grupo`,
"template.report.sales.performance":`Rendimiento de los vendedores`,
"label.newWindow":`Nueva Ventanilla`,
"label.forecast.editopp.forecastedit":`Editar previsiones`,
"label.data.import.setup.whichfield":`¿Qué campo le gustaría utilizar para el cotejo?`,
"label.noadd_dashboard":`No añadir al cuadro de mandos`,
"label.subtotal":`Subtotal`,
"front-email-payment-weichat":`Por favor, utilice WeChat "Scan"`,
"label.attendance.position.alert":`Seleccione primero las etiquetas`,
"chatter.follow.me":`Sígame`,
"label.mobile.more.details":`Editar las detalles del archivo`,
"Dashboard_SelectBoardToDisplay":`Seleccione los paneles que quiere mostrar en la página de menú del panel`,
"front-gantt-module-v1-search-project":`Busca tu proyecto...`,
"label.paging.totalofpagereport":`?Un total de {0} páginas({1})`,
"label.from.phone":`Desde`,
"lable.Signatory":`Signtory:`,
"label.campagin.roi.query.roi2":`ROI de las canales de marketing`,
"label.tabpage.selectcontentz":`Seleccione contenido`,
"label.multilang.lookfiltercondition.valuetypenotmate":`?La condición de línea {0} es incorrecta, el tipo de valor no coincide!`,
"label.interfaceconstraint.disabled":`La interfaz ha sido desactivada, por favor contacte con su administrador de sistemas`,
"third":`El tercero`,
"label.quickbooks.viewlist.status":`Status`,
"label.emailtocloudcc.select3":`Seleccione el propietario del registro`,
"label.projectManagement.week.work":`Mi trabajo para esta semana`,
"vue_label_pool_nodemand":`No hay demanda`,
"label.version.two.developapi":`Desarrollo secundario de API`,
"label.icon.82":`Impresora`,
"label.batchadd.newbatchpage.suclist":`Datos a?adidos con éxito`,
"label.checkfield.chooseatlast":`Seleccione por lo menos dos`,
"label.quotation.deleteTip":`Seleccione las ofertas desea eliminar`,
"label.generatepage.title.desc2":`Clic en Guardar para generar la página Web y el enlace URL al que se puede acceder.`,
"label.licence.total":`Licencia total`,
"Y":`Relación de búsqueda`,
"label.wuzibiekesitan.time":`Hora de Uzbekistán`,
"label.component.hotdeal.nodata":`No hay datos relacionados con la oportunidad de negocio`,
"label.data.exp.save":`Guardar plantilla`,
"label.appupload.upload.tips.dashboard":`NOTA: Los cuadros de mando de "Mis cuadros de mando personalizados" y "Cuadros de mando públicos no archivados" no pueden añadirse a los paquetes y no se mostrarán en esta lista. Los informes antiguos relacionados no pueden cargarse".`,
"lable.PowerProcess.new.PowerProcess":`Nuevo proceso de asignación`,
"label.loginhis.search.download":`Considerando que hay muchos historiales, sólo puede descargar los de últimos 2 meses`,
"label.tabpage.deleteview":`Eliminar vista`,
"label.chatter.recently":`Recientemente`,
"label.industrialandcommercialverification.title":`Verificación Industrial y Comercial`,
"message.nextapproverlost":`El aprobador siguiente específico es nulo.`,
"front-kefu-moudle-v1-mfsysy-time":`Días restantes para la prueba gratuita`,
"label.role.assign.tip":`Elija un usuario en la lista de Usuarios Seleccionado y agréguelos a la lista de Usuarios Seleccionados para asignarlos al rol`,
"label.addattachment.step2.intruduce":`Repetir Paso 1 y Paso 2 para añadir múltiples archivos`,
"vue_label_pool_returnreasondiscription":`Descripción del motivo de la devolución`,
"label.weixin.report.range":`Rango`,
"label.wei.weiresearchtab":`Opción de Micro Voto`,
"vue_label_report_setdrill":`Ajuste de exploración en profundidad`,
"page_404_button_back":`Regrese al paso anterior`,
"label.customfields.autonumber.tip":`Un número de secuencia generado por el sistema que utiliza un formato de visualización que usted define. El número se incrementa automáticamente para cada nuevo registro.`,
"label.ccpeak.return.allrecords":`Regrese a todos registros`,
"label.ccchat.notmember.active.group2":`No está en el nombre con`,
"label.uniquename":`Nombre único`,
"label.emailtocloudcc.filed.ssl":`Conexión segura`,
"chatter.emailFollowMe":`Al seguirme`,
"label.allrightsreserved.allrightsreserved.customerServiceHotline":`Derechos de autor. Todos los derechos reservados. Número de atención al cliente`,
"label.projectManagement.actualworkinghours":`Horas de trabajo reales`,
"label.quickbooks.fieldlabel.taxresale":`Reventa de impuesto`,
"label.icon.12":`Servicio`,
"label.data.exp.dataexptemp":`Plantilla para exportar los datos`,
"component_setup_tabs_label_add":`Añadido`,
"label.appointmentdetail.wizard.title10":`Fecha de inicio`,
"label.multilingual.close":`La gestión multilingüe no está habilitada.`,
"message.error.username.notexist":`Usuario Inválido, vuelva a ingresar.`,
"label.batchadd.newbatchpage.des2":`Si el tipo de campo es número automático, no necesita ingresar, el sistema generará automáticamente el código al guardar`,
"vue_label_SMS_search":`Búsqueda de clientes potenciales o contactos`,
"label.appupload.successWithUrl":`Ahora puede utilizar la URL siguiente para instalar el parquete.`,
"UG_Forcast_06":`Seleccione los usuarios que se permiten hacer las previsiones`,
"vue_label_dashboard_secondarygroup":`Seleccione el grupo secundario`,
"label.weixin..xsld.total":`Cantidad Total en Embudo de Ventas`,
"label.setup.mobile.bottombutton.recovery.default.fail":`Fallo en el restablecimiento de los valores por defecto`,
"label.addrecurrencetimetrigger":`Añadir la activación del tiempo periódico`,
"label.emailsync.connectaccount":`Vincular cuenta de correo electrónico`,
"label_fiscal_years":`Año fiscal`,
"label.icon.164":`Entrenador`,
"label.batchadd.mustinput":`Llevar`,
"message.newtabpage.nokeywords":`La palabra clave deber ser uno o más caracteres o puede añadir los criterios avanzados de búsqueda.`,
"label.login.verification.mfa.desc3":`Si su cuenta ha sido compartida por varias personas, las no vinculadas el MFA no pueden ingresar después de que ha vinculado el MFA. La solución consiste en dejarlas instalar la aplicación MFA y escanear el código QR en la página, o guardar la imagen de QR para que los demás lo escaneen. Sin embargo, por la seguridad, le recomendamos que cancele el uso de compartido de la cuenta.`,
"label.partnerCloud.basicSetting.initialize":`No se puede cambiar el nombre del dominio después de la inicialización.`,
"label.address.county":`Distrito`,
"label.validate.function.funcFormat.TODAY":`HOY()`,
"label.sso.addAKey":`Añadir claves`,
"label.myusergroup":`Mi grupo de usuarios`,
"label.import.index.time-consuming":`Tiempo`,
"label_tabpage_systems":`Hay * sistemas`,
"batch.sendemail.s":`, Envío exitoso del correo.`,
"label.appointment.wizard.subtitle4-1-1":`15 minutos`,
"label.projectManagement.delete.milestone":`Toda la información relacionada con este hito también se borrará lo elimina, y los datos no podrán ser recuperados. ¿Está seguro de querer eliminarlo?`,
"label.umeng.chatter.praise":`Le gusta su publicación de nube`,
"font-evaluate-module-v1-evdetails":`Detalle de la evaluación:`,
"label.group.filter.resources.and":`Elija un método de filtrado y relación de recursos`,
"label_emailtocloudcc_description":`Vincular con su correo de empresa, por ejemplo sales@company.com, info@company.com, support@company.com. El sistema generará candidatos o registro de caso según los correos recibidos para seguir a timpo los mensajes de cliente`,
"label.chat.topic.delete.prompt2":`Note que los temas del mismo nombre en otras comunidades no se cancelarán.`,
"message.error.group.authorization":`No tiene acceso a la configuración de este grupo`,
"label.attendance.wz":`Lugar`,
"vue_label_activity_notice_logacal_success":`Ha registrado una llamada`,
"label.emailtocloudcc.step1.case1":`Email to Case`,
"label.h5.chatter.praisenum":`Me gusta recibido`,
"label_time_statistics_basis":`Criterio estadístico del tiempo`,
"label.onlyadmincanedit":`Administradores <strong>SOLO</strong> puede editar registros durante el proceso de aprobación.`,
"label.fieldtoolongmassage":`Campo`,
"label.sales.team.shared":`Compartir de oportunidades comerciales en el grupo`,
"label_emailsync_status_department":`Departamento`,
"label.mobile.quickcreate.default.sellingfunnel":`Embudo de ventas`,
"label.tabpage.closez":`Cerrar`,
"homepage.components.two":`Paso 2: Seleccionar la ubicación donde se muestran los componentes personalizados`,
"label.everyday":`Todos los días`,
"lable.Product.to.asset.BOM":`Lista de materiales del producto al activo`,
"label.appointment.wizard.subtitle4-3":`El invitado puede elegir el intervalo del comienzo de reunión`,
"label.customobjects.standardfieldslist":`Lista de campos estándar`,
"label.customfields.suretodelete":`Sí, quiere cancelar el campo personalizado`,
"component.chatter.label.to":`a`,
"label.emailsync.form.seversetting":`Configuración`,
"label.service.gantt.enabled.resources":`Recursos activados`,
"label.tianyancha.h5.weibo":`Microblog`,
"template.chart.dddje":`Cantidad de pedidos perdidos`,
"label.pc.trigger.apiname":`Name Api ya existe, intente de nuevo`,
"label.icon.34":`Preparar`,
"label.schedulejob.setup.schedule.prgname":`Nombre de aplicación`,
"label.weixin.free.registration":`Registro gratis`,
"label.placeholder":`Búsqueda rápida`,
"label.emailobject.manage.template":`Gestionar plantillas`,
"label.knowledge.article.existsdata":`Existen otros datos, no cumple con los requisitos`,
"label.campaign.channel.lookup.ticket":`Revise el boleto`,
"label.searchlayout.relation.searchfield":`Buscar campos de filtro para listas relacionadas`,
"label.recordid.cannot.empty":`El registro ID no se puede estar vacío`,
"label_partner_workspace_member_choice":`Seleccione perfil`,
"vue_label_campaign_amount":`Importe ingresado`,
"label.niue.time":`Hora de Niue`,
"front-homepageobject-module-v1-workload-ranking":`Clasificación de la carga de trabajo`,
"message.error.datainvalid":`Error: dato inválido`,
"vue_label_helpcenter_salesfunnel":`Utilice la nueva versión del embudo de ventas para analizar el seguimiento de las oportunidades de negocio y proporcionar referencias de datos para su proceso de ventas.<br> En la esquina superior izquierda, los registros se filtrarán según condiciones como el rol o el propietario, y se mostrarán y analizarán todas las oportunidades de negocio visibles bajo las condiciones correspondientes. Haga clic en la etapa del gráfico del embudo de ventas para ver todos los registros que se encuentran en dicha etapa.`,
"vue_label_transferownernotice":`También se modificará el propietario del registro asociado a este proyecto`,
"label.monitorsys.operator":`Operado por`,
"label.please.codeNorm":`Por favor, elija el código estándar.`,
"label.campaign.channel.step6.remark2":`Activar la función de invitar los colegas`,
"market.potential.customers":`Clientes potenciales del mercado`,
"label.customfields.phone.tip":`Permitir a los usuarios introducir cualquier número de móvil. Transferir automáticamente en el formato de número de teléfono.`,
"label.currency.edit":`Editar moneda: cambiar moneda empresarial`,
"label.emailobject.emaildetail.button.markasunread":`Marcado como no leído`,
"label_partner_template_memo":`Título`,
"label.chat.message.search.all":`Buscar todas las informaciones`,
"label_tabpage_hoursagoz":`horas`,
"label.customcomponent.developer.help":`Desarrolladores de componentes personalizados Ayuda`,
"setup_mainpage_label_welcome":`Bienvenido a la plataforma CloudCC PaaS, la función principal es el siguiente:`,
"label.h5.similar.opportunity.list":`El resultado incluye oportunidades cerradas-ganadas que tienen uno o más campos en común con su oportunidad.  Las oportunidades de marcadores los agregarán a una lista relacionada con oportunidades similares en su página de detalles de oportunidades.`,
"vue_label_record_count":`Recuento de registros`,
"label.icon.29":`Manifestación`,
"pagecreator.page.label.pagelayout":`Diseño de la página`,
"label.ggReleaseRange.searchRole":`Buscar un papel`,
"label.campagin.member.field.setup":`Configuración del campo de miembro de campa?a`,
"augest":`Agosto`,
"label.salescloud.massloss.content":`Prohibir oportunidad del grupo cancelará irreversible los grupos existentes de todas las oportunidades y cancelar grupos de oportunidades predeterminados de los usuarios.`,
"label.customfields.new.step2.opration.unique.info":`No se permite el valor duplicado`,
"vue_label_email_optional_members":`Miembros opcionales`,
"label.emailobject.attachment.download":`Descargar`,
"label.recordamount":`Cantidad de Registro`,
"front-kefu-moudle-call-recorder":`Grabación de llamadas`,
"label.more.info":`Detalles`,
"vue_label_commonobjects_view_secondsbefore":`{seconds} segundos antes`,
"label.emailsync.status.action":`Acción`,
"label.customfields.totalsummary.collectedfields":`Objeto resumido`,
"label.knowledge.setting.hint.two":`Atención: No se puede desactivar el Conocimiento una vez activado.`,
"label.login.access.yujidao":`Expectado`,
"label.assignment.setup.detail.description":`Crear reglas para que asigne automáticamete los registros a los usuarios según los criterios determinados.`,
"message.error.marketsea.null":`El grupo público no existe`,
"lable.account.Current.CY":`A?o fiscal actual`,
"vue_label_salesadvance_lost":`Pérdida`,
"label.file.ownedbyme":`Mi propietario`,
"label.component.helper.nodata":`No hay nada que requiera su atención en este momento. Por favor, vuelva más tarde.`,
"label.weixin.appr.pending.auditor":`Enviado por`,
"UG_opportunity_004":`Múltiples tipos de servicio`,
"label.leadscore.setup":`Configuración de Puntuación de Candidatos`,
"label.addtimetrigger":`Añadir el trigger de tiempo`,
"label.mr.title.match":`Si coincide exactamente`,
"label.projectManagement.Newmilestone":`Nuevo hito`,
"label.preview":`Vista previa`,
"label.tabpage.issuez":`Problema`,
"label.img.max.size":`La imagen subida es demasiado grande, el tama?o máximo de la imagen no excede a 500K, suba de nuevo. `,
"label.mainpageset":`Configure componentes de la página oficial`,
"label.user.login.false.lock":`Se han superado los intentos de inicio de sesión. La cuenta está bloqueada`,
"UG_solution_02":`La solución es una solución internal de la institución para resolver los problemas que los usuarios encuentren.`,
"vue_label_approve_put_away":`Colapso`,
"label.profile.existing":`Perfil actual`,
"label.ems.logininfo":`Información de login`,
"label.weixin.location.service":`Los objetos que proporcionan el servico de ubicación`,
"label.multilang.datamoveaction.totaldata":`Hay totalmente{1} registros cumplidos con las condiciones, se puede transferir al máximo 100 registros`,
"label.ccdocument.cannot.update.set":`?Este documento no pertenece a formato de archivo Word, Excel o PPT, no se puede subir a la plantilla de carpeta roja!`,
"vue_label_fliter_addfliter":`Añadir filtro`,
"label.custom.page.or.trigger":`(Página personalizada o Activación)`,
"label.tag.filter1":`Filtrar todos los registros que contienen  las etiquetas seleccionadas`,
"UG.homepage.006":`Conoce las actividades de su cliente a profundidad a través de encuestas, chats en vivo, correos electrónicos, órdenes de trabajo, publicaciones en redes sociales e incluso actividades de ventas (como clientes potenciales, soporte de servicio y actividades).`,
"SCORE":`Puntuar`,
"label.file.library.managemembers2":`Gestionar los miembros de la biblioteca`,
"label.email.template.public.SMS":`Carpeta de plantillas de SMS públicas`,
"label.leadscore.donot":`No puede hacer puntuación a los candidatos`,
"label.gaode.map":`Amap`,
"pagecreator_button_preview":`Previsualizar`,
"UG_contact_04":`O`,
"label.ccchat.person.invite.eminfo":`{0} le ha invitado a entrar a {1} en CCChatter. Con el CCChatter puede chatear con sus colegas, crear grupos para sus proyectos y compartir los ficheros.`,
"setup_object_field_dependency_label_actionfieldvalue":`Controlar el valor del campo`,
"lable.Product.options":`Opciones de productos`,
"front-electronic-signature-add-autofill-field":`Añadir campo de autorrelleno`,
"label.customfields.totalsummary.selectcollectedfields":`Seleccionar objeto para resumir`,
"label.projectManagement.the.maximum.contract.amount.is.10.digits":`Máximo10 dígitos para el importe del contrato`,
"label.forecast.shrepage.pagetitle":`Usuarios, roles y compartido regional`,
"label.login.access.mark":`Para ayudarle a resolver el problema, puede autorizar su administrador para ingresar y acceder a los permisos de los datos.`,
"lable.outlook.edit.zdyout":`Mapeo de campo personalizado de Exchange`,
"label.approveoperate":`Operación de aprobación`,
"label.tabpage.linknamez":`Nombre del enlace`,
"label.report.error.deletehavedashboard":`Este informe tiene un nuevo cuadro de mandos y no puede ser eliminado`,
"label.summaryreport.2018.step1":`Paso 1: Seleccione el modelo de agrupación de las informaciones`,
"label.campaignmember.main.leadtomember.title":`Configuración del campo de mapeo`,
"label.select.dashboar.type":`?Seleccione tipo del panel!`,
"message.setup.field.picklist.valueexists":`El valor de la lista de opciones ya existe`,
"label.loading":`Cargando...`,
"label.payments.paytip1":`Su versión no es versión gratis, haga clic en ¨Confirmar¨ para refrescar o ingresar de nuevo.`,
"label.view.appliedMobile":`Si aplica al dispositivo móvil`,
"label.multilang.forcast.financialyear":`{0}a?o fiscal`,
"front-web-module-v1-detail-comment-opinion":`Comentarios`,
"UG_Forcast_10":`Completar`,
"label.optionlistset":`Opciones de la lista`,
"label.visualpage_list.vpname":`Nombre de página personalizada`,
"vue_label_calendar_failed_to_delete_calendar":`Error al borrar calendario`,
"label.json.string.null":`Vacío`,
"message.serviceappo.time.violation2":`Violación del tiempo disponible de la cita de servicio: la hora de finalización de la cita es anterior a la fecha de vencimiento de la cita de servicio`,
"label.productsales.today.noevttsk":`Hoy no hay eventos abiertos o tareas expiradas`,
"label_tabpage_emptyz":`Vaciar`,
"front-kefu-moudle-no-create":`No se ha creado`,
"label.wedge.shaped.tail.arrow.cannot.empty":`La flecha de cola de cu?a no puede ser vacía`,
"label.continue.shopping":`Seguir comprando`,
"label.turntomain":`Saltar a los contenidos principales`,
"component.assistant.label.nodata":`No hay evento hoy, por favor, compruébelo más tarde.`,
"label.payments.paytip4":`?Ingrese la cantidad correcta de los usuarios!`,
"label.appupload.upload.versionName":`Nombre de Versión`,
"label.chatter.endData":`Fecha de finalización`,
"front-kefu-moudle-buytr-tip":`Esperamos que pueda tener una gran experiencia con el centro de llamadas de CloudCC, y que pueda adquirir una cuenta oficial del centro de llamadas y le proporcionemos un mejor servicio.`,
"label.repw":`Repetir Contrase?a`,
"label.tabularreport.intro":`El informe tabular es uno de los métodos más simple y rápido para alistar los datos`,
"label.selectoperatetype":`Seleccione tipo de operación`,
"setup.layout.label.required":`Obligatorio`,
"label.default.designee":`Asignado por defecto`,
"label.ccdocument.cannotdel.folder":`La carpeta no se puede cancelar porque hay archivos bajo esta carpeta.`,
"label.escalation.setup.newentries.inputentries":`Ingrese los ítems de regla`,
"label.emailobject.addnewtemplate":`Añadir nueva plantilla`,
"label_chatter_content":`Contenido`,
"label.htyj.mubiao":`Meta`,
"label.reportsSubscriptionPage.schedulereport.weekly.friday":`Viernes`,
"label_tabpage_fieldoptions":`Registre tipo del campo, campo de lista de opciones y lista de opciones(Múltiples opciones). Se recomienda que ingrese 10 palabras clave al máximo, separado por comas para conseguir o relacionar, por ejemplo: ¨Beijing, Shanghai, Guangzhou¨`,
"label.mobiletablayoutedit.remark2":`Seleccione los campos que van a mostrar en la página oficial de la aplicación móvil`,
"label.sendemail.chat.addComentsat":`Estimado #name:\n\n    #userName te ha mencionado en los comentarios de la micro-publicación.`,
"Z":`Fórmula`,
"label.multilang.batchdeleteaction.movesuccess":`?Un total de {0} registros se ha cancelado con éxito!`,
"label.textmessage.vonage.message2":`Al configurar las cuentas API de Vonage, los usuarios permiten que CloudCC acceda a su cuenta API de Nexmo para enviar y recibir mensajes de texto.`,
"label.file.use.document":`Estado del espacio de almacenamiento`,
"UG.Lead.011":`Crear una pista`,
"label.view.name":`Nombre de la vista`,
"label.data.downtemplate":`Descargar la plantilla`,
"vue_label_appstore_get_now":`Obtener ahora`,
"label.controlfield":`Controlar el campo`,
"label.dataimport.type.insert":`Insertar`,
"label.customfields.multiselect.tip":`Permite a los usuarios seleccionar múltiples valores de lista definida.`,
"label.weixin.approval.qxzjl":`Seleccione registro`,
"component.salesperformance.label.70finish":`Finalizado - Sin procesar (>70%)`,
"Lead_Auto_Scoring_Setting":`Configuración de puntuación de los candidatos`,
"pagecreator_layout_message_canntdelete":`El dise?o actual no se permite cancelar`,
"vue_label_report_exprotpage":`Exportar página: Página {page}`,
"label.campaign.channel.step4":`Paso 4: Campo obligatorio de la página de registro del canal de marketing`,
"label.app.launcher":`Lanzador de aplicación`,
"vue_label_campaign_selectedmember":`{miembro} miembros de la campaña seleccionados`,
"label.mobile.quickcreate.default.approvals":`Por probar`,
"label.view.step4":`Paso 4. Limitación de visibilidad`,
"label.exchange.sync.state.user":`Utilizar status de Sync`,
"label.forecast.customforecast.tab.forecast":`Submenú de las previsiones`,
"label.theUserLoginForTheFirstTime":`Primer login del usuario`,
"label.workflowoperate.tip":`Especificar operación del flujo de trabajo que va a activarse al satisfacer los criterios de regla`,
"font-evaluate-module-v1-ten-points":`Puntuación positiva: 10 puntos`,
"label.knowledge.delete":`Error al borrar conocimientos`,
"front-console-see-contacts":`Contactos identificados {num}`,
"label.h5.similar.opportunity.add.to.favorites":`Añadir a favoritos`,
"front-epwechat-module-v1-install-app":`Instalar en WeCom`,
"setup_layout_message_relatedlistbutton":`Seleccione los botones estándar para mostrar en la lista relativa`,
"label.salescloud.massloss.title":`Causará una gran pérdida de datos`,
"front-console-conversation-btn1":`Anillo de vuelta`,
"label.custom.canvasScale":`Escala del lienzo`,
"label.lead.score.doing":`En el proceso de la puntuación de los candidatos`,
"message.approval.step.validation.invalid.number":`Introduzca números correctos`,
"chatter.lk":`Me gusta`,
"label.dashboardSetup.showmaxval":`Máximo visualizado`,
"label.keywords":`Palabra clave`,
"vue_label_helpcenter_SMS":`Activar la función SMS<br> Si el código de país del sistema CRM que ha adquirido es de EE.UU, entonces la función SMS está disponible en el sistema de su organización. El administrador de la organización puede introducir el número de teléfono adquirido por su organización en el sistema de vonage en la pasarela de vonage en la aplicación de integración de segundo plano, y luego utilizar la función de SMS en el menú de la aplicación de la nube de ventas.<br>Buzón de SMS<br> El buzón de SMS se divide en dos partes. A la izquierda está el registro de clientes potenciales o contactos contactados con SMS. Después de hacer clic en un registro, los detalles de envío y recepción se mostrarán a la derecha. Puede ver los registros propios y de sus subordinados.<br> SMS grupal<br> Puede enviar SMS de grupo en el menú de SMS, de la lista de clientes potenciales o contactos, y el botón para enviar mensajes SMS en los miembros de la campaña. Solo puede enviar mensajes de texto a clientes potenciales o contactos en CRM. Después de editar el mensaje de texto, seleccione "Enviar", y se generará un registro de grupo independientemente del número de destinatarios, o puede seleccionar "Enviar por separado" para enviar los mensajes de texto por separado. Los SMS que se envían por separado muestran los campos fusionados insertados en la plantilla del SMS.`,
"label.emailobject.createnewavailability":`Crear un nuevo enlace de reserva de programa`,
"front-kefu-moudle-buytr-send-email":`Todavía no se ha asociado al buzón del sistema. Por favor, envíe un correo electrónico a support@cloudcc.com y escriba su intención, nombre de la empresa e información de contacto, el personal de ventas se pondrá en contacto con usted lo antes posible.`,
"front-kefu-moudle-v1-Put-away-the-chat":`Colapsar los detalles del chat`,
"label.marketseamemset.lead.maxuser":`Número máximo de clientes potenciales del miembro`,
"label.forecast.forecastroleuserpage.shre.manager":`Sólo los administradores pueden compartir las previsiones`,
"label.file.noselect":`No hay fichero seleccionado`,
"label.notification.task3":`【被分配人】cambia el estado de la tarea que ha asignado a 【新状态】`,
"label.dependfield":`Campo dependiente`,
"lable.SalesCommitmentKanBan.receipts":`Cobro`,
"label_partner_workspace_member_search":`Buscar`,
"label.share.originally.posted":`? Cartel inicial ?`,
"label.autonumber":`Numeración automática`,
"label.view.sortview.name":`Nombre de vista`,
"label.h5.add.activity":`Añadir eventos`,
"label.textmessage.vonage.phone.number":`Número de teléfono`,
"label.partnerCloud.financeSetting.enterApiKey":`Por favor, introduzca la clave secreta de la API`,
"label.industrialandcommercialverification.enablestatus":`Status de activación`,
"label.reportTypeFocusD1":`Especifique que tipo de registros(Filas) será el foco de los reportes generados por este origen de datos del informe.`,
"vue_label_report_four-levelseriesobjecttree":`Árbol de objetos de serie de cuatro niveles`,
"label.mobile.default.catalogue":`Catálogo predeterminado`,
"label.partnerCloud.partnerAccount.again":`Recarga`,
"label.summaryreport.step2.new":`Paso 2: Seleccione el método de agrupación de los datos resumidos`,
"label.tabpage.cancel":`Cancelar`,
"label.multilang.datamovelist.datamove":`Transferir múltiples{0} de un usuario a otro:`,
"label.conferloginandvisitlimit":`Acceso al login concedido`,
"vue_label_help_viewhelpcenter":`Consultar el Centro de Ayuda de CloudCC`,
"label.leadscore.norule":`No hay reglas de puntuación, cree la regla primero o active la regla creada`,
"label.tabpage.exitz":`Salir`,
"label.DeploymentStatus":`Status de desarrollo`,
"label.layout.saving":`Guardando...`,
"label.emailobject.emaildetail.field.object":`Objetos`,
"label.customfields.searchrelation.fieldtag.tip":`Ingrese las etiqueta para utilizar en la pantalla de vista, vista del dise?o de página y vista de listas`,
"message.huanxin.bindtenant.notfound":`Agente no vinculado`,
"label.referpersonalias":`Entregado por`,
"label.icon.31":`Computadora`,
"label.appupload.upload.install.thispackage":`Este paquete`,
"label.appointment.wizard.subtitle1-1":`Personalizar`,
"pagecreator_page_message_save_fail":`Se frascasó en guardar la página`,
"label.lastset":`Finalmente de acuerdo con`,
"label.version.support.limited":`Soporte limitado`,
"vue_label_homepage_kanban":`Kanban`,
"label.layout.editsearchdistribute":`Editar el dise?o de búsqueda`,
"template.dashboard.customer.analysis":`Análisis de cuentas`,
"label.continue_editing":`Seguir editando`,
"label.version.sum.customtab":`Menú(s) personalizado(s)`,
"label.validate.function.funcExplain.TIMEVALUE":`Devuelve el valor de la hora del campo fecha/tiempo (hora, minuto, segundo)`,
"label.import.page1.selectobjfromdata":`Seleccionar el objeto para importar datos`,
"label.partnerCloud.basicSetting.success":`Inicializar con éxito`,
"label.customfields.fielddependency.cannotcreat":`El campo que seleccione depende directamente o indirectamente de sí mismo, por lo que no puede crear una dependencia.`,
"label.umeng.activity.youhaveatask":`Tiene una tarea nueva`,
"label.file.folder.create":`Nueva Carpeta`,
"vue_label_campaign_member_status":`Estado del miembro`,
"lable.opppdt.addpdt.table.date":`Fecha`,
"label_partner_workspace_login_buttontext":`Botón de textos`,
"label_other_mistakes":`Otros errores`,
"label.must.be.configured":`Configuración obligatoria`,
"label.customize.memory.function.sorting.enable":`Activar la memoria de la clasificación de cabecera`,
"setup.layout.label.areaname":`Nombre del área`,
"label_chatter_pastThirtyday":`Los últimos 30 días`,
"setup_mainpage_label_welcome25":`Instrucciones: Haga clic en el menú ubicado a la izquierda de la página →Configuración de gestión → Control de Seguridad→ Compartir configuración`,
"label.ccchat.person.invite.succsend":`Una invitación para unirse al CCChatter es enviado a`,
"label.select.time.range":`Por favor, elija el rango de tiempo`,
"label.partnerCloud.orderingPlatform.djustQuantity":`Añade productos a la cesta, donde puedes ajustar la cantidad y ver el precio.`,
"label.manageAll.sta1":`Pendiente`,
"label.cy.select":`Seleccione una nueva moneda de la lista disponible`,
"chatter.lam":`Comentario`,
"label.partner.setup.title":`Configurar`,
"component.setup.label.displaybutton":`Botón de visualización`,
"component.salesperformance.label.target":`Objetivo`,
"label.campagin.channel":`Ingrese el valor de canal`,
"label.validate.function.funcFormat.ISCHANGED":`ISCHANGED(campo)`,
"UG.homepage.009":`Acceder al CRM`,
"label.file.item":`Proyecto`,
"label.file.library.addmembprompt":`Los siguientes ya son miembros.`,
"label.bmap.releasePosition":`Localidad`,
"setup_object_layout_label_selectedprofile":`Perfiles seleccionados`,
"label_emailsync_message":`Indicación`,
"label.view_submissions":`Ver los envíos`,
"lable.tianyancha.repeated":`Selección duplicada`,
"label.import.index.introduce":`Importe sus datos al sistema en tres sencillos pasos`,
"label.time.operation.new":`Crear nuevo trabajo programado`,
"label.projectManagement.Pleaseentersettlementtype":`Introduzca el tipo de liquidación`,
"label.icon.169":`Auto Turístico`,
"vue_label_commonobjects_detail_related_listview":`Mostrar lista`,
"label.view.step1":`Paso 1. Ingrese el nombre de vista`,
"label.summaryreport.intro":`Los reportes de resumen muestran tanto dato subtotal e información de otro resumen`,
"vue_label_file_input_correct_name":`Introduzca el nombre correcto`,
"System_Email_Template_Title":`Bienvenido a CRM de CloudCC`,
"label.tianyancha.province":`Abreviación de provincia`,
"label.deleteall.sure":`?Está seguro de que quiere cancelar todo?`,
"label.passwordPolicy.setup.uppercasealpandnum":`Debe contener números, mayúscula y minúscula`,
"front-lightning-module-v1-details-page-chart-select":`Elija el objeto y la pantalla`,
"setup_mainpage_label_welcome8":`Personalización de la interfaz de Arrastrar y saltar`,
"lable.outlook.edit.lastupc":`Contactos recientemente actualizados`,
"label.weixin.registered":`Registrarse`,
"vue_label_file_history_version":`Versión histórica`,
"vue_label_campaign_earned":`Cantidad por ingresar`,
"label.staticresource.useful.realtion.tip":`A continuación se muestra una lista de todas las referencias de páginas de CloudCC.com a este recurso estático.`,
"vue_label_file_libraray":`Biblioteca`,
"label.department.phone":`Número de teléfono móvil`,
"label.emailtemplate.edit":`Editar plantilla de correo`,
"label.processsetting.key.information.tips":`Información clave y microposts`,
"label.summaryreport.step7":`Paso 7: Seleccione tipo de gráfico y los informes destacados`,
"label.chat.topic.remove.favorite":`Eliminar de Favoritos`,
"label.campagin.roi.ksrq":`Fecha de inicio`,
"label.data.downpage.e_title.e_btn":`Vaya a la página de exportación y empiece a exportar`,
"label.approvaldatamove.dname":`Aprobador actual`,
"lable.Partial.attributes":`Atributo parcial`,
"template.report.enabled.products":`Productos activados`,
"lable.outlook.detail.cto":`CloudCC.com a Exchange`,
"label.sendemail.activity.newtasktitle":`Notificación de nuevas tareas`,
"label.validate.function.funcFormat.DAY":`D?A(Fecha)`,
"label.log.datetime.value":`?Ingrese el tiempo de consulta`,
"label.import.index.updaterecord":`Actualizar registro`,
"label.registration.page.invitation":`Invitación a la página de registro`,
"pagecreator_systemstyle_label_detailcolor":`Color del texto detallado`,
"label.tabname.cannot.empty":`?El nombre no puede estar vacío!`,
"label.data.newtemplate.savetemp":`Puede guardar como plantilla y utilizar los campos y criterios de la exportación de datos como plantilla. Ingrese atentamente el nombre de plantilla y descripción para facilitar el uso en el futuro.`,
"label.ems.body":`Cuerpo`,
"enc":`Texto encriptado(Almacenamiento cifrado)`,
"label.profile.mobile.setup.commonSaler":`Ventas generales`,
"label.continueselectproduct":`Continúe la selección de productos`,
"label.event.new":`Nuevo evento`,
"label.renametabandtaglib":`Renombre el menú y la etiqueta`,
"label.qrcodelogin.message.exception":`Servidor anormal, contacte con el administrador`,
"label.service.gantt.locationToGantt":`Diagrama de Gantt`,
"label.mr.theLastGroup":`Es el último grupo. Haga clic en ¨Regresar a ver la lista de datos duplicados¨ para ver los datos repetidos.`,
"label.report.export.format.content":`Exportar la cabecera, los grupos y los detalles del informe actual. Exportar el máximo de detalles`,
"label.version.accountandcontact":`Clientes y contactos`,
"label.partnerCloud.financeSetting.enterMd5Key":`Por favor, introduzca la clave secreta del MDS.`,
"label.login.access.quater":`Semana`,
"vue_label_commonobjects_view_searchthisview":`Buscar esta lista`,
"label.import.step1.allobj":`Todos los objetos`,
"front-efficient-project-management":`Project Cloud ofrece una gestión completa del ciclo de vida del proyecto, desde el inicio, la planificación, la ejecución y el control hasta el cierre, optimizando el proceso de gestión de proyectos según las necesidades de su empresa y ayudándole a gestionar los proyectos de forma eficiente.`,
"label.includedvalue":`Valores incluidos`,
"label.service.newBuildDialog.past.days":`Días pasados`,
"vue_label_report_sortup":`Ordenar de forma ascendente`,
"label.appointment.wizard.subtitle3-2":`Martes`,
"label.dashboard.trend":`Tendencia`,
"label.schedulejob.setup.schedule.st2":`El segundo`,
"label.view.sortview.number":`Número de registros`,
"lable.Please.enable.order":`El pedido no está activado, por favor, actívelo.`,
"label.datamanage.immediately.import":`Importar`,
"label.delete.condition":`Limpiar`,
"label.dashboard.chooseDispalyOnTheHomePage":`Seleccione la página oficial para mostrar`,
"asset.accountid.contactid.required":`Cada activo debe estar asociado a un cliente o contacto`,
"label.mask.character":`Caracter de máscara`,
"lable.account.Previous.FY":`El a?o fiscal anterior`,
"chatter.attachment":`Añadir archivos`,
"label.view_only":`Ver sólo`,
"label.tianyancha.name":`Nombre de compa?ía`,
"label.service.gantt.avg.traveltime":`Tiempo medio de viaje de las citas de servicio`,
"vue_label_pool_move":`Mover`,
"label.import.index.beforeexport":`2. Antes de importar, asegúrese de importar todos los registros relacionados. Por ejemplo, si está importando registros de contacto y quiere rellenar el campo del cliente, que es un campo de búsqueda, necesita crear primero el registro del cliente que está rellenando, luego importar el registro de contacto y rellenar el campo del cliente con el nombre o el ID del cliente correspondiente.`,
"label.view.delete":`Eliminar`,
"template.detail.info.link":`Enlace de detalles`,
"label.sendemail.send.setfail":`La configuración de información de correo se frascasó, configure correctamente información de correo`,
"label_emailtocloudcc_redmessage11":`Autenticación de SMTP fallida. Por favor, compruebe que la dirección de correo electrónico y la contraseña son correctas.`,
"label.campaigns.memberalert":`Seleccione por lo menos un miembro`,
"label.schedulejob.setup.schedule.frequency":`Frecuencia`,
"component.newrecords.label.all":`Ver todo`,
"label.mr.caption.opportunity":`Encontrar duplicados y fusionar: Criterios para buscar duplicados de oportunidades`,
"chatter.group.onlyMembers":`Sólo los miembros pueden ver este grupo. Los miembros del grupo tienen derecho para a?adir los miembros del grupo.`,
"label.recordtype.edit.selectvalue.show":`Los valores de la lista de opción se muestran en orden guardado`,
"message.textmaxlength":`La longitud no puede exceder a 255 caracteres`,
"label.reportsSubscriptionPage.visibility":`Operar el informe según la vista de los siguientes usuarios`,
"label.umeng.chatter.addcoments":`Tiene una respuesta en su publicación de nube`,
"chatter.up.f":`Carga fallada, error desconocido.`,
"label.icon.146":`Teclado`,
"lable.custom.CY.Ago":`2 años personalizados antes`,
"label.tabpage.step3":`Paso 3: Seleccione los campos a mostrar`,
"label.checkfield.introduce":`Configurar los campos de objeto que se pueden utlizar para revisar las repeticiones, y encontrarlas en la lista de registros de acuerdo con lo que configurado`,
"label.tag.addtags":`Añadir etiqueta`,
"label.service.newBuildDialog.characterlimit":`El nombre tiene más de 25 caracteres`,
"font-evaluate-module-v1-evquestions":`Pregunta de evaluación`,
"label.knowledge.only.update.draft":`Sólo se actualiza el borrador`,
"label.partnerCloud.basicSetting.defaultCounts":`Número de funciones por defecto para añadir una cuenta de socio`,
"label.chat.topic.delete":`Eliminar`,
"label.workflow.contentcondition":`Los criterios están satisfechos`,
"vue_label_commonobjects_view_sortby":`Ordenar por {field}`,
"label.passwordPolicy.setup.pwdremember24":`Recordar (0) contraseña`,
"front-kefu-moudle-free-account":`Cuenta de prueba`,
"label.marketsea.isautorecycle":`Activar reciclaje automático`,
"label.addattachment.view":`Ver archivos`,
"vue_label_helpcenter_contact":`En la información detallada, haga clic en el botón de diagrama de árbol junto al contacto, puede ver y entender el diagrama de jerarquía de los contactos y ver parte de información de campo de cada contacto.`,
"label.taskevent":`Eventos de tarea`,
"label.industrialandcommercialverification.message":`Las consultas gratis de hoy está agotada`,
"label.object.already.delete":`El objeto se ha cancelado`,
"label.project.hit.four":`Aviso de actualización de la subtarea`,
"label.taskpagelayout":`Dise?o de la página de tareas`,
"label.version.sum.locationfield":`Campos geográficos`,
"front-sales-button-toQB":`Sincronización con QuickBooks`,
"label.app.oceanblue":`Azuel océano`,
"label.operating":`Operando...`,
"label.customfields.formula.dateexample":`Reminder Date(Fecha de recordatorio) = CloseDate - 7`,
"label.happen_delete":`¿Qué pasa si borro un formulario?`,
"label.service.appointmentList.plansToStart":`Comienzo del plan`,
"label.persmets.operate.licence":`Permiso`,
"label.mobile.quickcreate.default.activities":`Calendario`,
"label.australian.eastem.standard.time":`Hora de Verano de Este`,
"label.emailobject.remove":`REMOVER`,
"label.weixin.vote":`Votar`,
"label.reportsSubscriptionPage.condition.aggregate":`Total`,
"front-kefu-moudle-has-unbind":`Has sido desatado`,
"chatter.group.newGroup":`Nuevo grupo`,
"label.tabpage.systems":`Hay en total * sistemas`,
"label.textmessage.vonage.connect":`Conéctate a Vonage`,
"label.campaign.channel.input.ticket":`Enviar billete de entrada`,
"label.ccpeak.query.sharetab":`Buscar el informe de compartido`,
"label.reporttype":`Origen de datos de informe`,
"message.duplication.label.isprofiletip":`Si marque, el dato que los usuarios actuales pueden ver será verificado al encontrar los duplicados. O, verificará todos los datos.`,
"label.tianyancha.businessverify.xieyi":`Acuerdo de licencia de usuarios CloudCC`,
"font-evaluate-module-v1-select-person":`Seleccione el personal de atención al cliente`,
"vue_label_chatter_all_groups":`Todos los grupos`,
"label.recordtype.profile.setdefault":`Configurar predeterminado`,
"label.mr.descreption.nocondition":`No hay datos duplicados que cumplen con los requisitos.`,
"label.tabpage.askz":`¿Qué le gustaría preguntar?`,
"label.marketsea.selectMember":`Seleccione miembro`,
"template.report.stage.possibility.analysis":`Análisis de las posibilidades de la etapa`,
"label.data.selectderivedobject":`Seleccione objeto para exportar`,
"label.customfields.formula.explain":`Descripción: actualmente admite el número, el porcentaje y otros campos de los cuatro principios, así como los valores de acarreo del campo de búsqueda. Por ejemplo: número calcular: unit*unitprice&nbsp;&nbsp;&nbsp;&nbsp; valor de acarreo del campo de búsqueda:contact__r.address`,
"vue_label_notice_change_fail":`Cambio fallido`,
"label.customobjects.trackoldandnewvalues":`Seguir los valores antiguos y nuevos`,
"label.h5.leftprompt":`?Tiene contenidos editados para enviar, está seguro de que quiere salir?`,
"label.select.field":`Campos disponibles`,
"label.customobjects.layoutedit":`Asignación del dise?o de página`,
"label.false":`Falso`,
"UG_Forcast_07":`Permitir pronóstico`,
"vue_label_chatter_team_member":`Miembro del grupo`,
"label.tabpage.retypez":`Cuando se cambie el tipo del registro, los valores de la lista de opciones existentes no se modificarán automáticamente. Se recomienda actualizar el valor de la lista de opciones existentes del registro en el mismo lugar.`,
"front-epwechat-module-v1-single-desc":`Single Sign On otros extremos de CloudCC a través de WeCom; Swift switch entre todos los extremos.`,
"label.closeandconverted":`Convertido-cerrado`,
"label.service.confirmed":`Confirmado`,
"label.partner.workspace.member.cloudcc":`Perfil de CloudCC`,
"label.star.click":`Haga clic para resetear`,
"label.icon.135":`Moneda`,
"button_partner_workspace_login_logo_upload":`Subir imagen`,
"message.error.sql.constraint.recordnotsingle":`?Error al configurar ID externo! Razón: Hay datos duplicados en el campo original de datos`,
"label.ccchat.person.invite.errorpwd":`Utilice por lo menos 8 caracteres y incluye la combinación de números y caracteres`,
"label_tabpage_isdeleterecord":`Si cancela el registro seleccionado`,
"label.weixin.prompt.message":`Mensaje`,
"vue_label_chatter_view_original_post":`Ver el post original`,
"label.multilingual.tip3":`La activación del multilingüismo permite a cada usuario de la organización configurar los idiomas que haya habilitado.`,
"label.dataimport.error.datetime":`Error: El formato de datos y hora es incorrecto`,
"label_tabpage_addcondition":`Añadir condición`,
"label.query.detail.manageexcludeuser":`Gestionar usuario external`,
"label.tianyancha.creditcode":`Código social de crédito uniforme`,
"label.cy.enter":`Ingrese la tasa de conversión entre la moneda de su empresa y esta moneda nueva`,
"label.textmessage.vonage.message1":`Al integrarse con Vonage, los usuarios pueden enviar y recibir mensajes de texto en CloudCC Platform a través de Vonage. Sin embargo, los usuarios deben registrar cuentas de Vonage y comprar números de teléfono antes de poder enviar mensajes de texto.`,
"front-marketing-module-v1-share-invitation":`Compartir la invitación al personal`,
"label.file.items":`ítem(s)`,
"label.otherwise":`De lo contrario`,
"label.permission.detail.system":`Sistema`,
"message.success.task.emailsend":`Información de correos enviados guardada con éxito`,
"label.the.reward.group":`Grupo de fila de oferta`,
"setup.layout.label.relatedlistsetup":`Configuración de la lista relacionada`,
"label.empty":`Vaciar`,
"label.weixin.cloudcc.user.binding":`Vincular al usuario de CloudCC`,
"label.file.what.change":`?Qué ha cambiado?(Opcional)`,
"label.search":`Buscar`,
"label.mobile":`Móvil`,
"template.report.month.potential.customer":`Los líderes de este mes`,
"lable.setup.mobilesetup.isEnableValidationRulesForScan":`¿Habilitar las reglas de verificación del escaneo de tarjeta?`,
"lable.outlook.list.des":`La configuración de Exchange Sync define la configuración para que CloudCC for Exchange se aplique a un grupo de usuarios específico.`,
"label.appupload.install.error.info":`{0} "{1}" se ha utilizado por {2}, por favor renombre {0} actual.`,
"label.tabpage.addoptionsz":`Añadir opciones`,
"label.arabian.standard.time":`Hora estándar de Arabia`,
"label.thefirst":`La primera columna`,
"label_partner_workspace_login_footertext":`Texto de pie de página`,
"lable.Disabled.successfully":`Desactivar con éxito.`,
"label.confirm.del":`Los registros están en el proceso de aprobación, ?Está seguro de que quiere cancelarlo?`,
"vue_label_normal_reregister":`Reiniciar sesión`,
"label_file_img":`Imagen`,
"label.salescloud.salesdashboard.sales.behavior":`Comportamientos de ventas`,
"label.startdate":`Fecha de inicio`,
"label.field.duplicate.error.msg5":`Revise todos los errores siguientes, intente de nueve después de la modificación.`,
"setup.main2018.label.managesetup":`Ajustes de gestión`,
"label.forecast.editshrepage.title":`Compartido nuevo`,
"UG.solution.01":`Aportar solución`,
"label.knowledgebase.data.recovery.successfully":`Recuperar datos {a} con éxito`,
"label.pc.ui.2018.myccchat":`Mi CCChatter`,
"label.attachement":`Notas y adjuntos`,
"message.mobilechooseatmostten":`Seleccione hasta 10 campos`,
"label.campagin.roi.bhzeywjh":`Oportunidades totales`,
"label.autoresponserule":`Regla de respuesta automática`,
"label.attendance.yuyue":`?No tiene reserva, se registra ahor?`,
"label.insert":`Insertar`,
"label.service.ganttBaiduMap.shutDown":`¿Está seguro de querer cerrar?`,
"label.icon.194":`Televisión`,
"message.serviceterritory.violation":`Violación de zona: la zona de recursos no coincide con la zona de servicio de la cita`,
"label.appointment.disable.function":`Desactivar función`,
"lable.currencyManage.manageexchangeRate.dis":`Para gestionar las tasas de cambio vencidas de su organización, haga clic en ¨Gestionar tasa de cambio vencida¨. La tasa de cambio vencida se utiliza en las oportunidades, productos de oportunidad y los informes asociados con estos dos objetos.`,
"vue_label_file_upload_tip_newmsg":`Se recomienda subir archivos menor de {size}MB, ya que de lo contrario la carga puede resultar demasiada lenta`,
"label.event.next.week":`Próxima semana`,
"label.datamanage.import.contactfield":`En la siguiente tabla, seleccione los campos en el archivo importado que deben importarse a cada contracto. Luego haga clic en el siguiente:`,
"label.projectManagement.time.allocated":`Tiempo asignado`,
"label_tabpage_isdeleteview":`?Está seguro de cancelar esta imagen?`,
"label.pc.ui.2018.search":`Ingrese los contenidos de búsqueda`,
"label.role.createrolelevel":`Crear la jerarquía de rol`,
"label.tabpage.editview":`Editar vista`,
"label_partner_common_manageSetup":`Gestión administrativa de nube de socios`,
"label.service.gantt.noservice.resource":`No se han encontrado recursos de servicio disponibles en el territorio de servicio seleccionado`,
"message.numbertoolarge":`El número es demasiado grande`,
"label.sendsms.success":`SMS enviado con éxito`,
"UG.opportunity.009":`o`,
"label.ccpeak.construction.dataobj":`Para establecer un objeto de datos, se requiere pasar el nombre de API:`,
"front-lighting-module-v1-detail-file-uploadInfo":`El registro está bloqueado y no está disponible para subir archivos. Por favor, póngase en contacto con el administrador para desbloquearlo.`,
"label.import.page2.newnotmatchfiled":`En total hay {{ csvfiledlength }} campos en el archivo, quedan {{this.csvfiledlength - this.selectlength}} sin asignar`,
"label.ems.inputmailss":`Servidor para recibir correos`,
"label.knowledgebase.data.published.successfully":`Publicar {a} datos con éxito`,
"label_emailtocloudcc_position":`Posición`,
"label.data.exp.customexp":`Exportación personalizada`,
"component_chatter_post_button_user":`Añadir membrete`,
"label.new.visualpagefolder":`Página personalizada: Crear carpeta`,
"label.forecast.shrepage.classdes":`Descripción de los niveles de acceso`,
"label.task.overdue.unfinished":`Tarea sin procesar vencidas`,
"label.ccchat.micropost.isedit.setting.info":`El autor de la publicación o comentario, propietario de registro, moderador de CCChatter y de esta comunidad  tienen permiso para modificar este texto.`,
"label.recordname":`Nombre de registro`,
"label.posted_your":`y publicado en su`,
"label.globaloperation.operationtype.custom.page":`Página personalizada`,
"label_tabpage_busoppnamez":`Oportunidad`,
"front-epwechat-module-v1-schedule-desc":`Sincronizar los horarios de WeCom y los eventos de CloudCC`,
"label.escalation.setup.newentries.lastmodifydate":`Basado en la hora de la última modificación`,
"setup_layout_label_nofield":`No hay campos disponibles`,
"label.sendemail.registIMUser.logininfo":`El portal de la nube de socios en el que puede iniciar sesión es el siguiente: <br>`,
"label.weixin..xsld.kehu":`Clientes`,
"label.display_thank":`Mostrar página de agradecimiento`,
"label.group.no.my.group":`No coincide con mi grupo`,
"label.partnerCloud.newBuildSite.enterDomain":`Por favor, introduzca el nombre del dominio`,
"label.step1.total2":`Pasa 1 de 2`,
"label.ccpeak.delete.record":`Cancelar registros:`,
"label.customer.tab.step1.introduce":`Seleccione el objeto personalizado para este menú personalizado. Rellene otros detalles.`,
"label_tabpage_newInterfacez":`Nueva Interfaz`,
"setup.mainpage.label.manageuser":`Gestionar usuarios`,
"label.partnerCloud.partnerAccount.completed":`¿Pago completado?`,
"label.projectManagement.kanban":`Kanban de tareas`,
"label.operate":`Operación`,
"label.service.dispatchingUnits.selected.time.range":`Mostrar las citas de servicio dentro del rango de tiempo seleccionado`,
"component_setup_label_pagesize":`?tems mostrados en cada página`,
"font-evaluate-module-v1-email-evaluation-settings":`Configuración de la evaluación del correo electrónico`,
"label.service.dispatchingUnits.skills":`Habilidad`,
"label.editrecurrencetimetrigger":`Editar el trigger del tiempo periódico`,
"vue_label_file_edit_lib":`Editar biblioteca de archivos`,
"label.campaignmember.selectmember.deleteconc":`Campa?a: Eliminar miembros de los contactos`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.monday":`Lunes`,
"front-detail-module-v1-by":`por`,
"label.mobile.home.page.date.signed":`Fecha cerrada`,
"label.apply.send.success":`?Envío exitoso!`,
"label.app.choseimg":`Seleccione logo`,
"label.customsetting.visible":`Visibilidad`,
"label.sendemail.activity.task.distributetaskcompleted":`La tarea asignada a #belongtoidccname ha completado.`,
"label.dashboard.snapshot.refreshing":`Refrescando`,
"label.document.name.already.exists":`?El nombre único del documento ya existe!`,
"label.ccchat.person.invite.needlastname":`Ingrese su apellido`,
"pagecreator_page_button_copy":`Copiar`,
"label.appointmentpage.wizard.subtitle1-2":`La semana pasada`,
"label.validate.function.funcFormat.MILLISECOND":`MILLISECOND(date)`,
"label.profile.allowtocreateview":`Crear vistas`,
"message.error.recordid":`El id del registro no puede estar vacío`,
"lable.SalesCommitmentKanBan.returnToTheSuperiorRole":`Regrese al rol superior`,
"label.translation.start3":`Si es necesario, seleccione un objeto. Por ejemplo, la tarea del flujo de trabajo tiene un objeto(Cuenta, contacto, etc.) para filtrar ítems de traducción.`,
"label.ccpeak.send.email":`Notificación via correo:`,
"vue_label_commonobjects_detail_activity_noexpirationdate":`Sin fecha de expiración`,
"label.permission.objectpermission.objpermission":`Configuración de los permisos de los objetos`,
"label.version.custom.report":`Informes Estándar (Página personalizada)`,
"label.title.qrcodeOrbarcode":`Generar código de barras/código QR`,
"label.emailtocloudcc.step2.name":`Configurar la propiedad del correo`,
"label.reportsSubscription.edited.successfully":`Suscripción de informe editado con éxito`,
"label_tabpage_kanbansetup":`Configuración del tablero`,
"label.tianyancha.regcapital":`Capital de registro`,
"front-epwechat-module-v1-web-single":`Inicio de sesión único en la web:`,
"label.visualpage.display.top":`Mostrar encabezado, false-no mostrar encabezado`,
"label.customfields.fielddependency.selectcell":`Seleccione por lo menos una celda de la lista siguiente`,
"label.paging.addmember.totalofpages":`Un total de {0} ítem(s)`,
"label.email.saveing":`Guardando datos...`,
"label.userinfo.doublepwd.notnull":`Debe repetir la contrase?a`,
"label.appointment.wizard.subtitle4-4-2":`2 Semanas`,
"label.chatter.BCC":`CCO`,
"label.emailtocloudcc.description":`Añada aquí su correo electrónico empresarial como sales@company.com, info@company.com, support@company.com y el sistema generará automáticamente clientes potenciales o registros de casos según los correos recibidos para garantizar el seguimiento oportuno de los correos de los clientes.`,
"label.sendemail.send.atlastone":`Debe selecionar un destinatario al menos`,
"label.mobile.phone.subordinate":`Si incluye subordinados`,
"label.data.choses.e_desc":`De acuerdo con sus requisitos, puede opcionar por exportar todos los datos o los datos de un objeto.`,
"chatter.new":`Noticias`,
"vue_label_help_back":`Atrás`,
"label.skipwizardintro":`El Jump Start Wizard le creará un proceso de aprobación de un paso en unos minutos.`,
"label.weixin.fmu.before.week":`{0} semana(s) con antelación`,
"label.sendemail.chat.praiseFeedsubject":`A CloudCC CCChatter le gusta su publicación`,
"lable.currencyAdv.andafterdate":`Y la fecha despúes de`,
"label.sometoprocess":`Si solo ciertos tipos de registros pueden ingresar a este proceso de aprobación, ingrese los criterios a continuación, por ejemplo, solo los informes de gastos de los empleados de la sede oficial pueden usar este proceso de aprobación.`,
"label.campaignmember.main.updateleaddesc":`Actualizar el status de todos los candidatos de una sola vez`,
"label_partner_common_roleSetup":`Rol de nube de socios y configuración de usuario`,
"label.console.step5.no":`Seleccione como mostrar los registros`,
"label.salescloud.teamrole.optionlist.account":`Añadir un miembro del equipo de la cuenta a`,
"Report.Delete.Confirm.Title":`Por favor, confirme`,
"label.onclick":`Haga clic en`,
"label.weixin.input.identifying.code":`Ingrese el código de verificaión`,
"label.knowledge.translate":`Solo se puede traducir el artículo de conocimiento de la edición principal en estado de Borrador o Publicado`,
"label.log.ip":`IP`,
"front-electronic-export-goResult":`Comprobar en Mailchimp`,
"label.escalation.setup.newaction.otheremail.otheremail":`Correos adicionales`,
"label.icon.104":`Calendario`,
"label.partnerCloud.exceedTwo":`La foto de perfil cargada no puede superar los 2 MB.`,
"label_tabpage_thevalurofz":`El valor de`,
"front-lightning-module-v1-details-page-chart-maximum":`Se pueden introducir hasta 50 caracteres.`,
"label.data.downpage.i.title.num6":`Se recomienda importar un archivo de prueba que contenga 5 registros antes de importar los datos para asegurarse de que los datos que se quieren importar son correctos.`,
"label.ccpeak.update.record":`Modificar registros:`,
"label.dataimportandexport":`Importación y Exportación de datos`,
"label.tabpage.notexceed25":`Los registros seleccionados no deben superar de 25`,
"label.starting":`En el proceso`,
"label.knowledge.language.spanish":`Español`,
"label_emailtocloudcc_set":`Configure información del correo`,
"message.oneormoreneedsreport":`El panel utiliza este informe. Cancele primero el panel de componentes de este informe, y intente de nuevo.`,
"label.attendance.xccheckin":`Firmar`,
"label.emailmerge.editfolder.title":`Carpetas de plantilla para fusionar correos`,
"template.report.year.customer":`Líderes de este año`,
"label.partner.common.webSit.memo":`El nombre de dominio predeterminado de la nube de socio de su organización es:`,
"label.partnerCloud.financeSetting.onlinePayment":`Pago en línea`,
"Pagelayout.Setup.001":`Seleccione las listas relacionadas que quiera mostrar en el diseño de página flotante.`,
"front-kefu-moudle-time-length":`Duración`,
"label.deleteObject":`El objeto se ha cancelado.`,
"label.setup.mobile.homepageshortcuts.select":`Seleccione 4 funciones rápidas para mostrar en la parte superior de  la página oficial`,
"setup.mainpage.label.welcome26":`Gestión de datos - Procesamiento por lotes`,
"label.ServiceCloud.yuyuebainhao":`Número de cita de servicio`,
"label.emailobject.emaildetail.button.addtolead":`Añadir a los candidatos`,
"label.event.single.view":`Vista individual`,
"lable.product.pricebooks.ustand":`Elija el precio estándar`,
"label.emailtocloudcc.department":`Departamento`,
"component_assistant_label_30daysnoact":`30 días no activos`,
"label.weixin.no.pending.qzkh.qin":`Lo sentimos, ahora no hay datos de los candidatos `,
"label.vlidaterule.formula":`Error de las condiciones de fórmula`,
"label.tianyancha.h5.contact":`Información de contacto`,
"label.button":`Botones`,
"message.checkemail":`<strong>Error:</strong> Se ocurrió error al ingresar correo, revise.`,
"lable.account.previous.CY":`A?o calendario anterior`,
"label.icon.13":`Servicio`,
"chatter.coll.c":`Remover de marcadores`,
"label.knowledge.category.hint.four":`Asignación de categorías de datos`,
"label.tianyancha.phonenumber":`Número de teléfono`,
"label.tablayoutedit.remark":`Seleccione los campos y la página personalizada que se muestren en la página oficial`,
"label.shareusers":`Usuario compartido`,
"label.endtime":`Hora de finalización`,
"label.length":`Longitud`,
"label.umeng.activity.event.begin":`Empezar depués de`,
"label.tabpage.alltabs":`Todas las pestañas`,
"label.exact.query":`Búsqueda precisa`,
"label.weixin.skip":`Saltar a`,
"label.ems.cancel":`Cancelar`,
"label.trigger":`Triggers`,
"label.exchange.sync.setting":`Configuración de Exchange Sync`,
"label.product.pricebooks.name":`Nombre del Libro de Precios`,
"label.relation.list.total":`Seleccionado`,
"label.step2.total7":`Paso 2 de 7`,
"label.martrixreport.2018.step6.new":`Paso 6: Seleccione el tipo de gráfico e ítems destacados`,
"label.standard.buttonandlink.override":`Cubierto`,
"front-console-conversation-btn4":`Separar como nuevo caso`,
"vue_label_dashboard_range":`Rango`,
"label.app.sort.show":`La aplicación se mostrará según orden de guardar`,
"label.salescloud.teamrole.choose.correct":`Se han seleccionado los usuarios duplicados, por favor corrija`,
"label.schedule_post":`Publicar el puesto`,
"front-kefu-moudle-server-request-num":`Lista de solicitudes de servicio nº.`,
"label.h5.logout":`Cerrar la sesión`,
"label.weixin.horse.club.member.message":`Información de miembros Aid-Max`,
"label.field.addoptionlist.introduce":`Ingrese uno o más valores de la lista de opción al siguiente, cada valor deber estar en una línea separada.`,
"setup_layout_label_setupfield":`Configurar propiedades del campo`,
"label.chatter.nextStep":`Siguiente paso`,
"label.quickbooks.searchlist.total1":`Hay {0} registros de factura no vinculada, el monto total es {1}`,
"label.tianyancha.h5.regcapital":`Capital de registro`,
"label.icon.184":`Consultivo`,
"label.dashboard.message.refreshtoomush":`Demasiadas actualizaciones en el cuadro de mandos, por favor, inténtelo más tarde`,
"label.umeng.approval.reject":`#approver ha rechazado la solicitud de #ob`,
"label.h5.chatter.newmessage":`Ingrese un nuevo mensaje`,
"message.error.relationid":`¡relationid no puede estar vacío!`,
"label.setup.mobile.offlinecache.selectdefault":`Seleccione las pesta?as como las pesta?as offline de caché`,
"label.setup.mobile.homepageshortcuts.saveprompt":`Seleccione 4 funciones rápidas`,
"label.projectManagement.Selectmonth":`Seleccione el mes`,
"label.version.ultimate":`Última versión`,
"label.validate.remark5":`Los campos de fecha obligatoria están el orden correcto, por ejemplo: la hora de inicio deber ser menos que la hora de finalización`,
"label.version.nowis":`La versión actual de CloudCC es`,
"front-kefu-moudle-CRM-set":`Configuración de CRM`,
"label.mr.title.customerAddress":`Dirección del cliente`,
"label_emailtocloudcc_step1_name":`Seleccionar función`,
"label.time.operation.edit":`Modificar trabajos programados`,
"label_tabpage_operationz":`Campo, la operación no se puede ser nulo`,
"label.translation.start4":`Haga doble clic en la columna de traducción para ingresar nuevos valores.`,
"vue_label_systemSettings_request":`Solicitud de transferencia de lotes`,
"label.maintenance.notice":`Aviso de mantenimiento`,
"label.customfields.txet.textlength.tip":`Ingrese la longitud máxima del campo de texto al siguiente y la longitud máxima es de 255 caracteres`,
"label.ccdocument.select.template.open":`Seleccione plantilla para abrir`,
"vue_label_display_date_field":`Mostrar campos de fecha`,
"label_partner_workspace_tab":`Menú`,
"lable.account.LasthDays":`Los últimos 120 días`,
"chatter.using.sticker":`Activar el seguimiento de micro publicación`,
"message.save.dataerror":`Error: Error al guardar causado por la longitud de datos u otros problemas. Modifique los datos para guardar de nuevo.`,
"vue_label_commonobjects_view_chart_newchart":`Nuevo gráfico`,
"label.chat.micropost.a.group":`Grupo`,
"lable.currencyManage.advcurrencyunEnabled":`Gestión de moneda avanzada no activada`,
"label.appexchange.workflow":`Regla del flujo de trabajo`,
"vue_label_calendar_show_details_and_add_events":`Mostrar detalles y añadir eventos`,
"label.salescloud.optionlist.inputname":`Ingrese el nombre de valor de la lista de opciones`,
"label.dashboard.folder":`Carpetas`,
"label.knowledgebase.permanently.remove.articles":`La eliminación de un artículo archivado hará que otras versiones relacionadas también se eliminen de forma permanente.`,
"label.emailtocloudcc.titel":`Email to CloudCC`,
"label.visualpage.sel":`Páginas personalizadas en esta carpeta`,
"label.planned.all.work":`Todos los trabajos planeados`,
"label.weixin.agree.agreement":`Acepto los acuerdos relativos`,
"label.forecast.customforecast.qsn":`A?o de inicio`,
"label.appupload.managed":`Controlado`,
"template.report.folder.sale.index":`Análisis de los indicadores de ventas`,
"UG_opportunity_011":`Importar transacción`,
"label.validate.function.funcFormat.SECOND":`SECOND(date)`,
"UG_homepage_005":`Venta inteligente`,
"label.clicktoreturn":`Haga clic en aquí para regresar`,
"label.collectionofview":`Conjunto de vista de`,
"com.cloudcc.login.error.message.nonuser":`Este usuario no existe`,
"vue_label_systemSettings_emailsetting":`Configuración del correo electrónico`,
"vue_label_email_mark_as":`Marcar como`,
"label.tabpage.customernamez":`Cliente`,
"label.appupload.install.apicannotsame":`El nombre de API nuevo no puede ser igual que el valor original`,
"label.task.all.undealt":`Todas las tareas no procesadas`,
"front-lightning-module-v1-dashborad-statistical-indicators":`Índice estadístico`,
"UG.quota.02":`La oferta es un término legal entre un cliente y un proveedor para un producto específico a un precio determinado en un momento determinado.`,
"label.approve":`Aprobar`,
"vue_label_calendar_remove_calendar":`Eliminar calendario`,
"label.mr.title.contactName":`Nombre de contacto`,
"label.projectManagement.resource":`Gestión de recursos`,
"label.rejectbehaviour1":`Permite a los aprobadores seleccionar manualmente y regresar al paso (Regresar al N paso anterior)`,
"label.publicgroup.relationship":`Relación de los miembros del grupo`,
"Lead.Scoring.DetailedPage.Popup.Title":`Percepción del cliente potencial`,
"label.owner.edit":`Propietario de edición`,
"label.campaign.channel.ticket.mark":`Notas: Guarde el código QR al álbum de fotos utilizando la captura de pantalla o guardar el código QR al móvil para que pueda participar en los eventos con el código QR.`,
"label.opportunity.setting.showstage.info":`Si muestra la etapa de oportunidad en la aplicación de CloudCC`,
"label.emailobject.wizard.desc3":`Ahorrar tiempo utilizando plantillas de correo`,
"label.cpq.quote.no.product.add":`No hay productos añadidos en el presupuesto. Por favor, añada el producto antes de generar los pedidos.`,
"label.customer.tab":`Menú personalizado`,
"Opportunity_Detailed_Phase_Label_Popup_002":`Fecha cerrada de la etapa actual`,
"component_telerecord_label_name":`Nombres`,
"label_component_helper_nodata":`Nada necesita su atención en este momento, vuelva a revisar más tarde`,
"label.dashboardSetup.d2":`Punto de interrupción 2`,
"setup.mainpage.label.welcome4":`Instrucciones: Haga clic en el menú de la izquierda de la página → Configuración de la aplicación → Crear → Objeto.`,
"label.step4.total5":`Paso 4 de 5`,
"label.payment.the.remaining.days":`Su licencia expira en {0}días`,
"label.encoding":`Codificando`,
"label.setting.intergrationlist.status2":`La integración está instalada.`,
"label.new":`Nuevo`,
"label.search.searchsetup":`Buscar configuración`,
"label_tabpage_printz":`Imprimir`,
"report.type.label.customService":`Asistencia al cliente`,
"label.notification.addEmailObject.message":`Ha recibido un correo de {!fromaddress}, haga clic para verlo`,
"label.icon.68":`Máquina`,
"UG.Lead.003":`Interacción social`,
"label_mobile_default_field_service_home":`Página principal de Nube de Servicio`,
"label.select.one.group":`Por favor, elija al menos un grupo de líneas de cotización.`,
"front-kefu-moudle-trkey-nopower":`El par de claves de Tianrun no tiene permisos asignados`,
"label.chatter.cancel":`Cancelar`,
"label.weixin.report.optiondisplay":`Mostrar`,
"front-kefu-moudle-v1-System-version":`Versión del sistema:`,
"lable.product.pricebooks.editall":`Editar todo`,
"label.group.no.recent3":`O`,
"label.knowledge.article.delete":`Error al borrar el artículo de conocimiento`,
"label.relateobj":`Relacionado con`,
"workflow.action.tasks.assignortype.type":`Tipo`,
"label.layout.selectedfields":`Seleccione campos`,
"label.role.assign.operate":`Asignar otros usuarios a este rol: <ul><li>Seleccione de la lista desplegable para mostrar los usuarios disponibles. </li><li>Seleccione un usuario de la izquierda y agréguelo a la lista de ¨Usuarios seleccionados¨<b>.</li></ul>`,
"label.field.insert":`Insertar los campos`,
"label.icon.11":`Personas`,
"label.group.no.recent4":`Crear un grupo`,
"front-epwechat-module-v1-input-corpid":`Por favor, introduzca Corpld`,
"setup_object_field_dependency_label_actionfieldnotnull":`Seleccione un valor del campo de control para configurar`,
"setup.mainpage.label.welcome19":`Instrucciones:  Haga clic en el menú de la izquierda de esta página → Gestionar configuración → Gestionar usuarios → Usuarios, roles, perfiles`,
"label.escalation.setup.list.rulename":`Nombre de regla`,
"label.ems.addaccount":`Añadir cuenta ahora`,
"label.reportsSubscription.details.only":`Sólo detalles (formato Excel .xlsx)`,
"vue_label_commonobjects_view_groupby":`Criterio de grupo`,
"label.email.form.text":`Texto solo`,
"label.weixin.loginname":`Nombre de login`,
"label.forecast.settings.sr":`Ingresos`,
"label.chatter.sendEmailToGroupMember.subject.F":`{0} puestos publicados para todos en {1}`,
"label.ccchat.enter.subject":`Rellene el subjeto del voto`,
"label.customer.tab.introduce":`La apariencia y función del menú de objetos personalizados son similares al menú estándar proporcionado por CloudCC`,
"message.login.mfaverification.wrong":`?Error del código de seguridad!`,
"component.newrecords.label.name":`Nombre`,
"label.salescloud.opportunity.addandedit.contactrole":`Añadir y editar los roles de contacto`,
"label_emailtocloudcc_button_next":`Siguiente paso`,
"label.console.step5":`Paso 5. Seleccione como se muestran los registros`,
"setup.main2018.label.norole":`No tiene los permisos de gestión del sistema correspondientes`,
"template.chart.ywjhqd":`Etapa de la oportunidad de negocio`,
"label.instrumentPanel.breakpointOneLabelname":`Este valor debe ser mayor que el valor mínimo`,
"label.qrcode":`Código QR`,
"label_tabpage_no2z":`No2`,
"label.log.search.date.range":`El ciclo de búsqueda no puede ser mayor que {c} meses.`,
"label.console.step7":`Paso 7. Asignar Perfil`,
"label.australian.central.standard.time":`Hora Estándar Central(Territorio del norte)`,
"label_tabpage_deleteviewfailed":`Se frascasó en cancelar la vista`,
"vue_label_commonobjects_view_searchview":`Buscar en esta vista`,
"message.error.object.notexists":`El objeto no existe`,
"label.tablecell":`Casillas`,
"vue_label_notice_edit_success":`Editado con éxito`,
"label.customer.language":`Idioma por defecto`,
"label.csrf":`Activar la protección de seguridad csrf`,
"label.forecast.customforecast.submit.zhi":`a`,
"label.sso.saml.idp.config.desc2":`Haga clic en activar Proveedor de Identidad para activar la organización CloudCC.com como proveedor de identidad.`,
"label.export_data":`Exportación de datos`,
"component.todaytask.label.all":`Ver todo`,
"label.h5.chatter.record":`Seguir registros`,
"front-vew-email-verification":`Ver el correo electrónico y verificar la cuenta. Sólo puede iniciar sesión después de confirmar el correo electrónico.`,
"laber.marketsea.del.error":`El grupo público está en uso y no puede ser eliminado`,
"vue_label_notice_homepage_entername":`Introduzca el nombre nuevo`,
"UG.Forcast.01":`Previsión`,
"front-email-payment-tips":`El importe de la factura está vacío. Por favor, inicie el pago en línea después de rellenar el importe de la factura.`,
"setup.mainpage.label.welcome2":`Base de datos personalizada (objeto)`,
"APPIntegration.Social.facebookerror":`Debes introducir un URL válido de facebook.com`,
"label.profile.mobile.setup.stand":`Página de inicio estándar`,
"label.custom.CY":`Año personalizado`,
"label.knowledgebase.publishing.conditions":`¡Los datos de Pulish {a} fallaron, están fuera de los criterios de publicación!`,
"label.tianyancha.description":`Activar Tian Yancha para revisar la verificación de datos industrial y comercial. Este servicio es proporcionado por Tian Yancha y permite los datos comerciales registrados en la China Continental`,
"label.appexchange.uninstallpage.title":`Desinstalar el paquete causará:`,
"label.currencyRate":`Tasa de conversión`,
"setup_layout_label_areashow":`Lugar para mostrar nombre de las secciones`,
"label.setup.case.setting":`Miniprograma al caso`,
"vue_label_commonobjects_view_fixed_at_most":`Solo se pueden fijar tres columnas como máximo`,
"template.report.month.income":`Ingresos de este mes`,
"label.sms.companyname":`Nombre de empresa`,
"label.sendemail.registIMUser.waitmessage":`Lo senitmos, no tiene el portal de Nube de  Socios para entrar, espere al aviso del administrador, puede ingresar a la página de login una vez visite a la dirección determinada. Login con el nombre de usuario y contrase?a arriba mencionada.`,
"label.custom.field.task.object":`?Hola! Una tarea le asigna. Subjeto de la tarea:`,
"message.pleaseselectdayinweek":`Seleccione un día de la semana`,
"label.chat.topic.favorites":`Marcadores`,
"UG.Campaign.004":`Importar campaña`,
"label.approval.preview":`Vista previa del proceso`,
"label.knowledgebase.assign.articles.to.people.or.queues":`Elija el idioma de destino y asigne el artículo a la persona en cuestión o a la cola. La exportación de traducciones suele asignarse a una cola, y los artículos traducidos internamente van a una persona.`,
"pagecreator_systemstyle_message_save_success":`El estilo ha sido guardado con éxito`,
"label.outline":`Resumen`,
"label.read.only.field":`Campos de sólo lectura`,
"front-gantt-module-v1-early-warning":`Alerta temprana`,
"label.file.ccchat.selectfrompc":`Seleccione un archivo de su computador`,
"vue_label_systemSettings_social":`Medios de comunicación social`,
"label_report_year_last_year":`Año tras año`,
"lable.PowerProcess.Meet.the.conditions":`Deben cumplirse los siguientes criterios:`,
"label.changemydisplay.list.title":`Cambiar lo que muestra`,
"UG_Forcast_03":`Activar planeación y ejecución de estrategias comerciales.  <br> Te deseo una buena provisión.`,
"label.sendemail.chat.sendmessage":`Estimado #name:\n\n ?Hola! #userName le ha enviado un mensaje.`,
"label.huanxinconfig.secretid.lost":`secretid no puede estar vacío`,
"label.icon.49":`Generación De Energía`,
"chatter.feed.button.publish":`Compartir`,
"label.power":`^Poder`,
"label.partnerCloud.financeSetting.informationThree":`3. Después de entrar en la página de gestión de claves secretas, haga clic en mapi Gateway Product Key, y adquiera el ID de socio y la clave secreta MDS.`,
"label.emailtocloudcc.step1.lead2":`Una vez configurado, los correos recibidos en este correo generarán automáticamente registros de clientes potenciales en CloudCC para asegurar de que no se pierda ninguna oportunidad de negocio.`,
"label.knowledgebase.delete.draft.succeeded":`Borrar el borrador con éxito`,
"label.dashboardSetup.title":`Editor del componente`,
"label.trigger.operation.email.template.map":`Devuelve la información de la plantilla, asunto del correo: m.get("subject"); contenido del correo: m.get("context"); si es del tipo texto: m.get("istext")`,
"label.dependencesearchfilter":`Filtros de la búsqueda relativa`,
"label.selected.search.length":`Los campos de búsqueda seleccionados no pueden exceder 10`,
"label.profile.commonusercontrol":`Permisos de los usuarios generales`,
"lable.Microsoft.YaHei":`Microsoft YaHei`,
"label.appupload.component.type.app":`Aplicaciones`,
"label.customsetting.manage.position":`Localidad`,
"vue_label_systemSettings_bindweb":`Enlazar la web`,
"label.loginservice.license.notexist":`La licencia no existe`,
"label.icon.43":`Campanas`,
"UG_homepage_003":`Vista de 360 grado`,
"label.file_format":`Formato de archivo`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.sunday":`Domingo`,
"vue_label_chatter_post_has_delete":`El post ha sido borrado`,
"report_label_searchresult":`Resultado de búsqueda`,
"label.tabpage.justsz":`Recientemente`,
"Lead_Scoring_Setting_LevelSetting":`Configuración de Popularidad de Candidato`,
"setup.object.field.dependency.label.selectedfieldvalue":`Valor de campo seleccionado`,
"label.search.morelistview":`Más lista de vista`,
"vue_label_homepage_won":`Ganado`,
"label.notification.last30days":`Últimos 30 días`,
"vue_label_helpcenter_pool":`Utilice el grupo público de clientes y de clientes potenciales para gestionar sus datos de ventas.<br>Configurar grupo público <br>Cree el grupo público en segundo plano, configure los administradores y los miembros del grupo público, y configure las reglas de reciclaje automático de los registros vencidos, lo cual es conveniente para gestionar la situación de seguimiento de oportunidades dentro de su equipo y animar a los miembros del equipo a realizar un seguimiento activo.<br> <br> Gestionar manualmente los datos<br> El administrador del grupo público puede realizar operaciones como la asignación, el reciclaje, el descarte y la transferencia de registros en el grupo público, y gestionar los registros en el grupo público de forma unificada;<br> Los miembros del grupo público pueden recibir registros no asignados o ver los registros de los que son responsables.`,
"label.emailsync.status.export":`Exportar como archivo en formato Excel_csv`,
"label.service.miniProgram.slideshowTitle":`Carrusel`,
"label.service.miniProgram.slideshowName":`Nombre del diagrama de carrusel`,
"label.fieldupdate.selectobj":`Definir el objeto asociado con la actualización del campo, luego haga clic en el ¨Siguiente¨. La actualización de campo sólo puede asociarse con las reglas del flujo de trabajo y proceso de aprobación del mismo tipo.`,
"label.ccpeak.take.notice.sharetab":`Nota: Los campos en la expresión del formulario compartido no requiere la adición de "__c".`,
"label.log.startdate.after.endate":`?La hora de inicio no debe ser mayor que la hora de finalización!`,
"label.rememberme":`Recuérdame`,
"label.partner.all.maxNum":`Datos máximos de Nube de socios`,
"component.setup.iframe.label.inputurl":`Introducir la dirección URL`,
"label.h5.systemmessage":`Mensaje del sistema`,
"label.delete.date":`Cancelar la fecha`,
"front-email-payment-select-month-tips":`Por favor, elija MM`,
"front-kefu-moudle-bind-userinfo":`Vincular la información del usuario`,
"label.appointment.wizard.notif2":`Necesite configurar el período de una reserva antes de crearla.`,
"label.custom.field.maping.number":`El número de candidatos no puede exceder el número de campos de mapeo`,
"label.event.dayview":`Vista del día`,
"label.replace":`Reemplazar`,
"label.knowledgebase.search.knowledge.articles":`Búsqueda de artículos de conocimiento`,
"component_event_label_soon":`De inmediato`,
"label.imgfield.upload":`Subir imagen`,
"message.printable.view":`Ver`,
"vue_label_notice_uploadavatar_notice1":`El tamaño de la imagen del icono cargada no puede superar los 2MB`,
"label.visualpage.developer.help":`Ayuda para los desarrolladores de la página personalizada`,
"label.validate.function.funcFormat.IF":`IF(logical_test, value_if_true, value_if_false)`,
"label.sso.saml.sp.description1":`Configuración de inicio de sesión único`,
"vue_label_calendar_step_1":`Paso 1: Nombrar el calendario objetivo`,
"component.telerecord.button.save":`Guardar`,
"setup_mainpage_button_manageobject":`Gestión de objetos`,
"label.marketingactivityinfluence":`Influencia de campa?a`,
"label.quote.bjjsxx":`Información de aceptar la cotización`,
"label.appupload.upload.install.retry":`Reinstalar`,
"label.layout.assignrules":`Reglas de asignación`,
"UG.Lead.006":`Visitante del sitio web`,
"label.workmate.searchs":`Buscar compañero`,
"label.visualpage_list.no":`No tiene permiso para acceder a las páginas personalizadas`,
"label.service.miniProgram.slideshowintroduce":`El nombre del carrusel solo se utiliza para identificar las entradas de los anuncios múltiples y no se mostrará en el anuncio`,
"label.multilang.messagedetail.search.desc":`No podemos encontrar un mensaje con {0}:`,
"label.mobile.phone.read.note":`Ingrese las notas aquí`,
"label.passwordPolicy.setup.isUsingGotp":`Activar la Verificación Secundaria de Login`,
"message.datetypeerror":`<strong>Error: </strong> Fecha Inválida`,
"label.searchlayout.listview.button":`Los botones mostrados en la lista de vista`,
"label.sectionpart":`Sección`,
"label.partnerCloud.basicSetting.userSetting":`Configuración de roles y usuarios`,
"System_Data_Import_Warning_MaxCount":`Su organización solo puede importar {0}datos a la vez, ahora ha superado al límite, ajuste y importe de nuevo.`,
"label.datamove.qualified.record":`?Registros cualificados, cada vez se puede transferir hasta 100 registros!`,
"component_task_label_priority":`Prioridad`,
"vue_label_report_me":`Yo`,
"label.college.duplicate.option":`Las opciones no se pueden repetir.`,
"label.pw.letter":`Cartas`,
"label.file.sharedwithme":`Compartir conmigo`,
"label.translation":`Traducir`,
"lable.currencyAdv.exchagecurrency.before":`y antes`,
"label.file.share":`Compartir`,
"label.page.next":`Siguiente`,
"label.autoRegister.changepwd.setpwd.notmatch":`Dos contrase?as son inconsistentes`,
"label.tabpage.include":``,
"front-email-payment-thanks":`Gracias`,
"vue_label_help_helponthispage":`Ayuda en esta página`,
"label.approvepagelayout":`Dise?o de página de aprobación`,
"vue_lightning_help_zero_distance_communication":`La asistencia en línea le ayudará a ahorrar tiempo al ponerle en contacto con los expertos del servicio de CloudCC sin importar la distancia`,
"vue_label_normal_case_sf":`Caso`,
"label.report.line.tuozhuai":`Arrastre y suelte, o haga doble clic para seleccionar la columna del informe y ajustar el orden`,
"template.dashboard.management":`Gestión de operaciones`,
"label.customcomponent.params.info.n1":`El valor "args" de "args" en el "component" etiqueta es en formato "json", por ejemplo: args="name:'zhang',age:26", en el bloque de código cc, utilice: String myName = name; int myAge = age;`,
"lable.SalesCommitmentKanBan.signedCommitmentRate":`Ratio de firma comprometida`,
"label.add.status":`Añadir status`,
"label.loss.customers":`Cerrado / Pérdida de clientes`,
"vue_label_chatter_involving_me":`Involucrado`,
"label.update.input":`Por favor corrija la introducción`,
"label.import.step1.commonobj":`Objetos comunes`,
"label.appupload.upload.tips.document":`Nota: Los documentos en ¨Mis Archivos Personales¨ y ¨Conjunto de plantilla de carpeta¨ no se pueden añadir al paquete ni mostrar en esta lista.`,
"label.appupload.install.complete":`Terminar`,
"label.console.edit":`Editar Consola`,
"setup.object.field.dependency.label.removefromlist":`Eliminar los valores seleccionados`,
"label.textmessage.groupsms.no.phone":`Sin teléfono`,
"label.account.Current.and.NextFQ":`Trimestre fiscal actual y siguiente`,
"label.sso.saml.sp.idtype.userid":`La declaración contiene ID de usuario de los objetos de los mismos`,
"label.data.import.setup.operate.update":`Renovar los registros existentes, no inserte ningún registro nuevo`,
"front-kefu-moudle-v1-jcaws-call-serve":`Centro de llamadas integrado con AWS (Amazon Web Service) para ofrecer servicios SaaS más completos`,
"label.version.bacheditordel":`Edición masiva/Cancelar/Transferir`,
"lable.even.higher":`Mayor`,
"label.datetime.error":`Formato de fehca es incorrecto`,
"vue_label_commonobjects_detail_customer_hierarchy":`Jerarquía de cliente`,
"label.startuploadfile":`Empezar a subir`,
"label.appointment.wizard.subtitle3-1":`Lunes`,
"label.weixin.relevance":`Oportunidad asociada`,
"label.datamanage.field.mapping.information":`Configuración de Mapeo del Campo`,
"label.brief.lastweek":`Semana pasada`,
"label.nextstep":`Siguiente`,
"label.listtoshow":`A continuación se muestra una lista de los procesos de aprobación activos e inactivos para {0}.`,
"label.partner.ishave":`Error: el dominio ya existe`,
"label.service.miniProgram.name":`Introduzca el nombre`,
"label.view.filterbyaddition":`Filtrar por campos adicionales(Opcional):`,
"label.projectManagement.nodata.task":`No hay registros de tareas. Añada información sobre las tareas`,
"label.chooseemailtemplate":`Selecciona una plantilla de correo`,
"label.page.step4.add.profile":`Paso 4: Añadir a los perfiles`,
"label.ems.mailtype":`Tipo de correo`,
"label.weixin.no.pending.projects.vg":`Excelente, no hay ítems dependientes`,
"label.tabpage.saveviewfailed":`No se ha podido guardar la vista`,
"label.chat.file.upload.cancel":`Cancelar la carga`,
"com.cloudcc.login.error.message.notenabled":`Usuario no habilitado`,
"label.data.import.setup.operate.insertandupdate":`Actualizar los registros existentes y insertar los nuevos`,
"label_target_type":`Tipo de objetivo`,
"label.notification.event2":`【被分配人】ha revisado el evento enviado por usted`,
"chatter.feed.menutype.feed.news":`Mi seguimiento`,
"label.import.page1.suitedwayofcustomer":`Forma de emparejamiento con el cliente`,
"label.import.page2.CloudCCfiled":`Campo CloudCC`,
"label.custom.quarter.start":`Fecha de inicio del trimestre personalizado`,
"label.page.including.tab":`Incluir menú`,
"label.mobile.phone.day.plan2":`Plan de hoy`,
"template.report.lead.conversion.statistics":`Estadísticas de conversión de clientes potenciales`,
"label.show.type":`Tipo mostrado`,
"label.weixin.no.pending.wdgz.qin.week":`No hay trabajo en esta semana.`,
"2018UI.Homepage.DataDeleted.Info":`Los datos han sido borrados, por favor haga clic para volver al paso anterior.`,
"label.vlidaterule.message":`Error de mensaje`,
"label.approval.remark":`Opinión de aprobación`,
"label.field.duplicate1":`?nico`,
"label.batchtransfer":`Transferencia masiva`,
"label.quickbooks.view.allinvoices":`Todas las facturas`,
"vue_label_commonobjects_detail_lead_selectedstatus":`Marcar como seleccionado`,
"label_home_page_source":`Seleccione la fuente de datos.`,
"front-kefu-moudle-v1-opencall-please":`Por favor, active el centro de llamadas y luego configure`,
"setup_layout_label_asc":`Ascendente`,
"label.use_tikect":`¿Utilizar el billete de entrada?`,
"label.tag.setup":`Configuración de etiqueta`,
"label.existinglayout":`Dise?o de página existente`,
"label.productsales.today.noevt":`?Hoy no hay eventos abiertos!`,
"message.error.view.date.validerr":`Ingrese formato de fecha válido(YYYY-MM-DD、MM/DD/YYYY) o caracteres especiales de fecha`,
"label.mr.descreption.oneGroupReData3":`Datos repetidos, se han tratado`,
"label.tianyancha.businessverify.msg1":`Activar la verificación de datos industriales y comerciales, los usuarios deben leer atentamente, y comprender completamente los ítems de este ¨Acuerdo de licencia de usuario¨(Denominado Acuerdo al siguiente), incluida la exención de responsabilidad de Beijing Shenzhou Yundong Customer Co., Ltd. (En adelante denominado "CloudCC") y las restricciones de los derechos del usuario. Léalo atentamente y elija aceptar o no este acuerdo.`,
"label.custom.CQ":`Trimestre personalizado`,
"label.version.custom.dashboard":`Panel estándar (Página personalizada)`,
"vue_label_commonobjects_detail_dragtoupload":`Arrastre su archivo aquí, o <em>haga clic y cargue</em>`,
"label.tabpage.addadvancedoptions":`Añadir opciones avanzadas`,
"front-kefu-moudle-v1-Launch-page":`Página de aterrizaje:`,
"label.emailobject.tabname":`Correo`,
"label.weixin.addmore":`Añadir más`,
"message.error.view.operator.validerr":`Operador inválido`,
"label.another_page":`Redirigir a otra página`,
"label.reportTypeFocusD2":`Ejemplo: si el reporte contiene ¨Contactos con oportunidad de socios¨, seleccione ¨contactos¨ como el objeto primario.`,
"label.icon.47":`Barómetro`,
"label.task.today":`Tareas de hoy`,
"label.service.gantt.weekend.highlight":`Resaltar los fines de semana`,
"label.customcomponent.referencetagname":`Nombre de menú`,
"label.senderemail":`Dirección del correo del remitente`,
"label.defaultvalue":`Valor predeterminado`,
"label_tabpage_Sdfez":`Días anteriores`,
"pagecreator.page.label.pagename":`Nombre de la página`,
"vue_label_report_pagenumber":`Número de página en el rango`,
"label.emailsync.connectaccount.description":`Añada su correo personal aquí, y CloudCC emparejará automáticamente los clientes potenciales y los contactos en el sistema según sus direcciones de correo electrónico, y sincronizará el contenido del correo electrónico con los registros para facilitar el seguimiento y la comunicación con los clientes.`,
"label.schedulableprg.chooseweek":`Seleccione la fecha de cada semana`,
"lable.edit.queue.membercanuse":`Miembros disponibles`,
"lable.Quick.find":`Vistazo rápido`,
"label.daynuminmonth":`Día(s) de mes(es)`,
"message.error.state":`¡El state no puede estar vacío!`,
"label.introduction.the.form":`Descripción`,
"label.batchtransfer.pleaseselectcomefromuser":`Transferir de`,
"front-dashboard-module-implemented":`Realizado`,
"label.custombutton.newerror":`Se frascasó en crear`,
"label.version.allow.size":`, ha superado al límite. Si es necesario, actualice la versión CloudCC.`,
"label.weixin.account.loginpage":`Página de Login seguro de los usuarios`,
"message.pleaseselectfieldtype":`Seleccione el tipo de campo`,
"component.setup.label.parentobject":`Objeto superior`,
"System.TAB.SeeViewAmount":`Ver total`,
"label.event.lastmonth":`Mes pasado`,
"label.taskrecordtype":`Tipo del registro de tarea`,
"label.layout.selectedpages":`Páginas seleccionadas`,
"label.appointmentdetail.wizard.title19":`Plan de Sábado`,
"label_chatter_endData":`Fecha de finalización`,
"label.appupload":`Paquetes`,
"label.knowledgebase.article.link":`Artículo vinculado`,
"label.licence.enddate":`Fecha de Vencimiento`,
"chatter.fieldtrack.record":`Recordatario`,
"label.reportsSubscriptionPage.schedulereport.weekly":`Semanal`,
"label.forecast.editshrepage.title2":`Editar compartido`,
"label.attendance.onwork.time":`Día de trabajo`,
"label.appointment.wizard.subtitle1-8":`3h`,
"pagecreator.layout.button.upload":`Cargar el diseño`,
"label.input.notless.than.number":`Ingrese un número mayor o igual que {0}`,
"setup.mainpage.label.welcome13":`Instrucciones: Haga clic en el menú superior → Informes → Nuevo`,
"label.forecast.settings.data.opp":`Fecha del cierre de la oportunidad`,
"vue_label_display_checkbox_field":`Mostrar campos de casillas de verificación`,
"label.summaryreport.2018.step5":`Paso 5: Seleccione tipo de gráfico y ítems destacados`,
"front-lightning-module-v1-dashborad-one-statistic":`Elija al menos un valor estadístico y un tipo de estadística`,
"label.home.standard.dashboard.forcase":`No ha configurado el permiso de previsiones, no puede ver el panel de compromiso de ventas.`,
"page.field.track":`Seguir historial de campo`,
"label.dataimport.format.datetime.error":`Error de formato, utilice yyyy/MM/dd HH:mm:ss o yyyy-MM-dd HH:mm:ss.`,
"lable.opppdt.selPbk.title":`Seleccione el libro de precios`,
"pagecreator_systemstyle_label_stylename":`Nombre de estilo`,
"label.projectManagement.nodata.project":`No hay datos relacionados. Crea proyectos relacionados conmigo`,
"label.start_below":`Comience a compartir su formulario con sus contactos. Su formulario ha sido publicado de forma segura y está listo para ser utilizado en la dirección web que aparece a continuación.`,
"label.campaignmember.main.delete":`Eliminación masiva de los miembros de campa?a`,
"label.modifyall":`Modificar todo`,
"label.homepage":`Página de Inicio`,
"vue_label_pool_adoptedbyme":`Reclamados por mí`,
"label.email.clearItem":`Borrar solo los correos electrónicos que no tienen elementos asociados`,
"label.callcenter.login.Amazon.connect":`Iniciar sesión en Amazon Connect`,
"label.import.page1.selectimportfiled":`Seleccione el archivo a importar`,
"message.error.id":`La ID no puede estar vacía.`,
"label.ggReleaseRange.searchUsers":`Buscar usuario asociado`,
"label.changemypwd":`Cambiar mi contrase?a`,
"label.ccpeak.reference.parameters":`Los parámetros que se pueden referir directamente son:`,
"chatter.share.success.tip":`??xito! Ha compartido esta publicación a`,
"label.message.checkfailed":`?Reviso de sintaxis fallido, el nombre de clasificación ha sido utilizado!`,
"label.shangqing.introduction":`Integrar y analizar los eventos recientes de clientes potenciales o clientes para ayudar al agente comercial a entender a los clientes de manera más íntegra`,
"label.allemailnotice":`Notificación de todos los correos`,
"vue_label_report_copy":`Copiar informe`,
"label.exchange.sync.state.setting":`Ajuste de configuración`,
"label.merge.result.error1":`El registro siguiente está bloqueado, y no se permite la operación de ¨Fusión¨`,
"label.process.des":`Haga clic en el enlace izquierdo para ver detalles del registro actual.`,
"label.textmessage.vonage.create.lead.setting":`Crear nuevos clientes potenciales cuando se reciben SMS que no estén registrados en el sistema`,
"label.views":`Vistas`,
"label.notification.tip1":`No hay notificaciones`,
"label.forecast.detailforecast.returnforecast":`Regrese a la previsiones`,
"label.knowledgebase.target.framework.name":`Nombre del marco de destino`,
"label.brief.close.opportunities":`Cerrado-Ganado`,
"label.appointment.wizard.subtitle4-2":`Tiempo de recordatorio del último viaje`,
"vue_label_systemSettings_set_record":`Configurar el modo de dispaly de la lista relacionada, tratando de cambiar entre el modo de tarjeta y el modo de lista.`,
"pagecreator_page_message_publish_fail":`La publicación de página se frascasó`,
"vue_label_homepage_name":`Nombre de la página de inicio`,
"label.weixin.no.pending.wdgz.qin.month":`No tiene programa en esta semana`,
"label.campagin.register.page":`Página de Registro de Miembros de la Compa?a`,
"label.campaign.channel.edit":`Campa?a: Editar Canal de Marketing`,
"label.folder":`Carpeta`,
"label.umeng.chatter.follow":`Le sigue`,
"label.sso.theKeyToEdit":`Edición de clave`,
"label.deletelayout":`Cancelar el dise?o de página`,
"label.same.analyze.miaoshu":`Las relaciones entre las condiciones anteriores es: "Nombre de oportunidad " o "Nombre de cliente"  o ("Móvil de Contacto" y "Correo de Contacto");`,
"label.ccpeak.sel":`Clasificación en esta carpeta`,
"label.tabpage.addtoworkbench":`Añadir a la página de inicio del banco de trabajo`,
"label.forecast.shrepage.classdes.r":`Solo leído-Los usuarios pueden ver los datos de previsiones.`,
"homepage.custompagename":`Nombre de la página oficial personalizada`,
"label.sendemail.batchapprovalinfo":`Hola #name:\r\n La operación de aprobación masiva tiene éxito, con un total de #successnum aprobación exitosa y #errornum fallada.`,
"front-email-payment-Invoice-alipay-describe":`Pago seguro y fiable`,
"setup.object.field.dependency.label.configured":`Contenido configurado`,
"label.potentialcustomers":`Candidatos`,
"label.timetrigger.button":`El botón de añadir trigger de hora no está disponible bajo los casos siguientes:`,
"label.category.10":`Abogado`,
"label.selectall":`Seleccione todo`,
"message.field.id.not.null":`El campo ID no puede estar vacío`,
"CloudCCCRM.ST.Info.TypeIn.001":`Por favor, introduzca`,
"label.author":`Autor`,
"label.import.step1.csvonly":`1. Solo se admite archivos en formato csv y se pueden importar hasta {recordnumlimit} registros cada vez. Se pueden importar hasta 2.000 registros si se necesita ejecutar un disparador. Los registros que superen el límite serán ignorados automáticamente por el sistema. Si desea importar más datos, divídalos primero en varios archivos e impórtelos en varios intentos.`,
"label.assignment.setup.newrule.name":`Nombre de regla`,
"label.campaignmember.selectmember.chosestatusdesc":`Seleccione la campa?a que quiere añadir miembros, y edite el status de los miembros de campa?a. Para crear campa?a nueva, debe salir de este proceso.`,
"label_tabpage_operation":`Operación`,
"label_tabpage_datatyoez":`Tipo de dato`,
"UG_product_04":`Crear producto`,
"label_emailtocloudcc_step1_case2":`Una vez configure, los correos recibidos en este correo serán generados automáticamente el caso individual, y relacionan el caso con los contactos y cuentas correspondientes de acuerdo con la bandeja de salida, que facilita el tratamiento y seguimiento de los casos.`,
"workflow.action.tasks.assignortype.role":`Rol`,
"vue_label_notice_refreshi_success":`Actualizado con éxito`,
"label.notification.arketsea.abandon":`{5} ha descartado {2}{0}：{1}`,
"label.icon.36":`Computadora`,
"chatter.group.cancelToJoin":`Cancelar el ingreso`,
"label.publicgroups.edit":`Editar grupo público`,
"message.duplication.label.letternum":`Coincidir con bytes de caracteres`,
"label.brief.lost.opportunities":`Pérdida`,
"setup.layout.label.nofield":`No hay campos disponibles`,
"label.dataimport.isSharingRule":`Ejecutar Regla de Compartir`,
"vue_label_opportunity_contactrole_synctocontacts":`Sincronizar la información con los contactos`,
"attachment_button_massdownload":`Descarga Masiva`,
"label.weixin.agreement.remark":`Este servicio de WeChat es herramienta auxiliar para la consulta Aid-Max de los clientes, no es la base final para compa?ía de seguros al resolver las reclamaciones, las cuales deben resolverse de acuerdo con los requisitos reales de la compa?ía de seguros`,
"label.partnerCloud.basicSetting.introTwo":``,
"pagecreator_layout_funcpath":`/ constructor / biblioteca del dise?o`,
"label.ccdocument.online.edit":`Editar en línea los documentos`,
"label.partner.setup.Enable":`Verificar`,
"label.log.state":`Status de operación`,
"label.lower.bound":`Límite inferior`,
"label.timezone.isenable":`Activar la zona horaria múltiple de usuario, que perimte a los usuarios configurar zona horaria y mostrar la fecha/hora por su zona horaria`,
"label.martrixreport.setrowtitle":`Especificar`,
"label.bottom":`Fondo`,
"label.multilang.ccchat.groupnotcontainsname":`No es un miembro de cualquier grupo de compa?a que contiene {0} en su nombre`,
"label.step1.of.step5":`Paso 1 de 5`,
"message.report.error.FieldListIsAmbiguous":`El campo de fórmula en el informe hace referencia al campo siguiente, que causó la anormalía, remueva este campo:&nbsp;`,
"label.monitorsys.operator.ip":`IP`,
"ccchat.fieldtrack.fieldchange":`Cambiar de {0} a {1}`,
"label.report.export.print.content":`Exportar la cabecera, los grupos y los primeros 2000 registros del informe actual`,
"message.thanksusing":`?Gracias por utilizar CloudCC.com!`,
"label.reportexport.allobject":`Exportar todos los objetos`,
"label.projectManagement.working.hours.per.day":`Horas de trabajo diarias`,
"label.partnerCloud.financeSetting.enterCollaborator":`Por favor, introduzca el ID del cooperador`,
"label.defineReportRecords":`Definir el conjunto de registros de informe`,
"greate":`Mayor que`,
"label.sure_discard":`¿Estás seguro de renunciar a los cambios?`,
"label.escalation.setup.newaction.notifyowner":`Notificar el propietario del caso`,
"label.icon.28":`Sombrero De Doctor`,
"lable.PowerProcess.see.page":`Ver eventos clave`,
"message.error.object.relogin":`Error al iniciar sesión, por favor, inténtelo de nuevo`,
"label.chatter.activity":`Actividades`,
"label.query.clone.detail.choose.canChoose":`?tems de Línea Disponible`,
"chatter.using.object":`Iniciar el seguimento de micro-publicación de los objetos para que los usuarios puedan seguir los registros del tipo de este objeto. Seleccione los campos que seguir para que los usuarios puedan ver las acutalizaciones de micro-publicación cuando lso campos han sido cambiado en los registros que ellos siguen.`,
"UG.opportunity.001":`¿Cómo controla sus ventas?`,
"label.ServiceCloud.fuwuziyuan.distributionMap":`Mapa de distribución de recursos de servicios`,
"vue_label_email_current_email":`Al insertar esta plantilla se sobrescribirá el correo electrónico actual`,
"label.h5.approval.page.layout":`Puede establecer el diseño de la página de aprobación: <br>Configuración>Crear>Flujo de trabajo&Aprobación>Procesos de aprobación<br>seleccione el proceso de aprobación, haga clic en el nombre de la aprobación<br>haga clic en Editar>Configurar el diseño de la página de aprobación`,
"component.hots.label.title":`Transacciones destacadas`,
"mail.foldername.notOnly":`Este archivo ya existe`,
"label.customer.tab.step1":`Paso 1: Ingrese los detalles`,
"label.delete.persion":`Cancelado por`,
"chatter.changed0":`Cambiar {0} de {1} a {2}`,
"homepage.components.type":`Tipo de componente`,
"label.norfolk.isiands.time":`Hora de Norfolk`,
"label.product.pricebooks.view":`Vista del catálogo de precios`,
"label.forecast.customforecast.director":`Subordinado directo`,
"label.emailtocloudcc.step3total3":`Paso 3 de 3`,
"label.cloudccsite.end":`Página oficial del sitio no activado`,
"label.login.verification.mfa.device":`Verificar el dispositivo virtual MFA`,
"chatter.follow":`Lo que quiero seguir`,
"label.month's":`Mensual`,
"label.sendmail.step1.introduce":`Seleccione una de las vistas siguientes (Incluye el destinatario del correo).`,
"label.shangqing.title":`Ajuste de la información comercial`,
"label.rejectrecords":`Registro de rechazo`,
"label.selectupdatevalue":`Valor que cambia de`,
"vue_label_pricebook_disabled":`Lista de precios desactivada`,
"component.chatter.label.title":`Última publicación`,
"label.partner.all.workspace":`?rea de trabajo`,
"label.querydetailservice.delete.message":`Los datos se han cancelado o no existe`,
"label.objectRelationshipWithout":`Con o sin los registros relacionados`,
"nocontain":`No contiene`,
"label.partnerCloud.financeSetting.accountSettings":`Configuración del fondo de socios`,
"label.file.sharetype.owner":`Propietario`,
"label.open.multilingual":`Activar el multilingüismo`,
"label.searchresult.field":`Campo del resultado de búsqueda`,
"label.tabpage.selectdate":`Seleccionar una fecha`,
"label.h5.logouting":`Cerrar la sesión`,
"label.quickbooks.fieldlabel.payment":`Método de pago`,
"label.chatter.leaveword":`Comentario`,
"label.customfields.majoranddetailrelation.tip":`Cree un tipo especial de relación padre-hijo entre este objeto (hijo o detalle) y otro objeto (padre o" maestro "), donde: <br> ● Los campos de relación para todos los registros de detalles son obligatorios . <br> ● Una vez que se guarda el valor del campo de relación, no se puede cambiar. </li> <br> ●  La propiedad y el intercambio del registro de detalles se determina mediante el registro maestro. </li> <br> ● Cuando el usuario elimina el registro maestro, todos los registros de información detallada se eliminarán. </li> <br> ● Puede crear un campo de resumen acumulativo en el registro maestro para resumir los registros de información detallada. </li> < br> El campo Relación permite al usuario hacer clic en el icono de búsqueda para seleccionar un valor de la lista emergente. El objeto principal es la fuente del valor en la lista ".`,
"label.batchapproveorrefuse":`Aprobación masiva/Rechazar la solicitud`,
"label.copy.success":`Copiar con éxito`,
"vue_label_show_record_count":`Mostrar el recuento de registros`,
"label.ems.delete.false":`Cancelación fallida`,
"label.new.Product.Goals":`Nuevo objetivo de producto`,
"label_chatter_BCC":`Cco`,
"label.knowledgebase.data.archived.successfully":`{a} archivo de datos con éxito`,
"label.chuangming.title":`Chuang Ming SMS`,
"label.notification.arketsea.recovery":`Su {0}:{1} ha sido reciclado a {2} por {5}`,
"label.partnerCloud.orderingPlatform.paymentAmount":`Importe del pago:`,
"label.martrixreport.2018.step5.new":`Paso 5: Seleccione criterios de informe`,
"label.testing":`Revisando...`,
"chatter.poll.option4":`Opción 4`,
"lable.outlook.detail.otc":`Exchange a CloudCC.com`,
"label.startuploadfile.batch.step2":`Paso 2. Haga clic en ¨Subir¨ para subir los ficheros`,
"lable.outlook.edit.outdes":`Ingrese los campos personalizados que ha creado en Exchange. Antes de mapear el campo personalizado de Exchange a CloudCC.com, CloudCC.com verificará la existencia de Exchange durante la primera sincronización.`,
"hour":`Hora`,
"label.appointmentpage.wizard.notif4":`Formato de correo inválido`,
"label.import.index.state":`Estado`,
"label.integrations.mailchimp.massage6":`Los datos selecciones de la página acutal se exportarán a la lista de Mailchimp`,
"label.file.share.email.subject":`#sharedBy ha compartido contigo un archivo en #orgname`,
"label.assignment.setup.newentries.noassignment":`No asigne propietario de nuevo`,
"label.dashboard.unit1":`Unidad: 10,000`,
"label.forecast.customforecast.foretype.commit":`Comprometido`,
"label.type":`Tipo`,
"label.partner.workspace.login.logo":`Logo del encabezado`,
"pagecreator_systemstyle_button_edit":`Editar estilo`,
"label.displaytype2":`Botón de la página de detalles`,
"email.one":`Estimado usuario: \N  Bienvenido a CloudCC. Usted ha solicitado restablecer su contraseña en {¡hora de operación}, por favor, inicie sesión con el código de verificación de abajo dentro de 15 minutos: \n Código de verificación aleatorio: {Haga clic en el siguiente enlace para restablecer su contraseña: \n{!URL}/authcodecheck.jsp?username={!username}&lang={!lang}\n Importante: Si no ha solicitado esto, o cree que este mensaje no debería llegarle, póngase en contacto con su administrador inmediatamente.`,
"label.partnerCloud.orderingPlatform.unavailable":`No hay productos disponibles`,
"vue_label_email_save_the_signature_successfully":`Firma guardada con éxito`,
"label.reportsSubscriptionPage.email.detailed":`Detallado`,
"chatter.group.query":`Consultar`,
"label.translation.unsupported.format":`Formato incompatible, la importación de multi-idiomas solo se permite el formato Property`,
"message.operateexception":`Indicación(Contacte con su administrador).`,
"label.sendemail.chat.praiseFeedcomment":`Estimado #name:\n\n Hola! #userName quiere sus comentarios (#href).`,
"label.recycle.clearmy":`Limpiar la papelera de reciclaje`,
"label_tabpage_choose":`Seleccionar`,
"#label.importstep2tip":`Si quiere subir más de un fichero, puede compresionar todos los ficheros y importarlos.`,
"label.batchedit":`Edición Masiva`,
"label.integrations.mailchimp.export":`Exportar a Mailchimp`,
"label.cloudccsite.name":`Nombre del sitio`,
"serviceterritory.serviceappointment.iscontain.contain":`No puede eliminar el territorio de servicio porque está asociado a una cita de servicio. Puede no habilitar este territorio de servicio.`,
"label.sum":`Suma`,
"setup.mainpage.label.welcome29":`API estandarizado integrado con productos de terceros`,
"label.tabpage.nothingz":`No hay nada`,
"label.weixin.actual.contract.jine":`Monto real del contrato`,
"label.tabpage.emailaddressz":`Dirección del remitente`,
"label.dashboard.unit4":`Unidad: 10 millones`,
"label.dashboard.data.labels":`Etiqueta de los datos`,
"label.import.page2.oneonone":`Un campo CloudCC solo puede corresponder a un campo de un archivo`,
"homepage.components.name":`Nombre de componentes`,
"template.report.task.theme":`Tema de la tarea`,
"component.setup.label.setupsaveok":`Se ha guardado con éxito la configuración del componente`,
"front-epwechat-module-v1-add-selfapp":`Añadir una aplicación creada por Sefl`,
"label.to.save.the.current.page.information.button.":`Si desea guardar la información de la página actual, haga clic en el botón "Guardar rápidamente".`,
"vue_label_file_not_support_preview":`El archivo no admite  vista previa, por favor, descárguelo para visualizar`,
"label.object.reached.limit":`La cantidad de objeto ha alcanzado al límite`,
"label.partnerCloud.basicSetting.online":`Activar el pago en línea`,
"label.app.step1.error.nameexist":`El nombre de grupo ya existe`,
"label.workflowandapprove":`Flujo de trabajo y aprobación`,
"label.recordtypeselect.change.tip":`Al cambiar el tipo de registro, los valores existentes de la lista de opciones no cambia automáticamente. Se recomienda que actualice los valores actuales en el mismo lugar.`,
"label.summaryreport.step6":`Paso 6: Seleccione los criterios del informe`,
"Pagelayout.Setup.004":`Solo se puede configurar hasta 4 campos`,
"label.file.attached":`Adjuntar`,
"front-invoice-online-payment-setup-configure":`Haga clic en "Configurar ahora", Configurar la interfaz de pago de {nombre}.`,
"label.approvaldatamove.submitdate":`Fecha de envío`,
"label.emailobject.time.from":`De:`,
"label.dataimport.insertdata.error.fieldrepeat.insert":`El campo $schemefield_name$ de este registro ya existe,en la base de datos, y no inserte más, ya ha ignorado la importación del registro.`,
"assetbom.copy.notpermission":`No tiene permiso para copiar la lista de materiales de activos. Póngase en contacto con el administrador`,
"lable.outlook.mcto.autoallocation":`Asignarlos a registros relacionados de CloudCC.com automáticamente.`,
"label.dataimport.but.datalength":`, pero la longitud de los datos es `,
"label.setuserstocommit":`Utilice las opciones siguientes, especifique los usuarios que pueden enviar solicitud inicial para la aprobación.`,
"component_telerecord_label_related":`tems relativos`,
"front-lighting-module-v1-detail-file-lockInfo":`El registro está bloqueado y no está disponible para añadir archivos. Por favor, póngase en contacto con el administrador para desbloquearlo.`,
"pagecreator_layout_button_edit":`Editar el dise?o`,
"label.app.step3.tabcanuse":`Menú disponible`,
"label.ems.delete.sure":`?Está seguro de que quiere cancelar la información de esta cuenta de correo?`,
"label.email.show":`Mostrar`,
"label.checkbox.unchecked":`No seleccionado`,
"message.error.operation":`?Error de operación, contacte con el administrador!`,
"label.template.set.folder.only.upload.type.file":`La carpeta marcada roja de plantilla solo se puede utilizar para subir los archivos del formato Word, Excel y PPT`,
"label.knowledgebase.select.publish.status":`Elija un estado de publicación`,
"label.recordtype.tabname.edit":`Ingrese nuevo nombre para el tipo de registro seleccionado, y luego haga clic en ¨Guardar¨`,
"label.tabpage.exportview":`Exportar vista`,
"label.dataimport.insert.sharetab":`Se frascasó en insertar el formulario de compartido.`,
"vue_label_dashboard_penetrateto":`Penetrar hasta`,
"label.weixin.group.member":`Personal`,
"vue_label_systemSettings_customadd":`Extensión personalizada`,
"UG_Account_03":`Revise y fusione proactivamente los clientes duplicados`,
"label.singapore.standard.time":`Hora Estándar de Singapur`,
"label.weixin.captcha":`Código de verificación`,
"Account_News_Setting_004":`Activar noticias`,
"label_emailtocloudcc_select1":`Seleccione`,
"label_ring_ratio":`Mes a mes`,
"label.industrialandcommercialverification.button.save":`Guardar`,
"label.approvalstep5.tip":`La página de aprobación es donde el aprobador acepte o rechace. Utilice las opciones siguientes para seleccionar las propiedades editadas del campo para mostrar en esta página.`,
"label.import.page1.maxrecord{{30000}}":`1. Puede importar hasta {{30000}} registros de una sola vez`,
"setup_object_layout_label_profileoptions":`Perfiles disponibles`,
"label.emailtemplate.type":`Tipo de Plantilla`,
"label.searchlayout.tab.field":`Campos mostrados en el menú de la página oficial.`,
"chatter.news":`Mensajes`,
"label.pw.small.letter":`Minúsculas`,
"label.notification.group3":`Su solicitud para unirse al grupo público ha sido rechazada`,
"label.ccchat.day.before.yesterday":`Antepasado`,
"component.chatter.post.label.title":`Publicar`,
"label.tianyancha.type":`Tipo de representante legal`,
"label.detail.searchlayout":`Ver dise?o de búsqueda`,
"vue_label_pool_deleteconfirm":`¿Está seguro de que desea eliminar ?{??1??} dato(s) seleccionado(s)?`,
"label.import.index.maxmb{{100}}，maxitem{{30000}}":`1. Solo se admiten archivos en formato csv, el tamaño máximo es de {{100}}mb, y se puede importar un máximo de {{30000}} registros de una vez; por favor, divídalos en varios archivos e impórtelos por etapas si se supera el límite.`,
"label.h5.similar.opportunity.lookup":`Encontrar oportunidades similares`,
"template.report.customer.list.opportunity":`Lista de cuentas con más oportunidades`,
"component_setup_iframe_label_memo":`Haga clic en configurar ícono y ingrese la dirección URL integrada.`,
"label.version.allemail":`Correo masivo`,
"lable.product.editp":`Editar precios`,
"label.weixin.plate.number":`Número de Placa`,
"font-evaluate-module-v1-disabled-successfully":`Se ha desactivado con éxito la opción de evaluación "Neutral"`,
"label.multilingual.tip1":`Utilice esta página para definir la lengua de su organización.`,
"label.japan.standard.time":`Hora Estándar de Japón`,
"lable.product.notdel.use":`Cancelar intentos, porque está asociado con los registros siguientes. Se recomienda prohibir el uso bajo esta situación.`,
"label.appointment.wizard.subtitle4-2-4":`4h`,
"label.queue.edit":`Editar`,
"label.partnerCloud.financeSetting.informationTwo":`2. En el Merchant Center, haga clic en Gestión de cuentas  Gestión de comercios  Producto PIDIKEY  Gestión de claves secretas`,
"label.partnerCloud.partnerOrdering.permission":`Permiso de pedido del socio`,
"vue_label_commonobjects_detail_company_hierarchy":`Jerarquía de la empresa`,
"label.forecast.settings.sl":`Cantidad`,
"label.partner.workspace.tab.memo":`Seleccione menú para la nube de socios, puede elegir menú estándar o menú personalizado`,
"label.mr.mainRecord":`Registro maestro`,
"setup_mainpage_label_welcome20":`Plantilla de correo y SMS`,
"front-email-payment-select-date-tips":`Por favor, elija YY`,
"label.dependencelisttag":`Etiqueta de lista relacionada`,
"label.umeng.activity.eventof":`Evento de`,
"label.sales.dashboard.collection":`Objetivo de recibo`,
"report_label_folder":`Carpetas`,
"label.assignment.setup.newentries.step1":`Paso 1: Configurar el orden de los ítems de esta regla`,
"label.quote.shrname":`Nombre del destinatario`,
"label.newreport.group.sum":`Cantidad de grupos`,
"label.number.MinCheck":`El mínimo de {a} es {0}. Por favor, modifique la cantidad y guarde los cambios.`,
"label.chatter.save":`Guardar`,
"vue_label_email_all_email_templates":`Todas las plantillas de correo electrónico`,
"message.summaryconditionnototal":`Condición resumida no se puede usar campos acumulativos!`,
"label.callboard":`Anuncio`,
"label.step2.total5":`Paso 2 de 5`,
"vue_label_homepage_custom_homepage_page":`Página de inicio personalizada`,
"label.data.newtemplate.e_seltype":`Seleccione método de exportación de los datos`,
"label.data.dataexpalltype.all.desc2":`2. Puede tardar un rato al exportar todos los datos. Cuando la exportación se haya completado, recibirá un correo electrónico notificándole que la exportación de datos se ha realizado con éxito.`,
"lable.account.CalenderYear":`A?o calendario`,
"message.error.data":`Los datos a transferir no pueden estar vacíos, por favor compruebe los parámetros de transferencia`,
"label.from_user":`Del usuario`,
"label.parentdepartment":`Departamento superior`,
"template.dashboard.product.analysis":`Análisis de productos`,
"label.tabpage.unpacketz":`No hay datos de grupo disponibles.`,
"label.icon.107":`Comunicación`,
"label.monitorsys.operator.username":`Usuarios`,
"label.serchreport":`Buscar informe`,
"label.payment.upgrade":`Actualizado`,
"setup_layout_button_ok":`Confirmar`,
"label.please.select.channel":`Seleccione el supervisor del canal`,
"template.chart.txdrw":`Recordatorio de tareas`,
"chatter.group.accept":`Aceptar`,
"pagecreator_systemstyle_message_canntdelete":`El estilo acutal no se puede cancelar`,
"label_tabpage_ctbtsftcz":`Haga clic en buscar para seleccionar los contenidos`,
"label.datamanage.select.accountfield":`(Seleccione los campos correspondientes a los clientes importados)`,
"label.schedulejob.setup.list.title":`Trabajos programados`,
"label.visualpage_list.title":`Acceso de la página personalizada activado`,
"label.mr.selectTwoData":`Seleccione por lo menos dos registros para fusionarse.`,
"label.customer.tab.step2.different":`Aplicar a visibilidad del menú diferente a cada perfil`,
"label.mobile.side.tab.can":`Disponible`,
"label.log.url":`URL`,
"label.weixin.cloudccnumber.isgoon":`?La cuenta de CloudCC está vinculado, si continua, el WeChat vinculado a la cuenta no puede utilizar el sistema de CloudCC. Está seguro de continuar?`,
"label.applet.to.case":`Portal de atención al cliente del miniprograma`,
"lable.outlook.detail.cmaping":`Mapeo del campo de contactos`,
"label.theUserActiveTime":`Período activo del usuario`,
"label.event.moveup.9hour":`9 horas con antelación`,
"vue_label_pool_other":`Otros`,
"label.fieldname":`Nombre de campo`,
"vue_label_notice_add_success":`Añadido con éxito`,
"label.conditiontag.lookup.insertbutton":`Insertar los seleccionados`,
"label.identifying":`Identificación`,
"label.tabpage.uploadingz":`Cargando`,
"label.view.introduce":`Editar Vista`,
"vue_label_dashboard_sortingmethod":`Seleccione el método de ordenación`,
"label.quote.number.introduce":`Ingrese la cantidad de producto y descuento, y luego haga clic en ¨Guardar¨`,
"front-kefu-moudle-which-missphone-case":`Crear casos para los que se han perdido llamadas`,
"label.sendemail.chat.response":`Respuesta de CCChatter:`,
"label.productsales.refreshTime":`Última Actualización`,
"lable.SalesCommitmentKanBan.phase":`Etapa`,
"label.version.sum.object":`objeto(s)`,
"label.defineReportStep2":`Paso 2`,
"message.duplication.label.returnDuplications":`Volver a la Lista de Filtro de Repetición`,
"label.lookover":`Ver`,
"label.quickbooks.button.copy2":`Sincronice CloudCC con QuickBooks`,
"label.checkbox.true":`Sí`,
"label.profilename":`Nombre de perfil`,
"label.finalapproveoperate":`Operación de aprobación final`,
"label.SMS.detailed":`La notificación de SMS  será enviada por reglas del flujo de trabajo cuando se active`,
"label.lasttimemodifier":`Última Modificación Por`,
"label.sso.summary":`Resumen`,
"label.customfields.encd.tip":`Permite a los usuarios introducir cualquier combinación de letras y números, y guardarlos en forma de texto claro que se puede cifrar y buscar.`,
"vue_label_report_formulacolumn":`Columna de fórmulas a nivel de fila`,
"vue_label_systemSettings_transfer":`Registros de transferencia de lotes`,
"lable.product.ecm":`Línea, ingrese el monto correcto`,
"label.partner.setup":`Configuración de nube de socios`,
"label.same.analyze.miaoshu2":`¨Función`,
"label.mobile.phone.day.summary":`Resumen de hoy`,
"label.ccchat.person.error.illdomain":`Error: El formato de dominio rellenado es incorrecto`,
"label.knowledgebase.edit.as.draft":`Editar como borrador`,
"message.duplication.label.newfilterule":`Crear regla de duplicados y de filtro`,
"vue_label_salesfunnel_notice1":`Resumen de oportunidades de negocio`,
"label.partnerCloud.partnerAccount.order":`Número de pedido :`,
"label.account.Current.and.PreviousFQ":`El a?os fiscal actual y anterior`,
"label.customfields.formula.dateandtimeexample":`Next(Valor siguiente) = NOW()   1`,
"label.area.unassign":`Usuarios no asignados`,
"label.at.my":`Contenido he mencionado (@)`,
"vue_label_calendar_notice_stopsharingfail":`No se ha podido detener compartir`,
"label.data.file.validation.rules":`Ejecutar reglas de validación`,
"label.escalation.setup.entrydetail.escalation.hour":`Horas`,
"vue_label_ccchat_notice_pleaseentercontent":`Introduzca el contenido y las opciones`,
"label.forecast.edit.error1":`Error: Moneda inválida`,
"label_emailtocloudcc_exists1":`El correo ha sido configurado Email to Lead, no repita la configuración`,
"label.trigger.send.email":`Notificación de correo via Activación:`,
"label.setmysafetysignagain":`Restablecer mi token de seguridad`,
"label.callcenter.pleaseenter.access.keyID":`Por favor, introduzca el ID de la clave secreta`,
"chatter.poll.option10":`Opción 10`,
"vue_label_systemSettings_mobelbottonsetting2":`Configuración del menú inferior unificado`,
"label.quickbooks.searchs":`Buscar`,
"label.section":`Segmento`,
"label.customfields.fielddependency.new.tip":`Cree una relación dependiente, que causará el filtro dinámico a los valores de la lista de opciones o de la lista de multiopciones basándose en la selección de valor en otro campo por el usuario. <ul ><li>El campo que promueve el filtro se llama campo de control, que tiene por lo menos un valor y la cantidad de valor es menos de 300. La casilla de verificación personalizada y la lista de opciones pueden ser campo de control</li><li>Su valor filtrado se llama ¨Campo dependiente¨. La lista de opciones personalizada y la lista de multiopciones pueden ser campo dependiente.</li></ul>`,
"label.customobjects.track.introduce3":`Por favor, tenga en cuenta que sólo se rastrean una parte de los campos que se han publicado y que se mostrará "Editado" cuando se rastreen los campos.`,
"front-kefu-moudle-all-hidden-phone":`Ocultar el número de teléfono de forma global`,
"vue_label_calendar_share_calendar_with_others":`Compartir el calendario con otros`,
"label.case.copre":`Descargar el código QR del portal web`,
"label.conditiontag.lookup.pagetitle":`Seleccione valor de la lista de opciones`,
"UG.opportunity.004":`Tipo multiservicio`,
"label.event.moveup.1day":`1 día de antelación`,
"label.industrialandcommercialverification.enablestatus1":`Activar la verificación de datos industriales y comerciales`,
"label.ccpeak.newrecord.getorpost":`Nuevo Recordatario: hay dos método para construir CCObjeto utilizando CCObjeto.`,
"frame.personinfo.label.resizeimage":`Para realizar ajustes en su imagen en miniatura, arrastre la línea de puntos suspensivos que está en la parte superior de la foto del perfil.`,
"label.optional.searchresultfield":`Campos de resultado de búsqueda disponible`,
"UG.Contract.02":`El contrato es un acuerdo escrito entre las partes. Muchas empresas utilizan contratos para definir las condiciones de negocios con otras empresas. Utilice CloudCC para establecer y documentar los contratos existentes con sus clientes y oportunidades de negocio. Haga un seguimiento del contrato a través del proceso de aprobación. Utilice recordatorios de flujo de trabajo para recordar la renovación del contrato.`,
"label.group.activity":`Grupos activos`,
"label.tabpage.characterz":`Carácter de inicio`,
"label.globalsearch.tip":`Ingrese los contenidos de búsqueda`,
"label.campaign.channel.download.size2":`Tama?o medio: 500*500 pixeles`,
"label.step3.total4":`Paso 3 de 4`,
"label.partnerCloud.payForFailure":`Pago fallido`,
"label.ggReleaseRange.editSuccess":`Editar con éxito`,
"label.summaryinforelyon":`Base de información resumida`,
"label.productsales.htyj":`Rendimiento de contrato`,
"label.newpagelayout":`Dise?o de la nueva página`,
"front-gantt-module-input-task-name":`Por favor, introduzca el nombre de la tarea！`,
"label.c_d_without":`Los registros "C" pueden o no tener registros "D" relacionados.`,
"label.licence":`Licencia`,
"setup.layout.button.selectall":`Seleccionar todo`,
"label.app.step1.error.appnameexist":`Error: el nombre de aplicación ya existe`,
"label.cpq.quote.item.no.record":`Sólo se pueden transferir a los contratos los productos de los pedidos con registros.`,
"label.knowledgebase.noaffect.existing.translations":`No, mis modificaciones no afectarán a la traducción existente.`,
"label.schedulejob.setup.schedule.editjob":`Editar trabajo programado`,
"lable.PowerProcess.Tips":`El proceso de asignación es una línea de tiempo personalizable que contiene todos los pasos (eventos clave) que podrían ayudar al servicio de atención al cliente y al resto del personal a completar todos los pasos para resolver un caso o registro de orden de trabajo. Una vez completada la configuración, se puede aplicar en el proceso de asignación.`,
"label.campaignmember.selectmember.step2":`Paso 2: Seleccione los miembros que quiere añadir`,
"vue_label_calendar_stopsharing":`¿Estás seguro de dejar de compartir el calendario`,
"vue_label_notice_savemenu_fail":`Error al guardar menú`,
"message.error.getitems.id":`getItems:id no puede estar vacío`,
"label.return.currencylist":`Regrese a la lista: Gestión de moneda`,
"label.wtd.detail.p":`PC`,
"label.knowledgebase.publish.now":`Publicar ahora`,
"label.appupload.install.explain":`Instrucciones de instalación`,
"label.visualpage.folder.all":`Carpeta de todas las páginas`,
"message.passwordPolicy.validate.complexReq2":`Error: La contrase?a debe ser letras alfanuméricas`,
"label.umeng.chatter.at":`Le han mencionado`,
"label.mobile.phone.month.report":`Reporte mensual`,
"label.describableEditeSelectedFields":`Seleccione campos que muestren en las columnas de informe por defecto al crear nuevo informe personalizado`,
"component.event.label.subject":`Tema`,
"label.knowledgebase.edit.draft":`¿Editar el borrador?`,
"label.customer.tab.step1.selectoneobject":`Seleccione un objeto personalizado existente`,
"label_partner_step2":`Paso 2: Confirmar plantilla`,
"label_starting_annual":`Año de inicio`,
"X":`Área de texto`,
"label.customer.tab.style":`Tipo de Pesta?a`,
"vue_label_commonobjects_detail_book":`Un libro de precios estándar`,
"chatter.email.referredToMe":`Me han mencionado en la publicación`,
"label.enable.both.barcode.qrcode":`Activar el código de barras y el código QR`,
"front-market-form-quired-choose":`Campos obligatorios`,
"noinclude":`Excluir`,
"label.sms.template.select":`Seleccione una plantilla de SMS`,
"label.weixin.optionten":`Opción 10`,
"message.duplication.label.matchlastletters":`Coincide con los últimos n caracteres`,
"label.webtocloudcc.submit.success":`Envío exitoso`,
"label.sales.dashboard.number":`Número`,
"label.custom.field":`Mapear este campo personalizado`,
"label.dataimport.of.field":`Campo(s)`,
"label.view.new":`Crear nueva vista`,
"UG_activity_03":`Reservar un programa`,
"label.customfields.image.tip":`Permite a los usuarios subir imágenes`,
"label.startexport":`Empezar a exportar`,
"vue_label_commonobjects_view_chart_verticalbar":`Gráfico de barras verticales`,
"label.ccchat.person.invite.allexist":`Cada uno que ha invitado est?a utilizando CCChatter`,
"label.fielddependence":`Dependencia del campo`,
"label.scan.tip":`Utilice IE7, IE8, Chrome o Firefox, se recomienda utilizar una resolución más de 1024×768.`,
"label.wei.weiactor":`Votado por`,
"label.service.miniProgram.quantity":`Se pueden crear hasta 20 registros de carrusel~`,
"vue_label_homepage_new_homepage_page":`Nueva página de inicio`,
"label.apply.telphone.validate.error":`Error del número de verificación`,
"component.assistant.button.newevent":`Nuevo evento`,
"System_TimeField_Format_Warning":`Tiempo inválido`,
"chatter.feed.publishfeed":`Publicar`,
"label.setting.intergrationlist":`Lista de integración`,
"label.object.prefix":`Prefijo del objeto`,
"label.tippage.confirmed":`Sí, quiero cancelar el origen de datos del informe personalizado y todos los informes dependientes`,
"label_emailsync_form_signin":`Iniciar sesión`,
"label.delete.cancel":`Remover la cancelación`,
"label.dashboard.myHomePage.des":`Seleccione el panel que va a mostrar en cada App.`,
"lable.account.FY.Ago":`Hace dos a?os fiscales`,
"label.umeng.approval.reassign":`#approver ha reasignado su solicitud #obj`,
"label.data.exp.zippwd2":`Generar automáticamente la contrase?a del archivo comprimido`,
"label.tabpage.contentz":`Introduzca el contenido`,
"label.callcenter.batch.add.number":`Añadir números en el lote`,
"label.tabpage.deleteviewsuccess":`La vista se ha eliminado con éxito`,
"setup_layout_group_field":`Campos`,
"label.appupload.component.addobj.scheme.label.suoshu":`Objeto`,
"front-project-module-v1-market-is-template":`Marcar como plantilla`,
"label.service.gantt.one.esource.types":`y uno de los siguientes tipos de recursos`,
"label.emailtocloudcc.search":`Buscar`,
"label.mobile.home.page.myyj":`Mis rendimientos`,
"vue_label_normal_invoice_sf":`Factura`,
"label.permission.detail.app.fenpei.tip":`Especifique que aplicaciones son visibles en el menú de aplicaciones`,
"label.login.access.month":`Mes`,
"label_tabpage_retypez":`Al cambiar el tipo de registro, los valores de la lista de opciones existentes no cambiará automáticamente. Recomendamos que actualice los valores de la lista de opciones existente del registro en el mismo sitio. `,
"label.ems.private.company.message":`La versión de nube privada no admite editar en línea el correo de la empresa`,
"label.dataimport.length.check":`La longitud excede 18 dígitos, revise el registro y modifique.`,
"label.batchtransfer.type1":`Transfiere las oportunidades abiertas que no pertenecen al propietario del cliente actual`,
"vue_label_calendar_are_you_sure_to_remove":`¿Está seguro de eliminar este calendario?`,
"label.icon.117":`Bolsa Para La Escuela`,
"vue_label_systemSettings_downloadapp":`Descargar la aplicación móvil`,
"label.approval.project":`?tems por aprobar`,
"template.organization":`Nivel de organización`,
"label.weixin.return.research":`Regrese a la página detallada de Micro Encuesta`,
"label.ccchat.person.invite.addsay":`Añadir una información seleccionable...`,
"UG.Case.02":`Los casos le permiten responder y resolver los problemas del cliente. Los casos son un potente registro en Cloud CC que no solo hace un seguimiento de los problemas del cliente, sino que también muestra una visión completa de la misma.`,
"label_emailtocloudcc_step1":`Paso 1`,
"workflow.action.tasks.assignortype.owner":`Propietario`,
"label.data.import.page":`Ir a la página de importación`,
"label.cache":`Caché`,
"label.custom.page.cuspage.width":`Ancho(Píxel)`,
"label.customcomponent.referencetag":`Etiqueta referenciada`,
"label.tabpage.search":`Buscar`,
"label.knowledge.searcharticle.casefields":`Campos de casos para la búsqueda de artículos sugeridos`,
"setup_layout_message_relatedlistfield":`Seleccione campos para mostrar en la lista relativa, puede reordenar los campos seleccionados`,
"label.relationobject.type":`Tipo de objeto relativo`,
"UG_Account_02":`Algunas empresas ofrecen servicios a otras, algunas colaboran directamente con los usuarios finales, y algunas sirven para ONG.`,
"UG_homepage_006":`Obtenga una vista de 360 grados de la actividad de su cliente con cuestionarios, chats en vivo, correos, tickets, publicaciones en redes sociales e incluso eventos de ventas como clientes potenciales, soporte de servicio y eventos.`,
"chatter.poll.option1":`Opción 1`,
"label.ccdocument.fieldforld":`Nombre de la carpeta del documento`,
"label.wei.result":`Resultado`,
"label.recentview.new":`?ltimo`,
"label.martrixreport.setsumfield":`Seleccione el campo para usar como fila de suma en su informe matricial`,
"label.reportsSubscriptionPage.schedulereport.weekly.monday":`Lunes`,
"label.marketsea.button.recycle":`Reciclar`,
"label.standard.buttonandlink.info2":`Seleccione la página personalizada de CloudCC URL para reemplazar este botón estándar o enlace.`,
"label.reportsSubscription.select.two.months":`Seleccione un rango de fechas de dos meses para esta frecuencia`,
"label.standard.buttonandlink.page":`CloudCC Clásico`,
"vue_label_commonobjects_view_chart_horizontalbar":`Gráfico de barras horizontales`,
"label.Remove":`Remover`,
"label.mobile.phone.receivable":`Pago`,
"label.appupload.uploaddetail.goback":`Regrese a la lista de paquetes`,
"label.select.role":`Seleccione un rol`,
"label.file.sharetype":`Compartir el tipo`,
"label.app.chosetab":`Seleccione el menú`,
"label.case.other.phone":`Otro número de teléfono`,
"chatter.edit.cancel":`Su cambio ha sido cancelado`,
"label.html":`HTML`,
"message.auth2cn.acquisition.failed":`No se ha podido obtener el auth2cn.`,
"message.error.system.service.permissiondeny":`?Lo sentimos, no le autorizaron este servicio, contacte con el administrador!`,
"label.chatter.mygroups":`Mi grupo`,
"label.umeng.approval.approvalpass":`La solicitud de aprobación de #obj fue aceptada. #objname`,
"label.chatter.owner":`Propietario`,
"vue_label_commonobjects_view_kanban_view":`Vista Kanban`,
"message.please.choose.group.role":`Seleccione rol de grupo`,
"label.icon.136":`Moneda`,
"label_tabpage_selectdate":`Seleccione una fecha`,
"chatter.emailInformation":`Información general`,
"front-lightning-module-v1-dashborad-bubble-size":`Tamaño de la burbuja`,
"label.stdashbord.xsld.business.wan":`Diez mil`,
"label.datamanage.field.notexist":`El campo correspondiente al objeto no existe`,
"UG.Forcast.04":`Iniciar prueba`,
"UG.contact.02":`Atraer a los contactos a través de múltiples canales: llamadas, correos, redes sociales`,
"vue_label_pool_selecttransferinto":`Seleccionar el grupo público de transferencia`,
"label.quote.xingming":`Nombre`,
"label.customerinfo.userlicencenum":`Licencias de usuario`,
"label.group.no.my.archived":`No se encontraron los grupos archivados`,
"label.weixin.add.activity.tel":`Añadir llamada de actividad`,
"label.partner.setup.address":`Dirección de la nube del socio`,
"label.data.file.i_title.num3":`3. El sistema preleer el archivo de datos para el servidor, luego empieza la importación masiva en el backend, va a notificar a los usuarios sobre el resultado via correo, no necesite esperar en la página actual.`,
"label_sum_up":`Suma`,
"label.searchall.title":`Búsqueda global`,
"label.bind.chooseone":`Elegir propietario`,
"label.campaign.channel.input.owner.select1":`Propietario de campa?a actual`,
"front-kefu-moudle-v1-Expand-chat":`Ampliar los detalles del chat`,
"label.component.hotdeal":`Transacciones destacadas`,
"component_event_label_title":`Eventos porvenir`,
"No.planed.activity":`Actividad no planeada`,
"label.searchlayout.result.field":`Campos mostrados en los resultados de búsqueda.`,
"label.leadscore.value":`Valor`,
"vue.dashboard.linkage.is.set.successfully":`¡Enlace establecido con éxito!`,
"PersonalInfo.LoginHistory.001":`Enlace de verificación del correo de registro del navegador`,
"front-gantt-module-v1-problem-number":`Números del problema`,
"label.page.step5.of.step5":`Paso 5 de 5`,
"label.sendemail.chat.sendmessagesubject":`Aviso de mensaje de CloudCC CCChatter`,
"label.Linkedin_accounts":`Cuenta de LinkedIn`,
"label.qrcode.useful.life":`Validez del código QR`,
"deleterow":`Canelar línea`,
"label.forecast.settings.future1":`1 ciclo del futuro`,
"message.error.group.operation":`Error de archivo del grupo`,
"label_tabpage_loadz":`Página cargando, espere...`,
"label.brackets.left":`(Paréntesis izquierda`,
"label.source.code":`Ver código fuente`,
"setup_layout_label_areasetup":`Configurar propiedad de sesión`,
"component.assistant.label.todaylead":`Los clientes potenciales asignados a usted hoy`,
"label.qrcode_signin":`El código QR se limita a las aplicaciones que requieren el escaneo de códigos en el lugar y el inicio de sesión`,
"label.calendarshare":`Compartir el Calendario`,
"IMG":`Imagen`,
"label.use.rule.when.both":`Aplique esta regla cuando habilite el código de barras y el código QR al mismo tiempo.`,
"label.ccpeak.addshare.record":`Nuevo registro de formulario compartido: revise el registro nuevo.`,
"label.enable.email.tracking":`Activar el seguimiento de correo`,
"label.top.plsinput":`Buscar esta lista...`,
"vue_label_helpcenter_case":`Los casos son preguntas, comentarios o problemas de los clientes. Los agentes de soporte pueden revisar los casos para entender cómo proporcionar un mejor servicio. Los representantes de ventas pueden utilizar los casos para entender el impacto en el proceso de ventas. La respuesta a los casos individuales puede satisfacer a sus clientes y mejorar su imagen de marca.`,
"label.useonly":`Privado`,
"label.displaytype":`Tipo de mostrar`,
"label.most.user.group":`Los usuarios pueden unirse hasta 100 grupos. Se ha unido a 100 grupos`,
"label.umeng.activity.yourevent":`Sus eventos`,
"label.forecast.shrepage.classdes.w":`Leer/Escribir-Los usuarios pueden ver y cubrir los datos pronosticados.`,
"label.defaultaccess":`Acceso predeterminado`,
"label.partner.new.step2":`Paso 2: Confirmar plantilla`,
"component_setup_iframe_label_title":`Página personalizada`,
"label.sso.saml.sp.idenitytype":`Tipo de identidad SAML`,
"label.dashboard.this.folder":`Cuadros de Mando en esta carpeta`,
"label.data.newtemplate.e.seltype.desc":`Hay dos tipos de exportación de datos: </li><li class`,
"label.forecast.customforecast.submit.tip1":`Si entrega sus previsiones de:`,
"label.version.workflow.and.approval":`Flujo de trabajo y automatización del proceso de aprobación`,
"label.tianyancha.tip":`El texto introducido es incorrecto, por favor, vuelva a introducirlo.`,
"label.report_details":`Detalles del informe`,
"template.report.folder.contract.product":`Análisis de contratos y productos`,
"label.all":`Todo`,
"label.version.area.long.rich":`{0}campos de área de texto rico o texto largo`,
"label.enc":`Almacenamiento encriptado`,
"vue_label_pricebook_enterproductname":`Introduzca el nombre del producto`,
"label.edit.quote.line":`Editar la fila de oferta`,
"label.edit":`Editar`,
"M":`Relación de Maestro-Detalle`,
"front-kefu-phonenumber-exists":`El asiento nº {a} ya existe`,
"label.standardplatformuser":`Usuarios Estándar de la Plataforma`,
"label.custom.page.configuration":`Editar página personalizada`,
"url.error.contact.null":`La dirección del miniservicio está vacía`,
"label.sethelp":`Configuración de ayuda`,
"setup.mainpage.label.welcome23":`Configuración de seguridad`,
"label.sales.page.dashboard.fenxi":`Panel de análisis de ventas`,
"label.limit":`Acceso`,
"maintenanceasset.asset.contractlineitem.illegal":`Debe seleccionar el activo en la partida contractual antes de asociar la partida contractual con el activo de mantenimiento`,
"UG.contact.04":`o`,
"Opportunity.Detailed.Phase.Label.004":`día(s)`,
"label.emailobject.receive":`Destinatario`,
"label.brief.new":`Recién creado`,
"label.marketsea.button.adopt":`Reclamar`,
"label.select.up.to.three.fields":`Se puede seleccionar un máximo de tres campos.`,
"vue_label_allsearch_noresults":`Hemos buscado sus opciones de búsqueda habitual, no se ha encontrado ningún resultado que coincida con {userInput}`,
"Report_CantDelete_Info":`?El informe {0} está referenciado por el panel {1}, y no se puede cancelar!`,
"label.chile.summer.time":`Hora de Chile`,
"label.partnerCloud.menu.selectedMenu":`Menú seleccionado (los menús seleccionados se sincronizarán con la aplicación)`,
"vue_label_report_onlysummary":`Solo resumen`,
"front-template-V1-Applicable-object":`Por favor, elija el objeto aplicable.`,
"label.invoice.message.sendfailed":`Envío de factura se frascasó, intente de nuevo más tarde`,
"front-kefu-moudle-v1-use-free":`PRUEBA GRATUITA`,
"label.rule.updated.successfully":`Actualizar las normas con éxito`,
"label.owner.lastone":`Mantener por lo menos una condición`,
"label.appointment.wizard.subtitle1":`Duración de la reunión`,
"template.report.opportunities.closed.month":`Oportunidades cerradas de este mes`,
"label.tabpage.choosecontent":`Seleccione el contenido del valor`,
"template.chart.jbnddxl":`Ventas de pedidos en el último semestre`,
"label.fieldsecurity.detail":`Detalles de la Seguridad de los Campos`,
"label.knowledgebase.data.deleted.successfully":`{a} datos borrados con éxito`,
"label.sso.saml.idp.config.nameidfmt":`Formato del Nombre ID`,
"label.emailobject.prompt":`Indicación`,
"label.marketsea.isgetbyself":`Permitir a los miembros reclamar por ellos mismos`,
"label.winxin.cancelprompt":`La operación actual no ha sido guardado, ?Está seguro de salir?`,
"label.appexchange.installedpage.message2":`Las aplicaciones y componentes son instalados como paquetes de software. Las aplicaciones, menús, objetos personalizados, páginas personalizadas y triggers se marcan inicialmente como ¨En desarrollo¨ y no se implementan para los usuarios. Que le permite probarlos y personalizarlos antes de implementarse. Puede utilizar otras funciones de configuración para implementar componentes individualmente o hacer clic en implementar para implementar como componente.`,
"vue_label_import_importtype":`Tipo de importación`,
"label.data.importef.des":`Los archivos fallados en importar se guardarán por 48 horas en el servidor y se cancelarán automáticamente después de 48 horas.`,
"chatter.email.reply":`Comentar sobre mis publicaciones`,
"label.stdashbord.xsld.business.sdl":`Tasa de pérdida`,
"labal.emailtemplate.namemessage":`El nombre único de la plantilla de correo ya existe, ingrese de nuevo`,
"vue_label_email_Please_select_file":`Seleccione archivo`,
"label.event.modify":`Editar eventos`,
"label.projectManagement.isnmber":`Introduzca un número con un decimal como máximo`,
"lable.outlook.detail.emailst":`Configuración del Correo`,
"label.partnerCloud.priceOfManual.isUsed":`Este ajuste determina si los socios pueden o no utilizar este libro de precios para hacer pedidos.`,
"setup_mainpage_label_welcome26":`Gestión de datos- Tratamiento masivo`,
"label.file.version":`Versión`,
"pagecreator_systemstyle_label_bordercolor":`Color del marco`,
"label.approval.isallowed.reject.prompt":`¿Permitir rechazo al aprobar datos individuales? (La aprobación por lotes siempre puede ser rechazada)`,
"label.myinfo":`Información personal`,
"front-template-V1-fontSize":`Tamaño de la fuente`,
"lable.outlook.edit.alpreo":`Siempre preferido Exchange`,
"front-email-payment-card-number":`Número de tarjeta`,
"label.cpq.quote.pricebook.no.change":`Una vez que se ha determinado el libro de precios para un presupuesto, no se puede cambiar. Por favor, cree un nuevo registro de cotización para utilizar un nuevo libro de precios.`,
"vue_label_file_size_limit_tip":`El tamaño del archivo ha superado el límite`,
"lable.PowerProcess.worktime":`Tiempo de trabajo del proceso de asignación`,
"label.monthly.month.report":`Informe mensual interanual y mensual`,
"front-kefu-moudle-v1-sydq-buyuser":`Su rastro se debe. Por favor, compre el Easemob para mantener el uso`,
"label_tabpage_Rolesz":`Roles y subordinados`,
"chatter.f.n":`Seguir este registro`,
"UG.Forcast.02":`Las previsiones son estimaciones de las ventas previstas para un periodo determinado, y los modelos de previsión pueden ayudar a determinar la demanda de productos y los ingresos por ventas en un periodo determinado. Los directivos pueden utilizar las previsiones para establecer objetivos y medir el progreso del equipo. La previsión global de la organización puede reflejar el resumen de todas las ventas por representante de ventas (independientemente de la fase de realización de las ventas, desde la fase de tramitación hasta la fase de cierre).`,
"label.productsales.contract.phb":`Lista de Contratos`,
"label.umeng.insert.approval.submit":`El #solicitante presenta el #obj para su aprobación`,
"message.duplication.label.matchfirstletters":`Primero N caracteres coincide`,
"label.partnerCloud.partnerAccount.toPay":`Ir al pago`,
"label.model.un":`Modelo: UN6786`,
"label.save.c1":`El nombre de "Web To CloudCC" no se puede repetir.`,
"week":`Semana`,
"Pagelayout.Setup.003":`Se debe seleccionar el campo del nombre obligatoriamente`,
"label.query.detail.openpartnermessage":`Una vez que el cliente está activado como socio, aparecerá en informes filtrados y vistas de lista en el campo isPartner. Además, los cliente de socio puede crear de contactos asociados con este cliente. ?Está seguro?`,
"label.validate.function.funcFormat.DATEVALUE":`DATEVALUE(date)`,
"label.apply.send.false":`Envío fallido`,
"label.recordtype.edit.selectvalue":`Valores de la lista de opciones`,
"label.chosesubject":`Seleccione un tema`,
"label.validate.function.funcExplain.YEAR":`El a?o de la fecha de regreso es un número entre 1900 y 9999`,
"component.chatter.button.more":`Ver más detalles`,
"label.top.class.smallest":`El nivel mínimo de la jerarquía es 1`,
"label.startingvalue":`Número de inicio`,
"label.multi.layout.remark":`El dise?o que se aplica a la importación Maestro-Detalle y agregación masiva`,
"label.role.availableuser":`Usuarios disponibles`,
"label.weixin.iebrowser":`La versión del navegador actual es IE6, que fue lanzado por Microsoft en 2001, la versión es demasiado baja, el sistema de CloudCC ha sido desarrollado utilizando nueva tecnología, no garantizamos que todas las funciones se pueden utilizar normalmente, descargue y actualice a tiempo su navegador. `,
"Homepage_News_004":`No hay nueva noticia`,
"vue_label_normal_task_sf":`Tarea`,
"label.version.nonsupport.trigger":`?No se permite trigger temporalmente!`,
"pagecreator_page_label_pagelayout":`Dise?o de página`,
"label_tabpage_step3":`Paso 3: Seleccione el campo para mostrar`,
"label.canOnlyUploadCSVFormatFile":`Sólo se puede subir fichero en formato CSV`,
"label.b.c.least":`Cada registro "B" debe tener al menos un registro "C" relacionado.`,
"label.list.userinterface.sales.enable":`En el Ranking de la página oficial de ventas, revise los permisos de activación de datos`,
"label.umeng.approval.approvalreject":`La solicitud de aprobación de #obj fue aceptada. #objname`,
"vue_labenl_normal_notice_share_fail":`No se ha podido compartir`,
"label_emailtocloudcc_tip":`Indicación`,
"label.h5.touchselect":`Haga clic en seleccionar`,
"label.tabularreport":`Reporte Tabular`,
"label.app.defaulttab":`Menú predeterminado`,
"label.validate.function.category.Datetime":`Fecha y Tiempo`,
"vue_label_pricebook_editdetail":`Editar las entradas de la lista de precios`,
"vue_label_commonobjects_view_no_selected_record":`No se ha seleccionado ningún registro`,
"chatter.changed":`Cambiado`,
"label.asset.bom.based":`Generar la lista de materiales de los activos según la estructura de los productos del pedido`,
"label.appointmentdetail.wizard.title8":`Empezar cada`,
"label.area.query.user.error":`La búsqueda de los datos de usuarios correspondientes a las regiones se frascasaron, la región ID está vacía.`,
"page.field.masterinput":`Configure Registro Maestro-Detalle`,
"chatter.selads":`Seleccione destinatarios`,
"label.data.exp.please.savebutton":`Revise ¨Guardar como plantilla¨`,
"label.members.activity":`Miembros de la actividad`,
"label.weixin.click.searchs":`Haga clic para buscar registro`,
"label.input.least.two":`Ingrese por lo menos dos caracteres`,
"label.marketing.seting":`Configuración de Marketing Cloud`,
"label.approveprocess.tip":`Aprobación es un proceso de negocio complicado que requiere la recolección de información y la planeación. Se recomienda que siga las instruccione siguientes antes de comenzar.`,
"front-email-payment-Invoice-login-account":`Cuenta de acceso`,
"label.selectmulti.mes":`Demasiado remitentes seleccionados`,
"label.workflow.gotolist":`Regrese a la lista de flujo de trabajo`,
"label.profile.fieldsafety":`Securidad del Nivel de Campo`,
"front-project-module-v1-no-selectemplat":`No hay plantilla disponible`,
"label.sendemail.queue.assigntitle":`El objeto de asignación de cola registra la notificación de correo`,
"label.approval.mobile.comments.placeholder":`Por favor, introduzca un comentario aquí, de hasta 1000 palabras`,
"vue_label_report_given":`Indicado`,
"vue_label_dashboard_groups":`Seleccione el grupo`,
"label.service.gantt.popoverTip":`Distancia y tiempo de viaje`,
"label.mr.title.characters":`De acuerdo con la longitud de los caracteres`,
"label.passwordPolicy.setup.day":`Días`,
"label_tabpage_personvisible":`Visible para las personas relativas`,
"ct":`Multi-monedas`,
"label.chatter.newEvent":`Nuevo evento`,
"vue_label_systemSettings_id":`Identidad de inicio de sesión`,
"label.page.preview.web.tab":`Vista previa el menú del Web`,
"label_emailsync_button_sure":`Confirmar`,
"front-template-V1-Modification-time":`Tiempo de modificación`,
"vue_label_homepage_edit_fixed_components":`Editar componente estándar`,
"label.apply":`Aplique`,
"Main.Menu.Mobiledownload":`Disponible para`,
"vue_label_salesfunnel_notice6":`Importe total de oportunidades de negocio con 100% de probabilidad`,
"label.chosesubject.sendemail":`Enviar Correo`,
"label.changemydisplay.chagetab.des":`Seleccione los menús que van a mostrar en cada una de sus aplicaciones.`,
"label.attendance.setting.checkUser":`Ya existe en otra asistencia.`,
"label.list.projectSetting.setup":`Configuración de la gestión de proyectos`,
"label.app.introduce2":`Puede personalizar las aplicaciones existentes para coincidir con su manera de trabajo, o establecer nuevas aplicaciones a través de agrupar los menús estándar y personalizados`,
"label_emailsync_form_emialpassword":`Contrase?a`,
"label.Lightning.Setting":`Ajustes de Lightning`,
"label.print.preview":`Prevista de imprimir`,
"label_vue_create_edit_obj_create_event_dialog_desc_alert":`¿Sigue queriendo crear el evento en este plazo?`,
"label.mobile.phone.report.type":`Tipo de informe`,
"lable.account.CalenderWeek":`Calendario Semana`,
"label_emailtocloudcc_step3total3":`Paso 3 de 3`,
"label_tabpage_emailaddressz":`Correo del remitente`,
"label.data.is_woking":`Operando`,
"label.knowledge.cancelattach.case":`Cancelar Adjuntar al caso`,
"label.sendemail.chat.chatcontent":`Contenido de la publicación principal:`,
"label.timezone.set":`Configuración regional`,
"label_tabpage_uploadingz":`Subiendo`,
"front-epwechat-module-v1-home-url":`URL de la página web:`,
"label.reportsSubscription.select.subscription.frequency":`Por favor, seleccione la frecuencia de suscripción.`,
"label.validate.function":`Función`,
"label.partnerCloud.orderingPlatform.quantity":`Cantidad`,
"label.compact.layout.chatter":`CCChatter`,
"label.sso.saml.sp.description2":`Configurar inicio de sesión único para que los usuarios puedan ingresar a CloudCC del ambiente externo`,
"label.ccchat.message.new.error1":`No podemos encontrar ningún usuario de Chat con el nombre de {0}`,
"label.file.share.email.content3":`Por más detalles, por favor ingrese al sistema CRM de CloudCC`,
"label.file.cancel.sharing":`Cancelar el compartido`,
"label.changemydisplay.showalltabs.add":`Añadir menú a la pantalla predeterminada`,
"label_chatter_incident":`Evento`,
"label.file.folder.delete3":`¿Está seguro de que desea cancelar {foldername}?`,
"label_tabpage_delsuccessz":`Cancelación exitosa`,
"label.view_contact":`Ver Contacto`,
"label.deactivate":`Prohibir`,
"label.Horizontal.Date":`Filtrar citas de servicio según la fecha horizontal`,
"label.forecast.tree.title":`Jerarquía de previsiones`,
"vue_label_dashboard_dategruop":`Seleccione el criterio de agrupación de fechas`,
"label.version.nonsupport.custompage":`?Páginas personalizadas no están disponibles temporalmente!`,
"label.tabpage.personvisible":`Visible para el personal pertinente`,
"message.error.unknown":`Error desconocido;`,
"label.down":`Abajo`,
"label.multilang.customforcast.financialyear":`El {0}a?o fiscal`,
"label.dataimport.type.error":`Error del formato, por favor revise el registro y modifique.`,
"label.batchadd.newbatchpage.save.num":`El formato numérico incorrecto`,
"front-Dev-V12.2.8-calendar-endField":`Campo final`,
"label.tabpage.rtemptyz":`El tipo de registro no puede estar vacío`,
"vue_label_dashboard_maximum":`Introduzca el valor máximo`,
"label.expiredate":`Fecha vencida`,
"label_emailtocloudcc_button_view":`Ver`,
"label.event.future":`Eventos del futuro`,
"label.mobile.app.layout":`Dise?o de la aplicación Móvil`,
"label.emailobject.contacts":`  contacto(s)`,
"label.approvalstep2.tip":`Especificar si el registro alcance los criterios antes de entrar en el paso siguiente.`,
"label.usefollowtoset":`Utilice las opciones siguientes, especifique el usuario para que asignen a la solicitud de aprobación.`,
"label.dashboard.summary.editPageHeader":`Editar encabezado`,
"label_partner_workspace_tab_memo":`Seleccione los menús para esta nube de socio, puede seleccionar menú estándar o menú personalizado.`,
"front-lightning-module-v1-details-page-chart-title-supports":` El Título permite insertar un nombre de registro con un formato de {nombre de registro}, como "Importe de oportunidad de {nombre de registro}". Si el nombre del registro actual es CloudCC, entonces se mostrará como "Importe de la oportunidad de CloudCC".`,
"label.enable.generate.location.service":`Activar el servicio de generación de datos de latitud y longitud del cliente en función de su dirección`,
"label.loginsystem":`Iniciar sesión`,
"label.email.template.edit.template":`Editar plantilla`,
"vue_label_commonobjects_detail_share":`Participación en los ingresos`,
"label.icon.142":`Casa`,
"label.maintype":`Maestro`,
"label.step2.total4":`Paso 2 de 4`,
"label.select.intended.tablayout":`Seleccione el dise?o de página del menú de Web que quiere crear`,
"label.custom.unit":`Unidad`,
"label.mr.title.phone":`Móvil`,
"label.compact.layout.frame.showtype":`Mostrar método:`,
"label.associations":`Objeto asociado`,
"label.potentialcustomers.name":`Nombre de candidatos`,
"label.edit.profile":`Actualizar perfil`,
"label.tabpage.allvisible":`Visible para todos los usuarios`,
"label.login.verification.confirmation.enabled":`Confirmar la activación`,
"vue_label_norm_recordselected":`{selectNum} dato(s) seleccionado(s)`,
"label.partner.workspace.member.selectedprofile":`Perfil seleccionado`,
"label.divide":`/Dividir`,
"label.version.case.control":`Gestión del Caso`,
"label.attendance.nocheckin":`No registrado`,
"vue_label_helpcenter_report2.1":`2.Eliminar la agrupación de filas: <br> A. Después de encontrar el campo de "agrupación de filas" que desea eliminar en la lista de "fila de grupo" a la izquierda, haga clic en la "×" en el cuadro de campo. <br> B. O encuentre el campo de "agrupación de filas" que desea eliminar en la cabecera del informe de vista previa a la derecha, haga clic en el "botón desplegable", y haga clic en "eliminar fila de grupo".<br> Eliminar la agrupación de columnas: <br> A. Después de encontrar el campo "Agrupación de columnas" que desea eliminar en la lista "Columnas de grupo" de la izquierda, haga clic en "×" en el cuadro de campo. <br> 1. B. O encuentre el campo de Agrupación de filas que desea eliminar en el encabezado de la tabla del informe de vista previa a la derecha, haga clic en el botón desplegable y haga clic en Eliminar fila de grupo. <br> Para eliminar una agrupación de columnas:<br> A. Busque el campo Agrupación de columnas que desea eliminar en la lista Agrupar columnas de la izquierda y haga clic en la "x" del cuadro de campo. <br> B. O busque el campo de Agrupación de columnas que desea eliminar en la cabecera de la tabla del informe de vista previa a la derecha, haga clic en el botón desplegable y haga clic en Eliminar columna de grupo. <br>? Personalización de la granularidad de la fecha para agrupar registros<br> Paso 1: Después de agrupar por campos de fecha, también puede personalizar la granularidad de la fecha. Primero, seleccione el campo de fecha por el que desea agrupar el informe. A continuación, haga clic en el botón desplegable situado junto a este campo en la cabecera del informe de vista previa y haga clic en Base de agrupación de fechas. <br> Paso 2: Seleccione cómo desea agrupar: Día, Mes, Año, Trimestre contable, Año contable, Trimestre personalizado, Año personalizado. <br>? Paso 1: Después de encontrar la columna que desea resumir en la cabecera del informe de vista previa, haga clic en el "botón desplegable" y haga clic en "Resumen". <br>`,
"label.payment.renew":`Renovar`,
"vue_label_file_wrong_type":`Error en el tipo archivo subido, el formato de archivo que está subiendo ahora es {type}!`,
"UG_opportunity_005":`Proceso de múltiples ventas`,
"label.knowledge.language.korean":`Coreano`,
"label.customobjects.inputrecordtagandformat":`Ingrese la etiqueta y formato de registro`,
"label.h5.chatter.commentednum":`Respuesta recibida`,
"label.quickbooks.button.unlink":`Desvincular`,
"label.step5.total5":`Paso 5 de 5`,
"label.projectManagement.Selweek":`Seleccione la semana`,
"label.optional.searchfield":`Campos de búsqueda seleccionable`,
"label.mobile.quickcreate.default.signin":`Registrarse`,
"label.visualpage.unable.parse":`Etiqueta no analizable`,
"mesage.error.role.delete":`No puede eliminar el rol porque ha sido asignado un rol secundario.`,
"label.role.user":`Usuarios en el rol`,
"button_partner_workspace_saveas":`Guardar como`,
"label.file.no.public.link.created":`No hay enlace público creado`,
"label.login.access.shenyu":`Restante`,
"label.ccchat.group.section":`Grupo`,
"label.weixin.object.notnull":`El tema no puede estar vacío`,
"label.accmarketsea.add.title":`Nuevo grupo público`,
"label.sales.funnel.layout":`Dise?o de embudo de ventas`,
"pagecreator.page.button.edit":`Editar`,
"label_tabpage_entercontent":`Ingrese los contenidos`,
"component_event_label_begindate":`*Hora de inicio`,
"label.file.versionhref":`Saltar a la versión nueva&gt;&gt;`,
"label_chatter_send":`Enviar`,
"setup_layout_label_buttonlist":`Seleccione botones`,
"label.custom.Current.and.NexttCQ":`Trimestre personalizado actual y los 3 siguientes`,
"pagecreator_page_label_pagedesc":`Descripción de la página`,
"label.appupload.upload.uploader":`Subido por`,
"label.console.step5.tab.primary":`Como el menú principal`,
"vue_label_globalsearch_expandlist":`Expandir lista`,
"label.forecast.edit.userqu":`Objetivo de`,
"label.step1.total5":`Paso 1 de 5`,
"label.multilang.dupicatecheck.onegroupredata":`Proceso de verificación de duplicados y combinación: un total de {0}grupos:`,
"vue_label_systemSettings_repeat":`Gestionar los duplicados`,
"label.mobile.side.tab.error1":`Seleccione los funciones comunes y menú de aplicación que se requieren mostrar`,
"label.knowledgebase.reduction":`Restaurar`,
"label.standard.buttonandlink.override.usedefault":`No descubre (Uso predeterminado)`,
"dateandtime":`Date/Hora`,
"label.group.activate.info":`Grupo activado`,
"label.triggertotask":`Triggers de tarea`,
"label.emailobject.save.template":`Guardar el borrador como una plantilla`,
"label.audit.objInfo":`Detalles del proceso de aprobación`,
"label.callcenter.successfully.logged.account":`Se ha iniciado la sesión con éxito.`,
"label_new_customer_target":`Nuevo objetivo de cliente`,
"label.campaign.channel.step5":`Paso 5: Vista previa de la página de registro de las canales de marketing y código de origen`,
"label.log.type":`Tipo de operación`,
"front-template-V1-noTemplate":`No se han encontrado plantillas disponibles bajo el objeto conmutado.`,
"label_report_line_daixuan":`Columna de reporte pendiente`,
"label.tianyancha.businessverify.relation.tip":`Escriba los campos regresados de tianyancha al campo de cliente`,
"label.default.value":`Utilice este valor como el valor predeterminado para la lista de opciones principal`,
"label.weixin.campaign.attendance":`Asistencia de campa?a`,
"message.duplication.label.check":`Revisar`,
"label.salescloud.salescloud.yes2forbidden":`Sí, prohibir la venta del grupo`,
"lable.currencyAdv.exchagecurrency.rate":`Rango de tasa de cambio:`,
"lable.Hide.title":`Ocultar títulos`,
"label.finishedreport":`Informes generados`,
"vue_label_account_business":`Transferir las oportunidades de negocio cerradas del propietario del cliente`,
"vue_label_pool_assigned":`Asignado`,
"label.report.export.error":`Error de exportación, intente de nuevo.`,
"label.layout.availablefield":`Campos disponibles`,
"label.licence.remainder":`Licencias restantes`,
"label.approval.idea.required":`Comentario de aprobación es obligatorio`,
"front-kefu-moudle-needhand-createcase":`Se requiere una confirmación manual antes de crear el caso`,
"label.dashboard.snapshot.Data.change":`Origen de datos cambiados, configure de nuevo`,
"label.partner.workspace.login.footertext":`Textos de Pie`,
"vue_label_chatter_upload_link_type":`Se ha seleccionado el post de enlace de carga`,
"front-dialog-module-v1-error-detail":`Detalles del error`,
"label.emailobject.sendgroupemail":`Enviar correo masivo`,
"lable.newtabpage.allviews":`Todas las vistas`,
"label.khdd":`Localidad de clientes`,
"vue_label_dashboard_sortfield":`Ordenar campos`,
"label.form.sample":`Ejemplo de formulario`,
"component_setup_button_cancel":`Cancelar`,
"vue_label_salesfunnel_notice5":`Importe total de oportunidades de negocios con 1%-99% de probabilidad* probabilidad`,
"pagecreator_systemstyle_label_modifystyle":`Editor del estilo`,
"UG_homepage_001":`Obtener más transacciones en poco tiempo`,
"label.campaign.pc":`PC`,
"label.visualpage.lightning":`Versión Lightning`,
"label.knowledge.category.hint.two":`Utilice esta página para seleccionar el grupo para Lightning después de crear el grupo de categorías.`,
"label.south.africa.standard.time":`Hora Estándar de Sudáfrica`,
"label.service.gantt.reservation.number":`Número de pedido`,
"label.weixin.report.period":`Período`,
"label.leadtomap.exp":`Utilice menú para mapear los campos personalizados de cada candidato de su organización a cliente personalizado, contactos o campos de oportunidad. Los mapeos son utilizados al convertir candidatos en clientes, contactos u oportunidades.`,
"label.currency.d":`Puede cambiar la moneda empresarial a otra moneda soportada por su organización. Todas las tasas de conversión definidas en CloudCC.com se modificarán apropiadamente para reflejar este cambio.`,
"label.forecast.detailforecast.oppyclb":`Categoría de pronóstico de oportunidad`,
"label.reportsSubscriptionPage.email.selected":`Miembros seleccionados`,
"vue_label_homepage_componentname":`Introduzca el nombre del componente`,
"lable.account.Previous.FYt":`Dos a?os fiscales anteriores`,
"label.appupload.success":`Carga completada`,
"label.customer.newtab":`Crear el menú de la página personalizada`,
"label.value.notnull":`Debe ingresar un valor`,
"label.case.miniprogram.layout":`El diseño de página del informe de miniprogramas es el diseño de página utilizado para la solicitud de servicio del terminal del miniprograma, y este diseño es editable pero no borrable.`,
"label.partnerCloud.partnerAccount.twoDecimal":`Por favor, introduzca el formato correcto.  Se pueden mantener dos decimales.`,
"UG.Lead.004":`Formulario web`,
"label.umeng.activity.event.eventwillbeginnew":`Notificación de evento:#event empieza en#begintime`,
"label.projectManagement.subtasks":`Subtareas`,
"vue_label_checkduplicate_repeat_conditions":`Condiciones de reconocimiento de duplicados`,
"label.subject":`Asunto`,
"label_search_otherusers_forecast":`Buscar las previsiones de otros usuarios`,
"label_tabpage_namemandatory":`El nombre de vista es obligatorio`,
"label.timezone.importtimezone":`Configuración de zona horaria para la importación de datos`,
"label.mobile.buttom.team.init":`Inicialización del usuario del plan de equipo`,
"label.checkfield.choosefield":`Seleccione los campos para encontrar los duplicados`,
"label.b_c_least":`Cada registro ¨B¨ debe tener por lo menos un registro relacionado con ¨C¨.`,
"label.knowledge.setting.hint.five":`Seleccione un autor de conocimientos`,
"label.h5.similar.opportunity.step2":`Paso 2. Especifique los criterios coincidentes`,
"label.page.style.imbedded.cloudcc":`Utilice el estilo de página completa para maximizar el contenido de la pantalla incrustado en la ventana de CloudCC.com`,
"label.sendemail.marketactivity.invitecode":`El código de invitación de la campa?a #campaignname`,
"label.block.pricing":`Precios por bloques`,
"message.error.field.number.zero":`Error del formato de longitud ingresada, no puede ser 0.`,
"pagecreator.systemstyle.message.save.success":`Estilo guardado con éxito`,
"pagecreator_systemstyle_label_styledesc":`Descripción del formato`,
"APPIntegration_Dropbox_setting_01":`Activar`,
"label_emailtocloudcc_redmessage2":`Ingrese la contrase?a correcta de su correo`,
"label.user.special.operations":`?Exclusivo para los operadores, no se puede utilizar temporalmente, por favor contacte con el administrador!`,
"pagecreator_page_label_layoutpreview":`Vista previa del dise?o`,
"APPIntegration_Dropbox_setting_03":`Active Dropbox para le permita seleccionar ficheros de Dropbox y añadirlos como adjuntos.`,
"label.sure_leave":`¿Seguro que te vas?`,
"label.applt.copylink":`Copiar el enlace del miniprograma`,
"label_tabpage_allpotentialcustomers":`Todos los candidatos`,
"label.rulestrikedate":`Regla de trigger de hora`,
"label_tabpage_justsz":`Justo ahora`,
"label.customize.memory.function.sorting.title":`Personalizar la función de ordenación de mi memoria`,
"message.duplication.label.mergebutton":`Combinar`,
"chatter.group.cancelRequest":`Cancelar la solicitud`,
"label.campaign.channel.step6.remark":`Si la página de registro está confirmada, haga clic en el botón Generar para generar la página de registro.`,
"label.appupload.upload.install.abort":`Cancelar la instalación`,
"label.emailobject.proposetimes":`Reserva de viaje`,
"label.probability.cannot.empty":`La posibilidad no puede estar vacía, y debe ser número`,
"vue_label_homepage_editkanban":`Editar Kanban`,
"lable.Related.template":`Plantillas relevantes`,
"label.cloudccclass.list.cls.time":`Clase programada`,
"component.task.label.enddate":`Fecha de validez`,
"label.sendmail.step3":`Paso 3: Revisar y confirmar`,
"label.projectManagement.Gridview":`Vista de rejilla`,
"label.emailobject.time":`Hora de envío`,
"label.applt.address":`Portal de atención al cliente del miniprograma`,
"label.searchfield":`Buscar campos`,
"vue_label_calendar_please_enter_the_name":`Introduzca el nombre`,
"label.list.userinterface.default.page.setup":`Página predeterminada del sistema`,
"label.detail.2018":`Detalles`,
"label.webtocloudcc.success":`Las informaciones han sido enviadas con éxito. Gracias por su participación, le serviremos de todo corazón.`,
"component_telerecord_label_title":`Registrar llamada`,
"label.setting.sureDelete.rules":`¿Está seguro de que quiere eliminar esta regla?`,
"vue_label_email_current_theme":`Al insertar esta plantilla, se sobrescribirá el tema actual del correo electrónico`,
"lable.Order.product":`Pedir el producto`,
"UG_product_02":`Los productos se refieren a los productos o servicios de ventas o de compras.`,
"label.appexchange.task":`Tareas del flujo de trabajo`,
"label.selectprocesscondition":`Especificar condiciones de paso`,
"label.mobile.quickcreate.default.scan":`Escanear`,
"label.tabpage.prepagez":`Mostrar en cada página`,
"label.query.error":`Error de consulta`,
"label.tabularreport.2018.step1":`Paso 1: Seleccione la columna de informe`,
"pagecreator.systemstyle.label.modifystyle":`Editor de estilo`,
"label.app.step3":`Paso 3: Seleccione origen de la imagen para el logo de la aplicación personalizada`,
"label_tabpage_rowsz":`Cancelar filas`,
"label.validate.function.funcExplain.SUBSTITUTE":`Reemplace new_text por old_text de esta cadena de caracteres. Utilice SUBSTITUTE cuando quiera reemplazar los textos específico de la cadena de caracteres`,
"vue_label_checkduplicate_select_data_to_merge":`Seleccione los datos a fusionar`,
"vue_label_commonobjects_view_chart_displaymode":`Modo de visualización`,
"label.industrialandcommercialverification.servicesetiings":`Configuraciones del Servicio`,
"label.refresh":`Refrescar`,
"label.taskfield":`Campo de tareas`,
"label.notification.approval4":`【提交人】está solicitando la aprobación de 【对象英文单数】`,
"label.group.isusing":`Activo`,
"label.language.settings":`Ajustes del idioma`,
"front-kefu-moudle-please-login":`Por favor, inicie sesión primero`,
"label.page.double.line.cloudcc":`2 Columnas con la barra lateral de CloudCC. Com`,
"folder.error.delete":`1. La carpeta actual contiene informes y no puede ser eliminada. 2. La carpeta actual contiene informes ocultos y no puede ser eliminada. El informe oculto es un informe creado en base a un objeto lógicamente borrado (configuración-crear-objetos borrados bajo el objeto), porque el objeto no está realmente borrado, por lo que el informe está oculto`,
"eight":`Ocho`,
"label.marketseamemset.user":`Miembro`,
"label.recordnum":`Número de Registro`,
"page.404.button.back":`Volver al paso anterior`,
"label.mobile.phone.month.plan":`Plan del próximo mes`,
"label.marketseamemset.account.title2":`Por favor, establezca un límite superior en el número de clientes que afecte a todos los miembros. El límite no se aplica al grupo público.`,
"vue_label_chatter_current_avatar":`Icono actual`,
"label.mobile.side.tab.remark3":`Presione Shift o haga clic directamente y arrastre para seleccionar una serie de ítems adyacentes; presione Ctrl y haga clic para seleccionar varios ítems no adyacentes`,
"component.sendmail.label.touser":`Destinatario`,
"label.homeitems.noobject":`No hay subjeto`,
"template.report.overall.sales":`Período total de ventas (por fuente de clientes potenciales)`,
"label.partner.donotdel":`No puede cancelar`,
"label.service.miniProgram.bindCopyDesc":`Después de vincular su organización a la cuenta oficial de su empresa o al miniprograma, puede utilizar esta dirección como su propio portal de atención al cliente copiando y saltando a esta dirección con un solo toque.`,
"UG_Contract_01":`Gestionar contrato`,
"UG_quota_06":`Crear una cotización`,
"vue_label_report_deletereport":`Eliminar informe`,
"front-epwechat-module-v1-input-appname":`Por favor, introduzca el nombre de la aplicación`,
"label_tabpage_deleteviewsuccess":`Cancelación exitosa de la vista`,
"component_chatter_label_mygroup":`Mi grupo`,
"label.campagin.roi.leixing":`Tipo de campa?a`,
"label.dashboard.myHomepageDashboard":`Mi panel de la página oficial`,
"UG_solution_04":`Importar solución`,
"label.knowledge.setting.hint.four":`Activar el conocimiento`,
"label.campaign.channel.add.field":`Haga clic en el botón para añadir campos`,
"label.eastem.european.time":`Hora de Europa del Este`,
"label.partner.workspace.member.partner":`Perfil de socio de CloudCC`,
"label.campaignmember.main.backtocampaign":`Regrese a las campa?as`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.absolute":`Absoluto`,
"label.task.unsolve":`Todas las tareas abiertas`,
"label.multilang.chatterservice.vote":`{0} voto (s)`,
"label.console":`Consola`,
"label.emailsync.message1":`Si cancelas la asociación, no podrás sincronizar el contenido del correo con los clientes potenciales y los contactos, ¿está seguro de que quiere cancelar?`,
"pagecreator.systemstyle.label.stylename":`Nombre del estilo`,
"setup_mainpage_label_welcome16":`Instrucciones: Haga clic en el menú a la izquierda de la página → Configuración de aplicación → Crear → Flujo de Trabajo, Proceso de Aprobación, Tarea, Notificación de Correo, Actualización, y etc.`,
"message.duplication.label.editfilterule":`Editar la regla del filtro de duplicados`,
"Account.News.Setting.004":`Habilitar noticias`,
"label_tabpage_saveviewsuccess":`Guardar con éxito la vista`,
"label.forecast.forehistory.replacecommit":`Reemplazo de compromiso`,
"pagecreator_button_cancel":`Cancelar`,
"label.knowledge.article.nomatch":`No se ha podido archivar este artículo porque hay borrador asociado. Elimine el borrador e inténtelo de nuevo`,
"vue_label_combined_field":`No hay campos que sumar`,
"label.batchadd.save.prompt":`registro(s)`,
"label.tabpage.summaryway":`Modo de resumen`,
"label.check.input.condition.two":`No se admite SQL`,
"mail.apiCode.notOnly":`El único nombre ya existe`,
"UG.quota.01":`Gestionar las ofertas de los clientes`,
"label.approved.receiveApprovalEmail.option3":`Solo cuando soy un aprobador delegado`,
"label.stdashbord.xsld.business.img5":`Monto total de probabilidad 0%`,
"vue_label_chat_movedfromto":`{name} ha cambiado {label} de {oldField} a {newField}`,
"label.customfields.new.step2.opration":`Opciones generales`,
"label.dashboardSetup.isurl":`Si a?ade los enlaces`,
"label.forecast.settings.mrfwqj":`Ciclo de previsión`,
"label.campaign.channel.field":`Campos`,
"label.weixin.optionthree":`Opción 3`,
"label.safetystatement":`Declaración de seguridad`,
"label.useskipwizard":`Usar el Asistente de Inicio Rápido`,
"label.projectManagement.completion":`Estado de completitud`,
"label.customfields.fielddependency.new.step2":`<b>Paso 2: </b>En las página siguientes, edite las reglas de filtro que controlarán las valores aparecidos en el campo de dependencia para cada valor en el campo de control.`,
"setup.mainpage.label.welcome8":`Personalización de la interfaz mediante arrastre`,
"label.emailobject.list.outbox":`Bandeja de salida`,
"label.app.default.login.tab":`Login predeterminado`,
"label.follow_emails":`El correo electrónico de seguimiento es una gran manera de contactar rápida y fácilmente con sus visitantes una vez que envían los formularios.`,
"vue_label_homepage_application_page":`Página de inicio de la aplicación`,
"label.confirm.template":`Confirmar`,
"lable.product.not":`No se puede completar la cancelación de`,
"label.multilang.feedtrack.dispalyinfo":`Puede seleccionar {0}campos al máximo:`,
"label.weixin.plz.inputsrhkey":`Ingrese una palabra clave de búsqueda`,
"label.projectManagement.service.appointment":`Cita de servicio`,
"label.list.userinterface.watermark.enable":`Marca de agua en la página de inicio, vistas, detalles de registros, informes y cuadro de control de la APP y ordenador`,
"label.confirmDelete":`¿Estás seguro de que quieres borrar estos datos?`,
"label.sso.description":`Los usuarios pueden acceder al sistema CloudCC.com sin iniciar la sesión de acuerdo con el nombre de usuario y código de autorización.<br>Haga clic en la URL siguiente para acceder al sistema CloudCC.com: http://localhost:8080/ssologin.action?userName=admin@dev.com&authCode=dcc5c192facd7c08e124fbe93d8950b9 .<br>Utilice el enlace arriba,'http://localhost:8080' Reemplace el acceso de su organización al enlace.'admin@dev.com' reemplace el nombre de usuario de su organización.<br>'dcc5c192facd7c08e124fbe93d8950b9' reemplace el código de autorización de su organización.`,
"errormessage_email_atleastonereceiver_z":`Debe seleccionar o editar por lo menos una dirección del destinatario`,
"C":`Resumen Acumulativo`,
"label.service.major.event.edit":`Editar evento clave`,
"label.icon.9":`Servicio`,
"label.visualpage.notvalidate.check":`Página personalizada inválida, refiera a la Ayuda  para revisar la página.`,
"label.audit.todo.from":`De:`,
"label.directboss":`Este rol reporta a`,
"label.manageAll.selpage":`Página`,
"label.console.step6.all":`Pantalla completa, sin fijar y las listas son visibles sólo cuando el menú de navegador sea seleccionado`,
"vue_label_pool_expiredate":`Fecha de vencimiento`,
"lable.no.matching.record":`No hay registro de coincidencia`,
"label.standard.redirecterror":`Saltar a la página personalizada via botones estándar se frascasó`,
"label.Platform.Setting":`Configuración de la plataforma`,
"lable.outlook.edit.havenewc":`Contactos con los últimos eventos creados`,
"label.partnerCloud.partnerAccount.choosePayment":`Seleccione un método de pago`,
"label.weixin.optionsix":`Opción 6`,
"lable.SalesCommitmentKanBan.allCommitments":`Pipeline`,
"page_404_button_toknowmore":`Conocer más`,
"label.customfields.number.tip":`Permite a los usuarios ingresar cualquier número. Los ceros iniciales se cancelarán`,
"label.import.index.processimport":`Importar`,
"label.quote.phone":`Teléfono`,
"label.insert.approval":`Insertar la aprobación`,
"label.tabpage.printview":`Vista de Impresión`,
"lable.product.price":`Precio`,
"front-kefu-moudle-call-detail":`Llamar a los detalles`,
"label.umeng.approval.apply":`Solicitar`,
"label.background.the.form":`Fondo del formulario`,
"chatter.f":`Seguidores`,
"label.quickbooks.searchresault.company":`Cliente`,
"vue_label_systemSettings_platformutils":`Herramienta de la plataforma`,
"front-quotation-v1-nofilles-tocreate":`Por favor, haga clic en Generar presupuesto y envíelo después de la generación.`,
"label.category.6":`Tratamiento Médico`,
"label.attendance.choose.positon":`Seleccione punto de referencia`,
"label.batchadd.newbatchpage.save.pho":`El formato del teléfono es inválido`,
"UG.Account.01":`¿Quién es su cliente?`,
"label.marketseamemset.addspecialuser":`Añadir miembros especiales`,
"label.query.detail.forbidpartneruser":`Prohibir los usuarios de socios`,
"label.stdashbord.xsld.business.ydzhl":`Tasa ganada`,
"vue_label_SMS_mymessagebox":`Mi buzón de mensajes`,
"label.knowledgebase.data.publishing.failed":`Ha fallado la publicación de los datos de {a}. Por favor, elija un artículo con estado igual a Borrador para publicarlo.`,
"label.wholestate":`Status general`,
"label.selectedline":`Columnas seleccionadas`,
"label.validate.function.funcExplain.LEFT":`Regrese los números específicos de caracteres desde el inicio izquierda de la cadena de textos`,
"label.emailmerge.edittemplate.detail":`Detalles de plantilla de fusión de correo`,
"vue_label_checkduplicate_checkduplicate":`Buscar duplicados`,
"label.knowledgebase.assign.articles":`Artículos de montaje`,
"label.tabpage.recordsz":`Registro`,
"label.field.img.validate.error":`El nombre variable despúes de $User está mal escrito o es una referencia ilegal de $User, revise la ortografía.`,
"workorderlineitem.worktype.isnot.father.worktype":`Debe seleccionar el tipo de trabajo asociado a su registro principal de este proyecto de orden de trabajo`,
"label.ccchat.group.name.noexist":`El nombre de grupo ingresado no existe, intente de nuevo`,
"label.weixin.sign.type":`Inicio de sesión(Cerrar sesión) tipo de error`,
"label.nowvaluereplace":`Reemplazar con los existentes`,
"report_label_report":`Informes`,
"label.knowledge.setting.plus":`Ajustes de Conocimientos Plus`,
"label.event.moveup.2day":`2 días con anticipación`,
"label.translation.start":`Empezar a utilizar la mesa de trabajo de traducción:`,
"lable.PowerProcess.created.time":`Basado en el tiempo de creación de {detailInterestType}`,
"label.ems.step2":`Paso 2`,
"label.tabpage.groupingemptyz":`Los elementos de agrupación no pueden estar vacíos`,
"pagecreator.layout.button.new":`Nuevo diseño`,
"label.tabpage.listshow":`La lista muestra`,
"label.partnerCloud.productSet.optionName":`Nombre de la opción`,
"label.service.without.cycle":`Sin ciclo`,
"label.chatter.sendEmailToGroupMember.subject.V":`{0} publicó votos para todos en {1}`,
"label_target_model_dimension":`Dimensión del modelo objetivo`,
"component.task.label.subject":`Asunto`,
"label.custom.field.login.query.information":`?Ingrese al sistema para ver los detalles!`,
"label.validate.function.funcExplain.NOT":`Cambiar FALSE a TRUE o cambiar TRUE a FALSE`,
"pagecreator_layout_button_horizontal":`División horizontal`,
"lable.Returned.to.successful":`Devuelto con éxito`,
"label.campaign.channel.ticket.title":`Billete de entrada`,
"label.ruleName.supportMaximum.50Characters":`Se admite un máximo de 50 caracteres para el nombre de las reglas.`,
"label.email.track.attachment.size.control1":`El tama?o total de los adjuntos excede 20M, no se puede subir.`,
"template.report.folder.opportunities":`Análisis de oportunidades`,
"label.knowledge.setting.data.eight":`Va a eliminar el grupo de categorías {flzmc} y sus categorías. Esta categoría no estará disponible para ser asignada a los registros. Tiene 15 días para cancelar la eliminación del grupo de categorías. Una vez transcurridos los 15 días, se eliminará de forma permanente y no se podrá recuperar. ¿Está seguro de que desea eliminar este grupo de categorías y sus categorías?`,
"mail.id.notNull":`El ID no puede estar vacío al borrar la plantilla`,
"vue_label_normal_product_sf":`Producto`,
"vue_label_report_superiortothisrelationship":`La relación entre el objeto superior y el objeto actual`,
"label.leadscore.operation":`Operador`,
"label.customfields.formula.percentexample":`Descuento(Amount - Discount_Amount__c) / Amount`,
"component.setup.iframe.label.inputurlmemo":`Introduzca el URL de la página a importar`,
"label.icon.177":`Logo`,
"label.tabpage.myz":`Mi`,
"label.leadmarketsea.add.title":`Nuevo grupo público de clientes potenciales`,
"label.partnerCloud.partnerAccount.thePage":`Página {skippageNum}`,
"label.visualpage.some.size":`Capacidad del Código: Máximo 300KB caracteres, aproximadamente 30,0000 bytes`,
"label.setwxpay.null":`La información requerida para configurar el pago de WeChat está vacía`,
"label.icon.74":`Herramienta De Máquina`,
"font-evaluate-module-v1-evbad":`El tipo de evaluación es Negativo`,
"System.TimeField.Format.Warning":`No es una hora válida`,
"label.captcha":`Código de verificación`,
"label.payment.assessment":`Evalúe otras versiones`,
"message.error.not.taskevent":`No es objeto del evento de tarea`,
"font-evaluate-module-v1-evaluation":`Valoración`,
"vue_label_commonobject_view_updatedago":`Actualizado hace {timeInterval}`,
"label.sendemail.birthday.newevent":`Estimado {!ownerName}：\r\n Dentro de 3 días va a ser el cumpleaños de {!objectLable}{!recordName}. ¡No lo olvide! \r\n                     {!orgName}`,
"label.laststep":`Paso anterior`,
"message.duplication.label.matchoption":`Coincidir con las opciones`,
"label.setupmultplerecordtype":`Tipo de múltiples registros`,
"vue_label_account_unprocessed_oppprtunities":`Oportunidades sin procesar`,
"KeyInformationLayout.DefaultLayout.Name":`Sistema por defecto`,
"label.partner.all":`Toda nube de socio`,
"label.datamanage.export.error":`?Exportación fallida!`,
"label.standard.buttonandlink":`Botón o enlace estándar`,
"label.reportsSubscriptionPage.email":`Informe de correo electrónico`,
"message.nogrammarfaultinformula":`No hay error de sintaxis en la fórmula`,
"front-kefu-moudle-nofind-instance":`No se ha encontrado ninguna instancia`,
"label.is.delete.data":`?Lo que quiere cancelar contiene los recordatarios por aprobar, está seguro de que desea cancelar?`,
"label.partner.error":`Error: Error del formato de dominio`,
"label.notification.time2":`Hace {0} minutos`,
"label.ccchat.person.invite.needfirstname":`Ingrese su nombre`,
"label.mr.title.URL":`URL`,
"chatter.norecord":`No hay registros.`,
"label.readwrite":`Leer/Escribir`,
"label.partnerCloud.orderingPlatform.orderPayment":`Pedir el pago`,
"label.accesslimittype":`Nivel de Acceso`,
"label.preciew_tab":`Vista previa del enlace en una nueva pestaña`,
"label.attachment":`Adjunto`,
"label_tabpage_helpNavigationz":`Ayuda y guía`,
"label.dataimport.select":`Marque esta información, ejecute al importar los datos`,
"chatter.en.info":`Ingrese información para que la gente conozca sobre usted`,
"label.ccservice.validate.date":`?El formato del valor correspondiente {2} del campo{1} bajo la API de objeto {0} es incorrecto. Ingrese el formato de fecha o hora correcto!`,
"label.social.posts.send":`No se ha podido publicar`,
"label.emailobject.time.to":`A:`,
"label.defineReportStep1":`Paso 1`,
"savefail":`Se falló en reservar`,
"label.mr.descreption.title":`Fusionar datos duplicados`,
"label.share.info.by":`Por`,
"label.list":`Lista`,
"label.event.select":`Seleccionado`,
"message.accountmap.cannotfind":`No puede encontrar la dirección de clientes, actualícela`,
"label.choosefield":`Aprobar el campo de página`,
"label.forecast.settings.title":`Configuración de previsiones`,
"label.setup.log.datetime":`Descargar el log de comportamiento dentro del rango de tiempo(Excel.xls)`,
"button_partner_new":`Crear nube de socios`,
"label.umeng.approval.dlsp.reject":`#approvalname ha rechazado la solicitud de #actorname#objAPIName #recordname para usted`,
"label.tabpage.totalTeamz":`Total de grupos`,
"label.lead.score.prompt3":`El proceso de puntuación lleva tiempo, una vez termine, recibirá un correo de confirmación.`,
"label.schedulejob.setup.schedule.name":`Nombre de tarea`,
"vue_label_report_advanced":`Cuando el filtro avanzado está activado, escriba manualmente la condición del filtro en el cuadro de filtro avanzado de abajo, el formato se muestra en la figura.`,
"label.emailsync.form.connecttime":`Tiempo de asociación`,
"front-gantt-module-v1-project-status":`Estado del proyecto`,
"label.field.for.example":`Por ejemplo`,
"label.marketsea.manager.notnull":`El administrador no puede estar vacío.`,
"label.click.here":`&lt&lt Ingrese aquí para regresar`,
"UG.solution.04":`Importar solución`,
"label.validate.function.funcExplain.IF":`Revise si la condición es verdadera, si la condición es TRUE, entonces regresará un valor; si la condición es FALSE, regresará otro valor`,
"label.profile.settab":`Configuración del menú`,
"front-email-payment-weichat-tips":`Escanear el código QR para pagar`,
"label.task.next.week":`Tareas de la próxima semana`,
"label.operatedata.selectobjectfields.tip":`Seleccione los campos que quiere exportar, y debe seleccionar por lo menos un campo para exportar. <font color="red"> Atención: ?rea de textos (Rico) no se puede exportar. </font>`,
"label.recalculate.alert":`Seleccione las reglas compartidas que quiere recalcular`,
"label.marketsea.noopportunitydays":`días sin crear oportunidades de negocio (tiene que ser mayor que el número de días sin seguimiento tras la obtención)`,
"label.chat.likeperson":`?Persona(s)`,
"label.selectedFields":`Campos disponibles`,
"label.App":`Aplicaciones`,
"label.file.type":`Tipo de archivo`,
"permissionService.error1":`Permiso de aplicación insuficiente`,
"front-detail-module-v1-chart-display":`Visualización de gráficos`,
"label.audit.status":`Status de aprobación`,
"UG.activity.05":`Registrar llamada`,
"label.connectOtherObject":`(Haga clic en vincular con otro objeto)`,
"lable.currencyManage.unEnabledadvcurrency":`Prohibir la gestión de moneda avanzada`,
"label.ccpeak.getthree.function":`Hay tres métodos, y `,
"label.weixin.new.weitoupiao":`Cree un nuevo microvoto, los usuarios pueden participar en la votación y acceder a los resultados en las microactividades por WeChat.`,
"label.tag.manage.prompt":`?La etiqueta ya existe!`,
"label.goon":`Continuar`,
"label.addworkflowoperate":`Añadir operación de flujo de trabajo`,
"label.weixin.click.search":`Haga clic para buscar registro`,
"vue_label_report_deletecolumn":`Borrar columna`,
"label.ordercondition":`Ordenar por`,
"message.error.group.notallow":`El grupo no permite archivar`,
"label.unread":`Correos electrónicos no leídos`,
"vue_label_report_notice_namerequired":`El nombre de la columna es obligatorio`,
"label.tabpage.entercontent":`Introduzca el contenido`,
"label.schedulejob.setup.schedule.startdate":`Fecha de comienzo`,
"component_assistant_button_newtask":`Tareas Nuevas`,
"vue_label_report_notice_filter1":`Hay que rellenar manualmente el(los) filtro(s) avanzado(s) <br?/>como se muestra en la imagen cuando se activa el filtro avanzado`,
"value":`Valores`,
"label.icon.70":`Servicio`,
"label.knowledgebase.delete.draft.t":`Borrar el borrador`,
"label.setup.mini.bind":`Vincular miniprograma`,
"component_timeline_button_more":`Más pasos`,
"label_emailtocloudcc_redmessage4":`Ingrese los detalles del portal`,
"label.field.input.number":`Ingrese los números correctos`,
"front-invoice-online-payment-setup-title":`Iniciar el pago en línea`,
"front-kefu-moudle-called-user":`Persona llamada`,
"label.currency.disable":`Monedas prohibidas`,
"label.user.alias":`Alias`,
"UG_quota_04":`Imprimir la cotización`,
"label.chatter.delete":`Eliminar`,
"label.addtocurrentcustomer":`Adjuntar a los usuarios existentes`,
"message.error.recordid.null":`¡recordid no puede estar vacío!`,
"label.merge.records":`Combinar los registros`,
"report_label_norole":`?No tiene permiso, contacte con el administrador!`,
"label.pqrs":`.`,
"label.email.attach.button":`Haga clic en el botón ¨Adjuntar¨`,
"label.tabpage.selrecordtypez":`Seleccione el tipo de registro`,
"label.ServiceCloud.purchase.date":`Fecha de compra`,
"label.customreporttype.delete.prompt":`Cancele el reporte siguiente antes de cancelar`,
"label.brief.total.page":`Un total de {total} página(s)`,
"label.reportsSubscription.unsubscribe":`Cancelar suscripción`,
"label.ccpeak.take.notice.exp.order":`Notas: debe añadir "__c" después del nombre API en las condiciones de exp y condiciones de ordering`,
"report_type_label_quote":`Cotizar`,
"label.file.norecord":`No hay ítems para mostrar`,
"vue_label_checkduplicate_all_processed":`Todos los datos han sido procesados`,
"label.next":`Siguiente`,
"label.icon.10":`Carpeta`,
"label.lanxin.title.setting":`Información integrada`,
"label.h5.chatter.business":`Asociar oportunidades`,
"lable.are.you.sure.to.delete.this.view":`¿Desea eliminar esta vista?`,
"vue_group_no_operation_permission":`¡No hay permiso para operar!`,
"label.knowledge.archive.article":`Artículo de archivo`,
"vue_label_lead_":`No hay reglas de puntuación activas, póngase en contacto con el administrador del sistema`,
"label.fiscal.error.between":`La fecha de inicio y la fecha de finalización del año contable se encuentran entre el período de tiempo de los años contables históricos, por favor, compruébelas y reconfigúrelas.`,
"label.stdashbord.xsld.business.qdzje":`Cantidad total de las oportunidades ganadas`,
"label.calendar.day.view":`Vista del día`,
"label.emailtocloudcc.tip":`Nota`,
"label.schedulejob.setup.schedule.st1":`La primera`,
"label_tabpage_addtoworkbench":`Añadir a la mesa de trabajo en la página oficial`,
"label.umeng.approval.waitapproval":`Por aprobar`,
"label.justcheckingwebsite":`Solo verificar los sitios web`,
"homepage.components":`Componentes de la página oficial`,
"label.audit.remark":`Notas de aprobación`,
"label.searchs.labelname":`Buscar {fieldlabelName}`,
"label.remarkofreport":`Notas de informe`,
"label.weixin.isno":`Si`,
"label.currencyCode":`Código de moneda`,
"label.service.resources":`Recursos`,
"label.clone_form":`Formulario de clonación`,
"label.weixin.view.information":`Detalle de Vista`,
"UG_activity_05":`Registrar llamada`,
"chatter.feed.menutype.user.recentuser":`La gente recién revisada`,
"label.marketsea.notfollowdays2":`días sin seguimiento`,
"label.tabpage.namemandatory":`El nombre de la vista es obligatorio`,
"message.demo.nosupport":`La función será lanzada en la próxima versión.`,
"label.mail.merge.template":`Combinar plantillas de correo......`,
"label.sendemail.marketactivity.sign":`Notificación de firma de la Compa?a`,
"setup_layout_group_relatedlist":`Listas relativas`,
"label.pc.ui.2018.all.tabs":`Todos los menús`,
"label.field.lost.right.bracket":`Pérdida de paréntesis derecho`,
"label.datamanage.contact.novalue":`?Atención: El campo de ¨Nombre de contacto¨ es nulo, el registro de contacto no se importará!`,
"label.version.unlimited.edition":`Versión ilimitada`,
"vue_label_dashboard_selectsortfield":`Seleccione ordenar campo`,
"label.partnerCloud.productSet.instructions":``,
"front-kefu-moudle-v1-canuse-obj":`Visible a`,
"thursday":`Jueves`,
"label.nextapprover":`Próximo aprobador`,
"setup_mainpage_label_manageuser":`Gestión de usuarios`,
"label.saveandcontinue":`Guardar y Continuar`,
"label.top.userCenter":`Centro personal`,
"component.chatter.file.button.save":`Publicar`,
"label_emailsync_setting":`Configuración del correo personal`,
"label.usableshareuser":`Compatible con`,
"label.customfields.optionlist.fieldvaluelist.letterrank":`Se muestran los valores por alfabetos, no por orden de introducir`,
"label.list.button":`Asignación de perfil`,
"chatter.up.m":`Error: Los archivos subidos son demasiado grandes. Tama?o máximo es de 20 MB.`,
"label.knowledgebase.filters":`{a} filtros`,
"label.sso.saml.sp.idtype.username":`La declaración contiene el nombre de la Cuenta CloudCC del usuario`,
"vue_label_file_size_limit":`El tamaño del archivo no debe superar {size}MB`,
"label.appupload.install.error.choice4":`Omita los componentes conflictivos, no los instale`,
"label.currencyDecimalDigits":`Dígitos de decimales`,
"label.weixin.customer.details":`Detalles de cliente`,
"component.timeline.label.7daysahead":`7 días anteriores`,
"label.sendsms.batch.step1":`Paso 1: Especifique los destinatarios para incluir`,
"label.brief.opportunity1":`Oportunidades`,
"label.datamanage.click.importbutton":`Hacer clic en </b> importar </b>  y los datos serán importados al sistema de CloudCC`,
"label_filter_benchmark_objects":`Objeto de referencia del filtro`,
"label.area.record.notexist":`El registro no existe`,
"label.event.overdue.unfinished":`Eventos vencidos`,
"label.file.publicview.errortype":`Este tipo de archivo no se permite la vista previa`,
"label.setup.mobile.bottombutton.profile.setting":`Personalizar el menú inferior del perfil`,
"label.campaignmember.main.addleaddesc":`A?ade todos los candidatos existentes a esta campa?a de una sola vez`,
"vue_label_approve_actual_operator":`Operador real`,
"label.version.essential":`Versión básica`,
"lable.SalesCommitmentKanBan.commitments":`Pipeline`,
"label.chatter.pastEvents":`Eventos pasados`,
"vue_label_calendar_choose_calendar_type":`Elegir el tipo de calendario`,
"label.service.dispatchingUnits.batch.send":`Asignar por lotes`,
"chatter.poll.option8":`Opción 8`,
"label_tabpage_summaryway":`Método de resumen`,
"front-kefu-moudle-trindex-copy-num":`Por favor, copie el número de la empresa en la página de inicio del sistema Tianrun`,
"lable.quote.syncing.syncfinish":`Sync completada`,
"label.home.task.finish":`Tarea finalizada`,
"label.toleadfield":`Campos de mapeo de los candidatos`,
"label.everyone":`Todo el mundo`,
"label.multilang.databatchadd.success":`{0}datos han sido cancelados con éxito`,
"label.quote.createdate":`Crear fecha`,
"email.template.nopermission":`Sólo los administradores pueden editar las plantillas de esta carpeta`,
"label.report.action.addtodashboard2":`Agregar al panel`,
"label.campaign.name":`Nombre de campa?a`,
"label.check.input.condition":`Error de sintaxis, revise los criterios de filtros ingresados`,
"front-epwechat-module-v1-upload-file":`Cargar documento de crédito:`,
"label.batchadd.newbatchpage.button.add":`Añadir una fila`,
"label.partnerCloud.footer":`Pie de página`,
"lable.Enter.template.name":`Por favor, introduzca el nombre del tamplate.`,
"label_tabpage_last":`Paso anterior`,
"label.setup.mobile.bottombutton.setting":`Configuración de la página de primer nivel de la aplicación móvil`,
"label_emailtocloudcc_filed_emailto":`Correo a`,
"label.data.downpage.e_title.num3":`3. Los usuarios pueden crear plantillas de exportación de acuerdo con sus necesidades y seleccione ¨Exportar via Plantilla¨ que deje la operación de exportación sea más conveniente.`,
"startwith":`Empezar por`,
"vue_label_normal_cancel":`Cancelar`,
"label.reportTypcrtD":`Asociar objeto (D) haga clic en seleccionar el objeto relacionado`,
"label.globalselect.disabledvalue":`Valor inválido`,
"vue_label_commonobjects_view_notice_deletecertification":`¿Está seguro de que desea eliminar los {?selectNum?} datos seleccionados?`,
"front-epwechat-module-v1-bound-role":`Funciones vinculadas`,
"label.partnerCloud.financeSetting.gaofilter":`Avanza las condiciones del filtro (por ejemplo, 1 y 2 o 3 )`,
"label.quote.sprname":`Nombre de facturación`,
"lable.asset.successfully":`Transferir el producto al activo con éxito.`,
"label.projectManagement.service.appointment.work.noedit":`No se puede editar las horas de trabajo de la cita de servicio`,
"lable.tianyancha.h5.inputandsearch":`Ingrese palabras clave para buscar empresas relacionadas`,
"label.customcomponent.check.tag.firstrow":`La primera línea debe ser`,
"label.knowledgebase.published.translations":`Las traducciones publicadas también se archivarán y la traducción en estado de borrador se eliminará.`,
"vue_label_wang_yi":`Tom`,
"label.step3.total3":`Paso 3 de 3`,
"label.stdashbord.xsld.business.img6":`Cantidad de estapas con posibilidad de 100%/(Cantidad de estapas con posibilidad de 100%   Cantidad de estapas con posibilidad de 0%)`,
"component_button_cancel":`Cancelar`,
"label.delete.false.not.exists":`La cancelación se ha frascasado, porque los datos no existen`,
"label.appupload.install.error.choice1":`No instale`,
"label.Days.After.Horizontal.Date":`Días después de la fecha horizontal`,
"setup_layout_button_additem":`Aañadirlos adir los ítems seleccionados`,
"UG.contact.05":`Crear un contacto`,
"label.form.title":`Título del formulario`,
"label.horizontalbar-group":`Línea Horizontal-Agrupar`,
"component_sendmail_label_title":`Enviar correo`,
"label.passwordPolicy.setup.neverexpires":`Nunca expira`,
"label.sso.saml.idp.config.desc1":`Activar CloudCC. com como proveedor de identidad, así que puede utilizar inicio de sesión único en otros sitios web y definir los proveedores aplicables a aplicaciones con el inicio de sesión único. No necesita registrarse para cambiar a proveedor diferente. `,
"label.chat.topic.desc.null":`?Por más información de este tema? En el menú desplegable de la parte superior derecha, seleccione editar detalles.`,
"label.movablecustomerfield":`Campos de eventos personalizados`,
"label.trigger.folder":`Carpeta de Trigger no archivado`,
"label.selectuploadfile":`?Seleccione un archivo para subir!`,
"front-email-payment-card-tips":`Por favor, introduzca el número de tarjeta`,
"label.tabpage.addcondition":`Añadir condición`,
"label.number.MinAndMaxCheck":`El mínimo de {0} es {1}, el máximo es {2}. Por favor, modifique la cantidad y guarde los cambios.`,
"vue_label_dashboard_dashboard":`Cuadro de mandos renombrado con éxito`,
"label.objectDeleteList":`Cancelar la lista de objetos`,
"lable.service.gantt.and":`Y`,
"label.emailtocloudcc.step2":`Paso 2`,
"label.chatter.postup":`Publicar`,
"label.personalsetting":`Configuración personal`,
"message.please.choose.permission":`Seleccione acceso`,
"label.mobile.move":`Aplicación móvil`,
"label.Choose":`Opciones`,
"label_chatter_vote":`Votar`,
"label.weixin.user.select.one":`Seleccione un usuario`,
"pagecreator.page.label.modifypage":`Editor de páginas`,
"label.select.partOrField":`Elija las partes o campos a controlar`,
"vue_label_helpcenter_chat":`1. Mensajería instantánea<br> La función Plan de Equipo puede reemplazar el WeChat corporativo y otras aplicaciones, permitiéndole enviar mensajes de texto, archivos, etc. a sus compañeros de la empresa mientras trabaja en el sistema CRM. Cuando cada departamento de la organización necesita establecer un grupo de discusión departamental, el líder del departamento puede iniciar un chat de grupo en el Plan de Equipo y agregar miembros al chat de grupo.<br> 2. Crear chats de grupo para los registros de clientes y oportunidades de negocio<br> Abra la página de detalles del registro de clientes u oportunidades de negocio y haga clic en el botón "Plan de Equipo" en la esquina superior derecha para crear un chat de grupo sobre este registro en el Plan de Equipo. Si el chat de grupo no es creado por el propietario del registro, el propietario del registro también será agregado automáticamente al chat de grupo. Otros usuarios pueden entrar en el chat de grupo haciendo clic en el botón "Plan de Equipo" en la esquina superior derecha de la página de detalles del registro o después de ser agregado por el propietario del grupo.<br> 3. Seguir los registros en el chat de grupo<br> Cree un chat de grupo para los registros de clientes y oportunidades de negocio según el método del apartado 4.2, y podrá seguir el estado de los registros en el chat de grupo mediante el envío de tarjetas. Si el usuario tiene el acceso para ver los registros en la tarjeta será transferido directamente a la página de información detallada del objeto correspondiente cuando cliquea en la tarjeta.<br>Seguimiento de los cambios de campo de registro en el chat de grupo<br> Cuando el registro está configurado con la lista relacionada "Seguimiento de campos" y se configuran los campos que necesitan ser rastreados, cuando se produce alguna modificación, el asistente de estrategia de grupo en el chat de grupo enviará una tarjeta con la información del cambio al grupo.<br> Seguimiento del cambio de propietario del campo registrado en el chat de grupo<br> Cuando el propietario del registro cambia, el asistente del Plan de Equipo enviará una tarjeta con la información de cambio del propietario al grupo.<br>Realizar un seguimiento de las actividades en los chats de grupo<br> Tras la creación del chat de grupo del registro, si se crea una nueva tarea o evento sobre este registro, el asistente del Plan de Equipo enviará una tarjeta con información básica sobre la tarea o el evento al grupo.<br> Seguimiento y registro del nuevo registro de la lista relacionada en el chat de grupo<br> Una vez creado el chat de grupo del registro, cuando se añada el registro de la lista relacionada, el asistente del Plan de Equipo enviará una tarjeta con la información básica del nuevo registro añadido al grupo. Por ejemplo: cuando se añade un nuevo contacto a la lista de contactos de registros de clientes, se enviará una tarjeta de "Nuevo Contacto" en el chat de grupo de clientes, y se mostrará en tarjeta la información básica del nuevo registro.`,
"label.tianyancha.business":`Información del registro comercial`,
"chatter.group.groupMembersToFind":`Buscar los miembros del grupo`,
"label.pc.ui.2018.pin.top":`Pin a la parte superior`,
"label.forecast.forehistory.submitor":`Entregado por`,
"vue_label_email_send_emails_separately":`Correos enviados por separado con éxito`,
"vue_label_homepage_select_display_field":`Seleccionar el campo a mostrar`,
"label.partnerCloud.partnerAccount.accountBalance":`Saldo`,
"label.sendemail.template":`Seleccione plantilla de correo`,
"label.service.violated":`Violado`,
"label.manageAll.title":`Centro de Permiso`,
"label.forecast.settings.qy":`Activar el compartido de previsiones`,
"label.detailofshare":`Detalles compartidos`,
"label.multilang.passwordpolicy.chechlength":`Error: la contrase?a debe tener al menos {0} caracteres`,
"label.visualpage.filesave.error":`Error al guardar el archivo, intente de nuevo`,
"vue_label_campaign_please_select_member_status":`Seleccione el estado del miembro`,
"homepage.components.sort":`Orden de componentes`,
"label.brief.thismonth":`Este mes`,
"label_emailsync_connectaccount_description":`Aquí agregue su correo personal, CloudCC coincide automáticamente los candidatos y contactos en el sistema de acuerdo con sus direcciones de correo. Sync los contenidos del correo con los registros para facilitar el seguimiento y comunicación.`,
"label.sms.csid":`Nombre de signatura`,
"label.ccdocument.remark":`Descripción del documento`,
"label.forecast.customforecast.disdw":`Unidad de visualización`,
"label_tabpage_field":`Campo`,
"label.logintime.all":`Todo el día`,
"UG_Account_06":`Crear un cliente`,
"label.login":`Ingresar`,
"label.dupicate.data.error":`Error de los datos duplicados y combinados, revise.`,
"label.monitorsys.recent.logs":`Los últimos 200 logs se muestran por defecto`,
"message.chooseatleastonefield":`Seleccione un campo al menos`,
"lable.PowerProcess.name1":`Nombre del proceso de asignación`,
"label.processdetail":`Trate definición de detalles`,
"label.upload.file.size.limit":`Los archivos cargados no deben superar los 2 MB`,
"label.forecast.userenablepage.desc":`Los usuarios que activan previsiones aparecerán en la lista ¨Usuarios activados¨. Para activar los usuarios disponibles, agréguelos a la lista de ¨Usuarios activados¨, Para bloquearlos, debe cancelarlos.`,
"label.visualpage.type.detailembed":`Instrucción de uso de la página personalizada(Tipo de página es ¨detailEmbed¨)`,
"label.textmessage.vonage.configurations":`Configuraciones`,
"label.report.select.chart.and.item":`Seleccione el gráfico y ítems destacados`,
"label.data.downpage.i.title.num1":`1. El sistema solo admite el formato CSV común.`,
"label.mobileapp.scansetting":`Configuración de escaneo en la Aplicación Móvil`,
"chatter.emailFollow":`Seguidores`,
"label.weixin.businformation":`Detalles de vehículo`,
"label.import.index.recentrecord":`Registros importados recientemente`,
"label.case.update":`Actualización`,
"label.isEnableVisualpage.new.desc":`Seleccione una página personalizada disponible en y añádala a las páginas personalizadas habilitadas y haga clic en Guardar. Este perfil tendrá acceso a las páginas personalizadas habilitadas.`,
"label.emailobject.wizard.title":`Vincule su correo`,
"vue_label_ccchat_notice_deletepostsuccess":`Post borrado con éxito`,
"label.deleteQuoteLine":`Borrar la línea de oferta`,
"label.integrations.export.failed.Mailchimp":`La exportación ha fallado, por favor compruebe su conexión de red e inténtelo de nuevo más tarde`,
"label.increase":`#NAME?`,
"label.setup.mobile.homepageshortcuts.setunable":`Este módulo no se mostrará en la página oficial`,
"label.ccchat.person.invite.toolong":`No puede ingresar textos superados a 255 caracteres`,
"label.knowledge.setting.help":`Ayuda al autoservicio del cliente`,
"label.is_pigeonhole":`Archivar`,
"message.atleastonecommitter":`Hay por lo menos una persona que envia`,
"label.emailobject.wizard.desc4":`Inserte un horario reservable para facilitar la invitación de múltiples personas`,
"APPIntegration_Dropbox_setting_02":`Prohibir`,
"template.report.open.opportunities":`Oportunidades no cerradas`,
"label.goonwork":`Seguir trabajando`,
"label.isiands.time":`Hora de las islas`,
"label.enable.rules.enableOnlyOneqrcodeOrbarcode":`Reglas habilitadas (cada objeto sólo admite un código QR o un código de barras)`,
"label.summaryreport.2018.step2":`Paso 2: Seleccione información por resumirse`,
"pagecreator.systemstyle.message.delete.success":`Estilo eliminado con éxito`,
"label.standarduser":`Usuario estándar`,
"label.reportsSubscription.succeeded":`Suscrito con éxito`,
"lable.Select.a.template":`Seleccione una plantilla existente como base de la nueva plantilla.`,
"label.file.library.addfile2libsuccess":`?{0} fichero (s) subido (s)!`,
"label.searchfield.instruction":`Buscar campo es para hacer la búsqueda general o búsqueda individual. Si no selecciona nada, buscará según los campos seleccionados de resultado`,
"U":`URL`,
"label.Time.slot.overlap":`Se superponen una o varias franjas horarias. Actualice a una franja horaria que no se superponga`,
"vue_label_chat_opportunity_details":`Detalles de la oportunidad`,
"label.knowledge.category.hint.seven":`Categorías seleccionadas`,
"label.chatter.list":`Lista`,
"front-email-payment-Invoice-preview":`Vista previa de la factura`,
"label_emailsync_message1":`Si cancele la vinculación, no puede sincronizar los contenidos del correo con los candidatos y contactos, ?está seguro de que desea cancelar?`,
"label.summaryreport.step5":`Paso 5: Especificar la orden de columna del informe`,
"component_newrecords_label_name":`Nombre`,
"label.appointment.wizard.subtitle4-4-5":`2 meses`,
"component_salesperformance_label_title":`Rendimiento de venta`,
"label.ccchat.person.invite.says":`Decir:`,
"label.fax":`Fax`,
"label.knowledge.modify.article":`Modificar el artículo`,
"label.componenteditor.Limit.number.components":`Se pueden añadir hasta 15 componentes en una sola página`,
"label.multilang.forecast.shrepage.desc":`Esta página alistará los usuarios, roles y regiones que tienen acceso a  {0}.`,
"label.chat.micropost.write.comment":`Escribir comentarios`,
"Lead.Scoring.Setting.Rule.Setup.Active":`¿Activar?`,
"label.ccpeakfolder.time":`Carpetas de clase programada`,
"label.partnerCloud.financeSetting.filter":`Condiciones del filtro:`,
"label.knowledge.delete.topicassignment":`Error al borrar la asignación de temas`,
"label.file.orderbyname":`Ordenar por título`,
"vue_label_chat_activelater":`Activar más tarde`,
"chatter.reply":`Comentario`,
"label.setup.profile.accordtext":`De acuerdo con los textos`,
"label.encd.plaintext":`Ver texto claro`,
"label.h5.approval.cannotreassignmark":`?tems de aprobación delegados no se permiten reasignar, seleccione de nuevo ítems de aprobación`,
"label.version.area.lookup":`{0}área de textos o campos de búsqueda de opciones múltiples`,
"approval.request.email.body":`Los siguientes elementos están pendientes de aprobación：\n Haga clic en el enlace que aparece a continuación para aprobar：\n`,
"label.user.mass.emails.select":`Correos Masivos: Seleccionar la Plantilla`,
"lable.quote.syncing.title":`Sync cotizaciones y oportunidades`,
"vue_label_dashboard_dashboardaccess":`Permiso de acceso al cuadro de mandos`,
"label_emailtocloudcc_filed_owner":`Propietario`,
"label.brief.page":`Página`,
"label.isEnableVisualpage_new.desc":`Seleccione una página personalizada disponible para a?adirla en la lista de página personalizada activada, después de guardarla, este perfil se puede visitar a las páginas personalizadas activadas.`,
"label.service.shift.view":`Vista de los turnos de trabajo`,
"label.emailsync.addnewaccount":`Añadir cuenta nueva`,
"label.forecast.settings.prompt":`Prohibir previsones compartidas removerá todos accesos que tienen compartido manual.`,
"front-electronic-signature-explain-second":`Al vincular la firma electrónica, prepare la foto de la licencia de empresa y el código de crédito social unificado.`,
"label.emailtocloudcc.redmessage3":`Introduzca la dirección del servidor`,
"message.confirmgiveupedit":`Si quiere salir de esta página, perderá todos los cambios no guardados. ?Quiere continuar?`,
"label.gantt.plan.success":`Programado con éxito`,
"label.monitorsys.type.error":`?Seleccione el tipo de búsqueda!`,
"label.industrialandcommercialverification.button.setup":`Configurar`,
"today":`Hoy`,
"label.attendance.setting.position":`Configurar lugar de referencia`,
"chatter.mynews":`Mis mensajes`,
"label.recycle.dis.tip1":`El sistema va a mantener los datos en la papelera de reciclaje por 15 días, se cancelarán permanentemente al pasar 15 días.`,
"label.icon.81":`Refrigeración`,
"label.customer.tab.page.prompt":`¡Configure al menos una página!`,
"label.globalselect.use":`Utilizar el conjunto de valores de la lista de opciones global`,
"template.report.customer.sales.order":`Orden de venta de cuentas con diferentes niveles`,
"vue_label_dashboard_lastruntime":`Tiempo de la Última Ejecución`,
"label.edit.ccpeakfolder":`Clasificación: Editar carpeta`,
"vue_label_lead_be_converted":`Ya está convertido, no se puede volver a convertir`,
"label.tabpage.filenamez":`Nombre del archivo`,
"label.please.click.add.products.":`Por favor, haga clic en "Añadir Producto" para añadir el producto al libro de precios.`,
"label.followup_emails":`Una vez que un visitante ha enviado un formulario, el seguimiento con un correo electr髇ico es una forma f醤il de conectar r醤idamente con ellos`,
"label.indochina.time":`Hora de Indochina`,
"message.error.task.email":`Error en la tarea del correo`,
"label.dynamic.copy":`Copiar simultáneamente las reglas del dise?o`,
"label.log.d":`Descargar log de auditoría dentro del rango de la hora de búsqueda(Fichero Excel.csv)>>`,
"pagecreator_layout_label_layoutname":`Nombre de dise?o`,
"template.chart.htsktj":`Estadísticas de recaudación de contratos`,
"label.appointment.wizard.subtitle4-2-5":`Un día`,
"label.view_form":`Ver formulario`,
"label.tablet":`Tableta`,
"label.campaignmember.main.addcontact":`Añadir Miembros-Contactos existentes`,
"message.get.userinfo.error":`Se frascasó en obtener información de usuario`,
"label.department.username":`Nombre de usuario`,
"label.ems.verifysuccess":`?Verficación exitosa de la cuenta de correo!`,
"label.batchedit.copyValue":`Aplicar a esta columna`,
"label.trigger.triggerVersion":`Versión`,
"label.mr.descreption.oneGroupReData5":`Datos del grupo no procesados`,
"label.appointmentconfirmpage.wizard.subtitle5":`Descripción`,
"label.weixin.inbetween":`Múltiples opciones`,
"label.salescloud.contactrole.relatelist.customnize":`Esta lista no se puede personalizar`,
"label.data.exp.please.nameanddes":`Rellene el nombre de plantilla y la descripción.`,
"label_partner_workspace_login":`Página de Login`,
"label.notification.approval7":`【被委派人名称】le ayuda a rechazar la solicitud de 【对象】【对象名称】 de parte de【申请人】.`,
"message.send.posts.image.error":`La carga de la foto ha fallado.`,
"message.fieldtrack.operateupdate":`Cambiado`,
"label.sharerule.grantuselevelconstructureaccess":`Autorice acceso de uso de jerarquía`,
"label.translation.setup":`Configuración multilingüe`,
"PageLayout.Search.MultiSearch.003":`Seleccione al menos un campo.`,
"label.ccchat.person.emaildomain":`Dominio del correo de empresa`,
"pagecreator.systemstyle.label.bordercolor":`Color del borde`,
"label.submit":`Entregar`,
"UG.Lead.001":`¿Cómo introducir las pistas?`,
"label.icon.172":`Mapa`,
"label_chatter_owner":`Propietario`,
"vue_label_systemSettings_Currency":`Gestión de divisas`,
"page.layout.binfo":`Información básica`,
"label.version.date":`{0}Campos de fecha`,
"label.data.is.woking":`En funcionamiento`,
"label.customfields.searchrelation.dependobjectDefault.tip":`Puede seleccionar un registro en el elemento relacionado como valor por defecto para este campo`,
"label.partnerCloud.orderingPlatform.configuration":`Productos de confección`,
"lable.currencyManage.Enabledadvcurrency":`Iniciar la Gestión Avanzada de Moneda`,
"label.event.moveup.3hour":`3 horas con anticipación`,
"label.reportexport.object":`Exportar objetos`,
"front-dialog-module-v1-requestid":`Solicitar ID`,
"label.pw.symol":`Símbolos`,
"label_group_field":`Especifique el campo de agrupación`,
"label.recallapprove":`Recordar solicitud de aprobación`,
"vue_label_pool_deal_done":`Trato cerrado`,
"label.shangqing.description":`Descripción de la información comercial`,
"label.view.allcansee":`Visible para <b>todos los usuarios</b>`,
"chatter.poll.addOption":`Añadir más`,
"label.icon.112":`Comida`,
"label.ignorecase":`Trate¨ABC¨ y ¨abc¨ como valores duplicados (sin distinguir entre mayúscula y minúscula)`,
"label.email.track.edit":`Editar correo electrónico`,
"label_tabpage_erraddressz":`El formato de la dirección de correo es incorrecto, ingrese la correcta.`,
"label_tabpage_viewz":`Imprimir vista actual`,
"component.timeline.label.future":`Siguiente paso`,
"label.b_c_without":`Los registros "B" pueden o no tener registros "C" relacionados.`,
"label.version.autonumberfield":`Campo del Número Automático`,
"label.appointmentdetail.wizard.title5":`Enlace de invitación`,
"label.weixin.addoption":`Añadir opciones`,
"label.b.c":`Relación B a C`,
"chatter.group.complete":`Completar`,
"label.must.numeric.value":`El coste debe ser numérico.`,
"lable.edit.queue.memberdes":`Para añadir miembros a esta cola, seleccione un tipo de miembro, luego seleccione un rol o usuario de ¨Miembros disponibles¨ y muévelos a ¨Miembros seleccionados¨. Si el modelo de compartido de todos los objetos en la cola es ¨Lectura/Escritura/Transferencia pública¨, no necesitará asignar usuarios a la cola porque todos los usuarios ya tienen acceso a los registros de estos objetos.`,
"label.staticresource.chose.limit":`Archivos de este formato no son compatibles temporalmente. Por favor espere la actualización de esta función.`,
"vue_label_commonobjects_view_kanban_unset":`Seleccione la base de agrupación en la configuración de la vista Kanban`,
"label.appexchange.download.merge.mes":`Los componentes pugnantes son instalados via una combinación:`,
"label.sharerule.baseofowner":`Basado en el propietario del registro`,
"label.email.template.manage.SMS":`Gestionar la plantilla de SMS`,
"label.imgfield.example.tip":`El ícono verde significa que está aprobado, y el rojo rechazado.`,
"template.report.potential.customer.industry":`Industria de los plomos`,
"component_hots_label_title":`Transacciones famosas`,
"label_file_use_document":`Uso del espacio de almacenamiento`,
"label.input.path":`Ingrese la ruta de referencia`,
"label.partnerCloud.financialSetup":`Configuración financiera de los socios`,
"label_tabpage_myz":`Mi`,
"vue_label_pool_discard1":`{1}{2}`,
"label_emailtocloudcc_tip2":`Después de la cancelación, no puede utilizar más Email to CloudCC, ?Está seguro de cancelar?`,
"label.customfields.fielddependency.sure":`Los valores del campo de control excluye el valor dependiente. ?Está seguro de continuar?`,
"label.project.task.date":`La fecha de la tarea debe estar dentro del rango de fechas del hito al que pertenece.`,
"Report.CantDelete.Info":`El informe {0} está siendo utilizado por el cuadro de mandos {1} y no puede ser eliminado.`,
"label.assignment.setup.title":`Regla de Asignación`,
"image.pt.most.maxsize":`Tama?o del fichero máximo es de 2 MB.`,
"label.appupload.introduce":`Un paquete debe contener los componentes como aplicaciones, objetos, menús, triggers, o páginas. Estos paquetes se pueden publicar en CloudCC App Store para compartir públicamente. La lista siguiente muestra todos los paquetes creados por su organización. Haga clic en ¨Nuevo¨ para crear un paquete nuevo.`,
"label.import.page2.confirm":`Confirmar`,
"label.console.step2.introduce":`Rellenar los campos siguientes para definir la consola`,
"label.extendsfather":`Controlado por Parent`,
"front-homepageobject-module-v1-year":`Este año`,
"front-grasp-sales-opportunities":`El CRM le ayuda a dominar con precisión las oportunidades de venta, a adquirir más clientes potenciales, a proporcionar presupuestos rápidos y a cerrar más acuerdos, al tiempo que consigue un marketing omnicanal y mejora continuamente el ROI corporativo.`,
"label.tab.oldpage":`Página de la versión antigua`,
"label.service.miniProgram.intro":`Introducción`,
"label.data.import.setup.operate.insert":`No actualice los registros existentes, sólo inserte registros nuevos`,
"label.ccpeak.direction.for.use":`Descripción del Uso de la plataforma de CloudCC[Versión 2.0]`,
"label.sendemail.chat.addComentsmyFeedsubject":`Respuesta de micro-publicación CloudCC Cchatter`,
"label.campaignmember.main.importmember.contacts":`Importar miembros-Contactos`,
"setup.mainpage.label.welcome20":`Plantilla de correo y SMS`,
"label.newbatcheditor.remark":`Para diferentes registros, hay diferentes tipos de registro. El sistema utilizará dise?o del primer tipo de registro como el dise?o predeterminado para la edición masiva.`,
"label.step4.total7":`Paso 4 de 7`,
"label.campagin.roi.tzhbl":`Retorno de la Inversión`,
"label.emailmerge.mergepage.step3":`Registre un evento`,
"label.marketsea.isrecyclecreatebyself":`¿Desea reciclar el cliente creado por usted mismo?`,
"message.mobilechooseatmost.five":`En los dispositivos móviles se puede seleccionar un máximo de 5 campos en el menú.`,
"label.icon.171":`Casa De Huespedes`,
"label.saveandnext":`Guardar & Siguiente`,
"label.import.page1.selectcodingtype":`Elija el tipo de codificación`,
"label.searchlayout.displaybutton":`Botones mostrados`,
"label.approvalstep5":`Paso 5: Seleccione las propiedades de edición de los campos para mostrar en el dise?o de la página de aprobación`,
"label.passwordPolicy.setup.enforcePswHis":`Historial de contrase?a obligatoria`,
"vue_label_commonobjects_detail_contact_hierarchy":`Jerarquía de contactos`,
"front-kefu-moudle-v1-trythjzx-intelligent":`Centro de llamadas de servicio inteligente TRRT(tinet)`,
"label.select.statistical.indicators":`Elija el índice estadístico`,
"label.callcenter.Tianrun.RONGTONG":`TRRT(tinet)`,
"label.file.library":`Base de documentos`,
"lable.completion.rate.color.setting":`Ajuste del color de la tasa de completitud`,
"label.name.firstname":`Nombre`,
"setup_layout_label_readonly":`Solo leído`,
"label.chatter.recordcall":`Se ha registrado la llamada`,
"label.service.appointmentList.service.empty":`La cita de servicio está vacía`,
"component_milestones_label_choicestate":`Confirmar este status`,
"label.approved.receiveApprovalEmail.option2":`Sólo cuando yo sea el aprobador`,
"label.marketseamemset.account.title":`Ajustes de los miembros del grupo público`,
"label.changemydisplay.list.custom":`Personalizar mi menú`,
"label.emailtemplate.selecttype":`Seleccionar la plantilla de correo`,
"component_timeline_label_title":`Línea de tiempo`,
"chatter.group.addRemoveMembers":`Añadir/Remover Miembros`,
"label.console.step6.width":`Ancho`,
"pagecreator.systemstyle.message.delete.fail":`No se ha podido eliminar el estilo`,
"label.partnerCloud.orderingPlatform.productPrice":`{cantidad de productos}productos，{cuenta total} piezas, precio original：{divisa} {preciooriginal}，descuento：{divisa} {Reducción}`,
"label.h5.share":`Compartir`,
"label.schedulejob.setup.list.tip":`Configure los trabajos programados para que se realicen automáticamente a intervalos semanales o mensuales`,
"message.intheapproving":`Este registro está en el proceso de aprobación, no puede enviar de nuevo.`,
"vue_label_commonobjects_detail_real_time":`Después de unirse, el plan de equipo se mostrará en su lista de plan de equipos, y el estado del equipo se le notificará en tiempo real.`,
"label.autoRegister.changepwd.setpwd.too.weak":`Demasiado corto`,
"label.salescloud.forbiddenteamsales":`Prohibir grupo de ventas`,
"component.chatter.link.label.title":`Enlace`,
"label.layout.editsearchdistribute.page":`Seleccione las páginas personalizadas que debe incluir en la página de menú.`,
"label.dashboard.show.value.percent":`Valor mostrado o mostrar %, seleccione por lo menos uno`,
"label.everymonth":`Mensual`,
"label.campaign.channel.download.size1":`Tama?o grande: 1000*1000 pixeles`,
"permissionService.error2":`No se ha podido añadir permisos de aplicación`,
"button.partner.workspace.manage.memo":`Gestionar su nube de socio, y configure las propiedades de nube de socios.`,
"label.forecast.forehistory.commit.remark":`Entrega las notas`,
"six":`Seis`,
"label.datamanage.donot.export.object":`Los objetos que no se permiten exportar datos.`,
"label.schedulejob.setup.schedule.execute":`Ejecutar`,
"lable.account.CurrentandPreviousCY":`A?o calendario actual y anterior`,
"label.temp.SMS":`Plantilla SMS`,
"label_partner_all_state":`Status`,
"label.editdocument":`Editar propiedades`,
"front-epwechat-module-v1-ios-single":`Inicio de sesión único en iOS`,
"lable.redo":`Rehacer`,
"vue_label_SMS_alltemplates":`Todas las plantillas`,
"label.allfolderreport":`Carpeta de todos los informes`,
"label.layout.alltab":`Todos los menús`,
"lable.account.Yesterday":`Ayer`,
"label.formula.to.evaluate":`Evaluación de la Fórmula`,
"component_setup_label_setupsaveok":`La configuración de componentes se guardan con éxito`,
"pagecreator_page_message_canntdelete":`La página actual no puede cancelar`,
"label.tab.message.failtotp":`No se han configurado las pestañas`,
"label.h5.chatter.location":`Insertar localidad`,
"vue_label_commonobjects_view_chart_gotodashboard":`Ir al cuadro de mandos`,
"label.data.exp.conf":`?Está seguro de que quiere exportar datos?`,
"label.currency.e":`Editar el tipo de monedas`,
"message.matrixReportSetupStage.column":`Seleccione【Título de línea específica】 base de subtotal, debe seleccionar por lo menos una base de subtotal entre las dos.`,
"font-evaluate-module-v1-have-comment":`Dejó una evaluación`,
"chatter.feed.dao":`A`,
"label.import.index.notice":`Nota:`,
"label.weixin.information":`Detalles`,
"label.multilingual.tip5":`El estado multilingüe no es correcto. Por favor, actualice e inténtelo de nuevo.`,
"label.appointment.wizard.subtitle3-7":`Domingo`,
"label.emailobject.groupemail.fail.content":`Estimado{0},\r\nLa dirección de correo del envío masivo fallida es.{1}\r\n                      CloudCC`,
"vue_label_notice_uploadavatar_fail":`No se ha podido cargar icono`,
"chatter.group.myGroup":`Mi grupo`,
"label.ccpeak.object.fieldapi.name":`Es el campo de nombre API del objeto`,
"lable.activeCurrency":`Activar monedas`,
"label.file.save.to.send":`Guardar y enviar`,
"label.emailmerge.list.editfolder":`Editar carpeta`,
"label.Path.Setting":`Ajuste de rutas`,
"label.validate.function.funcFormat.DATE":`FECHA(a?o,mes,día)`,
"message.objapiexists":`El objeto API ya existe`,
"label.sendmail.batch.confirm":`Correo masivo: confirmar`,
"message.approval.cannotsubmit.detail":`Este registro no cumple las condiciones ni la presentación inicial para ningún proceso de aprobación válido. Póngase en contacto con su administrador para obtener ayuda.`,
"setup.layout.button.deleteitem":`Eliminar los elementos seleccionados`,
"label.end.loginipIP":`Direccion finalizada de IP`,
"component_event_label_subject":`Tema`,
"message.500":`Se ocurrió un error del servidor interno`,
"label.wei.polltype":`Tipos`,
"vue_label_norm_duplicate":`Duplicado`,
"label.addcycletrigger":`Añadir trigger periódico`,
"DetailedInfo.Activity.EmailMessage.01":`{0} ha enviado un correo electrónico a {1}`,
"No.Activity":`No hay actividad`,
"label.chat.topic.add.topic":`Haga clic en añadir un tema`,
"label.schedulejob.setup.schedule.morning":`AM`,
"chatter.save.al":`Su modificación ha sido guardada.`,
"label.setsharerule.step3":`Paso 3: Seleccione los usuarios con los quiere compartir`,
"label.tabpage.Sdfez":`días antes`,
"label_submit_forecast":`Presentar previsión`,
"label.version.sum.formulafield":`Campos de fórmula`,
"lable.weixin.you.invitation":`Invitado por usted`,
"label.stacked.horizontalbar":`Apilado-Líneas horizontales`,
"label.file.anyone.can.link":`Cualquiera que tiene el enlace puede ver y descargar el fichero.`,
"label.campaignmember.main.importmember.lead.desc":`Importar candidatos de los ficheros`,
"UG_activity_01":`?Como hace el seguimiento para interactuar con sus usuarios y grupos?`,
"label.reason":`Razón`,
"label.version.free.createmax":`?Se permite crear hasta 2000 registros, ya llegó al límite!`,
"label.brief.thisweek":`Esta semana`,
"label.deleteobjinapprove":`Ingrese las notas antes de cancelar este objeto del proceso de aprobación`,
"calendar.tips.event":`día(s) sin eventos`,
"label.customerinfo.mailinfo":`Información del correo de empresa`,
"lable.electronic.signature":`Firma electrónica`,
"label_emailsync_addnewaccount":`Añadir nueva cuenta`,
"label.layout.exampleoftesgobj":`Ejempo del objeto de prueba`,
"label.happen_submit":`¿Qué debería ocurrir después de que un visitante envíe este formulario?`,
"label.forecast.customforecast.button.submit":`Enviar`,
"label_right_click_notice":``,
"font-trade-module-v1-invoice-no-price":`A reembolsar`,
"lable.opppdt.selPdt.morecondtions":`Más filtros`,
"label_invalid_token":`Token inválido`,
"label_chatter_postup":`Publicar`,
"label.escalation.setup.newaction.step1":`Paso 1: Especifique los criterios de tiempo para esta regla`,
"label.sendmail.step3.dealoption2":`Guardar evento de cada correo`,
"front-kefu-moudle-v1-yesornoBatch-delete-templete":`¿Está seguro de que quiere eliminar las plantillas por lotes?`,
"vue_label_appstore_enter_website":`Ir a la página web oficial`,
"label.when":`Tiempo de publicación`,
"label.linellae":`Líneas`,
"label_chatter_detailinfo":`Información detallada`,
"lable.SalesCommitmentKanBan.receivingTaskRate":`Ratio de finalización de tareas de recibos`,
"vue_label_homepage_dashboard_deleted":`Cuadro de mandos eliminado`,
"pagecreator.layout.button.vertical":`Descomposición vertical`,
"label.redistribution1":`Seleccione hasta 5 artículos`,
"pagecreator_page_label_modifypage":`Editor de página`,
"label.Service.Cloud.Setting":`Ajuste de la Nube de Servicios`,
"setup_layout_label_pagename":`Nombre del dise?o de página`,
"label.ems.send":`Enviar`,
"vue_label_commonobjects_view_kanban_notice1":`La vista de Kanban solo muestra los primeros 200 registros`,
"lable.outlook.detail.maping":`Mapeo de campo`,
"vue_label_pool_abandonorrestore":`{1}{2}`,
"label.mobile.side.tab":`Configuración de la barra lateral en móvil`,
"label.trigger.operation.email.template.param":`Transferir parámetros: idioma, ID de la plantilla de correo e ID del registro`,
"front-objectTemplate-V1-Select-a-template":`Seleccione una plantilla existente como base de la nueva plantilla.`,
"label.email.template.delete.template":`¿Está seguro de que debe eliminar esta plantilla?`,
"label.reportsSubscription.cancel":`Cancelar`,
"lable.quote.syncingfrom.firstsync.description":`Los productos de la oportunidad reemplazarán los detalles de la oferta`,
"label.weixin.no.pending.xsld.qin":`Lo sentimos, ahora no hay datos de embudo de ventas`,
"template.dashboard.sales.indicators":`Indicadores de ventas`,
"label.field.new":`Proporcionar a los usuarios operaciones de evaluación y puntuación.`,
"label.generatepage.title.desc1":`Generar código HTML de móvil o Versión PC basado en los campos seleccionados, los usuarios pueden modificar el código según sus necesidades.`,
"template.report.source.potential.customers":`Fuente de los leads`,
"label.mr.title.queryData":`Encontrar duplicados`,
"button_partner_workspace_enable":`Activar nube de socios`,
"V":`Numeración automática`,
"label.icon.19":`Carpeta`,
"vue_label_report_summaryformula":`Fórmula resumen`,
"label.appointment.wizard.subtitle2":`Rango de fechas disponible`,
"label.stdashbord.xsld.business.bjdzhl":`Ratio de conversión de esta fase`,
"label.forecast.forehistory.deopportunity":`Oportunidades`,
"chatter.email.referredToMeLeaveMessage":`Me mencionan en un comentario`,
"label.dategrouprelyon":`Criterios de agrupar fechas`,
"label.sendmail.batch.finish":`Correo masivo: completado`,
"label.weixin.allexpired":`Todo Vencido`,
"label.dashboardSetup.showdw.d4":`10 Mil`,
"message.duplication.label.masterRecord":`Registro Maestro`,
"vue_label_calendar_availability":`Disponibilidad`,
"vue_label_chat_approval_message":`Mensaje de aprobación`,
"vue_label_zhang_er":`Jenny`,
"label.select.options":`Seleccione las opciones`,
"label.israel.daylight.time":`Hora estándar de Israel`,
"front-sales-search-QB":`0 datos en total, ya sea para crear una nueva cuenta en el QuickBooks`,
"vue_label_account_change_customer":`Cambiar el propietario del cliente`,
"label.integrations.mailchimp2":`Ver más sobre CloudCC y Mailchimp`,
"lable.product.pricebooks.onisu":`Libro de precio desactivado`,
"front-electronic-signature-backfill-field":`Campo de relleno`,
"label.document.myself.folder":`Mis carpetas personales`,
"label.event.moveup.10hour":`10 horas con antelación`,
"report.label.report":`Informe`,
"label.validate.function.funcFormat.CONTAINS":`CONTAINS(text, compare_text)`,
"label.usermanage.query.false":`Consulta fallada, el usuario no existe.`,
"front-epwechat-module-v1-input-EncodingAESKey":`Por favor, introduzca EncodingAESKey`,
"label.event.multi.view":`Vista de múltiples usuarios`,
"label.h5.similar.opportunity.setup":`Configuración de oportunidades similares`,
"label.setting.intergrationlist.button.install":`Instalar`,
"label.event.monthview":`Vista mensual`,
"label.version.weixin":`Versión de WeChat`,
"label_emailtocloudcc_redmessage6":`La verificación de IMAP/SMTP se frascasó, revise si el correo y contrase?a son correctos`,
"UG.homepage.003":`Vista de 360 grados`,
"vue_label_calendar_shared_calendar":`Calendario compartido`,
"label.select.hope.merge.num1.record":`Seleccione los registros que quiere fusionar en un registro. Seleccione 3 registros al máximo una vez`,
"label.createnewprocess":`Crear nuevo proceso de aprobación`,
"font-trade-module-v1-invoice-status":`Estado de los pagos`,
"label.customerinfo.introduce":`Información de compa?ía`,
"label.objectname":`Nombre de objeto`,
"label.chosen.field":`Campos seleccionados`,
"label_target_name":`Nombre del modelo de meta:`,
"label.appointment.wizard.subtitle4-4-4":`1 mes`,
"label.emailobject.groupemail.msg1":`No hay dirección de correo`,
"label_component_hotdeal_nopermission":`Para ver los datos relacionados con oportunidad, contacte con el administrador de CloudCC`,
"label.appointmentdetail.wizard.title13":`Descripción`,
"front-web-module-v1-detail-comment-title":`Por favor, comente este servicio`,
"label.visualpage.component.n1":`1.Método de llamada.  &lt;component:Name /> Name es nombre de componente`,
"lable.outlook.mcto.erecord":`Registro más temprano`,
"label.weixin.del.log":`Cancelar historiales`,
"setup_mainpage_label_welcome23":`Configuración de seguridad`,
"label.selectreportline":`Por favor seleccione las columnas del reporte`,
"label.chatter.following":`Está siguiendo`,
"seven":`Siete`,
"message.error":`Error:`,
"label.mobile.phone.reporter":`Enviado por`,
"label.valadate.telphone.false":`Error del número de móvil, revise`,
"label.linkedin.setting":`Integrar la miniaplicación H5 de LinkedIn`,
"label.mobile.side.tab.success":`Guardar con éxito la configuración de la barra lateral de la aplicación móvil`,
"label.notification.approval3":`Su solicitud de【对象的英文单数】fue reasignado por【重新审批人】`,
"label.channel.invites.employees":`Personal invitado de este canal`,
"label.assignment.setup.detail.assigner":`Asignar a`,
"label.campaignmember.main.updatecontactdesc":`Actualice status de todos los contactos a la vez`,
"label.permission.detail.app.fenpei":`Asignar aplicaciones`,
"label.copydown":`Copiar abajo`,
"label_emailsync_status_action":`Operación`,
"lable.Please.switch":`Cambie al menú horizontal o vertical para utilizar esta función`,
"label_adjust_remark":`Observaciones sobre el ajuste`,
"label.weixin.newspaper.coverage.list":`Hoja de riesgos`,
"label.datamanage.contact.field":`Campo de contacto`,
"label.partner.workspace.login.headerfooter":`Encabezado y pie de página`,
"lable.account.quarter.ovdate":`Día de finalización del trimestre fiscal`,
"pagecreator.systemstyle.label.textcolor":`Color del texto`,
"label.industrialandcommercialverification.fieldmappingsettings":`Configuración del Mapeo del Campo`,
"component_chatter_button_message":`Comentario`,
"label.partnerCloud.enterAddress":`Por favor, introduzca la dirección`,
"label.email.template.recently.used":`Usado recientemente`,
"component.event.label.calendar":`Ver calendario`,
"label.setup.mobile.offlinecache.setting":`Configuración de caché de aplicación móvil offline`,
"label.custom.PreviousCQ":`Trimestre personalizado anterior`,
"lable.total.of.payments":`0 pagos en total`,
"label.ccpeak.use.class.time.trigger":`Si el trigger recuerda este tipo, puede utilizar directamente el método en CCService`,
"label_tabpage_addresswrongz":`?Error del formato de correo, ingrese la dirección de correo correcta!`,
"vue_label_homepage_select_components":`Seleccionar componente`,
"front-kefu-moudle-v1-secretID-reinput":`Por favor, introduzca la ID secreta`,
"label.ccdocument.select.template.red":`Seleccione una plantilla para configurar`,
"vue_label_email_public_template":`Plantilla pública`,
"label.eowechat.openid":`ID de WeCom`,
"label.user.ip.notlogin.range":`?El IP está fuera del rango del inicio de sesión!`,
"chatter.email.reply.collection":`Al hacer comentario sobre las publicaciones a favoritos antes`,
"label.integrations":`Integración`,
"label.permission.modifyAppPermission.selectedapp":`Aplicaciones seleccionadas`,
"label.privacystatement":`Declaración de Privacidad`,
"label.specificvalue":`Un valor específico`,
"label.appointmentconfirmpage.wizard.subtitle2":`Fecha y hora`,
"label.message.ispartner.delete":`Porque el contacto ya está asociado con el usuario de socio, no puede cancelar el cliente`,
"report_button_go":`Ir a`,
"label.h5.similar.opportunity":`Oportunidades similares`,
"UG_Lead_005":`Buzón del correo`,
"label.num.length.not.overstep":`La longitud del valor no puede exceder a 18 dígitos`,
"label.profile.mobile.setup.CEOandDirector":`CEO y director de ventas`,
"label.addfield":`Añadir campo`,
"template.dashboard.institutional.overview":`Resumen de la Agencia`,
"label_tabpage_datefield":`Cuando el campo de fecha es igual, se puede utilizar "ayer", "hoy", "ma?ana", "mes pasado", “este mes", "próximo mes", "semana pasada", "esta semana", "próxima semana" o formato "YYYY-MM-DD、MM/DD/YYYY".`,
"label.category.7":`Turismo`,
"UG_contact_02":`Atraer contactos a través de múltiples canales, llamadas, correo, social`,
"chatter.feed.menutype.feed.mecom":`Publicación relacionada conmigo`,
"vue_label_systemSettings_calltemplate":`Plantilla de carta`,
"approval_process_errore":`Un error se ocurrió al guardar, contacte con el administrador`,
"label.tabpage.choosefilez":`Seleccione el archivo`,
"label.changemydisplay.chagetab.cusapp":`Aplicaciones personalizadas`,
"clearadvancedoption":`Limpiar opciones avanzadas`,
"front-epwechat-module-v1-binding-user":`Usuarios vinculados`,
"label.customfields.fielddependency.null":`No hay dependencia definida`,
"label.enterprise":`Versión Empresarial`,
"font-evaluate-module-v1-five-points":`Marca neutra: 5 puntos`,
"lable.Synchronize.from.QuickBook":`Sincronización desde QuickBook`,
"front-gantt-module-v1-task-number":`Cantidad de la tarea`,
"label.currency.edit.newexchagecurrency":`Tasa de cambio expirada`,
"label.partnerCloud.partnerSite":`Sitio asociado`,
"label_tabpage_unequalz":`No igual a`,
"label.version.solutions":`Soluciones`,
"label.setting.intergrationlist.button.installed":`Instalado`,
"label.h5.chatter.share":`Compartir ficheros`,
"front-epwechat-module-v1-unbound-item4":` vinculación de las cuentas externas`,
"label.textmessage.vonage.accessibility.setting":`Ajuste de la accesibilidad`,
"font-evaluate-module-v1-evaluation-set":`Ajustes de evaluación`,
"message.servicecrew.time.violation2":`Fuera del horario de trabajo`,
"label.processinfo":`Información del proceso de aprobación`,
"label.knowledgebase.last.modified":`Última modificación`,
"label.to.phone":`A`,
"label.baseoffirsttimereply":`Aprobar o rechazar basándose en<strong> Primero</strong>respuesta`,
"label.projectManagement.startingEndingTime":`Fecha de inicio y fin`,
"label.licence.enable":`Activado`,
"label.partnerCloud.basicSetting.cshua":`Inicializar la nube de socios`,
"APPIntegration.Dropbox.setting.03":`Habilita Dropbox para poder seleccionar archivos de Dropbox y añadirlos como adjuntos.`,
"label.account.contact":`Gráfico de contactos de clientes`,
"label.many.dayline.tab":`Marcar`,
"label.weixin.input.username":`Ingrese su nombre`,
"label.logintime.pagecue.invalido":`Hora de finalización debe ser un día entero`,
"label.icon.30":`Libro`,
"label_tabpage_advancedscreening":`Filtro avanzado`,
"lable.currencyManage.unEnabledadvcurrency.agree":`Sí, quiero prohibir la gestión de moneda avanzada.`,
"label.tab.web.new":`Nuevo menú del Web`,
"label.bmap.tiananmen":`Tiananmen`,
"label.disabled":`No disponible`,
"error.currencyAdv.deleteprecodedate":`No puede cancelar la tasa de conversión de fecha de una moneda`,
"message.error.view.checkbox.validerr":`Error: utilice verdadero o falso`,
"UG_ST_006":`Ingresar directamente`,
"label.dongshifang.title":`Dong Shifang SMS`,
"label.data.dataexpalltype.all.desc3":`3. Los datos exportados con éxito generarán un archivo comprimido que los usuarios pueden descargar desde la página de la lista de archivos exportados según la información del correo.`,
"vue_label_pool_returnreason":`Motivo de devolución`,
"label.list.userinterface.des":`Modifique la interfaz de usuario con las configuraciones siguientes:`,
"label.notification.approval2":`Su solicitud de 【对象英文单数】ha sido rechazada por【审批人】`,
"label.service.dispatchingUnits.the.level":`Nivel`,
"front-email-payment-Invoice-preview-tips":`Todas las plantillas de facturas están actualmente desactivadas. Póngase en contacto con el administrador para habilitar la plantilla antes de generar las facturas.`,
"label.dashboard.isAvailableFieldOfComponentGroupInTheReport":`Error: Uno o más de los campos seleccionados del componente no se puede utilizar en el informe. <br>Utilice el editor componente del panel para seleccionar uno de los campos disponibles.`,
"label.import.step2.chooseidorother":`2. Puede elegir entre utilizar el ID o el nombre para hacer coincidir el registro y rellenar el campo de búsqueda. Si necesita obtener el ID del registro correspondiente u otra información, puede crear un informe y establecer el nombre del registro y el ID del registro como columnas de grupo y luego exportar el informe.`,
"label.customobjects.introduce":`Los objetos personalizados son tablas de la base de datos que le permite guardar los datos específicos de la organización. Puede utilizar objeto personalizados para extender las funciones de CloudCC o establecer la función de aplicación.`,
"label.visualpage.oldsystem":`Versión antigua`,
"label.icon.94":`Libro`,
"label.setup.log.desctiption":`Puede descargar el seguimiento de comportamientos de su organización(Documento de Excel.xls).`,
"label.dynamicpage.layout":`Reglas de dise?o`,
"lable.list.queue.objct":`Objetos soportados`,
"label.customfields.placeholder.tip":`El texto de muestra se mostrará en el cuadro de entrada y desaparecerá después de obtener el foco`,
"label.ems.activationtime":`Hora de activación`,
"label.detailinfo":`Detalles`,
"label.icon.17":`Reporte`,
"label_emailtocloudcc_button_complete":`Finalizar`,
"label.visualpage.component.n2":`2. Notas. La etiqueta de component no puede insertar en la etiqueta de <cc>.`,
"label.object.name.one":`Nombre del objeto 1`,
"label.summaryreport.step2":`Paso 2: Seleccione datos resumidos`,
"thisisanew":`Nuevo!`,
"label.query.detail.editpartneruser":`Editar usuario de socio`,
"label.tabpage.newview":`Crear nueva vista`,
"label.partnerCloud.productSet.addNew":`Nueva opción`,
"label.appupload.upload.new.remark":`Este es un componente nuevo`,
"label.case.ptext":`Hemos vinculado su empresa a la versión web del portal. Copie la dirección de la versión web del portal de atención al cliente dedicada a su empresa y añada el portal en su sitio web oficial.`,
"lable.PowerProcess.name":`Proceso de asignación`,
"label_tabpage_choosefilez":`Seleccione archivos`,
"homepage.components.place":`Localidad de componentes:`,
"lable.Synchronization.failure":`Fallo en la sincronización`,
"label.dashboard.snapshot.get.data":`Conseguir sus datos`,
"label.input.invalid.format":`Ingrese el formato válido`,
"label.quickbooks.view.openinvoices":`Invoice Abiertos`,
"label.weixin.seating":`Número de asientos`,
"label.searchlayout.remark":`Permite seleccionar los estándares y campos personalizados que se muestran en la función de búsqueda siguiente:`,
"label.escalation.setup.entrydetail.escalation.assiner":`Asignar a`,
"vue_label_calendar_availability_view":`Calendario-Vista disponible`,
"label.country":`País`,
"label.campagin.roi.zl":`General`,
"lable.currencyManage.advcurrencyEnabled":`Gestión de moneda avanzada ha sido activada`,
"label.projectManagement.project.task":`Tarea del proyecto`,
"label.appointmentpage.wizard.subtitle3-2":`Correo`,
"label.input.invalid.date":`Ingrese fecha válida(ISO)`,
"vue_label_chatter_my_followers":`Mis seguidores`,
"label.setupdevelop":`Desarrollar`,
"label.sendemail.send.checksend":`Revise si el correo se ha enviado correctamente`,
"label.eventfield":`Campos de evento`,
"label.ccpeak.ccobject.put":`Utiliza put para asignar a CCobject, por ejemplo:`,
"label.campaignmember.main.addMemberDesc":`Puede buscar los candidatos y contactos actuales para a?adirles a esta campa?a, o gestionar los miembros de campa?a actuales`,
"label.knowledge.setting.hint.eleven":`Introducir categoría de datos`,
"label.knowledge.category.button.four":`Añadir categoría de hermanos`,
"label.icon.27":`Aprender`,
"vue_label_chatter_certification":`¿Está seguro de que quiere {isStatus}"{titleName}"?`,
"label.data.downpage.i.title.btn":`Ir a la página de importación y comenzar a importar`,
"label.campaign.channel.step6.pc":`Generar página de PC`,
"label.mr.caption.rule":`Reglas: seleccione uno o más reglas duplicadas`,
"label.service.gantt.resourcestype":`Tipo de recurso`,
"label.searchfitconditions":`Encontrar lo que coincide con los criterios siguientes`,
"label.partner.template.name":`Nombre de plantilla`,
"setup.mainpage.label.welcome15":`Las reglas de flujo de trabajo de la plataforma de nube CloudCC automatizan el proceso de asistencia para sus ventas, marketing y demás. En función de un conjunto de reglas predefinidas, se pueden asignar los registros automáticamente a los usuarios o transferirlos de un usuario a otro. La principal ventaja de la gestión del flujo de trabajo es mejorar la eficiencia del trabajo eliminando muchas operaciones innecesarias al actualizar los registros, y mejorar los niveles de procesamiento del negocio y optimizar los procesos de control mediante la estandarización de los métodos de trabajo y la reducción de los costes operativos. Soporta la aprobación ilimitada de cualquier objeto, y al mismo tiempo puede activar el recordatorio por correo y SMS, actualizar tareas y campos, etc.`,
"vue_label_commonobjects_view_chart":`Gráfico`,
"label.salescloud.teamrole.choose":`Seleccione el rol del grupo`,
"lable.outlook.mcto.emailrel":`Vinculación de correo`,
"front-invoice-online-payment-setup-describe":`Acceso rápido, con un solo clic. Servicio de pago en línea sencillo, seguro y rápido.`,
"label.korean.standard.time":`Hora Estándar de Corea`,
"label.lord.howe.standard.time":`Hora de Verano de Haword`,
"setup_layout_group_button":`Botón`,
"label.editdefaultshare":`Editar compartido predeterminado`,
"label_fiscal_year":`Año fiscal`,
"label.appointmentdetail.wizard.title2":`Todos`,
"label.email":`Correo`,
"label.city":`Ciudad`,
"label.knowledgebase.data.recovery.failed":`Fallo en la recuperación de datos de {a}`,
"setup_mainpage_label_welcome6":`Los usuarios pueden crear varios tipos de campos en todos los objetos del sistema CloudCC sin conocimientos de programación o desarrollo de código, los tipos de campo incluyen: Búsqueda de relación, campo de la opción individual, opción doble, fórmula, código automático, URL, teléfono, fax, correo, casilla de verificación, fecha, hora, número, texto, área de texto, lista de opciones (Opción individual/múltiple), moneda y etc.`,
"label_emailtocloudcc_button_enable":`Activar`,
"label.account.custom":`Trimestre fiscal personalizado`,
"label.custompublish_time":`Hora de publicación del cliente`,
"label.dashboardSetup.selwz":`Seleccione posición para mostrarse`,
"component_todaytask_label_all":`Ver Todo`,
"label.service.resource.group.tip":`Seleccione un equipo de servicios para crear un recurso de servicio, solo se puede seleccionar el equipo como tipo de recurso`,
"label.tianyancha.legalpersonname":`Nombre de persona legal`,
"component.setup.label.titlefield":`Campo del título`,
"label.email.template.public.mail":`Carpeta pública de plantillas de correo electrónico`,
"front-template-V1-DeleteTempalte":`¿Está seguro de eliminar "{currentTelmplateName}"?`,
"pagecreator.layout.label.layoutdesc":`Descripción del diseño`,
"vue_label_file_singel_upload":`Solo se puede cargar un archivo. Si necesita reemplazar el archivo, por favor, elimine primero el archivo cargado`,
"label.view.hierarchy":`Ver la jerarquía`,
"label.file.owner.settings":`Configuración de propietario`,
"label.sales.dashboard.name":`Nombre`,
"label.offfer.filer.name":`Nombre del archivo de la cita`,
"label.quickbooks.view.recentlypaid":`Recién pagado`,
"label.step1.select.merge.records":`Paso 1: Seleccione los registros para fusionarse`,
"message.recordtype.assignprofile.tip":`Seleccione por activar ¨Casilla de verificación¨ para el perfil , así que el nuevo tipo de registro se puede utilizar por este perfil. Los usuarios asignados a este perfil pueden crear registros de este tipo de registro, o asignar este tipo de registro a los regsitros existentes. Para que el tipo de registro nuevo sea el predeterminado, marque la casilla de verificación de ¨Configurar predeterminado¨`,
"label.appointmentdetail.wizard.title9":`Tiempo de viaje`,
"label.group":`Grupos`,
"label.deltorecycle":`Cancelar a la papelera de reciclaje`,
"label.import.index.numlimit":`1. Solo se admiten archivos en formato csv, y se pueden importar hasta 30.000 registros por intento (se pueden importar hasta 2.000 registros si se necesita ejecutar el disparador). Los registros que superen el límite serán ignorados automáticamente por el sistema. Si desea importar más datos, por favor divida en varios archivos primero e impórtelos en varios intentos.`,
"label.file.delete.desc":`Cancelar un archivo significa que lo removerá de los registros adicionales o publicaciones.`,
"UG_activity_04":`Correo de Outlook/Gmail, registra correo`,
"label.event.all.undealt":`Todos los eventos no procesados`,
"label.appupload.upload.install.error":`?La aplicación no se puede instalar, por favor finalice la instalación, o modifique el API del sistema y instale de nuevo!`,
"template.chart.yqydcpsl":`Número de productos activados`,
"label.import.index.advancepreparation":`Preparativos previos`,
"label.eowechat.epdeptnamee":`Nombre del departamento de WeCom`,
"front-kefu-moudle-please-input-servernum":`Por favor, introduzca el número de la lista de solicitudes de servicio.`,
"label.lookup.autocmp.nodata":`No hay datos coincidentes`,
"vue_label_pool_assign":`Asignar`,
"label.knowledge.timing.publish":`El tiempo de publicación ha fallado`,
"label.selected.groups":`Grupos de líneas de cotización seleccionados`,
"front-epwechat-module-v1-removesele-desc":`Después de la eliminación, toda la configuración de esta aplicación será eliminada. ¿Está seguro de eliminar?`,
"label.batchtransfer.type2":`Transferir las oportunidades cerradas`,
"label.richtext":`Área de textos (Texto rico)`,
"label.icon.174":`Aeronave`,
"vue.please.select.grouping.basis":`Seleccione el criterio de agrupamiento`,
"label.matrixreport":`Informe de matriz`,
"label.jiandangfenpei.leftlist":`Archivos no asignados`,
"label_chatter_card":`Tarjeta`,
"label.file.enter.title":`Ingrese el título`,
"label.the.record.is.locked.and.cannot.be.selected.":`Este registro está bloqueado, no se puede seleccionar.`,
"label.partner.success":`??xito! El dominio es disponible`,
"label.selectreporttype":`Seleccione la fuente de datos del informe`,
"report.type.label.productPricebooks":`Lista de precios y productos`,
"label.texttemplate.mergefields.tip":`Añade campos de incorporación mientras editas el contenido del SMS. Cuando se envía el SMS, los campos incorporados pueden ser sustituidos por el texto correspondiente. Por ejemplo, {¡Contacto.nombre} puede ser sustituido por el nombre del contacto al enviar el SMS.`,
"label.publicgroup.detail.showallusers":`Ver todos los usuarios`,
"label.brief.follow":`Seguir`,
"label.forecast.settings.qijian.p":`Previsiones de cada trimestre`,
"label.sms.url":`URL`,
"setup_layout_group_custompage":`Página personalizada`,
"label.validate.function.funcFormat.BEGINS":`BEGINS(text, compare_text)`,
"label.umeng.chatter.sendmessage":`Le enviaron un mensaje`,
"label.pc.layout":`Dise?o de PC`,
"label.currency.v":`Ingrese lugares decimales (número de dígito a la derecha del punto decimal) permitidos al mostrar los datos en esta nueva moneda. Debe ser un número entero de 0 a 6`,
"label.projectManagement.kanbantask":`Tarea Kanban`,
"component_recdetail_label_title":`Información detallada`,
"label.isremider":`Si recuerda`,
"front-epwechat-module-v1-input-home-url":`Por favor, introduzca la URL de la página web`,
"label.usefullife":`Período expirado`,
"label.visualpage.ptype":`Común`,
"label.quote.name":`Nombre de cotización`,
"vue_label_report_addtocomponent":`¿Está seguro de que quiere añadir { name } a la biblioteca de componentes?`,
"label.dashboardSetup.showdw.d1":`Mil Millones`,
"label.validate.function.funcFormat.OR":`OR(logical1,logical2,...)`,
"label.component.helper.potentialcustom":`Los clientes potenciales asignados hoy`,
"label.autoRegister.changepwd.setpwd.tip.number":`Por lo menos un número`,
"label.data.setok.e.desc3":`Descargar los datos exportados.`,
"label.data.downpage.e.title.num4":`4. Los archivos exportados tienen dos formatos: El formato CSV y el formato comprimido. El formato comprimido se divide en dos tipos: uno es de contraseña autogenerada, el otro es de contraseña manual.`,
"lable.quote.editqtpdt.description":`Seleccione manual de precio para esta cotización. Sólo puede añadir un producto de una lista de precios única. Cambiar la lista de precios seleccionada cancelará todos los productos actuales de la cotización.`,
"front-kefu-moudle-edit-userinfo":`Editar la información del usuario`,
"label.please.ChooseMinAndMax":`Por favor, elija al menos {0} opciones de productos, y hasta {1} pueden ser seleccionados.`,
"label.knowledgebase.archive.an.article":`¿Archivar un artículo?`,
"label.multilang.customforcast.submit":`?Entrega las previsiones de {0}a?o fiscal{1} al {2}a?o fiscal{3}?`,
"label.import.index.filename":`Nombre del archivo`,
"front-console-no-reco-contact":`No se puede identificar el contacto`,
"label.quantity.greater.than0":`La cantidad debe ser mayor que 0.`,
"label.codeNorm":`Código estándar`,
"label.average":`Media`,
"label.multilang.page1":`Página`,
"label.data.exp.save.ok":`Tener éxito en guardar la plantilla`,
"message.error.delete.record":`No se ha encontrado el registro a eliminar.`,
"label.newvaluereplaceoldvalue":`Globalmente reemplace un valor actual en una lista de opciones con un valor nuevo. Asegúrese de que ha creado un valor nuevo en el campo de lista de opciones primero.`,
"label.tabpage.saveviewsuccess":`Vista guardada con éxito`,
"label.partnerCloud.productSet.parentOptions":`Opción para los padres`,
"label.emailtemplate.availablemergefields":`Campos de combinación disponibles`,
"label.data.import.setup":`Configuración de importar datos`,
"label.escalation.setup.entrydetail.escalation.action":`Operación de actualización`,
"System.TimeField.Description":`Permite a los usuarios introducir una hora local. Por ejemplo, "2:40 PM", "14:40" y "14:40:00" son todas horas válidas para este campo.`,
"front-additional-products":`Comprar otros productos`,
"label.appointment.wizard.subtitle4-4-1":`Una semana`,
"label.chatter.colleagues.list":`Lista de colegas`,
"label.log.invalid.data":`Fecha inválida`,
"label.file.preview.unconvert":`No se genera información de la vista previa, haga clic en previsualizar los detalles`,
"label.customer.detailed":`Seleccione página para esta pesta?a nueva y rellene otros detalles`,
"label.sendsms.content":`El contenido es el siguiente:`,
"label.exported_to":`El archivo exportado se enviará por correo electrónico a`,
"label.attendance.checkin":`Iniciar sesión`,
"Dashboard.NoAccessRightToSee.Warning":`No tiene permiso para ver el cuadro de mandos {0} que está configurado como abierto por defecto, debe configurarlo con otro valor.`,
"message.choosedelete":`Seleccione los datos quiere cancelar`,
"label_tabpage_choosecontent":`Seleccione contenido del valor`,
"label.no_responses":`No hay respuestas`,
"report_type_label_customService":`Soporte de cliente`,
"label.report.select.condition":`Condiciones`,
"label.umeng.activity.distributeevent":`Te han asignado un evento`,
"label.knowledge.language.portuguese":`Portugués`,
"label.knowledgebase.published":`Publicado`,
"UG_opportunity_001":`?Como monitorea sus ventas?`,
"label.mr.caption.scope":`Rango: Consultará todos los datos si no seleccione nada`,
"message.login.mfaverification.to.pclogin":`Su organización ha activado la verificación secundaria, el primer inicio de sesión requiere vincular al dispositivo móvil, utilice PC para vincular el inicio de sesión`,
"vue_label_dashboard_pleaseenterthecolorrange":`Introduzca la gama de colores`,
"label.emailsync.status.time":`Tiempo`,
"chatter.putup":`Compartir un fichero`,
"vue_label_report_drillcondition":`Condición de exploración en profundidad`,
"label.emailobject.list.myemail":`Mi correo`,
"label_tabpage_andz":`Y`,
"label.share_link":`Compartir enlace`,
"label.emailtocloudcc.exists2":`Este correo ha sido configurado para Email to Case. No repita la configuración.`,
"label.icon.89":`Consultivo`,
"front-kefu-moudle-v1-qdygbzx-chat":`¿Estás seguro de desactivar el chat en línea?`,
"label.approval.selectone":`Seleccione por lo menos una operación`,
"chatter.group.groupName":`Nombre de grupo`,
"label_chatter_relateitem":`?tems relacionados`,
"label.file.folder.delete1":`?Cancela la carpeta?`,
"Pagelayout_Setup_003":`El campo de Name es obligatorio`,
"setup_mainpage_label_welcome2":`Base de los datos personalizada (Objeto)`,
"pagecreator.systemstyle.label.linkcolor":`Color del enlace`,
"label.task.this.week":`Esta semana`,
"message.custom.field.donotdelete.report":`Este campo es citado por el informe`,
"pagecreator.layout.button.delete":`Borrar diseño`,
"label.reportsSubscriptionPage.condition.operator":`Conectiva`,
"label.location.display.type.degrees":`Grados, minutos, segundos`,
"label.appupload.upload.url":`Instalar URL`,
"label.logical.relation":`Relación lógica`,
"label.knowledge.publish.article":`Publicar artículo`,
"vue_label_commonobjects_detail_activity_commingtask":`Tareas próximas en propiedad`,
"vue_label_pool_reason":`{0} causa`,
"front-gantt-module-subtasks-cannot-subtasks":`Las subtareas no pueden aparecer debajo de las subtareas.`,
"label_tabpage_filesizez":`Tama?o del archivo`,
"label.customfields.formula.returntype.monry.tip":`Calcular dólar u otras cantidades de moneda, y transferir automáticamente el campo en el formato de moneda.`,
"label.tabpage.allapplications":`Todas las aplicaciones`,
"message.duplication.label.matchcontainletters":`Contener`,
"maintenanceplan.workorder.type.asset.workorderlineitem":`Elija "Un proyecto de orden de trabajo para cada activo" como tipo de generación de orden de trabajo`,
"label.preview_post":`Vista previa del puesto`,
"chatter.p.data":`Publicar fecha`,
"label.isnot.right.number":`Número inválido`,
"label.contentsource":`Origen de contenidos`,
"message.groupandsummaryconditionsame":`Las condiciones de agrupación no puede ser igual que las condiciones de resumen`,
"label.weixin.wdyj.nodata.qin":`Lo sentimos, {0}no tiene datos`,
"chatter.vote":`Voto(s)`,
"label_partner_workspace_tab_option":`Menú seleccionable`,
"chatter.changeVote":`Cambiar votación`,
"label.data.file.i_title.num2":`2. Se recomienda que exporte primero antes de importar, arregle los datos importados con los documentos exportados como plantilla, y luego importa. (Si los datos importados contienen coma, reemplace por @)`,
"label.relation.list.error":`Error`,
"label.validate.function.funcExplain.MILLISECOND":`Devuelve los milisegundos del campo de fecha/tiempo`,
"label.emailobject.emaildetail.button.relateto":`Relacionado con`,
"label.dashboard.dataSource":`Muestra fuente de datos`,
"label.marketseamemset.lead.title":`Configuración de los miembros del grupo público de clientes potenciales`,
"label.appupload.addobj":`Añadir al Paquete`,
"lable.outlook.mcto.domain":`Agregar mi dominio (gmail.com) a la lista de dominios excluidos.`,
"label.input.right.url":`Ingrese la URL válida`,
"label.newprocessstep5.tip":`La página de aprobación es donde el responsable aprueba o rechaza realmente. Utilice las opciones siguientes y seleccione los campos para demostrar en esta página.`,
"label.schedulejob.setup.schedule.st4":`El cuarto`,
"label.emailsync.status.user":`Usuario`,
"front-kefu-moudle-v1-jymm-reinput":`Por favor, introduzca una contraseña de 12 dígitos, combinando dos o más de mayúsculas, minúsculas, números y caracteres`,
"Lead_Scoring_Setting_Rule_Setup_RuleName":`Nombre de regla de puntuación`,
"label.mr.title.fieldName":`Nombre del campo`,
"label.data.deriall":`Exportar todo`,
"label.tianyancha.businessverify.step2":`Activar verificación de datos comerciales Paso 2`,
"label.submissions":`Presentaciones`,
"vue_label_calendar_removed_successfully":`Calendario eliminado con éxito`,
"label.eventrecordtype":`Tipos de registro de evento`,
"lable.outlook.detail.syndire":`Dirección de Sync`,
"label.mobile.bind.fail":`No se ha podido enlazar, por favor, inténtelo más tarde`,
"label.notification.task2":`La tarea que ha asignado a 【被分配人】fue revisado`,
"label.partnerCloud.orderingPlatform.paymentMethod":`Pagar por:`,
"label.escalation.setup.newaction.step3":`Paso 3: Seleccione los usuarios para notificar`,
"label.summaryreport.selectsum":`Seleccione los datos resumidos y tipo resumido`,
"label.components.setup":`Configuración de componentes`,
"label.taskevent.introduce":`Lista de sus tareas y eventos`,
"label.assignment.setup.detail.conditon":`Criterio`,
"front-lightning-module-v1-details-page-chart-select-statements":`Seleccione el informe`,
"lable.Song.typeface":`SimSun`,
"label.formulassesstrue":`La evaluación de fórmula es verdadera`,
"label_partner_common_setup":`Configuración general`,
"label_chatter_dateRange":`Rango de fecha`,
"label.partner.workspace.tab.mobile.using":`Los menús seleccionados aparecerán en el móvil al mismo tiempo`,
"message.servicecrew.time.violation1":`Violación del tiempo de asignación: hay miembros del equipo`,
"report_label_projectcount":`ítems, ordena por el nombre de informe`,
"label.file.uploadfile":`Subir archivos`,
"vue_label_commonobjects_detail_correct_email_address":`Introduzca la dirección de correo electrónico correcta`,
"lable.account.CurrentandNextCQr":`3 Trimestre Calendario actual y siguiente`,
"setup.layout.label.order":`Ordenar por`,
"label.service.major.event.independent":`Independiente`,
"label.icon.38":`Posicionamiento`,
"label.knowledge.draft.record":`No se ha encontrado el registro a eliminar`,
"label_quota_percentage":`Mostrar el porcentaje de finalización de la cuota`,
"label.escalation.setup.entrydetail.escalation.minute":`Minutos`,
"label.knowledgebase.edit.article.category":`Editar la categoría del artículo`,
"Homepage_News_003":`No se puede mostrar las noticias sin los datos de cliente, al crear cliente, las noticias se mostrarán aquí`,
"label.mr.descreption.oneGroupNote3":`Registros`,
"label.customsetting.touse.getListCustomSetting":`Busque el "lista" tipo datos de configuración personalizada, regrese todos los datos correspondientes a API Name. Map map = cs.getListCustomSetting(String apiName);`,
"message.error.view.cannotbenull":`Error: debe ingresar por lo menos un valor`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.friday":`Viernes`,
"message.error.view.badprevilege.qin":`Lo sentimos, no tiene permiso para acceder a {1}, por eso no hay datos</br>.`,
"label.dashboard.distribution":`Distribución`,
"label.field.value.save":`Siempre se requiere un valor en este campo para guardar el registro`,
"label_custom_year":`Año personalizado`,
"label.code.error":`El código contiene comandos o funciones no permitidas como las siguientes:`,
"label.appexchange.uninstallpage.message2":`Cancelar permanentemente todas las configuraciones de estos componentes`,
"label.global.search.obj":`Configuración de objeto de la búsqueda global`,
"label.emailobject.from":`Remitente`,
"lable.opppdt.selPdt.byconditions":`Por campo`,
"chatter.p.note":`Notas de esta publicación`,
"label.hiddenformulaedit":`Ocultar editor de fórmula`,
"label.editQuotation":`Editar oferta`,
"label.notification.arketsea.collection":`{5} ha reclamado {2}{0}{0}:{1}`,
"label.timzone.tip.info1":`Al guardar tipo de datos como java.util.Date（insert y update）en una base de datos, por ejemplos, TpSysTask task=new TpSysTask () ；task.setBeginTime (new Date () ）；......dbman.insert (task) o dbman.update (task); debe cambiar new date () a recordar TimeUtil.getNowDate (userInfo), por eso las oraciones relativas en el ejempo arriba mencionado debe ser  task.setBeginTime (TimeUtil.getNowDate (userInfo);)`,
"label_tabpage_transformationsz":`Convertir`,
"front-kefu-moudle-IP-phone":`Teléfono IP`,
"label.emailobject.list.draft":`Borrador`,
"label.tianyancha.businessverify.readandconfirm":`He leído el acuerdo de usuarios y acepto`,
"label.win.customers":`Cerrado-Ganar clientes`,
"vue_label_commonobjects_view_switch_display":`Sus registros están agrupados por tipo de registro, puede hacer clic en el nombre del tipo de registro correspondiente para cambiar la visualización.`,
"pagecreator_systemstyle_label_textcolor":`Color de los textos`,
"label.autosearch.keywords":`Búsqueda automática de palabras clave`,
"label.knowledge.setting.data.six":`Va a eliminar la categoría {lbmc}, ¿está seguro de continuar?`,
"front-console-sort-field":`Caso No.`,
"label.bangladesh.time":`Hora de Bangladesh`,
"label.dashboardSetup.number":`Valores numéricos`,
"lable.account.LastbDays":`Los 30 días pasados`,
"label.layout.searchdialog":`Buscar diálogo`,
"label.newprocessstep4.tip":`Seleccione la plantilla de correo para notificar a los aprobadores que se les ha asignado una solicitud de aprobación. Tenga en cuenta que esta plantilla se utilizará para todos los pasos de este proceso.`,
"label.nousing":`Desactivado`,
"vue_label_report_detailline":`Línea de detalle`,
"label.emailobject.template.message3":`Se ha alcanzado el máximo de plantillas de correo.`,
"label.c.d":`Relación C a D`,
"message.report.error.fail":`Carga fallida, por favor intente de nuevo`,
"label.edit.ccdocument.content":`Ha modificado los contenidos del adjunto`,
"label.textmessage.exceeded":`El número de sus plantillas de texto ha superado el límite.`,
"label.saveas":`Guardar como`,
"label.visualpage.an.inline.style":`Inserte página personalizada para la página detallada y la página oficial del menú`,
"label.pagelayout.remark2":`Datos. Al crear el dise?o de página, haga clic en el botón ¨Asignación del dise?o de página¨ para controlar a que página los usuarios vean por defecto.`,
"label.notification.approval1":`Su solicitud de【对象的英文单数】fue aprobada por【审批人】`,
"label.h5.chatter.image":`El formato de la imagen subido es incorrecto`,
"vue_label_dashboard_displayunit":`Seleccione la unidad a mostrar`,
"label.knowledge.default.language":`Idioma de Conocimiento por defecto`,
"label.chatter.publish":`Publicar`,
"label.companyprofile.serveraddress":`Esta sincronización sólo sincroniza con el servidor actual`,
"label.chatter.groups":`Grupo`,
"label_set_successfully":`Configurado con éxito`,
"label.quote.zongjia":`Precio total`,
"label.project.notice.endingdatelater":`La fecha de finalización debe ser posterior o igual a la fecha de inicio.`,
"label.customfields.fielddependency.info":`Esta página te permite definir las dependencias entre campos(Ej, Lista de opciones dependientes)`,
"vue_label_lead_successful_conversion":`Conversión exitosa`,
"label.icon.93":`Libro`,
"shift.serviceresource.illegal":`El recurso de servicio no pertenece a los miembros del territorio de servicio o la fecha de turnos no está dentro del rango de relaciones de los miembros`,
"label.integrations.action.addnewlead":`Añadir candidatos`,
"label_display_all_zeros":`Mostrar todas las filas con valor cero`,
"canlendaryear":`A?o calendario`,
"label_tabpage_selrecordtypez":`Seleccione el tipo de registro`,
"vue_label_commonobjects_view_chart_funnel":`Gráfico de embudo`,
"label.layout3":`Dise?o 3`,
"label.logintime.cue":`No hay tiempo de login específico`,
"label.service.miniProgram.lastDate":`Fecha de la Última Modificación`,
"label.emailobject.view.fromcrm":`Correos electrónicos de los contactos/líderes`,
"pagecreator.button.mobilepage":`Móvil`,
"lable.oppt.jieduan.signcur":`Marcado como etapa actual`,
"label.fullaccess":`Acceso completo`,
"homepage.layout.pagename":`Nombre del dise?o`,
"label.appointment.wizard.subtitle4-2-3":`3h`,
"label.knowledgebase.please.check.record":`Por favor, seleccione al menos un registro.`,
"label.view.sortview.closepage":`Cerrar la página`,
"label_forecast_type":`Tipo de previsión`,
"all.day":`Todo el día`,
"label.view.sortview.printpage":`Imprimir esta página`,
"message.integration.configure":`La configuración integrada está vacía`,
"label.forecast.customforecast.foretype.close":`Cerrado-Ganado`,
"label_chatter_like":`Me gusta`,
"template.report.folder.customer.potential":`Análisis de clientes potenciales`,
"label.umeng.approval.dlsp.approve":`#approvalname ha aprobado #actorname''s solicitud de aprobación de #objAPIName #recordname para usted`,
"vue_label_normal_movedown":`Bajar`,
"chatter.group.groupAccessPermissions":`Permiso del grupo`,
"label.visualpage.tip":`Puede crear su propia página aquí`,
"message.validation.isnotdate":`Fecha inválida`,
"label.icon.173":`Velero`,
"label.icon.124":`Inyección`,
"label.import.page2.csvfiled":`Campo CSV`,
"setup_layout_component_area":`?rea`,
"label.visualpage.workability.standard":`Class Estándar disponible en la página`,
"label_emailtocloudcc_redmessage9":`Error de la base de datos, contacte con el administrador`,
"label_tabpage_contactsz":`Contactos`,
"label.multilang.workflow.everydayinmonth":`{1} días cada {0} meses`,
"APPIntegration.Social.linkedinerror":`Debe introducir un URL válido de linkedin.com`,
"button_partner_workspace_manage_memo":`Gestione su Nube de Socios y configure las propiedades de la Nube de Socios.`,
"template.chart.bnsrmb":`Objetivo de ingresos para el año`,
"chatter.follow.now":`Seguiendo`,
"label.entitlement.process.condition.repeat":`Establecer la repetición de eventos clave`,
"label.relationobject.isdl":`Ya sea proxy`,
"label.lasttimemodifieralias":`Alias del úlitmo modificador`,
"vue_label_commonobjects_detail_task_name":`Editar nombre de la tarea`,
"vue_label_homepage_quarterlyperformance":`KPI trimestral`,
"pagecreator.layout.message.delete":`¿Borrar el diseño actual seleccionado?`,
"component_sendmail_label_cc":`Cc`,
"vue_label_email_enable_signature":`Habilitar firma`,
"label.partnerCloud.financeSetting.create":`Crear fondo para los usuarios elegibles automáticamente cuando se activan nuevos parters.`,
"label.data.file.i.title.num1":`1. El archivo importado debe ser un archivo en formato CSV. El archivo debe contener un título, no se puede importar sin título.`,
"label_efine_assessment":`Período de evaluación`,
"message.duplication.label.sectionTitle":`Seleccione el valor para guardarse`,
"front-electronic-export-buttonExport":`Continuar con la exportación`,
"message.submitpage.email":`?Felicitades! Envío exitoso del correo!`,
"after":`Después de`,
"label.version.nonsupport":`No compatible`,
"label.icon.105":`Calendario`,
"label.quickcreate.titledesc":`Activar la creación rápida permite a los usuarios crear registros desde el cuadro de diálogo de búsqueda.`,
"label.quote.number":`Rellene la cantidad`,
"label.view.sortview.setdefault.prompt":`Configurar esta lista de vista como vista predeterminada`,
"label.refertime":`Fecha de envío`,
"frame.personinfo.label.minipic":`Imagen en miniatura`,
"label.mobile.home.page.newopp":`Candidatos recién creados`,
"label.address":`Dirección`,
"front-pay":`Pagar`,
"label.chat.serviceAppointment":`Aviso de servicio`,
"label.umeng.activity.eventviewed":`El evento que ha asignado a #name ha sido visto`,
"label.validate.function.funcExplain.DATE":`Cree fecha via a?o, mes y día`,
"label.commiterselectapprover":`Deje que el remitente elija al aprobador manualmente.`,
"label.appointmentconfirmpage.wizard.subtitle3":`Ubicación`,
"vue_label_display_text_field":`Mostrar campos de texto`,
"label.salescloud.teamrole":`Rol del grupo`,
"maintenanceplan.workorder.generate.limit":`La orden de trabajo deberá estar dentro del rango del programa de mantenimiento`,
"label.campaignmember.selectmember.description":`Seleccione una vista, luego seleccione miembros para añadir a la compa?a, el status de miembros es`,
"label.ismodify":`Si permite la edición`,
"label.height":`Altura`,
"label.tabpage.thevalurofz":`El valor de`,
"label.create_successful":`Crear formulario con éxito`,
"front-invoice-online-payment-setup-configure-dialog":`Configurar la interfaz de pago`,
"label.customerinfo.smsEid":`SMS Gateway EID`,
"label.visualpage.list.no":`No tiene permisos para acceder a las páginas personalizadas`,
"look.trigger.in":`Ver instrucciones`,
"label.setting.disable":`Desactivar`,
"chatter.group.name":`Grupos`,
"label.solutionadministrator":`Administrador de solución`,
"label.vlidaterule.top":`La parte superior de página`,
"pagecreator.layout.message.save.fail":`Guardar diseño fallido`,
"label.partnerCloud.orderingPlatform.noZero":`La cantidad no puede ser 0.`,
"label.customfields.suretodeleteprompt":`Confirmar la cancelación de las indicaciones personalizadas`,
"button_partner_viewdetail":`Ver`,
"label.icon.122":`Casa`,
"label.customer.tab.step2.introduce":`Seleccione los perfiles de usuario que van a utilizar nuevo menú personalizado. También puede examinar o cambiar algún menú en la página de información o de editación de cada perfil.`,
"label.task.delegated":`Aprobador`,
"vue_label_salesadvance_averageamount":`Media por transacción`,
"vue_label_chat_invitedtojoin":`“{invite}”le ha invitado a unirse al chat de grupo`,
"label.data.downpage.e_title.num1":`1. Seleccione los objetos que quiere exportar, o seleccione para exportar todo.`,
"label_display_options":`Opciones de visualización`,
"vue_label_chatter_more_comments":`Más comentarios`,
"label.ggReleaseRange.publish":`Publicar lista`,
"label.valuetype.notmate":`Error de las condiciones de línea, el tipo de valor no coincide.`,
"label.chatter.chatter":`CCChat`,
"label.exchange.sync.state.contact.m1":`Sincronización del úlitmo evento:`,
"label.dataimport.duplication.filter":`Encontrar indicaciones del fitro duplicado`,
"label.appdownload.uninstall":`Desinstalar`,
"message.error.task.add":`Error en la tarea nueva`,
"UG.Account.07":`Importar clientes`,
"label_tabpage_lastone":`Seleccione por lo menos una operación`,
"front-console-holdTime":`Tiempo de retraso`,
"label.emailobject.schedule":`Revise mi programa y seleccione un tiempo adecuado`,
"label.lookup.locked.data":`Este registro está bloqueado, no es electivo`,
"label.assignment.setup.newentries.ifcondtions":`Si alcance las condiciones siguientes, se operarán las reglas`,
"label.magadan.time":`Hora de Petropavlovsk`,
"message.error.serviceterritorymember":`Defina el recurso de servicio seleccionado como un miembro del territorio de servicio dentro del rango de tiempo del plan de citas de servicio`,
"label_chatter_delete":`Eliminar`,
"label.partner.workspace.member.permission":`Conjunto de permisos disponibles`,
"label.notification.task5":`Su tarea está caducada`,
"mary":`Mayo`,
"label.homepagemodule":`Componentes de página oficial`,
"label.compact.layout.frame.error1":`La pantalla derecho no puede estar vacía`,
"chatter.error.refresherror":`Error al cargar página de nuevo, intente de nuevo`,
"label.login.rememberPsd":`Recordar contrase?a`,
"Lead.Scoring.Setting.Rule.Setup.01":`Lista de reglas de puntuación de clientes potenciales`,
"label.reportsSubscriptionPage.schedulereport.weekly.sunday":`Domingo`,
"label.visible":`Visible`,
"label.console.new":`Nueva Consola`,
"label.mr.descreption.reDataList4":`Milisegundos. Cada página`,
"vue_label_notice_uploadavatar_notice2":`La imagen del icono solo puede ser de formato JPG/PNG/GIF`,
"label.operation.error":`La operación se frascasó, intente de nuevo`,
"label.sendsms.context":`Contenidos de SMS`,
"label.least.show.line":`(Mostrar por lo menos 4 líneas)`,
"label.tabpage.newWizardz":`Nuevo asistente de funciones`,
"label.tippage.li2":`Cancelar todos los informes basados en fuente de informes de datos personalizados`,
"label.customfields.new.step2.opration.unique":`?nico`,
"label.listofshare.remark":`Los usuarios siguientes pueden ver los registros`,
"label.address_information":`Información sobre la dirección`,
"label.projectManagement.overdue.tasks":`Tarea atrasada`,
"lable.account.PreviousCQ":`Trimestre calendario anterior`,
"label.service.miniProgram.advertising":`El nombre del anuncio sólo se utiliza para identificar entradas de anuncios múltiples, no se mostrará en el propio anuncio`,
"label.integrations.mailchimp.exportlead":`Exportar los candidatos a Mailchimp`,
"label.payments.paytip3":`Seleccione una dirección de cuenta`,
"label.mobile.phone.screen":`Filtrar`,
"label.h5.tome":`Sobre mí`,
"label.mobile.side.tab.remark1":`Añadir el menú de CloudCC y objeto al menú de navegación ubicado en la columna lateral del móvil`,
"vue_label_calendar_choose_a_custom_color":`Elegir el color personalizado de este calendario`,
"label.lastname":`Apellido`,
"vue_label_dashboard_selectreport":`Seleccione informe`,
"label.lanxin.setting.appid":`AppID`,
"vue_label_report_information":`Exportar el informe como se muestra en CloudCC, incluyendo la cabecera del informe, el grupo y la información de los filtros.`,
"label_chatter_default":`Predeterminado`,
"label.globalSearch.info":`Buscar todos los objetos seleccionados`,
"label.integrations.mailchimp.massage2":`Exportando a los candidatos a Mailchimp, puede verlos en la lista de Mailchimp más tarde.`,
"label.tabpage.addresswrongz":`El formato de correo electrónico incorrecto, por favor, introduzca el correo de forma correcta.`,
"label.mobile.phone.customer.call":`Visitar a los clientes`,
"vue_label_email_linkrecordfail":`Se ha desvinculado los registros relacionados`,
"lable.account.LastfDays":`Los últimos 90 días`,
"label.cpq.order.status.delete":`Este pedido está activo y no puede ser eliminado`,
"label.ccchat.notmember.active.group":`No eres miembro de`,
"label.savepayset.failure":`No se ha podido guardar la cuenta de pago en línea`,
"label.version.createlimitbyobject":`La versión actual de su CloudCC es {0}, y puede crear {1}{2} para cada objeto. Ahora la cantidad de {2} ha superado al límite, actualice a la última versión. `,
"approval.process.errore":`Se ha producido un error al guardar, póngase en contacto con el administrador.`,
"label.stdashbord.xsld.business.reportanalysis":`Análisis del gráfico`,
"label.login.verification.please.enter":`Ingrese el código de seguridad de las aplicaciones MFA`,
"label.tabpage.cue":`Nota de información`,
"vue_label_salesadvance_converserate":`Tasa de conversión`,
"label.marketsea.recyclereminddays1":`Antes del reciclaje automático`,
"label.import.page1.update":`Actualizar`,
"label.document.folder":`Carpeta de documentos`,
"label.h5.similar.opportunity.feature":`Esta función permite a usuario buscar las oportunidades que comparte campos comunes con la oportunidad. Una vez active, una lista relativa de ¨Oportunidades similares¨ aparecerán en el registro de oportunidad.`,
"label.myanmar.time":`Hora de Myanmar`,
"monday":`Lunes`,
"vue_label_account_shareholder":`Accionista`,
"button.partner.search":`Consultar`,
"label.partnerCloud.partnerAccount.topUpAmount":`Importe de la recarga`,
"label.tabpage.refreshz":`Actualizar`,
"lable.PowerProcess.complete":`Minutos de finalización del evento clave`,
"front-kefu-moudle- normal-phone":`Teléfono general`,
"label.user.unauthorized.organization":`?Organización no autorizada, contacte con el administrador!`,
"label.area.canot.save.nulldata":`No se puede guardar los datos nulos`,
"label.version.role.management":`Gestión de roles`,
"label.recordtype.batchaddattachments.batch.remark":`Paso 1. Seleccione fichero; Paso 2. Haga clic en ¨Subir¨ para subir los ficheros; Paso 3 Haga clic en ¨Finalizar¨ para regresar a la página anterior`,
"label_tabpage_contentz":`Ingrese los contenidos`,
"label.partner.workspace.member.all":`Todo`,
"label.validate.function.funcFormat.LEFT":`LEFT(text, num_chars)`,
"vue_label_SMS_notice_selectatleastone":`Seleccione al menos un cliente potencial o contacto`,
"label.appupload.install.error.choice5":`Deje de instalar inmediatamente y genere los componentes en conflicto`,
"label.version.lookupmdfield":`Campo de relación maestro-detalle`,
"setup.layout.label.desc":`Orden descendente`,
"vue_label_report_addsummaryformula":`Añadir fórmula de resumen`,
"label.done":`Hecho`,
"label.input.samevalue":`Ingrese el mismo valor`,
"label.SMS.next":`Seleccione objetos para esta notificación de SMS y haga clic en ¨Siguiente¨. La notificación de SMS sólo se puede asociar con el mismo tipo de las reglas del flujo de trabajo y proceso de aprobación.`,
"label.role.allunselectuser":`Todo los usuarios no asignados`,
"label.loginhistory":`Historial de login`,
"vue_label_report_addpublicreportstofolder":`Añadir informes públicos a esta carpeta`,
"label.email.track.no.attachment":`No hay adjunto`,
"label_network_connection_failure":`Error de conexión`,
"vue_label_file_delete_lib_member":`Eliminar miembro de la biblioteca de archivos`,
"label_partner_step1":`Paso 1: Seleccionar plantilla`,
"label.password":`Contrase?a`,
"label.select.the.fields.around.code":`Elija los campos que se mostrarán alrededor del código QR/código de barras.`,
"label.file.share.limit":`?Fuera del límite de compartido, no se puede añadir más!`,
"label.desktop":`Escritorio`,
"label.sendmail":`Enivar correo`,
"label.quote.detail":`Detalles de cotización`,
"label.approvalstep2":`Paso 2: Especificar las condiciones de paso`,
"label_component_hotdeal_nodata":`No hay datos relativos de oprtunidad`,
"lable.reset":`Resetear`,
"label.eventpagelayout":`Dise?o de la página de eventos`,
"label.icon.100":`Papelería`,
"UG.quota.03":`Plantilla de ofertas`,
"label.calendar.week.view":`Vista semanal`,
"component_chatter_file_button_save":`Publicar`,
"label.as":`Como`,
"template.chart.yqxypjz":`Respuesta media esperada`,
"UG.Contract.03":`Crear contrato`,
"label.projectManagement.gantt":`Diagrama de Gantt`,
"label.forecast.edit.error0":`?Error: seleccione por lo menos un moneda de empresa!`,
"label.ccpeak.delete.sharetab":`Cancelar el formulario compartido`,
"label.account.contact.goback":`Regrese a los clientes`,
"vue_label_email_insert_field":`Seleccione el campo de inserción`,
"setup_object_field_dependency_label_fieldvalueoptions":`Valores de campo disponibles`,
"label.salescloud.opportunity.contactrole.optionlist.main":`El siguiente es la lista principal de valores de la lista de opciones para roles de contacto de oportunidades`,
"label.huanxinconfig.tenantid.lost":`tenantid no puede estar vacío`,
"label.mask.show.last_4":`Se muestra con máscara los últimos caracteres`,
"label.targer.name":`Nombre del indicador`,
"vue_label_commonobjects_detail_unlocksuccess":`Desbloqueado con éxito`,
"front-kefu-moudle-length-min":`Duración (minutos)`,
"label.chat.topic.my.favorite":`Los temas a favoritos`,
"chatter.upload":`Subir`,
"message.cannotapproveit":`La solicitud de aprobación no se puede procesar`,
"label.weixin..xsld.order.by.jine":`Ordena por el monto de contrato`,
"label.projectManagement.wait.test":`Esperando test`,
"template.report.customer.contact.list":`Lista de contactos de las cuentas`,
"label.empty.recycle.bin":`Vaciar papelera de reciclaje`,
"label.detail.approveprocess":`Ver proceso de aprobación`,
"label.appexchange.uninstallpage.message4":`Cancelar permanentemente todos los informes, vistas y menú personalizado en este paquete`,
"label.weixin.linkreport":`Asociar con→Informe`,
"label.tianyancha.orgnumber":`Código de organización`,
"Q":`Lista de opciones (Opción múltiple)`,
"pagecreator_systemstyle_message_save_fail":`Se frascasó en guardar el estilo`,
"label.partner.new":`Nube de socios: Nuevo`,
"label.ems.accounttype":`Tipo de Cuenta (a)`,
"label.weixin.next":`Siguiente`,
"label.weixin.coach.interpret":`Aid-Max reserva el derecho de revisión y interpretación final dentro del rango de ley para el servicio de WeChat`,
"label.some":`registro(s)`,
"label.currency.rate":`Editar moneda: tasa de conversión`,
"label.emailobject.template.name":`Nombre de la plantilla`,
"UG.Campaign.001":`Planificar campañas`,
"label.mr.descreption.reDataList3":`Grupos de dato, hora de consulta`,
"label.project.hit.nine":`Recordatorio de la emisión diaria`,
"lable.PowerProcess.golist":`<<Volver a la lista: Proceso de asignación`,
"label.viewbuttonedit.remark":`Seleccione el botón estándar y el personalizado para mostrar en la vista frontal`,
"label.component.helper":`Asistente`,
"lable.SalesCommitmentKanBan.contractAndReceipts":`Pago firmado`,
"chatter.group.userName":`Nombre de usuario`,
"label.mobile.phone.business":`Oportunidades`,
"label.quickbooks.payments":`PAGUE`,
"label.step6.total7":`Paso 6 de 7`,
"label.forecast.detailforecast.revenue":`Pronóstico del ingreso`,
"vue_label_commonobjects_view_chart_displayas":`Mostrar como`,
"label.recordeditoption":`Registrar las propiedades de editar`,
"label.sendemail.send.sendfailstandby":`Envío de correo se frascasó, contacte con el administrador.(Bandeja de salida de reserva)`,
"label.knowledgebase.reset.filter":`Restablecer filtro`,
"label.icon.111":`Comida`,
"label.standard.buttonandlink.firstsetting":`Configuración con prioridad`,
"front-filter-module-v1-filter-description":`El filtro Flash no se puede guardar. Sólo se aplica a la operación actual sin influir en las vistas o en otros usuarios.`,
"label.showmore":`Ver más`,
"UG_Lead_001":`? Cómo introduce pistas?`,
"label.exchange.sync.state.setting.m1":`Cuenta de servicio proporcionado por Miscrosoft Exchange:`,
"label.please.enter.channel.name":`Introduzca el nombre del canal`,
"label.emailtocloudcc.edit":`Editar`,
"label.layout.tabdialog":`Menús`,
"label.Emoji":`Emoji`,
"template.report.completed.tasks":`Tareas completadas`,
"label.tabpage.enterviewname":`Paso 1: introduzca el nombre de la vista`,
"label.mobile.phone.not.to.choose":`No selecciona`,
"label.datamanage.contact.namenull":`?Notas: si el ¨nombre de contacto¨ es nulo, el registro de contacto no se importará!`,
"LT":`Geolocalización`,
"label.exchange.sync.state.task.m3":`Registros sincronizados en los último 24 horas:`,
"lable.SalesCommitmentKanBan.contractOwner":`Propietario de contrato`,
"vue_label_chatter_write_review":`Escribir comentario`,
"label.h5.approval.enter.content":`Ingrese las notas de aprobación`,
"label.location.display.type":`Método de visualización de latitud y longtitud`,
"label.numberscannotnull":`El número no puede estar vacío`,
"label.icon.3":`Moneda`,
"setup_object_field_dependency_label_linkedfieldvalue":`Campo dependiente`,
"label.task.future":`Tareas porvenir`,
"label.look.more.record":`Mostrar más`,
"vue_label_account_cases":`Transferir todos los casos del propietario del cliente`,
"label.emailobject.emaildetail.title.ccaddress":`CC:`,
"label.setHistoryTrack":`Configurar el seguimiento de historiales`,
"ObjectDetailed.ViewKeyInformation.Layout":`Editar información clave`,
"label.layout.editsearchdistribute.tip":`Seleccione los campos para incluir en la búsqueda. Tenga en cuenta que su selección solo determina como mostrar el resultado de la búsqueda y no afecta a los campos realmente buscados.`,
"label.emailtoall":`Enviar correo a todos`,
"label_partner_new":`Nube de socios: Nuevo`,
"label.direct.dashboard.me.not.approval":`Mis ítems por aprobar`,
"label.platform.customize.customizeui":`Interfaz de usuario personalizada`,
"label.userinfo.pwderror.againinput":`?Las contrase?as ingresadas dos veces son diferentes. Introduzca de nuevo!`,
"label.customsetting.introduce":`Utilice configuraciones personalizadas para crear y gestionar los datos personalizados de la organización, perfil y niveles de usuarios. Los datos de configuración personalizada se guardarán en el caché de aplicación. Eso significa que puede accederlos eficientemente sin hacer consultas repetidas. `,
"label.file.owner":`Propietario`,
"label.icon.7":`Personas`,
"label.document.query.button":`Haga clic en buscar para encontrar el archivo`,
"label.tabpage.turnoffsz":`Cerrado  Convertido`,
"message.error.appid.appsecret.failed":`No se ha podido conseguir la clave de seguridad`,
"vue_label_commonobjects_view_to_display_fields":`Seleccionar hasta 10 campos de visualización`,
"label.martrixreport.setlinetitle":`Especificar el título`,
"vue_label_chatter_applycertification":`¿Acepta la solicitud de "{nombre}" para que se una al equipo?`,
"front-electronic-export-success":`Exportar con éxito, por favor, compruébelo en la lista de Mailchimp`,
"label.emailsync.status.enable":`Habilitar asociación`,
"label.c_d":`Relación de C a D`,
"PageLayout_Search_MultiSearch_003":`Seleccione por lo menos un campo`,
"label.tabpage.newInterfacez":`Nueva interfaz`,
"label.cutomsummaryfieldedit":`Editar campo de resumen personalizado`,
"label.usermanage.view.field.notexist":`El campo correspondiente a la vista no existe.`,
"label.list.userinterface.dashboard.setup":`Configuración de panel`,
"label.knowledgebase.delete.article":`Eliminar el artículo`,
"label.dataimport.type.update":`Actualizar`,
"label.marketsea.new":`Nuevo grupo público`,
"label_tabpage_newlybuildz":`Crear`,
"vue_label_helpcenter_report1":`1. Crear informe<br> El informe Lightning del sistema de gestión de ventas Cloud CC es una potente herramienta de análisis de datos. Muchos problemas de ventas se pueden resolver agrupando, filtrando y resumiendo los registros. Por ejemplo: “¿Cuál fue el ingreso generado por las nuevas oportunidades de negocio de la empresa en el último trimestre?". Se puede agregar gráficos tras completar el resumen de datos. Una vez completado el informe, haga clic en Ejecutar para ver los resultados completos.<br> Paso 1: En la pestaña de informe, haga clic en "Nuevo informe".<br> Paso 2: Seleccione la fuente de datos del informe y, a continuación, haga clic en "Siguiente".<br> Puede seleccionar en la fuente de datos que elija qué registros o campos pueden utilizarse en el informe. Seleccione o busque un objeto como objeto principal. Puede seleccionar hasta 4 objetos relacionados con el objeto principal, y puede seleccionar el tipo de relación entre ellos. <br> Paso 3: Entre en la página de edición del informe y haga que muestre los datos de la vista previa<br> En el modo de edición, puede personalizar el informe, añadir campos como columnas al informe, agrupar filas y columnas, y utilizar filtros para filtrar los datos del informe hasta que se muestren los datos que desee.<br> <br> Añadir o eliminar columnas y reordenar<br> Añadir columna: En el modo de edición del informe, haga clic en el cuadro de entrada "Columna" en el "Resumen" de la parte izquierda de la página, y añada columnas al informe buscando el campo o seleccionando la forma del campo en la liste de desplegable. <br> Eliminar columna: <br> A. Después de encontrar la "columna" que desea eliminar en la lista de "columna" de la izquierda, haga clic en la "×" en el cuadro de campo. <br> B. O encuentre la "columna" que desea eliminar en la cabecera de la vista previa del informe a la derecha, haga clic en el "botón desplegable", y haga clic en "eliminar columna".<br> Eliminar la columna del informe no elimina el campo. Si desea restaurar la columna después de haberla eliminado, basta con añadirla de nuevo. <br> Reordenar columnas: Arrastre el campo "columna" en la lista "columna" de la izquierda hacia arriba y hacia abajo para ajustar el orden de disposición de la "columna". <br>Añadir y eliminar la agrupación de filas y la agrupación de columnas<br> Añadir la agrupación de filas: Haga clic en el cuadro de entrada "Agrupar fila" en el "Resumen" de la parte izquierda de la página, y añada campos de agrupación de filas del informe para filtrar los datos después de buscar el campo o desplazarse por la lista de campos desplegables y luego seleccionar el campo de destino. <br> Si no se ha añadido agrupación de columnas, puede añadir hasta tres agrupaciones de filas. <br> Añadir agrupación de columnas: cuando existe la agrupación de filas, puede añadir la agrupación de columnas. Haga clic en el cuadro de entrada "Agrupar columna" en el "Resumen" de la parte izquierda de la página, seleccione el campo tras la búsqueda o desplácese por la lista desplegable de campos y seleccione la forma de añadir columnas del campo deseado para filtrar los datos del informe. <br> Puede añadir hasta dos grupos de columnas. Si se ha añadido grupos de columnas, puede añadir hasta dos grupos de filas. Los campos añadidos como grupos de filas no pueden añadirse como grupos de columnas. <br>`,
"label.notification.event1":`【分配人】le ha asignado un evento`,
"chatter.field":`Campo(s)`,
"chatter.feed.menutype.feed.newscom":`Todo lo que estoy siguiendo`,
"label.attendance.range":`Rango de asistencia`,
"vue_label_calendar_deleteconfirm":`¿Está seguro de eliminar el calendario {nombre}?`,
"label.ems.createTask":`Crear {taskName}`,
"label.visualpage.wgd":`Páginas personalizadas no clasificadas`,
"label.multilang.product.deleterederect1":`Su intento de cancelar <font style="font-weight:bold;">{0}</font> no se puede completar porque está asociado con los registros siguientes. Se recomienda desactivarlo bajo esta situación.`,
"label_emailtocloudcc_filed_servertype":`Tipo del servidor`,
"label.umeng.insert.approval.dlsp.approvenew":`#actorname presenta #objAPIName#recordname para su aprobación`,
"label.tabpage.queue":`Cola`,
"label.approval.step":`Pasos para la aprobación`,
"label.approvaldatamove.approvalprocessname":`Nombre de proceso`,
"label.actualapprovedpeople":`Aprobador actual`,
"label.systemlog.f":`Frascaso`,
"front-template-V1-addText":`Añadir texto`,
"label.chat.like":`Me gusta`,
"label.userinfo.oldpwd.notnull":`?La contrase?a antigua no puede estar vacía!`,
"label.service.all.done.major.event":`Has completado todos los eventos clave`,
"label_chatter_to":`A`,
"message.toomuchlinecannotoutput":`Con tantas columnas seleccionadas del informe, el informe no se puede exportar.`,
"maintenanceasset.assetid.maintenanceplanid.unique":`El plan de mantenimiento ha sido asignado al activo. Por favor, no lo asigne repetidamente.`,
"lable.quote.syncing.firstsync.description":`Detalles de cotización reemplazarán los productos de oportunidad`,
"lable.outlook.mcto.saveemail":`Asegúrese de guardar bien el adjunto de correo`,
"label.passwordPolicy.setup.pwdremember2":`2 contrase?as recordadas`,
"label.project.hit.five":`Aviso de actualización de tareas`,
"label.linkedin.setting.appid":`Clave secreta`,
"label.dataimport.error.name.notnull":`Error: name no puede ser nulo`,
"label.knowledge.case.field.selected":`Campos de casos seleccionados`,
"label.version.datetime":`{0} Campos de fecha/ahora`,
"Dashboard_NoAccessRightToSee_Warning":`No tiene permiso para ver los paneles {0}que se configura como abierto por defecto, por favor resetee.`,
"label.login.access.permission":`Otorgar acceso a`,
"label.operatedata.import.tip":`1. El archivo importado deber ser un archivo con el formato CSV. El fichero debe contener un título y no se puede importar sin título. 2. Se recomienda que exportes antes de importar. (Si los datos importados contiene comas, por favor utilice el signo @ para reemplazarla)<br/>3. El sistema colocará a los datos por importar en el servidor, y luego iniciará el programa de tratamiento masivo en la plataforma, el resultado de importación se enviará a los usuarios via correo, no necesite esperar en esta página de operación.`,
"workflow.action.tasks.assignortype.rolename":`Nombre de rol`,
"vue_label_account_quotations":`Transferir todas las ofertas del propietario del cliente`,
"lable.account.CurrentCQ":`Trimestre de Calendario Actual`,
"label.user.database.error":`?Error de la base de dato!`,
"label_emailtocloudcc_titel":`Correo a CloudCC`,
"label_file_content":`Contenido del texto`,
"label.button.behavior":`Modo`,
"message.recordtype.new.tip":`Ingrese los detalles`,
"label.ccchat.message.new.error3":`Error: no puede seleccionar más que 9 destinatarios`,
"vue_label_commonobject_notice_lessthanwords":`El nombre del archivo debe tener menos de {FILE_NAME_COUNT} caracteres.`,
"label.stacked.verticalline":`Apilado-Columna Vertical`,
"vue_label_SMS_messagebox":`Buzón de mensajes`,
"label.appexchange.installedpage.message3":`Dependiendo de los enlaces están al lado de los paquetes instalados, puede ejecutar operaciones diferentes. Para cancelar el paquete , clic en <b>desinstalar</b>. Para gestionar la licencia del paquete, clic en <b>Gestionar licencia</b>.`,
"label.unusedapproveprocess":`Proceso de aprobación no activado`,
"label.onlywithspecificconditions":`Solo los registros que alcancen los criterios se pueden incluir en la calculación`,
"lable.outlook.mcto.formaterror":`Error de formato`,
"label.area.parent":`?rea superior`,
"vue_label_chat_activesuccess":`Activado con éxito`,
"label.setting.intergrationlist.button.upgrade":`Actualizar`,
"label.page_hidden":`Campos ocultos para la página de registro`,
"label.customsetting.manage.belong":`Configurar propietario`,
"label.appointment.wizard.subtitle4-2-8":`7 Días`,
"template.chart.ydywjhxsje":`Importe mensual de las ventas de la oportunidad de negocio`,
"label.multilang.currencylist.after":`Después de {0}`,
"vue_label_commonobjects_view_chart_countby":`Criterio de recuento`,
"label.week":`Semana`,
"label.emailtemplate.name":`Nombre de plantilla`,
"label.umeng.sign":`Firmado`,
"label.appupload.upload.details":`Detalles`,
"label.file.loading":`Cargando`,
"label.newdetail.orgTitle":`Contactar roles`,
"label.salescloud.field.addoptionlist":`Añadir valores de lista de opciones`,
"pagecreator.page.funcpath":`/ constructor / lista de páginas`,
"Account.News.Setting.001":`Configuración del cliente`,
"label.marketsea.getnoconversiondays":`días sin convertir (deben ser más que el número de días sin seguimiento después de la obtención)`,
"message.error.event.add":`Error al crear nuevo evento`,
"front-electronic-export-choseChimp":`Seleccione la lista de Mailchimp exportada`,
"vue_label_report_personothers":`Otras personas`,
"label.hierarchy.diagram":`Estructura de jerarquía`,
"label.stdashbord.xsld.business.yqsr":`Ingresos estimados`,
"label.chat.topic.max.count":`Ha llegado al número máximo de temas.`,
"label.sendemail.send.sendfail":`Se ocurrió al enviar el correo, contacte con su administrador.`,
"registration.page.body.title":`Página de registro`,
"label.userphoto.back":`Regresar`,
"label.service.without.timeslot":`Parece que no hay franjas horarias, ¡vamos a añadir algunas!`,
"label.processsetting.remaining.quantity":`Se pueden introducir hasta 255 caracteres, cantidad restante:`,
"label.sure.delete":`Confirmar la cancelación`,
"front-epwechat-module-v1-callback":`Configuración de la devolución de llamada`,
"front-email-payment-failed":`Lo siento, ¡el pago ha fallado!`,
"label.icon.67":`Máquina`,
"UG_Forcast_01":`Previsiones`,
"label.escalation.setup.newentries.step3":`Paso 3: Especifique como configurar la hora de actualización`,
"lable.account.NextCY":`El próximo a?o calendario`,
"report.type.label.quote":`Oferta`,
"label.area.name":`Nombre del área`,
"component.setup.label.object":`Objeto`,
"label.customsetting.type":`Tipo de configuración`,
"label.showdetail":`Mostrar detalles`,
"label.department.prev":`Página anterior`,
"label.select.data.source.report":`?Seleccione fuente de datos del informe!`,
"UG_homepage_002":`Gestionar sus pistas, candidatos, embudo de ventas y transacciones, y información de clientes con las herrramientas integrales de negocio`,
"vue_label_report_notice_exprot1":`Solo exportar las líneas de detalle. Utilizar estos datos para realizar más cálculos o para cargarlos en otros sistemas. Exportar por páginas, se puede exportar hasta 5000 elementos en una página`,
"message.error.task.phonecreate":`Error en la creación de la tarea telefónica`,
"label_chatter_day":`Día`,
"label.setinitialcommiter":`Paso 6 Especifique los envíos iniciales`,
"message.huanxinconfig.notfound":`No se encuentra la configuración de Easemob`,
"label.customfields.file.count.tip":`Por favor ingrese la cantidad de archivos que se pueden introducir en este campo, el valor predeterminado es 1`,
"label.weixin.appmanage":`Gestión de Apps`,
"label.approverautoconfirm":`Aprobador Autorizado determinado por`,
"vue_label_CCChat_followers":`Seguidores`,
"label.usermanage.notselect":`Usuarios no seleccionados`,
"label.item":`??tem(s)`,
"label.sendemail.chat.linkurl":`El enlace de la URL`,
"label.sendmail.step3.deliveroptions":`Opciones de envío`,
"homepage.components.creationtime":`Fecha de creación`,
"label.pc.ui.2018.ccchat.setting":`Configuración de CCChatter`,
"label.knowledge.search.result.highlight":`Resaltar los artículos relevantes en los resultados de la búsqueda`,
"label.data.downpage.e.title.num2":`2. Si elige exportar datos de un solo objeto, debe seleccionar cómo quiere exportar los datos: exportación personalizada, exportación por plantilla y plantilla de exportación.`,
"label.field.duplicate.error.msg1":`Existen datos duplicados, revíselos primero, y luego configure propiedad única.`,
"label.campaign.channel.input.number.error":`Error del formato de número`,
"label.goto.dashboard":`Ir a los paneles`,
"com.cloudcc.login.error.message.invalid.ip":`Su IP no está en el rango IP de inicio`,
"label.selectnewfieldvalue":`Especificar valor del nuevo campo`,
"label.appointmentdetail.wizard.title11":`Fecha de finalización`,
"Opportunity_Detailed_Phase_Label_Popup_001":`Fecha de inicio de la etapa actual`,
"front-dynamiclayout-module-v1-readonly":`El campo de {requerido} está configurado como Sólo Lectura.`,
"vue_label_calendar_start_field":`Campo de inicio`,
"label.weixin.recalculate.shared.failed":`Recalculación de regla de objeto compartido se frascasó`,
"label.sendmail.step3.dealoptions":`Opción de proceso`,
"setup_layout_label_modifypage":`Editar página`,
"homepage.components.select.wide":`Seleccione componentes anchos para mostrar`,
"label.import.page1.laststep":`Paso anterior`,
"label.weixin.donot.permission":`No tiene permiso para hacer esta operación`,
"message.error.name.null":`¡name no puede estar vacío.`,
"label.salescloud.teamrole.optionlist":`Valor de la lista de opciones dentro de roles de grupo`,
"component_setup_label_titlefield":`Campo de título`,
"vue_label_commonobjects_detail_have_been":`Usted ha`,
"label.textmessage.vonage.setup":`Configuración de Vonage`,
"label.recordtype.profile.enableit":`Activar para el perfil`,
"UG.product.04":`Crear producto`,
"label.knowledge.No.related.articles":`Ningún artículo relacionado...`,
"label.chat.muted":`No moleste`,
"registration.page.field.selection":`Seleccione el campo de la página de registro`,
"label.project.hit.eleven":`Emitir una notificación de asignación`,
"lable.newtabpage.advsearch":`Búsqueda avanzada`,
"label.report.share.roleandsub":`Roles y subordinados internos`,
"component.salesperformance.label.nodata":`Añada su oportunidad de negocio y regrese para ver el gráfico de KPI.`,
"label.submitted_on":`Enviado el`,
"label.file.create.link":`Crear enlace`,
"label.contact":`Contactos`,
"label.tab.message.failtoopenleft":`No se ha podido la operación de apertura y fusión de la columna de izquierda`,
"label.replaces":`Reemplazar`,
"label.customcomponent.check.tag.startwith":`Los componentes deben comenzar por la etiqueta &lt;cc:component&gt;.`,
"label.tab.web":`Menú de Web`,
"message.success.task.add":`Información de la nueva tarea guardada con éxito`,
"label.chatter.addresser":`Remitente`,
"label.mobile.homepage":`Página oficial`,
"label.data.imp.su.ok":`Importando`,
"label.knowledge.category.hint.one":`El grupo de categorías es la jerarquía de las categorías de datos. Por ejemplo, un grupo de categorías denominado "Ubicación" puede contener la jerarquía geográfica de continente, país, región y estado. Utilice esta página para gestionar los grupos de categorías y las subcategorías.`,
"label.schedulejob.setup.schedule.weekly":`Semanal`,
"label.tag.manage.description":`Todas las etiquetas relacionadas con {0} son siguientes. Puede renombrar o cancelar las etiquetas disponibles.`,
"label.tabcontrol":`Menú`,
"label.field.duplicate3":`Tratar ¨ABC¨ y ¨abc¨ como valores duplicados (No distinguir entre Mayúsculas y Minúsculas)`,
"label.customsetting.type.list":`Lista`,
"lable.account.ovdate":`Fecha de finalización del trimestre fiscal`,
"label_chatter_pastSevenday":`Los últimos 7 días`,
"front-kefu-moudle-v1-lxndxsdb-free":`Póngase en contacto con su representante de ventas y habilite el servicio de agente libre`,
"label.termsforusage":`Uso de ítems`,
"label.forecast.settings.qijian.m":`Previsiones mensuales`,
"label_tabpage_viewname":`Nombre de vista`,
"label.report.action.addtodashboard1":`Añadir al panel`,
"label_vue_create_edit_obj_create_event_dialog_desc":`El usuario que has asignado ya está comprometido con los horarios:`,
"vue_label_report_standardfilter":`Filtro Estándar`,
"label.umeng.approval.submit":`#applyer ha entregado #obj por aprobar`,
"label.tab.mobile.sign":`?cono del lado Móvil`,
"vue_label_commonobjects_detail_check_the_content":`Hay un error de verificación, por favor revise el contenido`,
"UG_Campaign_001":`Planeación de eventos de campa?a`,
"chatter.group.baseInformation":`Información básica`,
"label.sendemail.send.noreceiver":`No hay destinatario o el correo del destinatario está vacío`,
"template.chart.yskje":`Importe a cobrar`,
"label.textarea":`Área de texto`,
"vue_label_statistics_value":`Valor estadístico`,
"font-evaluate-module-v1-select-img":`Seleccionar imagen`,
"label.totalof":`Es un total de`,
"label.hangye":`Industria`,
"label.partner.common.setup":`Configuraciones comunes`,
"label.icon.78":`Agricultura`,
"lable.outlook.detail.addemail":`Añadir correo`,
"label.ServiceCloud.fuwuquyu":`Territorio de servicio`,
"label.gb2312encoding":`Chino simplificado(GB2312)`,
"label.appointment.wizard.subtitle4-3-1":`10 minutos`,
"label_emailtocloudcc_reauthorization":`Reautorización`,
"label.approval.message":`Las opiniones de aprobación se pueden ingresar hasta 500 caracteres.`,
"label_component_helper":`Asistente`,
"label.editRate":`Editar tasa de cambio`,
"label.setuptemplate":`Plantilla automatizada`,
"label_emailsync_button_cancel":`Cancelar`,
"label.marketseamemset.account.maxuser":`Número máximo de clientes del usuario`,
"label.someerror":`Por la seguridad, su sesión de CloudCC se caducará. <br><br>?Qué hará?`,
"label_person_in_charge":`Supervisor`,
"label.visualpage.reference.standard.style":`Referir al estilo estándar de la plataforma, customize-estilo personalizado`,
"errormessage_email_relatedorreceivermusthaveone_z":`Debe seleccionar al menos un destinatario o un ítem relacionado`,
"label.insert.field.empty.continue":`Los registros con valor nulo de 【{resDataField}】 existen, por lo que no se puede generar el código. Quieres seguir generando?`,
"component.newrecords.label.title":`Registros recientes`,
"template.detail_info_link":`Enlace de Detalles`,
"component_setup_tabs_label_default":`Página predeterminada`,
"label.emailobject.template.name.null":`El nombre de la plantilla de correo no puede estar vacío！`,
"label.knowledge.field.changed":`{1} se cambia`,
"homepage.components.select.narrow":`Seleccione componentes estrechos para mostrar`,
"label.mobile.phone.week":`Semana`,
"component_chatter_button_like":`Me gusta`,
"label.brief.won":`Ganados`,
"label.setup.profile.replaceme":`Reemplazar acerca de mí`,
"label.knowledge.setting.enable.lightning":`Activar el Conocimiento de Lightning`,
"label.middle":`Medio`,
"label.icon.109":`Personas`,
"vue_label_normal_activity_sf":`Actividad`,
"chatter.poll.option6":`Opción 6`,
"label.lanxin.setting":`Integrar la MiniApp Lanxin H5`,
"label.stdashbord.xsld.business.totals":`Oportunidades totales`,
"label.emailobject.emaildetail.promptbutton1":`Confirmar`,
"Opportunity.Detailed.Phase.Label.001":`Fase`,
"label.customcomponent.params.info":`Cómo utilizar los parámetros`,
"label.emailtocloudcc.button.next":`Siguiente`,
"front-email-payment-billing-date":`Fecha de la factura`,
"label.ems.with3day":`Dentro de 3 días`,
"label.project.subtask.date":`La fecha de la subtarea debe estar dentro del rango de fechas de la tarea a la que pertenece.`,
"label.role.allunselectanduseduser":`Todos los usuarios activados y no asignados`,
"front-kefu-moudle-yes-wantbuy":`Sí, quiero comprar`,
"label.looking_for":`¿Consiguió lo que buscaba?`,
"page.404.label.noresource":`Lo sentimos, el recurso al que quiere acceder no existe.`,
"vue_label_ccchat_notice_deletecommentcertification":`¿Está seguro de que quiere borrar este comentario?`,
"label.data.setok.e.desc1":`Se le notificará por correo una vez que se hayan importados los datos. Los datos se almacenarán temporalmente en el servidor durante 48 horas, por favor, diríjase a`,
"label.weixin.confirm.delete":`?Está seguro de que quiere cancelar este dato?`,
"A":`?rea de textos(Texto rico)`,
"template.report.sales.cycle":`Duración del ciclo de ventas`,
"label.service.shift":`Turnos de trabajo`,
"label.visualpage.display.side.bar":`Mostrar barra lateral, Error-No muestra barra lateral`,
"label.list.userinterface.chatter.showall":`La página oficial de CCChatter muestra todas las publicaciones por defecto`,
"vue_label_systemSettings_set_course":`Configure el camino añadiendo consejos para cada etapa para guiar a los usuarios paso a paso.`,
"label.icon.156":`Personas`,
"label.marketsea.button.move":`Mover`,
"front-email-payment-select-email":`Introduzca el código postal`,
"front-electronic-signature-service-provider":`Proveedor de servicios`,
"label.h5.add.checkin":`Inscribirse`,
"vue_label_amount_total":`Importe total`,
"label.campaign.channel.new":`Campa?a: Nueva canal de marketing`,
"label.knowledgebase.restore.creates.draft":`Restaurar generará un borrador de la versión actual. Es necesario publicar el borrador para que todos lo vean.`,
"UG_Case_01":`Caso`,
"label.validate.function.funcExplain.CONTAINS":`Revise si el texto contenga un carácter específico, si es, regresará TRUE, si no, regresará FALSE.`,
"label.data.exp.savetemp":`Guardar como plantilla`,
"front-project-module-v1-template-newcreate":`Crear un proyecto a partir de una plantilla de proyecto`,
"label.field.default.count":`Número de fila predeterminado`,
"page.note.acc":`Notas & Adjuntos`,
"label.close":`Cerrar`,
"label.app.detailbeforeedit":`Al siguiente son informaciones de aplicaciones personalizadas. Haga clic en ¨Editar ¨ para modificar las apps personalizadas.`,
"label.profile.standardfieldsafety":`Nivel de Seguridad de Campo Estándar`,
"vue_label_report_notice_deletefilter":`Por favor, elimine primero el filtro avanzado`,
"label.multilang.datamoveaction.movesuccess":`?Transferencia exitosa de {0} registros!`,
"label.emailmerge.edittemplate.descirption":`Ingrese información sobre la plantilla de combinación de su correo. Atención: las notas solo se mostrarán en CloudCC, no en Word.`,
"label.visualpage.at.the.end":`Utilizar la etiqueta en el final`,
"label.exchange.sync.state":`Status de Exchange Sync`,
"label.newdashboardpage.new":`Añadir una fila`,
"label.querydetailservice.profile.notsetup":`El perfil de su cuenta no se ha configurado`,
"label.escalation.setup.detail.description":`Añadir los ítems de criterios para la actualización del caso de acuerdo con las condiciones determinadas. Al crear los criterios, puede ordenar de nuevo en esta página.`,
"lable.setup.mobilesetup.isenbaleh5newandedit":`¿Ha habilitado Editar/Nuevo H5 en el dispositivo móvil?`,
"vue_label_file_upload_tip_msg":`Se recomienda que el archivo subido sea inferior a 30MB, de lo contrario se ralentizará la carga de la página`,
"label.eowechat.epdeptid":`ID del departamento de WeCom`,
"label.adminorapprover":`Administradores<strong>O</strong> El aprobador actualmente asignado puede editar registros durante el proceso de aprobación.`,
"label_emailtocloudcc_email":`Correo`,
"setup_main2018_label_norole":`No tiene permiso del administrador`,
"label.onlyone":`?nico`,
"label.sso.saml.idp.config.nameidtype":`Tipo de sujeto`,
"vue_label_normal_campaign_sf":`Campañas`,
"label.icon.61":`Grua`,
"label.datatype":`Tipo de datos`,
"label.mobile.home.page.today.work":`Mis trabajos`,
"label.sendemail.chat.praiseFeedcommentsubject":`A CloudCC CCChatter le gusta sus comentarios`,
"chatter.sel.p":`0 seleccionado`,
"label.b_c":`Relación de B a C`,
"label.tabcontrolnameandtaglib":`Nombre y etiqueta del menú`,
"label.globaloperation.tip":`Crear, editar y ver la operación global, que se puede utilizar en la página detallada.`,
"R":`Tipos de registro`,
"label.initcommiteoperate":`Operación de entrega inicial`,
"front-kefu-moudle-v1-Operation-without0-permission":`No hay permiso para operar este registro, por favor, póngase en contacto con el administrador`,
"button_partner_create":`Nuevo`,
"label.document.name.length.cannot.than":`La longitud del nombre del documento no puede exceder a 255 caracteres`,
"label.area.donot.delete":`No se puede cancelar la área, porque la área actual tiene área subordinada`,
"label.currency.activation":`Activar`,
"label.connect":`&Concatenar`,
"button.partner.viewdetail":`Ver`,
"setup_object_field_dependency_label_mustsetup":`Configure primero el campo de dependencia y guarde`,
"label.SalesCommitmentKanBan.task":`Monto de tarea`,
"lable.quote.syncing.finishbutton":`Finalizado`,
"label.weixin.group.type":`Tipo de acceso`,
"vue_label_commonobjects_detail_relationship":`Grado de relación`,
"vue_label_email_cc":`CCO`,
"setup.object.field.dependency.label.fieldvalueoptions":`Valores de campo disponibles`,
"label.sso.lookAtTheKey":`Ver clave`,
"UG.opportunity.008":`Grupo`,
"label.customfields.new.step1":`Paso 1. Seleccione tipo del campo`,
"lable.qrcodeOrbarcode.rule":`Generar reglas de código QR/código de barras`,
"vue_label_notice_nopermission_delete":`Lo sentimos, no tiene permiso para eliminar este registro, por favor, póngase en contacto con el administrador.`,
"label.customerobj.tab":`Menú del objeto personalizado`,
"com.cloudcc.login.error.message.nolicens":`La licencia no existe`,
"label.sendsms.batch.confirm":`SMS masivo: Confirmar`,
"label.forecast.settings.sos":`Ingreso y Cantidad`,
"label.calendar.addevent.notice.opencalendarfirst":`Por favor, abra mi calendario u otros calendarios antes de añadir eventos`,
"message.success.task.phonerecord":`Tarea de registros de llamadas guardada con éxito`,
"label.knowledgebase.create.new.subtab":`Nueva subpestaña`,
"label.knowledge.article.recordid":`El ID del artículo de conocimiento no puede estar vacío`,
"Opportunity.Detailed.Phase.Label.Popup.003":`Días transcurridos`,
"homepage.layout.nowpage":`Dise?o de página actual`,
"template.chart.khslph":`Número de cuentas Clasificación`,
"front-epwechat-module-v1-android-single":`Inicio de sesión único en Android:`,
"serviceresource.assignedresource.islacksr.lack":`No puede eliminar el recurso de servicio porque se le ha asignado una cita de servicio. Puede no habilitar este recurso de servicio.`,
"label.email.only.display.info":`Sólo los contactos o colegas con las direcciones de correo guardadas se mostrarán en el espacio siguiente`,
"label.weixin..xsld.yjhtje":`Monto de contrato estimado`,
"label.permission.delete.permsets.error.prompt":`El conjunto de permisos no puede ser eliminado porque tiene usuarios asignados.`,
"label.ccchat.enter.two.choices":`Ingrese por lo menos dos opciones`,
"label.edit.field.select.style2":`Una línea por cada opción`,
"vue_label_email_please_enter_email_subject":`Por favor, introduzca el asunto del correo electrónico`,
"batch.sendemail.f":`, envío fallado del correo.`,
"label.sms.senderr":`Fallo en el envío de SMS`,
"label.batchadd.newbatchpage.save.em":`El formato de correo inválido`,
"label.icon.96":`Brújula`,
"message.recordtype.deleterecord.tip":`Utilice esta página para reemplazar todos los tipos de registro existentes con los nuevos. Seleccione el tipo de registro siguiente para reemplazar cualquier registro que contiene los tipos de registro cancelados. Si solo quiere cancelar el tipo de registro de uno existente sin reemplazarlo con un nuevo, seleccione ¨No¨`,
"label.field.edit.max":`Punto máximo`,
"label.partnerCloud.orderingPlatform.preferential":`Descuento`,
"label.callcenter.login.later":`Entrar más tarde`,
"batch.change.owner":`Seleccione el propietario`,
"label.version.allow.upload.size":`Se permite subir el archivo máximo es`,
"setup.mainpage.label.welcome17":`Configuración de permisos`,
"label.tag.sectionname":`Información de etiqueta`,
"label_partner_workspace_setup":`Configuraciones`,
"label.managecontrol":`Permisos de administración`,
"label.timetrigger.condition":`Los criterios de evaluación son configurados cada vez que se crea o se edita un regsitro`,
"label.reportsSubscriptionPage.schedulereport.monthly.week":`Semana`,
"front-verkoop-bywerking-error":`Actualización fallida`,
"label.allowcommittercallback":`Permite a los remitentes retiren solicitudes de aprobación`,
"vue_label_commonobjects_detail_lead_finishistatus":`Marcar el estado como completado`,
"message.error.object.lookupmd":`El objeto ha creado la relación de Maestro-Detalle`,
"label.stdashbord.xsld.business.img7":`Número de etapas con probalidad 0% / (Número de etapas con probalidad 100%   Número de etapas con probalidad 0%)`,
"label.checkruleofevent":`Reglas de Verificación de Eventos`,
"front-epwechat-module-v1-single":`Inicio de sesión único`,
"label.tabpage.save":`Guardar`,
"label_emailtocloudcc_search":`Buscar`,
"label.tianyancha.h5.registeredPlace":`Lugar de registro(Abreviación)`,
"label.field.addoptionlist":`Añadir valores de lista de opciones: lista de opciones`,
"label.schedule_anotherpost":`Planificar otros puestos`,
"label.customfields.searchrelation.tip":`Crea una relación que vincula este objeto a otro objeto. El campo de relación permite a los usuarios hacer clic en un ícono de búsqueda para seleccionar un valor de una lista emergente. El otro objeto es la fuente de los valores en la lista.`,
"label.partnerCloud.partnerAccount.prepaidPhone":`Recarga de la cuenta`,
"label.projectManagement.view.details":`Ver detalles`,
"label.sendemail.chat.praiseFeed":`Estimado #name:\n\n hola! #userName le gusta su micro publicación.`,
"label.validate.function.category.Text":`Texto`,
"component.task.label.newevent":`Nueva tarea`,
"label.data.import.setup.operate":`Qué quiere hacer si encuentre un registro existido`,
"label.salescloud.salesdashboard.clear.option":`Vaciar las opciones`,
"lable.account.PreviousCY":`Dos a?os calendarios anteriores`,
"label.appointment.wizard.subtitle8":`Nombre de la empresa visible para el invitado`,
"label_emailsync_status_viewlog":`Ver log`,
"message.duplication.label.filtertitle":`Filtros de encontrar duplicados`,
"label.custom.quarter.description":`Esta página le permite definir el trimestre personalizado. La fecha del trimestre personalizado se generará en función de las opciones que elija a continuación.`,
"label_tabpage_filenamez":`Nombre del archivo`,
"lable.currencyAdv.andbefordate":`Y día antes`,
"label.version.nonsupport.sharerule":`?La regla de compartido no está disponible!`,
"front-epwechat-module-v1-unbound":`Desenlazar`,
"label.division":`División`,
"label.data.import.setup.repeat":`?Si quiere prevenir la creación de registros duplicados?`,
"label.callcenter.makesure.Amazon.connect":`Nota: Asegúrese de haber creado una instancia de Amazon Connect`,
"label.version.lead.control":`Gestión de los candidatos`,
"label.copying.reward.groups":`Copiar grupo de filas de oferta`,
"#label.severalorone":`Compresionado o fichero individual#`,
"label.mailinginfo":`Dirección de correo`,
"component.telerecord.label.title":`Registrar llamada`,
"label.godocumentlist":`Regrese a la lista de documentos`,
"APPIntegration.Dropbox.setting.01":`Habilitar`,
"label.tianyancha.website":`Sitio web`,
"label_tabpage_greaterequalz":`Mayor o igual que`,
"vue_label_campaign_influencedopportunity":`Oportunidad influenciada`,
"message.save.param.null":`El parámetro está vacío, no se puede guardar`,
"front-epwechat-module-v1-domain":`Nombre de dominio de confianzaJSSDK：`,
"label.allowreport":`Permitir informes`,
"label.service.major.event":`Evento clave`,
"label.import.index.selectobjectandfiles":`Seleccione el objeto y el archivo`,
"label.chatter.task":`Tarea`,
"label.knowledge.setting.hint.twelve":`Introducir categoría de datos`,
"lable.account.CurrentandPreviousFY":`A?o fiscal actual y anterior`,
"label.martrixreport.step3":`Paso 3: Seleccione los datos por resumir`,
"front-console-select-cases":`El número de casos seleccionados no puede ser superior a 10`,
"label.partnerCloud.partnerAccount.backHome":`Volver a la página de inicio`,
"label.me.assign":`Mi asignación`,
"label.appointment.wizard.subtitle3":`Hora de la reunión`,
"label.edit_columns":`Editar columnas`,
"label.partnerCloud.orderingPlatform.useRebates:":`Utilice el reembolso:`,
"label.projectManagement.enter.up.to.10.digits":`Máximo 10 dígitos`,
"label.integrations.description.mailchimp":`A través de integrar CloudCC con MailChimp, puede importar los candidatos seleccionados y contactos de su cuenta de CloudCC al MailChimp y enviar correo a los destinatarios determinados. Sus usuarios pueden seguir los resultados en MailChimp.`,
"label.ccchat.person.error.requiredomain":`Error: Se requiere por lo menos un dominio`,
"label.projectManagement.Pleaseselectitem":`Seleccione el proyecto`,
"label.netaccess":`Acceso a Internet`,
"vue_label_SMS_searchobject":`Objeto de búsqueda`,
"label.role.viewintree":`Mostrar en vista de árbol`,
"lable.SalesCommitmentKanBan.accountName":`Cliente`,
"label.please.contact.your.administrator":`Por favor, póngase en contacto con el administrador para activar las reglas de generación de código QR/código de barras`,
"label.sso.saml.sp.idenitysource":`Ubicación de Identidad SAML`,
"label.queue.delete":`Eliminar`,
"label.service.miniProgram.jumpLink":`Enlace de salto`,
"label_set_ forecast_scope":`Establecer rango de previsión`,
"label.weixin.success.sign":`Se ha iniciado la sesión, que se entere.`,
"front-dialog-module-v1-error-code":`Código de error`,
"label.projectManagement.nodata.problem":`Genial. No hay problema por resolver`,
"label.myhomepage":`Mi página oficial`,
"label.exchange.sync.state.task.m1":`La actividad de Sync pasada`,
"label.pw.config":`Confirme su contraseña`,
"front-console-new-contact":`Nuevo contacto`,
"label.customfields.fielddependency.editexplain":`<li>Haga doble clic en una celda para alternar la visibilidad del valor del campo de control que se muestra en el encabezado de la columna</li><li>Para cambiar varias celdas, haga clic en el botón de ¨Valor incluído¨ o ¨Valor Excluído¨ para cambiar la visibilidad de todas las celdas seleccionadas al mismo tiempo.</li><li>Utilice SHIFT   click para seleccionar una serie de celdas adyacentes. Utilice CTRL   click para seleccionar múltiples celdas no adyacentes.</li><li>Utilice el botón de ¨Previsualizar¨ para probar los resultados.</li>`,
"setup_mainpage_label_welcome7":`Instrucciones: Haga clic en el menú a la izquierda de la página → Configuración de Aplicación → Crear → Objetos → Nombre de Objeto→ Dise?o Personalizado.`,
"message.validation.sum":`Hay demasiados campos mostrados en la página de aprobación, puede seleccionar hasta 190 campos`,
"label.knowledge.attach.case":`Adjuntar a la caja`,
"front-electronic-signature-custom-field-type":`Tipos de campos personalizados`,
"vue_label_pricebook_activated":`Lista de precios habilitada`,
"vue.schedule.pre":`Este es mi horario, por favor`,
"Lead_Tools_BatchScoring":`Puntuación masiva de los candidatos`,
"front-lightning-module-v1-details-page-chart-screening-based-on":`Filtrar por`,
"label.report.no.recently":`No hay registro reciente`,
"label.service.gantt.dangerous.sum":`Número de citas de servicio en peligro.`,
"label.main.field":`Campo primario`,
"label.weixin.optionfive":`Opción 5`,
"homepage.wide":`Columna ancha(Columna Derecha)`,
"vue_label_notice_confirmdelatehomepage":`¿Está seguro de eliminar la página de inicio?`,
"vue_label_report_exportpages":`Exportar página: No.`,
"label.select_compaign":`Elija una campaña`,
"attachment.button.massdownload":`Descarga masiva`,
"label.chatter.incident":`Evento`,
"label_partner_new_step1":`Paso 1: Seleccione la plantilla que quiere`,
"button.partner.workspace.saveas.memo":`Guardar la nube de socios actual como ¨Plantilla¨`,
"vue_label_pricebook_edit":`Editar lista de precios`,
"label.weixin.privacy.rights":`Permisos de privacidad: ubicación aproximada(basado en la web),Ubicación precisa(GPS).`,
"label.please.codeType":`Por favor, elija el tipo de código.`,
"label.approveorrefuserequest":`Aprobar / Rechazar`,
"message.error.sharemember":`El sharemember transferido no puede estar vacío, por favor compruebe los parámetros de la transferencia.`,
"label.file.folder.edit":`Editar carpeta`,
"label.data.import.setup.repeat.yes":`Sí-prevenir crear registros duplicados. Nota: si quiere activar los registros actuales, debe seleccionar esta opción.`,
"label.approveBeforeTheOperation":`Operación antes de aprobar`,
"vue_label_file_already_checked_file":`Se han seleccionado {checkedWork} archivos, se pueden añadir hasta 10 archivos de una sola vez`,
"vue_label_hidden_record_count":`Ocultar el número de registros`,
"UG_product_01":`Lista de productos y servicios`,
"label.tabpage.clearoptionsz":`Borrar las opciones avanzadas`,
"label.partnercloud.num.overstep":`Se ha superado el número máximo de Nube de Socios`,
"label.tianyancha.businessverify.msg8":`Por la presente, la función solo permite búsqueda de empresas registradas de negocio en china continental, y hay cierta demora.`,
"Lead_Scoring_DetailedPage_Popup_Title":`Perspectiva de Candidatos`,
"label.emailtocloudcc.email":`Correo electrónico`,
"vue_label_pool_highcost":`Alto coste del producto`,
"label.callcenter.enterprise.configuration":`Por favor, copie el par de claves en Configuración de la empresaInterconexión del sistema en el sistema de Tianrun`,
"label.view.edit.search.prompt":`Ingrese palabras clave`,
"label.ems.sms":`Enviar SMS`,
"label.emailobject.list.new":`Escribir correo`,
"label.salescloud.forenableteamsales":`Activar el grupo de ventas`,
"pagecreator.systemstyle.funcpath":`/ constructor / biblioteca de estilos de marca`,
"label.partnerCloud.basicSetting.domain":`El dominio de nivel superior no puede estar vacío`,
"label.projectManagement.Posttask":`Tarea posterior`,
"label.tianyancha.businessverify":`Activar la verificación de datos comerciales`,
"label.tianyancha.h5.info":`Información básica`,
"september":`Septiembre`,
"chatter.poll.option9":`Opción 9`,
"label.department.firstpage":`Ya está en la primera página`,
"label.reportsSubscriptionPage.condition.button":`Añadir condición`,
"label.exchange.sync.state.task":`Tareas`,
"pagecreator.layout.button.splitall":`Descomponer todo`,
"vue_label_calendar_please_select_the_start":`Seleccione el campo de inicio`,
"label.tab.message.failtogettop":`No se ha podido obtener la pestaña superior`,
"label.sharerule.organizationscopesetshare":`Configuración predeterminada dentro de la organización`,
"label.delete.rules":`Borrar reglas`,
"label.recordtype.tabname.detail":`Haga clic en ¨Editar¨ para cambiar las propiedades del tipo de este recordatario. Seleccione el valor desplegable disponible para el recordatario utilizando enlace de ¨Editar¨ en la lista relacionada de ¨Valor Desplegable.¨`,
"label.knowledge.setting.hint.ten":`¿No está seguro del modo de organización? No hay problema. Puedes ejecutarlo más tarde.`,
"vue_label_norm_undone":`No se puede deshacer esta operación`,
"label.trigger.line":`Línea:`,
"lable.info.queue.reason":`Razón por ser un miembro`,
"label.validate.function.funcExplain.HOUR":`Devuelve el número de la hora del campo de fecha/tiempo que va de 0 a 11`,
"label.update.document.content":`Ha modificado los contenidos del documento`,
"lable.Existing.template":`Plantillas disponibles`,
"label.summaryreport.step3":`Paso 3: Seleccione el método de agrupación para los datos resumidos`,
"label.emailmerge.list.filetype":`Tipo de documento`,
"label.customfields.helptext.tip":`Los textos se muestrarán en la página detallada y la página de edición cuando los usuarios pasan el cursor sobre el ícono de información al lado de este campo`,
"label.setting.intergrationlist.description":`La integración de CloudCC le permite ver y compartir datos entre las aplicaciones de negocio sin salir de su CRM. Algunas integraciones, como QuickBooks y Zapier se requiere permisos para que los usuarios puedan utilizar. Algunas, como Gmail y Outlook pueden configurar en su propia cuenta de cada usuario.`,
"component_milestones_label_title":`Hito`,
"label.custom.AntiRevocation":`Cancelar Deshacer`,
"label.mobile.app.new.task":`Si permite la aplicación móvil activar App y crear tareas nuevas`,
"vue_label_opportunity_related_chooseproduct":`Elija al menos un producto`,
"label.standardguest":`Visitante Estándar`,
"label.icon.125":`Instrumento`,
"label.skipsomeset":`Porque este es Jump Start Wizard, CloudCC selecciona automáticamente algunas configuraciones para usted.`,
"label.forecast.shrepage.fmanager":`Gerente de previsiones`,
"label.mobile.quickcreate.default.work":`Trabajo`,
"label.projectManagement.nodata.team.members":`No puedo encontrar los miembros de mi proyecto`,
"label_social_media_account_settings":`Configuración de la cuenta en las redes sociales`,
"UG.quota.05":`Sincronización bidireccional con las oportunidades de negocio`,
"label.partner.workspace.tab.selectedoption":`Menú seleccionado`,
"front-kefu-moudle-v1-clientID-reinput":`Por favor, introduzca el ID del cliente`,
"label.mobile.home.page.contract.value":`Monto estimado de contrato`,
"december":`Diciembre`,
"label.campagin.roi.dcrs":`Asistencia`,
"label.currency.edits":`Editar moneda`,
"label.currency.company":`Moneda de la empresa`,
"label.customfields.newformula.nogrammererror":`No hay error de sintaxis en el campo combinado o la fórmula`,
"label.version.nonsupport.api":`?La interfaz API no está disponible temporalmente!`,
"label.data.file.i.title.num2":`2. Se recomienda exportar antes de importar, de modo que el documento de exportación se utilice como plantilla para cotejar los datos que se van a importar e impórtalos después. (Si los datos importados contienen comas, sustitúyalas por el símbolo @).`,
"front-console-conversation-title":`Evaluación del servicio`,
"front-kefu-moudle-call":`Llame a`,
"vue_label_systemSettings_pagefooter":`Configuración del pie de página`,
"label.newRule.successfully.added":`Nuevas reglas añadidas con éxito.`,
"label.trigger.direction.for.use":`Instrucciones para la plataforma de Triggers[Versión 2.0]`,
"label.instrumentPanel.maxLabelname":`Este valor debe ser mayor que el valor mínimo, punto de ruptura de valor 1 o 2`,
"label.same.month.report":`Informe interanual y mensual`,
"label.knowledge.language.american":`Inglés americano`,
"label.paging.totalof":`Un total de {0}`,
"label.tianyancha.businessverify.enable.error":`?Se frascasó en conseguir si active la verificación industrial y comercial, contacte con el administrador!`,
"vue_label_commonobjects_detail_email_template":`Utilizar plantilla de correo electrónico`,
"message.error.save.failed":`Error al guardar`,
"advancedoptions":`Opción avanzada`,
"setup_object_layout_message_selectedlayoutandrecordtype":`Seleccione dise?o y tipo de registro`,
"label.sendemail.recycle.operatesuccess":`?Operación exitosa de limpiar la papelera de reciclaje, se ha eliminado un total de #size datos.`,
"J":`Área de los textos (Longitud)`,
"message.validation.isnotmail":`Introduzca el correo válido`,
"label.timetrigger.before.lasttime":`1 hora más temprano que la última modificación`,
"label.tabpage.arecordtypez":`Tipo de registro disponible`,
"label.reportoption":`Opciones de informe`,
"pagecreator.button.next":`Siguiente`,
"assetbom.transferowner.notpermission":`No tiene permiso para migrar la lista de materiales de activos. Póngase en contacto con el administrador`,
"label.toptitle.lightning":`Menú Lightning`,
"label.copy.target":`Valor del indicador de clonación`,
"label.productsales.oppor.approach":`Oportunidades inminentes`,
"label.email.template.select":`Seleccione una plantilla de correo`,
"label.edit.lower.bound.of.discount.per.tier.is.required.":`Se requiere el límite inferior para editar cada nivel de descuento.`,
"label.tabularreport.step3":`Paso 3: Definir orden de columna en el informe`,
"label.multilang.cchttpservice.signin":`Estimado {0}, el cliente invitado {2} del evento {1} ha registrado con éxito.`,
"label.appexchange.uninstallpage.message3":`Cancelar permanentemente todos los datos de objetos personalizados en este paquete`,
"label_tabpage_ownedz":`Total`,
"label.tabularreport.2018.step2":`Paso 2: Seleccione criterios de informe`,
"label.object":`Objeto`,
"template.report.contracted.customers":`Análisis del sector de las cuentas contratadas`,
"label.field.remark3":`Nota: si cancela algún campo personalizado, cancelará todos los filtros habilitados en este campo. Al mismo tiempo cambiará el resultado de las reglas de Asignación o Distribución que dependen de los datos del campo personalizado.`,
"label.eventview.issms":`Si avisa por SMS`,
"label.knowledge.language.brazilian":`Portugués (Brasil)`,
"vue_label_norm_viewfilter":`Aplicar filtro`,
"label.forecast.settings.qijian":`Período de previsiones`,
"label.startuploadfile.step.intruduce":`Haga clic en ¨Seleccionar archivo¨ para buscar archivos, y mostrar los archivos seleccionados en la área siguiente`,
"label.smstemplate":`Plantilla de SMS`,
"vue_label_chatter_no_permission":`No tiene permiso para ver este archivo`,
"label.callcenter.Incorrect.data.filling":`Hay un error al rellenar los datos`,
"label.tag.search.button":`Filtrar por etiqueta`,
"label.multiplyselectoptions":`Opciones de casilla de verificación`,
"lable.outlook.detail.mutual":`Sync bidireccional`,
"label.workflow.estimatecondition1":`Creado, y cada vez que se edita para cumplir posteriormente los criterios`,
"label.validate.globalvariable.user.profileId":`ID de perfil`,
"UG.Campaign.003":`Crear campaña`,
"label.validate.function.funcExplain.ISNULL":`Regresará TRUE si la expresión está vacía. Si contiene un valor, regresará FALSE`,
"label.setting.intergrationlist.status0":`ESTADO DE INTEGRACI?N`,
"label.copy_error":`Fallo al copiar`,
"label.connectOtherNone":`El objeto seleccionado no tiene objetos que pueden relacionar más`,
"label.bmap.beijing":`Beijing`,
"front-kefu-moudle-v1-hxzxybsc-again":`Easemob ha sido eliminado. Por favor, vuelve a conectarte.`,
"label.wei.pollsubject":`Subjeto de votación`,
"APPIntegration_Social_twittererror":`Debe ingresar a una URL válida de twitter.com`,
"label.appupload.install.apicannotuse":`El nombre de api no está disponible`,
"label.returntolist":`Regrese a la lista`,
"label.translation.start2":`Seleccione una configuración de componente`,
"lable.edit.queue.alter":`Seleccione los objetos que quiere asignar a esta cola`,
"label.campaign.channel.step3":`Paso3: Seleccione campos para mostrar en la página de registro de canal de marketing`,
"label.data.newtemplate.e.seltype":`Seleccione el método de exportación de datos`,
"front-kefu-moudle-hangup":`Cuelga`,
"label.forecast.forecastroleuserpage.shre.managerandother":`Administradores y gerentes de previsiones pueden compartir las previsiones`,
"label.knowledgebase.mark.as.new.version":`Marcar como novedad`,
"label.conditiontag.lookup":`Buscar`,
"label.import.page3.importsucceed":`Importado con éxito`,
"label.stdashbord.xsld.condtion":`Configurar de condición`,
"label_emailtocloudcc_redmessage10":`La página ha caducado, ingrese de nuevo. `,
"label.event.moveup.1hour":`1 hora con antelación`,
"label.chat.topic.page.add.favorite":`Guardar como marcadores en la página de CCChatter`,
"label.icon.88":`Consultivo`,
"page_404_label_noresource":`Lo sentimos, los recursos que quiere acceder no existe.`,
"label.quickbooks.refresh":`Refrescar`,
"front-kefu-moudle-which-getphone-case":`Reglas para crear casos después de responder a una llamada`,
"label.objecttab.edit":`Editar el menú de objetos`,
"label.data.file.the.trigger":`Ejecutar el disparador`,
"frame.personinfo.label.personimage":`Foto de perfil`,
"label_tabpage_turnoffsz":`Cerrar-convertido`,
"label.sendmail.batch.chose":`Correo masivo: seleccione destinatarios`,
"label.data.downpage.i_title":`Paso importar datos:`,
"label.recycle.clearconfirm":`?Está seguro de cancelarlo?`,
"chatter.using":`Este utilizado`,
"label.batchadd.newbatchpage.list":`Lista de añadir los datos masivos`,
"pagecreator.systemstyle.button.new":`Crear diseño`,
"label.notification.serviceappointment.changestate":`El estado de {1}{0} ha cambiado a{2}{3}`,
"label.weixin.weipollname":`Nombre de Micro Voto`,
"label.tabpage.skip":`Ir a`,
"label.edit.field":`Editar campos`,
"label.edit.new.rule":`Editar las reglas de generación`,
"label.approved.receiveApprovalEmail":`Acepte la solicitud de permiso via correo`,
"label.dashboard.refreshNow":`Refrescar ahora`,
"label.lookup.introduce":`Ingrese por lo menos un carácter para hacer la búsqueda difusa`,
"homepage.components.newdes":`Asegúrese de  que el código HTML ingresado siguiente sea válido y el formato sea correcto. Escribir código HTML inapropiado en un componente causará que el menú de la página oficial se muestre incorrectamente.`,
"label.role.giveuserrole":`Asignar roles a los usuarios`,
"lable.opppdt.selPbk.subtitle":`Libro de precios`,
"setup_mainpage_label_welcome19":`Instrucciones: Haga clic en el menú a la izquierda de la página → Configuración de Gestión → Gestión de Usuarios → Usuarios, Roles, Perfiles`,
"setup.mainpage.label.welcome22":`Instrucciones: Haga clic en el menú de la izquierda de esta página → Ajustes de gestión → Plantilla de comunicaciones → Plantilla de correo electrónico.`,
"label.tianyancha.h5.zipcode":`Código postal`,
"label_tabpage_allapplications":`Todas las aplicaciones`,
"label.chatter.like":`Me gusta`,
"label.licence.noremainder":`Cantidad de licencia insuficiente`,
"lable.outlook.edit.dataset":`Configuración de datos`,
"D":`Fecha`,
"label.detail":`Ver`,
"label.globaloperation.operationtype.custom_page":`Página personalizada`,
"label.addattachment.down":`Descargar el fichero`,
"label.data.exportall.all_btn":`Exportar todos los datos`,
"label.recordtypeselect.current":`Tipo de registro actual`,
"label.tabpage.entercusnamez":`Introduzca el nombre del cliente`,
"label.location.valunit.km":`Km`,
"label.mobile.phone.week.plan":`Próxima semana`,
"vue_label_report_everyday":`Todos los días`,
"label.weixin.broadcasting":`Enviando...`,
"label.input.search.string":`Ingrese la cadena de caracteres para buscar`,
"label.picandreporttype":`Tipo del gráfico`,
"label.setmulti":`Transferir múltiple`,
"label.visualpage.component.t":`Utilizar los componentes component`,
"label.knowledge.designate":`Solo se puede asignar un artículo de conocimiento en estado de Borrador`,
"label.enable.barcode.only":`Activar sólo el código de barras`,
"vue_label_commonobjects_detail_a_group_strategy":`Este dato no tiene propietario, no se puede crear un Plan de Equipo`,
"setup.layout.group.button":`Botón`,
"label.mini.layout.remark":`Es el dise?o utilizado en la ventana flotante en la página`,
"setup.mainpage.label.welcome3":`La creación de formularios en la plataforma en la nube CloudCC se basa en bases de datos personalizadas (objeto), los objetos definidos por el usuario son tablas de bases de datos que almacenan datos específicos de su organización. Las relaciones entre tablas pueden establecerse fácilmente sin necesidad de desarrollar ningún programa.`,
"label.knowledge.draft.status":`El estado de publicación de los artículos de conocimiento debe ser Borrador`,
"label.manageAll.sel.one1":`?tems por aprobar`,
"label.campagin.roi.bhydkhywjh":`Cantidad para ganar oportunidades`,
"label_partner_template_thumbnail":`Imagen en miniatura`,
"label.loginip.setup":`Rango de login IP`,
"label.data.downpage.e.title.e.btn":`Vaya a la página de importación y comience a importar`,
"vue_label_appstore_project_management":`Gestión de proyectos`,
"assetbom.delete.notpermission":`No tiene permiso para eliminar la lista de materiales de activos. Póngase en contacto con el administrador`,
"vue.dashboard.setdrill.inThe":`sujeto a`,
"label.mobile.more.savephoto":`Guardar foto`,
"label.customerinfo.PageTriggerFag":`Sync`,
"label.commonobjects.Nopermission":`Lo sentimos, no tiene permiso para editar estos datos, por favor, póngase en contacto con el administrador del sistema`,
"label.searchlayout.opperationtab.xsldfield":`Los campos mostrados al hacer clic en el enlace de embudo de ventas bajo el menú de oportunidad en la página oficial.`,
"label.emailsync.form.disconnect":`Cancelar asociación`,
"label.document.nofile.upload":`No hay archivo por subir.`,
"label.appointmentpage.wizard.subtitle3-3":`Teléfono`,
"message.custom.field.donotdelete":`El campo se ha utilizado y no se puede cancelar`,
"chatter.using0":`{0}ms ha sido utilizado hasta ahora`,
"label.tabpage.multiple":`Opción múltiple`,
"label.attendance.setting.sy.alert":`?Debe seleccionar los usuarios aplicables para la asistencia!`,
"label.refuse":`Rechazar`,
"label.log.button":`Buscar por nombre de usuario`,
"component_chatter_link_label_title":`Enlace`,
"template.report.contract.collection":`Pago del contrato`,
"label.campaignmember.selectmember.step1":`Paso 1: Seleccione campa?a y status de miembros de campa?a`,
"label.datamanage.warn.owner":`Advertencia: Si continua la importación, será el propietario de todos los registros importados. `,
"label.a.b":`Relación de A a B`,
"label.app.step3.homeisfrist":`La página oficial deber ser la primera`,
"UG_Lead_003":`Social`,
"label.partner.workspace.member.choice":`Seleccione perfil`,
"lable.outlook.detail.emaping":`Campo de mapeo de evento`,
"label.service.appointmentList.gantt.chart.shows":`Mostrar fecha en Gantt`,
"label.mr.caption.account.result":`Encontrar Duplicados y Combinar: Resultado de duplicados de los clientes`,
"vue_label_chatter_approve_members_join":`Aprobar solicitud de entrada al grupo`,
"label.reportsSubscriptionPage.schedulereport.monthly.day":`Día`,
"pagecreator.systemstyle.label.modifycolor":`Editar color`,
"label.tabpage.yesz":`Sí`,
"label.fieldtoolongmessage":`Los campos han superado al límite`,
"lable.account.year.name":`Nombre del a?o fiscal`,
"label.mini.layout":`Dise?o flotante`,
"label.icon.97":`Enseñando`,
"vue_label_chat_smart_assistant":`Asistente inteligente`,
"label.marketingmanagementuser":`Usuario de marketing`,
"label_emailtocloudcc_description2":`Vincule su correo`,
"label.campaign.channel.input.name":`1. Ingrese el nombre de canal de marketing:`,
"UG.homepage.007":`Desde el envío de correos electrónicos de seguimiento hasta la automatización de campañas de ventas, pasando por la creación de flujos de trabajo mediante nuestra tecnología Blueprint o la activación de macros personalizadas, automatice las tareas diarias y céntrese más en la creación de relaciones.`,
"label.share":`Compartir`,
"label.step2.total6":`Paso 2 de 6`,
"label.sendemail.chat.addComentspraise":`Estimado #name:\n\n hello! #userName respondió al miscro-publicación que quiere`,
"label.icon.20":`Archivo`,
"label.service.gantt.absenteeism":`Absentismo`,
"message.error.color.nagatice":`El número de página actual no puede ser negativo`,
"chatter.group.applyToJoin":`Solicitar la entrada`,
"pagecreator_layout_message_delete":`?Si quiere cancelar el dise?o actualmente seleccionado?`,
"label.multilang.viewlist.count":`Un total de {0}registros:`,
"message.notdesable.type":`Este tipo de registro no se puede cancelar porque los perfiles siguientes utilizan este tipo de registro como el valor predeterminado.`,
"label.standard.time":`Hora estándar`,
"label_chatter_newpost":`Últimas publicaciones`,
"front-epwechat-module-v1-binding":`Encuadernar WeCom`,
"label.recent":`Reciente`,
"label.globaloperation.createfeeditem":`Crear proyecto de extracto`,
"label_partner_common_roleNum":`Cantidad de roles`,
"front-template-V1-quikSearch":`Introduzca el nombre del campo y busque`,
"label_tabpage_haschangedz":`El candidato ha sido convertido`,
"label.service.work.order.line":`Proyecto de fila de la orden de trabajo`,
"label.lead.score.ok":`OK`,
"Account_News_Setting_003":`Configuraciones generales`,
"label.event.moveup.15minutes":`15 minutos con anticipación`,
"vue_label_all_selected_objects":`Todo los objetos seleccionados`,
"label.visualpage.an.inline.style.relatedlist":`Encajar el tipo de página personalizada para listas relacionadas`,
"label.umeng.approval.approvaling":`#applyer está solicitando la aprobación de #obj #objname #owner`,
"lable.SalesCommitmentKanBan.digital":`Dígito`,
"label.appupload.img.max.size":`La imagen subida es demasiado grande, el tama?o máximo de la imagen no excede a 20K, suba de nuevo. `,
"vue_label_normal_top":`Fijar`,
"label.knowledge.language.traditional":`Chino tradicional`,
"homepage.layout.edit":`Editar dise?o de la página oficial`,
"label.campagin.qrcode":`Código escaneado de Campa?a`,
"label.emailmerge.merge.emailmerge":`Fusión de correo`,
"label.icon.18":`Reloj`,
"vue_label_homepage_taskview":`Vista de tareas`,
"label.search.related.record":`No encuentran registros relativos.`,
"label.report.reports":`Informes`,
"label.appointment.wizard.subtitle4-3-2":`15 minutos`,
"label.forecast.condition":`Criterios de previsiones`,
"label.westem.indonesia.time":`Hora de Indonesia Occidental`,
"front-epwechat-module-v1-callback-desc":`Copie la siguiente información en el backend de WeCom.`,
"label.version.group":`Versión de grupo`,
"label.allReportType":`Origen de todos los informes personalizados`,
"label.trigger.lastmodifydate":`Fecha de la Última Modificación`,
"message.layout.unique.sectionfield":`?Está en contra de la restricción única del dise?o de página, revíselo y guarde de nuevo!`,
"vue_label_systemSettings_mobelbottonsetting":`Configuración del menú inferior de la aplicación móvil`,
"label.recordtype.selectonefield":`Seleccione al menos un campo quiere añadir.`,
"label.notification.group1":`【申请人】está solicitando unirse a su grupo público`,
"component_todaytask_label_title":`Tarea de hoy`,
"label.assignment.setup.list.description":`Utilice la regla de asignación para distribuir los registros a los usuarios correspondientes automáticamente. La regla de asignación consta de criterios definidos en el registro y ítems de regla.`,
"label.project.resource.data":`Este recurso de servicio ya ha sido asignado a una cita de servicio, no lo añada de nuevo`,
"label.emailmerge.newtemplate.file":`Fichero`,
"label.notification.task1":`【分配人】le ha asignado una tarea`,
"label.ServiceCloud.Overlapping":`Visualización superpuesta de asignaciones`,
"label.globalselect.used":`Posición del uso de campo`,
"setup_layout_button_layoutprop":`Propiedades`,
"label.quickbooks.retrivingdata":`Obteniendo datos...`,
"component.button.ok":`Aceptar`,
"message.pleaseinputformula":`Por favor ingrese fórmula`,
"label.h5.whatifollow":`Lo que sigo`,
"label.new.crew.target":`Nuevo objetivo de personal`,
"label_chatter_task":`Tarea`,
"label.knowledge.setting.data.four":`Se puede seleccionar un máximo de {cuentas} grupos de categorías.`,
"label.rule.not.enabled":``,
"label_in_scope":`Dentro del rango`,
"label.partnerCloud.orderingPlatform.bundle":`Paquete`,
"label.emailtocloudcc.redmessage10":`Información caducada, reinicie la sesión`,
"label.knowledgebase.data.assignment.succeeded":`{a} datos asignados con éxito`,
"vue_label_commonobjects_view_nokanban":`No se ha creado ninguna vista de Kanban`,
"label.knowledgebase.article.cancelled.attaching.case":`El artículo {nombre} ha sido cancelado para adjuntarlo al caso！`,
"label.brief":`Resumen`,
"label.version.sum.app":`Aplicaciones`,
"label.commoninfo":`Información común`,
"vue_label_SMS_nodata":`No hay datos`,
"label.icon.153":`Información`,
"label.conditiontag.lookup.false":`FALSE`,
"label.emailobject.view.unread":`Correos no leídos`,
"label.staticresource.useful":`?Dónde se utiliza?`,
"label.ems.connect.test":`Probar`,
"vue_label_chat_group_assistant_notification":`Notificación de asistente de grupo`,
"label.multipleactivity.total":`Un total de`,
"vue_label_report_addtocomponentlibrary":`Añadir a la biblioteca de componentes`,
"font-evaluate-module-v1-following-personnel":`Notificar a los siguientes usuarios cuando reciban una evaluación inferior a 3:`,
"label.setup.mobile.bottombutton.change.fail":`No ha podido cambiar`,
"front-epwechat-module-v1-unbound-item5":`y no se pueden recuperar los datos, ¿está seguro de que hay que desvincularlos?`,
"label.customerinfo.smsUid":`UID de puerta de enlace de SMS`,
"label.list.isOpenApprovalQueue":`Activar la cola de aprobación (no disponible en la selección manual de aprobadores)`,
"label.leadscore.setup.scorenumber":`Vez`,
"label.workflow.selectobj.introduce":`Seleccione el objeto a lo que se aplica la regla de flujo de trabajo`,
"label.visualpage.label.for.example":`La etiqueta de página por ejemplo:`,
"label.appointmentdetail.wizard.title17":`Plan de jueves`,
"label.projectManagement.timeFrame":`La fecha de inicio y de finalización de la tarea deben estar dentro del rango de tiempo del hito`,
"lable.product.pricebooks.list":`El libro de precios es una lista de producto con un precio especial y moneda definida. El libro de precios se puede configurar para múltiples monedas. Al poner un producto en un libro de precio, las oportunidades o cotizaciones solo se pueden incluir los productos de un libro de precios singular. Para editar los productos en el libro de precios, haga clic en el nombre del libro de precios.`,
"font-trade-module-v1-delete-invoice":`Verificar la factura`,
"vue_label_salesadvance_winamount":`Cantidad total de transacciones ganadas`,
"component.salesperformance.label.nopermission":`Para ver los datos relacionados con las oportunidades de negocio, póngase en contacto con el administrador del sistema.`,
"vue_label_report_formatreport_desc":`Exportar el informe con cabeceras, grupos y configuración de filtros.`,
"label.enable.qrcode.only":`Activar sólo el código QR`,
"label.smstemplate.edit":`Editar plantilla de SMS`,
"label.qrcodeSetting.detailed.information":`El código QR puede almacenar más datos que el código de barras y no es necesario el escaneo lineal. Por ello, el código QR se aplica ampliamente en el seguimiento de productos, la identificación de artículos, la gestión de documentación y el marketing, etc.`,
"label.event.moveup.1week":`1 semana con anticipación`,
"label.customize.memory.function.sorting.disable":`Desactivar la memoria de la ordenación de cabeceras`,
"label.icon.195":`Bañera`,
"label.compact.layout.assign":`Asignación del dise?o de información clave`,
"label.icon.183":`Casa`,
"front-kefu-moudle-v1-jchxzxzi-chat":`Integrar el chat en línea del asiento de Easemob para proporcionar un servicio SaaS más completo.`,
"label.mycontact":`Mis contactos`,
"label.tabularreport.2018.step3":`Paso 3: Seleccione criterios de informe`,
"chatter.group.uploadGroupPicture":`Subir el perfil del grupo`,
"label.total.forecast.setup":`Previsiones primero y configurarlo como`,
"label.weixin.group.description":`Notas`,
"label.edit_emailfooter":`Editar el pie de página del correo electrónico`,
"label.ems.create":`Nuevo`,
"label.weixin.optionseven":`Opción 7`,
"font-evaluate-module-v1-continue-work":`Su evaluación nos ha animado. Seguiremos esforzándonos por mejorar.`,
"label.close.multilingual":`Desactivar el multilenguaje`,
"component.chatter.post.button.user":`Añadir usuarios`,
"label.use_QRcode":`Utilizar el código QR`,
"label.operatedata.exportsuc":`La exportación tiene éxito, ingrese al correo para ver la dirección de descarga de los documentos exportados, el documento se le guardará 48 horas, descargue lo antes posible. Tenga en cuenta de que preteja el enlace, se recomienda que cancele el correo una vez termine la descarga. `,
"label.page.step2.define.content":`Paso 2: Definir los contenidos y propiedades mostradas`,
"label_tabpage_groupingitem":`?tems del Grupo`,
"label.customfields.placeholder":`Rellenar la muestra`,
"vue_label_commonobjects_detail_enter_subject":`Introduzca el tema`,
"label.multilang.workflow.everyotherdayinmonth":`{1} días cada {0} meses`,
"label.knowledgebase.data.archiving.failed":`{a} el archivo de datos ha fallado`,
"vue_label_notice_nopermission_view":`Lo sentimos, no tiene acceso para ver este dato, por favor, póngase en contacto con el administrador.`,
"vue_label_calendar_calendar_view":`Vista del calendario`,
"lable.outlook.edit.des":`Si un contacto Exchange coincide con múltiples contactos de CloudCC.com, sincronice con los contactos de CloudCC.com que alcancen los criterios siguientes`,
"label.custom.NextCQ":`Siguiente trimestre personalizado`,
"label.emailsync.form.stutas":`Estado`,
"label.nameandintro":`Nombre y Descripción`,
"label.dashboardSetup.showdw":`Unidad de visualización`,
"label.tianyancha.actualcapital":`Capital recibida`,
"front-kefu-moudle-info-delete-calluser":`La información ha sido modificada, por favor, póngase en contacto con el administrador`,
"label.emailobject.list.all":`Seleccione todo`,
"label.campaign.channel.step7.send":`Seleccione los usuarios para recibir el correo`,
"label.formulafield.type":`Tipo de regresar fórmula`,
"label.reportsSubscriptionPage.schedulereport.weekly.thursday":`Jueves`,
"label.chosesubject.eat":`Programar una cena`,
"label.back":`Regresar`,
"label.h5.allcompany":`Todas las publicaciones de nube`,
"label.location.display.type.digital":`Digital`,
"label.datamanage.error.csv":`El formato de archivo inválido, el sistema sólo se permite el fomato general CSV, intente de nuevo`,
"label.emailobject.mark":`Marcar`,
"setup_mainpage_label_welcome9":`Los usuarios pueden realizar la demuestra de clasificación y ajuste de dise?o de todos los elementos de página , así como la configuración de solo lectura y campos obligatorios en la página a través de arrastrar y saltar el ratón sin hacer desarrollo del código.`,
"label.icon.56":`Instrumento De Medición`,
"label.forecast.edit.fwcd":`Rango de longitud`,
"vue_label_email_Please_select_related_items_first":`Seleccione primero los elementos relacionados`,
"label.icon.87":`Libro`,
"label.knowledgebase.recovery.was.successful":`La recuperación fue un éxito`,
"label.emailobject.emaildetail.promptcontent":`?Está seguro de que desea cancelar este correo? Tenga en cuenta de que la operación es irreversible`,
"label.delete.role":`Cancelar roles`,
"label.multiselect":`Lista de opciones(Múltiples selecciones)`,
"label.customerinfo.mailisnull":`No se configura el correo de empresa`,
"label.waitforamoment":`Cargando, espere por favor...`,
"lable.edit.queue.tip":`Ingrese el nombre de cola y correo al enviar notificación(Por ejempo, al poner un caso en la cola), si la dirección de correo esté vacía, no enviará el correo. Si opte por ¨Enviar correo a los miembros¨, notificarán a los miembros de cola al asignarlos a una cola, si no seleccione, no la notificarán.`,
"lable.custom.y.d":`Esta página le permite definir un registro de año personalizado. Las fechas del año personalizado se generarán en función de las opciones que elija a continuación.`,
"chatter.feed.content.user.searchbutton":`Buscar`,
"label.data.downpage.i.list.desc3":`Los usuarios pueden ver el motivo de la importación fallida en la última columna del archivo después de la descarga.`,
"label.tag.manage.createdby":`Creado por`,
"label.h5.similar.opportunity.last.months3":`Los últimos 3 meses`,
"chatter.group.members":`Miembros`,
"label.knowledgebase.data.translation.failed":`Traducir {a] datos falló`,
"label.log.look":`Revise configuraciones del seguimiento de auditoría`,
"label.service.gantt.week.timescale":`Escala de tiempo en la vista de la semana:`,
"label.userLicence":`Licencia de usuario`,
"label.file.library.managemembers.permission":`Acceda a`,
"label_emailtocloudcc_name":`Nombre`,
"label.mr.mrSuccess":`Fusión exitosa`,
"vue_label_commonobject_view_notice_selectadd":`Seleccione los datos que desea añadir`,
"vue_label_commonobjects_detail_level":`Nivel`,
"CloudCCCRM_ST_Info_TypeIn_001":`Por favor ingrese`,
"label_chatter_list":`Lista`,
"label_tabpage_optionsz":`Opciones`,
"UG_homepage_008":`Conocer el status de negocio actual(Informe de ventas, ranking, embudo de ventas, etc.), ver las oportunidades que son posiblemente problemáticas, predecir rendimiento del futuro, tratar y asignar a tiempo los asuntos importantes y tomar decisiones correctas.`,
"label.myselfdashboard":`Mi Cuadro de Mando Personal`,
"label.globaloperation.operationtype.record_phone":`Registrar llamada`,
"label.field.standard":`Estándar Campo`,
"label.changemydisplay.appedit.check":`Descubrir configuración personlizada personal de las aplicaciones personalizadas`,
"label.tianyancha.h5.legalpersonnames":`Representante legal`,
"label.tabpage.sorttypez":`Tipo de orden`,
"label.newdashboard.folder":`Carpeta de tablero nueva`,
"label.campaign.channel.step6":`Paso 6: Generar la página de registro de canal de marketing`,
"label.ems.composeemail":`Enviar correo`,
"label.app.step4.tabcanuse":`Menú disponible`,
"label.sendmail.batch":`Correo masivo`,
"label.process.execute.title":`Pendiente`,
"lable.outlook.detail.lastup":`Última actualización`,
"label_emailtocloudcc_delete":`Eliminar`,
"lable.opppdt.selPdt.leastone":`Seleccione por lo menos una fila`,
"label.customfields.new.step2.opration.exid":`ID external`,
"label.assignment.setup.newrule.description":`Ingrese el nombre de regla, y luego seleccione activar casilla de verificación, utiliza la regla para la asignación automática. Activar esta regla significa prohibir el uso de la regla acutal de asignación.`,
"label.campaign.channel.input.to.isactivity":`7. Si activa canales de marketing`,
"label.document.return":`Regrese a los documentos`,
"label.data.downpage.i_title.num5":`5. Revise la precisión de los datos.`,
"label.taskinto":`Al asignar automáticamente las tareas a los usuarios, tareas son plantillas que el flujo de trabajo utiliza.`,
"label.customfields.formula.textexample":`Nombre completo= LastName &amp; ", " &amp; FirstName`,
"label.appointmentpage.wizard.subtitle1-1":`Próxima semana`,
"label.weixin.radio":`Selección única`,
"vue_label_file_replace_reason_check":`Motivo de reemplazo (opcional)`,
"label.sendemail.recycle.operateexception":`?Error al limpiar la papelera de reciclaje, intente de nuevo! `,
"label.vlidaterule.formulaerror":`Se ocurre un error si el descuento es superior al 30%`,
"vue_label_campaign_existing_member_status":`Mantener el estado de los miembros existentes`,
"label.service.miniProgram.fillSlideshowName":`Introduzca el nombre del carrusel`,
"label_partner_workspace_login_headerfooter":`Encabezado y pie de página`,
"label.quickbooks.viewlist.total2":`Hay {0} estimaciones para un valor total de {1}`,
"chatter.viewingResults":`Ver resultados`,
"label_tabpage_allvisible":`Visible para todos los usuarios`,
"label.quote":`Cotización`,
"label.changemydisplay.list.des":`Personalizar el menú según sus necesidades`,
"label.leadscore.notimes":`Oportunidad de puntuación se agotó`,
"label.icon.51":`Generación De Energía`,
"component.assistant.label.title":`Asistente`,
"label.emailobject.emailsent":`?Correo enviado con éxito!`,
"label.group.nofile":`No hay ficheros enviados a este grupo.`,
"label.foldervisitlimit2":`Todos los usuarios no pueden ver esta carpeta`,
"label.dataoperate":`Operación de los datos`,
"label.addattachment.size":`Tama?o`,
"label.not.double":`No se permiten los valores duplicados`,
"label.customfields.formula.number.tip":`Calcular el valor numérico`,
"lable.opppdt.addpdt.table.description":`Descripción de línea`,
"label.sms.isactivity":`Si activa`,
"label.campaign.channel.input.owner":`4. El propietario de los candidatos registrados de esta canal de marketing:`,
"label.visualpage.notfound.error":`Un error desconocido se ocurrió, contacte con el administrador`,
"label.mr.title.button.group3":`Registros`,
"label_tabpage_beginz":`Empezar`,
"label_tabpage_queue":`Cola`,
"label.tabpage.advancedscreening":`Filtro avanzado`,
"nogreate":`Menos o igual`,
"chatter.fields":`Campo de`,
"button_partner_workspace_manage":`Gestionar`,
"label.partnerCloud.orderingPlatform.search":`Buscar productos`,
"message.password.isnull":`La contrase?a no se puede estar vacío.`,
"label.fenbeitong.title":`Configuración de FenBeiTong`,
"label.salescloud.contactrole.message.chooseatleastone":`Seleccione por lo menos un contacto`,
"label.knowledge.delete.election":`Error al borrar la selección de la categoría de datos`,
"front-console-status-hoided":`Colocación`,
"label.lastmodifydate":`Fecha de la Última Modificación`,
"vue_label_chat_deleting_chat":`Después de borrar, se vaciará el historial del chat y se eliminará de la lista de Plan de Equipo. Al recibir un nuevo mensaje, este volverá a aparecer en la lista de Plan de Equipo.`,
"label.timeframe":`Marco de tiempo`,
"UG.opportunity.002":`Defina su período de ventas y configure las etapas`,
"label.templates.merge":`Por favor, seleccione las plantillas que desea fusionar. Se puede seleccionar un máximo de 20.`,
"label.generatepage.c2":`La longitud máxima es de 30`,
"label.appointment.wizard.subtitle4-1-6":`2h`,
"label.passwordPolicy.setup.pwdremember3":`Recordar 3 contrase?as`,
"button.partner.workspace.enable":`Activar nube de socio`,
"vue_label_pool_nopool_notice":`Aún no se ha unido a ningún grupo público, por favor, póngase en contacto con el administrador para crear o unirse a un grupo público.`,
"label.layout.required.field.select":`Campos obligatorios seleccionados`,
"label.loginhis.date":`Ingrese la fecha de comienzo y la de finalización`,
"vue_label_commonobjects_detail_and_overdue":`Próximos y atrasados`,
"label_tabpage_advancedsearch":`Búsqueda avanzada`,
"label.custom.field.login.home.query":`Ingrese a la página ofical para ver los detalles de tarea.`,
"page":`Página`,
"label_tabpage_onlymevisible":`Solo visible para mí`,
"label.weixin.optionfour":`Opción 4`,
"label.confirm.to.remove":`Confirmar eliminar`,
"label.event.moveup.30minutes":`30 minutos con anticipación`,
"label.mail.merge.template.finish":`Plantilla de fusionar correo completada`,
"label.multilang.currencylist.before":`Antes de {0}`,
"label.goback":`Regrese a la página anterior`,
"label.unknown.prefix":`Prefijo inválido, ingrese de nuevo`,
"lable.account.CurrentandPreviousCYt":`2 A?os Calendario actuales y anteriores`,
"label.product.dent":`Ingrese las palabras clave y criterios de filtro, luego haga clic en Buscar para empezar su búsqueda. Haga clic en más filtros para uitlizar más de un filtro. Los resultados de búsqueda incluyen todos los registros que coinciden con las palabras clave y criterios de filtro ingresados.`,
"label.ems.bcc":`Cco`,
"label.import.index.operation":`Operación`,
"label.knowledge.setting.hint.eight":`Mantenga todo en perfecto orden.`,
"label.sso.saml.sp.idtype.fid":`La declaración contiene Federación ID del objeto de usuario`,
"vue_label_chat_voice":`Voz`,
"label.config.pw":`Confirmar nueva contraseña`,
"lable.newtabpage.closesearchresult":`Colapsar los resultados de la búsqueda`,
"lable.account.NextWeek":`Próxima semana`,
"label.ems.username":`Nombre de usuario (U)`,
"vue_label_email_emails_from_potential":`Todos los correos electrónicos de clientes potenciales y contactos de su CRM, y los correos que los contienen como destinatarios serán clasificados aquí`,
"lable.approval.shared":`Compartir la aprobación`,
"label.tabpage.allz":`Todo`,
"label.file.uploadfiles":`Subir archivos`,
"label.emailobject.text":`Texto:`,
"label.version.allow.create":`Se permite crear`,
"label.empty.field":`El campo no puede estar vacío.`,
"label.emailsync.status.department":`Departamento`,
"label.pw.str":`5 caracteres`,
"label.attendance":`Asistencia`,
"label_mobile_buttom_team":`Plan de equipo`,
"label.campaignmember.main.addcontactdesc":`Agregar todos los contactos existentes a esta campa?a`,
"label.search.result":`Resultado de Búsqueda`,
"label.weixin.activity.account":`Clientes activos`,
"label_tabpage_clearoptionsz":`Vaciar las opciones avanzadas`,
"UG.activity.01":`¿Cómo sigue sus registros para interactuar con sus clientes/equipos?`,
"serviceappointment.new.status.limit":`No se puede crear una nueva cita de servicio con estado programado o asignado`,
"label.notice.higher":`Enviar correo a gerente`,
"label.passwordPolicy.setup.gletters":`Caracter(es)`,
"label.data.exportsf.des":`Los ficheros exportados con éxito se guardarán 48 horas en el servidor, se cancelarán automáticamente después de 48 horas.`,
"label.view.onlymecansee":`Visible solo por <b> a mí</b>`,
"UG.Lead.005":`Correo`,
"label.umeng.approval.approvalfail":`Envío fallado`,
"label.huanxinconfig.clientid.lost":`clientid no puede estar vacío`,
"label.campaignmember.main.updatecontactstatus":`Actualizar el status-Contactos actuales`,
"component_chatter_button_delete":`Eliminar`,
"label.weixin.no.pending.projects.qin":`No hay ítems por aprobar`,
"front-electronic-signature-auto-fill-field":`Campo de relleno automático`,
"message.resetpw":`?Está seguro de que quiere resetear su contrase?a?`,
"label.service.ganttBaiduMap.service.resourname":`Nombre del recurso de servicios`,
"vue_label_pricebook_deleted":`Lista de precios eliminada`,
"label.icon.193":`Bañera`,
"label.validate.function.funcFormat.NOT":`NOT(logical)`,
"label.address.city":`Ciudad`,
"label.pc.ui.2018.searchs":`Ingrese los contenidos de búsqueda`,
"label.yard":`Código de invitación`,
"label.data.downpage.i_title.btn":`Vaya a la página de importación y empiece a importar`,
"label.useablereceivers":`Destinatarios disponibles`,
"label.cloudccsite.name.length":`Nombre de sitio no se puede exceder a 255 caracteres`,
"label.secrecy":`Confidencial`,
"label.campagin.roi.ydkhywjhzz":`Monto toal para ganar las oportunidades`,
"vue_label_report_conditiondesc_one":`A parte de suscribirse, puede establecer condiciones para este informe. Se le notificará si se cumplen todas las condiciones. Esto es opcional.`,
"label.datamanage.select.contactfield":`(Seleccione el campo correspondiente a los contactos importados)`,
"label.emailtocloudcc.filed.action":`Acción`,
"label.smstemplate.new":`Nueva plantilla de SMS`,
"label.mobile.side.tab.app":`Apps`,
"label.icon.118":`Reloj`,
"label.customfields.selectcontainfieldlayout.tip":`El campo se a?adirá como último campo a las primeras dos columnas del dise?o de página. Si no seleccione el dise?o, este campo no se mostrará en ninguna página.`,
"Lead_Homepage_Tools_BatchScoring":`Puntuación masiva`,
"lable.quote.syncing.quote":`Cotización`,
"pagecreator.button.preview":`Vista previa`,
"label.ccchat.am":`AM`,
"chatter.feed.menutype.user.nullrecent":`No hay registro reciente`,
"lable.info.queue.showallmember":`Ver miembros de cola`,
"label.multilang.campaign.selelctmember.desc":`Seleccione una vista y luego seleccione un miembro para añadir a la campa?a, el status del miembro es {0}`,
"label.notification.ccchat3":`【评论用户名】comenta su publicación`,
"UG.product.03":`Lista de precios con diferentes divisas`,
"label.sso.saml.idp.config.pksize":`Tama?o de clave`,
"label.defineCustomReportType":`Definir el origen de datos del informe personalizado`,
"component.timeline.button.filter":`Filtro`,
"label.mr.nextGroup":`Saltar a este grupo para ir al grupo siguiente`,
"label.quote.sprdz":`Dirección del beneficiario`,
"label.total.refuse.forecast.have.priority":`Rechazar todas las previsiones con prioridad`,
"lable.product.peep":`Ingrese un precio válido`,
"label.file.who.can.access":`Quién puede acceder`,
"label.page.last":`?litma Página`,
"label.icon.180":`Personas`,
"font-evaluate-module-v1-enabled-successfully":`Activar con éxito la opción de evaluación "Neural"`,
"label.appointment.wizard.subtitle4-2-2":`2h`,
"label.passwordPolicy.setup.oneyear":`Un a?o`,
"label.login.bound.mfadevice.title":`Activar el dispositivo virtual de MFA`,
"vue_label_dashboard_statisticalvalue":`Seleccione el valor estadístico`,
"label.ishistory":`Historial`,
"component.timeline.label.title":`Línea de tiempo`,
"label.page.step3.of.step5":`Paso 3 de 5`,
"label.assignment.setup.detail.section":`Detalles de regla`,
"label.salescloud.opportunity.nothave.main.contactrole":`No hay contactos principales`,
"label.import.page1.limitedcsv":`Solo cargar archivos csv`,
"label.icon.187":`Martillo`,
"label.emailobject.wizard.desc5":`Personalizar su firma para que el correo se vea más bonito.`,
"vue_label_report_notice_copy_success":`Informe copiado con éxito`,
"label.dupicatecheck.repeatcondition.chooserulemsg":`Todavía no ha seleccionado la regla de buscar duplicados`,
"label.componentEditor.upper.limit":`Límite superior 100`,
"label.validate.function.funcExplain.ISNEW":`Revise si el registro es nuevo, y regresará TRUE si es nuevo, FALSE si no. `,
"label.postalCode":`Código Postal`,
"label.dashboard.snapshot.enable.flag":`Activar instantánea de panel`,
"vue_label_file_upload_type_size":`Solo se pueden subir archivos {fileType} y no más de {size}MB`,
"label.appointment.wizard.subtitle3-6":`Sábado`,
"homepage.narrow":`Columna extrecha(Izquierda)`,
"chatter.addmute.confirm":`?Está seguro de que quiere mantener esta publicación ¨No moleste¨?`,
"label.lookup.account":`Buscar clientes`,
"message.lostthemanager":`Este envío requiere la aprobación del gerente del usuario, y el valor está vacío. Para los detalles, contacte con su administrador.`,
"label.exchange.sync.state.contact.m3":`Los registros sincronizados en las últimas 24 horas:`,
"label.version.phone.app":`Aplicación de Móvil`,
"label_tabpage_search":`Buscar`,
"vue_label_helpcenter_campaign":`En la información detallada, haga clic en el botón de diagrama de árbol junto a la campaña para ver y comprender el diagrama de estructura jerárquica de la campaña.<br> Gestione los contactos o clientes potenciales involucrados en las campañas a través de la lista relacionada de miembros de campaña.`,
"front-lightning-module-v1-dashborad-last-year":`El año pasado`,
"label.campaign.channel.value":`Valores`,
"vue_label_opportunity_contactrole_primarycontact_notice":`Para seleccionar su contacto principal, guarde este paso y elija desde "Gestionar"`,
"label.biaoqingfaxian.title":`Descubrir ofertas`,
"label.approved":`Aprobado`,
"label.hong.kong.time":`Hora de Hong Kong`,
"label.customfields.file.cannotopen":`No puede abrir el fichero`,
"lable.New.tips":`Haga clic en "Nuevo" para crear una nueva plantilla de informe de servicio sobre la base de una plantilla estándar o cualquier otra seleccionada. Active la plantilla y comience a utilizarla.`,
"component.setup.tabs.label.add":`Añadidos`,
"label.forecast.forehistory.replacebest":`Mejor caso reemplazado`,
"front-kefu-moudle-v1-jctrrt-call-serve":`Centro de llamadas integrado con TRRT para ofrecer servicios SaaS más completos`,
"label.workflow.configrule":`Paso 2: Configure regla del flujo de trabajo`,
"label.dashboard.snapshot.refresh.frequently":`Las instantáneas del panel se refrescan con demasiada frecuencia, intente de nuevo más tarde`,
"label.ems.editsetting":`Editar configuración de correo`,
"message.confirmdeleteAPP":`?Está seguro de que quiere cancelar la aplicación?`,
"label_chatter_activity":`Actividades`,
"label.editsharerules":`Permiso de compartir redacción`,
"label.loginservice.license.notuse.must":`La licencia no está disponible ahora, debe`,
"label.import.step2.beforeexport":`1. Antes de importar, asegúrese de importar todos los registros relacionados. Por ejemplo, si el objeto que quiere importar tiene relación de búsqueda con los contactos, tiene que importar los contactos primero e importar los datos después.`,
"label.chat.mute":`No moleste`,
"label.icon.128":`Casa`,
"label.give":`&&Y`,
"label.hide":`No mostrar`,
"label.relationobject.wpr":`Aprobador`,
"label.summation":`Suma`,
"label.layout.availabletab.details":`Detalles`,
"label.circle":`Gráfico de Donas`,
"vue_label_opportunity_contactrole_add":`Añadir rol de contacto`,
"label.file.library.file2libsuccess":`?Agregado con éxito!`,
"label.weixin.report.reportgenerated":`Reporte generado`,
"label.icon.91":`Personas`,
"report.label.pleaseinput":`Introduzca lo que quiere buscar`,
"label.escalation.setup.newaction.otheremail.tip":`Puede entrar hasta 5 correos para enviar. Cada correo se separa con coma`,
"label.area.donot.have.data":`No hay datos`,
"label.customcomponent.btn.reference":`Referencia de componentes`,
"label.appointmentdetail.wizard.title7":`Hora del recordatorio`,
"label.ccchat.with":`Tener`,
"label.file.size":`Tama?o`,
"label.product.sort.beyond":`Se puede establecer un máximo de 10 niveles.`,
"label.ccchat.2018":`CCChatter`,
"label.report.select.column":`Seleccione las columnas`,
"label.appointmentpage.wizard.subtitle1_1":`Seleccione la fecha y hora`,
"label.passwordPolicy.setup.uppercasealpandnumsymbol":`Debe contener mayúsculas y minúsculas alfanuméricas y signos`,
"label_chatter_addressee":`Destinatario`,
"label.profile.remark2":`Si su organización utiliza tipos de registro, utilice el enlace de edición en la sección de ¨Configuración de tipos de registro¨ al siguiente, que deja que los usuarios del perfil puedan utilizar uno o más tipos de registro`,
"UG_Account_01":`?Quién es su cliente?`,
"label.dataimport.error.contact.notnull":`Error: el nombre de contacto no puede ser nulo.`,
"lable.account.CalenderQuarter":`Trimestre calendario`,
"vue_label_commonobjects_detail_empty":`El precio de venta no puede estar vacío`,
"label.approveassigntemplate":`Permite asignar plantillas de correo`,
"label.objectRelationshipDescription1":`Origen de datos de este informe generará`,
"vue_label_email_insertmergefield":`Insertar campo combinado`,
"label.mobile.home.page.check.team":`Ver grupo`,
"lable.edit.queue.edit":`Cola de editar`,
"label.campagin.roi.query":`Ver ROI de campa?a`,
"label.dataimport.field.allow.access.to":`Los campos de datos no se permiten acceder, cancele manualmente los registros correspondientes y intente de nuevo`,
"pagecreator.systemstyle.message.canntdelete":`No se puede borrar el estilo actual`,
"label.searchkey":`Ingrese palabras clave`,
"chatter.showall":`Mostrar todo`,
"show":`Mostrar`,
"label.quote.choseproduct":`Seleccionar Producto`,
"label.report.selected.field":`Campos seleccionados`,
"label.globaloperation.operationtype.create_data":`Crear registro`,
"label.knowledge.setting.data.seven":`Eliminar grupo de categorías: {flzmc}`,
"chatter.email.mentionOrMessage":`Mencionar o mensajes`,
"label_tabpage_exclusivez":`Excluye`,
"chatter.en.userinfo":`Ingrese sus informaciones`,
"label.log.orgid":`Organización`,
"label.dataimport.insertdata.error.fieldrepeat.update":`El campo $schemefield_name$ en este registro no se puede encontrar en la base de datos y no puede hacer la actualización. Este registro ha ignorado la importación.`,
"vue_label_chatter_add_link_success":`Enlace añadido con éxito`,
"label.sender_details":`Para añadir nuevos detalles del remitente, cree un usuario en su`,
"label.ccpeak.addwhere.condition":`Un criterio de ¨Where¨ se puede añadir`,
"label.datamove.total":`Total`,
"label.tianyancha.businessverify.warning":`Tenga en cuenta que esta verificación solo admite los datos comerciales registrados en China continental.`,
"label.emailmainbody":`Cuerpo del correo`,
"label.justadmin":`Solo para los administradores`,
"label.data.downpage.e.list.desc1":`Esta página muestra los datos de los archivos exportados con éxito. Por favor, descargue los archivos exportados a tiempo según la información enviada a su correo electrónico.`,
"label.reportsSubscriptionPage.email.value":`Valores existentes`,
"message.error.serviceappointment":`Rellene la hora de inicio y la hora de finalización programada en la cita de servicio`,
"label.textMessageObject.selectone":`Seleccione al menos un registro como destinatario del mensaje de texto`,
"label.schedulejob.setup.schedule.plan":`Programar`,
"label.assignment.layout.field.isassigned":`Asignar de acuerdo con las reglas de asignación válidas`,
"label.captcha.error":`Error de verificación.`,
"mobel_web_not_more_data":`No hay más datos`,
"label.emailsync.form.emailaddress":`Dirección de correo electrónico`,
"label.loginservice.error":`Error del inicio de sesión, contacte con el administrador`,
"label.integrations.description":`Conectar su cuenta CloudCC con otras apps`,
"vue_label_homepage_notice_selectone":`Seleccione al menos un cliente potencial o contacto`,
"label.chatter.default":`Por defecto`,
"label.tabpage.datefield":`Cuando el campo de fecha es igual, se puede utilizar el formato "ayer", "hoy", "mañana", "el mes anterior", "este mes", "el mes siguiente", "la semana anterior", "esta semana", "la semana siguiente" o "AAAA-MM-DD, MM/DD/AAAA".`,
"front-kefu-moudle-myzdhsc-file":`Archivo de grabación no encontrado o no generado`,
"label.createname":`Creador`,
"label.mobile.phone.enter.plan":`Ingrese su plan`,
"report.label.highlevelreport":`El informes avanzado permite crear informes relacionados de hasta 4 objetos.`,
"label.edit.select.label":`Modo de editación`,
"label.partnerCloud.financeSetting.deduction":`Después de la activación, los fondos se añadirán a la cuenta de reembolso, al ingreso de reembolso y al objeto de gasto de reembolso. Los usuarios asociados pueden utilizar la cuenta de rappel para deducir la cantidad a pagar.`,
"message.duplication.label.updateoption":`Operación al actualizar`,
"label.custom.CurrentCQ":`Trimestre personalizado actual`,
"front-kefu-moudle-wait":`Esperando`,
"sunday":`Domingo`,
"label.service.timezone":`Zona horaria`,
"setup.layout.label.selectfield":`Seleccionar campo`,
"label_emailtocloudcc_filed_action":`Operación`,
"label.forecast.customforecast.mycommit":`Mi compromiso`,
"label.uploadsuc":`Subir con éxito`,
"vue_label_commonobjects_view_notice_atleast1field":`Seleccione al menos 1 campo de visualización`,
"label.dataimport.khmc.length":`Error: el nombre del cliente es demasiado largo.`,
"label.isemailnotification":`Si envia el aviso del correo`,
"label.addAPPexchange":`Añadir aplicaciones de Cloud CC App Store`,
"label.partnerCloud.orderingPlatform.currency":`La moneda:`,
"UG_quota_02":`Los presupuestos son las disposiciones jurídicas de transacciones bajo tiempo, precio y productos determinados entre los clientes y proveedores.`,
"label.customer.tab.step2.same.option3":`Ocultar el menú`,
"H":`Teléfono`,
"label_tabpage_searchz":`Buscar`,
"vue_label_homepage_deleted":`Borrado`,
"label.weixin.recent.view":`Visto Recientemente`,
"template.report.opportunity.sales":`Volumen de ventas de oportunidades`,
"label.customfields.new.step2.opration.unique.info.v1":`Tratar ¨ABC¨ y ¨abc¨ como valores duplicados (No distinguir entre Mayúsculas y Minúsculas)`,
"savesuccess":`Guardar con éxito`,
"label.partner.workspace.member.memo":`Todos los usuarios con perfil y permiso seleccionado pueden acceder a esta nube de socios.`,
"label.icon.23":`Fármaco`,
"lable.batchadd.service.cfq.before":`Triggers(Antes de importar)`,
"label.instrumentPanel.breakpointTwoLabelname":`Este valor debe ser mayor que el valor mínimo y el valor del punto de ruptura 1`,
"message.selectgsummaryinformation":`Seleccione los datos que quiere resumir`,
"label.tianyancha.businessverify.msg6":`Esta función utiliza los servicios de los terceros y tendrá situación inestable o servicio imposible debido al uso masivo. CloudCC no asumirá las responsabilidades por eso.`,
"vue_label_helpcenter_report3":`3.A. Haga clic en el cuadro de búsqueda de campos, seleccione el campo que desee buscándolo o desplazándose por la lista de campos, seleccione el operador del campo, introduzca o seleccione un valor, haga clic en Aplicar y el filtro de campo tendrá efecto. <br> B. Haga clic en el signo " " situado encima del cuadro de búsqueda de campos e introduzca una condición de filtrado avanzada formada por números y letras en el "Cuadro de entrada de la condición de filtrado". Por ejemplo, (1 y 2) o3.<br>? Editar filtros<br> Para editar los filtros, incluya los filtros estándar y haga clic en los filtros. <br>? Eliminar filtros<br> Haga clic en el icono "x" de un filtro para eliminarlo. <br>? Ejecutar el informe<br> Haga clic en el botón Ejecutar en la esquina superior derecha de la página de edición para ver los resultados completos del informe. <br>? Guardar el informe<br> Haga clic en el botón "Guardar" en la esquina superior derecha de la página de edición, rellene el nombre del informe, seleccione la carpeta del informe y guárdelo. <br>2. Crear carpeta de informes<br> Antes de crear una carpeta de informes, el sistema genera por defecto Mi carpeta de informes personalizada y Carpeta de informes pública sin archivar. <br> Paso 1: En la pestaña Informes, haga clic en Nueva carpeta de informes<br> Paso 2: En la ventana emergente de Nueva carpeta de informes, puede elegir transferir los informes de la carpeta de informes públicos no archivados a esta carpeta. Puede seleccionar qué usuarios pueden acceder a esta carpeta y los derechos de acceso. <br>3. Visualización de informes<br> Paso 1: Desde la pestaña Informes, vaya a la página de la lista de informes y busque el informe que desea ver alternando entre "Vistos recientemente", "He creado", "Todos los informes" o la carpeta Informes. o la carpeta Informes para encontrar el informe que desea ver. <br> Paso 2: Haga clic en el nombre del informe para verlo. O haga clic en el botón desplegable en el extremo derecho del informe y seleccione Ejecutar para ver el informe. <br>Si es un perfil de administrador, desde la pestaña Informes, vaya a la página de la lista de informes y haga clic en el icono del engranaje junto al botón Nueva carpeta para seleccionar los campos que se mostrarán en el encabezado de la tabla de la lista de informes de cada carpeta. <br>4. Exportar informes<br> Paso 1: Desde la pestaña Informes, vaya a la página de la lista de informes, busque el informe que desea exportar y haga clic en el botón desplegable situado en el extremo derecho del informe. <br> Paso 2: Seleccione el tipo<br> Informe de formato: contiene encabezados de informe, agrupación, detalles de filtrado. <br> Informe de sólo detalle: Líneas de detalle sin formato. <br> Paso 3: Haga clic en Exportar. El informe de sólo detalles debe exportarse en páginas, con un máximo de 2000 datos por página.  `,
"label.batchdelete.success":`Eliminación por lotes completada`,
"label.newprocess5.seq":`Orden`,
"label.knowledgebase.data.translated.successfully":`Traducir datos {a] con éxito`,
"label_enable_range":`Rango habilitante`,
"label.ccchat.and":`Y`,
"label.assignment.setup.list.norule":`No hay reglas específicas`,
"vue_label_report_summaryformulacolumn":`Columna de fórmulas de resumen`,
"label.field.edit.change1":`El punto máximo no debe exceder de 100`,
"syntaxerror":`Error de sintaxis, revise los criterios ingresados`,
"label.icon.116":`Casa`,
"lable.asset.BOM.according.to.product":`Generar la lista de materiales de los activos según la estructura de los productos`,
"chatter.like.post":`Me gusta esta publicación`,
"label.trigger.page":`Página de trigger`,
"vue_label_email_contact_adminstrator":`El sistema es anormal, por favor, póngase en contacto con el administrador.`,
"label.workreport":`Informe de trabajo`,
"vue_label_homepage_edit_card_view":`Editar vista de la tarjeta`,
"label_emailsync_status_disabel":`Desactivado`,
"label.icon.54":`Excavador`,
"message.error.view.validerr.common":`La verificación se falló`,
"label.exchange.sync.account.username":`Nombre de la cuenta de servicio(Nombre de dominio o UPN):`,
"label.dataimport.error.date":`Error: Fecha`,
"label.orgname":`Organización`,
"label.weixin.group.owner":`Propietario`,
"vue_label_dashboard_colorrange":`Gama de colores`,
"label.forecast.shrepage.tableth":`Acceso de previsiones`,
"label.related.disabled":`No lista relativa activada, contacte con el administrador para activar la lista relativa en la página del dise?o.`,
"label.version.product.management":`Gestión de productos`,
"label.knowledge.new.article.published":`El artículo se publica como un artículo nuevo.`,
"label.sendsms.batch.step4":`Paso 4: Ha enviado SMS`,
"vue_label_commonobjects_detail_and_tasks":`Enhorabuena, todos los eventos y tareas están procesados`,
"label.salescloud.ci":`Vez`,
"label.ccpeak.getapi.name.time":`Si quiere utilizar los métodos en la clasificación de CCService, necesite instanciar`,
"label.escalation.setup.detail.conditon":`Criterio`,
"label.lbs.isUseLbs":`Activar el servicio de ubicación`,
"front-lightning-module-v1-dashborad-color-depth":`Profundidad de color`,
"date":`Fecha`,
"label.select.personnel":`Seleccione el personal`,
"label.appointmentpage.wizard.notif3":`?Rellene el correo!`,
"label.import.page1.pleaseselectwayofdealdata":`Seleccione el modo de procesamiento primero`,
"label.partner.all.memo":`La lista muestra todas nubes de socios de su organización. Haga clic en la URL para iniciar la sesión.`,
"label.appointment.wizard.subtitle4-3-3":`30 minutos`,
"component_telerecord_label_subject":`Tema`,
"label.sendsms.batch.finish":`SMS masivo: Completado`,
"label.login.access.myusername":`Mi nombre de usuario`,
"label.weixin.wechatnumber":`WeChat ID`,
"label.eowechat.status":`Estado del usuario`,
"Lead_Scoring_Setting_Rule_Setup_Value":`Puntuación`,
"label.appexchange.oldreport.noupload":`Informe viejo-No subirá`,
"label.approverfieldediting":`Editabilidad del campo de aprobador y registros.`,
"label_tabpage_customernamez":`Nombre del usuario`,
"vue_label_dashboard_linkagesettings":`Ajustes de Enlace`,
"vue_label_ccchart_notice_deletecomment":`¿Está seguro de que quiere borrar este comentario?`,
"label.allprofile":`Todos los perfiles`,
"label.campaignmember.main.addMember":`Añadir miembros-Buscar`,
"label.projectManagement.subtask.list":`Lista de subtareas`,
"label.code.some.size":`Capacidad del Código: Máximo 200KB caracteres, aproximadamente 20,0000 bytes`,
"front-custom-service":`Service Cloud proporciona servicios personalizados eficientes y ágiles para los clientes, acorta el tiempo de resolución del servicio y aumenta las tasas de resolución con el sistema inteligente de órdenes de trabajo, mejora la fidelidad de los clientes y aumenta las tasas de recompra.`,
"label.SMS.det":`Notificaciones detalladas de SMS`,
"setup_layout_label_nobutton":`No hay botones disponibles`,
"vue_label_email_Could_not_save_template":`No se ha podido guardar la plantilla`,
"label.imgfield.height":`Altura`,
"label.leadscore":`Puntuación de Candidato`,
"setup_object_field_dependency_label_removefromlist":`Cancelar los valores seleccionados`,
"message.error.code.null":`El código de autorización no puede estar vacío`,
"label.tianyancha.businessscope":`Rango de operación`,
"vue_label_chat_empty_message":`Vaciar mensajes`,
"label.total":`Total`,
"label.delerror.list":`Lista de archivos no cancelada`,
"label.selectedreceivers":`Destinatario seleccionado`,
"label.layout.availablepages":`Páginas disponibles`,
"label.pc.ui.2018.personalinfo":`Información Personal`,
"label.chat.topic.edit.detial":`Editar detalles`,
"label.mr.descreption.reDataList1":`En la consulta para cumplir las condiciones de un total de`,
"label.document.value.too.long":`?El tama?o del fichero ha excedo a 5M!`,
"lable.opppdt.addpdt.table.listprice":`Lista de precios`,
"label.selectoperate":`Seleccione operación`,
"label.icon.5":`Moneda`,
"label.icon.126":`Cama De Hospital`,
"label.hiddensearch":`Ocultar búsqueda`,
"label.view.sortview.exportble":`Exportable`,
"vue_label_homepage_noassignee":`No hay asignatario`,
"label.knowledgebase.close.and.resolve":`Cerrado y resuelto`,
"label.licence.used":`Licencia utilizada`,
"label.newprocessstep5":`Paso 5 Selecciones campos para mostrar en el dise?o de la página de aprobación`,
"vue_label_appstore_all_applications":`Todas las aplicaciones`,
"label.no.edit.permission":`No se puede seleccionar. No hay permiso para editar los registros seleccionados.`,
"vue_label_calendar_calendar_added_successfully":`Calendario añadido con éxito`,
"report_line":`Campo de datos`,
"component.chatter.link.label.name":`Nombre del enlace`,
"label.data.expnode.e_desc1":`1. Exportación personalizada: Los usuarios pueden seleccionar los campos para exportar y configurar los criterios de filtro de acuerdo con su demanda`,
"label.tabularreport.step4":`Paso 4: Seleccione los criterios de informe`,
"Opportunity.Detailed.Phase.Change.Text.001":`Cambiar fase de la oportunidad de negocio`,
"label.quickbooks.searchresault.action":`Operación`,
"component_timeline_label_today":`Hoy`,
"label.callboard.remark":`Ingrese el anuncio de su empresa al siguiente`,
"label.campagin.field.choose":`Seleccione los campos para incluir en la página de registro de campa?a`,
"front-gantt-module-rolling-temporary-tasks":`Rodar a la tarea temporal`,
"label.file.des":`Descripción`,
"Dashboard_View_RecentlyView":`Visto Recientemente`,
"UG_Account_04":`Filtro de consulta pasiva de los usuarios`,
"chatter.refresh":`Refrescar`,
"label.tianyancha.companyorgtype":`Tipo de empresa`,
"label.chatter.dateRange":`Rango de fechas`,
"label.campagin.step3":`Paso 3: Generar las páginas`,
"label.appointmentdetail.wizard.title14":`Plan de lunes`,
"setup.object.field.dependency.button.setdependency":`Configuración de la dependencia del campo`,
"serviceterritorymember.serviceterritory.isactive.notactive":`Este territorio de servicio no está habilitado. Sólo se puede añadir miembros en un territorio de servicio habilitado.`,
"template.chart.ygydyj":`Rendimiento de la orden de ganancia de los empleados`,
"label.tag.edittags":`Editar etiquetas`,
"label.clone":`Copiar`,
"front-electronic-signature-setting-intro1":`Antes de vincular su cuenta, se recomienda que primero se registre y autentique en la plataforma DocuSign.`,
"label_reach":`Rendimiento`,
"label.tabpage.havez":`Hay`,
"label.email.clearCase":`Borrar solo los correos relacionados a los casos`,
"label.customer.tab.all":`Todos los menús`,
"label.direct.dashboard.day.report":`Nuevo reporte diario`,
"label_tabpage_exportview":`Exportar la vista`,
"label.passwordPolicy.setup.maxFailTimes":`Intentos máximos del inicio de sesión inválido`,
"label.processsetting.complete.enable":`Completar y activar`,
"label.marketsea.memberfield":`Los campos pueden ser disputados por los miembros`,
"label.report.export.format.title":`Informes formateados`,
"label.recycle.execute.title":`Limpiar la papelera de reciclaje`,
"label.file.use.most.user":`Usuario con más espacio de almacenamiento utilizado`,
"report_type_label_systemReport":`Informes del sistema`,
"label.customobjects.majorobject":`Objeto principal`,
"label.file.delete.public.link":`Eliminar enlace público`,
"front-epwechat-module-v1-id":`ID de WeCom`,
"label.partner.common.roleNum":`Cantidad de roles`,
"label.sendtonextapprover":`Enivar al aprobador siguiente`,
"label.notification.tip3":`Cargar 10 notificaciones más`,
"label.tabpage.placeenterz":`Introduzca`,
"label.mobile.phone.cc.people":`Cc`,
"component_setup_iframe_label_inputurlmemo":`Ingrese la URL para importar a la página`,
"label.umeng.activity.statuschange":`El status de tarea que le ha asignado a #name ha sido cambiado por  #newstatus`,
"label.step3.restricted.visibility":`Paso 3: Restringir la visibilidad`,
"label.multilang.datadelete.approvedata":`Los registros están en el proceso de aprobación ({0}):`,
"label.reportsSubscription.save":`Guardar`,
"label.emailobject.template.visibility":`Visibilidad`,
"label_partner_step3":`Paso 3: Información básica`,
"label.product.across":`Libro de precios cruzados`,
"label.same.analyze.opportunity.name":`Nombre de oportunidad`,
"label.chatter.memotel":`Registrar llamada`,
"label.recentview.seloption2":`Recién creado`,
"label.ccchat.message.search.desc1":`No podemos encontrar las noticias de`,
"label.reportexport":`Exportar`,
"label.service.gantt.drop.tip":`Permiso denegado: No tiene suficientes permisos para operar. Póngase en contacto con el administrador.`,
"label.australian.westem.standard.time":`Hora Estándar de Oeste (Australia)`,
"label.emailobject.email":`Correo`,
"Homepage_Contract_FieldMissed_DoesntSupport":`Falta el campo ¨qdrq¨ y ¨htje¨ en el objeto de contrato, por eso el dato no puede mostrarse.`,
"label.email.cancel.upload.info":`Va a cancelar el proceso de cargando`,
"label.page.copy.merged.field.value":`Copiar el valor del campo fusionado`,
"UG.ST.006":`Entrar directamente`,
"label.trigger.service.connot.access":`Oración Inaccesible`,
"label.projectManagement.new.tasks":`Nueva tarea`,
"lable.SalesCommitmentKanBan.receiptsRate":`Ratio de finalización de recibos`,
"label.productsales.oppor.overdue":`Oportunidades vencidas`,
"vue_label_pool_convertedbyme":`Convertido por mí`,
"label.loginip.pagecue.invalidt":`La dirección de internet inicial es mayor que la dirección del internet final o la dirección de internet es inválida`,
"label.campagin.roi.xyzj":`Respuesta total`,
"label.visualpage.list.title":`Acceso a páginas personalizadas activas`,
"chatter.feed.searchinitvalue":`Ingrese el nombre...`,
"label.export_submission":`Exportar datos enviados`,
"this.season":`Este trimestre`,
"label.forecast.settings.gx":`Dato compartido de previsiones`,
"label.tag.addtags.tagcolour":`Color de Etiqueta`,
"label.api":`Nombre de API`,
"label.bulk.delete":`Cancelación masiva (Completamente)`,
"label.reportsSubscriptionPage.condition.emailoption":`Opciones de correo electrónico`,
"vue_label_dashboard_newdashboardsuccessfully":`Nuevo cuadro de mandos creado con éxito`,
"three":`Tres`,
"label.prompt":`Indicación`,
"label.same.analyze.contact.phone":`Móvil`,
"label.icon.62":`Tubería`,
"label.forecast.shrepage.tableth.isnable":`Permitir envío`,
"label.multilang.polloption.vote":`{0} voto(s)`,
"label.customfields.totalsummary.selecttotaltype":`Seleccione el tipo de acumulación`,
"lable.SalesCommitmentKanBan.receivingCommitmentRate":`Tasa de compromiso de cobro`,
"label.areaAndSub":`?rea y ?rea subordinada`,
"vue_label_pool_recycle":`Reciclar`,
"lable.outlook.detail.synset":`Configuración de Sync`,
"label.quote.detail.introduce":`Ingrese palabra clave, haga clic en ¨Buscar¨ para comenzar la búsqueda, al terminar la búsqueda, clic en ¨Seleccionar¨ para saltar al paso siguiente.`,
"label.profile.customappset":`Configuración de aplicación personalizada`,
"label.changemylanguage":`Cambiar idioma`,
"message.approval.plzcapppor":`Seleccionar aprobador`,
"vue_label_pool_operatecertification2":`¿{0}{1}{2}{3}？`,
"label.publiccalendarandresource":`Calendario público y recursos`,
"label.wtd.changefields.title.desc1":`Seleccione los campos para incluir en su página, ingrese URL regresada, haga clic en ¨Generar¨ para generar la página`,
"label.weixin.voting.not.empty":`Opción de votación no puede estar vacía.`,
"label.campaign.channel.equal":`Igual a`,
"label.emailobject.emaildetail.button.back":`Regresar`,
"label.ccchat.person.invite.allowemails":`Para la seguridad, solo ingrese a los correos finalizados con los siguientes`,
"label.notEdit.message":`Lo sentimos, no tiene acceso para editar estos datos, por favor contacte con el administrador del sistema`,
"label.layout.selectedfields.relatedlist":`Campos seleccionados / Listas relativas`,
"label.weixin.voting.deadline":`Plazo de votación`,
"label.document.upload":`Archivos por subir`,
"label.import.page2.notmatchfiled":`Hay {csvfiledlength} campos en el archivo en total. Quedan {difflength} campos sin asignar`,
"label.data.exp.selzippwd":`Si no rellene, por defecto no hay contrase?a compresionada`,
"label.user.step2.select.email.template":`Paso 2. Seleccione la plantilla de correo`,
"label.currency.effective":`Monedas activas`,
"label.version.control.type":`Clasificación de versión`,
"label.projectManagement.Taskorproblem":`Tarea/Asunto`,
"label.everyweek":`Semanal`,
"label.passwordPolicy.setup.pwdremember4":`Recuerda cuatro contrase?as`,
"label.emailobject.groupemail":`Correo masivo`,
"label.approvepagelayout1":`Todos tienen la misma disposición`,
"label.integrations.mailchimp.massage5":`Al importar los candidatos y contactos del sistema a MailChimp, puede enviar el correo a los destinatarios determinados.`,
"label.icon.22":`Añadir`,
"Dashboard_View_All":`Todos los paneles`,
"label.import.page2.example":`Ejemplo`,
"label.send.letter":`Enviar carta de invitación`,
"label.mobilesectionpart":`Parte Móvil`,
"component_setup_tabs_label_title":`Página de Tab`,
"label.knowledgebase.results":`{a} resultados`,
"label.field.remark":`Esta página se aplica a`,
"vue_label_systemSettings_url":`Configuración del nombre de dominio`,
"vue_label_SMS_failed_find_view_list":`No se ha podido encontrar la lista de vistas`,
"setup_layout_label_order":`Ordenado por`,
"label.customsetting.touse":`Utilizar configuración personalizada`,
"label.product.enter":`Ingrese palabras clave para encontrar los productos a juego`,
"label.email.template.private.SMS":`Carpeta exclusiva de plantillas de SMS`,
"vue_label_homepage_chart_deleted":`Vista o cuadro de mandos eliminado`,
"label.conversion_pages":`Página de conversión`,
"label.compact.layout.select":`Seleccione campo de dise?o de información clave`,
"report_label_folderandreport":`Informes y Carpetas`,
"label.product.entry":`Lista de precios de los libros`,
"label.campaignmember.main.manageMember":`Gestionar miembros`,
"front-QBtoCC-changing":`Actualizando...`,
"vue_label_pool_abandonreason":`Motivo del descarte`,
"template.report.customer.contract.statistics":`Análisis contractual de las cuentas`,
"label.invoice.message.sendsuccessully":`Envío de Invoice exitoso`,
"label.addcurrentoperate":`Añadir operación existente`,
"label.customerinfo.mailpwd":`Contrase?a del Correo`,
"batch.nochange.owner":`?No tiene permiso para cambiar el propietario del registro!`,
"label_tabpage_uploadfailez":`Error de carga, por favor intente de nuevo`,
"vue_label_systemSettings_mobelqrsetting":`Configuración del escáner de la aplicación móvil`,
"label.regular_field":`Dominio de la forma`,
"label.tabpage.delsuccessz":`Borrado con éxito`,
"label.Days.Before.Horizontal.Date":`Días antes de la fecha horizontal`,
"label.evaluation.general":`Vale`,
"chatter.notlike.p":`Dejar de gustar esta publicación`,
"label.chatter.send":`Enviar`,
"label.emailsync.button.cancel":`Cancelar`,
"label.notification.task4":`Su tarea está caducada hoy`,
"vue_label_helpcenter_detail1.2":`Cambiar rápidamente el estado de la tarea: Marque la casilla de verificación frente a la tarea en el módulo "atrasado y próximo", y haga clic en el botón de actualización para cambiar rápidamente el estado de la tarea a "finalizado".<br> Antes de actualizar, cancele la marca y el estado de la tarea no cambiará.<br> Las tareas con alta prioridad se marcarán con un icono de "bandera roja" en la línea de tiempo de la actividad.<br>La secuencia de visualización de la línea de tiempo de la actividad<br> Ordenar en orden inverso según la fecha de vencimiento de la tarea, la fecha de vencimiento de la llamada registrada, la fecha de inicio del evento, la fecha de envío y recepción de correos electrónicos y la fecha de envío y recepción de SMS. Si las fechas anteriores son iguales, se ordenarán en el orden inverso al de la hora de creación del registro.<br>Filtro de la línea de tiempo de la actividad<br> Utilice los filtros de la línea de tiempo del evento para reducir el alcance de los elementos visibles, centrarse en los elementos importantes y encontrar los elementos objetivo. El filtro de la línea de tiempo incluye tres tipos de filtros: rango de fechas, actividad a mostrar y tipo de actividad.<br> Actividades a mostrar: todas las actividades, mis actividades<br> En el filtro de la línea de tiempo del evento, esta opción puede restringir el rango de visualización del evento.<br> Mis actividades: Muestra las actividades en las que has participado, ya sea como propietario o como participante. Por ejemplo, eres el propietario de los correos electrónicos y eventos. Por ejemplo, cuando eres el destinatario del campo Cc o Cco del correo electrónico, significa que estás participando en el evento.<br>`,
"component_chatter_post_label_title":`Publicar`,
"label.data.dataexptemplate.desc":`La plantilla de la exportación de datos creada por los usuarios es utilizada para exportar datos, que se puede hacer la exportación de datos más conveniente.`,
"label.helptext":`Textos de ayuda`,
"vue_label_norm_removecomponent_certify":`Confirmar borrar componente`,
"front-template-V1-Click-new-template":`Haga clic en "Nuevo" para crear una nueva plantilla. Active y comience a utilizar esta plantilla`,
"label.optional_fields":`Campos opcionales`,
"label.delete_about":`Vas a borrar`,
"chatter.feed.initvalue":`?Qué está procesando?`,
"label.mail.configure":`Configure el correo personal con el cual contacte con los clientes, puede enviar y recibir correo utilizando la página oficial de correo de CloudCC, y sincronice historial de correo con los candidatos y contactos.`,
"label.project.hit.seven":`Recordatorio de vencimiento de tareas`,
"label.button.upgrade":`Comprar y cambiar versión`,
"lable.PowerProcess.event.name":`Nombre del evento clave`,
"label.weixin.confirm":`Confirmar`,
"label.customfields.new.inputformula":`Ingresar fórmula`,
"label.standard.buttonandlink.edit":`Anular botón estándar o enlace`,
"workflow.action.tasks.assignortype.createdtype":`Tipo de creador`,
"front-email-payment-paypal-describe":`Haga clic en "Continuar", puede acceder al sitio web de PayPal o crear una cuenta de PayPal para completar el pago de la factura.`,
"label.selectexistingoperate":`Seleccione las operaciones existentes`,
"label.workflow":`Flujo de trabajo`,
"label.assignment.setup.detail.ruleentries":`Regla de ítems`,
"label.data.file.i.title.num3":`3. El sistema cargará previamente el archivo de datos al servidor, después iniciará el importador masivo de back-end, cuyos resultados serán notificados a los usuarios por correo y no tendrá que esperar en esta página.`,
"label.use.view":`Utilizar vista actual`,
"label.forecast.settings.moren":`Serie de producto predeterminado`,
"vue_label_calendar_add_share":`Añadir compartir`,
"label_tabpage_newview":`Crear una nueva vista`,
"label.recycle":`Papelera de reciclaje`,
"UG_solution_03":`Crear una solución`,
"label.customfields.formula.text.tip":`Cree una cadena de textos, por ejemplo, a través de vincularse con otros campos de texto`,
"vue_label_file_single_file_size":`Tamaño máximo por archivo`,
"label.a.b.least":`Cada registro "A" debe tener al menos un registro "B" relacionado.`,
"label.validate.function.addtoformula":`Insertar la función seleccionada`,
"label_tabpage_pleaseSelectz":`Por favor seleccione`,
"label.account.NextFQ":`Próximo trimestre fiscal`,
"label.project.project.name":`No puede haber dos nombres de proyectos iguales`,
"label.emailtocloudcc.filed.owner":`Propietario del registro`,
"label.textmessage.template.message2":`El campo insertado en el correo electrónico actual no coincide con el registro asociado, lo que puede provocar valores nulos.`,
"label.icon.92":`Libro`,
"label.trailerpage":`Última página`,
"component_event_label_noevent":`Parece que ha terminado el trabajo de hoy.`,
"label.trigger.tip":`Sobre Triggers`,
"label.knowledge.case.field.usable":`Campos disponibles del caso`,
"label.group.isusing.success":`Tener éxito en activar`,
"label.marketsea.nextnotfollowdays":`Desde el último seguimiento`,
"component.todaytask.label.choicestate":`Seleccionar estado`,
"label.recordtype.main":`--Maestro--`,
"label.sendletter.step1":`Paso 1: Especifique destinatarios de invitación`,
"label_tabpage_saveviewfailed":`Se frascasó en guardar la vista`,
"vue_label_report_notiec_selectone":`Cada registro de objeto superior debe tener al menos un registro relacionado al objeto actual`,
"UG_opportunity_003":`Seguir sus canales de ventas, crear tablero`,
"#label.importsourcestep4":`Paso 4: Importar su ficheros#`,
"front-kefu-moudle-v1-trrt-tip":`Es necesario asociar usuarios (agentes de atención al cliente) con las extensiones de TRRT para obtener la función de "Click to Dial".`,
"UG.Forcast.09":`Siguiente`,
"label.ggReleaseRange.subordinates":`Función de búsqueda y subordinación`,
"label.log.desctiption":`Puede descargar el seguimiento de auditoría que contiene más informaciones.(Archivo Excel.csv).`,
"label.submitted":`Enviado`,
"label.validate.function.funcExplain.BEGINS":`Revise si los textos comienzan con los caracteres específicos, si es así, regresaráTRUE, si no, regresará FALSE`,
"label.campaign.channel.code":`Código escaneado de Marketing`,
"chatter.group.theLastActivityDate":`Fecha de la última actividad`,
"vue_label_dashboard_pleaseenterabreakpoint2value":`Introduzca un valor de punto de ruptura 2`,
"label.labeltranslation":`Traducción de etiqueta`,
"label.multilang.product.deleterederect":`La cancelación de {0} no se puede terminar porque está asociado con registros en otro catálogo de precios. El vinculación es el siguiente`,
"lable.currencyManage.manageRate.dis":`Para gestionar las tasas de cambio de otros objetos, añadir nueva moneda, activar o prohibir moneda, o cambiar moneda de empresa, haga clic en ¨Gestionar Monedas¨`,
"setup.layout.label.modifypage":`Editar página`,
"label.import.page2.editforname":`Edite la asignación del campo {necessaryName} .`,
"label.searchlayout":`Buscar dise?o`,
"label.chatter.loadmore":`Cargar más`,
"label.trigger.folder.all":`Carpetas de todos los triggers`,
"label.export_submissions":`Exportación de formularios`,
"lable.SalesCommitmentKanBan.allsignedTaskRate":`Tasa de finalización de todas las tareas firmadas`,
"KeyInformationLayout_DefaultLayout_Name":`Sistema predeterminado`,
"label.h5.chatter.great":`Me gusta`,
"label.call.center.configuration.enable":`Utilice las configuraciones siguientes para modificar si activa la función Center Call de su organización`,
"label.overdate":`Fecha de finalización`,
"chatter.poll":`Votar`,
"label.login.input.verification.code":`Ingrese el código de seguridad:`,
"label.file.sharetype.cooperation":`Colaborador`,
"label.app.step5":`Paso 5: Asignar perfiles`,
"front-gantt-module-save-order":`Guardar el pedido`,
"label.globalselect.toallrecord":`Añadir el valor de la nueva lista de opciones a todos los tipos de registro que utilizan este conjunto de valor`,
"setup.mainpage.label.welcome24":`La plataforma en la nube CloudCC proporciona ajustes de acceso de seguridad para todos los datos de los objetos en el sistema. El intercambio de datos y los derechos de acceso pueden controlarse estableciendo diversas reglas y condiciones.`,
"homepage.layout.desctiption":`Esta página le permite crear o editar los componentes mostrados en el dise?o de la página oficial.`,
"vue_label_SMS_notice_send_sussess":`SMS enviado`,
"label.projectManagement.overdue":`Atrasado`,
"label.assignment.setup.list.lead.description":`Asigna automáticamente los candidatos a los usuarios según las reglas de asignación de candidatos que define. Puede crear múltiples reglas con condiciones diferentes.`,
"label.list.projectSetting.des":`¿Desea enviar el correo bajo la configuración de abajo?:`,
"setup.mainpage.label.welcome18":`La configuración de permisos a nivel empresarial de CloudCC le permite controlar los permisos de uso de los usuarios individuales mientras trabajan con datos y módulos. La configuración de permisos basada en roles también incluye cargos del usuario, grupos, roles, reglas de compartir datos y controles de seguridad a nivel de campo, permite compartir datos entre diferentes personas y departamentos de la empresa.`,
"label.ratio":`En términos interanuales y mensuales`,
"label.Xaxis":`Eje X`,
"label.google.map":`Mapa de Google`,
"Dashboard.SelectBoardToDisplay":`Seleccione el cuadro de mando que abre la pestaña del cuadro de mando`,
"label.data.newtemplate.e_conditions":`Criterios de exportación`,
"label.emailtocloudcc.description3":`Añada aquí su correo electrónico empresarial, como sales@company.com, info@company.com, support@company.com, el sistema generará automáticamente los clientes potenciales o registros de casos según los correos recibidos para garantizar el seguimiento oportuno de los correos de los clientes.`,
"label.page.select.profile":`Seleccione los perfiles del usuario que se van a utilizar las nuevas pesta?as personalizadas. También puede examinar o modificar pesta?as desde Informaciones detalladas y Editar de cada perfil.`,
"label.chosen.button":`Botones seleccionados`,
"front-epwechat-module-v1-info":`Información sobre el backend de WeCom`,
"label.translation.select":`Criterios de filtro`,
"ten":`Diez`,
"label.barcode":`Código de barras`,
"lable.product.nextdel":`Continuar o cancelar los registros mostrados, o haga clic en `,
"label.default":`Predeterminado`,
"label.chatter.theme":`Tema`,
"vue_label_commonobjects_view_split_screen_view":`Vista de pantalla múltiple`,
"label.ems.myemails":`Mis correos`,
"label.email.clearPersonalEmail":`¿Desea borrar todos los correos electrónicos sincronizados del correo personal?`,
"label.login.access.admin":`Administrador de su empresa`,
"label.emailobject.wizard.desc":`Después de conectar su cuenta de correo electrónico en CloudCC, puede enviar correos electrónicos directamente desde CloudCC mientras los vincula automáticamente a los clientes potenciales, contactos y oportunidades relacionados. El historial de comunicaciones está claramente ordenado por línea de tiempo.`,
"label.passwordPolicy.setup.minpwdlength":`Longitud mínima de la contrase?a`,
"choserow":`Seleccione las columnas para mostrarse`,
"front-epwechat-module-v1-role-binding":`Vinculación de funciones`,
"lable.outlook.edit.newdata":`Fecha de creación más temprana`,
"label.schedulejob.setup.schedule.enddate":`Fecha de finalización`,
"label.quickbooks.view":`Vista`,
"font-evaluate-module-v1-not-inform":`No hay notificación`,
"chatter.poll.option3":`Opción 3`,
"setup_layout_label_selectfield":`Seleccione los campos`,
"label.partner.common.roleSetup":`Roles de la nube de socios y cofiguración de usuarios`,
"label_partner_new_step3":`Paso3: Ingrese nombre y URL`,
"label.transfer":`Transferir`,
"label.bmap.myaddress":`Mi localidad`,
"label_tabpage_individual":`Opción individual`,
"label.autoRegister.changepwd.setpwd.repassword":`Ingrese de nuevo la contrase?a`,
"vue_label_commonobjects_detail_and_before":`Fechas más antiguas`,
"front-kefu-moudle-v1-single-Login-area":`Nombre de dominio de inicio de sesión único`,
"label.replacedocument":`Reemplazar los documentos`,
"label.validate.function.category.Logical":`Lógica`,
"label.companyprofile.syncsuccess":`Sync exitosa`,
"template.chart.rwzthyxj":`Tema y prioridad de la tarea`,
"label.product.clearcondition":`Vaciar las condiciones`,
"component_task_label_person":`* Asignado`,
"label.tabpage.as":`Como`,
"message.error.calendar.add":`El calendario ya ha sido añadido`,
"label.marketsea.isrecycleleadcreatebyself":`¿Quiere reciclar los clientes potenciales creados por usted mismo?`,
"label.icon.57":`Barómetro`,
"UG.Lead.010":`o`,
"setup_object_field_dependency_label_configured":`Configurado`,
"label.tianyancha.regnumber":`Código de registro`,
"front-kefu-moudle-v1-Opened-chats":`Activar el chat`,
"label_tabpage_converstatez":`Status convertido`,
"label.bmap.beijing.haidianqu":`No.10 Calle Shangdi, Distrito de Haidian, Beijing`,
"label.startimport":`Iniciar la importación`,
"label.knowledgebase.application.default.settings":`Configuración por defecto de la aplicación Lightning`,
"lable.account.year.custom":`A?os fiscales personalizados`,
"label.event.nextmonth":`Próximo mes`,
"label.email.body":`Cuerpo`,
"setup.object.field.dependency.label.mustsetup":`Configure la dependencia del campo antes de guardar`,
"label_tabpage_multiple":`Múltiples opciones`,
"label.task.this.month":`Tarea de este mes`,
"label.customfields.formula.moneyexample":`Margen Bruto = Amount - Cost__c`,
"label.tonewemailnotice":`Seleccione objeto para esta tarea y haga clic en el ¨Siguiente¨. Las tareas solo se pueden asociar con las reglas del flujo de trabajo y proceso de aprobación del mismo tipo.`,
"setup.mainpage.label.welcome11":`Informe personalizado`,
"label.layout.availabletab":`Menú disponible`,
"label.data.importef":`Importar los ficheros fallados`,
"label.appupload.upload.alert":`Proporcione detalles sobre este paquete antes de subir. Estas configuraciones determinan los requisitos que deben alcanzar para instalar este paquete.`,
"label.sales.accountteam.shared":`Compartir el equipo de cuentas`,
"lable.currency.addexchageRate":`Añadir tasa de cambio`,
"label.page.simplified.chinese":`Chino(Simplificado)`,
"label.service.dispatchingUnits.search.service.area":`Buscar territorio de servicio`,
"lable.list.queue.name":`Nombre de cola`,
"pagecreator.button.save":`Guardar`,
"label.ccpeak.support.function":`Se permite todas las funciones en un formulario singular`,
"label.tianyancha.legalpersonid":`ID de la persona jurídica`,
"label.sendemail.chat.addPostmainPage":`Estimado #name:\n\n Hola! #userName ha publicado en su página de CCChat.`,
"batch.no.change":`No hay permiso para transferir datos`,
"label.the.referenced":`Referido en`,
"label.input.webtab.information":`Rellene información sobre el menú del Web.`,
"vue_label_systemSettings_subscription":`Tipo de suscripción`,
"label.login.access.title":`Autorizar el acceso para los clientes`,
"label.schedulejob.setup.schedule.lastday":`El último día`,
"label.synchronize.department":`Sincronizar usuarios`,
"label_tabpage_lessequalz":`Menos o igual a`,
"label.file.library.successmanagemember":`Guardado con éxito`,
"label.service.major.event.oreder":`Secuencia`,
"label.desktopintegration":`Integración de Escritorio`,
"label.a_b":`Relación de A a B`,
"every":`Cada`,
"label.tabpage.bar":`elementos`,
"label.filecontentsnotnull":`Los contenidos del fichero no puede estar vacíos`,
"label.layout.detailoftestobj":`Detalles del objeto de prueba`,
"label.summaryreport.2018.step3":`Paso: seleccione columna de informe`,
"UG.Lead.002":`Hay muchas formas de identificar "clientes potenciales" para su producto o servicio.`,
"label_partner_workspace_member_selectedprofile":`Perfil seleccionado`,
"label.newdescription":`Nota nueva`,
"vue_label_normal_moveup":`Subir`,
"label.mobile.quickcreate.default.logacall":`Historial de llamadas`,
"userterritory.serviceterritory.user.unique":`Este usuario ya tiene asignado este territorio de servicio, no lo vuelva a asignar`,
"label.weixin.record":`Registro`,
"front-kefu-moudle-connecting":`Conectando`,
"label.monitorsys.recent.operation.log":`Log de operación reciente`,
"lable.outlook.detail.lmaping":`Mapeo del campo de candidatos`,
"lable.account.year.ovdate":`Fecha cerrada del a?o fiscal`,
"vue.homepage.auditcard.record":`{recordTotal} registros`,
"label.processsetting.delete.process.succeeded":`Proceso eliminado con éxito`,
"label.customerinfo.smsPwd":`Contrase?a de Gateway SMS`,
"label.tolead.object":`Importar objetos`,
"label.data.downpage.i.list.desc2":`Después de importar los datos, recibirá un correo electrónico notificándole si la importación se ha realizado con éxito.`,
"label.sharerule.ruletype":`Tipo de regla`,
"label.reportsSubscriptionPage.email.toothers":`Enviarme a mí y a otros usuarios`,
"label.emailobject.templates":`Plantillas`,
"vue_label_checkduplicate_":`Análisis de duplicados`,
"label.campaign.channel.lookup.example":`Ver ejemplo`,
"label.login.verification.please.note":`Notas:`,
"label.version.charge":`Cobrar`,
"label.ccdocument.show.trace":`Mostrar seguimiento`,
"label.sendemail.approval.submit":`Hola, #name:\n #actorname el #objLabel-#recordname entregado por #actordate está esperando su aprobación, haga clic en el enlace siguiente o ingresar al sistema CRM para entrar al centro de aprobación:\n #path#appPath/query.action?id=#recordid&m=query\n#orgName`,
"setup.mainpage.label.welcome12":`El usuario puede completar la definición del informe haciendo clic con el ratón, sin programar, y siguiendo las instrucciones del sistema. El sistema dispone de informe de lista, informe de resumen e informe de matriz para elegir. También están disponibles las opciones de visualización de todos los campos y eliminar la información innecesaria de los campos. Al mismo tiempo, proporciona una gran variedad de visualizaciones gráficas, como de barras, líneas, anillos, embudos y circular, para mostrar los datos a los usuarios de una manera más clara y concisa.`,
"UG_contact_06":`Importar contactos`,
"message.success.event.add":`Información del nuevo evento guardada con éxito`,
"report.line":`Campo de datos`,
"label.approvepagelayout2":`Cada uno tiene una disposición diferente`,
"vue_label_normal_contract_sf":`Contrato`,
"label.tabpage.tpcustomersz":`Convertir clientes potenciales`,
"label.ccchat.message.new.error5":`Error, su mensaje no puede exceder 10,000 caracteres.`,
"label.severalorone":`Fichero individual`,
"pagecreator_systemstyle_label_buttonfontcolor":`Texto del botón`,
"label.customer.tab.step3.introduce":`Seleccione las aplicaciones personalizadas que van a utilizar el menú personalizado. También puede revisar o modificar la visibilidad de los menús en la página de detalles o de edición de cada aplicación personalizada`,
"chatter.group.groupEdit":`Editar grupos`,
"label.partnerCloud.partnerAccount.spending":`Gastos de reembolso`,
"label.slip":`ítems)`,
"label.field.master.class":`El nivel de relación Maestro-Detalle excede al nivel 3`,
"label.sendemail.chat.addComentsmyFeed":`Estimado #name:\n\n ?Hola! #userName responde a su micro-publicación.`,
"label.service.ganttBaiduMap.selectingDispatchTime":`Seleccione el intervalo de asignación`,
"label.knowledgebase.remove.article":`¿Está seguro de que debe eliminar los archivos del artículo?`,
"label.appupload.notmanaged":`Fuera de control`,
"label.report.goto.step":`Volver al paso`,
"label.publicgroup.save.mustbeselect":`Debe seleccionar los miembros`,
"label.data.expnode.e.desc2":`2. Exportación por plantilla: los usuarios pueden seleccionar la plantilla que quieren usar para exportar los datos.`,
"UG.product.02":`Productos y servicios comprados y vendidos consultados.`,
"label.sendemailtouser":`?Está seguro de que quiere enviar correo a los usuarios seleccionados?`,
"label.knowledge.setting.hint.nine":`Si no lo sabe, ¿en qué le beneficiará el Conocimiento? Clasifique los artículos similares como la única categoría de datos y acumule a una categoría más amplia. Ahora, vamos a añadir una categoría de datos. Puede añadir más categorías más tarde.`,
"front-asset-module-v1-view-asset-bom":`Ver la lista de materiales de los activos`,
"label_partner_all_enable":`Activar`,
"label.processsetting.disable.process.successfully":`Proceso desactivado con éxito`,
"label.call.center.enable":`Activar Call Center`,
"message.recordtype.applyitseparatly":`Aplicar dise?os diferentes para cada perfil`,
"label.weixin.report.customize":`Personalizar`,
"label.file.mongdb.file.is.not.exist":`El archivo no existe`,
"label.chat.edit.topics":`Editar tema`,
"label.knowledge.delete.searchterm":`Error al eliminar el término de búsqueda`,
"label_emailtocloudcc_redmessage3":`Ingrese la dirección del servidor`,
"use":`Utilizar`,
"label.batchtransfer.transferfrom":`Transferir de`,
"label.recycle.my":`Mi papelera de reciclaje`,
"label_json_string_null":`Vacío`,
"label.version.lookupfield":`Buscar campos`,
"lable.tianyancha.h5.searchf":`No encontrado`,
"label.validate.globalvariable.description":`$User.[Campo API] eg: $User.id <br>Los valores que se pueden utilizar son : id,name,roleId,roleName,profileId,profileName,department,title,email`,
"UG.opportunity.006":`Genio de oportunidad de negocio`,
"label.applt.copy":`Clonación con un solo toque`,
"chatter.emailMessageOrReply":`Publicar o comentar`,
"label.newreport.self":`Campos seleccionados`,
"label.visualpage.checkpinxie":`Revise ortografía de esta página`,
"label.knowledgebase.article.attaching.case":`¡El artículo {nombre} se ha adjuntado al caso!`,
"label.dialogbox":`Casilla de diálogo`,
"label.summaryreport.step3.new":`Paso 3: Seleccione los datos para resumir`,
"label.confirm":`Confirmar`,
"label.mobile.buttom.team":`Plan de equipo`,
"label.quickbooks.action.link":`Asociar`,
"vue_label_commonobjects_view_support_to_datas":`La operación admite hasta 10 datos`,
"vue_label_helpcenter_homepage":`Cada usuario tiene dos páginas de inicio por defecto, una página de inicio estándar y una página de inicio personal. El administrador puede asignar una página de inicio de perfil correspondiente al usuario según su perfil. Tenga en cuenta que la página de inicio de la versión Lightning y la página de inicio de la versión antigua no son interoperables.<br> 1. Página de inicio estándar <br> El contenido de la página de inicio estándar es igual para todos y no editable. Incluye el componente de KPI trimestral, el componente de visto recientemente, el componente del centro de aprobación, el componente del evento de hoy, el componente de la tarea, el componente de la oportunidad de negocio atrasada, el componente de la oportunidad de negocio no contactada en los últimos 30 días y el componente de la próxima oportunidad de negocio<br> Componente de KPI trimestral: todos pueden establecer sus propios objetivos trimestrales<br> Componente de visto recientemente: Muestra los 10 registros de objetos vistos recientemente<br> Componente de oportunidad de negocio no contactada en los últimos 30 días: Muestra 5 oportunidades de negocio que llevan más de 30 días sin contactar y de probabilidad diferente del 0 y 100<br> 2. Página de inicio personal<br> Todos los usuarios tienen una página de inicio personal, y el contenido de la página de inicio personal se puede personalizar añadiendo o eliminando componentes, también puede arrastrar y soltar para ajustar la posición y el tamaño de estos<br> Habrá un componente de información, un componente de centro de aprobación, un componente de oportunidad de negocio atrasada y un componente de próxima oportunidad de negocio por defecto <br> La página de inicio personal permite hasta 15 componentes<br> 3. Página de inicio del perfil<br> Los administradores pueden crear/editar/eliminar las páginas de inicio del perfil personalizando la página de inicio, y pueden asignar diferentes páginas de inicio a diferentes perfiles, para que los usuarios con diferentes perfiles puedan ver diferentes páginas de inicio<br> Se puede añadir hasta 15 componentes por página de inicio del perfil<br> 4. Añadir componentes<br> La página de inicio personal permite hasta 15 componentes. Añadir componentes<br> La página de inicio personal y la página de inicio del perfil se pueden personalizar para añadir componentes, se pueden añadir el componente del cuadro de mandos, componente del gráfico del cuadro de mandos y componente de la vista de tarjetas<br> Componente del cuadro de mandos: añade todo el cuadro de mandos del sistema a la página de inicio. El número de subcomponentes del tablero representa cuántos componentes ocupa el componente del tablero (la página de inicio admite hasta 15 componentes), y los datos del componente del cuadro de mandos añadido no se asociarán con el cuadro de mandos original (es decir, si se elimina el cuadro de mandos original, el componente del cuadro de mando añadido puede seguir funcionando) <br> Componente de gráfico del cuadro de mando: Puede añadir un componente de gráfico específico del cuadro de mandos a la página de inicio, y la función de enlace del componente se deshabilitará en este momento<br> Componente de vista de tarjeta: Puede elegir añadir una determinada vista de un objeto como fuente de datos a la página de inicio. Los campos y elementos de operación se pueden personalizar. Pero tenga en cuenta que si la vista de la fuente de datos de la vista de tarjeta se elimina, no habrá datos en la vista de la tarjeta.`,
"label.usersandlimit":`Usuarios y permisos`,
"label.sendmail.step3.introduce2":`Destinatario(s) seleccionados para recibir este correo.`,
"label.setupcustomfield":`Campos personalizados`,
"label.layout.last.notdel":`El último del dise?o no se permite cancelar`,
"label.emailtocloudcc.redmessage7":`Error de configuración, póngase en contacto con el administrador`,
"label.includedIn":`Contenido en {parentproductname}`,
"label.permission.detail.app.pagesetting":`Configuración de página personalizada`,
"label.addfile.tips":`Se han seleccionado {selectedNum} archivos. Se pueden añadir hasta {originNum} archivos de una vez`,
"label.fieldinformation":`Detalles del campo`,
"label.campagin.roi.sjcb":`Costo actual`,
"label.email.all.works.company":`Todos los colegas de la empresa`,
"label.currencyDesc":`Utilizar esta página para definir todas las monedas utilizadas por su organización. Debe configurar la misma moneda empresarial que la utlizada al reportar los ingresos a la sede oficial. Si define otras monedas como moneda empresarial, debe modificar todas las tasas de conversión para reflectar este cambio.`,
"label.file.details":`Detalles`,
"label.foldervisitlimit3":`Sólo los usuarios siguientes pueden acceder a esta carpeta:`,
"label.account.next.M":`Próximo mes`,
"label.oweralias":`Alias del propietario`,
"label.projectManagement.entryname":`Nombre del proyecto`,
"label.customcomponent.page.add.title1":`Información de componente`,
"label.projectManagement.PleaseenterCreator":`Introduzca el creador`,
"label.multipleactivity.memberselected":`Miembros seleccionados`,
"label_chatter_memotel":`Registrar llamada`,
"lable.Confirm.customers":`Confirmar recuperar {num} clientes`,
"front-email-payment-Invoice-number":`Número de factura`,
"label.not.appoint.validation":`No objetos ha sido especificado para la regla de validación, determine `,
"label.peru.time":`Hora de Perú`,
"label.setting.intergrationlist.status3":`QuickBooks login requerido`,
"vue_label_display_number_field":`Mostrar campos numéricos`,
"label_productline_count":`Cantidad de series de productos`,
"label.data.downpage.i_title.num2":`2. Antes de empezar la importación, asegúrese de que el nombre del campo del fichero que quiere importar coincidan con el nombre del objeto en CloudCC.`,
"label.field.duplicate4":`Tratar ¨ABC¨ y ¨abc¨ como valores diferentes (Distinguir entre Mayúsculas y Minúsculas)`,
"message.approval.step.validation.invalid.levels":`Por lo menos Nivel. 1`,
"label.tianyancha.businessverify.step1":`Paso 1 para activar la verificación comercial`,
"label.hidedetail":`Ocultar detalles`,
"UG_Lead_009":`Historial de llamadas APP`,
"label.partnerCloud.newProductSeries":`Nueva familia de productos`,
"label.brief.opportunities":`Total`,
"label.user.mfa.unbind.remind":`Desbloqueará MFA a los usuarios seleccionados y necesite revincular MFA en el login siguiente, ?Está seguro de continuar?`,
"vue_label_report_grouprow":`Fila de grupo`,
"setup.layout.label.newarea":`Nueva área`,
"label.nostart":`Por comenzar`,
"UG_Lead_010":`O`,
"label.emailmerge.mergepage.record.requeired":`?Seleccione los registros para fusionarse!`,
"label.appointmentpage.wizard.notif1btn1":`Confirmar`,
"UG.Account.02":`Algunas empresas prestan servicios a otras empresas, otras colaboran directamente con los usuarios finales y otras prestan servicios a las ONG.`,
"label.address.country":`País o regiones`,
"label.userinfo.updatepwd":`Cambiar contrase?a`,
"label.salescloud.teamrole.optionlist.opportunity":`A?adir los miembros de oportunidad a`,
"lable.account.Current.FY":`A?o fiscal actual`,
"chatter.coll.p":`Añadir esta publicación a marcadores`,
"label.setupsms":`SMS`,
"label.atlantic.daylight.time":`Hora de Verano Atlántico`,
"label.recordslock":`Registro cerrado`,
"button_partner_search":`Buscar`,
"vue_label_salesfunnel_notice4":`Importe total de oportunidades de negocios con probabilidad del 1% - 99%`,
"vue_label_report_statistics":`Estadísticas`,
"label.ccchat.notmember.active.group0":`No es miembro de cualquier grupo de actividad con {0} en su nombre`,
"label.tag.manage.newtag":`Etiqueta Nueva`,
"label.customfileds.formula.dateandtime.tip":`Calcular un fecha/hora, por ejemplo, a través de añadir un número de horas o días en otra fecha/hora`,
"label.weixin.mobile.fly.ios":`Compartir de móvil (ISO)`,
"vue_label_file_over_file_size":`¡El tamaño de archivo de file.name   ' excede del límite preestablecido por el sistema!`,
"label.schedulejob.setup.schedule.last":`Al final`,
"label.ccchat.whose.name.contains":`De cualquier grupo activo cuyo nombre contiene`,
"label.project.milestone.name":`No se puede tener dos hitos con el mismo nombre en un proyecto`,
"message.passwordPolicy.validate.reuse":`Error: no puede repetir el uso de contrase?a`,
"label.stdashbord.xsld.business.img3":`El monto de probabilidad de 1%-99% * Probabilidad`,
"label.event.view.list":`Lista de vista`,
"label.workflow.ruletriggertime":`Tiempo de Activación de Regla`,
"label.campaign.channel":`Canal de marketing`,
"label.appexchange.emailnotice":`Aviso de correo del flujo de trabajo`,
"label.icon.77":`Agricultura`,
"label.visualpage.display.value":`Ingrese los valores que se mostrarán y tenga en cuenta que no aparezca espacio antes o después.`,
"label.forecast.customforecast.type.user":`Por usuario`,
"label_tabpage_lessz":`Menor que`,
"label.same.analyze.contact.email":`Correo`,
"vue_label_report_range":`Rango`,
"lable.product.pricebooks.nr":`Puede copiar los contenidos de la lista de precios existente seleccionando la lista de opciones siguiente`,
"label_mobile_buttom_team_setUp":`Configuración del plan de equipo`,
"label.email.bcc.recipients":`Cco`,
"vue_label_ccchat_notice_deletepostfail":`No se ha podido borrar el post`,
"label_file_type":`Tipo de fichero`,
"label.multilang.feedtrack.operateupdate":`Un registro{0} ha sido modificado`,
"label.contractmanager":`Gerente de contrato`,
"front-gantt-module-drag-one-task-sorting":`Las tareas sólo pueden clasificarse dentro del mismo hito.`,
"label.partner.step2":`Paso 2: Confirmar Plantilla`,
"front-epwechat-module-v1-again-binding":`Rebobinar`,
"label.service.miniProgram.imageSize":`No se puede cargar imágenes de más de 2MB`,
"setup_main2018_label_managesetup":`Configuración de administración`,
"component_salesperformance_label_nopermission":`Para ver los datos relacionados con las oportunidades, contacte con el administrador.`,
"lable.account.stadate":`Fecha de comienzo del trimestre fiscal`,
"label.service.gantt.and.resourcestype":`y el tipo de recurso es`,
"label.ems.attachfiles":`Añadir adjuntos`,
"label.data.expnode.e.desc1":`1. Exportación personalizada: los usuarios pueden seleccionar los campos a exportar y establecer las condiciones de filtrado según sus necesidades.`,
"vue_label_systemSettings_analyse":`Analizar`,
"label.project.all.date":`La fecha de finalización debe ser posterior o igual a la fecha de inicio.`,
"vue_label_commonobjects_view_summary_basis":`Criterio de resumen`,
"template.chart.yywjhdschd":`Campañas con oportunidades`,
"vue_label_pool_notmeet":`No se cumplen los requisitos del cliente`,
"label.attendance.manager":`Gestión de asistencia`,
"vue_labenl_normal_current":`Actual`,
"label.projectManagement.completed.quantity":`Cantidad completada`,
"label.layout.testfield":`Campos de prueba`,
"label.customfields.selectcontainrelatelistlayout":`Seleccione el dise?o de página que debe incluir en la lista relativa`,
"label.fiji.time":`Hora de Fiji`,
"message.error.domain.already.exists":`Este dominio ya existe`,
"label.accountandcontact":`Clientes/Contactos`,
"label.dashboardSetup.right":`Derecho`,
"label.view.appliedMobile.xgry":`Marque este ítem, los usuarios relevantes pueden ver la vista en mesa de trabajo de página oficial`,
"label.file.share.all":`Cualquier usuario en su empresa`,
"vue_label_pool_summary":`{0} datos en total, actualizados hace {1}`,
"label.emailtemplate.new":`Plantilla de Nuevo Correo`,
"label.tag.manage.button1":`Crear nueva etiqueta`,
"label.data.exp.tempexppage":`Página de plantilla para exportar datos`,
"font-trade-module-v1-invoice-total":`Importe total de la factura`,
"label.folder.sort":`Ordenar por carpeta`,
"label.multilang.campaign.countnum":`{0} vez`,
"label.homepagelayout":`Dise?o de la página oficial`,
"setup_layout_button_cancel":`Cancelar`,
"lable.Search.in.QuickBook":`Buscar en QuickBook`,
"setup_fielddependency_label_pleaseclick":`Haga clic en el valor del ¨Campo de control¨ para editar`,
"setup.fielddependency.label.pleaseclick":`Haga clic en el valor de "Control del campo" para editarlo`,
"label.version.sum.field":`Campos personalizados`,
"label.form.is.submitted.successful":`Aviso de que el formulario se ha enviado correctamente`,
"label.campaignmember.main.batchaddmember":`Agregación masiva de los miembros de campa?a`,
"label.sendemail.activity.newevent":`Estimado#belongtoidccname, hola:\r\nsu colega#createbyidccname le ha asignado un evento nuevo en#createdate, los contenidos son:\r\n subjeto: #subject\r\n Hora de comienzo: #begintime\r \n Hora de finalización: #endtime\r\n ?tems relativos: #relatedstr\r\n Contenido: #remark\r\nfor más detalles, visite este enlace:\r\n #path\r\n #orgNameSistema CRM`,
"label.knowledgebase.select.target":`Por favor, elija un objetivo`,
"setup.layout.label.buttonlist":`Seleccionar botones`,
"pagecreator.page.label.pagedesc":`Descripción de la página`,
"label.version.professional":`Versión profesional`,
"UG.Forcast.10":`Completar`,
"template.chart.schdyqsr":`Ingresos previstos de las campañas`,
"front-filter-module-v1-quick-filter":`Filtro Flash`,
"label.notification.group2":`Se ha unido al grupo público con éxito`,
"label.ServiceCloud.statistics.by.serviceArea":`Estadísticas por territorio de servicio`,
"label.validate.function.funcExplain.TIMENOW":`Devolver la hora actual (hora, minuto, segundo)`,
"label.brief.lastmonth":`Mes pasado`,
"label.weixin.member.states":`Status de Miembro`,
"template.chart.ljxsje":`Importe acumulado de las ventas`,
"label.eidt.queue.label.hasused2":`El nombre de cola ya existe y ha sido utilizado`,
"label.textmessage.nophonenumber":`Este contacto no tiene un número de teléfono móvil registrado.`,
"label.task.new":`Nueva tarea`,
"label.tabpage.grid":`Visualización de cuadrícula`,
"label.workbanch.setup.viewname":`Nombre de vista`,
"front-gantt-module-temporary-tasks":`Tarea temporal`,
"label.reportTypeDescripe":`Según el origen de datos del informe personalizado, los usuarios pueden crear informes de acuerdo con los objetos predefinidos, relación de objetos y campos específicos.`,
"setup_layout_label_fieldlist":`Campos disponibles`,
"label.ggReleaseRange.searchforRole":`Función de socio de búsqueda`,
"label.datamanage.account.field":`Campo de cliente`,
"label_tabpage_groupingemptyz":`Los ítems de agrupación no pueden ser vacíos`,
"label.permission.edit.insertinfo":`Ingrese información del conjunto de permiso`,
"label.back_forms":`Volver a la lista de formularios`,
"vue_label_calendar_step_2":`Paso 2: Crear un calendario a partir de un objeto estándar o personalizado.`,
"lable.outlook.mcto.out":`Dominios excluídos`,
"label.workflow.accessnext":`Si satisface las condiciones, entrará a este paso`,
"label.data.exp.temppage":`Página de exportación de datos y de elaboración de plantilla`,
"label_tabpage_printview":`Vista de imprimir`,
"vue_label_report_preview":`Actualice la vista previa para ver las últimas ediciones`,
"frame_personinfo_label_personimage":`Foto del perfil`,
"component.chatter.button.like":`Me gusta`,
"label.ems.drafts":`Borradores`,
"front-lightning-module-v1-details-page-chart-report-name":`Nombre del informe`,
"label.partner.workspace.login":`Página de inicio de sesión`,
"include":`Incluir`,
"label_length_20":`Máximo 20 caracteres`,
"component_event_button_save":`Guardar`,
"label.weixin.recalculate.shared.success":`La recalculación de regla de objeto compartido tiene éxito`,
"message.duplication.errorinscript.lessthan2":`?Debe seleccionar por lo menos dos registros para combinarse!`,
"label_my_forecast":`Mi previsión`,
"label.ems.to":`Destinatario`,
"label_mobile_buttom_team_init":`Inicialización del usuario del plan de equipo`,
"label.sendemail.send.codeerror":`Transferencia de Código se falló, por favor ingrese el código correcto.`,
"lable.quote.syncing.and":`Y`,
"label.campaignmember.selectmember.step1oftotal":`Paso 1 de 2`,
"label.ems.step3":`Paso 3`,
"lable.PowerProcess.detail.message":`Detalles del proceso de asignación`,
"chatter.poll.option2":`Opción 2`,
"front-view-module-v12-verify-number":`Error de formato numérico. Por favor, compruebe los datos de entrada.`,
"label.setup.mobile.homepageshortcuts.savesuccess":`La configuración de la función rápida ha sido guardada exitosamente`,
"lable.outlook.edit.zdyoutfi":`Personalizar el nombre de Exchange`,
"label.assignment.setup.newentries.inputentries":`Ingresar ítems de regla`,
"label.customfields.money.tip":`Permite a los usuarios ingresar dólar o monto de otra moneda, y transferir automáticamente el campo al formato de moneda. Que será útil si exportan los datos a Excel u otros formularios.`,
"label.service.appointmentList.cancelThePlan":`Cancelar el plan`,
"label.chat.topic.suggest.add.topic":`No sugerencia, agregue su propio tema`,
"vue_label_commonobjects_detail_tips":`Consejos`,
"message.error.view.nameexists":`Error: el nombre único de la vista ya existe`,
"label_emailtocloudcc_step2_name":`Configurar el propietario del correo`,
"label.field.validation.apiname":`Debe comenzar con letra, sólo contiene letras alfanuméricas, guión bajo, la longitud máxima es de 50, por lo menos dos dígitos, no puede ser palabra clave dentro de la base de datos`,
"page.field.masterinput.remark2":`Por ejemplo, al crear una nueva orden, necesite activar esta función para ingresar los ítems detallados de ventas en la misma página(Esta función es muy adecuado para los objetos en la relación maestro-detalle )`,
"label.rule.enabled.successfully":`Habilitar las reglas con éxito`,
"label.role.createrolelist.tip":`Al siguiente es una lista de los roles de su organización. Puede ver más informaciones haciendo clic en el enlace del rol`,
"label.multilang.datamanage.dataimport.redundantmsg":`La longitud del título es &nbsp;{0}&nbsp;, pero la longitud de datos es&nbsp;{1}&nbsp;, el sistema determina cual&nbsp;{2}&nbsp; los campos son restantes.`,
"label.visualpage.staticresource":`Introducir recursos estáticos`,
"chatter.group.members01":`Miembros`,
"label.planned.workname":`Nombre de trabajo`,
"label.service.dispatchingUnits.gantt.data":`Fecha de coincidencia de Gantt`,
"label.data.newtemplate.t.conditions":`Condiciones de la plantilla`,
"label.accmarketsea.edit.title":`Editar grupo público`,
"label_chatter_priority":`Prioridad`,
"label_mobile_buttom_team_open":`Habilitar el plan de equipo del PC y de la APP`,
"front-gantt-module-no-tasks-available":`No hay tareas disponibles`,
"component.newrecords.label.type":`Tipo de almacenamiento`,
"label.version.ccdocument.and.remark":`Adjuntos & Notas`,
"label.martrixreport.step2":`Paso 2: Seleccione el método de agrupación para utilizar el cálculo de las informaciones resumidas`,
"label.projectManagement.Scheduleinformation":`Información sobre los horarios`,
"label.emailmerge.mergeFolder.description":`Puede generar un documento de Microsoft Word en esta página, que contiene los datos de sus contactos. Seleccione plantilla de correo para fusionarse, 20 al máximo.`,
"label.autoRegister.changepwd.setpwd.tip":`La contrase?a debe cumpir las condiciones siguientes`,
"label.partnerCloud.orderingPlatform.shoppingEmpty":`La cesta está vacía, por favor haga clic en "Añadir productos" para añadir.`,
"label.marketcloud_seminar":`Seminario de Marketing Cloud`,
"label.knowledgebase.no.results.knowledge.search":`No hay resultados sobre "{a}" en Conocimiento`,
"label.createdate":`Fecha de creación`,
"vue_label_systemSettings_bazaar":`Mercado`,
"report_type_label_contractPayment":`Contratos y Recibos`,
"label.myemailset":`Configuración de mi correo`,
"label.emailtype":`Tipo del Correo`,
"label.appexchange.uninstallpage.message5":`Cancelar permanentemente relaciones y listas relativas asociadas con los objetos personalizados en este paquete`,
"label.customerinfo.applicationlicencenum":`Función Número de licencias`,
"label.product":`Productos`,
"lable.opppdt.selPdt.subtitle":`La selección de producto se utiliza en`,
"label_emailtocloudcc_step1_lead1":`Correo a Candidatos`,
"label.multilang.recentview.query":`Ver {0} reciente`,
"label.cumstom":`Personalizar`,
"lable.product.pep":`Ingrese el precio`,
"label.suggestion":`Sugerencia`,
"vue_label_email_sentto":`Enviado a`,
"label.email.cancel":`Una vez cancelada la asociación, el buzón no podrá utilizarse para enviar o recibir correos electrónicos. Está seguro de cancelar la asociación?`,
"component_timeline_label_1monthahead":`Hace un mes`,
"setup_mainpage_label_welcome31":`Instrucciones:Haga clic en el menú a la izquierda de la página → Configuración de gestión → Crear →Aplicación`,
"label.weixin.settlement.rate":`Tasa de recepción`,
"front-lightning-module-v1-details-page-chart-add-report":` Se puede añadir un máximo de 4 gráficos de informe.`,
"label_related_list_types":`Tipo de lista relacionada de la versión Lightning`,
"label.tabpage.converstatez":`Estado convertido`,
"label.chatter.ok":`Aceptar`,
"lable.SalesCommitmentKanBan.contractRate":`Tasa de firmado`,
"component.setup.label.setupsavefail":`No se ha podido guardar la configuración del componente`,
"label.email.form.text2":`[Cambia a ¨HTML¨]`,
"UG.Lead.009":`Historial de llamadas de la APP`,
"label.escalation.setup.newrule.title":`Regla de escalamiento de casos`,
"label.field.available.value":`Valores de campos disponibles`,
"label.cannotuseaddtimetrigger":`<b>  Añadir botón de trigger de tiempo</b> no está disponible si<br/><ol><li>  Los criterios de regla se configurán cada vez cree o edite registros</li><li>  Cuando la regla haya activado</li></ol>`,
"vue_label_chat_activefail":`Activación fallida`,
"label.dashboard.show.total.percent":`Mostrar la totalidad o muestra %, seleccione por lo menos uno `,
"label.schedulejob.setup.schedule.jobprg":`Programas de trabajo`,
"label.select.email.type":`Por favor, seleccione el tipo de correo electrónico.`,
"chatter.group.allTheMembers":`Todos los miembros`,
"label.webtab.validation.apiname":`Debe comenzar con una letra, contiene mayúsculas, minúsculas, guión bajo, la longitud máxima es de 20 caracteres, la longitud mínima es de 2 caracteres.`,
"label_partner_new_step3_name":`Nombre`,
"vue_label_chatter_remove_member":`Eliminar miembro`,
"label.customobjects.majorobject.tip":`Si seleccione un objeto de relación no maestro-detallado, los datos de resumen no tienen relación con los permisos`,
"label.forecast.edit.kjjd":`A?o fiscal`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.three":`Tercera semana`,
"label.weixin.senderror":`Envío fallido`,
"label.visiturl":`Visitar URL`,
"label.apply.img.error":`Los caracteres ingresados son incorrectos.`,
"label.been.detained":`Restablecer descuento`,
"vue_label_helpcenter_dashboard2":`<br> En el cuadro de mando recién creado, primero hay que añadir componentes y seleccionar la fuente de datos del informe o de la vista de lista. A continuación, determine el tipo de gráfico utilizado y seleccione la agrupación y los datos estadísticos correspondientes para crear el gráfico<br> Después de añadir los componentes, puede hacer clic en el botón "Reordenar" del cuadro de mandos para ajustar la posición y el tamaño de los componentes. <br> Si necesita establecer condiciones de filtro de tiempo para algunos componentes, puede hacer clic en "Configuración de la condición de filtro" para seleccionar el componente y establecer el campo de tiempo que el componente necesita filtrar. Después de la configuración, puede filtrar por tiempo en el tablero y seleccionar el rango de tiempo correspondiente para actualizar los datos seleccionados. <br>Nota: Un tablero de instrumentos admite hasta 10 componentes. <br> 2. Penetración y vinculación de componentes<br> En el mismo cuadro de mando, el componente A puede establecer el componente B y C de la misma fuente de datos como sus objetos de vinculación. Una vez completada la configuración, haga clic en un área de datos del componente A, el componente B y el componente C realizarán simultáneamente un recuento de datos basado en las condiciones del área de datos del componente A. <br> Tenga en cuenta que hacer clic en el área de datos del componente B o del componente C no hará que el componente A realice un recuento. Si necesita conseguir este efecto, debe establecer el componente A como su objeto de enlace en el componente B/C. <br> Para cada componente del gráfico en el tablero, los datos provienen de la vista o del informe. Por lo tanto, se proporciona una función de penetración, es decir, al hacer clic en el área de datos del componente se puede saltar al informe correspondiente y a la vista de lista. Tenga en cuenta que si la fuente de datos original falla, el componente no tendrá datos y la función de penetración también fallará. <br> Dado que tanto la penetración como la vinculación son el área de datos del componente para hacer clic, no pueden tener efecto al mismo tiempo. Si el componente tiene tanto la penetración como la vinculación establecidas, entonces el componente sólo puede tener una función que tenga efecto al mismo tiempo, y usted puede elegir la función en efecto cambiando los estados de vinculación y penetración.`,
"vue_label_commonobject_view_notice_delete_false":`No se ha podido borrar el registro {0} debido a {1};`,
"label.weixin.newspaper.coverage.information":`Detalles de hoja de riesgos`,
"label.you.do.not.have.permission.to.operate.":`No tienes acceso para operar.`,
"label.checkfield.match":`Combinar`,
"message.custom.field.donotdelete.ref":`Este campo ha sido referenciado por otros campos`,
"label.version.maxsum":`, ha alcanzado al límite.`,
"System.ChangeUser.Info.001":`Propietario cambiado con éxito, no tiene permiso para ver este registro, haga clic para volver a la página anterior.`,
"label.target":`Objetivo`,
"template.dashboard.behavior.analysis":`Análisis de las acciones`,
"label.login.verification.enter.prompt":`Ingrese el código de seguridad de 6 dígitos`,
"label.am":`AM`,
"chatter.emailSetUp.remark":`Permite a los usuarios recibir correos de CCChatter cuando alguien le sigue, seleccione si envia correo`,
"label.accmarketsea.grouplist.title":`Configuración de grupos del grupo público de clientes`,
"label.stdashbord.xsld.business.danwei":`Unidad: 10 mil`,
"label.app.step1.error.namenull":`El nombre del grupo público no puede estar vacío`,
"label.login.button.verification":`Enviado para verificar`,
"label_tabpage_newWizardz":`Wizard de función agregada`,
"label.addattachment.step1.intruduce":`Ingrese la ruta del fichero o haga clic en el botón para encontrar el archivo`,
"pagecreator.layout.funcpath":`/ constructor / biblioteca de diseños`,
"fourth":`El cuarto`,
"label.timetrigger.after.lasttime":`Un día más tarde que la fecha de la última modificación`,
"vue_label_report_showme":`Muéstrame`,
"label.h5.similar.opportunity.end.date.in":`La fecha de finalización se encuentra dentro del siguiente período`,
"label.turntonextstep":`Regrese al siguiente paso`,
"label.icon.106":`Calendario`,
"label.user.receivenewsbulletin":`Recibir noticias transmitidas`,
"label.mask.card.number":`Número de Tarjeta de Crédito`,
"setup.object.layout.label.profileoptions":`Perfiles disponibles`,
"vue_label_systemSettings_obj":`Objetos y campos`,
"label.call.center.history.open":`Se abre automáticamente la página del historial de llamadas`,
"label.attendance.cityname":`Ingrese el nombre de la ciudad`,
"label.newemailnotice.tip":`Cree una notificación de correo para asociar con uno o más reglas del flujo de trabajo o proceso de aprobación. Al cambiar la notificación de correo, caulquiera modificación se aplicará a las reglas y proceso de aprobación asociados con ella.`,
"label.app.step1.error.labelnull":`Error: La etiqueta no puede estar vacía`,
"front-kefu-moudle-connect-free-account":`Asociar los usuarios de CloudCC con las cuentas de prueba de TRRT`,
"label.biaoqingfaxian.description":`Si se activa la función descubrir ofertas, se puede añadir un menú de descubrimiento de ofertas en el front-end, donde los usuarios pueden ver la información de las ofertas de los sectores pertinentes y convertir los datos de las ofertas en clientes potenciales en el sistema.`,
"label.filter":`Filtro`,
"label.data.downpage.e.title.num1":`1. Seleccione los objetos que desea exportar o seleccione exportar todos.`,
"label.h5.similar.opportunity.last.months12":`9-12 Meses Recientes`,
"label.chatter.name":`Nombre`,
"vue_label_helpcenter_email":`1. Enviar correo<br> Salir del sistema para ir a su correo para comunicarse con los contactos ya es cosa del pasado. En Cloud CC, puede vincular su dirección de correo electrónico personal para enviar correos electrónicos directamente desde Cloud CC. Cuando introduzca la dirección de correo electrónico o el nombre del destinatario, el sistema podrá asociar su registro de contactos o clientes potenciales por usted. También puede asociar los registros de correo con los registros relacionados que se hayan configurado, y los correos que envíe se sincronizarán en la página de detalles del registro.<br> 2. 4 funciones comunes al enviar correos electrónicos<br> Al enviar un correo electrónico, puede utilizar las 4 funciones que se encuentran debajo del texto del correo electrónico para ayudarle en su trabajo.<br> <br>Seguimiento del correo<br> Al activar el seguimiento del correo electrónico, le ayudaremos a controlar el número de veces que se ha abierto este correo electrónico y cuándo se abrió por última vez. Puede pasar el ratón por encima del icono del "ojo" en la lista de la bandeja de salida para verlo.<br>Subir archivo adjunto<br> Haga clic en Subir archivo adjunto, puede seleccionar el archivo que se ha subido al sistema, o puede elegir subir el archivo. Puede seleccionar varios archivos adjuntos, siempre que el tamaño del archivo adjunto sea inferior a 20M.<br> <br>Insertar campos combinados<br> Cuando el correo electrónico está asociado a un registro de objeto, puede hacer clic para insertar el campo combinado, seleccionar el objeto asociado, seleccionar el campo que desea insertar e introducir el texto de sustitución después de la coma en el campo combinado, como {!Contact.FirstName,Sir or Madam }. Al guardar la plantilla, los campos combinados se mostrarán en el texto del correo electrónico de la plantilla. Utilice los campos combinados para personalizar el contenido del correo electrónico. Puede añadir texto de sustitución a cualquier campo combinado. El texto de sustitución sólo se muestra cuando el registro fusionado no contiene los datos del campo.<br> <br>Editar y habilitar la firma<br> Cuando envíe correos electrónicos de trabajo, una firma que pueda representar su identidad le ayudará a mejorar su profesionalidad laboral. Haga clic en el botón "Editar Firma", puede editar su información básica, y le ayuda a insertar imágenes. Si marca "Activar firma", su firma se adjuntará al cuerpo del mensaje cada vez que redactes un correo electrónico. Puede desactivar la firma en cualquier momento.<br> 3. Filtrar la bandeja de entrada<br> Puede filtrar todos los correos no leídos en tu bandeja de entrada para facilitar su trabajo. Cuando quiera descargar archivos por correo electrónico, puede filtrar todos los correos con archivos adjuntos en su bandeja de entrada, para poder localizar rápidamente el correo que necesita. Además, puede ver rápidamente los registros de los clientes en el sistema que rastrea a través de los correos electrónicos, filtrando los correos electrónicos que contienen oportunidades de negocio abiertas o filtrando los correos electrónicos enviados por clientes potenciales o contactos.<br> 4. Envío masivo de correos<br> Hay un botón para el envío de correos en grupo en la esquina superior derecha de la lista de clientes potenciales y contactos. Puede enviar correos masivos a clientes potenciales o registros de contactos con direcciones de correo electrónico. Cuando tiene un registro de campaña, puede enviar correos electrónicos a los miembros de la campaña en lotes, lo que también es conveniente para enviar invitaciones a eventos.`,
"front-kefu-moudle-auto-callphone":`Creación automática de nuevos casos para las llamadas conectadas`,
"label.fiscal.FQ":`Trimestre contable`,
"label_tabpage_groupsVisiblez":`Algunos grupos de usuarios son visibles`,
"UG.product.01":`Lista de productos/servicios`,
"vue_label_commonobjects_view_members":`Miembros disponibles`,
"label.organization.id":`Organización ID`,
"label.tyle_preview":`Vista previa del estilo`,
"label.campaign.channel.input.to.owner":`6. Configure si notificarán a todos cuando los miembros inicien la sesión:`,
"label.appointmentconfirmpage.wizard.notif1":`La reserva ha sido cancelada`,
"lable.tianyancha.maping":`Mapeo de campo`,
"front-kefu-moudle-v1-noadd-online-chats":`No se añade el agente en línea`,
"vue_label_commonobjects_detail_group_strategy":`¿Está seguro de entrar en el plan de equipo de este cliente?`,
"vue_label_report_deletegrouprow":`Borrar fila de grupo`,
"lable.account.y.d":`Esta página le permite definir un registro del a?o fiscal personalizado. La fecha del a?o fiscal personalizado se generá según lo que seleccione a continuación.`,
"label.visualpage.lllegal.definitions":`Definición inválida`,
"label.tabpage.enterrecordnamez":`Por favor, introduzca el propietario del registro`,
"vue_label_report_howmuchlines":`{length} líneas`,
"homepage.components.custom":`Componentes Personalizados`,
"label.campaign.channel.upload.img":`Subir imagen`,
"UG_Case_03":`Actualización automática del caso`,
"label.approved.receiveApprovalEmail.option4":`Nunca`,
"System.Data.Import.Warning.MaxCount":`Su organización solo puede importar {0} datos cada vez, actualmente ha excedido del límite, por favor, ajústelos y vuelva a importar.`,
"label.sent.sms":`envió un SMS`,
"vue_label_dashboard_statistictype":`Tipo de estadística`,
"label_report_last_year_same":`Mismo periodo del año pasado`,
"lable.Examle":`Ejemplos`,
"label.customerinfo.PageTriggerFagTitle":`Cada dos horas sincroniza una vez`,
"label.mobile.phone.read":`Revisar`,
"label.product.gopage":`Saltar a`,
"label.a_b_without":`El registro ¨A¨ puede tener o no tener registro relacionado con ¨B¨`,
"front-kefu-moudle-callin-missphone":`Llamadas perdidas`,
"label.sso.saml.sp.idsource.attrname":`Nombre de propiedad`,
"label.h5.chatter.colleagues2":`Colegas`,
"label.approveprocess":`Proceso de aprobación`,
"label.dataimport.error.name.null":`Error: el nombre es nulo.`,
"label.paging.countitems":`{0}`,
"vue_label_report_notice_filter":`Cuando el filtrado avanzado no está activado, las diferentes condiciones de filtrado son "y", es decir, los registros que satisfacen las características comunes de 1 y 2 se mostrarán en el informe. Por ejemplo: 1 es una oportunidad de negocio con un importe superior a 1 millón, y 2 es una fecha prevista de firma de contrato igual a este mes, por lo que el resultado del informe son oportunidades de negocios de más de 1 millón de este mes.`,
"front-lightning-module-v1-dashborad-export-picture":`Exportar imagen`,
"label.activity.disabled":`No hay evento activado, contacte con el administrador del sistema para activar el historial de evento y las actividades no procesadas en el dise?o de página.`,
"message_chooseatleastonefield":`Seleccione al menos un campo a mostrar`,
"label.case.text":`Los formularios de solicitud de servicios enviados a través del sitio web pueden generar registros de casos en el sistema. Por favor, seleccione el usuario como creador del registro del caso, y el usuario seleccionado debe tener permiso de creación para el objeto del caso. La página web está disponible para ordenadores y teléfonos móviles.`,
"label.sendmail.step3.dealoption1":`Cco me cada correo`,
"label.forecast.settings.title.remark":`Los mejores presupuestos de los ingresos estimados para los usuarios, las previsiones pueden ofrecerles una vista completa de negocio`,
"label.apply.youxiaotime.finish.opperation":`Tiene cinco minutos para terminar las operaciones. Ignore este mensaje si no lo opere usted mismo.`,
"label.user":`Usuario`,
"pagecreator.page.button.copy":`Copiar`,
"label.userinfo.pwdupdate.or.reset":`La última modificación o reseteo de contrase?a está en`,
"label.fieldupdata":`Actualización del campo`,
"label.sendemail.chat.followsubject":`Alguien sigue CloudCC CCChatter`,
"component_task_label_enddate":`Fecha expirada`,
"label.campaign.channel.step6.remark5":`Puede asignarlo a través de las reglas de asignación de candidatos. Conocer más sobre la regla`,
"label.mr.title.mobilePhone":`Móvil`,
"label.notice":`Recordatorio`,
"message.serviceappo.time.violation":`Violación de la hora disponible de la cita de servicio: La hora de inicio acordada de la cita de servicio es posterior a la hora de inicio más temprana disponible`,
"label.account":`Clientes`,
"front-kefu-moudle-callcenter-user":`Usuarios del centro de llamadas`,
"label.usermanage.query.notexist":`El usuario no existe`,
"label.forecast.userinfo.isnable":`Permite previsiones`,
"label_partner_workspace_member":`Miembro`,
"vue_label_dashboard_penetrationsetting":`Ajustes de Penetración`,
"chatter.fieldtrack.operatecreate":`Ha creado uno`,
"label_tabpage_tpcustomersz":`Convertir cliente potencial`,
"label.emailtocloudcc.redmessage6":`Autenticación IMAP/SMTP fallida, compruebe que la dirección de correo electrónico y la contraseña son correctas.`,
"label.customfields.file.upload":`Subir`,
"label.forecast.isforecast":`No previsiones activadas`,
"label_benchmark":`Referencia`,
"label.exchange.sync.state.system":`Status de Sync del sistema`,
"UG.opportunity.003":`Seguimiento de sus canales de venta, creación de cuadros de mando`,
"label.campaign.matchway.select.error":`Para actualizar los datos, seleccione método para coincidir`,
"vue_label_dashboard_located":`Carpeta del cuadro de mandos`,
"front-electronic-signature-enter-object":`Por favor, introduzca el objeto`,
"vue_label_systemSettings_mobelquick":`Configuración rápida de las aplicaciones móviles`,
"lable.outlook.list":`Configuración de Exchange Sync`,
"label.sendemail.approval.dlsp":`Hola, #dlspr:\n #actorname#objapiname-#recordname enviado por #actordate ha sido configurado como aprobador de proxy via el aprobador original #spr y está esperando su aprobación. \nHaga clic en el enlace siguiente o ingrese al sistema CRM para entrar al centro de aprobación por la aprobación: \n#url\n ?Gracias! \n#orgname`,
"label.service.deleteCustomView.wanttoremove.filter":`¿Está seguro de que quiere eliminar el filtro "{name}"?`,
"component_task_label_newevent":`Nueva tarea`,
"vue_label_commonobjects_view_chart_groupby":`Agrupar por`,
"front-kefu-moudle-v1-edit-chats":`Editar agente`,
"pagecreator_page_message_delete_fail":`Se frascasó en cancelar la página`,
"label.file.search":`Buscar archivos...`,
"label.projectManagement.Addpredecessors":`Añadir una tarea previa`,
"label_tabpage_norecordtypez":`Tipo de registro no disponible`,
"label.come.recycle.bin":`Entrar a la papelera de reciclaje`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.relative":`Relativo`,
"label.customfields.address.tip":`Permite a los usuarios seleccionar provincia, ciudad, condado, y ingresar información detallada de la dirección para calcular latitud y longitud.`,
"label.weixin.optioneight":`Opción 8`,
"label.recordtypeselect.modify":`Editar el tipo de registro`,
"label.forecast.settings.future3":`Los 3 ciclos del futuro`,
"label.rename":`Renombrar`,
"label.emailtocloudcc.button.complete":`Completar`,
"chatter.new.at":`Eventos recientes`,
"component.setup.label.milestonesfield":`Campo de hito`,
"vue_label_commonobjects_detail_email_newaddress":`Correo del destinatario`,
"lable.PowerProcess.big.event":`Evento clave:`,
"label.appexchange.uninstallpage.confirm":`Sí, Quiero desinstalar este paquete y cancelar permanentemente todos los componentes asociados`,
"label_mobile_buttom_homepage":`Página oficial`,
"label.sso.saml.idp.config.logouturl":`Salir único URL`,
"lable.quote.pdf.button.savetoquote":`Guardar a la cotización`,
"label.page.select.application":`Seleccione los apps personalizadas en los que quiere utilizar el nuevo menú personalizado. También puede ver o modificar si una pesta?a aparezca en la página detallada o editar página de cada app personalizada.`,
"chatter.down":`Descargar`,
"label.tabpage.searchz":`Buscar`,
"label.emailsync.form.action":`Acción`,
"label.campaignmember.setup.campaignmember.field":`Campo de miembros de campa?a`,
"label.version.remark":`Nota: La edición gratis sólo se permite crear 5 usuarios, 2000 registros y no se puede importar o exportar datos.`,
"label.selectoperateobject":`Seleccione objeto`,
"label.appointmentdetail.wizard.title12":`La hora del libro`,
"label.submitforapproval":`Enviar por aprobar`,
"label.the.lower.bound.of.each.layer.of.editing.discount.must.be.equal.to.the.upper.bound.of.the.upper.level.":`El límite inferior para editar cada nivel de descuento será igual al límite superior del último nivel.`,
"label.appupload.install.component.view":`Ver los componentes`,
"label.profile.customobjcontrol":`Permisos del objeto personalizado`,
"label.customfields.configprofilefieldsafety.tip":`Seleccione los perfiles a los cuales desea otorgar acceso de editación a este campo via nivel de seguridad del campo. Este campo no mostrará en ningún perfil si no lo agregue al nivel de seguridad.`,
"label.service.gantt.service.resources":`Recursos de servicio`,
"label.input.right.emailaddress":`Ingrese al correo correcto`,
"label.ccdocument.folder.notedit":`Esta carpeta no se puede editar.`,
"label.data.choses.i.desc":`Importe los datos de un solo objeto según sus necesidades`,
"label.icon.75":`Coche`,
"label.summaryreport.step4":`Paso 4: Seleccione las columnas de informe`,
"label.appupload.upload.install":`Instalar`,
"label.reportlist.newfolder":`Crear carpeta de informe`,
"label.projectManagement.myproject":`Mi proyecto`,
"label.true":`TRUE`,
"label.tabpage.reallproplez":`Registrar todas las personas`,
"label.change.lead.share.error":`No tiene permiso de editar usuario`,
"F":`Fecha/Tiempo`,
"lable.account.CurrentandNextCQ":`Trimestre calendario actual y siguiente`,
"UG.activity.06":`Querer hacer un seguimiento del cliente`,
"UG.contact.03":`Seguimiento de los contactos en un solo lugar, señales de venta`,
"label.field.duplicate.error.msg2":`Configuración fallida de la propiedad única`,
"label.sales.dashboard.reality":`Pago actual`,
"lable.PowerProcess.type":`Tipos de proceso de asignación`,
"batch.selected.data":`Datos Seleccionados:`,
"#label.importsourcefilestep2":`Paso 2: Comprime sus archivos(Opcional)#`,
"label.emailtemplate.select":`Seleccione la plantilla de correo que quiere utilizar`,
"chatter.most.w":`?Ingrese hasta 500 caracteres!`,
"vue_label_calendar_new_object_calendar":`Nuevo calendario de objeto`,
"label.aggregated_formsdata":`Datos agregados de los formularios`,
"label.knowledge.language.french":`Francés`,
"label.customfields.enc.tip":`Permitir a los usuarios ingresar cualquiera combinación alfanuméricas, y guardarles con el formato cifrado. No se puede buscar.`,
"label.icon.158":`Nube`,
"font-evaluate-module-v1-bad-review ":`Cuando el tipo de evaluación es negativa`,
"UG_quota_03":`Plantilla de presupuestos`,
"label.eidt.queue.label.hasused":`Esta etiqueta se ha utilizado`,
"label.lookupfilter":`Filtro de búsqueda`,
"label.callcenter.Instance.name":`Nombre de la instancia`,
"label.commitertype":`Tipo del envío`,
"vue_label_checkduplicate_any_one":`Satisfacer uno cualquiera`,
"label.campaign.channel.input.img":`Seleccione la imagen de local como la página de agradecimiento`,
"vue_label_dashboard_pleaseenterafoldername":`Introduzca el nombre de la carpeta`,
"label.tianyancha.look":`Ver`,
"label.tabpage.lastone":`Seleccione al menos una operación`,
"label.sendemail.approval.submit.title":`{!objLabel} - {!recordName} están esperando su solicitud`,
"label.chat.topic.delete.prompt1":`Cancelar el tema lleva tiempo, el tema se guardará en las publicaciones y registros a menos de que el proceso termine.`,
"component_setup_label_displaybutton":`Botón de Visualización`,
"label.partnerCloud.backgroundImage":`Imagen de fondo`,
"label.mobile.phone.time.range":`Rango de tiempo`,
"label.page.url.address.remark":`Ingrese sitio web en el campo de ¨Enlace URL¨. Puede ingresar una URL simple, como se muestra en el navegador; puede utilizar uno o más campos fusionados para insertar dato específico de la organización de CloudCC a los parámetros URL. Algunos sitios son inválidos en el menú Web debido a la configuración de seguridad de navegador, o por que el sitio le previene mostrar en el marco.`,
"label.h5.copyemail":`Correo copiado`,
"label.view.step3":`Paso 2. Seleccionar campos para mostrar`,
"label.quickbooks.view.moneyreceived":`Dinero recibido`,
"label.emailobject.attachment.preview":`Previsualizar`,
"label.selectapprover":`Seleccione aprobador`,
"vue_label_normal_opportunity_sf":`Oportunidad`,
"label_emailtocloudcc_filed_port":`Portal`,
"mesage.errorinsaving":`Un error se ocurrió al guardarse. Por favor contacte con el adiministrador.`,
"label.partnerCloud.partnerCloudName":`Por favor, introduzca el nombre de la nube asociada`,
"lable.edit.queue.checkemail":`Error: Correo inválido`,
"label_builder":`Constructor de página`,
"component_setup_label_setupsavefail":`Se frascasó en guardar la configuración de componentes`,
"label.icon.76":`Coche`,
"label.reportsSubscriptionPage.schedulereport.monthly":`Mensual`,
"message.nopermession":`Permisos insuficientes`,
"label.view.groupscansee":`Visible a <b>algunos grupos de usuario</b>`,
"label.leadscore.rule.new":`Puntuación de candidatos: Nueva regla`,
"label.new.ccpeakfolder.time":`Clases programadas: Nueva carpeta`,
"label.record":`Registros`,
"message.error.flabel":`El campo de etiquetas no puede contener comillas simples o dobles en inglés`,
"label.emailobject.emaildetail.promptbutton2":`Cancelar`,
"label.h5.phone":`Llamada`,
"label.visualpage.error.deal.with":`Se ocurrió un error, contacte con el administrador`,
"label.button.step1.select.field":`Paso 1: Seleccione los campos`,
"label.setsharerule.step1":`Paso 1: Seleccione el tipo de regla`,
"component.chatter.file.label.title":`Cargar archivos`,
"front-epwechat-module-v1-appname":`Nombre de la aplicación`,
"chatter.error.notsel":`?Error: Seleccione primero una imagen para subir!`,
"label.updatevalue":`El valor preciso que quiere cambiar`,
"label.chatter.sendEmailToGroupMember.subject.D":`{0} documentos publicados para todos en {1}`,
"label_tabpage_grid":`Visualización de cuadrícula`,
"homepage.components.standard":`Componentes Estándar`,
"label.movable":`Actividades`,
"label.report.selected.field.cannot":`Los campos seleccionados no pueden exceder 50`,
"label.projectManagement.distribution.by.excess":`Asignar por excesos`,
"addrow":`Añadir fila`,
"label.approvaldatamove.p":`Utilice las opciones siguientes para gestionar múltiples solicitudes de aprobación. Haga clic en ¨Buscar¨ para filtrar las solicitudes de aprobación. Cuando se muestren los resultados en la lista, especifique la operación que ejecutar.`,
"label.passwordPolicy.setup.title":`Políticas de contrase?a`,
"label.appointmentpage.wizard.title1":`{0} ({1}) está invitándote`,
"label.tippage.li1":`Cancelar permanentemente el origen de datos del informe personalizado`,
"label.campagin.roi.dcl":`Tasa de asistencia`,
"label.h5.new.errorbody":`El campo * es obligatorio`,
"label.cy.enable":`Activar moneda`,
"label.currency.rate.e":`Editar la tasa de cambio entre las monedas utilizadas por su organización.`,
"or":`O`,
"lable.custom.Previous.CYt":`Los 2 años personalizados anteriores`,
"front-epwechat-module-v1-unbound-desc":`Eliminar la vinculación borrará la cuenta vinculada. ¿Está seguro de que quiere desvincularla?`,
"pagecreator_button_publish":`Publicar`,
"font-evaluate-module-v1-case-owners":`Notificar al propietario del caso:`,
"label.pw.new":`Por favor, introduzca una nueva contraseña`,
"message.tabsearch.nokeywords":`Ingrese por lo menos una palabra clave con la longitud de un carácter`,
"label.sendemail.send.erroruser":`Usuario incorrecto`,
"label.personalinfo":`Mi información personal`,
"label.case":`Casos`,
"lable.product.pricebooks.now":`Lista de precios existente`,
"label.ccpeak.take.notice":`?Nota: ID, Código, Creador, Fecha de Creación y otros campos del sistema no necesitan ingresar valor!`,
"label.page.first":`La primera página`,
"label.icon.168":`Monumentos`,
"label.choices":`Opciones`,
"label.is.delete.document":`?Está seguro de cancelar este archivo?`,
"homepage.layout.custom":`Dise?o personalizado`,
"label.emailobject.template.insert.field":`Campos`,
"label.ccpeak.folder.all":`Todas las carpetas de clasificación`,
"front-console-conversation-btn3":`Reenviar el correo electrónico`,
"label.ems.port":`Portal`,
"label.app.introduce":`Una aplicación es un grupo de menús que trabaja como una unidad para proporcionar la función. Los usuarios pueden cambiar entre apps utilizando el menú de app desplegable en la parte superior derecha de cada página.`,
"label.file.library.managemembers.admin":`Administrador de la biblioteca`,
"vue_label_salesadvance_win":`Ganados`,
"label.email.click.complete.info":`Haga clic en ¨finalizar¨ para regresar a la página anterior`,
"label.umeng.activity.event.willbegin":`Su evento #event empezará en #time`,
"label.mobile.phone.week.summary":`Resumen semanal`,
"label.quickbooks.fieldlabel.terms":`?tems`,
"lable.currencyManage.advcurrencyEnabled.dis":`Puede mapear la tasa de cambio a la tasa de conversión de moneda vencida dentro de un rango de fecha específica. La tasa de cambio caducada se utiliza para oportunidades, productos de oportunidad y informe relacionado con estos dos objetos.`,
"label.weixin.data.save.failed":`Error al guardar los datos`,
"label.service.gantt.filter.logic":`Lógica del filtro:`,
"vue_label_pool_adopt":`Reclamar`,
"label.emailobject.markasunread":`Marcado como no leído`,
"label_please_select_a_member":`Seleccione los miembros`,
"label.salescloud.unit.ci":`Unidad(Pieza)`,
"vue_label_pool_obsolete":`Descartado`,
"label.cancelall":`Cancelar todo`,
"label.exchange.sync.state.setting.m2":`Usuarios de la configuración de CloudCC Exchange han sido activados:`,
"vue_label_pool_claimtime":`Tiempo de reclamación`,
"label.forecast.forehistory.history":`Historial de previsiones`,
"label.knowledge.article.record":`El artículo de conocimiento no cumple con los requisitos`,
"label.setting.intergrationlist.button.uninstall":`Desinstalar la integración`,
"label_tabpage_gotit":`Lo sé`,
"label.data.exp.csvform":`Solo válido para los datos exportados`,
"UG.Forcast.06":`Seleccione los usuarios que están autorizados a realizar previsiones`,
"vue_label_report_savereport":`Guardar informe`,
"setup.object.field.dependency.label.mustone":`Seleccione al menos 1 valor que depende del campo`,
"label.batchadd.newbatchpage.des1":`Name es obligatorio, si no rellene, este registro no se guardará por defecto`,
"lable.custom.CurrentandPreviousCYt":`Año personalizado actual y los dos anteriores`,
"label.versiontype.Professional":`Versión Profesional`,
"label.customfields.configprofilefieldsafety":`Configure seguridad del campo de perfil`,
"label.ccpeak.wgd.time":`Clase programada no archivada`,
"component.telerecord.label.subject":`Asunto`,
"label_year":`Año`,
"pagecreator_layout_label_modifylayout":`Editor del dise?o`,
"label.compact.layout.frame.splitline":`Línea de separación dividida derecha y izquierda`,
"lable.PowerProcess.enter.the.process":`{describeName} entra en el proceso`,
"label.emailobject.cc":`Cc:`,
"front-electronic-export-choseCount":`Seleccione los datos importados`,
"label.setup.mobile.bottombutton.recovery.default.success":`Se ha restaurado con éxito el estado por defecto...`,
"label.datamanage.import.accountfield":`En el formulario siguiente, seleccione los campos en el archivo importado que se deben introducir a cada cliente. Luego clic en ¨Siguiente paso¨.`,
"vue_label_opportunity_related_list":`Añadir a la lista relacionada`,
"label.group.recent":`Grupos recientemente revisados`,
"vue_label_pool_finalclaimtime":`Tiempo de reclamación final`,
"vue_label_homepage_30daysnocontact":`Oportunidades de negocio no contactadas en los últimos 30 días`,
"label.tianyancha.field.error":`El dato de Tianyancha no se ha encontrado, contacte con el administrador para realizar la inicialización`,
"label.product.go":`Ir a los informes`,
"label.customsetting.manage.introduce":`Si la configuración personalizada es una lista, haga clic Crear para a?adir un conjunto nuevo de los datos. Por ejemplo, si su aplicación tiene una configuración del código de país, entonces cada conjunto incluirá con posibilidad el nombre de país y el código de teléfono.`,
"label.task.dateadd":`Más`,
"label.email.recipients.select":`Seleccione los destinatarios`,
"chatter.emailListMyChat":`Le gusta mi publicación o hacer comentarios`,
"label.batchadd.newbatchpage.save.name":`Si el nombre está nulo, el sistema no a?ade a este registro por defecto, asegúrese de que el nombre no está nulo, y luego guarde`,
"UG_Lead_011":`Crear una pista`,
"vue_label_salesfunnel_notice2":`Número total de oportunidades en curso`,
"APPIntegration_Social_linkedinerror":`Debe ingresar una URL válida para linkedin.com`,
"label.industrialandcommercialverification.enablestatus2":`Búsqueda del nombre de cliente en tiempo real`,
"label.stdashbord.xsld.business.ajssx":`Por rol`,
"lable.info.queue.showalluser":`Ver todos los usuarios`,
"label.generatepage.c1":`Debe comenzar con una letra, solo contiene las letras mayúsculas y minúsculas, números y guión bajo`,
"label.thenset":`y luego de acuerdo con`,
"label.salescloud.salescloud.defaultteam":`Grupo de oportunidad predeterminado de los usuarios`,
"label_partner_workspace_tab_selectedoption":`Pesta?as seleccionadas`,
"label.tippage.li":`Cancelar el origen de datos del informe personalizado causará`,
"lable.quote.syncingfrom.syncingto":`Los productos de oportunidad ha sido sincronizados en los ítems de cotización`,
"label.emailobject.delete":`Eliminar`,
"label.data.selectimportobject":`Seleccione objetos para importar`,
"label.knowledge.language.dutch":`Holandés`,
"message.campaign.page.overtime":`La página ha expirado`,
"label.ccchat.message.search.desc4":`Revisar la ortografía de las palabras de búsqueda.`,
"label.login.forgetPsd":`Olvidar contrase?a`,
"vue_label_title_order":`Pedir`,
"template.report.contract.follow.status":`Seguimiento del estado del contrato`,
"label.forecast.edit.kjnd":`A?o fiscal`,
"front-electronic-export-listTitle":`Lista de Mailchimp`,
"label.dataimport.error.khmc.notnull":`Error: Debe introducir el nombre del cliente`,
"label.testobject":`Objeto de la prueba`,
"label_chatter_nextStep":`Paso siguiente`,
"label.file.public.link.share":`Compartir enlace público`,
"label.weixin.organization.name":`Nombre de organización`,
"label.quote.email":`Correo`,
"label.reg_field":`Campo regular`,
"font-evaluate-module-v1-response":`Respuesta tras la evaluación:`,
"label.chatter.sendmail":`Enviar correo electrónico`,
"label.weixin.start.incorrect":`El formato de la fecha de inicio es incorrecto`,
"component_chatter_link_label_url":`Enlace URL`,
"vue_label_pool_operatecertification1":`{0}{1}{2}`,
"lable.currencyManage.Enabledadvcurrency.agree":`Sí, quiero habilitar Gestión Avanzada de Moneda`,
"label.east.africa.time":`Hora del Este de ?frica`,
"label.product.proof.Three":`En {0}, elija un mínimo de {1} opciones de productos, pero hasta {2}.`,
"label_emailtocloudcc_filed_password":`Contrase?a de correo`,
"component.task.label.person":`* Persona asignada`,
"pagecreator_systemstyle_label_buttonareacolor":`Color de la área de operación`,
"label.clearrule":`Reglas para vaciar`,
"lable.customer.access":`Permiso de acceso del cliente`,
"label.finish.wait":`Su solicitud ha sido procesada, debe esperar a que se complete el proceso, por favor revise su correo sobre el resultado. `,
"label.weixin.appr.auditor":`Aprobador`,
"label.tabpage.systemz":`sistema(s)`,
"label.file.nocan.process.desc":`No se puede procesar la solicitud. No podemos tratar la entrega de contenido`,
"label.relationobject.name":`Nombre de objeto relacionado`,
"setup.layout.group.relatedlist":`Listas relacionadas`,
"label.generatepage.title":`Página Web to CloudCC`,
"label.page.step3.input.url.information":`Paso 3: Ingrese detalles de la URL`,
"label.change.to":`Cambiar el status de miembros de campa?a a`,
"label.validate.function.funcFormat.TIMEVALUE":`TIMEVALUE(date)`,
"label.partnerCloud.seriesSettings":`Configuración de la familia de productos`,
"component.timeline.label.1monthahead":`1 mes antes`,
"label.batchadd.senumberpage.selnum":`Seleccione la cantidad de registro para añadir`,
"label.downloadapp":`Descargar App`,
"label.dashboardSetup.showmainpage":`Mostrado en la Pagina de inicio`,
"label.h5.nophoneprompt":`Este colega no registra el número de contacto`,
"label.service.deleteCustomView.wanttoremove.theFilter":`¿Desea eliminar el filtro "{name}"?`,
"label.appupload.state1":`Subido`,
"component_timeline_button_filter":`Filtrar`,
"label.passwordPolicy.setup.subtitle":`Configure las restricciones de contrase?a y políticas de ingreso bloqueado para todos los usuarioss`,
"vue_label_normal_quote_sf":`Oferta`,
"label.productsales.today.noevttskaddall":`Hoy no hay eventos abierto o tareas expiradas, puede hacer clic en  “ ” en la parte superior derecha para añadir nuevos eventos y tareas.`,
"label.projectManagement.no.end.date":`Sin fecha de finalización`,
"label.sendmail.batch.chosetemplate":`Correo masivo: seleccione una plantilla`,
"serviceterritorymember.serviceresource.isactive.notactive":`Este recurso de servicio no está habilitado. Puede asignar los territorios de servicio a un recurso de servicio habilitado.`,
"label.notification.event.overlapEvent.continue":`Continuar creando`,
"label.appupload.component.type.obj":`Objetos personalizados`,
"label.partnerCloud.financeSetting.basicConfiguration":`Ruta de acceso: Plataforma pública  Desarrollo  Configuración básica`,
"lable.outlook.detail.info":`Detalle de configuración Exchange Sync`,
"vue_label_commonobjects_detail_activity_commingevents":`Eventos próximos en propiedad`,
"coderules.nullvalue2":`No se ha podido generar. Introduzca el valor de 【{0}】,【{1}】 utilizado en las reglas de generación.`,
"label.version.sum.workflowrule":`flujos de trabajo`,
"label.sso.saml.idp.config.enable":`Activar proveedor de identidad`,
"label.temp.exp.conf":`?Está seguro de exportar la plantilla?`,
"label.department":`Departamento`,
"label.trigger.operation.email.template":`Obtener información de la plantilla del correo`,
"label.page.content.frame.height":`Altura de Marcos de contenido (Píxel)`,
"label.ServiceCloud.jinengyaoqiu":`Requisitos de habilidades`,
"PageLayout.Search.MultiSearch.001":`Solo puede seleccionar hasta 3 campos.`,
"label.error500":`?Oops! Error...<br />Contacte con administrador...`,
"label.appexchange.download.stop":`Deja de instalar por los conflictos`,
"label.service.dispatchingUnits.left.right.totalAll":`Actualmente hay {left}-{right}} registros, {totalCount} registros en total`,
"label.tabpage.haschangedz":`Este cliente potencial ya está convertido`,
"label.industrialandcommercialverification.button.cancel":`Cancelar`,
"label.edit.role":`Editar rol`,
"label.mr.descreption.condition2":`Reglas-De acuerdo con los primeros caracteres: ingrese número y encontrar los duplicados de acuerdo con los primeros caracteres ingresados del número.`,
"label.testgrammer":`Revisar sintaxis`,
"label.age":`Edad`,
"lable.real.time.chat":`El soporte técnico del chat en tiempo real es proporcionado por Easemob. Por favor, configure la configuración avanzada en Easmob.`,
"vue_label_opportunity_selected":`Ya se han seleccionado {sum}`,
"label.weixin.optionone":`Opción 1`,
"label.file.delete.public.link.desc":`Cancelar el enlace público significa que ninguno puede acceder al archivo con esta URL. Si cree un nuevo enlace público, se volverá una URL diferente.`,
"label_tabpage_cancel":`Cancelar`,
"template.report.opportunity.analysis":`Análisis de la etapa de oportunidad`,
"label.escalation.setup.newrule.inputrule":`Ingrese el nombre de regla`,
"label.ccpeak.getapi.name":`Conseguir directamente el nombre de API al lograr el valor de registro:`,
"second":`El segundo`,
"label_tabpage_uploadsz":`Subir`,
"label.description":`Notas`,
"label.ccchat.person.invite.notsamepwd":`Contrase?a inconsistente`,
"label.mobile.app.isEnableAblumWatermark":`Agregue marca de agua a la foto seleccionada de los álbumes de fotos de móvil al registrarse`,
"vue_label_allsearch_searchable_items":`Elementos Explorables`,
"lable.outlook.detail.react":`Eventos recientes`,
"label.sales.team":`Grupo de oportunidad`,
"label.guif.standard.time":`Hora Estándar del Golfo Pérsico`,
"label.emailobject.emaildetail.button.forward":`Reenviar`,
"label.refused":`Rechazado`,
"homepage.components.one":`Paso 1: Ingrese el nombre de los componentes`,
"day":`Día`,
"label.dataimport.error.number":`Error: Número`,
"label.customer.tab.step2.same.option2":`Cerrar por defecto`,
"component_button_ok":`Confirmar`,
"label.allrecordmeetprocess":`Todos los registros deben entrar a este paso`,
"label.version.onefile.size":`Tama?o subido de adjunto individual`,
"label.partnerCloud.orderingPlatform.allProducts":`Todos los productos`,
"pagecreator.page.message.publish.success":`Página publicada con éxito`,
"lable.currencyAdv.exchagecurrency.rate.pro":`El rango anterior`,
"label.attendance.persons":`Usuarios aplicables`,
"label.send.an.email":`Enviar un correo`,
"registration.page.browser.title":`Registro en el canal de marketing de Campagin`,
"label.importfilestep3":`Paso 2: Seleccione y suba su fichero`,
"lable.currencyAdv.exchagecurrency.rate.next":`Próximo rango`,
"label.ems.no.sync.msg":`No ha configurado información de sincronización de correo.`,
"label.total_views":`Vista previa de la presentación de formularios`,
"label.knowledge.article.notnull":`Por favor, elija al menos un artículo.`,
"message.error.view.lastview.delete":`No se puede cancelar la última vista de lista pública</br> No puede cancelar la última vista de lista pública que es visible para todos los usuarios.</br></br>`,
"label.integrations.second.half":`datos, seleccione los datos importados`,
"vue_label_systemSettings_mobelparams":`Configuración de los parámetros de la aplicación móvil`,
"message.choose.maximum":`Puede seleccionar hasta 150 registros para compartir, ahora ha seleccionado`,
"vue_label_homepage_won&unprocessed":`Ganado   Sin procesar`,
"UG.contact.01":`¿Cómo aprovechar al máximo sus contactos?`,
"label.data.import.setup.remark":`El administrador puede configurar reglas para ejecutar al importar datos, incluye si ejecute regla de verificación, triggers, filtro de duplicados`,
"pagecreator_layout_message_delete_success":`Dise?o eliminado con éxito`,
"lable.account.name":`Nombre de Trimestre Fiscal`,
"label.userinfo.must.updatepwd":`Para la seguridad, debe cambiar la contrase?a ahora`,
"label.mobile.phone.subordinate.setup":`No se puede configurar si incluye los subordinados, seleccione todos y configúrelos para permitir previsiones.`,
"label.monitorsys.delete.date":`Fecha`,
"label_emailsync_form_emailaddress":`Dirección del correo`,
"label.projectManagement.cancelled":`Cancelado`,
"label.partnerCloud.partnerAccount.rechargeAmount":`El importe de la recarga debe estar entre 0,1 y 100000000.`,
"label.select.relatedlist.approval.layout":`Seleccione las listas relativas para demostrar en el dise?o de la página de aprobación`,
"label.userphoto.thumbnail":`Miniatura`,
"label.assignment.setup.list.rulename":`Nombre de regla`,
"label.emailtemplate.usemergefields":`Campos fusionados en la plantilla de correo`,
"label.tabpage.enabletomobile":`¿Quiere habilitarlo en el dispositivo móvil?`,
"setup_layout_label_desc":`Descendente`,
"vue_label_pool_abandonreasondiscription":`Descripción del motivo del descarte`,
"label.ems.outputmails":`Enviar servidor de correo (SMTP)`,
"font-evaluate-module-v1-evall":`Todas las evaluaciones`,
"front-epwechat-module-v1-unbound-tips":`Los siguientes datos se borrarán después de la desvinculación:`,
"label.weixin.number.data":`Datos`,
"front-objectTemplate-V1-UseObject":`Objeto aplicable`,
"label.call.center.configuration":`Configuración de Call Center`,
"vue_label_systemSettings_website":`Portal web de atención al cliente`,
"lable.currencyAdv.foreverdate":`Fecha permanente`,
"label.globalselect.view":`Ver conjunto de valores de la lista de opciones`,
"component_newrecords_label_title":`Últimos registros`,
"component_assistant_label_title":`Ayudante`,
"label.equals.deletebut.bulk.delete":`Incluir botón de eliminación, eliminación masiva(Papelera de reciclaje)`,
"label.field.duplicate.error.msg4":`Error: Datos Inválidos.`,
"label.input.right.date":`Ingrese el formato de fecha válido`,
"file.error.notsel":`Error: por favor seleccione el archivo para subir`,
"label.customcomponent.page.add.title":`Crear nuevos componentes personalizados`,
"message.chooseatleastthreefield":`Seleccione por lo menos 3 campos`,
"label.dataimport.system.unnecessary":`, el sistema no puede determinar many `,
"message.login.wrong":`El nombre de usuario o contrase?a es incorrecto.`,
"label.appupload.install.recheck":`Revise de nuevo`,
"label.ems.option":`Opción`,
"label.wei.subject.img":`?cono del subjeto`,
"chatter.emailReceiveOrNotAccept":`Marque la opción para recibir recordatorio de CCChatter, si no marque, no recibirá.`,
"label.icon.46":`Horno`,
"label.newpw":`Nueva contrase?a`,
"font-evaluate-module-v1-praise":`El tipo de evaluación es Positivo`,
"label.help.user":`Guía del usuario`,
"label.callcenter.no.searchs":`No se ha encontrado información relevante`,
"UG_homepage_007":`Desde el envío de los correos de seguimiento hasta la automatización de campa?a de ventas, desde la creación del flujo de trabajo utilizando nuestra tecnología Blueprint hasta el trigger de los macros personalizados,la automatización de las tareas diarias y la concentración en establecer las relaciones.`,
"label.saveandnew":`Guardar y Nuevo`,
"component_salesperformance_label_70finish":`Finalizado-no procesado(>70%)`,
"lable.account.dp":`Esta página le permite definir el a?o fiscal personalizado.`,
"label.notification.serviceappointment.injeopardy":`{1}{0} está en estado crítico. Por favor, procese lo antes posible`,
"label.workflow.edit.esimaterule":`Error: No puede cambiar los criterios de evaluación a ¨cada vez cree o edite registro¨ cuando tiene triggers asociados con esta regla`,
"label.partnerCloud.basicSetting.feature":`Ajustes funcionales`,
"label.sms.companyname.gm.infor":`C.M.W.L.SMS Info (Este servicio sólo sirve para China Continental)`,
"vue_label_homepage_components":`Seleccione los componente`,
"label_chatter_allactivity":`Todos los eventos`,
"label.quickcreate.title":`Crear rápido del dise?o`,
"label.tabpage.exclusivez":`No incluye`,
"front-service-cloud-transfer-desc":`Al transferir el propietario de la lista de materiales del activo, el activo actual y los activos propios bajo el activo se cambiarán de propietario`,
"label.data.downpage.i.list.desc1":`Durante la importación, los datos que no pudieron ser importados con éxito debido a que los datos tienen un formato incorrecto, o que falla el disparador o la validación, generan un archivo CSV y se mostrará en la página actual. Los datos importados con éxito no se mostrarán en la página actual.`,
"template.report.individual.case.status":`Estado de los casos`,
"label.report.export.file.format":`Formato: Excel .csv`,
"vue_label_filternotice1":`Cumplir todas las condiciones del filtro al mismo tiempo, por ejemplo: 1 Oportunidad de negocio con un importe superior a 1 millón, 2 Oportunidad de negocio con una fecha de contrato estimada igual a este mes, y el resultado de la selección muestra oportunidades de negocio superiores a 1 millón de este mes; cuando <spanstyle="color:red"> el filtro avanzado está activado</span>, se necesita introducir manualmente las condiciones en el cuadro del filtro avanzado`,
"label.lead.score.confirm1":`Esto puede llevar varios minutos. Recibirá un correo electrónico de confirmación una vez completado.`,
"label.scores":`Puntuaciones`,
"label.dashboard.message.mainnoset":`No se ha configurado el cuadro de mandos de la página de inicio`,
"label.customfields.optionlist.fieldvaluelist":`Ingrese valores para los campos de lista de opciones al siguiente, cada valor se separa por una línea nueva`,
"label.autosearch.title":`Completar la búsqueda de títulos automáticamente`,
"label.knowledge.setting.hint.seventeen":`Crear algunos artículos`,
"label_tabpage_closez":`Cerrar`,
"label.partnerCloud.orderingPlatform.shoppingCart":`Carrito`,
"label.recalculate":`Recalcular`,
"label.umeng.approval.approvalmes4obj":`#numsucc registros fueron aprobados en #obj, #numfailed reocrds no fueron aprobados.`,
"label.appointment.wizard.subtitle2-2":`A`,
"label.validate.function.funcExplain.AND":`Revise si todos los parámetros son verdaderos, si todos son verdaderos, ingresará TRUE`,
"label.recordtype.batchaddattachments.remark":`Paso 1. Seleccione archivo, Paso 2. Archivar, Paso 3. Haga clic en ¨Subir¨ para cargar archivos, Paso 4. Haga clic en ¨Completar¨ para regresar a la página anterior`,
"label.reportlist.findreport":`Buscar informes`,
"label.partnerCloud.financeSetting.enterAppsecret":`Por favor, introduzca el Appsecret`,
"label.campagin.roi.query2":`Ver ROI de las canales de marketing`,
"label.sendmail.notice.immediately":`Enviar las notificaciones por correo`,
"label.file.library.managemembers1":`Gestionar miembros`,
"label.forecast.customforecast.foredis.yclb":`Categoría de previsiones`,
"label.no.target.model.available.":`No hay modelo de indicador disponible. Por favor, cree primero un modelo de indicador o póngase en contacto con el administrador del sistema.`,
"label.quote.contactname":`Nombre de contacto`,
"label.customer.tab.step2.same":`Aplicar una visibilidad de pesta?a a todos los perfiles`,
"UG_product_03":`Manual de precios con múltiples monedas disponibles`,
"label.pc.system.prompt":`Mensaje del Sistema`,
"homepage.components.description":`Descripción de los componentes`,
"front-email-payment-safety-code":`Código de seguridad`,
"label.the.extra.reward.group.describes":`Añadir descripción del grupo de filas de oferta`,
"label.isEnableVisualpage.new.rightlist":`Páginas personalizadas habilitadas`,
"label.icon.84":`Transformador`,
"label.chat.message.to":`Destinatario`,
"lable.product.pricebooks.edit":`Editar la lista de precios`,
"label.partner.workspace.member.belong":`Pertenece a`,
"pagecreator_systemstyle_message_delete_success":`Eliminación de estilo exitosa`,
"label.salescloud.teamrole.message.chooseatleastone":`Por favor seleccione por lo menos un usuario`,
"label.knowledgebase.self.window":`Ventana idéntica`,
"label.product.cost":`Precio original de ventas`,
"label.imgfield.remove":`Limpiar imágenes`,
"label.event.lastweek":`La semana pasada`,
"template.report.today.statistics":`Ventas de hoy`,
"label.emailobject.recipients":`Destinatarios({0}):`,
"vue_label_commonobjects_view_successfully":`Vista por defecto establecida con éxito`,
"label.uploadfail.typeerror":`Se falló en subir, el formato es incorrecto.`,
"vue_label_lead_required_fields":`Rellene los campos obligatorios`,
"front-console-reopen":`Reabrir`,
"message.layout.unique.relatedlist":`?Viola la restricción única de la lista relativa del dise?o de página, confirme y guarde de nuevo!`,
"label.emailobject.emaildetail.nextactivity":`Eventos siguientes`,
"label.publicgroup.save.error":`Error: uno de los grupos siguientes es grupo de padre de este grupo`,
"label.editdefaultshare.tip":`Editar la configuración del compartido predeterminado dentro del rango de su organización. Cambiar las configuraciones predeterminadas causará la recalculación de todas las reglas de compartido. Se requieren muchos recuersos y tiempo según la cantidad de datos de su organización.`,
"label.icon.53":`Coche`,
"label.exchange.sync.state.setting.m3":`Usuarios con correo vinculado de Microsoft Exchange y CloudCC:`,
"label.currency.enable":`Moneda: Activar moneda`,
"component.timeline.label.past":`Actividades pasadas`,
"workflow.action.tasks.assignortype.user":`Usuario`,
"setup_layout_label_relatedlistsetup":`Configuración de lista relativa`,
"label.systemadmin":`Administrador de sistema`,
"label_tabpage_allz":`Todo`,
"label.ems.subject":`Subjeto`,
"message.recordtype.selectlayout.tip":`Seleccione el dise?o de página que los usuarios con este perfil pueden ver con respecto al tipo de registros. Después de guardarlo, seleccione los valores de la lista de opciones que están disponibles con este tipo de registro.`,
"label.current.version":`Versión actual del programa`,
"label.sourceoffile":`Documento no traducido: Genere unos archivos con textos no traducidos separados por idiomas`,
"label.file.versionerror":`Utilice función del menú de archivo en la interfaz de versión nueva`,
"label.validate.function.funcExplain.MINUTE":`Devuelve el minuto del campo de fecha/tiempo`,
"abel.setup.mobile.bottombutton.profile.setting":`Personalizar el menú inferior del perfil`,
"label.recycle.dis.tip3":`Seleccione mi papelera de reciclaje de la lista desplegable para ver los ítems cancelados. Los administradores pueden seleccionar todas las papeleras de reciclaje para ver los datos de todas las organizaciones cancelados.`,
"message.selectnothing":`No seleccionado`,
"label.develop":`Desarrollar`,
"label.tab.lightningpage":`Página de la versión Lightning`,
"label.chat.micropost.share.info":`Compartir`,
"label.block.pricing.editor":`Editor de precios por bloque`,
"label.ccchat.file.unavailable":`El fichero no está disponible`,
"label_component_helper_businesschange_0UntreatActivity":`Oportunidades no procesadas`,
"label.search.setup.obj":`Puede configurar hasta 100 objetos`,
"component.setup.button.cancel":`Cancelar`,
"message.longtextareamaxlength":`La longitud no puede exceder 32,000 caracteres`,
"vue_label_chat_removedby":`Has sido expulsado del chat de grupo por el "Administrador"`,
"label.autoRegister.changepwd.setpwd.tip.morechar":`No puede ser menos de 8 caracteres`,
"label.informassigner":`Notificar persona asignada`,
"font-evaluate-module-v1-not-received":`No recibir nunca una evaluación de satisfacción de los contactos`,
"label.trigger.triggertime":`Hora de Trigger`,
"label.attendance.cannot.make":`No se puede marcar`,
"label.shouldallrecords":`Todos registros debe incluirse en el cálculo`,
"label.eidt.queue.alter1":`Seleccione los miembros de la cola`,
"L":`Lista de opciones`,
"label_emailtocloudcc_filed_email":`Correo`,
"label.productsales.contract.badversion":`Su versión acual no soporta objeto de contrato, no puede ver las cantidades del contrato`,
"label.tabpage.operation":`Acción`,
"label.file.copy.public.link":`El enlace público ha sido copiado`,
"label.all.SMS":`Todos los avisos por SMS`,
"UG_opportunity_008":`Grupo de oportunidades`,
"UG.Campaign.002":`Planificar, ejecutar y supervisar los resultados de la campaña`,
"label.jiandangfenpei.title":`Asignación de perfil`,
"pagecreator.systemstyle.message.delete":`¿Borrar el estilo actual seleccionado?`,
"lable.outlook.mcto.repeat":`Si encuentra registros de duplicados, el correo será asociado con el `,
"label.user.field":`Campos de usuario`,
"vue_label_commonobjects_detail_market_hierarchy":`Jerarquía del mercado`,
"label.ems.emails":`Correos`,
"label.tabpage.deleteviewfailed":`Error al eliminar vista`,
"label.data.exp.new.expobjtemp":`Crear la plantilla de exportar objeto`,
"label.useformulassetval":`Utilice fórmula para configurar valores nuevos`,
"label.service.newBuildDialog.six.fields":`Se pueden seleccionar hasta 6 campos`,
"error":`Error`,
"template.chart.sdyyfx":`Análisis de la razón perdida`,
"label.icon.191":`Bigote`,
"label.app.step3.tabused":`Pesta?as seleccionadas`,
"label.user.level":`Nivel de usuario`,
"label.custombutton.querydata.notexist":`Los datos no existen`,
"label.executestate.calculating":`Calculando...`,
"label.visualpage.folder.notdel2":`1. ?Esta carpeta contiene fichero y no se puede cancelar! 2. La carpeta contiene ficheros ocultos y no se puede cancelar. Un fichero oculto es creado del objeto de cancelación lógica (Cancelado de Configurar-Crear-Objetos) , que han sido ocultos porque no han sido cancelado verdaderamente. `,
"vue_label_report_conditiondesc_three":`Se le notificará si se cumplen todas las condiciones`,
"approval.request.email.subect":`Solicitud de aprobación`,
"label.log.user.value":`?Ingrese el nombre de usuario para buscar!`,
"label.isCompanyCurrency":`Empresa`,
"label.related.2018":`Listas relativas`,
"label.tonga.time":`Hora de Tonga`,
"message.actionfailed":`Error de operación`,
"label.’s":`De`,
"label.custombutton.queryobj.notnull":`El objeto ID de la búsqueda no puede está vacío`,
"label.list.userinterface.setup":`Interfaz de usuario`,
"front-kefu-moudle-v1-yxgsbzq-reinput":`El formato del correo electrónico es incorrecto. Por favor, vuelva a introducirlo`,
"label.chatter.content":`Contenido`,
"label.projectManagement.Addnotes":`Añadir notas`,
"label.service.newBuildDialog.reservation":`Mostrar reserva`,
"label.ccchat.pm":`PM`,
"vue_label_chat_cannot_invite_users":`No se puede invitar a otros usuarios si no es el propietario del grupo`,
"label_partner_workspace_member_belong":`Pertenece a`,
"label.task.modify":`Editar tarea`,
"label.tabpage.transformationsz":`Conversión`,
"label.new.password.no.indexof":`La nueva contraseña no puede contener caracteres chinos ni espacios.`,
"label.ji.quarter":`No. {a} Trimestre`,
"label.sso.isActiveNo":`No`,
"label.mobile.phone.week.report":`Reporte semanal`,
"label.email.template.please.select.folder":`Elija una carpeta`,
"label.pc.ui.2018.tab.groups":`Grupo de menú`,
"label.h5.approval.status":`Status de aprobación`,
"setup.mainpage.label.welcome27":`La plataforma en la nube CloudCC ofrece funciones como importar, exportar, borrar y transferir por lotes de todos los datos de los objetos del sistema.`,
"vue_label_systemSettings_setHomePage":`Configuración de la casa`,
"label.select.button":`Botones disponibles`,
"label_emailsync_status_enable":`Activar la vinculación`,
"label.trigger.triggerVersion.detail":`Este campo no se puede editar, hay dos versiones de triggers, 1.0 y 2.0, todos los triggers creados son Ver.2.0, Ver.1.0 ya se prohibe crear`,
"pagecreator_layout_message_save_fail":`Se frascasó en guardar el dise?o`,
"label.salescloud.salesdashboard.10big":`Las primeras 10 oportunidades en los próximos 3 meses`,
"label.file.share.size":`El recurso compartido máximo y enlace público de cada archivo es`,
"label.page.simple":`Simple`,
"pagecreator.page.message.delete":`¿Quiere borrar la página actual seleccionada?`,
"label.weixin.newspaper.coverage.detailinfo":`Detalles de informe de seguro`,
"label.list.userinterface.chattersetup":`Configuración de CCChatter`,
"lable.opppdt.addpdt.table.quantity":`Cantidad`,
"label.product.description":`Descripción del producto`,
"button_partner_back":`Regresar`,
"label.user.current.loginuser.sessionid":`Sesión ID del usuario actual`,
"label.otherreport":`Otros informes`,
"pagecreator_button_mobilepage":`Móvil`,
"label.mobile.phone.state":`Status`,
"lable.currencyManage.unenableCurrencyAdv":`Bloquear la gestión de moneda avanzada`,
"lable.product.addp":`Añadir precio`,
"label.field.validate.notpass":`No hay errores de sintaxis`,
"label.app.global.search.obj":`Puede configurar hasta 10 objetos para utilizar en la búsqueda global.`,
"label.group.archived":`Archivar`,
"vue_label_approve_to_submit":`Pendiente de entregar`,
"showfrom":`Mostrar de`,
"chatter.emailNotification":`Notificación del correo`,
"label.callcenter.pleaseenter.enterprise.number":`Por favor, introduzca el número de la empresa.`,
"label.forecast.customforecast.forecastnumber":`Número de previsiones`,
"label.vlidaterule.messagelocation":`Error de localidad`,
"label.h5.similar.opportunity.step3.conment":`Siempre se mostrará en las columnas relevantes que representa la cantidad de campos de combinación`,
"label.ccchat.group.gd.setting.info":`Modificar configuración del Grupo CCChatter`,
"label.knowledgebase.delete.article.succeeded":`Eliminar el artículo con éxito`,
"message.layout.edit":`La gestión del dise?o de página es una función separada de valor a?adido. Si su organización confirma que ha comprado el módulo, consulte al administrador del sistema para la contrase?a. Contacte con CloudCC.com por más detalles.`,
"label.case.create":`Se crea el caso ({0})`,
"label.icon.170":`Compras`,
"message.error.contact.null":`El contacto no puede estar vacío`,
"label.appupload.install.error.hasinstalled":`Este paquete de software se ha instalado en su organización. Antes de instalar la nueva versión, necesite desinstalar la versión antigua.`,
"label.service.miniProgram.imageType":`Se admiten los formatos PNG, JPG y JPEG. Se recomienda utilizar imágenes de 750*349 píxeles. Pase el ratón por encima de la imagen para volver a cargarla o eliminarla.`,
"label.leadscore.rule.edit":`Puntuación de candidatos: Regla de editación`,
"vue_label_commonobject_anytime":`Cualquier momento`,
"label.clearing.conditions":`Borrar condiciones`,
"label.campagin.roi.ydkhjhze":`Monto total para conseguir oportunidades de cliente`,
"Lead_Auto_Scoring_Setting_001":`Puntuación automática al guardar o editar los candidatos. (Excluye la importación masiva y creación de interfaz)`,
"pagecreator.systemstyle.label.buttonareacolor":`Color del área de operación`,
"label.batchregist.huanxinuser.finish":`Registro masivo de los usuarios se ha finalizado`,
"UG_opportunity_006":`Genio de oportunidad`,
"message.serviceappo.violation":`Violación del tiempo de asignación: está en conflicto con otra cita de servicio`,
"label.recordtypeselect.selectnew":`Seleccione el nuevo tipo de registro`,
"Lead.Tools.BatchScoring":`Puntuación por lotes de clientes potenciales`,
"label.partnerCloud.financeSetting.enterWechat":`Por favor, introduzca la cuenta comercial de WeChat.`,
"label.philippine.time":`Hora de Filipinas`,
"five":`Cinco`,
"label_average_value":`Media`,
"message.realdelete":`?Está seguro de que quiere cancelar completamente?`,
"label.currency.note":`Ingresar información de nueva moneda. Tenga en cuenta de que no se puede cancelar la moneda una vez la active.`,
"label.projectManagement.delete.prompt":`Notificación de eliminación`,
"label.approval.present":`(Actual)`,
"label.escalation.setup.newrule.name":`Nombre de regla`,
"label.edit.list":`Lista relativa editable`,
"label.partnerCloud.financeSetting.informationOne":`1. Visite el centro comercial de Alipay (b.alipay.com) e inicie sesión con el suscriptor de Alipay.`,
"label.customfields.numberText":`2. La suma de la longtitud de los números introducidos y el número de decimales no se puede exceder 18 dígitos`,
"label.biaoqing.businessverify.relation.tip":`Escribe el valor devuelto de bid&tender en el campo lead`,
"label.icon.149":`Robot`,
"System.btn.SaveAndCommit":`Guardar y enviar`,
"label.calendar.many":`Múltiples usuarios`,
"label.ccchat.create.email":`El correo electrónico ha sido creado`,
"template.report.income.marketing.activities":`Informe de ingresos de la campaña`,
"label.ccchat.person.invite.needemail":`Ingrese un correo`,
"template.report.open.amount":`Importe no cerrado`,
"label.currentoperate":`Operaciones existentes`,
"label.finalapprove":`Aprobación final`,
"label.emailmerge.mergepage.step2":`2. Seleccione la plantilla para combinarse, 20 al máximo:`,
"label_tabpage_sorttypez":`Ordenado por tipo`,
"label.workbanch":`Mi mesa de trabajo`,
"font-evaluate-module-v1-disable":`¿Está seguro de desactivar esto？`,
"label.ServiceCloud.distributionMap":`Mapa de distribución`,
"lable.Confirm.potential.customers":`Confirmar la recogida de {num} clientes potenciales`,
"label.mobile.quickcreate.default.nearby":`Cerca`,
"label.isremider.noremider":`No recordar`,
"label.approval.select.step":`Seleccione el paso de aprobación a devolver`,
"chatter.error.pm":`?Error: El archivo subido es demasiado grande!`,
"UG_activity_08":`Reservar una programa`,
"label.marketsea.notwinopportunitydays":`días sin transacción (tiene que ser mayor que el número de días sin crear una oportunidad de negocio)`,
"label.selectpage":`Seleccione una página existente`,
"label.dashboard.dispalyOnTheHomePage":`Página oficial mostrada`,
"front-lightning-module-v1-details-page-chart-set-report":`Configurar el informe`,
"vue_label_pool_mydeal":`Mis tratos`,
"vue_label_report_lastone":`El último`,
"label.tabpage.potentialcustomersz":`Cliente potencial`,
"font-evaluate-module-v1-more-satisfied":`No somos lo suficientemente buenos。 ¡Haremos que esté más satisfecho la próxima vez!`,
"label.trigger.instructions":`<font color = "red"> Nota: La capacidad máxima del código de trigger es de 200 KB de caracteres y aproximadamente 200,000 bytes. </ font> <font size = 3 color = "red"> </ font>`,
"lable.SalesCommitmentKanBan.commitmentToCompletionRate":`Tasa de finalización de compromiso`,
"label.umeng.approval.dlsp.approvenew":`Aprobación de proxy : #actorname está solicitando el permiso#objapiname#recordname`,
"label.edit.visualpagefolder":`Página personalizada: Editar carpeta`,
"label.pc.flash.teach":`Ense?anza de video`,
"label.showsearch":`Mostrar búsqueda`,
"label.reportsSubscriptionPage.condition.title1":`Se le notificará cuando se cumplan todas las condiciones`,
"label.h5.search.result":`Resultado`,
"vue_label_commonobjects_view_chart_pie":`Gráfico circular`,
"label_please_enter_currency":`Introduzca la moneda`,
"chatter.share.to.profile":`Su perfil`,
"label.mykeeptouchset":`Configuración de mis contactos`,
"label.profile.mustcopyaprofile":`Debe seleccionar un perfil existente para copiarlo.`,
"label.managereport":`Gestionar informes`,
"label.total.choice":`archivos, se han seleccionado`,
"label_emailtocloudcc_help":`Ingrese la contrase?a de correo o código de autorización. Si el servidor de su correo necesita activar el servicio IMAP/SMTP para ingresar desde una cuenta de los terceros, debe ingresar primero a su correo para asegurarse de que este servicio ha activado, y copiar el código de autorización correspondiente a este cuadro.`,
"label.trigger.sel":`Triggers en esta carpeta`,
"label.dashboardLookUp":`Ver paneles`,
"label.batchadd.newbatchpage.save.emptytext":`Revise si hay información obligatoria que no se rellene`,
"setup.mainpage.label.welcome16":`Instrucciones: Haga clic en el menú de la izquierda de la página → Configuración de la aplicación → Crear → Flujo de trabajo, Proceso de aprobación, Tareas, Notificar por correo electrónico, Actualización de campos, etc.`,
"vue_label_email_mark as":`Marcar como`,
"label.customobjdel.cannot.delete.try":`No se puede cancelar porque está asociado con las relaciones siguientes de otros objetos.`,
"label.customsetting.visible.public":`Público`,
"label.log.bit":`Dígitos`,
"label.data.exportall.all.desc":`Exportar todos los datos de todos los objetos que el usuario tiene acceso actualmente.`,
"message.login.mfadevice.already.bound":`El usuario ha vinculado con el dispositivo MFA`,
"label.campaign.channel.please.img":`Suba la imagen`,
"assetbom.manage.notpermission":`Póngase en contacto con su administrador para habilitar el acceso a BOM`,
"schedstarttime.schedendtime.time.illegal":`La hora de inicio programada de la cita de servicio debe ser menor o igual a la hora de finalización real.`,
"label.referperson":`Propietario`,
"front-email-payment-area":`Distrito`,
"label.c.d.least":`Cada registro "C" debe tener al menos un registro "D" relacionado.`,
"label.weixin.longitude.isnull":`La longitud y latitud están vacías o son inválidas`,
"setup.layout.button.ok":`Confirmar`,
"vue_label_fiter_component_date_customdate":`Fecha personalizada`,
"label.enable.case.createarticle":`Permitir a los usuarios crear artículos a partir de casos`,
"label.event.moveup.8hour":`8 horas por delante`,
"label.input.most.string":`Ingrese hasta {0} caracteres`,
"lable.SalesCommitmentKanBan.contractEndDate":`Fecha finalizada del contrato`,
"label.visualpage.function.name":`Nombre de la función será:`,
"label_emailtocloudcc_redmessage1":`Correo inválido`,
"message.aliasnameinput":`Error: El nombre debe ser único y comenzar con una letra. Debe contener sólo letras y números.`,
"label.data.exp.selectedtemp":`Seleccione la plantilla utilizada para exportar datos`,
"label.import.page1.suitedwayoflinkman":`Forma de emparejamiento con el contacto`,
"label.customsetting":`Configuraciones personalizadas`,
"label.versiontype.Free":`Versión gratis`,
"setup.layout.label.norelatedlist":`No hay listas relacionadas`,
"label.forecast.edittotal.de.leiji":`Acumulación de`,
"label.customfields.file.max":`El archivo subido es demasiado grande, no exceda a 5M.`,
"label_partner_all_workspace":`?rea de trabajo`,
"label.searchrelation":`Relación de búsqueda`,
"label.icon.185":`Consultivo`,
"label.service.gantt.effective":`Válido`,
"label.newreportstp1":`Paso 1: Seleccione el formato del informe`,
"label.category.9":`Fabricación`,
"label.zuowei":`Como`,
"front-quotation-v1-select-quota":`Seleccione un presupuesto`,
"label.dashboard.refresh":`Refrescar`,
"label.weixin.saveandnew.log":`Guardar y Crear log`,
"label.report.list":`Lista de informe`,
"FL":`Archivo`,
"label.h5.followingcolleagues":`Colegas seguidos con atención`,
"template.report.conversions.number":`Número de conversiones de clientes potenciales (por propietario)`,
"label.validate.function.funcFormat.MONTH":`MONTH(fecha)`,
"front-kefu-moudle-v1-tenant-ID":`Identificación del arrendatario`,
"label.reportsSubscriptionPage.schedulereport.monthly.time":`Tiempo`,
"label.multilang.workflow.everyotherday":`Cada {0} días`,
"label.chat.message.send.message":`Enviar información`,
"label.knowledgebase.fast.operation.error":`Error de funcionamiento rápido`,
"label.multilang.dupicatecheck.dumplicatedata":`En el registro de {0}, hay un total de  {1} grupos de datos repetidos que satisfacen las condiciones, la consulta se lleva  {2} milisegundos. Cada página muestra los datos de {3} grupos.`,
"vue_label_report_addFile_detail_Information":`2000 detalles exportados. Utilice estos datos para realizar cálculos adicionales o para cargarlos en otros sistemas.`,
"label.ccchat.message.search.desc3":`Indicaciones de búsqueda`,
"message.deletereport.prompt":`No puede cancelar este reporte`,
"pagecreator.page.message.save.success":`Página guardada con éxito`,
"vue_label_rise":`Ascender`,
"label.appupload.install.error.choicehead":`?Qué hacer si los componentes existentes en el sistema tiene conflicto con los instalados?`,
"message.dispatch.violation":`Violación del tiempo de asignación: el período de asignación no está dentro del tiempo de trabajo de los recursos`,
"label.tool":`Herramientas`,
"label.sso.saml.idp.downloadcert":`Descargar certificado`,
"label.chatter.detailinfo":`Información detallada`,
"label.area.tree":`Vista de ?rbol de Jerarquía Regional`,
"label.partnerCloud.priceOfManual.notEnabled":`No activar`,
"label.chosesubject.call":`Llamar`,
"label.leadscore.rule.detail":`Puntuación de clientes potenciales: Detalle de la regla`,
"front-welcome-to-try":`Acoge el juicio`,
"label.umeng.activity.event.willbegin1":`Evento #event empezará en #time.`,
"component.event.label.noevent":`Parece que ya ha completado tu trabajo por hoy.`,
"label.document.templatesetof.folder":`Conjunto de plantilla de carpeta`,
"label.quickbooks.none":`Sin datos coincidentes, ingrese un nombre para buscar o cree un cliente nuevo`,
"label.assignment.setup.newrule.inputrule":`Ingrese el nombre de regla de asignación`,
"label.appointmentdetail.wizard.title4":`Nombre de empresa`,
"label.malaysia.time":`Hora de Malasia`,
"label.partnerCloud.partnerAccount.way":`Método de recarga`,
"label.roleoflinkman":`Rol de contacto`,
"mesage.error.role.delate.user":`No puede cancelar rol porque asignaron usuarios para el rol actual.`,
"chatter.warning":`?Alerta: si seleccione un objeto diferente, los cambios no se guardarán, estás seguro de continuar?`,
"label.service.gantt.violations.sum":`Citas de servicio con infracciones`,
"label.permission.objectpermission.recordfenpei1":`Los tipos del registros asignados`,
"label.mobile.phone.required.plan":`Plan es obligatorio`,
"label.after_leaving":`Los datos actuales no se guardarán después de salir`,
"label.cpq.opportunity.mainquote.trasnfer.order":`Ha habido una cotización primaria bajo la oportunidad y se ha transferido al orden.`,
"component.setup.iframe.label.title":`Página personalizada`,
"visit.dispatchplatform.nopermission":`Permiso denegado: No está autorizado a acceder a la plataforma de asignación. Por favor, póngase en contacto con el administrador.`,
"label.validate.function.funcExplain.RIGHT":`Regrese a los números específicos de caracteres del final de un texto`,
"component.chatter.link.button.save":`Publicar`,
"label.knowledge.selection":`Cada Conocimiento tiene un máximo de 8 grupos de datos que pueden ser seleccionados.`,
"chatter.email.homePage":`Publica en la página oficial de mi CCChatter`,
"vue_label_commonobjects_view_copy_view":`Copiar vista`,
"label.documentmessage":`Detalles de documento`,
"label.emailtocloudcc.step1":`Paso 1`,
"label.user.mfa.unbind":`Desbloquear MFA a los usuarios seleccionados`,
"label.stdashbord.xsld.business.sdzje":`Monto total (Oportunidades perdidas)`,
"vue.please.select.the.total.method":`Seleccione el método de la suma del total`,
"label.stdashbord.xsld.business.img1":`Número de etapas con una probabilidad del 1% al 99%`,
"label.reportsSubscriptionPage.condition.title":`Además de la función de suscripción, también puede establecer condiciones en este informe. Se le notificará cuando se cumplan todas las condiciones. Esto es opcional.`,
"chatter.sel.field":`Error: Más de 20 campos son seleccionados .`,
"label.login.access.year":`A?o`,
"label.dashboard.all":`Todos los paneles`,
"label.approver":`Aprobador`,
"Lead.Homepage.Tools.BatchScoring":`Puntuar por lote`,
"lable.opppdt.selPdt.lesscondtions":`Menos filtros`,
"label.integrations.action.export":`Exportar`,
"label.datamanage.lookupandsure":`(Ver y confirmar)`,
"label.email.attach.to.mail":`Adjuntar al correo`,
"message.nodataordeleted":`Los datos no existen o han sido cancelado`,
"component_newrecords_label_all":`Ver todo`,
"lable.currencyAdv.startdate.rate":`Mostrar todas las tasas de cambio definidas de la fecha inicial bajo el rango siguiente`,
"label.callbackoperate":`Recordar operación`,
"label.knowledge.setting.hint.eighteen":`Comienza a crear un artículo para el conocimiento`,
"label.user.step4.submit.email":`Paso 4. Ha entregado su solicitud de enviar correo.`,
"label.appointment.wizard.subtitle4-1":`Tiempo de viaje entre eventos`,
"component.assistant.button.newtask":`Nueva tarea`,
"label.icon.129":`Tarjeta`,
"label.relatedlist":`Listas relacionadas`,
"label.report.recently":`Visto Recientemente`,
"label.batchadd":`Creación Masiva`,
"front-template-V1-Delete-succeeded":`"{currentTelmplateName}" se ha eliminado con éxito`,
"label.appupload.upload.otherdetail":`Detalles adicionales`,
"label.emailobject.link":`Enlace:`,
"label.quickbooks.createcustomer":`Cree nuevo cliente en QuickBooks`,
"report.label.projectcount":`proyectos, ordenados por los nombres de los informe`,
"vue_label_normal_contact_sf":`Contacto`,
"chatter.group.groupActivities":`Todos los grupos`,
"label_tabpage_addoptionsz":`Añadir opciones`,
"label.knowledgebase.submit.for.translation":`Enviar para su traducción`,
"vue_label_pool_notallowed":`La naturaleza del negocio no lo permite`,
"label.icon.80":`Fabricación De Papel`,
"label.readonlys":`Solo leído`,
"label.recordsediting":`Editabilidad del registro`,
"label.mr.title.email":`Correo`,
"label.partner.all.enable":`Activar`,
"label.customsetting.manage.errmessage":`Mantenga primero los campos personalizados antes de gestionar los datos`,
"label.cloudccclass.list.cls":`Clasificación`,
"label.weixin.click.loadall":`Haga clic para cargar todo`,
"label.weixin.appr.initialtime":`Tiempo iniciado`,
"UG_ST_002":`Confirmar`,
"setup_mainpage_label_welcome17":`Configuración de permisos`,
"label.appupload.state0":`No subido`,
"label.icon.115":`Casa`,
"setup_mainpage_label_welcome5":`Campo personalizado`,
"lable.custom.year.ovdate":`Fecha de fin del año personalizado`,
"label_tabpage_findz":`Buscar`,
"label.appupload.uploading":`Cargando...`,
"setup.mainpage.label.welcome1":`Se necesita el permiso correspondiente`,
"label.file.folder.delete2":`?Cancela la base de documentos?`,
"2018UI_Homepage_DataNoAccess_Info":`No tiene permiso para ver este registro, haga clic para regresar al paso anterior.`,
"label.ems.google":`Google`,
"label.hawaii.aleutian.standard.time":`Hora Estándar de Hawai`,
"template.report.unfinished.tasks":`Tareas no realizadas`,
"vue_label_calendar_add_calendar":`Añadir calendario`,
"label.button.sel.useremail":`Enviar correo a los usuarios seleccionados`,
"user.email.template":`Estimado {username}：<br>El código de invitación de la campaña [{Campaign.name}] es el siguiente: <br>{Campaign.ColleagueInvitationLetter}<br> El URL correspondiente es：<br>{Campaign.ColleagueInvitationLetterLink}<br>¡Esta campaña permite el registro mediante código QR y por vía URL! Gracias por su apoyo <br> Personal de campaña: {Campaign.Owner}`,
"label.forecast.settings.shouru":`Ingresos`,
"label.casesensitive":`Tratar "ABC" y "abc" como valores diferentes(Mayúsculas y minúsculas)`,
"message.pleaseinputrightdistanceweek":`Rellene el intervalo de semana correcto`,
"label.linellae-group":`Columna-Agrupación`,
"label.showdefault_times":`Mostrar la hora de publicación por defecto`,
"label.smstemplate.finishmessagedetailinfo":`Completar los detalles de la plantilla de SMS`,
"label.service.miniProgram.backgroundImage":`Imagen de fondo`,
"label.recentview.news":`Últimos registros`,
"label.reportType.chose.and.form":`Seleccione la fuente de datos y el formato del informe`,
"setup.layout.button.additem":`Añadir los elementos seleccionados`,
"front-epwechat-module-v1-auto-mate":`Automatch`,
"vue_label_helpcenter_contract&plan":`Un contrato es un acuerdo escrito entre las partes. Muchas empresas utilizan los contratos para definir las condiciones para hacer negocios con otras empresas. Utilice Cloud CC para establecer y documentar los contratos existentes con sus clientes y oportunidades de negocio. Realice un seguimiento del contrato a través del proceso de aprobación.<br> Gestione sus transacciones y apoye a la función de los contratos a través de un plan de cobro.`,
"label_mobile_version_nonsupport_feature":`Esta función no es compatible con la versión actual. Por favor, actualice a la versión más reciente`,
"label.icon.44":`Fuego`,
"label.data.downpage.i.title.num3":`3. Antes de importar, asegúrese de importar todos los registros relacionados. Por ejemplo: si existe una relación de búsqueda entre los objetos que está importando actualmente y los contactos, debe importar primero los contactos y luego importar sus datos.`,
"label.mr.object.customer":`Clientes`,
"label.social.user.null":`La información del usuario de Social no puede estar vacía`,
"front-epwechat-module-v1-unbound-item2":` todos los datos de la configuración de la aplicación`,
"label.partnerCloud.partnerAccount.noempty":`El importe de la recarga no puede estar vacío.`,
"label.weixin.myapproval":`Mis aprobaciones`,
"label.data.setok.e_desc1":`Recibirá un mensaje del sistema una vez exporte con éxito, los datos exportados han sido guardados en el servidor en 48 horas, vaya lo antes posible a `,
"lable.batchadd.service.cfq.after":`Trigger(Después de insertar)`,
"label.umeng.activity.youhaveanevent":`Tiene un evento nuevo`,
"label_emailsync_status_connectaccounts":`Vincular cuenta de correo`,
"label.multilang.shenpi.count":`Un total de {0} registros:`,
"pagecreator.page.message.delete.fail":`Error al intentar borrar página`,
"label.version.sum.lookupmdfield":`Campo de relación Maestro-Detalle`,
"vue_label_pool_clueduplication":`Pista duplicada`,
"label.system.setup.log":`Historiales del comportamiento del sistema`,
"label.globaloperation.operationtype.send.e-mail":`Enviar correo electrónico`,
"vue_label_pricebook_entry":`Nueva entrada de la lista de precios`,
"label.forecast.forehistory.submit.date":`Entregar Fecha y Hora`,
"chatter.handle":`?Qué está haciendo?`,
"lable.SalesCommitmentKanBan.complete":`Cantidad completada`,
"label.weixin.upload.pictures":`Subir imagen`,
"label.create.document":`Nuevo documento`,
"vue_label_commonobjects_detail_unlockconfirm":`¿Está seguro de querer desbloquearlo?`,
"label.customer.page":`Menú de página personalizada`,
"button.partner.workspace.saveas":`Guardar como`,
"setup.layout.label.asc":`Ascendente`,
"label.ccpeak.folder.time":`Carpetas no archivadas de clase programada`,
"label_tabpage_includez":`Incluir`,
"label.custom.button":`Bontones personalizados`,
"label.weixin.binding":`Encuadernar`,
"P":`Porcentaje`,
"chatter.stop.n":`Deje de seguir este registro`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.wednesday":`Miércoles`,
"template.report.revenue.marketing.activities":`Ingresos de la campaña`,
"lable.SalesCommitmentKanBan.theActualReceipts":`Recibo actual`,
"vue_label_popularresults":`Resultados Destacados`,
"label.log.belongs":`Parte subordinada`,
"label.profile.remark":`Los usuarios con este perfil tiene permisos y el dise?o de la página siguiente. Los administradores pueden cambiar su perfil editando la información personal de usuarios`,
"label.appupload.component.type.button":`Botón`,
"label.partner.all.operate":`Operación`,
"vue_label_notice_modify_fail":`Modificación fallida`,
"label.icon.137":`Tierra`,
"front-dialog-module-v1-nosupport-copy":`No se admite la clonación`,
"label.integrations.mailchimp.massage3":`Autorización cancelada`,
"UG.opportunity.010":`Crear una transacción`,
"front-lightning-module-v1-details-page-chart-selecting-reports":` Sólo puede elegir informes públicos, es decir, informes con acceso para todos los usuarios, e informes públicos no archivados.`,
"System_btn_SaveAndCommit":`Guardar y enviar`,
"vue_label_dashboard_statisticaltype":`Seleccione el tipo de estadística`,
"label.mr.object.opportunity":`Oportunidades`,
"label.area.detail.remark":`Vista previa de los usurios bajo esta región`,
"label.view.sortview.index":`Número de orden`,
"label.mobile.quickcreate.default.events":`Eventos`,
"label.product.price":`Precio de venta`,
"label.leadmarketsea.edit.title":`Editar grupo público de clientes potenciales`,
"pagecreator.layout.button.edit":`Editar diseño`,
"label.addressee":`Destinatario`,
"label.movablesearchlayout":`Dise?o de búsqueda de actividad`,
"label.ems.confirm":`Confirmar`,
"vue_label_file_save_to_file":`Guardar en archivo`,
"component_chatter_button_more":`Ver más detalles`,
"label.ccdocument.hidden.trace":`Ocultar los historiales`,
"label.partnerCloud.maximumTwo":`Se admite un máximo de 2M de archivos.`,
"label.event.moveup.4hour":`4 horas de anticipación`,
"label.batchadd.save":`Se frascasó en añadir compartido`,
"label.passwordPolicy.setup.expireDate":`La contrase?a de los usuarios expiran en`,
"label.workflowrule":`Reglas del flujo de trabajo`,
"vue_label_notice_pleaseselecview":`Seleccione vista`,
"label.h5.chatter.colleagues":`Sobre los colegas`,
"lable.opppdt.addpdt.subtitle":`Añadir producto a`,
"label.data.import.setup.repeat.no":`No-Inserte todos los registros a mi perfil importado`,
"label.changeCorporate":`Cambiar moneda empresarial`,
"label.customfields.dateandtime.tip":`Permite a los usuarios ingresar un a fecha y hora, o seleccione fecha del calendario emergente. Cuando los usuarios hagan clic en la fecha emergente, la fecha y hora acutal serán ingresadas al campo Fecha/Hora.`,
"label.integrations.mailchimp.massage1":`Seleccione por lo menos un registro para exportar`,
"lable.PowerProcess.custom":`Basado en una condición personalizada`,
"label.service.editDialog.displays.service.appointmentsFordays":`Mostrar las citas de servicio de {before} días antes y {after} días después de la fecha de nivel`,
"label.Receivables.ActualMoneyTime":`Fecha de recibo real`,
"label.matrixreport.intro":`Los informes de matriz muestran datos de resumen calculados en términos horizontales y verticales en forma de cuadrícula.`,
"message.validation.isnotnumber":`Por favor ingrese el número correcto`,
"label.partner.workspace.member.search":`Buscar`,
"label.customfields.deletewill":`Cancelar este campo personalizado causará`,
"label.content":`Contenido`,
"component.setup.button.weburl":`URL externo`,
"setup.mainpage.label.welcome28":`Instrucciones: Haga clic en el menú de la izquierda de esta página → Ajustes de gestión → Gestión de datos → Importar y exportar datos, Transferir por lotes, Eliminar por lotes.`,
"label.related.setup":`Configuración de tareas y eventos`,
"label.weixin.sign":`Estimado, has iniciado sesión, no es necesario volver a hacerlo`,
"label.norecord":`No hay registros`,
"label.emailmerge.detail.emailtempldatemerge":`Plantilla de fusión de correo`,
"label_emailsync_status_role":`Rol`,
"label.mobileapp.modelsetting2":`Seleccione los módulos que satisfacen las necesidades comerciales de acuerdo con el escenario actual <br> Activado: Permite los módulos seleccionados mostrar en Más-Recomendación<br> Desactivado: Los módulos seleccionados no mostrarán en Más-Recomendación`,
"component.sendmail.label.title":`Enviar correo electrónico`,
"component_assistant_button_newevent":`Nuevo evento`,
"label.chatter.input":`Ingrese los contenidos relacionados`,
"message.error.view.operate.rtnlink":`Haga clic en <a href='javascript:history.back();'>Aquí</a> Regresa a la página anterior.`,
"lable.new.profile":`Nuevo perfil`,
"label.custom.field.null":`No disponible`,
"label.reportsSubscriptionPage.schedulereport.weekly.saturday":`Sábado`,
"label.stdashbord.xsld.business.img4":`Monto total de etapas con probabilidad de 100%`,
"pagecreator_layout_button_splitall":`Deshacer todos`,
"label.mobile.phone.total.amount":`Monto toal(Diez mil)`,
"label.ratifyhistory":`Historial de aprobación`,
"label.projectManagement.Antecedents":`Tarea previa`,
"label.projectManagement.Newserviceappointment":`Nueva cita de servicio`,
"label.delete.record.is.approval":`?Los registros que quiere cancelar están en el proceso de aprobación, está seguro de que desea cancelar?`,
"front-gantt-module-no-tasks-describe":`Puede ver cómo se organizan los elementos de trabajo a lo largo del tiempo, cómo se solapan y cómo se relacionan en el diagrama de Gantt.`,
"vue_label_visualize_data":`Los datos de TianYanCha están rellenados. Por favor, guarde los cambios.`,
"UG.activity.02":`Asignar tareas`,
"label.field.duplicate2":`No se permiten valores duplicados`,
"label.cloudccclass.list.tip":`Permite a los técnicos para desarrollar clasificaciones en CloudCC.com que se puede utilizar en la página personalizada y triggers`,
"before":`Antes de`,
"UG.ST.001":`Nota`,
"label_tabpage_userGuidez":`Guía de usuarios`,
"vue_label_account_looking_for":`Introduzca lo que desea buscar`,
"vue_label_calendar_notice_timecantmove":`La fecha de este calendario no se puede cambiar arrastrando`,
"label.mobile.phone.enter.summary":`Ingrese los resumenes`,
"label.object.api.existed":`El nombre de objeto API ya existe, cambie otro nombre de API`,
"label.weixin..xsld.order.by.time":`Ordena por la fecha cerrada`,
"label.h5.chatter.whether":`Si or no`,
"label.file.delete.success":`Los ficheros han sido cancelados con éxito`,
"label.imgfield.type.url.tip1":`El usuario puede ingresar el enlace que cita a la imagen, y configure el tama?o de imagen por a?adir &cimgSize=ancho, altura al enlace.`,
"label.tomanyrecords":`Más de 5,000 ítems en este formulario`,
"label.save.partnercloud":`Error al guardar Nube de Socios`,
"vue_label_homepage_fliteritems":`Opción de configuración del filtro`,
"pagecreator_page_button_new":`Nueva página`,
"label.sharerule.baseofcondition":`Basado en criterios`,
"label.dashboard.snapshot":`Instantánea de los paneles`,
"label.appointmentpage.wizard.subtitle1.1":`Elija la fecha y la hora`,
"label.reportsSubscriptionPage.condition.emailsummary":`Enviar solo informe`,
"chatter.group.showAll":`Mostrar todo`,
"label.tabpage.helpNavigationz":`Ayuda y navegación`,
"label.emailtocloudcc.button.back":`Cancelar`,
"approval_request_email_subect":`Solicitud de aprobación`,
"label.lookup.error":`Un error se ocurrió al buscar.`,
"label.publicgroup.save.groupisnull":`Los datos del grupo son nulos al guardarse, vuelva a guardar, si todavía hay error, contacte con su administrador`,
"label.pie":`Gráfico circular`,
"chatter.feed.is":`es una red corporativa que permite a sus usuarios trabajar juntos, hablar entre ellos y compartir información, todo en tiempo real.`,
"label.customfields.file.max5m":`El tama?o máximo del archivo es de 5M`,
"com.cloudcc.login.error.message.vaildauthfail":`Validación de inicio de sesión no válida`,
"label.profile.appsetuppermission":`Gestión de la configuración de la aplicación`,
"label.customfields.file.totalmax":`El archivo subido es demasiado grande, no exceda a 500M.`,
"label.sms.list":`Lista de información de la Interfaz SMS`,
"message.error.referencedcolumnIdnotexist":`Los campos referidos por el informe han sido cancelados, no se puede mostrar, contacte con el administrador para la ayuda.`,
"front-lightning-module-v1-details-page-chart-setting-chart":`Configurar el gráfico del informe`,
"label.recordtype.profile.enables":`Tipos de registro disponibles ahora`,
"chatter.this.n":`Este registro`,
"label.only.upload.file":`Solo se permite subir archivos jpg/png de no más de 500kb`,
"vue_label_lead_conversion_failed":`Conversión fallida`,
"label.file.share.file.success":`?Compartir los archivos con éxito!`,
"label.processsetting.delete.process":`¿Está seguro de que quiere eliminar el proceso?`,
"message.uniquenamevalidate":`Debe comenzar con letra, debe contener sólo letras, números, y guiones bajos.`,
"label.group.archived.desc.info":`Este grupo ha sido archivado, por eso no puede crear nueva publicación o compartir ficheros con este grupo. Activar el grupo permite el uso de todas las funciones.`,
"label.customer.maincontact":`Contacto principal`,
"label.appointment.wizard.subtitle1-9":`4h`,
"label_productline_income":`Ingresos de la serie de productos`,
"label.dashboardSetup.tz.ybb":`Saltar al panel`,
"label.recordowner":`Propietario del registro`,
"message.approval.othersdoing":`Los demás están operando este proceso, refresque para obtener las últimas noticias.`,
"Opportunity_Detailed_Phase_Label_002":`{0} días en la etapa actual`,
"label.field.validating.rule.isnot.passed":`La compilación de la regla de validación se frascasó, revise la sintaxis`,
"label.textmessage.fieldskong":`Algunos de los campos insertados en el mensaje son nulos, por favor edite y reenvíe.`,
"com.cloudcc.login.error.message.islocked":`Usuario bloqueado`,
"label.forecast.customforecast.foredis.debfb":`% Cuota`,
"lable.opppdt.selPbk.changepbk.worning":`Modificar el libro de precios de esta oportunidad, y el prodcto asociado con esta oportunidad se cancelará ?Está seguro que quiere cancelarlo?`,
"label.mr.backLookReData":`Regrese, ver la lista de datos duplicados`,
"label.quickbooks.searchqb":`Buscar QuickBooks`,
"label.service.gantt.searchSkills":`Búsqueda de habilidades`,
"label.account.Current.and.NexttFQ":`3 trimestre fiscal actual y futuro`,
"customer.notopen.chat":`La organización no ha activado la función de chat, por favor, póngase en contacto con el administrador`,
"vue_label_commonobjects_view_sum":`En total hay {total} registros`,
"label.partnerCloud.orderingPlatform.adjust":`Ajustar el pedido del producto`,
"label.emailmerge.mergeFolder.tips":`En esta página se puede generar un archivo de Microsoft Word con los datos de contacto. Por favor, elija las plantillas de correo electrónico que se van a fusionar, y se puede seleccionar un máximo de 20 plantillas.`,
"vue_label_ccchat_notice_deletecommentfail":`No se ha podido borrar el comentario`,
"label.emailsync.status":`Estado del correo electrónico del usuario`,
"label.forecast.forecastroleuserpage.desc":`Asignar una gerente de previsiones para este rol. Las previsiones subordinadas se agregarán a las previsones de gerente.`,
"label.step1.total4":`Paso 1 de 4`,
"front-kefu-moudle-confirm-fjcase":`¿Está seguro de dividir este caso`,
"label.icon.60":`Grua`,
"label.appointmentpage.wizard.subtitle3":`Ingrese sus informaciones`,
"label.loginservice.license.exceed.time":`La licencia ha expirado`,
"label.customcomponent.check.tag.lastrow":`La última línea debe ser`,
"label.product.code":`Código de producto`,
"label.salescloud.salesdashboard.phone":`Móvil`,
"label_please_input_price_list_price":`Introduzca el precio de lista de precios`,
"label.multilang.page3":`Página(s)`,
"label.file.lastmodifydate":`Tiempo modificado`,
"label.icon.121":`Computadora`,
"message.error.system.service.unknow":`?Servicio desconocido, contacte con el administrador!`,
"label.thesecond":`La segunda columna`,
"vue_label_report_conditiondesc_two":`Añadir condiciones a este informe`,
"label.exchange.serverUrl":`Dirección de servidor`,
"RL":`Referencia`,
"label.emailobject.emailsend.sendindividuallyprompt":`Cada recibo recibirá un mensaje sólo enviado a él. Está seguro？`,
"label.appointmentconfirmpage.wizard.subtitle4":`Participantes`,
"message.save.opportunity.team.save.failed":`El grupo de oportunidades se frascasó`,
"vue_labenl_normal_notice_share_success":`Compartido con éxito`,
"label.triggerfolder":`Carpetas de Trigger`,
"label.more":`Más`,
"label.file.num":`Cantidad`,
"label.dashboard.list.sortBy":`ítem(s), ordenado por hora de acceso`,
"c":`Monedas`,
"label.weixin.detail.edit":`Editar`,
"label.escalation.setup.newentries.step2":`Paso 2: Seleccione los criterios de esta regla`,
"label.report.error.prompt":`La configuración ha fallado. Sólo se admite el informe en serie con un conjunto de filas. Por favor, asegúrese de que es un informe público y que no se ha eliminado.`,
"label.notification.new":`Nuevo`,
"label_tabpage_releaseTourz":`Guía de publicación`,
"label.icon.41":`Posicionamiento`,
"label.sendsms.hello.new":`Hola, tiene un nuevo`,
"label.custom.combination":`Combine`,
"label.project.hit.fifteen":`Aviso de asignación de hitos`,
"label.campaign.channel.step6.mobile":`Generar página móvil`,
"label.goback.N.step":`Volver al paso N anterior`,
"label_partner_all_name":`Nombre de Nube de Socio`,
"label.usermanage.loginusername.exist":`El nombre de usuario ya existe.`,
"template.chart.cpxse":`Venta de productos`,
"chatter.feed.deletecomments":`?Está seguro de que quiere cancelar este comentario?`,
"label.list.userinterface.show.newrcords.enable":`Prohibir el uso de los registros más recientes`,
"label.sso.saml.idp.config.enablelogout":`Activar salir único`,
"label.file.library.create":`Nueva base de documentos`,
"label.event.moveup.half.day":`0.5 días con antelación`,
"label.stdashbord.xsld.business.jhzje":`Monto total de oportunidades`,
"label.partnerCloud.orderingPlatform.unitPrice":`Coste unitario`,
"label.recordtype.edit.attribute":`Propiedades Generales`,
"front-template-V1-TemplatePreview":`Vista previa de la plantilla`,
"label.tabpage.personalCenterz":`Centro personal`,
"label.setuplookuplayout":`Dise?o de búsqueda`,
"label.no.merge.records":`No hay registros para combinarse`,
"label.attachementNew.set2":`Paso 2. Si archiva`,
"label.publicgroup.detail.showmembers":`Ver miembros del grupo`,
"UG.Forcast.03":`Habilitar programa y ejecutar estrategias de negocio. <br>¡Le deseamos un feliz pronóstico!`,
"label.h5.manageprompt":`Seleccione algún menú para añadir a la página oficial, o haga clic en el ícono del menú para abrirlo`,
"label.icon.145":`Relacionado`,
"label.select":`Seleccionar`,
"label.publicgroup":`Grupos públicos`,
"label.customcomponent.usewhere.title":`Ubicación donde utilice los componentes:`,
"label.custom.page.button.name":`Nombre de botón`,
"pagecreator_layout_button_vertical":`Desmontaje vertical`,
"label.marketsea.autorecyclerule":`Reglas del reciclaje automático`,
"label.reportsSubscription.entrance.attachment":`Formato Excel .xlsx`,
"component_chatter_button_collect":`Guardar`,
"label.page.step2.of.step5":`Paso 2 de 5`,
"label.reportsSubscription.addfile.helptext":`Aquí puede establecer si se añaden o no informes adjuntos a los correos electrónicos de suscripción, así como el formato de los informes adjuntos`,
"label.oldpw":`Contrase?a antigua`,
"lable.SalesCommitmentKanBan.contractAmount":`Monto firmado`,
"lable.Bundle":`Paquete superior`,
"label.weixin.unit.million":`Unidad (diez mil yuanes)`,
"label.app.choseprofile":`Asignar perfil`,
"label_tabpage_editz":`Editar`,
"label.email.attachement.size.info":`El archivo no puede ser mayor que`,
"label.chatter.pastSevenday":`Los últimos 7 días`,
"label.weixin.end.later.start":`Fecha de finalización debe ser más tarde que la fecha del comienzo`,
"label.passwordPolicy.setup.lockoutPeriod":`Tiempo bloqueado`,
"pagecreator_page_funcpath":`/ Constructor / Lista de página`,
"label.emailobject.apperror":`No hay servicio disponible, contacte con el administrador`,
"label.custom.page.button.broadband":`Tama?o del botón (Píxel)`,
"label.weixin.contract.rate":`Tasa de logro de contratos`,
"label.brief.payments":`Pago`,
"lable.approvaldatamove.transfermsg":`Transferencia masiva de todas las solicitudes de aprobación pendientes a un nuevo usuario`,
"label.datamanage.account.namenull":`Notas: Si el nombre del cliente está vacío, el registro no se importará.`,
"lable.SalesCommitmentKanBan.allTotalPaymentAmount":`Monto total acumulado de cobros`,
"Opportunity_Detailed_Phase_Label_001":`Etapa`,
"vue_label_helpcenter_calendar2":`<br> Calendarios de objetos: Los calendarios que se crean con los objetos muestran los datos del campo de la fecha en la vista de calendario. Puede editar o eliminar calendarios de objetos y personalizar el color de cada calendario. <br> Nuevo evento<br>Puede crear un nuevo evento en la vista de calendario de dos maneras. <br>(1) Haga clic en el botón "Nuevo evento" en la esquina superior derecha de la vista de calendario para crear un nuevo evento. En un nuevo evento puede asociar el evento con otros objetos, como las oportunidades de negocio, seleccionando en los campos "Elementos relacionados" y "Nombre". Los registros de eventos asociados se sincronizarán en el módulo "Actividad" de la página de detalles de otros objetos. <br>(2) O puede crear un nuevo evento haciendo clic en la cuadrícula del calendario. <br>Nuevo calendario de objetos<br> Paso 1: Haga clic en la pestaña Calendario del menú de navegación para ir a la página de vista del Calendario. <br> Paso 2: Busque Mis calendarios en la parte derecha de la vista, haga clic en el icono junto a Mis calendarios y proceda en la ventana emergente de Nuevo calendario de objetos. <br> Paso 3: Comience por nombrar el calendario creado. Seleccione el objeto del que se basa el calendario, y seleccione los campos que determinan el contenido de la visualización del calendario: Campo de inicio, Filtro de vista, Mostrar campo. El "Campo de inicio" determina el rango de tiempo sobre el que se muestran los datos, puede filtrar los datos mediante "Filtro de vista", y "Mostrar campo" determina lo que se muestra en la entrada del calendario. <br> Otros calendarios<br> Los otros calendarios contienen los calendarios añadidos por otros usuarios. Puede añadir calendarios de personas que estén subordinadas a usted y que compartan calendario con usted. <br> Compartir mi calendario de eventos<br> Paso 1: Haga clic en la pestaña Calendario del menú de navegación para ir a la página de vista del Calendario. <br> Paso 2: Busque "Mis eventos" en el lado derecho de la vista de calendario bajo "Mis calendarios", haga clic en el botón desplegable a la derecha de "Mis eventos" y seleccione "Compartir calendario". <br> Paso 3: En la ventana emergente "Compartir calendario", seleccione los usuarios y los permisos de acceso con los que desea compartir el calendario. Además, también puede ver los registros del calendario compartido haciendo clic en "Quién tiene acceso actualmente" y eliminar los registros compartidos haciendo clic en el icono X a la derecha de los registros compartidos. <br> Una vez compartido el calendario, sus compañeros subordinados pueden añadir su calendario de eventos a otros calendarios y ver su calendario de eventos. <br> Añadir un calendario<br> Paso 1: Haga clic en la pestaña Calendario del menú de navegación para ir a la página de vista del Calendario. <br> Paso 2: Haga clic en el botón desplegable de otros calendarios en el lado derecho de la vista de calendario y seleccione "Añadir calendario". <br> Paso 3: En la ventana emergente de Calendarios compartidos, seleccione los calendarios de eventos de las personas que quiera añadir. Puede seleccionar los calendarios de eventos de sus subordinados, así como los calendarios de eventos compartidos con usted. Haga clic en "Añadir" para completar el proceso. <br> Eliminar el calendario añadido<br> Haga clic en el botón desplegable a la derecha del calendario que desea eliminar debajo de los otros calendarios y seleccione "Eliminar".`,
"label.callcenter.Seat.number":`Número de asiento`,
"vue_label_commonobjects_view_change_all_selected_records":`Cambiar todos los registros seleccionados`,
"label.user.notinuse":`Usuario no activado, contacte con el administrador`,
"label.usermanage.hasbeen.reached":`?Ha alcanzado al límite del número de usuarios licenciados, contacte con el proveedor del servicio para conseguir más licencias!`,
"vue_label_help_list":`Vista de la lista`,
"label.infomation.edit":`Editar informaciones generales`,
"label.ccchat.person.setting.info":``,
"label.sso.isDelete":`?Si cancela?`,
"label.unique.identification.number":`Código de identificación único`,
"label.weixin.no.pending.projects":`No hay ítems por aprobar`,
"label.projectManagement.Pleaseenteramember":`Introduzca un miembro`,
"label.salescloud.salesdashboard.visit":`Visitar`,
"label.weixin.user.registered":`Registro de usuario`,
"message.loginhistory.downloadcsv":`Descargue los historiales de login de los últimos seis meses. (CSV)`,
"label.icon.37":`Posicionamiento`,
"template.chart.schdyqyx":`Respuesta esperada de las campañas`,
"label.tel.ten":`Puede ingresar hasta 10 números de teléfono para enviar SMS, y cada número de telefóno serán separado por ¨;¨`,
"label.data.exp.objdata":`Exportará los datos de este objeto de acuerdo con las condiciones siguientes`,
"label.loginservice.after.use":`Después, se puede utilizar.`,
"pagecreator_systemstyle_message_delete":`?Si cancela el estilo actualmente seleccionado?`,
"label.globalselect.deleteerror":`Como el conjunto de valores de esta lista de opciones ha sido utilizado por los campos siguientes, no se puede cancelar temporalmente.`,
"label.department.add":`Añadir un nuevo departamento`,
"label.attendance.dingwei":`Localidad`,
"label.workflow.editrule":`Regla de edición`,
"lable.product.pecm":`?Ingrese la cantidad correcta!`,
"label.icon.182":`Maletín`,
"label.help.release.notes":`Publicar guía de CloudCC R7.1`,
"UG.product.05":`Importar producto`,
"label.email2":`Correo`,
"label.weekrepeat":`Repetición de semana`,
"label.mr.descreption.oneGroupReData2":`Conjunto(s)`,
"chatter.at.d":`Grado activo`,
"label.mr.descreption.oneGroupReData1":`Duplicados y proceso de combinación: total`,
"label.weixin.mobile.fly.android":`Compartir en Aplicación Móvil de Android`,
"label.brackets.right":`Paréntesis derecho`,
"message.recordtype.applytoAllProfiles":`Aplicar el dise?o de una página a todos los perfiles`,
"label.customcomponent.page.index.tip":`Similar a la forma en que trabaja la función en un lenguaje de programación, los componentes personalizados le permiten encapsular patrones de dise?o comunes y luego reutilizarlos en una o más páginas personalizadas.`,
"lable.List.properties":`Atributos de la lista`,
"label.fieldinfo":`Detalles de campo`,
"label.ems.error.fail":`Carga fallida, intente de nuevo o contacte con el administrador`,
"label_emailsync_form_email":`Correo`,
"lable.currencyManage.button.manageRate":`Gestionar monedas`,
"component_salesperformance_label_100finish":`Finalizado`,
"label.knowledgebase.data.assignment.failed":`{a} la asignación de datos ha fallado`,
"label.custom.buttonandlink.remark":`Seleccione modo: Pesta?a actual/Nueva pesta?a(Pesta?a actual: se abre bajo la pesta?a actual; Nueva pesta?a: Se abre una nueva pesta?a)`,
"label.list.userinterface.watermark.setup":`Ajuste de la marca de agua`,
"component_timeline_label_7daysahead":`7 días con anticipación`,
"label.sendemail.chat.replyinchat":`Comentario sobre las publicaciones`,
"component.salesperformance.label.title":`KPI de ventas`,
"label.data.downpage.e.list.desc2":`Una vez que se haya completado la exportación, recibirá un correo recordándole que los datos se han exportado con éxito.`,
"vue_label_campaign_fromclosedopprotunities":`Oportunidades cerradas de {sjcb}`,
"label.umeng.activity.taskviewed":`La tarea que ha asignado a #name fue visto`,
"vue_label_salesadvance_retentions":`Número de retención`,
"label.fieldtag":`Etiqueta del campo`,
"label.quickbooks.button.searchinquickbooks":`Buscar en QuickBooks`,
"label.quickbooks.viewlist.action":`Operación`,
"label.weixin.sysapp":`Aplicaciones de sistema`,
"label.approval.examine.level":`Aprobar y rechazar según el nivel de usuario, el nivel máximo de usuario es`,
"label.appupload.upload.error":`Esta aplicación no se puede instalar. Cancele la instalación o modifique el API de su sistema, y instale de nuevo.`,
"label.emailtemplate":`Plantilla de correo`,
"front-email-payment-Invoice-amount":`Importe de la factura`,
"label.viewselectedproducts":`Ver los productos seleccionados`,
"label.tianyancha.businessverify.openfirst":`Active primero la verificación de datos comerciales`,
"lable.SalesCommitmentKanBan.returnAList":`Regrese a la lista de colegas`,
"label.knowledgebase.nopublished.draft.translations":`No se ha publicado ni se ha hecho un borrador de la traducción`,
"vue_label_calendar_day_view":`Calendario-Vista por día`,
"label.globalselect.remark":`El conjunto de los valores de lista de opciones globales le permite compartir los valores entre objetos.`,
"label.orderby":`Ordenar por`,
"lable.weixin.LastaDaysFinished":`Completado en los últimos 7 días`,
"lable.currencyManage.Enabledadvcurrency.discripation":`Le permite mapear la tasa de cambio de moneda a  la tasa de cambio caducada en el rango de fecha específico. La tasa de cambio caducada se utiliza en las oportunidades, productos de oportunidad y informes relacionados con estos dos objetos. La tasa de cambio caducada no se puede aplicar a campos de otros campos u otro tipo de informe. Por ejemplo, en primero de enero la tasa de cambio es 1 USD equivale a 6.68 CNY, pero en 6 de febrero la tasa de cambio es 1 USD equivale a 6.70 CNY. Las oportunidades con la fecha de finalización entre 1 de enero a 6 de febrero utilizará la primera tasa de cambio (1 = 6.68), mientras las oportunidades con la fecha de finalización después de 6 de febrero utilizará la segunda tasa de cambio (1 = 6.70).`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.one":`Primera semana`,
"label.leadtoobjectfield":`Mapeo de campo personalizado de los candidatos`,
"label.dashboardSetup.shujuyuan":`Fuente de Datos`,
"label.tabpage.userz":`Usuario`,
"label.sms.companyname.dsf":`Configuración de SMS-1`,
"label.step2.total3":`Paso 2 de 3`,
"front-gantt-module-Drag-dropt- reorder-tasks":`Arrastre para reordenar las tareas.`,
"label.dashboard.snapshot.no.enabled":`La instantánea del panel no está activada`,
"label.dashboard.unit3":`Unidad: Unidad entera`,
"label.forecast.shrepage.desc2":`Los usuarios, roles y áreas con acceso compartido`,
"label.commonobjects.new":`Crear {eventName}`,
"label.view.nameonlyone":`Nombre único de la vista`,
"label.assignment.setup.newentries.user":`Usuarios`,
"label.otheremails":`Correos adicionales`,
"component_sendmail_button_send":`Enviar`,
"vue_label_accountpool":`Grupo público de clientes`,
"label.h5.approval.actortime":`Fecha de inicio`,
"message.approval.cannotsubmit":`No se puede enviar para aprobación.`,
"vue_label_pool_createdbyme":`Creado por mí`,
"label.change.event":`Vista de evento`,
"vue_label_homepage_personalpage":`Página personal`,
"label.new.collect.target":`Nuevo indicador agregado`,
"label.ServiceCloud.zichanxuhao":`Número de activo`,
"label.product.userl":`Columnas para todos los usuarios`,
"label.syslog":`Log del sistema`,
"label.reportcreatestatus":`Status de informe generado`,
"label.datamanage.account.novalue":`Nota: "El nombre del cliente" está vacío, el registro del cliente no se importará.`,
"label.letter.body":`Texto de la Invitación`,
"label.select.please":`Seleccione`,
"label.escalation.setup.entrydetail.description":`1. Haga clic en editar para cambiar las propiedades de ítems<br/>2. Haga clic en Nuevo para añadir operación de actualización.`,
"label.component.salesDashboard.nodata":`A?adir las oportunidades que está utilizando, y luego ingrese aquí para ver los rendimientos.`,
"vue_label_helpcenter_account":`En la información detallada, haga clic en el botón del diagrama de árbol junto al cliente para ver y comprender el diagrama de la jerarquía del cliente, y ver alguna información de campo de cada cliente.<br> Al cambiar el propietario de un cliente, puede elegir cambiar el propietario de las oportunidades de negocio relacionadas con el cliente, los casos y otras informaciones al mismo tiempo.`,
"front-kefu-moudle-v1-awshjzx-intelligent":`Centro de llamadas de servicios inteligentes de AWS`,
"label.productby":`Generado por`,
"label.operation.date":`Fecha de operación`,
"label.name.donot.delete":`Nombre no se puede cancelar`,
"label.validate.function.funcFormat.DATETIMEVALUE":`DATETIMEVALUE(date)`,
"label.escalation.setup.entrydetail.howescalationtime":`Cómo configurar la hora de actualización`,
"label.view.step2":`Paso 2. Especificar los criterios de filtro`,
"lable.outlook.edit.notnull":`El campo de nombre no puede está vacío`,
"label.knowledgebase.createnewbrowser":`Nueva pestaña del navegador`,
"label.partner.all.name":`Nombre de nube de socios`,
"chatter.group.groupSetUp":`Configuración de grupo`,
"label.reportlist.findfolder":`Buscar carpeta...`,
"component.setup.tabs.label.title":`Paginación Tab`,
"label.passwordPolicy.setup.pswComplexReq":`Requisito del complejo de contrase?a`,
"label.emaildocument":`Enviar un documento via correo`,
"message.selectgsummaryconditon":`Seleccione los criterios de resumen`,
"component_todaytask_label_notask":`Hoy no hay tareas vencidas, tome un café.`,
"label.user.organization.notexists":`?La organización no existe!`,
"label.isEnableVisualpage.new.leftlist":`Páginas personalizadas habilitadas`,
"label.mobile.phone.write.week.report":`Escribir reporte semanal`,
"label.emailmerge.edittemplate.edit":`Editar la plantilla de fusionar correo`,
"template.dashboard.folder.sales.manage":`Gestión de ventas`,
"label.confirm.order.productsToassets":`¿Está seguro de que quiere convertir el producto de la orden en activo?`,
"label.service.dispatchingUnits.leftRight.total":`Actualmente hay {{ left }}-{ right }} registros, {{ totalCount }} registros en total`,
"label.import.step1.chooseidorother":`2. Puede elegir entre utilizar el ID o el nombre para hacer coincidir el registro y rellenar el campo de búsqueda. Si necesita el ID del registro correspondiente u otra información, puede crear un informe y establecer el nombre del registro y el ID del registro como columnas de grupo y luego exportar el informe.`,
"label_tabpage_completez":`Marque el status seleccionado como completado`,
"chatter.c.adr":`Dirección`,
"label.account.d":`Esta página le permite definir y editar el registro de trimestre personalizado. La fecha del trimestre personalizado se generará de acuerdo con sus opciones siguientes.`,
"label.tag.more50":`Se puede crear hasta 50 etiquetas`,
"setup.layout.label.areashow":`Ubicación del nombre del área`,
"label.partnerCloud.basicSetting.rebate":`Activar el reembolso`,
"label.tabpage.greaterequalz":`Mayor o igual que`,
"vue.please.select.the.aggregate.basis":`Seleccione el criterio de la suma del total`,
"label.form":`Formularios`,
"label.chatter.colleagues.list.beizhu":`Activar`,
"label.priority":`Prioridad`,
"vue_label_checkduplicate_set_repeat_rules":`Establecer reglas de duplicado`,
"label.share_form":`Comparta su formulario`,
"label_relation_shareholder":`Los accionistas y las filiales no pueden ser iguales`,
"label.project.hit.sixteen":`Recordatorio de caducidad de la emisión`,
"label.service.miniProgram.imageFormat":`Solo se pueden cargar imágenes en formato PNG, JPG y JPEG`,
"label.summary.mode":`Método de resumen`,
"vue_label_beforeverification":`Antes de la verificación`,
"label.data.newtemplate.desc":`Guardar los campos y criterios seleccionados por los usuarios como plantilla, si los usuarios repiten las operaciones con frecuencia, pueden exportar directamente via plantilla.`,
"lable.evaluation.badreview":`Bad`,
"label.total.tabs":`{0} Total {1}`,
"label.emailmerge.mergeFolder.foldertemplate":`Plantilla en esta carpeta`,
"vue_label_normal_notice_repeated":`Por favor, no añada repetidamente`,
"label.icon.140":`Datos`,
"label.fromonetoanother":`De un usuario a otro`,
"label.user.list":`Lista de usuarios`,
"label.file.prevent.share.operate":`Prevenir los demás que compartan o cancele el compartido`,
"label.app.detail":`Detalles de aplicación`,
"label.h5.similar.opportunity.correlation":`Relevancia`,
"label_emailtocloudcc_filed_username":`Nombre de usuario del correo`,
"vue_labe_account_shareholdingratio":`Ratio de participación`,
"label.data.dataexpalltype.all_desc3":`3. Los datos exportados con éxito generarán un archivo compresionado que los usuarios pueden descargar de la página de lista de exportación exitosa de acuerdo con información en el correo.`,
"label.callcenter.please.select .seatID":`Por favor, elija el número de asiento`,
"label.remark.length.cannot.than":`La longitud de descripción no puede exceder 255 caracteres`,
"label.batchtransfer.dateandtimetype.tip":`En cuanto a los campos de Fecha/Hora, ingrese el valor con el formato siguiente:`,
"label.component.helper.businesschange.0UntreatActivity":`Oportunidades sin actividades no procesadas`,
"front-project-module-v1-plase-input-start-time":`Por favor, introduzca la fecha de inicio`,
"label.event.moveup.6hour":`6 horas con antelación`,
"label.data.exp.tempexp":`Exportar por plantilla`,
"label.schedulejob.setup.schedule.afternoon":`PM`,
"label.ems.format":`Formato`,
"label.objectHasBeenDeleted":`Objetos cancelados`,
"label.ServiceCloud.chaxunchenggong":`Buscados con éxito`,
"label.campaign.channel.input.notice.owner":`Notificar el propietario`,
"label.bajisitan.time":`Hora de Pakistán`,
"label.warnMes":`?El objeto está referido, la cancelación se frascasó!`,
"lable.Up.to.ten.fields":`Elija un objeto y añada hasta 10 campos al gráfico. Haz clic en las flechas arriba y abajo para ordenar los campos.`,
"label.approverule":`Reglas de aprobación`,
"message.error.specific":`Devuelve un mensaje de error específico`,
"front-template-V1-saveUse":`Guardar y previsualizar`,
"label.uploadfile.success":`Subir con éxito`,
"label.tabname.donot.database.key":`?El nombre del menú no puede ser palabra clave de la base de datos!`,
"message.recordtype.selectlayout.select":`--Seleccionar el dise?o de página--`,
"front-detail-module-v1-list-cardview":`Vista de lista/tarjeta`,
"label.product.maintenance":`Mantenimiento`,
"vue_label_helpcenter_approve":`1. Proyectos a aprobar<br> Muestra todos los proyectos que necesitan su aprobación. Puede buscar los registros a aprobar por la fecha de inicio, la fecha de finalización, el remitente, el tipo de registro y los elementos relacionados con el registro de aprobación.<br> <br>Procesar un solo registro: Haga clic en el botón izquierdo de cada registro.<br> A. Aprobación<br> Paso 1: Haga clic en "Aprobar" para abrir la página de solicitud de aprobación<br> Paso 2: Haga clic en "Aprobar" o "Rechazar" para completar la operación.<br> Si el siguiente paso de la configuración del proceso de aprobación necesita seleccionar manualmente un aprobador, el paso 3 se ejecuta después de "Aprobar".<br> Paso 3: Seleccione el siguiente aprobador para completar la operación de aprobación.<br> Si necesita seleccionar el paso de retorno después de que la aprobación sea rechazada, complete el paso 4 después de "Rechazar".<br> Paso 4: seleccione el paso de aprobación que debe devolverse para completar la operación de aprobación.<br> B. Reasignación<br> Paso 1: Haga clic en "Reasignar"<br> Paso 2: Busque el reasignador<br> Paso 3: Haga clic en "Solicitud de aprobación de reasignación" para completar la operación.<br>Nota: Si usted es el aprobador adjunto de un registro, no puede realizar la operación de reasignación.<br> Procesamiento por lotes de registros: Después de seleccionar los elementos a aprobar, haga clic en el botón situado encima de la lista.<br> C. Aprobación<br> Paso 1: Seleccione los registros que se van a aprobar<br> Paso 2: Haga clic en "Aprobar"<br> Paso 3: Haga clic en "Aprobar" o "Rechazar" para completar la operación.<br> Si necesita seleccionar el paso de retorno después de que se rechace la aprobación, vaya al paso 4 después de "Rechazar".<br> Paso 4: Seleccione el paso de aprobación a devolver para completar la operación de aprobación.<br> D. Reasignación<br> Paso 1: Seleccione los registros a aprobar<br> Paso 2: Haga clic en "Reasignar"<br> Paso 3: Busque reasignadores<br> Paso 4: Haga clic en "Solicitud de aprobación de reasignación" para completar la operación.<br> 2. Proyectos presentados por mí<br> Muestra todos los proyectos aprobados que ha presentado. Puede buscar rápidamente el registro que desea ver a través de la fecha de inicio, la fecha de finalización, el remitente, el tipo de registro, los elementos relacionados y el estado de aprobación del registro de aprobación.<br> 3. Proyectos aprobados por mí<br> Muestra todos los proyectos aprobados que usted ha aprobado. Puede buscar rápidamente el registro que desea ver a través de la fecha de inicio, la fecha de finalización, el remitente, el tipo de registro, los elementos relacionados y el estado de aprobación del registro de aprobación.<br> 4. Proyectos rechazados por mí <br> Muestra todos los proyectos que ha rechazado. Puede buscar rápidamente el registro que desea ver a través de la fecha de inicio, la fecha de finalización, el remitente, el tipo de registro, los elementos relacionados y el estado de aprobación del registro de aprobación.`,
"label.knowledgebase.knowledge.article":`Artículo de conocimiento`,
"march":`Marzo`,
"label.accraditation":`Aprobar`,
"vue_label_pool_cantreach":`No se ha podido contactar con el cliente`,
"label.service.appointmentList.startOf.maturityPeriod":`Inicio del período de vencimiento`,
"message.huanxin.closed":`Función de chat inactivo`,
"label.implementation.time.operation":`Ejecutar trabajos programados`,
"label.setting.intergrationlist.permissions":`Permiso de integración`,
"label.translation.norecord":`No hay registros`,
"label.lack.expression":`Pérdida de expresión`,
"setup.layout.message.relatedlistfield":`Seleccione los campos que se mostrarán en la lista relacionada, también puede reordenar los campos seleccionados.`,
"label.group.file":`Archivos del grupo`,
"message.error.id.null":`No existe esa información de identificación`,
"label.a_b_least":`Cada registro ¨A¨ debe tener por lo mneos un registro ¨B¨ relacionado`,
"label.addattachment.step3":`Paso 4. Haga clic en el botón ¨Confirmar¨ para regresar a la página anterior`,
"label.data.exportsf":`Ficheros exportados`,
"label.callcenter.call.out":`Llamar a la puerta`,
"front-electronic-export-exportIntro":`Los datos seleccionados se exportarán a la lista de Mailchimp que hayas seleccionado`,
"label.custombutton.deletedata.notnull":`Los datos cancelados no puede estar vacíos`,
"UG.homepage.002":`Gestione sus pistas, clientes potenciales, embudos de ventas e información de clientes con herramientas comerciales integradas`,
"label.globaloperation":`Operación global`,
"label.icon.58":`Trabajador`,
"vue_label_salesadvance_lostrate":`Tasa de pérdida`,
"chatter.from":`De`,
"front-epwechat-module-v1-account-binding":`Vinculación a cuenta`,
"label.list.userinterface.old.page.setup":`Página antigua`,
"label.forecast.settings.periods":`&nbsp;ciclo(s)`,
"label.file.share.email.content":`#sharedBy ha compartido un fichero contigo en #orgname`,
"label.knowledge.category.hint.five":`Ajuste de la clasificación de datos`,
"setup.layout.label.selectedfield":`Seleccione los campos`,
"label_business_income":`Ingresos de oportunidad de negocio`,
"vue_label_display_options_field":`Mostrar campos de la lista de selección`,
"label.emailtocloudcc.set":`Configurar información del correo`,
"label.knowledge.setting.data.five":`Borrar categoría: {lbmc}`,
"front-epwechat-module-v1-bound-enterprise":`Empresa vinculada`,
"label.ccpeak.delete.recycle":`Los registros se cancelarán en la papelera de reciclaje`,
"label.leadconvers.tip":`Los candidatos no pueden convertirse en clientes, contactos, oportunidades ni pueden conseguir tareas siguientes, solo pueden convertirlos después de confirmar que los candidatos tengan valor. `,
"label.rsa.key.invalid":`La clave pública no es válida, por favor inicie sesión de nuevo`,
"label.mobile.bind.success":`Vincular con éxito`,
"label.emailtocloudcc.filed.servertype":`Tipo de servidor`,
"label.user.new":`Nuevo usuario`,
"label.setup.mobile.homepageshortcuts.remark":`Las organizaciones pueden configurar la función rápida mostrada en la parte superior de la página de acuerdo con el scenario comercial.`,
"label_emailtocloudcc_select2":`Seleccione el Tipo de Gráfico`,
"page.send.email":`Enviar correo`,
"label.service.newBuildDialog.field.display":`Campos a mostrar`,
"vue_label_homepage_card_impending":`Oportunidades próximas`,
"label.message.contactispartner.delete":`Hay socio asociado con este contacto, no se puede cancelar`,
"label.attendance.checkout":`Salir`,
"label.emailmerge.newtemplate.description":`Introduzca las informaciones sobre la combinación de la plantilla del correo. Las notas solo se muestran en CloudCC.com, no en Word.`,
"laebe.data.exp.success":`Después de la exportación exitosa, recibirá un aviso del correo de sistema, los datos exportados se guardan 48 horas temporalmente en el servidor, vaya a la página de lista de datos exportados para descargar sus datos. `,
"lable.Maximum.number":`Se permite un máximo de 50 caracteres para el nombre de la plantilla.`,
"label.projectManagement.drag.and.drop.existing.tasks":`Arrastrar una tarea existente a la categoría actual`,
"label.forecast.tree.desc":`La jerarquía de previsiones determinan como su organización acumula los valores de previsiones y quien puede ver y adjustarlos. Se ha generado automáticamente basándose en la jerarquía de su rol, pero puede a?adir o editar gerente, representante de ventas u otros usuarios según sus necesidades. También puede activar las previsiones compartidas para algunos usuarios.`,
"vue_label_chatter_upload_file_type":`Se ha seleccionado el post de archivo de carga`,
"front-lightning-module-v1-dashborad-analysis-dimension":`Dimensión de análisis`,
"vue_label_homepage_custom_homepage":`Página de inicio personalizada`,
"label.icon.39":`Posicionamiento`,
"label.appointmentpage.wizard.notif1":`?Seleccione tiempo primero!`,
"vue_label_report_filterby":`Filtrar por {screenCondition}`,
"label.argentina.time":`Hora argentina`,
"label.role.assign.notremove":`No se puede remover los usuarios de <b>Usuarios Seleccionados</b> a "Todos los Usuarios Activados pero No Asignados" o "Todos los Usuarios no Asignados".`,
"label.sharerule.detailsetshare":`Detalle de regla de compartido`,
"label.file.publicview.error1":`El archivo se ha cancelado o el enlace público es inválido`,
"label.data.downpage.e_title.num4":`4. Los ficheros de exportación tienen dos formatos: Formato CSV y formato compresionado. El último se divide en dos tipos: uno es generar automáticamente contrase?a del fichero compresionado, el otro es ingresar manualmente la contrase?a del fichero compresionado.`,
"label.knowledge.case.article":`Artículo sobre el caso`,
"label.data.newtemplate.e.conditions":`Condiciones de exportación`,
"front-object-change-owner":`El propietario del registro de listas relacionadas que corresponde a este propietario de cuenta también se cambiará al nuevo propietario`,
"label.newdashboardpage.edittitle":`Editar título`,
"label.datamove.end.query.no.record":`?Finalización de la búsqueda, no hay registros que alcance los requisitos!`,
"lable.SalesCommitmentKanBan.receiptsTarget":`Destino de recibos`,
"label.orderagain":`Reordenar`,
"vue_report_dashboard_transfer":`Mover carpeta`,
"label.view.sortview.default":`Vista predeterminada`,
"label.brasilia.time":`Hora de Brasilia`,
"label.industrialandcommercialverification.instructions":`Se puede iniciar la Verificación de los Datos Industriales y Comerciales para ayudar a los usuarios introducir informaciones de registro correctas industriales y comerciales. Tenga en cuenta que esta función solo permite la consulta de información de registro industrial y comercial en China continental.`,
"label.chatter":`Publicación de nube`,
"label.sso.goBackToList":`Ingrese a la lista: Gestión de clave`,
"label.mobile.side.tab.state":`Empezar barra lateral personalizada`,
"label.weixin.addbus":`Añadir vehículos`,
"label.dropbox.description":`Vincular su cuenta de DropBox para utilizar lo en CloudCC.`,
"label.service.newBuildDialog.available.tousers":`Establecer este filtro disponible para todos los usuarios`,
"label.knowledge.language.thai":`Tailandés`,
"label.passwordPolicy.setup.foreverlock":`Permanente(Debe ser reseteado por el administrador)`,
"label.bmap.unreported.location":`No comparte la información de ubicación. Configure en su cuenta oficial de WeChat.`,
"label.tag.field":`Etiquetas`,
"label.addyourlanguage":`Haga clic en ¨Añadir¨ para agregar los idiomas que su organización soporte.`,
"label.chat.topic.my.use":`Tema que utilizo`,
"UG.contact.06":`Importar contactos`,
"label.embed_code":`Código de inserción`,
"label.campaign.channel.input.chenben":`1. Costo actual:`,
"label.quickbooks.estimates":`Estimaciones`,
"label.report.items.i.created":`Reporte que he creado`,
"label.forecast.edit.fwqd":`Comienzo del rango`,
"label.validate.function.funcExplain.DATEVALUE":`Devuelve un campo de fecha (incluye año, mes y día) según el campo de fecha/tiempo introducido (incluyendo año, mes, día  el tiempo GMT)`,
"vue_label_helpcenter_calendar1.1":`Los eventos son una poderosa herramienta para entender las relaciones con clientes y asegurar las transacciones. Puede asociar los eventos con oportunidades, clientes potenciales, clientes y contactos. La vista de calendario muestra principalmente los registros de eventos.<br> 1. Vista de calendario y vista de lista<br> Ver calendario<br> Haga clic en la pestaña del Calendario del menú de navegación para acceder a la página del calendario. <br>Vista del calendario<br> Clasificación de las vistas del calendario: Las vistas de calendario pueden ser por mes, por semana, por día o por disponibilidad. Los datos registrados de diferentes rangos de tiempo se pueden mostrar a través de diferentes estilos de cuadrícula. La vista de disponibilidad muestra los datos diarios de cada calendario, incluyendo mi calendario y otros calendarios. Haga clic en el icono "botón de calendario" en la parte superior derecha de la página de calendario para cambiar de vista. <br> Contenido que se puede ver en la vista del calendario: El calendario incluye mi calendario y otros calendarios. Puede ver mi calendario en la vista de calendario, incluyendo todos los datos registrados de mi calendario de eventos y del calendario de objetos. Nos referimos a estos registros como "entradas del calendario". <br> Puede ver todos los eventos que tiene en la vista de calendario. El calendario que se crea con el objeto mostrará los datos como entradas de calendario en la vista de calendario en el campo de la fecha. También puede ver otros calendarios en la vista de calendario, es decir, puede ver cualquier entrada de calendario compartida por sus colegas que haya añadido a la vista. <br>`,
"label.tabpage.rowsz":`Borrar fila`,
"label.file.library.managemembers.memberlist":`Miembros actuales`,
"label.report.action.addtodashboard4":`Añadir a los tableros existentes`,
"label.chat.send.voice":`Enviar un mensaje de voz`,
"label.home.dashboard.add":`Añadir paneles de la página ofical`,
"front-dialog-module-v1-copied-requestid":`El ID de la solicitud se clona`,
"label.customfields.exportdata":`Exportar los datos`,
"label.emailobject.signature":`Firma`,
"label.hide.source":`Ocultar código original`,
"label.icon.71":`Servicio`,
"vue_label_help_whatslightning":`¿Qué es un Lightning?`,
"report.type.label.systemReport":`Informe del sistema`,
"front-kefu-moudle-v1-input-email":`Por favor, introduzca la dirección de correo electrónico`,
"label.event.moveup.5minutes":`5 minutos con anticipación`,
"message.error.postsid.null":`El ID del puesto no puede estar vacío.`,
"UG.Account.05":`Diagrama de la estructura de contactos`,
"label_emailtocloudcc_description3":`Vincular con su correo de empresa, por ejemplo sales@company.com, info@company.com, support@company.com. El sistema generará candidatos o registro de caso según los correos recibidos para seguir a timpo los mensajes de cliente`,
"report.label.searchresult":`Resultados de la búsqueda`,
"vue_label_report_detailsonly_desc":`Exportar solo las líneas de detalle. Utilizar estos datos para realizar cálculos adicionales o para cargarlos en otros sistemas.`,
"label.partnerCloud.partnerAccount.payment":`Importe del pago:`,
"vue_label_commonobjects_view_select_member":`Seleccionar miembro`,
"label.emailtocloudcc.step1.lead1":`Enviar correo a Lead`,
"label.forecast.settings.current":`Período actual`,
"label.canceluploadfile":`Cancelar la carga`,
"label.manual.shared":`Compartir manualmente`,
"label.document.uniquename.length.cannot.than":`La longitud del nombre único del documento no puede exceder 255 caracteres`,
"vue_label_lead_notcreateopportunity":`No crear oportunidades`,
"APPIntegration.Social.twittererror":`Debe introducir una URL de twitter.com válida`,
"message.duplication.label.errormessage":`Error de mensaje`,
"label.file.img":`Imagen`,
"label.tabpage.sum":`Total`,
"label.permission.systempermission.fenpei":`Asignación de permisos`,
"template.dashboard.folder.data":`Análisis de datos`,
"label.sms.account":`Cuenta de usuario`,
"label.product.filter":`Filtro de productos`,
"label.file.content":`Contenido del texto`,
"label.percent":`Porcentaje`,
"label.single.attachment":`Individual`,
"label.processsetting.failed.enable.process":`No se ha podido activar el proceso`,
"label.view.modify":`Editar`,
"label.knowledgebase.enter.keywords.filter":`Por favor, introduzca las palabras clave para filtrar`,
"label.tabpage.uploadfailez":`Carga fallida, por favor, reinténtelo`,
"label.please.enter.the.target.model.name":`Introduzca el nombre del modelo de destino`,
"label.layout.availabletab.related":`Relacionado`,
"label.label":`Etiqueta`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.saturday":`Sábado`,
"label.addattachment.unit":`Byte`,
"vue_label_commonobjects_view_selected":`{Registro(s) seleccionado(s)`,
"label.view.sortview.printble":`Imprimible`,
"label.umeng.insert.approval.approvaling":`El #solicitante presenta el #obj#nombredelobj#propietario para su aprobación`,
"label.forecast.customforecast.tztotal":`Cantidad Total Ajustada`,
"label.ccchat.failtoset":`Error de configuración del ccchat`,
"label.ccchat.message.new.error2":`Usuario de CCChatter`,
"label.validate.function.category.Advanced":`Avanzado`,
"label.projectManagement.team.members":`Miembros del equipo`,
"vue_label_report_clickcrosstofliter":`Haga clic en el cruce de la tabla para filtrar los detalles.`,
"lable.opppdt.selPdt.leasttwenty":`Puede seleccionar hasta 25 líneas`,
"label.campaign.channel.download":`Descargar el Código QR HD`,
"component_event_label_person":`Persona asiganda`,
"vue_label_homepage_new_homepage":`Nueva página de inicio`,
"label.version.sum.vlidaterule":`Reglas de validación`,
"vue_label_chat_click_for_details":`Haga clic para más detalles`,
"label.fold":`Plegarse`,
"label.readonly":`Solo lectura`,
"label.h5.similar.opportunity.result":`Oportunidades similares`,
"label.yourimportsuc":`Su solicitud de importación ha sido procesada, revise su correo.`,
"label.report.line.yixuan":`Columna de informe seleccionada`,
"setup_layout_label_areaname":`Nombre de sesión`,
"label.forecast.edit.title":`Objetivo`,
"label.chatter.allweather":`En todo tiempo`,
"label.service.ganttBaiduMap.scheduled.endtime":`Fecha de finalización prevista`,
"lable.create.new.list":`Nueva lista`,
"label.emailobject.groupemail.msg3":`{0} destinatarios`,
"lable.opppdt.selPdt.description":`Introduzca palabra clave y los criterios de filtro, luego haga clic en ¨Buscar¨ para empezar la búsqueda. Haga clic en ¨Más filtros¨ para utilizar más de un filtro. El resultado incluirá todos los registros que coinciden con las palabras clave y criterios de filtro.`,
"label.file.versionerror1":`Puede hacer clic en el enlace siguiente para cambiar directamente al menú de archivo de la nueva interfaz, o puede utilizar la función del menú de archivo después de cambiar manualmente a la interfaz de nueva versión`,
"label.under.approve.record":`Pendiente`,
"front-epwechat-module-v1-open":`Activar`,
"label.projectManagement.delete.task":`Toda la información relacionada con esta tarea también se borrará si elimina esta tarea, y los datos no se podrán recuperar. Está seguro de confirmar la eliminación?`,
"label.reportforms":`Informes`,
"label.tabpage.onlymevisible":`Visible solo para mí`,
"label.customer.tab.please.name":`Ingrese el nombre del menú`,
"label_emailsync_form_stutas":`Estado`,
"message.recordtype.nolist":`No hay tipo de registro definido`,
"label.version.forecasting.sales":`Previsiones`,
"chatter.sel.mostfield":`Puede seleccionar hasta`,
"label.data.derived":`Exportación de datos`,
"label.component.helper.businesschange.expiredtask":`Oportunidades de negocio con tareas caducadas`,
"label.cycle":`Ciclo`,
"lable.product.standp":`Precio estándar`,
"label.sendemail.batchapproval":`Operación de aprobación masiva`,
"message.organization.not.open.mffverification":`La organización no activa la certificación secundaria`,
"label.icon.131":`Paraguas`,
"UG.activity.08":`Reservar un horario`,
"label_partner_workspace_member_choicepermission":`Seleccione el conjunto de permisos`,
"label.reportTypeCategory":`Fuente de datos del informe`,
"label.exporttwotype":`Puede exportar dos tipos de texto`,
"message.oppdt.selectpricebook":`Seleccione primero el libro de precios`,
"vue_label_dashboard_generatefromlistview":`Generar a Partir de la Vista de Lista`,
"label.quote.title":`Título`,
"label.tianyancha.businessverify.cancel.sure":`Después de cancelar la verificación de los datos comerciales, es imposible rellenar la información de registro comercial al crear o editar un cliente. ?Está seguro de continuar?`,
"label.save":`Guardar`,
"label.mobile.quickcreate.default.appstore":`Apps`,
"label.partnerCloud.orderingPlatform.configure":`{a} los productos no están configurados, por favor, guarde después de la configuración.`,
"front-epwechat-module-v1-unbound-role":`Roles no vinculados`,
"label.partnerCloud.financeSetting.enterAlipay":`Por favor, introduzca la cuenta de empresa de Alipay.`,
"label.validate.function.funcExplain.TODAY":`Regrese a la fecha actual`,
"label.visualpage.parameter.values":`Los parámetros se muestran directamente en la página:`,
"label.version.task.and.activity":`Seguimiento de tarea y actividad`,
"label.audit.history":`Por aprobar`,
"setup.object.field.dependency.label.addtolist":`Añadir valor seleccionado`,
"vue_label_report_exportquantity":`Cantidad exportada:`,
"label_tabpage_havez":`Adjunto`,
"label.partnerCloud.partnerAccount.amountOfRebate":`Cantidad de reembolso disponible`,
"label.createralias":`Creado por alias`,
"label.created_followup":`Crear un correo electrónico de seguimiento`,
"label_chatter_mygroups":`Mis grupos`,
"label.chat.topic.no.display":`No hay temas para mostrar`,
"vue_label_calendar_month_view":`Calendario-Vista del mes`,
"label.service.gantt.resources.assigned.work":`Recursos con trabajo asignado`,
"UG_activity_07":`Crear una tarea`,
"label.quote.xsjg":`Precio de venta`,
"message.toomanyrows":`?Los registros de búsqueda son demasiados!`,
"label.importsourcestep1":`Paso 1: Prepare los archivos traducidos`,
"vue_label_normal_appointment_sf":`Reservar cita`,
"lable.list.queue.message":`La cola no se puede cancelar, porque existen registros de objeto que pertenecen a la cola`,
"label.service.major.event.desc":`El evento clave representa pasos dependientes del tiempo en el proceso de apoyo. Se puede añadir al principio del proceso de asignación. A continuación, se puede aplicar el proceso a la asignación de clientes y crear un caso o una orden de trabajo a partir de ellos.`,
"label.ems.hostorport.null":`Dirección del servidor y el número de portal no se pueden estar vacío`,
"chatter.group.private":`Privado`,
"label.icon.192":`Pastilla De Jabón`,
"vue_label_systemSettings_list":`Configuración de la pantalla de la lista relacionada`,
"label.activity.saveobj.notnull":`El objeto guardado no puede estar vacío`,
"vue_label_chatter_current_no_people_approval":`Actualmente no hay personas que requieran aprobación`,
"label.tianyancha.reglocation":`Dirección de registro`,
"UG_ST_005":`Lo sé, no muestre esta página de nuevo y ingrese directamente la próxima vez.`,
"label.vlidaterule.example.truetodisplay":`Este mensaje aparecerá cuando la fórmula de ¨Criterios de error¨ sea verdadera`,
"label.icon.99":`Notas`,
"label.whenselectmoreapprover":`Cuando seleccione más de un aprobador`,
"label.forecast.customforecast.directorbest":`El Mejor Caso del Subordinado Directo`,
"label.customsetting.view.introduce":`Ofrecer valores para los campos creados. Los datos serán guardados en los cookies de la aplicación.`,
"label.there.are.no.unenabled.rules":`Todas las reglas están activadas.`,
"front-project-module-v1-plase-selectemplat":`Por favor, seleccione la plantilla del proyecto`,
"label.campaignmember.selectmember.from":`De`,
"setup_layout_button_quicksave":`Guardar rápido`,
"label.setup.service.report":`Configuración de la plantilla del informe de servicio`,
"label.visualpage.direction.for.use":`Instrucción de la página personalizada[versión 2.0]`,
"message.modify":`?EStá seguro de que quiere modificar?`,
"label.sms.inside":`Interior`,
"label.category.3":`Educación`,
"label.login.mfadevice.verification.title":`Verificación de dispositivo MFA`,
"UG_Forcast_08":`Paso anterior`,
"label.projectManagement.unable.to.complete":`No se puede completar`,
"front-kefu-moudle-all-missphone":`Todas las llamadas perdidas`,
"font-evaluate-module-v1-emergency":`Advertencia`,
"label.sso.saml.sp.idsource.attr":`Identidad está en los elementos de propiedad`,
"chatter.not.meg":`No puede enviar mensaje vacío`,
"label.chatter.startDate":`Fecha de inicio`,
"label.emailobject.track.times":`Intento de abrir: {0}`,
"label.customsetting.fieldhasbeendeleted":`Campos cancelados`,
"label.knowledge.setting.hint.thirteen":`Añadir categoría de otros datos`,
"message.duplication.label.newfiltertitle":`Nueva regla de duplicados`,
"setup_object_field_dependency_label_selectedfieldvalue":`Campos de valores seleccionados`,
"vue_label_calendar_who_currently_has_access":`¿Quién tiene acceso actualmente?`,
"message.passwordPolicy.validate.minlengthe":`caracteres`,
"label.emailsync.status.disconnect":`Cancelar asociación`,
"label.applt.down.one":`Descarga con un solo toque`,
"label.manageAll.sel.one2":`Los ítems enviados`,
"message.error.SQLTimeout":`?El sistema está ocupado, intente de nuevo más tarde!`,
"label.global.search.obj.setup":`Configuración del objeto de búsqueda global`,
"vue_label_commonobjects_view_chat":`Plan de equipo`,
"vue_label_systemSettings_startSet":`Inicio de la configuración`,
"label.quickbooks.viewlist.balance":`Saldo`,
"message.error.fieldid.null":`¡fieldid no puede estar vacío!  id del contenido del archivo`,
"label.replaceallnullvalue":`Reemplazar todos los valores en blanco`,
"label.georgia.time":`Hora de Georgia`,
"label.hastransfer":`Contener convertido`,
"label.partner.all.description":`Descripción`,
"font-evaluate-module-v1-following-peopple":`Cuando recibas la reseña negativa, notifica a los siguientes usuarios`,
"label_business_count":`Cantidad de oportunidades de negocio`,
"vue_label_ccchat_closedetail":`Cerrar post`,
"label.partner.all.disable":`Deshabilitar`,
"label.view.relationship":`Relación de objetos`,
"label.noless":`>=No menos de`,
"label.sendsms.batch.step2":`Paso 2: Seleccione una plantilla o personalizar los contenidos de SMS`,
"label.stdashbord.xsld.business.jieduan":`Nombre de etapa`,
"label.appupload.component.type.trigger":`Trigger`,
"label.knowledge.setting.data.two":`El nombre de la categoría es obligatorio.`,
"label.color.display.of.completion.rate":`Visualización de los colores de la tasa de completitud`,
"label.loginhis.default":`Alistar los últimos 200 historiales por defecto`,
"vue_label_pricebook_book":`Lista de precios actual`,
"label.knowledgebase.data.deletion.failed":`{a} ha fallado el borrado de datos`,
"label_partner_workspace_member_permission":`Conjunto de permisos disponibles`,
"label.list.userinterface.approval.setup":`Configuración de Aprobación`,
"label.weixin.binding.effect":`Vinvulación inválida, ingrese de nuevo`,
"label.appupload.install.newapicannotnull":`El nombre de nuevo API no puede estar vacío`,
"chatter.feed.menutype.feed.company":`Todas las publicaciones`,
"label.assignment.setup.detail.email":`Correo`,
"label_tabpage_selectcontentz":`Seleccione los contenidos`,
"template.report.converted.leads.campaign":`Contactos convertidos de las campañas`,
"label.forecast.season":`Este trimestre`,
"label.post":`Publicar en`,
"label.knowledge.setting.hint.fifteen":`Los cimientos ya están puestos. Ahora usted y su equipo pueden escribir y organizar sus artículos de conocimiento.`,
"front-kefu-moudle-v1-Seats-name":`Apodo del agente`,
"label.weixin.leadname":`Nombre de candidato`,
"label.account.quarter":`Trimestre`,
"label.detail.field":`Ver campos`,
"label.icon.189":`Cosmético`,
"label.appointment.disable.reappointment":`Desactivar Reprogramación`,
"label.appointmentconfirmpage.wizard.subtitle1":`Nombre de evento`,
"label.campaign.channel.step6.remark3":`El sistema generará un código QR único de invitación, con el cual los colegas pueden invitar, y el número de invitadores incluirá en el rendimiento personal`,
"System.AddressFieldType.Post":`Código postal`,
"label_partner_new_step2":`Paso 2: Confirmar plantilla`,
"vue_label_helpcenter_file":`Ver y gestionar sus archivos<br> Utilice la nueva versión del objeto archivo para ver y gestionar los archivos que le pertenecen o que son compartidos con usted. Puede obtener una vista previa de los archivos en algunos formatos en línea. <br>Biblioteca de archivos<br> Utiliza la función de biblioteca de archivos para establecer una biblioteca de conocimientos de equipo, configurar diferentes administradores y miembros para una gestión más cómoda; utiliza la función de carpetas para clasificar los archivos.`,
"label.locateddowncurrentvalue":`El valor ubicado debajo del valor actual`,
"label.tianyancha.businessverify.msg5":`Segundo: Fiabilidad del servicio`,
"label.setup.mobile.bottombutton.change.success":`Cambiado con éxito`,
"label.appointmentconfirmail.wizard.subtitle2":`Hora`,
"label.email.address.lookup":`Buscar dirección de correo`,
"setup.mainpage.label.welcome":`Bienvenido a la plataforma CloudCC PaaS, las principales funciones de la plataforma son las siguientes:`,
"label.icon.55":`Excavadora`,
"label_tabpage_enterrecordnamez":`Ingrese el propietario del registro`,
"label.tabpage.andz":`Y`,
"label.selectfiletoimport":`Seleccione el archivo a importar`,
"label.version.sum.trigger":`trigger(s)`,
"label.multi.layout":`Dise?os compactos`,
"pagecreator.button.back":`Paso anterior`,
"label.imgfield.truetype":`Por favor sube el formato correcto de imagen`,
"front-kefu-moudle-v1-publicKey":`Llave compartida`,
"label.data.exp.newtemp":`Crear plantilla`,
"label.martrixreport.2018.step4.new":`Paso 4: Seleccione columna de informe`,
"label.sendemail.chat.addComentsatsubject":`Me han mencionado en los comentarios de CloudCC CCChatter`,
"vue_label_applauncher_description_leadpool":`Utilice el grupo público de clientes para gestionar cómodamente el estado de seguimiento dentro de la organización y motivar al personal a completar las transacciones.`,
"label.knowledgebase.archive.published.articles.without.drafts":`Sólo se pueden archivar los artículos publicados que no tengan borradores.`,
"label.projectManagement.bar.chart":`Gráfico de barras`,
"label.ccpeak.condition.return.sort":`Regrese y ordena según las condiciones`,
"label.salescloud.opportunity.contactrole":`Rol de contacto de las oportunidades`,
"label.language":`Lengua`,
"message.error.view.badprevilege":`?Lo sentimos, no le autorizan para este servicio, contacte con el administrador!`,
"label.textmessage.managetemplates":`Gestionar plantillas`,
"message.error.type.null":`El tipo no puede ser nulo.`,
"setup.mainpage.label.welcome9":`Los usuarios pueden realizar la clasificación, el ajuste del diseño de todos los elementos de la página y la configuración de la propiedad como "solo lectura", "obligatorio" de los campos de la página mediante el arrastre del ratón sin necesidad de desarrollar códigos.`,
"label.appupload.component.type.page":`Página Personalizada`,
"label.textmessage.bookschedule":`Haga clic en el siguiente enlace para ver y reservar mi horario:`,
"component_chatter_post_button_save":`Publicar`,
"lable.oppt.jieduan.signcomplete":`Marca la etapa como completada`,
"label.help.notes":`AYUDA Y GU?A`,
"label_tabpage_reallproplez":`Registrar todos`,
"label.obtain.authorization.failure":`No se ha podido obtener el código de autorización. Por favor, vuelva a autorizarlo.`,
"label.account.FiscalQuarter":`Trimestre Fiscal`,
"label.customsetting.savecustomvalue":`Datos de esta localidad ya existe, por favor los modifique y guarde de nuevo`,
"label.maximum":`Máximo`,
"component_chatter_file_label_maxsize":`El fichero máximo es 20M`,
"c218":`Su mensaje se ha guardado como borrador`,
"c875":`Nuevo puesto de conversación`,
"c183":`Filtro de etiquetas`,
"c366":`Configurar el Pool`,
"c91":`Puntuación de la interacción por correo electrónico`,
"c184":`Avance de etapa`,
"c750":`Iniciador:`,
"c619":`Las publicaciones en Twitter deben tener 280 caracteres o menos. Intenta usar contracciones para acortar las cosas.`,
"c69":`A pagar`,
"c675":`Alineado a la izquierda`,
"c533":`Recuento de casos actualizados`,
"c167":`Se requiere la longitud del pedido`,
"c682":`Cuadrado`,
"c960":`Edición Super`,
"c850":`Muestra el número actual de seguidores de cada una de tus cuentas sociales, excepto en el caso de Facebook, que muestra el número actual de "me gusta" de la página.`,
"c343":`Añadir miembros del proyecto`,
"c8":`Elija la forma`,
"c157":`Modo de toma de pedidos abierto`,
"c397":`Equipo de servicio`,
"c556":`las imágenes no se publican`,
"c563":`Tiempo activo`,
"c179":`Logotipo del socio`,
"c147":`Reglas para la toma de pedidos`,
"c303":`Obligación legal`,
"c885":`Ocultar la barra lateral`,
"c808":`Insertar imagen`,
"c718":`Continuar con la configuración`,
"c414":`Gracias por su tiempo para completarlo.`,
"c9":`Solicitudes de los empleados`,
"c15":`Se ha facturado. Por favor, vuelva a seleccionar`,
"c59":`Por favor, primero vincule el asiento de administrador de Easemob y luego entre en la configuración avanzada.`,
"c504":`Planifique los proyectos, asigne el trabajo, gestione los recursos y colabore con su equipo para alcanzar los objetivos del proyecto, controlar su progreso y entregar el proyecto en el plazo previsto y dentro del presupuesto.`,
"c836":`Vincular la cuenta de Fadada`,
"c187":`Página de agradecimiento`,
"c208":`Paquete de descarga`,
"c952":`Brasil`,
"c104":`Responder una vez`,
"c346":`Cálculo de los recursos de las tareas`,
"c913":`Ampliar la barra lateral`,
"c571":`El formulario(s) {número de selección} ha sido seleccionado`,
"c44":`Elija una red para conectarse`,
"label.social.posts.content.null":`El contenido del mensaje está vacío`,
"c852":`Nombre de la empresa (sin rellenar)`,
"c561":`Aplicar filtro`,
"obtain.contract.envelopeid.fail":`Fallo en la obtención de la información de los sobres o de los mensajes no vinculados`,
"c465":`Sólo los pedidos con la misma moneda pueden generar una factura`,
"c982":``,
"c350":`Clasificación de tareas`,
"c352":`Calendario de recursos de personal`,
"c670":`Iconos gráficos`,
"front-electronic-signature-given":`Entrega`,
"c542":`Evaluación de la satisfacción`,
"c314":`Generar el archivo de la factura`,
"c148":`Configuración de las notificaciones por correo electrónico`,
"c47":`Conectar dominio`,
"c754":`Rellenar`,
"c326":`Lista de materiales de los activos`,
"c289":`Preferencia`,
"c196":``,
"c63":`Abrir {objName}`,
"c769":`El documento de tarea firmado iniciado se borrará después de la revocación. ¿Continuar para deshacer?`,
"c216":`Su puesto ha sido programado`,
"c842":`Enviar notificación de presentación por correo electrónico`,
"c389":`Territorio de servicio principal`,
"c7":`Propietario de la promoción`,
"c981":``,
"c143":`Seleccione el usuario que recibirá las notificaciones. Esta configuración se puede cambiar en cualquier página de destino en la que se utilice el formulario.`,
"c930":`Interruptor de posicionamiento de los empleados`,
"c515":`Añadir resumen de trabajo`,
"c393":`Miembro del Territorio de Servicio`,
"c357":`Valora`,
"c597":`Medidor de objetivos`,
"front-electronic-signature-cancelIntro1":`La firma electrónica de DocuSign no estará disponible después de la desvinculación. Estás seguro de que vas a desvincularte?`,
"c271":`Tiene un tiempo de espera para aceptar el pedido, número: {0}. Por favor, atiéndalo con prontitud y tenga en cuenta el retraso del trabajo. Haga clic para ver más >`,
"label.gaode.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`Amap no funciona correctamente. Por favor, compruebe si la clave secreta es correcta.`,
"c424":`Gestión del territorio de servicios`,
"c711":`Conecta tus cuentas sociales y llega a todo un nuevo mundo de fans.`,
"c197":`Has alcanzado el número máximo de envíos. Gracias por su participación.`,
"front-electronic-signature-save-success":`Guardar la asignación con éxito`,
"c765":`Bloqueado`,
"c286":`Incumplimiento`,
"c145":`Las horas de trabajo presentadas para una/múltiples tareas por persona y día no pueden superar las 24 horas.`,
"c264":`Gestionar los campos personales`,
"label.china":`China`,
"label.no.bind.mobile":`No hay móvil. Por favor, vaya a la información personal y encuadre`,
"c95":`Borrar los productos seleccionados`,
"front-electronic-signature-open-signInfo1":`La firma electrónica de DocuSign está activada. Por favor, desactívelo y luego habilite el Esignature&stamp de Fadada.`,
"c391":`Ver comentario`,
"c106":`Interacciones`,
"c519":`Toda la información relacionada con esta hoja de horas también se borrará si elimina esta hoja de horas, y los datos no se podrán recuperar. ¿Está seguro de confirmar la eliminación?`,
"c528":`Registro de horas`,
"c78":`Número de pedido`,
"c41":`Desenlazar con éxito`,
"c517":`Introduzca un tipo impositivo válido`,
"c774":`Signo de progreso`,
"c296":`Por favor, rellene el nombre del campo`,
"c757":`Aceptar`,
"front-electronic-signature-confirmintro":`Vincular con éxito. Ahora puede iniciar la firma desde el objeto Contracts.`,
"c446":`Estado de la tarea`,
"c238":`{!ServiceResource.name} aceptó el pedido. Cuenta: "{!ServiceAppointment.accountid.name}", Asunto: "{!ServiceAppointment.subject}", Número: "{!ServiceAppointment.name}"`,
"c980":``,
"c802":`Cada usuario sólo puede ser añadido como recurso de servicio`,
"c387":`Habilidades de recursos de servicio`,
"c965":`El servicio EaseMob no está habilitado`,
"c480":`¿A qué lista debemos enviar?`,
"c937":`Cambiar el número de teléfono`,
"c632":`Ver en Facebook`,
"c131":`El campo de la cuenta de la factura está vacío, por favor añada la información.`,
"c680":`Blanco`,
"c806":`Cuando`,
"c649":`Has leído todo lo que había en tu bandeja de entrada.`,
"c797":`Contactos recientes`,
"c616":`Abrir enlace en una nueva ventana`,
"c169":`Lo sentimos, no tiene permiso para ver este gráfico`,
"c21":`El número de producto no puede ser inferior al importe facturado`,
"c231":`No puede ser inferior al número de productos que ha envasado`,
"c555":`La imagen de tu post no ha sido publicada.`,
"c583":`Mapa de China`,
"front-electronic-signature-open-signInfo2":`La firma electrónica de Fadada está activada. Por favor, desactívelo y active el sello electrónico de DocuSign.`,
"c822":`Nuevos contactos externos`,
"c600":`Tabla numérica`,
"c442":`Sistema integral de gestión de proyectos`,
"c762":`Para firmar`,
"label.user.not.permission":`El usuario actual no tiene permiso para operar`,
"c35":`Nombre de la suscripción`,
"c921":`función(es)`,
"c305":`Intereses públicos`,
"c730":`No se puede reutilizar la antigua contraseña`,
"c525":`Desactivar usuario del portal`,
"c942":`América`,
"c780":`Proceso de firma`,
"c447":`Fuente del canal final`,
"c369":`Enviar archivo de cotización`,
"c702":`Hacer el borrador`,
"c22":`El importe pagado en la factura será mayor que el valor total si sigue creando este detalle de pago. Por favor, reajuste el importe y vuelva a guardar.`,
"c79":`Fecha del pedido`,
"c785":`Nombre real (opcional)`,
"label.insert.approval.reassign.error":`La aprobación en el estado de aprobación de inserción no puede ser reasignada`,
"c273":`Aceptación de la orden de envío. Cancelar el envío.`,
"c3":`Borrar el gráfico con éxito`,
"c448":`Sesión de chat`,
"c495":`Todo lo que necesita para vender de forma más rápida e inteligente`,
"c429":`KPI de envío`,
"c16":`Existe más de un pedido facturado. Por favor, vuelva a seleccionar`,
"c128":`Se pueden añadir hasta 5 filas`,
"c955":`El ancho mínimo de {label} es {minWidth}px`,
"c716":`Está listo para empezar a publicar desde CloudCC`,
"c638":`Opciones de publicación`,
"c746":`Revocar la solicitud de destrucción`,
"c534":`Recuento de casos cerrados`,
"c948":`Italia`,
"c317":`Enviar archivo de orden de compra`,
"c426":`Gestión de recursos de servicios`,
"c457":`Importe total del contrato Clasificación`,
"c263":`Campos personales`,
"c372":`Generar orden`,
"c907":`Sólo disponible en versión lightning`,
"c771":`Progreso de llenado`,
"c408":`Aplicación de servicio de campo personalizable`,
"c12":`Tasa de crecimiento`,
"c379":`Datos de pago`,
"c410":`Tipo de trabajo`,
"c510":`Pedidos de socios`,
"c701":`Asignar campaña`,
"c617":`El texto es necesario para publicar una entrada`,
"c213":`Formato EPS`,
"c473":`El sistema generará un código de invitación único para los empleados, que podrán utilizar el código de invitación para realizar invitaciones y contar como rendimiento personal. Tenga en cuenta que el propietario de los clientes potenciales será el propietario de la campaña actual o el invitador del canal de marketing`,
"c975":``,
"c168":`Por favor, elija un gráfico.`,
"c121":`Sin categoría`,
"label.send.invoice":`Enviar factura`,
"c792":`Confirmar la iniciación`,
"c686":`Tamaño`,
"c652":`Muestra el número de publicaciones que se han realizado en sus cuentas durante el periodo seleccionado. Esto también incluye los mensajes que se publicaron en sus cuentas conectadas fuera de CloudCC.`,
"c136":`Por favor, introduzca una breve introducción aquí`,
"c662":`Icono personalizado`,
"label.invoice.customer.is.error":`La generación de facturas sólo es posible para los pedidos realizados por el mismo cliente.`,
"c580":`Gráfico de burbujas`,
"c894":`Asigne una campaña a un mensaje y podrá revisar todos los mensajes relacionados con la misma campaña. Esto se utiliza para un esfuerzo de marketing anlyazing.`,
"c570":`Diseño`,
"c133":`superar`,
"c564":`Estimado usuario: \N  Bienvenido al sistema CloudCC. Usted ha solicitado restablecer su contraseña en {¡hora de operación}, por favor, inicie sesión con el código de verificación de abajo dentro de 15 minutos: \nCódigo de verificación aleatorio: {!authcode}\NImportante: Si usted no solicitó esta operación, o cree que este mensaje no debería llegarle, por favor, póngase en contacto con su administrador inmediatamente.`,
"c854":`Parece que no hay nada publicado.`,
"c775":`Descatalogado`,
"c105":`Reproducir más de una vez`,
"c729":`Por favor, confirme que ha configurado la plataforma social o no. Vaya a la configuración del backend  Integraciones  Habilitar (Twitter/Facebook/LinkedIn)`,
"c491":`Desactivado`,
"c609":`Marca comercial`,
"c611":`Enlace a`,
"c843":`Ver presentación`,
"c933":`Página de conversión`,
"c383":`Productos de oportunidad`,
"c186":`El ID único ya existe. Por favor, no añada repetidamente`,
"c608":`Sustituir`,
"c149":`Activar las notificaciones de Outlook (sólo admite parte de los servicios de correo electrónico)`,
"c486":`Responder a la dirección de correo electrónico:`,
"c598":`Tabla de donuts`,
"c726":`Solicitud de destrucción con éxito`,
"c645":`Aprobar el proyecto`,
"label.verificationCode.is.invalid":`El código de verificación no es válido. Por favor, vuelva a adquirirlo`,
"c904":`Entre`,
"c594":`Gráfico de líneas 2D`,
"c103":`Haga clic más de una vez`,
"c188":`comentario(s)`,
"c891":`El registro no puede ser un contacto, una oportunidad, un cliente potencial o una cuenta`,
"c902":`Distancia entre la dirección de entrada y el visitante`,
"c484":`Correos electrónicos:`,
"c421":`Método de generación de órdenes de trabajo`,
"c406":`Gestión automatizada de las ventas`,
"c739":`Campaña: Solicitudes de los empleados`,
"c329":`Sustitución de activos`,
"c351":`Frecuencia de recurrencia`,
"c622":`Las estadísticas de la red se actualizaron por última vez en`,
"2":`Configurar correctamente las opciones de filtrado`,
"c463":`Mis oportunidades`,
"c268":`Combinar la información con éxito`,
"label.mobile.no.letter.blankcharacter":`El número de teléfono no puede contener letras ni caracteres en blanco`,
"c438":`Transferencia`,
"c581":`Tabla de M&A`,
"c953":`Corea del Sur`,
"c90":`Asunto`,
"c2":`¡Borrar el tablero de instrumentos con éxito!`,
"c897":``,
"c444":`Primer canal Fuente`,
"c242":`{!ServiceResource.name} ha rechazado el pedido. Cuenta: "{!ServiceAppointment.accountid.name}", Número: "{!ServiceAppointment.name}"`,
"c135":`Plantilla en blanco`,
"c659":`Sígueme`,
"c773":`Finalización de`,
"c11":`Promoción de la comercialización de formularios`,
"c799":`Contactos externos`,
"c880":`editar publicaciones sociales`,
"c890":`Enviar correo electrónico de invitación con éxito`,
"c846":`Seleccione una cita de servicio elegible`,
"front-electronic-signature-sucessSign":`Empezar a firmar con éxito`,
"c472":`Elija un formulario para aplicar el cartel`,
"c963":`El campo del nombre es obligatorio`,
"c390":`Territorio del Servicio de Menores`,
"c248":`La aceptación de la transferencia de la orden está pendiente`,
"c646":`Flujo de la bandeja de entrada`,
"c308":`Seleccione al menos un dato`,
"c858":`¿Estás seguro de que quieres guardar {a} posts como borradores? Estas entradas no se publicarán a menos que las programes de nuevo.`,
"c152":`Número de citas de servicio completadas en el rango de tiempo seleccionado actualmente / Número de todas las citas de servicio en el rango de tiempo seleccionado actualmente`,
"c316":`Ver el progreso del caso`,
"c435":`Ver versión`,
"c362":`Restricciones del producto adjunto`,
"c800":`Por favor, introduzca el nombre o el nombre de la empresa`,
"c415":`Inicio programado`,
"c735":`El nombre no se puede repetir`,
"c903":`Seleccione el icono de la aplicación`,
"label.insert.approval.massreassign.error":`Las aprobaciones por lotes existentes La aprobación de inserción no se puede reasignar. El sistema autofiltrará por usted`,
"c354":`Editar la hoja de horas`,
"c409":`Plataforma única de atención al cliente`,
"c651":`Muestra el número de seguidores actuales de cada una de tus cuentas sociales, excepto en el caso de Facebook, que muestra el número de Me gusta actuales de la página.`,
"c582":`Mapa del mundo`,
"c826":`¿Estás seguro de que quieres descartar tus cambios?`,
"c781":`Empresa: Por favor, introduzca el nombre de la empresa que figura en la licencia comercial. La comprobación se hará en el momento de la firma.`,
"c873":`Más detalles`,
"c837":`Después de la desvinculación, la función de Firma Electrónica de Fadada no podrá ser utilizada, y la función de autocompletar y rellenar campos que han sido configurados serán eliminados. ¿Está seguro de que va a desvincular la cuenta?`,
"label.diedirect.sale":`Reducciones directas de precios`,
"c798":`Contactos internos`,
"c368":`Generar archivo de cotización`,
"c770":`Iniciado`,
"c882":`Condiciones de servicio`,
"front-setting-dialog-title-two":`Configurar desde la página de información personal si no se introduce esta vez. Encuadernar al introducir el número`,
"c535":`Sin resolver`,
"front-electronic-signature-look-account":`Ver cuenta`,
"c19":`Modo de visualización de detalles del registro`,
"c52":`Nombre del impuesto`,
"c388":`Derecho de asociación y uso`,
"c18":`Hay más de un pedido inactivo, por favor, vuelva a seleccionar`,
"c820":`Por favor, introduzca el número de teléfono/buzón`,
"c285":`Resumen`,
"c478":`Autentificar Mailchimp`,
"c164":`Por favor, introduzca un valor entero de 060`,
"label.tip.excess.quota":`Se ha superado el uso de este recurso`,
"c318":`Generar archivo de orden de compra`,
"c698":`Red social`,
"c312":`Los pedidos múltiples aún no son efectivos, por favor seleccione de nuevo`,
"c110":`Agrupación por proyectos`,
"c549":`El intervalo de fechas no puede superar los 31 días.`,
"c845":`Por favor, seleccione al menos una cita de servicio`,
"c282":`Gestionar los datos personales de los clientes en el CRM`,
"c270":`Aceptación de la orden de compra`,
"c288":`Cambiar la base de procesamiento de datos`,
"c878":`Dirección actual`,
"c324":`Añadir colas a los casos`,
"c129":`Esta acción borrará definitivamente el archivo. ¿Desea continuar?`,
"c339":`Destrucción de datos GDPR`,
"c405":`Tamaño de la tripulación`,
"c848":`Cuentas de Linkedin`,
"c345":`Plantilla del proyecto`,
"c591":`Mapa de Australia`,
"c180":`Idioma en la página de inicio de sesión`,
"c126":`Entregado`,
"c311":`No es efectivo, por favor seleccione de nuevo`,
"c587":`Mapa de México`,
"c37":`Este es el texto que debe ver su cliente en la página de preferencias de comunicación`,
"c840":`Sí. No hay puestos infructuosos.`,
"c241":`{!ServiceResource.name} ha rechazado el pedido. Cuenta: "{!ServiceAppointment.accountid.name}", Asunto: "{!ServiceAppointment.subject}", Número: "{!ServiceAppointment.name}"`,
"c141":`El mensaje de agradecimiento es necesario`,
"obtain.contract.fail":`No se ha podido adquirir la información del contrato`,
"c945":`Rusia`,
"c454":`Importe del contrato Mensual`,
"c34":`Tiene 100 productos en su cesta de la compra. Por favor, borra al menos un artículo antes de añadir un nuevo producto.`,
"c243":`{!ServiceResource.name} ha rechazado el pedido. Asunto: "{!ServiceAppointment.subject}", Número: "{!ServiceAppointment.name}"`,
"c548":`La tarea/emisión, la subtarea y el proyecto no se pueden editar desde una hoja de horas`,
"c807":`Publicar ahora`,
"c590":`Mapa de Alemania`,
"c831":`Certificando`,
"c198":`Su formulario está publicado de forma segura y puede ser utilizado en la siguiente URL para compartir su formulario como un enlace público.`,
"c977":``,
"c66":`La información logística del producto se actualiza a Entregado`,
"label.twitter.title.setting":`Información integrada en Twitter`,
"c922":`Póngase en contacto con el administrador para habilitar el equipo`,
"front-email-payment-Invoice-Tips":`Por favor, póngase en contacto con el administrador para habilitar PayPal o VISA y luego iniciar el pago en línea`,
"c605":`	
Dirección de facturación por defecto`,
"c403":`Proyectos`,
"c156":`Normas de toma de pedidos para el lado móvil`,
"c635":`Programar otro puesto`,
"c753":`Participante`,
"c647":`Toda la actividad`,
"c295":`Tras la desactivación, se eliminarán todas las marcas de los campos personales, la base del procesamiento de datos y otra información para cumplir con la DGPR, excepto el historial de operaciones para los registros. ¿Está seguro de desactivar?`,
"c915":`Piscina abierta`,
"front-electronic-signature-signStatus":`Ha iniciado la firma en línea. El estado del contrato es {signStauts}`,
"c568":`Ajustar el diseño`,
"c744":`Introduzca un número válido entre 0 y 100`,
"c464":`se eliminan los mensajes`,
"c385":`Resumen del trabajo`,
"c392":`Elija la solución que necesita`,
"c418":`Recursos de servicio asignados`,
"c256":`El cambio de cuenta borrará el pedido con los artículos seleccionados. ¿Está seguro de cambiar?`,
"c690":`Carga de imágenes`,
"c261":`Destruir datos`,
"c62":`Solicitudes de los empleados`,
"c892":`No se ha encontrado el registro actual`,
"c909":`Se han añadido definiciones de precios para esta moneda. Por favor, no vuelva a añadirlas.`,
"c883":`&`,
"c134":`Límite superior de los miembros del grupo`,
"c896":`El registro se ha bloqueado y no permite añadir archivos. Por favor, póngase en contacto con el administrador para desbloquearlo`,
"c974":``,
"c209":`Tamaño medio`,
"c185":`Estadísticas en esta página`,
"c796":`Por favor, póngase en contacto con el administrador para configurar un modelo de contrato en la plataforma Fadada antes de iniciar la firma.`,
"c60":`Recuento de proyectos`,
"c866":`Configurar la aplicación`,
"c666":`Mostrar`,
"c219":`Su mensaje ha sido borrado`,
"c732":`Póster`,
"c155":`{Nombre`,
"c511":`Contrato electrónico`,
"c240":`Rechazado`,
"c468":`El tipo de clasificación está vacío`,
"c961":`Q{trimestre} {año}`,
"c404":`Una herramienta de marketing y generación de contactos`,
"c586":`Mapa de Singapur`,
"c694":`Anchura/Altura`,
"c297":`Por favor, introduzca el tipo de datos personales`,
"c860":`Cambio de dirección`,
"c58":`Página web del proyecto`,
"c920":`Si se configuran las reglas de autoreciclaje, el sistema autoreciclará los registros al pool cuando el lead no se haya convertido después del límite de tiempo. Esto mejora la eficacia del seguimiento de los clientes potenciales.`,
"c27":`Introduzca el importe flotante para ajustar el importe bruto, por ejemplo,  10 o 10.`,
"c94":`3 veces arriba`,
"c1":`Sólo para móviles`,
"c557":`Casos recibidos`,
"c294":`Desactivar la configuración del cumplimiento del GDPR`,
"c970":``,
"c565":`Asigne esta tarea a`,
"c668":`Alineación`,
"c972":``,
"c660":`Copyright`,
"c433":`Seguimiento del campo del Lead Pool`,
"c443":`Archivo Todo`,
"c275":`{0} tiene un tiempo de espera para aceptar la orden, y el envío se cancela. Número: {1}. Haga clic para ver más >`,
"c691":`Enlace (opcional)`,
"c956":`Todavía no has activado tu cuenta de Mailchimp. Por favor, vaya a configuración>Integración>Lista de integración para activar su cuenta de Mailchimp o póngase en contacto con el administrador.`,
"c910":`Nueva orden de trabajo`,
"c692":`Navegador por defecto`,
"c355":`Añadir hojas de horas por lotes`,
"c122":`Imagen del producto`,
"c395":`Tipo de territorio`,
"c689":`Altura máxima`,
"c344":`Ver el proyecto con el diagrama de Gantt`,
"c656":`Tiempo de refresco`,
"c943":`Japón`,
"front-electronic-signature-outerSinger":`Firmante externo`,
"front-generate-v1-invoiceDetail":`Detalle de la factura`,
"front-electronic-signature-open-vertify":`Por favor, introduzca el código de verificación`,
"c291":`Tipo de datos personales`,
"front-setting-phone-message":`Introduzca el número de teléfono`,
"c559":`Casos escalados`,
"label.google.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`El mapa de Google no funciona correctamente. Por favor, compruebe si la clave secreta es correcta.`,
"c259":`Fundamentos del procesamiento de datos`,
"c488":`Hora de la invitación`,
"c6":`Nombre de la promoción`,
"front-electronic-signature-signerInfo":`Configurar la información del firmante`,
"c512":`Miembros del proyecto`,
"c507":`Cultivo de plomo`,
"c760":`Rechazado`,
"c756":`No enviar`,
"c321":`Necesario o no`,
"c817":`Ver la configuración de permisos del menú de la página personalizada`,
"c949":`España`,
"label.biaoqing.field.relation.tip":`Campo de descubrimiento de ofertas y licitaciones`,
"c382":`Puntuación de la red de relaciones`,
"c265":`Esta orden no puede ser modificada porque aún no es efectiva`,
"c417":`Información sobre el trabajo de los recursos del servicio`,
"c847":`Cuentas de Facebook`,
"c494":`Consiga una gestión unificada de todos los canales en CloudCC Marketing Cloud. Establezca conexiones y una confianza duradera con sus clientes, impulse el ROI con análisis y convierta el alcance en ingresos.`,
"c86":`Campaña: Editar la referencia de los empleados`,
"c776":`Deshacer con éxito`,
"c709":`Elija una red para conectarse`,
"label.mobile.orVerificationCode.is.error":`El error del número de teléfono o del código de verificación`,
"c579":`Gráfico de radar`,
"c413":`Estado de la cita de servicio`,
"c950":`Países Bajos`,
"c573":`Gráfico de barras 2D`,
"label.choose.is.tax":`Elija el tipo de impuesto`,
"c768":`La tarea de firma de contrato iniciada no se ha completado. Por favor, descargue el documento después de la firma del contrato.`,
"c604":`La dirección de facturación ya existe, guarde la actual como nueva dirección de facturación`,
"c160":`Tratamiento atrasado`,
"c239":`Aceptado`,
"c834":`Preliminar aprobado`,
"c113":`Enviar {nombre}`,
"c146":`Los productos pertinentes se compensarán después de cambiar la moneda. ¿Quiere seguir cambiando?`,
"c313":`Enviar el archivo de la factura`,
"c140":`Elija el objeto y la plantilla`,
"c298":`No cumple con la normativa`,
"c681":`Círculo`,
"c870":`¿Estás seguro de que vas a borrar por lotes?`,
"c551":`<span style="fontsize: 16px; fontweight: bold; color: #fe8a14"> {days} </span> días que quedan para el juicio`,
"c88":`Días que quedan de juicio`,
"c175":`Fallo en la obtención de información detallada`,
"c64":`Abrir o no {objName}`,
"c319":`Configuración del estilo del formulario`,
"label.pay.online":`Iniciar el pago en línea`,
"c941":`China  Taiwán`,
"c550":`Elija la fecha de inicio o de finalización`,
"c365":`Sincronizar la línea de cotización con el producto de la oportunidad`,
"c908":`Seleccionar icono`,
"c260":`Solicitud de destrucción`,
"c50":`Tipo impositivo`,
"c869":`¿Está seguro de archivar todos los datos`,
"c93":`Abrir repetidamente`,
"c280":`Borrar el correo electrónico`,
"c23":`El importe pagado en la factura será mayor que el importe del pedido si sigue creando este detalle de pago. Por favor, reajuste el importe y vuelva a guardar.`,
"front-console-v1-see-contacts":`Identifica varios contactos. Por favor, seleccione`,
"c607":`La dirección de envío ya existe, guarde la actual como nueva dirección de facturación`,
"c229":`Eliminar el hito`,
"front-filter-v1-filter-by-name":`Filtrar por "{nombre}`,
"c125":`En tránsito`,
"c513":`Hojas de tiempo`,
"c80":`Dirección de facturación`,
"c648":`Conversaciones`,
"c521":`Recuento de pedidos`,
"c560":`Casos cerrados`,
"c973":``,
"c509":`Lista de embalaje`,
"c685":`Añadir nueva dirección`,
"c178":`El formato de la imagen cargada no es compatible. Por favor, suba las imágenes en formato png, jpg y jpeg.`,
"c436":`Detalles del visitante`,
"front-electronic-signature-prepareTemplate":`Por favor, póngase en contacto con el administrador para preestablecer la plantilla del contrato en el sistema antes de empezar a firmar.`,
"c749":`Proceso de firma`,
"c114":`Por favor, haga clic en el botón Generar {nombre} para generar {nombre} antes de enviar.`,
"c898":``,
"c279":`Ventas`,
"c232":`No puede superar el número de productos a envasar`,
"c911":`Envío cancelado`,
"c901":`Su número de envíos ha alcanzado el límite.`,
"c663":`Texto alternativo`,
"c541":`Estadísticas del caso actual`,
"c536":`Recibido`,
"front-project-v1-batch-deletion-confirmation-information":`La eliminación por lotes de los registros seleccionados también borrará toda la información asociada a los mismos, y los datos no podrán ser recuperados,. ¿Está seguro de borrar?`,
"c893":`El usuario actual no puede tener acceso a editar el campo de dirección de detalle de la cuenta`,
"c623":`Monitor`,
"c493":`Dar forma al marketing digital, aprovechar todas las oportunidades`,
"c327":`Jerarquía de activos`,
"c747":`Su número total de productos está lleno. Por favor, elimine algunos productos primero y luego continúe añadiendo productos.`,
"c728":`Privacidad de los datos`,
"front-reportlist-v1-optimizedReport":`Los informes se optimizan después de la consulta. Por favor, no modifique al azar.`,
"c741":`¡Por favor, rellene el contenido del correo!`,
"c643":`Detalles del puesto`,
"c537":`Tiempo medio de respuesta`,
"front-electronic-signature-add-field":`Añadir campo de relleno`,
"c626":`Todos los usuarios`,
"c199":`Enlace al formulario`,
"c917":`Utilice el pool para estimular el potencial del equipo y mejorar la eficacia del seguimiento de las cuentas. El administrador del pool realiza una gestión unificada para las cuentas y la asignación de lotes. El personal de ventas también puede examinar los clientes potenciales y recibir el seguimiento.`,
"c159":`La longitud del pedido no supera un máximo de`,
"c640":`Calendario de actividades`,
"c192":`Diseño actual de la página:`,
"c978":``,
"c969":``,
"c871":`Así es como se mostrará su entrada en {a}. Pueden producirse ligeras diferencias si {a} realiza algún ajuste de diseño.`,
"c814":`1{0} seleccionado`,
"c235":`{!ServiceResource.name} aceptó el pedido. Asunto: "{!ServiceAppointment.subject}", Número: "{!ServiceAppointment.name}"`,
"c215":`Su mensaje ha sido publicado`,
"c425":`Gestión de citas de servicio`,
"c182":`La orden de trabajo y el registro del caso no pueden estar conectados a la vez`,
"c194":`Limitar el número de envíos`,
"c657":`No hay permiso para operar， por favor, póngase en contacto con el administrador`,
"c855":`Parece que no hay nada programado.`,
"c333":`Presupuesto Coste`,
"c338":`Proveedor  Destrucción`,
"c431":`Jerarquía de la campaña`,
"c374":`Precio Libro Producto`,
"c506":`Programa automatizado`,
"font-trade-module-invoice-totalMoney":`Total de facturas por cobrar`,
"c203":`Comparta sus formularios a través de Mailchimp`,
"c962":`{mes} {año}`,
"c786":`Número de teléfono/buzón de correo`,
"c469":`La página está en estado de edición. Los datos actuales no se pueden guardar si se sale de la página`,
"c137":`Elija una plantilla para el formulario`,
"c483":`Información de la campaña`,
"c947":`Francia`,
"c190":`La moneda de las partidas de pago debe ser coherente con la moneda del pedido, la factura y el pago. Por favor, afine la moneda y vuelva a guardar.`,
"c386":`Cumplido`,
"c803":`Cuentas: Todas las cuentas`,
"c759":`Para llenar`,
"c823":`Ajuste de la orden`,
"c422":`Método de generación de citas de servicio`,
"c782":`Cómo participar`,
"c416":`Informe de servicio Registro de empuje`,
"c758":`Aceptado`,
"c407":`Miembro del equipo de servicio`,
"c51":`Nuevo impuesto`,
"c844":`Vincular la cuenta de DocuSign`,
"c361":`Menú de edición`,
"c602":`Gráfico matricial`,
"c191":`Se requiere el permiso de edición de la vista actual`,
"c299":`Seleccione al menos un objeto`,
"c432":`Historia de la campaña`,
"c650":`Publicar un nuevo post para iniciar una nueva conversación`,
"c531":`Recuento de casos recibidos`,
"c13":`El usuario actual no tiene permiso para editar`,
"c162":`Informar simultáneamente al cedente y al cesionario`,
"c171":`Accionariado`,
"c230":`Eliminar tarea`,
"c470":`Campos de autorrellenado`,
"c367":`Generar contrato`,
"c26":`Establecer el descuento`,
"c705":`Mensajes publicados`,
"c613":`Página externa`,
"front-electronic-signature-openSign":`Comenzar a firmar`,
"c349":`Arrastrar y soltar`,
"c683":`Cargar más`,
"c679":`Gris`,
"c914":`Colapsar la barra lateral`,
"c224":`Ir a Milestone`,
"c220":`Su mensaje ha sido publicado sin éxito`,
"c498":`CloudCC Inventory soporta eficazmente el negocio omnicanal online y offline, realizando el flujo y la gestión de bienes y fondos. Los múltiples módulos se combinan de forma eficaz y los usuarios pueden lograr una gestión de pedidos refinada para crear situaciones ventajosas con los socios.`,
"c566":`Recuperar automáticamente la dirección de la cuenta después de guardarla`,
"front-electronic-signature-ContractTemplate":`Elija el modelo de contrato`,
"c540":`Resolver el tiempo por canales`,
"c793":`Plantillas de documentos`,
"c293":`Establecer objetos para permitir el cumplimiento del GDPR`,
"front-invoice-online-pay-again":`Ya ha iniciado un pago en línea. Por favor, no lo intente de nuevo.`,
"front-electronic-signature-open-password":`Por favor, introduzca la contraseña`,
"front-v1-partner-background-tooltip":`Se admite un archivo máximo de 2M. Se recomienda subir imágenes claras.`,
"c449":`Historia del chat`,
"c30":`Clásico`,
"c245":`{!oldServiceResource.name} transfirió la orden de trabajo numerada {!ServiceAppointment.name} a {!newServiceResource.name}`,
"c923":`Este es su equipo`,
"c24":`Mostrar mapa`,
"c872":`Nombre (sin rellenar)`,
"c886":`Abrir la barra lateral`,
"c485":`Nombre del formulario:`,
"c101":`pc(s)`,
"c816":`Ver el post`,
"c445":`Función del proyecto`,
"c853":`Muestra el número de "me gusta" y de comentarios de tus publicaciones.`,
"c398":`Empezar ahora`,
"c522":`Recuento de la facturación`,
"c287":`Cumplimiento`,
"c578":`Gráfico numérico MoM&YoY`,
"c40":`Por favor, introduzca la contraseña`,
"c631":`Ver en Twitter`,
"c489":`Tiempo de desactivación`,
"c819":`Número de teléfono/buzón de correo`,
"c935":`Tipo de formulario`,
"c625":`Todas las campañas`,
"c471":`Campaña: Remisión de empleados`,
"front-electronic-signature-writen":`Relleno`,
"c889":`Desactivar la cuenta de usuario con éxito`,
"c201":`Comparte este formulario en tus redes sociales`,
"c467":`El campo de clasificación está vacío`,
"label.mobile.no.null":`El número de teléfono no puede estar vacío`,
"c307":`Derecho`,
"front-kefu-moudle-wait-calling":`Llamada en curso, por favor, inténtelo más tarde`,
"c784":`Por favor, introduzca el nombre de la empresa en la licencia comercial`,
"c490":`Última hora de inicio de sesión`,
"c790":`Firma manuscrita`,
"c336":`Plomos  Destrucción`,
"c453":`Página de inicio Kanban`,
"c530":`Por favor, configure primero el buzón de la empresa`,
"c610":`El icono enlazará con el dominio principal si no ha especificado la URL`,
"c359":`Gráfico`,
"c193":`Limitaciones`,
"label.mobile.verificationCode.exceeded.times":`Se ha superado el número de reintentos. Por favor, solicite de nuevo`,
"c138":`Plantilla de la empresa`,
"c821":`Nuevos contactos internos`,
"c381":`Solicitud de pago en línea`,
"c761":`Firmando`,
"c964":`El campo de la relación maestrodetalle es obligatorio`,
"c585":`Mapa del Reino Unido`,
"c500":`Proporcione soluciones de servicio de atención al cliente con procesos estandarizados y una gestión eficaz, y coordine los recursos de servicio para ofrecer la mejor asistencia a sus clientes.`,
"c214":`Incluya mapas de bits en tres tamaños y gráficos vectoriales en todos los formatos`,
"c714":`Programe las entradas para que se publiquen en el momento adecuado.`,
"c552":`Rechazado`,
"c684":`{sumTotalCount} más`,
"c54":`Por favor, rellene el tipo de impuesto`,
"c320":`Seleccione los campos del formulario`,
"c236":`{!ServiceResource.name} aceptó el pedido. Cuenta: "{!ServiceAppointment.accountid.name}", Número: "{!ServiceAppointment.name}"`,
"c123":`Información logística`,
"c654":`Volver a la lista de cuadros de mando`,
"c335":`Margen de beneficios`,
"c267":`No se han podido confirmar los cambios porque no se cumple el criterio`,
"c226":`Ir a la subtarea`,
"c102":`Haga clic una vez`,
"c637":`Guardar como borrador`,
"c633":`Crear nuevas publicaciones sociales`,
"c777":`Configurar la información de los participantes`,
"c223":`Añadir al proyecto`,
"c592":`Gráfico de cascada`,
"c315":`Sólo los pedidos válidos pueden generar facturas`,
"c89":`Correo electrónico Nombre del evento`,
"c108":`Automatch con éxito`,
"c402":`Campo`,
"c748":`Por favor, seleccione un libro de precios para {título}. Sólo puede añadir productos de un único libro de precios. Si cambia el catálogo de precios seleccionado, se eliminarán todos los productos existentes.`,
"c501":`Proporcione un servicio de campo de calidad a sus clientes`,
"c269":`Fallo en la fusión de la información`,
"front-electronic-signature-open-confirm":`Vincular la cuenta`,
"c584":`Mapa de Estados Unidos`,
"c437":`Sin éxito`,
"c738":`Fecha de envío`,
"c274":`Se ha agotado el tiempo de aceptación de la orden y se ha cancelado el envío. Número: {0}. Haga clic para ver más >`,
"c83":`Buscar datos`,
"c206":`Formato PNG`,
"c309":`Enviar archivo de pedido`,
"c539":`Mayor proporción de fuentes`,
"c304":`Intereses principales`,
"c151":`Describa brevemente el contenido principal del formulario`,
"c639":`Publicar ahora`,
"c720":`No, gracias`,
"c801":`Nuevos contactos`,
"c900":`No se dispone de información sobre la dirección del visitante, por lo que no se puede calcular la distancia de registro.`,
"c695":`Tamaño original`,
"c864":`Elija un formulario`,
"c881":`He leído y aceptado`,
"c794":`Plantilla de firma`,
"c543":`Evaluaciones recibidas`,
"c466":`Sólo los pedidos que utilizan el mismo libro de precios pueden generar una factura`,
"c867":`{userName} recibirá un correo electrónico de invitación que le pedirá que cree una contraseña para acceder a su Centro de Ayuda.
¿Continuar?`,
"c529":`No hay formas disponibles para recargar, por favor, póngase en contacto con el administrador`,
"c742":`Se puede seleccionar un máximo de 4 imágenes y cada una de ellas no puede superar los 200K. Haga clic en la imagen para seleccionarla.`,
"c430":`Buscar Término de Rendimiento`,
"c553":`Última hora invitada`,
"c575":`Cuadro de columnas`,
"c124":`Entrega pendiente`,
"c629":`Sin éxito`,
"c554":`Primera vez que se invita`,
"c547":`Últimos 7 días`,
"c599":`Cuadro`,
"c588":`Mapa de Canadá`,
"c703":`A través de`,
"c713":`Cree publicaciones sociales desde dentro de CloudCC.`,
"c142":`Esta es la acción que se llevará a cabo después de que un visitante envíe el formulario en su sitio`,
"c153":`Después de borrar los productos asociados al registro actual, puede cambiar la moneda.`,
"c253":`Cumplimiento del GDPR`,
"c612":`Página interna`,
"c400":`Ubicación de los recursos del servicio`,
"c671":`Icono y palabra`,
"c20":`No puede superar la cantidad a facturar del pedido relacionado.`,
"c514":`Gráficos del informe`,
"c946":`Reino Unido`,
"c717":`Nuevo puesto`,
"c174":`Todo editado con éxito`,
"c940":`China  Hong Kong`,
"c743":`Por favor, introduzca números válidos`,
"c441":`Gestión empresarial y financiera inteligente`,
"c423":`Plataforma de despacho`,
"c723":`Confirmar para solicitar la destrucción`,
"c664":`Ninguna red social`,
"c859":`Por favor, introduzca {0}`,
"c356":`Coste previsto`,
"c221":`Ir al proyecto`,
"front-email-payment-Invoice-Tips1":`Por favor, póngase en contacto con el administrador para habilitar WeChat, Alipay, PayPal o VISA y luego iniciar el pago en línea`,
"c99":`Cantidad de productos`,
"c278":`¿Desea eliminar los siguientes correos electrónicos?`,
"c364":`Línea de cotización`,
"c572":`Los campos seleccionados no pueden estar vacíos, por favor, añada campo(s)`,
"c310":`Generar el archivo de la orden`,
"c247":`Transferido`,
"c158":`Asignar umbral de tiempo`,
"c325":`Plantilla de notificación de asignación de casos`,
"c877":`Relleno No ordenado`,
"front-filter-v1-press":`Pulse`,
"c505":`Seguimiento de visitantes`,
"c523":`Añadir como usuario del portal`,
"c727":`Destruir los datos con éxito`,
"front-electronic-signature-sended":`Enviado`,
"c150":`Por favor, rellene la información requerida`,
"c700":`ÚLTIMA HORA DE ACTUALIZACIÓN`,
"c824":`Firmar en orden`,
"c710":`Una casa para gestionar todas sus redes sociales`,
"c358":`Presupuesto`,
"c544":`Canales`,
"c212":`Formato SVG`,
"c165":`Por favor, introduzca un valor entero de 0 a 24`,
"c932":`Spam`,
"c888":`Activar la cuenta de usuario con éxito`,
"c838":`Operador`,
"c98":`Categoría de productos`,
"c830":`CREADO POR`,
"c661":`Red`,
"c818":`Configuración del menú de la página personalizada`,
"c861":`Elija en el mapa`,
"c736":`Publicado por`,
"c204":`Estándar`,
"c839":`Parece que no hay nada programado.`,
"c456":`Importe pagado`,
"c341":`Cuentas finales`,
"c724":`Confirmar la destrucción de datos`,
"c865":`He leído y estoy de acuerdo con {0} y {1}`,
"c332":`El importe no puede superar el pedido a facturar`,
"c520":`Pago fallido. La rebaja disponible es insuficiente`,
"c906":`Menos`,
"c482":`Nombra a tu compaginador:`,
"c49":`Actualizar la configuración de seguridad del dominio`,
"c725":`Revocar la solicitud de destrucción con éxito`,
"c76":`PAGUE`,
"c558":`Casos en espera`,
"c876":`Signo No ordenado`,
"front-invoices-v1-nofilles-tocreate":`Haga clic en el botón Generar factura para generar una factura y enviarla.`,
"c779":`Fecha límite para firmar`,
"c603":`Gráfico biaxial MoM&YoY`,
"c455":`Objetivo del contrato`,
"c428":`Despacho en modo mapa`,
"c55":`Por favor, rellene el valor del impuesto`,
"c899":`Distancia de registro`,
"label.facebook.title":`MiniApp FacebookH5`,
"c487":`Nombre del beneficiario:`,
"label.social.posts.info":`No se ha encontrado el contenido de la entrada`,
"c704":`Audiencia`,
"c673":`Imagen de la web`,
"front-electronic-signature-singed":`Inicio de la firma`,
"c722":`1 cuenta conectada`,
"c595":`Cuadro de áreas`,
"c120":`tipo(s)`,
"c68":`Orden de pago`,
"c479":`CloudCC Forms Mailchimp`,
"front-electronic-signature-explain-mainTitle":`Firma electrónica y sellado`,
"c5":`Impuesto`,
"c976":``,
"c812":`COMENTARIOS`,
"c532":`Recuento de casos en reposo`,
"c330":`Partida del contrato`,
"c249":`el puesto sale ahora`,
"c630":`Ver en LinkedIn`,
"c958":`El ID de Post Like no puede estar vacío`,
"c170":`No se han podido crear datos con el identificador de registro {0}, motivo del fallo: {1};`,
"c810":`RESPUESTAS`,
"c783":`Requisitos de la firma`,
"c968":``,
"c752":`Iniciar la tarea de firma`,
"c439":`Visitante`,
"c67":`¡Enviar el pedido con éxito!`,
"front-generate-v1-invoice":`Generar factura`,
"c477":`Debes autentificarte con tu cuenta de MailChimp. Haga clic en el botón "Autenticar MailChimp" y será redirigido a Mail Chimp para enviar campañas.`,
"c966":`Póngase en contacto con el administrador`,
"c764":`Rechazado`,
"c301":`Se pueden introducir hasta 200 caracteres`,
"c61":`Por favor, abra primero el Conocimiento y luego utilícelo`,
"c815":`Archivar todo`,
"c827":`Tiene cambios no guardados en esta página que se perderán si continúa.`,
"c688":`Anchura máxima`,
"c33":`Editar tipo de suscripción`,
"c217":`el puesto va a salir {fecha}`,
"c721":`Desconectar la cuenta`,
"c284":`Procesar la solicitud de datos de los clientes en el CRM`,
"c939":`China  Macao`,
"c503":`Controle el progreso de su proyecto`,
"c492":`Invitado`,
"c73":`Saldo actual`,
"label.the.peoples.republic.of.china":`República Popular de China`,
"c828":`POST`,
"c36":`Vista previa`,
"c954":`Nuevo número de teléfono`,
"front-electronic-signature-innerSinger":`Firmante interno`,
"c508":`Análisis del retorno de la inversión`,
"c833":`Certificación aprobada`,
"c207":`Formato vectorial`,
"c31":`Media pantalla`,
"c71":`Elija una opción de pago`,
"c373":`Libro de precios estándar`,
"c545":`Tiempo de resolución (h)`,
"c77":`Módulo de configuración`,
"label.lastcompiledate":`Última hora de compilación`,
"c119":`Confirmar la recepción`,
"c281":`Procesamiento de datos`,
"c715":`Supervise las menciones de la marca y responda rápidamente.`,
"c127":`Gestionar columnas`,
"c283":`Solicitud de datos`,
"c919":`Utilice el pool para estimular el potencial del equipo y mejorar la tasa de conversión de leads. El administrador del pool realiza una gestión unificada de los leads y la asignación de lotes. El personal de ventas también puede examinar los clientes potenciales y recibir un seguimiento.`,
"c82":`Sólo para el Rayo`,
"front-file-delete-intro":`El archivo fue eliminado`,
"c606":`Dirección de envío por defecto`,
"c905":`Añadir`,
"c644":`TIEMPO DE PUBLICACIÓN`,
"c75":`Saldo de la rebaja`,
"c884":`Política de privacidad`,
"c538":`Tiempo medio de resolución`,
"c322":`Nueva factura`,
"c461":`Tendencia de los pagos`,
"c825":`Empresas`,
"c56":`El total de las facturas a cobrar y el importe a cobrar no son coherentes. Por favor, rellene de nuevo.`,
"c931":`No ha habilitado el interruptor de posicionamiento de los empleados y no puede utilizar el intervalo de uso compartido de la ubicación. ¿Continuar?`,
"c276":`Permitir el cumplimiento del GDPR`,
"c334":`Importe del presupuesto`,
"c733":`Campaña: Nuevo cartel`,
"c384":`Nueva lista de empaque`,
"c139":`Plantilla de reunión`,
"c957":`El ID del comentario no puede estar vacío`,
"front-electronic-signature-nosign":`Su organización no ha elegido ningún proveedor de servicios de firma electrónica. Por favor, póngase en contacto con el administrador para habilitar este servicio.`,
"c419":`Plan de mantenimiento`,
"c934":`Título de la conversión`,
"c677":`Alineado a la derecha`,
"c593":`Gráfico de líneas`,
"c272":`{0} tiene un tiempo de espera para aceptar la orden. Cuenta: {1}, Asunto: {2}, Número: {3}. Haga clic para ver más >`,
"c811":`RETWEETS`,
"c451":`Caso dividido`,
"c277":`Una vez que elimine el correo electrónico, los siguientes correos electrónicos también se eliminarán y no se enviarán a futuros contactos. Esto es irreducible.`,
"c244":`{!ServiceResource.name} ha rechazado el pedido. Número: "{!ServiceAppointment.name}"`,
"c627":`Publicado`,
"c601":`Cuadro de objetivos`,
"c251":`La publicación de los puestos ha fallado`,
"c202":`Compartir en Mailchimp`,
"font-social-prohibit-create":`No se puede crear una nueva entrada mientras se edita`,
"c394":`CloudCC le ayuda a gestionar el negocio online y a mejorar la eficiencia. Elija la aplicación que desee utilizar y siga la introducción y la guía.`,
"c323":`Formato PDF`,
"front-setting-dialog-title-one":`Para evitar la pérdida de la cuenta, iniciar la sesión rápidamente y recuperarla con facilidad, vincule el número de teléfono`,
"front-electronic-signature-cancelIntro2":`Si es la primera vez que vincula una cuenta, haga clic en Continuar para pasar al siguiente paso. Si va a volver a vincular la cuenta después de desvincularla, se recomienda hacer clic en Cancelar y volver a vincularla después de borrar los datos de navegación.`,
"c353":`Visualización de las hojas de tiempos`,
"c621":`Contenido de texto enriquecido`,
"front-v1-partner-image-tooltip":`Se admite un archivo máximo de 2M. La imagen se reducirá a {tamaño}. Se recomienda subir imágenes claras con proporciones similares.`,
"c772":`Finalizado`,
"c734":`Nombre del canal del cartel`,
"c380":`Nuevo pago`,
"c979":``,
"c233":`No se puede borrar la lista de empaque del estado de envío`,
"c458":`Mapa de distribución de cuentas`,
"c697":`Elija la dirección de la cuenta{nombre}`,
"c476":`Elija el empleado al que desea enviar el código de invitación`,
"c634":`Crea un post atractivo y conecta con el mundo`,
"c144":`La hora de finalización no puede superar el año 2038. Por favor, seleccione una nueva hora de finalización.`,
"c474":`Se puede reasignar utilizando las reglas de asignación de clientes potenciales. Para conocer las reglas de asignación, consulte`,
"c371":`Sincronización con la oportunidad`,
"c420":`Activos de mantenimiento`,
"c620":`Se utiliza para agrupar múltiples piezas de contenido para analizar un único esfuerzo de marketing.`,
"c708":`Unificar la escala o no`,
"c100":`Descuento`,
"c576":`Gráfico de columnas 2D`,
"c751":`Plazo para firmar:`,
"c252":`Ajustes de conformidad`,
"c699":`Sólo nuevo`,
"c74":`Pagar con descuento`,
"c805":`Elige una red social para empezar:`,
"c452":`Historia del caso`,
"c740":`Seleccione un empleado para enviarle una invitación`,
"c596":`Tabla biaxial`,
"c832":`Revisando`,
"c971":``,
"c262":`Historia`,
"c363":`Sensible`,
"label.singleSignOn.is.invalid":`Loginfree no es válido`,
"c72":`Pago a terceros`,
"c292":`Marketing`,
"c499":`Un servicio de atención al cliente eficiente para impresionar a los clientes`,
"c574":`Gráfico de barras apiladas`,
"c618":`Cambia el contenido o la hora de publicación de este post.  Twitter no permite publicar más de un post con el mismo contenido en 24 horas.`,
"front-setting-phone-format":`Por favor, introduzca el número de teléfono en el formato correcto`,
"c460":`Clasificación del tamaño de la cuenta`,
"c189":`La moneda de la factura debe coincidir con la moneda del pedido. Por favor, afine la moneda y guarde de nuevo.`,
"label.exe.supported.request.rejected":`El archivo exe. no se puede enviar. La solicitud es rechazada.`,
"c835":`Ya existe una factura para este presupuesto. ¿Continuar o no?`,
"c655":`Contabilización de`,
"c45":`Conectar por`,
"c43":`Conectar la cuenta`,
"c481":`Iniciar sesión como un usuario diferente`,
"c674":`Dirección externa`,
"c266":`Esta orden no puede ser modificada ya que ha sido completada`,
"c967":``,
"c154":`Busque los libros de precios después de seleccionar los productos`,
"c841":`¿Tienes ideas? Haz un borrador.   `,
"c615":`No se ha seleccionado ninguna cuenta`,
"c84":`Elija el empleado al que desea enviar el código de invitación`,
"c401":`Servicio`,
"c290":`Objetos habilitados`,
"c205":`Descargar código QR`,
"c928":`Se pueden seleccionar hasta 10 campos.`,
"c195":`Límite de presentación`,
"1":`No hay acciones disponibles`,
"c46":`Autorizar con éxito`,
"c459":`Importe del contrato firmado`,
"c250":`los mensajes se guardan como borradores`,
"c399":`Inventario`,
"c518":`El #recordName de #label no ha superado la aprobación por #failReason`,
"c396":`Elija diferentes soluciones`,
"c300":`Destrucción solicitada por`,
"c789":`Método de firma sin restricciones`,
"c874":`Has leído todo lo que había en tu bandeja de entrada.`,
"c38":`Número de bloque comunitario`,
"c228":`Añadir subtarea`,
"c342":`Beneficios`,
"c879":`Clonar publicaciones sociales`,
"c173":`Rebobinar con éxito`,
"c778":`Iniciador`,
"c211":`Tamaño pequeño`,
"c496":`CloudCC Sales CloudUn CRM inteligente para todos los escenarios que le ayudará a alcanzar sus objetivos de ventas`,
"c427":`Despacho en modo diagrama de Gantt`,
"c851":`Muestra el número de mensajes publicados en sus cuentas durante el periodo seleccionado.`,
"c32":`Nuevo tipo de suscripción`,
"c28":`Crecimiento interanual`,
"c163":`Informar y anular el envío simultáneamente`,
"c225":`Ir a la tarea`,
"c569":`Por favor, elija primero la cuenta`,
"c92":`Abrir una vez`,
"c412":`Crear automáticamente una cita de servicio`,
"c81":`Añadir a la cesta`,
"c653":`Muestra el número de "me gusta", reacciones y comentarios de sus publicaciones. Esto también incluye las publicaciones que se publicaron en sus cuentas conectadas fuera de CloudCC Si está buscando retweets de Twitter, los encontrará en Acciones.`,
"c516":`Asistencia`,
"c918":`Si se configuran reglas de autoreciclaje, el sistema autoreciclará los registros al pool cuando la cuenta no haya cerrado la operación después del límite de tiempo. Esto mejora la eficacia del seguimiento de las cuentas.`,
"c809":`LIKES`,
"c181":`Por favor, rellene la orden de trabajo o el registro del caso`,
"c745":`Por favor, introduzca hasta 2 decimales`,
"c669":`Color`,
"c929":`Por favor, compruebe la conexión de red`,
"c117":`Ahorrar y pagar`,
"c938":`China continental`,
"c112":`Todas las plantillas de {nombre} están actualmente desactivadas. Por favor, póngase en contacto con el administrador para habilitar la plantilla antes de generar {nombre}.`,
"c347":`Modificar las horas de trabajo de la tarea del proyecto`,
"c795":`Elija el modelo de contrato`,
"c17":`Inactivo. Por favor, vuelva a seleccionar`,
"c787":`Firmado por el operador`,
"c829":`CAMPAÑA`,
"c161":`Informe también`,
"c65":`Desea cambiar el estado logístico del producto a Entregado`,
"c665":`Añade uno más`,
"c767":`Comprobar el progreso de la firma`,
"c87":`Código QR del formulario de la campaña`,
"c589":`Mapa de Francia`,
"front-electronic-signature-newTime":`Última actualización`,
"c813":`COMPARTIR`,
"c85":`{miembro} invitador seleccionado`,
"c951":`Polonia`,
"c29":`Crecimiento intermensual`,
"c210":`Tamaño grande`,
"c39":`Archivado`,
"c672":`Palabra`,
"c97":`Esta lista de selección debe contener al menos una opción "Convertida".`,
"c687":`Tamaño máximo`,
"c916":`Cerrar Piscina`,
"c475":`Por favor, rellene el titular de la campaña`,
"c628":`Programado`,
"c788":`El libro de precios para esta oportunidad está actualmente desactivado. Por favor, active el libro de precios antes de crear un nuevo pedido.`,
"c177":`Tamaño sugerido: 390*210`,
"c856":`Sí. No hay puestos infructuosos.`,
"c70":`Información de pedidos`,
"c546":`Últimas 24 horas`,
"c331":`Convertir activos`,
"label.order.paidamount.greater.than.total":`Una vez creados los nuevos datos de pago, el importe reembolsado del pedido será mayor que el importe del pedido. Por favor, reajuste el pago y luego guárdelo.`,
"c524":`Reinvite`,
"c246":`{!oldServiceResource.name} le transfirió la orden de trabajo numerada {!ServiceAppointment.name}.`,
"label.parameter.is.incorrect":`Parámetros erróneos`,
"c667":`Espacio entre iconos`,
"c737":`Plataforma social`,
"c48":`Desconectar`,
"c111":`Generar {nombre}`,
"c755":`En secuencia`,
"c526":`Habilitar usuario del portal`,
"c450":`Fusión de casos`,
"front-electronic-export-reChoseChimp":`La vista actual no tiene registros de datos y no se puede exportar. Por favor, seleccione una nueva vista`,
"label.invoice.paidamount.greater.than.total":`Después de crear los nuevos datos de pago, el importe reembolsado de la factura será mayor que el valor total. Por favor, reajuste el pago y luego guárdelo.`,
"c222":`Editar proyecto`,
"c849":`Cuentas de Twitter`,
"c678":`Blanco y negro`,
"c502":`Ofrecer soluciones integrales para la gestión de todos los procesos relacionados con los servicios de campo para agilizar las operaciones, mejorar la productividad y aumentar la fidelidad y la satisfacción de los clientes.`,
"c497":`Inventario más inteligente, gestión empresarial y financiera más sólida`,
"c200":`Compartir en las redes sociales`,
"c658":`Texto enriquecido`,
"c434":`Nuevo contacto relacionado`,
"c641":`Sólo puede elegir no más de 4 imágenes, haga clic en la imagen seleccionada para deseleccionarla. El tamaño de la imagen que subas debe ser inferior a 200kb`,
"c944":`Alemania`,
"c411":`Compensación de la fecha de vencimiento`,
"c624":` Todas las cuentas`,
"label.twitter.title":`MiniApp TwitterH5`,
"c791":`Firma estándar`,
"c306":`De acuerdo`,
"c14":`El usuario actual no tiene permiso para borrar`,
"c176":`Sólo se pueden cargar imágenes png, jpg y jpeg. La imagen cargada no puede superar los 2M.`,
"c166":`Introduzca la longitud máxima del pedido según las normas`,
"c731":`El cambio del libro de precios seleccionado también eliminará todos los productos existentes. ¿Está seguro de cambiar al nuevo libro de precios?`,
"c237":`{!ServiceResource.name} aceptó el pedido. Número: "{!ServiceAppointment.name}"`,
"c887":`Reinvitar al usuario con éxito`,
"c227":`Editar subtarea`,
"c257":`Contacto disponible`,
"c712":`Informar y comparar el rendimiento de las redes, las publicaciones y las campañas.`,
"c107":`Buscar usuarios por nombre, cuenta y número de móvil`,
"c370":`Contrato`,
"c895":`El cálculo de la distancia ha fallado, por favor, introduzca la dirección completa`,
"c693":`Autorregulación`,
"c763":`Firmado`,
"c302":`Intereses legítimos`,
"c577":`Gráfico de columnas apiladas`,
"c258":`Presentar una reclamación`,
"c676":`Centro`,
"c868":`Después de desactivar esta cuenta, el sistema restringirá su acceso u operaciones en su portal. ¿Continuar?`,
"c53":`Relación (%)`,
"c527":`El #nombredelusuario le ha asignado una tarea de aprobación`,
"label.facebook.title.setting":`Información integrada en Facebook`,
"c340":`Cambiar el propietario del plan del proyecto`,
"c706":`Sobre los gráficos`,
"label.mobile.used":`El número de móvil ha sido utilizado`,
"c328":`Código QR del activo`,
"c337":`Contactos  Destruir`,
"c642":`Imágenes recientes`
}